const StockData = [
  {
    "symbol": "A",
    "name": "Agilent Technologies Inc."
  },
  {
    "symbol": "B",
    "name": "Barnes Group Inc."
  },
  {
    "symbol": "C",
    "name": "Citigroup Inc."
  },
  {
    "symbol": "D",
    "name": "Dominion Resources Inc."
  },
  {
    "symbol": "E",
    "name": "Ente Nazionale Idrocarburi SpA (ADR)"
  },
  {
    "symbol": "F",
    "name": "Ford Motor Company",
    "last_sale": "9.85",
    "market_cap": "$39.26B",
    "IPOyear": "n/a",
    "sector": "Capital Goods",
    "industry": "Auto Manufacturing",
    "summary_quote": "https://www.nasdaq.com/symbol/f",
    "FIELD9": ""
  },
  {
    "symbol": "H",
    "name": "Hyatt Hotels Corporation",
    "last_sale": "77.93",
    "market_cap": "$8.68B",
    "IPOyear": "2009",
    "sector": "Consumer Services",
    "industry": "Hotels/Resorts",
    "summary_quote": "https://www.nasdaq.com/symbol/h",
    "FIELD9": ""
  },
  {
    "symbol": "I",
    "name": "IntelSat Global Holdings"
  },
  {
    "symbol": "K",
    "name": "Kellogg Company",
    "last_sale": "73.17",
    "market_cap": "$25.37B",
    "IPOyear": "n/a",
    "sector": "Consumer Non-Durables",
    "industry": "Packaged Foods",
    "summary_quote": "https://www.nasdaq.com/symbol/k",
    "FIELD9": ""
  },
  {
    "symbol": "L",
    "name": "Loews Corporation",
    "last_sale": "51.76",
    "market_cap": "$16.36B",
    "IPOyear": "n/a",
    "sector": "Finance",
    "industry": "Property-Casualty Insurers",
    "summary_quote": "https://www.nasdaq.com/symbol/l",
    "FIELD9": ""
  },
  {
    "symbol": "M",
    "name": "Macy’s Inc."
  },
  {
    "symbol": "O",
    "name": "Realty Income Corp"
  },
  {
    "symbol": "Q",
    "name": "Qwest Communications International Inc."
  },
 
  {
    "symbol": "SPY",
    "name": "SPDR S&P 500 ETF Trust",
  },
 {
   "symbol": "YI",
   "name": "111, Inc.",
   "last_sale": "15.425",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Communications",
   "industry": "Media",
   "summary_quote": "https://www.nasdaq.com/symbol/yi",
   "FIELD9": ""
 },
 {
   "symbol": "PIH",
   "name": "1347 Property Insurance Holdings, Inc.",
   "last_sale": "6.75",
   "market_cap": "$40.4M",
   "IPOyear": "2014",
   "sector": "Financials",
   "industry": "Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/pih",
   "FIELD9": ""
 },
 {
   "symbol": "PIHPP",
   "name": "1347 Property Insurance Holdings, Inc.",
   "last_sale": "25.16",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/pihpp",
   "FIELD9": ""
 },
 {
   "symbol": "TURN",
   "name": "180 Degree Capital Corp.",
   "last_sale": "2.16",
   "market_cap": "$67.22M",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Finance/Investors Services",
   "summary_quote": "https://www.nasdaq.com/symbol/turn",
   "FIELD9": ""
 },
 {
   "symbol": "FLWS",
   "name": "1-800 FLOWERS.COM, Inc.",
   "last_sale": "11.95",
   "market_cap": "$771.87M",
   "IPOyear": "1999",
   "sector": "Consumer Discretionary",
   "industry": "Retail Discretionary",
   "summary_quote": "https://www.nasdaq.com/symbol/flws",
   "FIELD9": ""
 },
 {
   "symbol": "FCCY",
   "name": "1st Constitution Bancorp (NJ)",
   "last_sale": "20.2",
   "market_cap": "$169.26M",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/fccy",
   "FIELD9": ""
 },
 {
   "symbol": "SRCE",
   "name": "1st Source Corporation",
   "last_sale": "54.26",
   "market_cap": "$1.41B",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/srce",
   "FIELD9": ""
 },
 {
   "symbol": "VNET",
   "name": "21Vianet Group, Inc.",
   "last_sale": "10.38",
   "market_cap": "$1.16B",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/vnet",
   "FIELD9": ""
 },
 {
   "symbol": "TWOU",
   "name": "2U, Inc.",
   "last_sale": "76.3",
   "market_cap": "$4.38B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/twou",
   "FIELD9": ""
 },
 {
   "symbol": "TPNL",
   "name": "3PEA International, Inc.",
   "last_sale": "4.75",
   "market_cap": "$207.44M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tpnl",
   "FIELD9": ""
 },
 {
   "symbol": "JOBS",
   "name": "51job, Inc.",
   "last_sale": "75.28",
   "market_cap": "$4.65B",
   "IPOyear": "2004",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/jobs",
   "FIELD9": ""
 },
 {
   "symbol": "EGHT",
   "name": "8x8 Inc",
   "last_sale": "21.2",
   "market_cap": "$1.98B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/eght",
   "FIELD9": ""
 },
 {
   "symbol": "AVHI",
   "name": "A V Homes, Inc.",
   "last_sale": "21.45",
   "market_cap": "$479.65M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/avhi",
   "FIELD9": ""
 },
 {
   "symbol": "AAON",
   "name": "AAON, Inc.",
   "last_sale": "39.85",
   "market_cap": "$2.08B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/aaon",
   "FIELD9": ""
 },
 {
   "symbol": "ABEO",
   "name": "Abeona Therapeutics Inc.",
   "last_sale": "12.625",
   "market_cap": "$605.28M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/abeo",
   "FIELD9": ""
 },
 {
   "symbol": "ABEOW",
   "name": "Abeona Therapeutics Inc.",
   "last_sale": "8.55",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/abeow",
   "FIELD9": ""
 },
 {
   "symbol": "ABIL",
   "name": "Ability Inc.",
   "last_sale": "4.4",
   "market_cap": "$14.54M",
   "IPOyear": "2014",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/abil",
   "FIELD9": ""
 },
 {
   "symbol": "ABMD",
   "name": "ABIOMED, Inc.",
   "last_sale": "384.88",
   "market_cap": "$17.27B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/abmd",
   "FIELD9": ""
 },
 {
   "symbol": "ABP",
   "name": "Abpro Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/abp",
   "FIELD9": ""
 },
 {
   "symbol": "AXAS",
   "name": "Abraxas Petroleum Corporation",
   "last_sale": "2.4",
   "market_cap": "$400.11M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/axas",
   "FIELD9": ""
 },
 {
   "symbol": "ACIU",
   "name": "AC Immune SA",
   "last_sale": "8.6",
   "market_cap": "$579.32M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/aciu",
   "FIELD9": ""
 },
 {
   "symbol": "ACIA",
   "name": "Acacia Communications, Inc.",
   "last_sale": "39.79",
   "market_cap": "$1.61B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/acia",
   "FIELD9": ""
 },
 {
   "symbol": "ACTG",
   "name": "Acacia Research Corporation",
   "last_sale": "3.25",
   "market_cap": "$160.86M",
   "IPOyear": "n/a",
   "sector": "Consumer Discretionary",
   "industry": "Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/actg",
   "FIELD9": ""
 },
 {
   "symbol": "ACHC",
   "name": "Acadia Healthcare Company, Inc.",
   "last_sale": "35.7",
   "market_cap": "$3.15B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/achc",
   "FIELD9": ""
 },
 {
   "symbol": "ACAD",
   "name": "ACADIA Pharmaceuticals Inc.",
   "last_sale": "20.18",
   "market_cap": "$2.52B",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/acad",
   "FIELD9": ""
 },
 {
   "symbol": "ACST",
   "name": "Acasti Pharma, Inc.",
   "last_sale": "0.5885",
   "market_cap": "$21.59M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/acst",
   "FIELD9": ""
 },
 {
   "symbol": "AXDX",
   "name": "Accelerate Diagnostics, Inc.",
   "last_sale": "22.55",
   "market_cap": "$1.22B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/axdx",
   "FIELD9": ""
 },
 {
   "symbol": "ACCP",
   "name": "Accelerated Pharma, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/accp",
   "FIELD9": ""
 },
 {
   "symbol": "XLRN",
   "name": "Acceleron Pharma Inc.",
   "last_sale": "56.72",
   "market_cap": "$2.61B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/xlrn",
   "FIELD9": ""
 },
 {
   "symbol": "ANCX",
   "name": "Access National Corporation",
   "last_sale": "27.89",
   "market_cap": "$580.04M",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/ancx",
   "FIELD9": ""
 },
 {
   "symbol": "ARAY",
   "name": "Accuray Incorporated",
   "last_sale": "4.15",
   "market_cap": "$358.93M",
   "IPOyear": "2007",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/aray",
   "FIELD9": ""
 },
 {
   "symbol": "ACRX",
   "name": "AcelRx Pharmaceuticals, Inc.",
   "last_sale": "3.925",
   "market_cap": "$237.85M",
   "IPOyear": "2011",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/acrx",
   "FIELD9": ""
 },
 {
   "symbol": "ACER",
   "name": "Acer Therapeutics Inc.",
   "last_sale": "30.7",
   "market_cap": "$308.63M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/acer",
   "FIELD9": ""
 },
 {
   "symbol": "ACET",
   "name": "Aceto Corporation",
   "last_sale": "3.04",
   "market_cap": "$93.6M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Other Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/acet",
   "FIELD9": ""
 },
 {
   "symbol": "AKAO",
   "name": "Achaogen, Inc.",
   "last_sale": "4.2",
   "market_cap": "$189.88M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/akao",
   "FIELD9": ""
 },
 {
   "symbol": "ACHV",
   "name": "Achieve Life Sciences, Inc. ",
   "last_sale": "2.49",
   "market_cap": "$11.33M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/achv",
   "FIELD9": ""
 },
 {
   "symbol": "ACHN",
   "name": "Achillion Pharmaceuticals, Inc.",
   "last_sale": "3.51",
   "market_cap": "$486.44M",
   "IPOyear": "2006",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/achn",
   "FIELD9": ""
 },
 {
   "symbol": "ACIW",
   "name": "ACI Worldwide, Inc.",
   "last_sale": "28.34",
   "market_cap": "$3.28B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/aciw",
   "FIELD9": ""
 },
 {
   "symbol": "ACRS",
   "name": "Aclaris Therapeutics, Inc.",
   "last_sale": "15.16",
   "market_cap": "$469.67M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/acrs",
   "FIELD9": ""
 },
 {
   "symbol": "ACMR",
   "name": "ACM Research, Inc.",
   "last_sale": "11.97",
   "market_cap": "$190.1M",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/acmr",
   "FIELD9": ""
 },
 {
   "symbol": "ACNB",
   "name": "ACNB Corporation",
   "last_sale": "38.55",
   "market_cap": "$271.34M",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/acnb",
   "FIELD9": ""
 },
 {
   "symbol": "ACOR",
   "name": "Acorda Therapeutics, Inc.",
   "last_sale": "18.2",
   "market_cap": "$864.21M",
   "IPOyear": "2006",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/acor",
   "FIELD9": ""
 },
 {
   "symbol": "ATVI",
   "name": "Activision Blizzard, Inc",
   "last_sale": "80.29",
   "market_cap": "$61.21B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/atvi",
   "FIELD9": ""
 },
 {
   "symbol": "ACXM",
   "name": "Acxiom Holdings, Inc.",
   "last_sale": "50.89",
   "market_cap": "$3.94B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/acxm",
   "FIELD9": ""
 },
 {
   "symbol": "ADMS",
   "name": "Adamas Pharmaceuticals, Inc.",
   "last_sale": "19.17",
   "market_cap": "$521.24M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/adms",
   "FIELD9": ""
 },
 {
   "symbol": "ADMP",
   "name": "Adamis Pharmaceuticals Corporation",
   "last_sale": "3.1",
   "market_cap": "$146.6M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/admp",
   "FIELD9": ""
 },
 {
   "symbol": "ADAP",
   "name": "Adaptimmune Therapeutics plc",
   "last_sale": "11.71",
   "market_cap": "$1.22B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/adap",
   "FIELD9": ""
 },
 {
   "symbol": "ADUS",
   "name": "Addus HomeCare Corporation",
   "last_sale": "69.2",
   "market_cap": "$809.46M",
   "IPOyear": "2009",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/adus",
   "FIELD9": ""
 },
 {
   "symbol": "AEY",
   "name": "ADDvantage Technologies Group, Inc.",
   "last_sale": "1.4",
   "market_cap": "$14.43M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/aey",
   "FIELD9": ""
 },
 {
   "symbol": "IOTS",
   "name": "Adesto Technologies Corporation",
   "last_sale": "6.375",
   "market_cap": "$186.59M",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/iots",
   "FIELD9": ""
 },
 {
   "symbol": "ADIL",
   "name": "Adial Pharmaceuticals, Inc",
   "last_sale": "2.96",
   "market_cap": "$19.35M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/adil",
   "FIELD9": ""
 },
 {
   "symbol": "ADILW",
   "name": "Adial Pharmaceuticals, Inc",
   "last_sale": "0.589",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/adilw",
   "FIELD9": ""
 },
 {
   "symbol": "ADMA",
   "name": "ADMA Biologics Inc",
   "last_sale": "6.15",
   "market_cap": "$285.05M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/adma",
   "FIELD9": ""
 },
 {
   "symbol": "ADBE",
   "name": "Adobe Systems Incorporated",
   "last_sale": "260.9",
   "market_cap": "$127.75B",
   "IPOyear": "1986",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/adbe",
   "FIELD9": ""
 },
 {
   "symbol": "ADOM",
   "name": "ADOMANI, Inc.",
   "last_sale": "0.6281",
   "market_cap": "$45.54M",
   "IPOyear": "2017",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/adom",
   "FIELD9": ""
 },
 {
   "symbol": "ADTN",
   "name": "ADTRAN, Inc.",
   "last_sale": "18.6",
   "market_cap": "$887.95M",
   "IPOyear": "1994",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/adtn",
   "FIELD9": ""
 },
 {
   "symbol": "ADRO",
   "name": "Aduro Biotech, Inc.",
   "last_sale": "6.2",
   "market_cap": "$490.17M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/adro",
   "FIELD9": ""
 },
 {
   "symbol": "ADES",
   "name": "Advanced Emissions Solutions, Inc.",
   "last_sale": "11.71",
   "market_cap": "$235.52M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/ades",
   "FIELD9": ""
 },
 {
   "symbol": "AEIS",
   "name": "Advanced Energy Industries, Inc.",
   "last_sale": "54.07",
   "market_cap": "$2.11B",
   "IPOyear": "1995",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/aeis",
   "FIELD9": ""
 },
 {
   "symbol": "AMD",
   "name": "Advanced Micro Devices, Inc.",
   "last_sale": "31.02",
   "market_cap": "$30.24B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/amd",
   "FIELD9": ""
 },
 {
   "symbol": "ADXS",
   "name": "Advaxis, Inc.",
   "last_sale": "0.8667",
   "market_cap": "$60.23M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/adxs",
   "FIELD9": ""
 },
 {
   "symbol": "ADXSW",
   "name": "Advaxis, Inc.",
   "last_sale": "0.04",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/adxsw",
   "FIELD9": ""
 },
 {
   "symbol": "ADVM",
   "name": "Adverum Biotechnologies, Inc.",
   "last_sale": "5.85",
   "market_cap": "$366.76M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/advm",
   "FIELD9": ""
 },
 {
   "symbol": "DWMC",
   "name": "AdvisorShares Dorsey Wright Micro-Cap ETF",
   "last_sale": "24.7188",
   "market_cap": "$3.09M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dwmc",
   "FIELD9": ""
 },
 {
   "symbol": "DWSH",
   "name": "AdvisorShares Dorsey Wright Short ETF",
   "last_sale": "24.38",
   "market_cap": "$4.88M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dwsh",
   "FIELD9": ""
 },
 {
   "symbol": "ACT",
   "name": "AdvisorShares Vice ETF",
   "last_sale": "27.0305",
   "market_cap": "$12.84M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/act",
   "FIELD9": ""
 },
 {
   "symbol": "AEGN",
   "name": "Aegion Corp",
   "last_sale": "24.77",
   "market_cap": "$800.35M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/aegn",
   "FIELD9": ""
 },
 {
   "symbol": "AGLE",
   "name": "Aeglea BioTherapeutics, Inc.",
   "last_sale": "9.16",
   "market_cap": "$201.47M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/agle",
   "FIELD9": ""
 },
 {
   "symbol": "AEHR",
   "name": "Aehr Test Systems",
   "last_sale": "2.52",
   "market_cap": "$55.99M",
   "IPOyear": "1997",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/aehr",
   "FIELD9": ""
 },
 {
   "symbol": "AMTX",
   "name": "Aemetis, Inc",
   "last_sale": "1.12",
   "market_cap": "$22.65M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/amtx",
   "FIELD9": ""
 },
 {
   "symbol": "AERI",
   "name": "Aerie Pharmaceuticals, Inc.",
   "last_sale": "58.5",
   "market_cap": "$2.65B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/aeri",
   "FIELD9": ""
 },
 {
   "symbol": "AVAV",
   "name": "AeroVironment, Inc.",
   "last_sale": "107.16",
   "market_cap": "$2.56B",
   "IPOyear": "2007",
   "sector": "Capital Goods",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/avav",
   "FIELD9": ""
 },
 {
   "symbol": "ARPO",
   "name": "Aerpio Pharmaceuticals, Inc.",
   "last_sale": "3.39",
   "market_cap": "$137.57M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/arpo",
   "FIELD9": ""
 },
 {
   "symbol": "AEZS",
   "name": "AEterna Zentaris Inc.",
   "last_sale": "1.74",
   "market_cap": "$28.61M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/aezs",
   "FIELD9": ""
 },
 {
   "symbol": "AEMD",
   "name": "Aethlon Medical, Inc.",
   "last_sale": "1.21",
   "market_cap": "$21.54M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/aemd",
   "FIELD9": ""
 },
 {
   "symbol": "GNMX",
   "name": "Aevi Genomic Medicine, Inc.",
   "last_sale": "1.3",
   "market_cap": "$77.14M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/gnmx",
   "FIELD9": ""
 },
 {
   "symbol": "AFMD",
   "name": "Affimed N.V.",
   "last_sale": "4.375",
   "market_cap": "$272.96M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/afmd",
   "FIELD9": ""
 },
 {
   "symbol": "AGEN",
   "name": "Agenus Inc.",
   "last_sale": "2",
   "market_cap": "$226.56M",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/agen",
   "FIELD9": ""
 },
 {
   "symbol": "AGRX",
   "name": "Agile Therapeutics, Inc.",
   "last_sale": "0.3375",
   "market_cap": "$11.6M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/agrx",
   "FIELD9": ""
 },
 {
   "symbol": "AGYS",
   "name": "Agilysys, Inc.",
   "last_sale": "15.99",
   "market_cap": "$376.17M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/agys",
   "FIELD9": ""
 },
 {
   "symbol": "AGIO",
   "name": "Agios Pharmaceuticals, Inc.",
   "last_sale": "73.56",
   "market_cap": "$4.27B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/agio",
   "FIELD9": ""
 },
 {
   "symbol": "AGMH",
   "name": "AGM Group Holdings Inc.",
   "last_sale": "25.77",
   "market_cap": "$549.31M",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/agmh",
   "FIELD9": ""
 },
 {
   "symbol": "AGNC",
   "name": "AGNC Investment Corp.",
   "last_sale": "18.9",
   "market_cap": "$9.03B",
   "IPOyear": "2008",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/agnc",
   "FIELD9": ""
 },
 {
   "symbol": "AGNCB",
   "name": "AGNC Investment Corp.",
   "last_sale": "25.8998",
   "market_cap": "$8.97B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/agncb",
   "FIELD9": ""
 },
 {
   "symbol": "AGNCN",
   "name": "AGNC Investment Corp.",
   "last_sale": "26.52",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/agncn",
   "FIELD9": ""
 },
 {
   "symbol": "AGFS",
   "name": "AgroFresh Solutions, Inc.",
   "last_sale": "6.68",
   "market_cap": "$337.25M",
   "IPOyear": "2014",
   "sector": "Financials",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/agfs",
   "FIELD9": ""
 },
 {
   "symbol": "AGFSW",
   "name": "AgroFresh Solutions, Inc.",
   "last_sale": "0.195",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Financials",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/agfsw",
   "FIELD9": ""
 },
 {
   "symbol": "ALRN",
   "name": "Aileron Therapeutics, Inc.",
   "last_sale": "2.87",
   "market_cap": "$42.3M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/alrn",
   "FIELD9": ""
 },
 {
   "symbol": "AIMT",
   "name": "Aimmune Therapeutics, Inc.",
   "last_sale": "27.21",
   "market_cap": "$1.59B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/aimt",
   "FIELD9": ""
 },
 {
   "symbol": "AIRT",
   "name": "Air T, Inc.",
   "last_sale": "32.208",
   "market_cap": "$65.82M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/airt",
   "FIELD9": ""
 },
 {
   "symbol": "ATSG",
   "name": "Air Transport Services Group, Inc",
   "last_sale": "22.04",
   "market_cap": "$1.3B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/atsg",
   "FIELD9": ""
 },
 {
   "symbol": "AIRG",
   "name": "Airgain, Inc.",
   "last_sale": "13.02",
   "market_cap": "$128.8M",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/airg",
   "FIELD9": ""
 },
 {
   "symbol": "AMCN",
   "name": "AirMedia Group Inc",
   "last_sale": "0.3912",
   "market_cap": "$24.57M",
   "IPOyear": "2007",
   "sector": "Technology",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/amcn",
   "FIELD9": ""
 },
 {
   "symbol": "AKAM",
   "name": "Akamai Technologies, Inc.",
   "last_sale": "73.5",
   "market_cap": "$12.46B",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Software",
   "summary_quote": "https://www.nasdaq.com/symbol/akam",
   "FIELD9": ""
 },
 {
   "symbol": "AKTX",
   "name": "Akari Therapeutics Plc",
   "last_sale": "2.11",
   "market_cap": "$32.19M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotech & Pharma",
   "summary_quote": "https://www.nasdaq.com/symbol/aktx",
   "FIELD9": ""
 },
 {
   "symbol": "AKCA",
   "name": "Akcea Therapeutics, Inc.",
   "last_sale": "28",
   "market_cap": "$2.4B",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/akca",
   "FIELD9": ""
 },
 {
   "symbol": "AKBA",
   "name": "Akebia Therapeutics, Inc.",
   "last_sale": "8.28",
   "market_cap": "$472.33M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/akba",
   "FIELD9": ""
 },
 {
   "symbol": "AKER",
   "name": "Akers Biosciences Inc",
   "last_sale": "0.2499",
   "market_cap": "$23.52M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/aker",
   "FIELD9": ""
 },
 {
   "symbol": "AKRX",
   "name": "Akorn, Inc.",
   "last_sale": "13.22",
   "market_cap": "$1.66B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/akrx",
   "FIELD9": ""
 },
 {
   "symbol": "AKTS",
   "name": "Akoustis Technologies, Inc.",
   "last_sale": "8.3",
   "market_cap": "$184.45M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/akts",
   "FIELD9": ""
 },
 {
   "symbol": "ALRM",
   "name": "Alarm.com Holdings, Inc.",
   "last_sale": "56.61",
   "market_cap": "$2.7B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/alrm",
   "FIELD9": ""
 },
 {
   "symbol": "ALSK",
   "name": "Alaska Communications Systems Group, Inc.",
   "last_sale": "1.68",
   "market_cap": "$89.35M",
   "IPOyear": "1999",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/alsk",
   "FIELD9": ""
 },
 {
   "symbol": "ALBO",
   "name": "Albireo Pharma, Inc.",
   "last_sale": "31.45",
   "market_cap": "$376.45M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/albo",
   "FIELD9": ""
 },
 {
   "symbol": "ABDC",
   "name": "Alcentra Capital Corp.",
   "last_sale": "6.2301",
   "market_cap": "$84.29M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/abdc",
   "FIELD9": ""
 },
 {
   "symbol": "ALDR",
   "name": "Alder BioPharmaceuticals, Inc.",
   "last_sale": "16",
   "market_cap": "$1.09B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/aldr",
   "FIELD9": ""
 },
 {
   "symbol": "ALDX",
   "name": "Aldeyra Therapeutics, Inc.",
   "last_sale": "9.1",
   "market_cap": "$190.87M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/aldx",
   "FIELD9": ""
 },
 {
   "symbol": "ALXN",
   "name": "Alexion Pharmaceuticals, Inc.",
   "last_sale": "121.99",
   "market_cap": "$27.19B",
   "IPOyear": "1996",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/alxn",
   "FIELD9": ""
 },
 {
   "symbol": "ALCO",
   "name": "Alico, Inc.",
   "last_sale": "34.65",
   "market_cap": "$284.13M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/alco",
   "FIELD9": ""
 },
 {
   "symbol": "ALGN",
   "name": "Align Technology, Inc.",
   "last_sale": "380.84",
   "market_cap": "$30.59B",
   "IPOyear": "2001",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/algn",
   "FIELD9": ""
 },
 {
   "symbol": "ALIM",
   "name": "Alimera Sciences, Inc.",
   "last_sale": "1.06",
   "market_cap": "$74.24M",
   "IPOyear": "2010",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/alim",
   "FIELD9": ""
 },
 {
   "symbol": "ALJJ",
   "name": "ALJ Regional Holdings, Inc.",
   "last_sale": "1.745",
   "market_cap": "$66.17M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/aljj",
   "FIELD9": ""
 },
 {
   "symbol": "ALKS",
   "name": "Alkermes plc",
   "last_sale": "41.56",
   "market_cap": "$6.45B",
   "IPOyear": "1991",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/alks",
   "FIELD9": ""
 },
 {
   "symbol": "ALLK",
   "name": "Allakos Inc.",
   "last_sale": "46.86",
   "market_cap": "$1.97B",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/allk",
   "FIELD9": ""
 },
 {
   "symbol": "ABTX",
   "name": "Allegiance Bancshares, Inc.",
   "last_sale": "44.75",
   "market_cap": "$598.2M",
   "IPOyear": "2015",
   "sector": "Financials",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/abtx",
   "FIELD9": ""
 },
 {
   "symbol": "ALGT",
   "name": "Allegiant Travel Company",
   "last_sale": "129.05",
   "market_cap": "$2.09B",
   "IPOyear": "2006",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/algt",
   "FIELD9": ""
 },
 {
   "symbol": "ALGR",
   "name": "Allegro Merger Corp.",
   "last_sale": "9.55",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Financials",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/algr",
   "FIELD9": ""
 },
 {
   "symbol": "ALGRR",
   "name": "Allegro Merger Corp.",
   "last_sale": "0.37",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Financials",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/algrr",
   "FIELD9": ""
 },
 {
   "symbol": "ALGRU",
   "name": "Allegro Merger Corp.",
   "last_sale": "10.25",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Financials",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/algru",
   "FIELD9": ""
 },
 {
   "symbol": "ALGRW",
   "name": "Allegro Merger Corp.",
   "last_sale": "0.33",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Financials",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/algrw",
   "FIELD9": ""
 },
 {
   "symbol": "ALNA",
   "name": "Allena Pharmaceuticals, Inc.",
   "last_sale": "10.35",
   "market_cap": "$214.78M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/alna",
   "FIELD9": ""
 },
 {
   "symbol": "AMMA",
   "name": "Alliance MMA, Inc.",
   "last_sale": "0.264",
   "market_cap": "$3.92M",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/amma",
   "FIELD9": ""
 },
 {
   "symbol": "ARLP",
   "name": "Alliance Resource Partners, L.P.",
   "last_sale": "19.7",
   "market_cap": "$2.59B",
   "IPOyear": "1999",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/arlp",
   "FIELD9": ""
 },
 {
   "symbol": "AHPI",
   "name": "Allied Healthcare Products, Inc.",
   "last_sale": "2.2295",
   "market_cap": "$8.95M",
   "IPOyear": "1992",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/ahpi",
   "FIELD9": ""
 },
 {
   "symbol": "AMOT",
   "name": "Allied Motion Technologies, Inc.",
   "last_sale": "49.42",
   "market_cap": "$468.26M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/amot",
   "FIELD9": ""
 },
 {
   "symbol": "ALQA",
   "name": "Alliqua BioMedical, Inc.",
   "last_sale": "2.3",
   "market_cap": "$11.51M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/alqa",
   "FIELD9": ""
 },
 {
   "symbol": "ALLT",
   "name": "Allot Communications Ltd.",
   "last_sale": "6.23",
   "market_cap": "$210.04M",
   "IPOyear": "2006",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/allt",
   "FIELD9": ""
 },
 {
   "symbol": "MDRX",
   "name": "Allscripts Healthcare Solutions, Inc.",
   "last_sale": "14.37",
   "market_cap": "$2.51B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mdrx",
   "FIELD9": ""
 },
 {
   "symbol": "ALNY",
   "name": "Alnylam Pharmaceuticals, Inc.",
   "last_sale": "94.59",
   "market_cap": "$9.52B",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/alny",
   "FIELD9": ""
 },
 {
   "symbol": "AOSL",
   "name": "Alpha and Omega Semiconductor Limited",
   "last_sale": "11.94",
   "market_cap": "$284.92M",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/aosl",
   "FIELD9": ""
 },
 {
   "symbol": "GOOG",
   "name": "Alphabet Inc.",
   "last_sale": "1166.07",
   "market_cap": "$811.21B",
   "IPOyear": "2004",
   "sector": "Communication Services",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/goog",
   "FIELD9": ""
 },
 {
   "symbol": "GOOGL",
   "name": "Alphabet Inc.",
   "last_sale": "1172.12",
   "market_cap": "$815.42B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/googl",
   "FIELD9": ""
 },
 {
   "symbol": "SMCP",
   "name": "AlphaMark Actively Managed Small Cap ETF",
   "last_sale": "27.03",
   "market_cap": "$27.03M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/smcp",
   "FIELD9": ""
 },
 {
   "symbol": "ATEC",
   "name": "Alphatec Holdings, Inc.",
   "last_sale": "3.215",
   "market_cap": "$136.3M",
   "IPOyear": "2006",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/atec",
   "FIELD9": ""
 },
 {
   "symbol": "ALPN",
   "name": "Alpine Immune Sciences, Inc.",
   "last_sale": "6.18",
   "market_cap": "$85.6M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/alpn",
   "FIELD9": ""
 },
 {
   "symbol": "SWIN",
   "name": "ALPS/Dorsey Wright Sector Momentum ETF",
   "last_sale": "32.87",
   "market_cap": "$11.5M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/swin",
   "FIELD9": ""
 },
 {
   "symbol": "AMR",
   "name": "Alta Mesa Resources, Inc.",
   "last_sale": "4.44",
   "market_cap": "$1.7B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/amr",
   "FIELD9": ""
 },
 {
   "symbol": "AMRWW",
   "name": "Alta Mesa Resources, Inc.",
   "last_sale": "0.549",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/amrww",
   "FIELD9": ""
 },
 {
   "symbol": "AABA",
   "name": "Altaba Inc.",
   "last_sale": "67.93",
   "market_cap": "$41.13B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/aaba",
   "FIELD9": ""
 },
 {
   "symbol": "ALTR",
   "name": "Altair Engineering Inc.",
   "last_sale": "40.96",
   "market_cap": "$2.86B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/altr",
   "FIELD9": ""
 },
 {
   "symbol": "ALT",
   "name": "Altimmune, Inc.",
   "last_sale": "26",
   "market_cap": "$1.11M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/alt",
   "FIELD9": ""
 },
 {
   "symbol": "ASPS",
   "name": "Altisource Portfolio Solutions S.A.",
   "last_sale": "34.16",
   "market_cap": "$582.12M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/asps",
   "FIELD9": ""
 },
 {
   "symbol": "AIMC",
   "name": "Altra Industrial Motion Corp.",
   "last_sale": "42.9",
   "market_cap": "$1.26B",
   "IPOyear": "2006",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/aimc",
   "FIELD9": ""
 },
 {
   "symbol": "AIMCV",
   "name": "Altra Industrial Motion Corp.",
   "last_sale": "42.67",
   "market_cap": "$1.25B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/aimcv",
   "FIELD9": ""
 },
 {
   "symbol": "ALZH",
   "name": "Alzheon, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/alzh",
   "FIELD9": ""
 },
 {
   "symbol": "AMAG",
   "name": "AMAG Pharmaceuticals, Inc.",
   "last_sale": "20.65",
   "market_cap": "$711.86M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/amag",
   "FIELD9": ""
 },
 {
   "symbol": "AMAL",
   "name": "Amalgamated Bank",
   "last_sale": "18.59",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Consumer Non-Durables",
   "industry": "Textiles",
   "summary_quote": "https://www.nasdaq.com/symbol/amal",
   "FIELD9": ""
 },
 {
   "symbol": "AMRN",
   "name": "Amarin Corporation plc",
   "last_sale": "3",
   "market_cap": "$889.05M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/amrn",
   "FIELD9": ""
 },
 {
   "symbol": "AMRK",
   "name": "A-Mark Precious Metals, Inc.",
   "last_sale": "12.06",
   "market_cap": "$84.8M",
   "IPOyear": "n/a",
   "sector": "Materials",
   "industry": "Metals & Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/amrk",
   "FIELD9": ""
 },
 {
   "symbol": "AMZN",
   "name": "Amazon.com, Inc.",
   "last_sale": "1915.01",
   "market_cap": "$934.03B",
   "IPOyear": "1997",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/amzn",
   "FIELD9": ""
 },
 {
   "symbol": "AMBC",
   "name": "Ambac Financial Group, Inc.",
   "last_sale": "21.3",
   "market_cap": "$965.58M",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/ambc",
   "FIELD9": ""
 },
 {
   "symbol": "AMBCW",
   "name": "Ambac Financial Group, Inc.",
   "last_sale": "10.57",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/ambcw",
   "FIELD9": ""
 },
 {
   "symbol": "AMBA",
   "name": "Ambarella, Inc.",
   "last_sale": "38.48",
   "market_cap": "$1.23B",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/amba",
   "FIELD9": ""
 },
 {
   "symbol": "AMCX",
   "name": "AMC Networks Inc.",
   "last_sale": "65.17",
   "market_cap": "$3.71B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/amcx",
   "FIELD9": ""
 },
 {
   "symbol": "DOX",
   "name": "Amdocs Limited",
   "last_sale": "66.315",
   "market_cap": "$9.38B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dox",
   "FIELD9": ""
 },
 {
   "symbol": "AMDA",
   "name": "Amedica Corporation",
   "last_sale": "0.22",
   "market_cap": "$2.61M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/amda",
   "FIELD9": ""
 },
 {
   "symbol": "AMED",
   "name": "Amedisys Inc",
   "last_sale": "118.55",
   "market_cap": "$3.77B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/amed",
   "FIELD9": ""
 },
 {
   "symbol": "UHAL",
   "name": "Amerco",
   "last_sale": "350",
   "market_cap": "$6.86B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Rental/Leasing Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/uhal",
   "FIELD9": ""
 },
 {
   "symbol": "AMRH",
   "name": "Ameri Holdings, Inc.",
   "last_sale": "1.41",
   "market_cap": "$32.25M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/amrh",
   "FIELD9": ""
 },
 {
   "symbol": "AMRHW",
   "name": "Ameri Holdings, Inc.",
   "last_sale": "0.18",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/amrhw",
   "FIELD9": ""
 },
 {
   "symbol": "ATAX",
   "name": "America First Multifamily Investors, L.P.",
   "last_sale": "5.75",
   "market_cap": "$347.6M",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/atax",
   "FIELD9": ""
 },
 {
   "symbol": "AMOV",
   "name": "America Movil, S.A.B. de C.V.",
   "last_sale": "16.3701",
   "market_cap": "$54.06B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/amov",
   "FIELD9": ""
 },
 {
   "symbol": "AAL",
   "name": "American Airlines Group, Inc.",
   "last_sale": "43.59",
   "market_cap": "$20.07B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/aal",
   "FIELD9": ""
 },
 {
   "symbol": "AETI",
   "name": "American Electric Technologies, Inc.",
   "last_sale": "0.8665",
   "market_cap": "$7.73M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/aeti",
   "FIELD9": ""
 },
 {
   "symbol": "AFIN",
   "name": "American Finance Trust, Inc.",
   "last_sale": "17.58",
   "market_cap": "$1.87B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/afin",
   "FIELD9": ""
 },
 {
   "symbol": "AMNB",
   "name": "American National Bankshares, Inc.",
   "last_sale": "39.8",
   "market_cap": "$346.71M",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/amnb",
   "FIELD9": ""
 },
 {
   "symbol": "ANAT",
   "name": "American National Insurance Company",
   "last_sale": "132.52",
   "market_cap": "$3.56B",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/anat",
   "FIELD9": ""
 },
 {
   "symbol": "AOBC",
   "name": "American Outdoor Brands Corporation",
   "last_sale": "15.75",
   "market_cap": "$856.63M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Ordnance And Accessories",
   "summary_quote": "https://www.nasdaq.com/symbol/aobc",
   "FIELD9": ""
 },
 {
   "symbol": "APEI",
   "name": "American Public Education, Inc.",
   "last_sale": "31.15",
   "market_cap": "$511.6M",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/apei",
   "FIELD9": ""
 },
 {
   "symbol": "ARII",
   "name": "American Railcar Industries, Inc.",
   "last_sale": "46.76",
   "market_cap": "$892.36M",
   "IPOyear": "2006",
   "sector": "Capital Goods",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/arii",
   "FIELD9": ""
 },
 {
   "symbol": "AMRB",
   "name": "American River Bankshares",
   "last_sale": "15.41",
   "market_cap": "$90.38M",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/amrb",
   "FIELD9": ""
 },
 {
   "symbol": "AMSWA",
   "name": "American Software, Inc.",
   "last_sale": "11.74",
   "market_cap": "$362.84M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/amswa",
   "FIELD9": ""
 },
 {
   "symbol": "AMSC",
   "name": "American Superconductor Corporation",
   "last_sale": "6.58",
   "market_cap": "$139.68M",
   "IPOyear": "1991",
   "sector": "Consumer Durables",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/amsc",
   "FIELD9": ""
 },
 {
   "symbol": "AMWD",
   "name": "American Woodmark Corporation",
   "last_sale": "83",
   "market_cap": "$1.46B",
   "IPOyear": "1986",
   "sector": "Consumer Discretionary",
   "industry": "Home & Office Supplies",
   "summary_quote": "https://www.nasdaq.com/symbol/amwd",
   "FIELD9": ""
 },
 {
   "symbol": "CRMT",
   "name": "America&#39;s Car-Mart, Inc.",
   "last_sale": "77.75",
   "market_cap": "$535.18M",
   "IPOyear": "n/a",
   "sector": "Consumer Discretionary",
   "industry": "Retail Discretionary",
   "summary_quote": "https://www.nasdaq.com/symbol/crmt",
   "FIELD9": ""
 },
 {
   "symbol": "ABCB",
   "name": "Ameris Bancorp",
   "last_sale": "48.4",
   "market_cap": "$2.3B",
   "IPOyear": "1994",
   "sector": "Financials",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/abcb",
   "FIELD9": ""
 },
 {
   "symbol": "AMSF",
   "name": "AMERISAFE, Inc.",
   "last_sale": "63.75",
   "market_cap": "$1.23B",
   "IPOyear": "2005",
   "sector": "Financials",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/amsf",
   "FIELD9": ""
 },
 {
   "symbol": "ASRV",
   "name": "AmeriServ Financial Inc.",
   "last_sale": "4.35",
   "market_cap": "$78.41M",
   "IPOyear": "n/a",
   "sector": "Financials",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/asrv",
   "FIELD9": ""
 },
 {
   "symbol": "ASRVP",
   "name": "AmeriServ Financial Inc.",
   "last_sale": "28.16",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/asrvp",
   "FIELD9": ""
 },
 {
   "symbol": "ATLO",
   "name": "Ames National Corporation",
   "last_sale": "27.4",
   "market_cap": "$255.12M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/atlo",
   "FIELD9": ""
 },
 {
   "symbol": "AMGN",
   "name": "Amgen Inc.",
   "last_sale": "205.1",
   "market_cap": "$132.76B",
   "IPOyear": "1983",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/amgn",
   "FIELD9": ""
 },
 {
   "symbol": "FOLD",
   "name": "Amicus Therapeutics, Inc.",
   "last_sale": "12.22",
   "market_cap": "$2.31B",
   "IPOyear": "2007",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/fold",
   "FIELD9": ""
 },
 {
   "symbol": "AMKR",
   "name": "Amkor Technology, Inc.",
   "last_sale": "7.78",
   "market_cap": "$1.86B",
   "IPOyear": "1998",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/amkr",
   "FIELD9": ""
 },
 {
   "symbol": "AMPH",
   "name": "Amphastar Pharmaceuticals, Inc.",
   "last_sale": "19.18",
   "market_cap": "$887.2M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/amph",
   "FIELD9": ""
 },
 {
   "symbol": "IBUY",
   "name": "Amplify Online Retail ETF",
   "last_sale": "51.46",
   "market_cap": "$550.62M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ibuy",
   "FIELD9": ""
 },
 {
   "symbol": "ASYS",
   "name": "Amtech Systems, Inc.",
   "last_sale": "5.89",
   "market_cap": "$88.28M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/asys",
   "FIELD9": ""
 },
 {
   "symbol": "AFSI",
   "name": "AmTrust Financial Services, Inc.",
   "last_sale": "14.6049",
   "market_cap": "$2.89B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/afsi",
   "FIELD9": ""
 },
 {
   "symbol": "AMRS",
   "name": "Amyris, Inc.",
   "last_sale": "7.96",
   "market_cap": "$401.06M",
   "IPOyear": "2010",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/amrs",
   "FIELD9": ""
 },
 {
   "symbol": "ADI",
   "name": "Analog Devices, Inc.",
   "last_sale": "94.56",
   "market_cap": "$35.15B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/adi",
   "FIELD9": ""
 },
 {
   "symbol": "ANAB",
   "name": "AnaptysBio, Inc.",
   "last_sale": "92.81",
   "market_cap": "$2.23B",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/anab",
   "FIELD9": ""
 },
 {
   "symbol": "AVXL",
   "name": "Anavex Life Sciences Corp.",
   "last_sale": "2.49",
   "market_cap": "$113.12M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/avxl",
   "FIELD9": ""
 },
 {
   "symbol": "ANCB",
   "name": "Anchor Bancorp",
   "last_sale": "27.6",
   "market_cap": "$68.56M",
   "IPOyear": "2011",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ancb",
   "FIELD9": ""
 },
 {
   "symbol": "ANGI",
   "name": "ANGI Homeservices Inc.",
   "last_sale": "22.55",
   "market_cap": "$10.85B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/angi",
   "FIELD9": ""
 },
 {
   "symbol": "ANGO",
   "name": "AngioDynamics, Inc.",
   "last_sale": "23.51",
   "market_cap": "$871.64M",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/ango",
   "FIELD9": ""
 },
 {
   "symbol": "ANIP",
   "name": "ANI Pharmaceuticals, Inc.",
   "last_sale": "52.99",
   "market_cap": "$626.81M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/anip",
   "FIELD9": ""
 },
 {
   "symbol": "ANIK",
   "name": "Anika Therapeutics Inc.",
   "last_sale": "41.02",
   "market_cap": "$598.22M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/anik",
   "FIELD9": ""
 },
 {
   "symbol": "ANSS",
   "name": "ANSYS, Inc.",
   "last_sale": "182.48",
   "market_cap": "$15.38B",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/anss",
   "FIELD9": ""
 },
 {
   "symbol": "ATRS",
   "name": "Antares Pharma, Inc.",
   "last_sale": "3.26",
   "market_cap": "$513.24M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/atrs",
   "FIELD9": ""
 },
 {
   "symbol": "APLS",
   "name": "Apellis Pharmaceuticals, Inc.",
   "last_sale": "19.9",
   "market_cap": "$1.12B",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/apls",
   "FIELD9": ""
 },
 {
   "symbol": "APOG",
   "name": "Apogee Enterprises, Inc.",
   "last_sale": "43.01",
   "market_cap": "$1.22B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/apog",
   "FIELD9": ""
 },
 {
   "symbol": "APEN",
   "name": "Apollo Endosurgery, Inc.",
   "last_sale": "6.89",
   "market_cap": "$150.75M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/apen",
   "FIELD9": ""
 },
 {
   "symbol": "AINV",
   "name": "Apollo Investment Corporation",
   "last_sale": "5.51",
   "market_cap": "$1.18B",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ainv",
   "FIELD9": ""
 },
 {
   "symbol": "AMEH",
   "name": "Apollo Medical Holdings, Inc.",
   "last_sale": "16.57",
   "market_cap": "$555.46M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ameh",
   "FIELD9": ""
 },
 {
   "symbol": "APPF",
   "name": "AppFolio, Inc.",
   "last_sale": "80.65",
   "market_cap": "$2.76B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/appf",
   "FIELD9": ""
 },
 {
   "symbol": "APPN",
   "name": "Appian Corporation",
   "last_sale": "34.2701",
   "market_cap": "$2.12B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/appn",
   "FIELD9": ""
 },
 {
   "symbol": "AAPL",
   "name": "Apple Inc.",
   "last_sale": "217.66",
   "market_cap": "$1051.28B",
   "IPOyear": "1980",
   "sector": "Technology",
   "industry": "Hardware",
   "summary_quote": "https://www.nasdaq.com/symbol/aapl",
   "FIELD9": ""
 },
 {
   "symbol": "ARCI",
   "name": "Appliance Recycling Centers of America, Inc.",
   "last_sale": "1.1",
   "market_cap": "$9.32M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/arci",
   "FIELD9": ""
 },
 {
   "symbol": "APDN",
   "name": "Applied DNA Sciences Inc",
   "last_sale": "1.4101",
   "market_cap": "$42.46M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/apdn",
   "FIELD9": ""
 },
 {
   "symbol": "APDNW",
   "name": "Applied DNA Sciences Inc",
   "last_sale": "0.19",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/apdnw",
   "FIELD9": ""
 },
 {
   "symbol": "AGTC",
   "name": "Applied Genetic Technologies Corporation",
   "last_sale": "4.4",
   "market_cap": "$79.77M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/agtc",
   "FIELD9": ""
 },
 {
   "symbol": "AMAT",
   "name": "Applied Materials, Inc.",
   "last_sale": "39.63",
   "market_cap": "$38.96B",
   "IPOyear": "1972",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/amat",
   "FIELD9": ""
 },
 {
   "symbol": "AAOI",
   "name": "Applied Optoelectronics, Inc.",
   "last_sale": "32.72",
   "market_cap": "$644.52M",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/aaoi",
   "FIELD9": ""
 },
 {
   "symbol": "AREX",
   "name": "Approach Resources Inc.",
   "last_sale": "2.18",
   "market_cap": "$205.98M",
   "IPOyear": "2007",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/arex",
   "FIELD9": ""
 },
 {
   "symbol": "APTI",
   "name": "Apptio, Inc.",
   "last_sale": "37.94",
   "market_cap": "$1.69B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/apti",
   "FIELD9": ""
 },
 {
   "symbol": "APRI",
   "name": "Apricus Biosciences, Inc.",
   "last_sale": "0.2875",
   "market_cap": "$6.74M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/apri",
   "FIELD9": ""
 },
 {
   "symbol": "APVO",
   "name": "Aptevo Therapeutics Inc.",
   "last_sale": "4.95",
   "market_cap": "$112.21M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/apvo",
   "FIELD9": ""
 },
 {
   "symbol": "APTX",
   "name": "Aptinyx Inc.",
   "last_sale": "26.67",
   "market_cap": "$893.34M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/aptx",
   "FIELD9": ""
 },
 {
   "symbol": "APTO",
   "name": "Aptose Biosciences, Inc.",
   "last_sale": "2.6",
   "market_cap": "$89.47M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/apto",
   "FIELD9": ""
 },
 {
   "symbol": "AQMS",
   "name": "Aqua Metals, Inc.",
   "last_sale": "2.67",
   "market_cap": "$103.54M",
   "IPOyear": "2015",
   "sector": "Basic Industries",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/aqms",
   "FIELD9": ""
 },
 {
   "symbol": "AQB",
   "name": "AquaBounty Technologies, Inc.",
   "last_sale": "2.95",
   "market_cap": "$37.9M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aqb",
   "FIELD9": ""
 },
 {
   "symbol": "AQST",
   "name": "Aquestive Therapeutics, Inc.",
   "last_sale": "16.33",
   "market_cap": "$407.04M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/aqst",
   "FIELD9": ""
 },
 {
   "symbol": "AQXP",
   "name": "Aquinox Pharmaceuticals, Inc.",
   "last_sale": "2.93",
   "market_cap": "$68.96M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/aqxp",
   "FIELD9": ""
 },
 {
   "symbol": "ARDM",
   "name": "Aradigm Corporation",
   "last_sale": "1.24",
   "market_cap": "$18.85M",
   "IPOyear": "1996",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/ardm",
   "FIELD9": ""
 },
 {
   "symbol": "PETX",
   "name": "Aratana Therapeutics, Inc.",
   "last_sale": "5.96",
   "market_cap": "$284.12M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/petx",
   "FIELD9": ""
 },
 {
   "symbol": "ABUS",
   "name": "Arbutus Biopharma Corporation",
   "last_sale": "9.5",
   "market_cap": "$526.34M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/abus",
   "FIELD9": ""
 },
 {
   "symbol": "ARCW",
   "name": "ARC Group Worldwide, Inc.",
   "last_sale": "1.95",
   "market_cap": "$45.45M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/arcw",
   "FIELD9": ""
 },
 {
   "symbol": "ABIO",
   "name": "ARCA biopharma, Inc.",
   "last_sale": "0.5379",
   "market_cap": "$7.49M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/abio",
   "FIELD9": ""
 },
 {
   "symbol": "RKDA",
   "name": "Arcadia Biosciences, Inc.",
   "last_sale": "4.93",
   "market_cap": "$23.54M",
   "IPOyear": "2015",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/rkda",
   "FIELD9": ""
 },
 {
   "symbol": "ARCB",
   "name": "ArcBest Corporation",
   "last_sale": "46.6",
   "market_cap": "$1.2B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/arcb",
   "FIELD9": ""
 },
 {
   "symbol": "ACGL",
   "name": "Arch Capital Group Ltd.",
   "last_sale": "30.2",
   "market_cap": "$12.24B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/acgl",
   "FIELD9": ""
 },
 {
   "symbol": "ACGLO",
   "name": "Arch Capital Group Ltd.",
   "last_sale": "23.67",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/acglo",
   "FIELD9": ""
 },
 {
   "symbol": "ACGLP",
   "name": "Arch Capital Group Ltd.",
   "last_sale": "23.3",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/acglp",
   "FIELD9": ""
 },
 {
   "symbol": "FUV",
   "name": "Arcimoto, Inc.",
   "last_sale": "3.92",
   "market_cap": "$62.7M",
   "IPOyear": "2017",
   "sector": "Consumer Non-Durables",
   "industry": "Motor Vehicles",
   "summary_quote": "https://www.nasdaq.com/symbol/fuv",
   "FIELD9": ""
 },
 {
   "symbol": "ARCT",
   "name": "Arcturus Therapeutics Ltd.",
   "last_sale": "9.8",
   "market_cap": "$101.18M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/arct",
   "FIELD9": ""
 },
 {
   "symbol": "ARDX",
   "name": "Ardelyx, Inc.",
   "last_sale": "4.15",
   "market_cap": "$257.52M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ardx",
   "FIELD9": ""
 },
 {
   "symbol": "ARNA",
   "name": "Arena Pharmaceuticals, Inc.",
   "last_sale": "43.75",
   "market_cap": "$2.16B",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/arna",
   "FIELD9": ""
 },
 {
   "symbol": "ARCC",
   "name": "Ares Capital Corporation",
   "last_sale": "17.3299",
   "market_cap": "$7.39B",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/arcc",
   "FIELD9": ""
 },
 {
   "symbol": "ARGX",
   "name": "argenx SE",
   "last_sale": "78.1",
   "market_cap": "$2.53B",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/argx",
   "FIELD9": ""
 },
 {
   "symbol": "ARDS",
   "name": "Aridis Pharmaceuticals Inc.",
   "last_sale": "12.035",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ards",
   "FIELD9": ""
 },
 {
   "symbol": "ARKR",
   "name": "Ark Restaurants Corp.",
   "last_sale": "23.07",
   "market_cap": "$80.06M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/arkr",
   "FIELD9": ""
 },
 {
   "symbol": "ARTX",
   "name": "Arotech Corporation",
   "last_sale": "3.55",
   "market_cap": "$94.03M",
   "IPOyear": "1994",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/artx",
   "FIELD9": ""
 },
 {
   "symbol": "ARQL",
   "name": "ArQule, Inc.",
   "last_sale": "5.08",
   "market_cap": "$552.79M",
   "IPOyear": "1996",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/arql",
   "FIELD9": ""
 },
 {
   "symbol": "ARRY",
   "name": "Array BioPharma Inc.",
   "last_sale": "15.3",
   "market_cap": "$3.26B",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/arry",
   "FIELD9": ""
 },
 {
   "symbol": "ARRS",
   "name": "ARRIS International plc",
   "last_sale": "26.48",
   "market_cap": "$4.78B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/arrs",
   "FIELD9": ""
 },
 {
   "symbol": "DWCR",
   "name": "Arrow DWA Country Rotation ETF",
   "last_sale": "28.84",
   "market_cap": "$18.75M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dwcr",
   "FIELD9": ""
 },
 {
   "symbol": "DWAT",
   "name": "Arrow DWA Tactical ETF",
   "last_sale": "12.5573",
   "market_cap": "$6.28M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dwat",
   "FIELD9": ""
 },
 {
   "symbol": "AROW",
   "name": "Arrow Financial Corporation",
   "last_sale": "38.3",
   "market_cap": "$552.92M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/arow",
   "FIELD9": ""
 },
 {
   "symbol": "ARWR",
   "name": "Arrowhead Pharmaceuticals, Inc.",
   "last_sale": "17.78",
   "market_cap": "$1.57B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/arwr",
   "FIELD9": ""
 },
 {
   "symbol": "ASNS",
   "name": "Arsanis, Inc.",
   "last_sale": "1.68",
   "market_cap": "$24.05M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/asns",
   "FIELD9": ""
 },
 {
   "symbol": "ARTNA",
   "name": "Artesian Resources Corporation",
   "last_sale": "36.5",
   "market_cap": "$337.32M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/artna",
   "FIELD9": ""
 },
 {
   "symbol": "ARTW",
   "name": "Art&#39;s-Way Manufacturing Co., Inc.",
   "last_sale": "2.7",
   "market_cap": "$11.34M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/artw",
   "FIELD9": ""
 },
 {
   "symbol": "ASNA",
   "name": "Ascena Retail Group, Inc.",
   "last_sale": "4.24",
   "market_cap": "$831.95M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/asna",
   "FIELD9": ""
 },
 {
   "symbol": "ASND",
   "name": "Ascendis Pharma A/S",
   "last_sale": "66.53",
   "market_cap": "$2.79B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/asnd",
   "FIELD9": ""
 },
 {
   "symbol": "ASCMA",
   "name": "Ascent Capital Group, Inc.",
   "last_sale": "2.19",
   "market_cap": "$27.22M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ascma",
   "FIELD9": ""
 },
 {
   "symbol": "APWC",
   "name": "Asia Pacific Wire & Cable Corporation Limited",
   "last_sale": "2.6",
   "market_cap": "$35.93M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/apwc",
   "FIELD9": ""
 },
 {
   "symbol": "ASLN",
   "name": "ASLAN Pharmaceuticals Limited",
   "last_sale": "7.8",
   "market_cap": "$249.8M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/asln",
   "FIELD9": ""
 },
 {
   "symbol": "ASML",
   "name": "ASML Holding N.V.",
   "last_sale": "188.47",
   "market_cap": "$80.39B",
   "IPOyear": "1995",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/asml",
   "FIELD9": ""
 },
 {
   "symbol": "ASPU",
   "name": "Aspen Group Inc.",
   "last_sale": "7.2",
   "market_cap": "$131.88M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/aspu",
   "FIELD9": ""
 },
 {
   "symbol": "AZPN",
   "name": "Aspen Technology, Inc.",
   "last_sale": "110.89",
   "market_cap": "$7.87B",
   "IPOyear": "1994",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/azpn",
   "FIELD9": ""
 },
 {
   "symbol": "ASMB",
   "name": "Assembly Biosciences, Inc.",
   "last_sale": "36.1",
   "market_cap": "$918.62M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/asmb",
   "FIELD9": ""
 },
 {
   "symbol": "ASRT",
   "name": "Assertio Therapeutics, Inc.",
   "last_sale": "6.14",
   "market_cap": "$392.44M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/asrt",
   "FIELD9": ""
 },
 {
   "symbol": "ASFI",
   "name": "Asta Funding, Inc.",
   "last_sale": "3.975",
   "market_cap": "$26.57M",
   "IPOyear": "1995",
   "sector": "Finance",
   "industry": "Finance Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/asfi",
   "FIELD9": ""
 },
 {
   "symbol": "ASTE",
   "name": "Astec Industries, Inc.",
   "last_sale": "52.51",
   "market_cap": "$1.21B",
   "IPOyear": "1986",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/aste",
   "FIELD9": ""
 },
 {
   "symbol": "ATRO",
   "name": "Astronics Corporation",
   "last_sale": "43.45",
   "market_cap": "$1.22B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/atro",
   "FIELD9": ""
 },
 {
   "symbol": "ALOT",
   "name": "AstroNova, Inc.",
   "last_sale": "21.85",
   "market_cap": "$149.86M",
   "IPOyear": "1983",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/alot",
   "FIELD9": ""
 },
 {
   "symbol": "ASTC",
   "name": "Astrotech Corporation",
   "last_sale": "5.54",
   "market_cap": "$22.79M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/astc",
   "FIELD9": ""
 },
 {
   "symbol": "ASUR",
   "name": "Asure Software Inc",
   "last_sale": "12.78",
   "market_cap": "$194.55M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/asur",
   "FIELD9": ""
 },
 {
   "symbol": "ASV",
   "name": "ASV Holdings, Inc.",
   "last_sale": "5.27",
   "market_cap": "$51.82M",
   "IPOyear": "2017",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/asv",
   "FIELD9": ""
 },
 {
   "symbol": "ATAI",
   "name": "ATA Inc.",
   "last_sale": "1.14",
   "market_cap": "$27.6M",
   "IPOyear": "2008",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/atai",
   "FIELD9": ""
 },
 {
   "symbol": "ATRA",
   "name": "Atara Biotherapeutics, Inc.",
   "last_sale": "39.9",
   "market_cap": "$1.81B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/atra",
   "FIELD9": ""
 },
 {
   "symbol": "ATHN",
   "name": "athenahealth, Inc.",
   "last_sale": "136.67",
   "market_cap": "$5.54B",
   "IPOyear": "2007",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/athn",
   "FIELD9": ""
 },
 {
   "symbol": "ATNX",
   "name": "Athenex, Inc.",
   "last_sale": "16.92",
   "market_cap": "$1.12B",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/atnx",
   "FIELD9": ""
 },
 {
   "symbol": "ATHX",
   "name": "Athersys, Inc.",
   "last_sale": "1.94",
   "market_cap": "$268.85M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/athx",
   "FIELD9": ""
 },
 {
   "symbol": "AAME",
   "name": "Atlantic American Corporation",
   "last_sale": "2.6",
   "market_cap": "$52.65M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/aame",
   "FIELD9": ""
 },
 {
   "symbol": "ACBI",
   "name": "Atlantic Capital Bancshares, Inc.",
   "last_sale": "17.475",
   "market_cap": "$456.17M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/acbi",
   "FIELD9": ""
 },
 {
   "symbol": "AY",
   "name": "Atlantica Yield plc",
   "last_sale": "20.46",
   "market_cap": "$2.05B",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/ay",
   "FIELD9": ""
 },
 {
   "symbol": "ATLC",
   "name": "Atlanticus Holdings Corporation",
   "last_sale": "2.88",
   "market_cap": "$44.93M",
   "IPOyear": "1995",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/atlc",
   "FIELD9": ""
 },
 {
   "symbol": "AAWW",
   "name": "Atlas Air Worldwide Holdings",
   "last_sale": "63.35",
   "market_cap": "$1.62B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/aaww",
   "FIELD9": ""
 },
 {
   "symbol": "AFH",
   "name": "Atlas Financial Holdings, Inc.",
   "last_sale": "10.35",
   "market_cap": "$123.55M",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/afh",
   "FIELD9": ""
 },
 {
   "symbol": "AFHBL",
   "name": "Atlas Financial Holdings, Inc.",
   "last_sale": "25.2625",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/afhbl",
   "FIELD9": ""
 },
 {
   "symbol": "TEAM",
   "name": "Atlassian Corporation Plc",
   "last_sale": "90.62",
   "market_cap": "$21.32B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/team",
   "FIELD9": ""
 },
 {
   "symbol": "ATNI",
   "name": "ATN International, Inc.",
   "last_sale": "72.36",
   "market_cap": "$1.15B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/atni",
   "FIELD9": ""
 },
 {
   "symbol": "ATOM",
   "name": "Atomera Incorporated",
   "last_sale": "5.05",
   "market_cap": "$62.66M",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/atom",
   "FIELD9": ""
 },
 {
   "symbol": "ATOS",
   "name": "Atossa Genetics Inc.",
   "last_sale": "1.56",
   "market_cap": "$8.58M",
   "IPOyear": "2012",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/atos",
   "FIELD9": ""
 },
 {
   "symbol": "ATRC",
   "name": "AtriCure, Inc.",
   "last_sale": "35.24",
   "market_cap": "$1.25B",
   "IPOyear": "2005",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/atrc",
   "FIELD9": ""
 },
 {
   "symbol": "ATRI",
   "name": "Atrion Corporation",
   "last_sale": "658.8",
   "market_cap": "$1.22B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/atri",
   "FIELD9": ""
 },
 {
   "symbol": "ATIS",
   "name": "Attis Industries Inc.",
   "last_sale": "0.27",
   "market_cap": "$5.84M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Miscellaneous",
   "summary_quote": "https://www.nasdaq.com/symbol/atis",
   "FIELD9": ""
 },
 {
   "symbol": "ATISW",
   "name": "Attis Industries Inc.",
   "last_sale": "0.084",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Miscellaneous",
   "summary_quote": "https://www.nasdaq.com/symbol/atisw",
   "FIELD9": ""
 },
 {
   "symbol": "ATTU",
   "name": "Attunity Ltd.",
   "last_sale": "18.68",
   "market_cap": "$393.97M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/attu",
   "FIELD9": ""
 },
 {
   "symbol": "LIFE",
   "name": "aTyr Pharma, Inc.",
   "last_sale": "0.7799",
   "market_cap": "$23.29M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/life",
   "FIELD9": ""
 },
 {
   "symbol": "AUBN",
   "name": "Auburn National Bancorporation, Inc.",
   "last_sale": "39.94",
   "market_cap": "$145.53M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/aubn",
   "FIELD9": ""
 },
 {
   "symbol": "BOLD",
   "name": "Audentes Therapeutics, Inc.",
   "last_sale": "37.65",
   "market_cap": "$1.41B",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/bold",
   "FIELD9": ""
 },
 {
   "symbol": "AUDC",
   "name": "AudioCodes Ltd.",
   "last_sale": "10.1",
   "market_cap": "$291.05M",
   "IPOyear": "1999",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/audc",
   "FIELD9": ""
 },
 {
   "symbol": "AEYE",
   "name": "AudioEye, Inc.",
   "last_sale": "8.6333",
   "market_cap": "$64.58M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/aeye",
   "FIELD9": ""
 },
 {
   "symbol": "AUPH",
   "name": "Aurinia Pharmaceuticals Inc",
   "last_sale": "5.56",
   "market_cap": "$474.38M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/auph",
   "FIELD9": ""
 },
 {
   "symbol": "EARS",
   "name": "Auris Medical Holding AG",
   "last_sale": "0.2923",
   "market_cap": "$1.79M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ears",
   "FIELD9": ""
 },
 {
   "symbol": "JG",
   "name": "Aurora Mobile Limited",
   "last_sale": "8.24",
   "market_cap": "$970.69M",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/jg",
   "FIELD9": ""
 },
 {
   "symbol": "ADSK",
   "name": "Autodesk, Inc.",
   "last_sale": "152.4",
   "market_cap": "$33.32B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/adsk",
   "FIELD9": ""
 },
 {
   "symbol": "AUTL",
   "name": "Autolus Therapeutics plc",
   "last_sale": "28.75",
   "market_cap": "$1.15B",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/autl",
   "FIELD9": ""
 },
 {
   "symbol": "ADP",
   "name": "Automatic Data Processing, Inc.",
   "last_sale": "150.68",
   "market_cap": "$66.01B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/adp",
   "FIELD9": ""
 },
 {
   "symbol": "AUTO",
   "name": "AutoWeb, Inc.",
   "last_sale": "3.3",
   "market_cap": "$42.73M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/auto",
   "FIELD9": ""
 },
 {
   "symbol": "AVDL",
   "name": "Avadel Pharmaceuticals plc",
   "last_sale": "4.38",
   "market_cap": "$161.03M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/avdl",
   "FIELD9": ""
 },
 {
   "symbol": "ATXI",
   "name": "Avenue Therapeutics, Inc.",
   "last_sale": "3.42",
   "market_cap": "$36.1M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/atxi",
   "FIELD9": ""
 },
 {
   "symbol": "AVEO",
   "name": "AVEO Pharmaceuticals, Inc.",
   "last_sale": "2.86",
   "market_cap": "$340.43M",
   "IPOyear": "2010",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/aveo",
   "FIELD9": ""
 },
 {
   "symbol": "AVNW",
   "name": "Aviat Networks, Inc.",
   "last_sale": "17.07",
   "market_cap": "$91.67M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/avnw",
   "FIELD9": ""
 },
 {
   "symbol": "CDMO",
   "name": "Avid Bioservices, Inc.",
   "last_sale": "6.88",
   "market_cap": "$385.29M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cdmo",
   "FIELD9": ""
 },
 {
   "symbol": "CDMOP",
   "name": "Avid Bioservices, Inc.",
   "last_sale": "25.9",
   "market_cap": "$18.13M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cdmop",
   "FIELD9": ""
 },
 {
   "symbol": "AVID",
   "name": "Avid Technology, Inc.",
   "last_sale": "5.755",
   "market_cap": "$240.5M",
   "IPOyear": "1993",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/avid",
   "FIELD9": ""
 },
 {
   "symbol": "AVGR",
   "name": "Avinger, Inc.",
   "last_sale": "1.44",
   "market_cap": "$16.63M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/avgr",
   "FIELD9": ""
 },
 {
   "symbol": "CAR",
   "name": "Avis Budget Group, Inc.",
   "last_sale": "33.92",
   "market_cap": "$2.69B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Rental/Leasing Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/car",
   "FIELD9": ""
 },
 {
   "symbol": "AHPA",
   "name": "Avista Healthcare Public Acquisition Corp.",
   "last_sale": "10.12",
   "market_cap": "$121.45M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ahpa",
   "FIELD9": ""
 },
 {
   "symbol": "AHPAU",
   "name": "Avista Healthcare Public Acquisition Corp.",
   "last_sale": "10.25",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ahpau",
   "FIELD9": ""
 },
 {
   "symbol": "AHPAW",
   "name": "Avista Healthcare Public Acquisition Corp.",
   "last_sale": "0.21",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ahpaw",
   "FIELD9": ""
 },
 {
   "symbol": "AVT",
   "name": "Avnet, Inc.",
   "last_sale": "47.11",
   "market_cap": "$5.45B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/avt",
   "FIELD9": ""
 },
 {
   "symbol": "AVRO",
   "name": "AVROBIO, Inc.",
   "last_sale": "49.25",
   "market_cap": "$1.18B",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/avro",
   "FIELD9": ""
 },
 {
   "symbol": "AWRE",
   "name": "Aware, Inc.",
   "last_sale": "3.65",
   "market_cap": "$78.76M",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/awre",
   "FIELD9": ""
 },
 {
   "symbol": "ACLS",
   "name": "Axcelis Technologies, Inc.",
   "last_sale": "20.35",
   "market_cap": "$658.44M",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/acls",
   "FIELD9": ""
 },
 {
   "symbol": "AXGN",
   "name": "AxoGen, Inc.",
   "last_sale": "35.85",
   "market_cap": "$1.37B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/axgn",
   "FIELD9": ""
 },
 {
   "symbol": "AAXN",
   "name": "Axon Enterprise, Inc.",
   "last_sale": "64.79",
   "market_cap": "$3.78B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Ordnance And Accessories",
   "summary_quote": "https://www.nasdaq.com/symbol/aaxn",
   "FIELD9": ""
 },
 {
   "symbol": "BOFI",
   "name": "Axos Financial, Inc.",
   "last_sale": "35.82",
   "market_cap": "$2.25B",
   "IPOyear": "2005",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/bofi",
   "FIELD9": ""
 },
 {
   "symbol": "BOFIL",
   "name": "Axos Financial, Inc.",
   "last_sale": "25.98",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/bofil",
   "FIELD9": ""
 },
 {
   "symbol": "AXON          ",
   "name": "Axovant Sciences Ltd.",
   "last_sale": "2.28",
   "market_cap": "$278.34M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/axon",
   "FIELD9": ""
 },
 {
   "symbol": "AXSM",
   "name": "Axsome Therapeutics, Inc.",
   "last_sale": "3.25",
   "market_cap": "$85.32M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/axsm",
   "FIELD9": ""
 },
 {
   "symbol": "AXTI",
   "name": "AXT Inc",
   "last_sale": "7.5202",
   "market_cap": "$297.13M",
   "IPOyear": "1998",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/axti",
   "FIELD9": ""
 },
 {
   "symbol": "AYTU",
   "name": "Aytu BioScience, Inc.",
   "last_sale": "2.86",
   "market_cap": "$5.15M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/aytu",
   "FIELD9": ""
 },
 {
   "symbol": "AZRX",
   "name": "AzurRx BioPharma, Inc.",
   "last_sale": "2.64",
   "market_cap": "$44.64M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/azrx",
   "FIELD9": ""
 },
 {
   "symbol": "BCOM",
   "name": "B Communications Ltd.",
   "last_sale": "10.3593",
   "market_cap": "$309.63M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/bcom",
   "FIELD9": ""
 },
 {
   "symbol": "RILY",
   "name": "B. Riley Financial, Inc.",
   "last_sale": "22.35",
   "market_cap": "$583.94M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rily",
   "FIELD9": ""
 },
 {
   "symbol": "RILYG",
   "name": "B. Riley Financial, Inc.",
   "last_sale": "25.07",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rilyg",
   "FIELD9": ""
 },
 {
   "symbol": "RILYH",
   "name": "B. Riley Financial, Inc.",
   "last_sale": "25.92",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rilyh",
   "FIELD9": ""
 },
 {
   "symbol": "RILYI",
   "name": "B. Riley Financial, Inc.",
   "last_sale": "25.03",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rilyi",
   "FIELD9": ""
 },
 {
   "symbol": "RILYL",
   "name": "B. Riley Financial, Inc.",
   "last_sale": "25.49",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rilyl",
   "FIELD9": ""
 },
 {
   "symbol": "RILYZ",
   "name": "B. Riley Financial, Inc.",
   "last_sale": "25.41",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rilyz",
   "FIELD9": ""
 },
 {
   "symbol": "BOSC",
   "name": "B.O.S. Better Online Solutions",
   "last_sale": "2.4385",
   "market_cap": "$8.67M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/bosc",
   "FIELD9": ""
 },
 {
   "symbol": "BIDU",
   "name": "Baidu, Inc.",
   "last_sale": "228.97",
   "market_cap": "$80.16B",
   "IPOyear": "2005",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/bidu",
   "FIELD9": ""
 },
 {
   "symbol": "BCPC",
   "name": "Balchem Corporation",
   "last_sale": "116.06",
   "market_cap": "$3.74B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/bcpc",
   "FIELD9": ""
 },
 {
   "symbol": "BLDP",
   "name": "Ballard Power Systems, Inc.",
   "last_sale": "4.36",
   "market_cap": "$779.59M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/bldp",
   "FIELD9": ""
 },
 {
   "symbol": "BANF",
   "name": "BancFirst Corporation",
   "last_sale": "62.6",
   "market_cap": "$2.05B",
   "IPOyear": "1993",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/banf",
   "FIELD9": ""
 },
 {
   "symbol": "BANFP",
   "name": "BancFirst Corporation",
   "last_sale": "27.7132",
   "market_cap": "$27.71M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/banfp",
   "FIELD9": ""
 },
 {
   "symbol": "BCTF",
   "name": "Bancorp 34, Inc.",
   "last_sale": "16.22",
   "market_cap": "$55.21M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/bctf",
   "FIELD9": ""
 },
 {
   "symbol": "BAND",
   "name": "Bandwidth Inc.",
   "last_sale": "52.41",
   "market_cap": "$987.07M",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/band",
   "FIELD9": ""
 },
 {
   "symbol": "BOCH",
   "name": "Bank of Commerce Holdings (CA)",
   "last_sale": "12.65",
   "market_cap": "$206.42M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/boch",
   "FIELD9": ""
 },
 {
   "symbol": "BMRC",
   "name": "Bank of Marin Bancorp",
   "last_sale": "86.2",
   "market_cap": "$602.84M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bmrc",
   "FIELD9": ""
 },
 {
   "symbol": "BMLP",
   "name": "Bank Of Montreal",
   "last_sale": "51.22",
   "market_cap": "$51.22M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bmlp",
   "FIELD9": ""
 },
 {
   "symbol": "BKSC",
   "name": "Bank of South Carolina Corp.",
   "last_sale": "20.7",
   "market_cap": "$114.07M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bksc",
   "FIELD9": ""
 },
 {
   "symbol": "BOTJ",
   "name": "Bank of the James Financial Group, Inc.",
   "last_sale": "16.47",
   "market_cap": "$72.11M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/botj",
   "FIELD9": ""
 },
 {
   "symbol": "OZK",
   "name": "Bank OZK",
   "last_sale": "40.19",
   "market_cap": "$5.17B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ozk",
   "FIELD9": ""
 },
 {
   "symbol": "BSVN",
   "name": "Bank7 Corp.",
   "last_sale": "19.1",
   "market_cap": "$29.3M",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bsvn",
   "FIELD9": ""
 },
 {
   "symbol": "BFIN",
   "name": "BankFinancial Corporation",
   "last_sale": "16.05",
   "market_cap": "$279.96M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/bfin",
   "FIELD9": ""
 },
 {
   "symbol": "BWFG",
   "name": "Bankwell Financial Group, Inc.",
   "last_sale": "31.4",
   "market_cap": "$246.26M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bwfg",
   "FIELD9": ""
 },
 {
   "symbol": "BANR",
   "name": "Banner Corporation",
   "last_sale": "65.14",
   "market_cap": "$2.11B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/banr",
   "FIELD9": ""
 },
 {
   "symbol": "BZUN",
   "name": "Baozun Inc.",
   "last_sale": "48.58",
   "market_cap": "$2.77B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/bzun",
   "FIELD9": ""
 },
 {
   "symbol": "DFVL",
   "name": "Barclays PLC",
   "last_sale": "62.64",
   "market_cap": "$4.46M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/dfvl",
   "FIELD9": ""
 },
 {
   "symbol": "DFVS",
   "name": "Barclays PLC",
   "last_sale": "37.8",
   "market_cap": "$4.65M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/dfvs",
   "FIELD9": ""
 },
 {
   "symbol": "DLBL",
   "name": "Barclays PLC",
   "last_sale": "75.08",
   "market_cap": "$4.35M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/dlbl",
   "FIELD9": ""
 },
 {
   "symbol": "DLBS",
   "name": "Barclays PLC",
   "last_sale": "21.6407",
   "market_cap": "$20M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/dlbs",
   "FIELD9": ""
 },
 {
   "symbol": "DTUL",
   "name": "Barclays PLC",
   "last_sale": "56.75",
   "market_cap": "$3.97M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/dtul",
   "FIELD9": ""
 },
 {
   "symbol": "DTUS",
   "name": "Barclays PLC",
   "last_sale": "40.95",
   "market_cap": "$6.4M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/dtus",
   "FIELD9": ""
 },
 {
   "symbol": "DTYL",
   "name": "Barclays PLC",
   "last_sale": "72.62",
   "market_cap": "$4.64M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/dtyl",
   "FIELD9": ""
 },
 {
   "symbol": "DTYS",
   "name": "Barclays PLC",
   "last_sale": "24.1525",
   "market_cap": "$72.59M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/dtys",
   "FIELD9": ""
 },
 {
   "symbol": "FLAT",
   "name": "Barclays PLC",
   "last_sale": "65.13",
   "market_cap": "$2.99M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/flat",
   "FIELD9": ""
 },
 {
   "symbol": "STPP",
   "name": "Barclays PLC",
   "last_sale": "30.31",
   "market_cap": "$2.52M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/stpp",
   "FIELD9": ""
 },
 {
   "symbol": "TAPR",
   "name": "Barclays PLC",
   "last_sale": "29.1792",
   "market_cap": "$18.53M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tapr",
   "FIELD9": ""
 },
 {
   "symbol": "BHAC",
   "name": "Barington/Hilco Acquisition Corp.",
   "last_sale": "10.9",
   "market_cap": "$24.48M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bhac",
   "FIELD9": ""
 },
 {
   "symbol": "BHACR",
   "name": "Barington/Hilco Acquisition Corp.",
   "last_sale": "0.21",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bhacr",
   "FIELD9": ""
 },
 {
   "symbol": "BHACU",
   "name": "Barington/Hilco Acquisition Corp.",
   "last_sale": "10.52",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bhacu",
   "FIELD9": ""
 },
 {
   "symbol": "BHACW",
   "name": "Barington/Hilco Acquisition Corp.",
   "last_sale": "0.1207",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bhacw",
   "FIELD9": ""
 },
 {
   "symbol": "BBSI",
   "name": "Barrett Business Services, Inc.",
   "last_sale": "63.4",
   "market_cap": "$466.62M",
   "IPOyear": "1993",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bbsi",
   "FIELD9": ""
 },
 {
   "symbol": "BSET",
   "name": "Bassett Furniture Industries, Incorporated",
   "last_sale": "20.375",
   "market_cap": "$218.74M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/bset",
   "FIELD9": ""
 },
 {
   "symbol": "ZTEST",
   "name": "BATS BZX Exchange",
   "last_sale": "11",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ztest",
   "FIELD9": ""
 },
 {
   "symbol": "BCML",
   "name": "BayCom Corp",
   "last_sale": "25.23",
   "market_cap": "$274.23M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bcml",
   "FIELD9": ""
 },
 {
   "symbol": "BCBP",
   "name": "BCB Bancorp, Inc. (NJ)",
   "last_sale": "14.05",
   "market_cap": "$221.75M",
   "IPOyear": "2005",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/bcbp",
   "FIELD9": ""
 },
 {
   "symbol": "BECN",
   "name": "Beacon Roofing Supply, Inc.",
   "last_sale": "39.37",
   "market_cap": "$2.68B",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/becn",
   "FIELD9": ""
 },
 {
   "symbol": "BBGI",
   "name": "Beasley Broadcast Group, Inc.",
   "last_sale": "6.55",
   "market_cap": "$180.17M",
   "IPOyear": "2000",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/bbgi",
   "FIELD9": ""
 },
 {
   "symbol": "BBBY",
   "name": "Bed Bath & Beyond Inc.",
   "last_sale": "19.13",
   "market_cap": "$2.68B",
   "IPOyear": "1992",
   "sector": "Consumer Services",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/bbby",
   "FIELD9": ""
 },
 {
   "symbol": "BGNE",
   "name": "BeiGene, Ltd.",
   "last_sale": "164.16",
   "market_cap": "$9.72B",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bgne",
   "FIELD9": ""
 },
 {
   "symbol": "BELFA",
   "name": "Bel Fuse Inc.",
   "last_sale": "21",
   "market_cap": "$252.26M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/belfa",
   "FIELD9": ""
 },
 {
   "symbol": "BELFB",
   "name": "Bel Fuse Inc.",
   "last_sale": "24.85",
   "market_cap": "$298.51M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/belfb",
   "FIELD9": ""
 },
 {
   "symbol": "BLPH",
   "name": "Bellerophon Therapeutics, Inc.",
   "last_sale": "1.18",
   "market_cap": "$68.2M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/blph",
   "FIELD9": ""
 },
 {
   "symbol": "BLCM",
   "name": "Bellicum Pharmaceuticals, Inc.",
   "last_sale": "6.12",
   "market_cap": "$265.3M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/blcm",
   "FIELD9": ""
 },
 {
   "symbol": "BNCL",
   "name": "Beneficial Bancorp, Inc.",
   "last_sale": "17.25",
   "market_cap": "$1.29B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/bncl",
   "FIELD9": ""
 },
 {
   "symbol": "BNFT",
   "name": "Benefitfocus, Inc.",
   "last_sale": "40.4",
   "market_cap": "$1.29B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/bnft",
   "FIELD9": ""
 },
 {
   "symbol": "BNTC",
   "name": "Benitec Biopharma Limited",
   "last_sale": "2.3681",
   "market_cap": "$30.43M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bntc",
   "FIELD9": ""
 },
 {
   "symbol": "BNTCW",
   "name": "Benitec Biopharma Limited",
   "last_sale": "0.4497",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bntcw",
   "FIELD9": ""
 },
 {
   "symbol": "BRY",
   "name": "Berry Petroleum Corporation",
   "last_sale": "16",
   "market_cap": "$1.3B",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/bry",
   "FIELD9": ""
 },
 {
   "symbol": "BYSI",
   "name": "BeyondSpring, Inc.",
   "last_sale": "25",
   "market_cap": "$560.89M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bysi",
   "FIELD9": ""
 },
 {
   "symbol": "BGCP",
   "name": "BGC Partners, Inc.",
   "last_sale": "11.65",
   "market_cap": "$3.81B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/bgcp",
   "FIELD9": ""
 },
 {
   "symbol": "BGFV",
   "name": "Big 5 Sporting Goods Corporation",
   "last_sale": "5.075",
   "market_cap": "$108.76M",
   "IPOyear": "2002",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/bgfv",
   "FIELD9": ""
 },
 {
   "symbol": "BRPA",
   "name": "Big Rock Partners Acquisition Corp.",
   "last_sale": "9.98",
   "market_cap": "$26.17M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/brpa",
   "FIELD9": ""
 },
 {
   "symbol": "BRPAR",
   "name": "Big Rock Partners Acquisition Corp.",
   "last_sale": "0.5",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/brpar",
   "FIELD9": ""
 },
 {
   "symbol": "BRPAU",
   "name": "Big Rock Partners Acquisition Corp.",
   "last_sale": "10.7",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/brpau",
   "FIELD9": ""
 },
 {
   "symbol": "BRPAW",
   "name": "Big Rock Partners Acquisition Corp.",
   "last_sale": "0.45",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/brpaw",
   "FIELD9": ""
 },
 {
   "symbol": "BILI",
   "name": "Bilibili Inc.",
   "last_sale": "12.5",
   "market_cap": "$2.41B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bili",
   "FIELD9": ""
 },
 {
   "symbol": "BASI",
   "name": "Bioanalytical Systems, Inc.",
   "last_sale": "1.63",
   "market_cap": "$16.7M",
   "IPOyear": "1997",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/basi",
   "FIELD9": ""
 },
 {
   "symbol": "ORPN",
   "name": "Bioblast Pharma Ltd.",
   "last_sale": "1.25",
   "market_cap": "$4.18M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/orpn",
   "FIELD9": ""
 },
 {
   "symbol": "BIOC",
   "name": "Biocept, Inc.",
   "last_sale": "2.94",
   "market_cap": "$6.71M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/bioc",
   "FIELD9": ""
 },
 {
   "symbol": "BCRX",
   "name": "BioCryst Pharmaceuticals, Inc.",
   "last_sale": "7.28",
   "market_cap": "$796.3M",
   "IPOyear": "1994",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/bcrx",
   "FIELD9": ""
 },
 {
   "symbol": "BDSI",
   "name": "BioDelivery Sciences International, Inc.",
   "last_sale": "2.85",
   "market_cap": "$169.74M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bdsi",
   "FIELD9": ""
 },
 {
   "symbol": "BFRA",
   "name": "Biofrontera AG",
   "last_sale": "13.9",
   "market_cap": "$309.32M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bfra",
   "FIELD9": ""
 },
 {
   "symbol": "BIIB",
   "name": "Biogen Inc.",
   "last_sale": "345.41",
   "market_cap": "$69.58B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/biib",
   "FIELD9": ""
 },
 {
   "symbol": "BHTG",
   "name": "BioHiTech Global, Inc.",
   "last_sale": "4.4",
   "market_cap": "$64.03M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bhtg",
   "FIELD9": ""
 },
 {
   "symbol": "BKYI",
   "name": "BIO-key International, Inc.",
   "last_sale": "1.425",
   "market_cap": "$17.94M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/bkyi",
   "FIELD9": ""
 },
 {
   "symbol": "BIOL",
   "name": "Biolase, Inc.",
   "last_sale": "2.17",
   "market_cap": "$44.7M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/biol",
   "FIELD9": ""
 },
 {
   "symbol": "BLFS",
   "name": "BioLife Solutions, Inc.",
   "last_sale": "17.25",
   "market_cap": "$308.61M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/blfs",
   "FIELD9": ""
 },
 {
   "symbol": "BLRX",
   "name": "BioLineRx Ltd.",
   "last_sale": "0.98",
   "market_cap": "$105.92M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/blrx",
   "FIELD9": ""
 },
 {
   "symbol": "BMRN",
   "name": "BioMarin Pharmaceutical Inc.",
   "last_sale": "97.84",
   "market_cap": "$17.38B",
   "IPOyear": "1999",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bmrn",
   "FIELD9": ""
 },
 {
   "symbol": "BMRA",
   "name": "Biomerica, Inc.",
   "last_sale": "3.5",
   "market_cap": "$30.28M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/bmra",
   "FIELD9": ""
 },
 {
   "symbol": "BNGO",
   "name": "Bionano Genomics, Inc.",
   "last_sale": "6.99",
   "market_cap": "$66.35M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/bngo",
   "FIELD9": ""
 },
 {
   "symbol": "BNGOW",
   "name": "Bionano Genomics, Inc.",
   "last_sale": "2.62",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bngow",
   "FIELD9": ""
 },
 {
   "symbol": "BVXV",
   "name": "BiondVax Pharmaceuticals Ltd.",
   "last_sale": "5.74",
   "market_cap": "$37.51M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/bvxv",
   "FIELD9": ""
 },
 {
   "symbol": "BVXVW",
   "name": "BiondVax Pharmaceuticals Ltd.",
   "last_sale": "1.25",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/bvxvw",
   "FIELD9": ""
 },
 {
   "symbol": "BPTH",
   "name": "Bio-Path Holdings, Inc.",
   "last_sale": "0.6195",
   "market_cap": "$7.03M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bpth",
   "FIELD9": ""
 },
 {
   "symbol": "BIOS",
   "name": "BioScrip, Inc.",
   "last_sale": "3.09",
   "market_cap": "$395.66M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bios",
   "FIELD9": ""
 },
 {
   "symbol": "BSGM",
   "name": "BioSig Technologies, Inc.",
   "last_sale": "6.68",
   "market_cap": "$99.79M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bsgm",
   "FIELD9": ""
 },
 {
   "symbol": "BSTC",
   "name": "BioSpecifics Technologies Corp",
   "last_sale": "58.4",
   "market_cap": "$426.02M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bstc",
   "FIELD9": ""
 },
 {
   "symbol": "TECH",
   "name": "Bio-Techne Corp",
   "last_sale": "195.92",
   "market_cap": "$7.4B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/tech",
   "FIELD9": ""
 },
 {
   "symbol": "BEAT",
   "name": "BioTelemetry, Inc.",
   "last_sale": "60.65",
   "market_cap": "$1.98B",
   "IPOyear": "2008",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/beat",
   "FIELD9": ""
 },
 {
   "symbol": "BTAI",
   "name": "BioXcel Therapeutics, Inc.",
   "last_sale": "7.5",
   "market_cap": "$117.34M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/btai",
   "FIELD9": ""
 },
 {
   "symbol": "BCAC",
   "name": "Bison Capital Acquisition Corp.",
   "last_sale": "10.25",
   "market_cap": "$24.93M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bcac",
   "FIELD9": ""
 },
 {
   "symbol": "BCACR",
   "name": "Bison Capital Acquisition Corp.",
   "last_sale": "0.5832",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bcacr",
   "FIELD9": ""
 },
 {
   "symbol": "BCACU",
   "name": "Bison Capital Acquisition Corp.",
   "last_sale": "10.832",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bcacu",
   "FIELD9": ""
 },
 {
   "symbol": "BCACW",
   "name": "Bison Capital Acquisition Corp.",
   "last_sale": "0.52",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bcacw",
   "FIELD9": ""
 },
 {
   "symbol": "BJRI",
   "name": "BJ&#39;s Restaurants, Inc.",
   "last_sale": "69.5",
   "market_cap": "$1.46B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/bjri",
   "FIELD9": ""
 },
 {
   "symbol": "BBOX",
   "name": "Black Box Corporation",
   "last_sale": "1.02",
   "market_cap": "$15.54M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/bbox",
   "FIELD9": ""
 },
 {
   "symbol": "BRAC",
   "name": "Black Ridge Acquisition Corp.",
   "last_sale": "9.85",
   "market_cap": "$43M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/brac",
   "FIELD9": ""
 },
 {
   "symbol": "BRACR",
   "name": "Black Ridge Acquisition Corp.",
   "last_sale": "0.37",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bracr",
   "FIELD9": ""
 },
 {
   "symbol": "BRACU",
   "name": "Black Ridge Acquisition Corp.",
   "last_sale": "11.155",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bracu",
   "FIELD9": ""
 },
 {
   "symbol": "BRACW",
   "name": "Black Ridge Acquisition Corp.",
   "last_sale": "0.45",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bracw",
   "FIELD9": ""
 },
 {
   "symbol": "BLKB",
   "name": "Blackbaud, Inc.",
   "last_sale": "101.02",
   "market_cap": "$4.91B",
   "IPOyear": "2004",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/blkb",
   "FIELD9": ""
 },
 {
   "symbol": "BL",
   "name": "BlackLine, Inc.",
   "last_sale": "55.4",
   "market_cap": "$2.99B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/bl",
   "FIELD9": ""
 },
 {
   "symbol": "BKCC",
   "name": "BlackRock Capital Investment Corporation",
   "last_sale": "6.03",
   "market_cap": "$428.23M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bkcc",
   "FIELD9": ""
 },
 {
   "symbol": "TCPC",
   "name": "BlackRock TCP Capital Corp.",
   "last_sale": "14.37",
   "market_cap": "$845.05M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tcpc",
   "FIELD9": ""
 },
 {
   "symbol": "BLNK",
   "name": "Blink Charging Co.",
   "last_sale": "2.51",
   "market_cap": "$61.94M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/blnk",
   "FIELD9": ""
 },
 {
   "symbol": "BLNKW",
   "name": "Blink Charging Co.",
   "last_sale": "0.8601",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/blnkw",
   "FIELD9": ""
 },
 {
   "symbol": "BLMN",
   "name": "Bloomin&#39; Brands, Inc.",
   "last_sale": "20.13",
   "market_cap": "$1.86B",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/blmn",
   "FIELD9": ""
 },
 {
   "symbol": "BCOR",
   "name": "Blucora, Inc.",
   "last_sale": "35.75",
   "market_cap": "$1.7B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bcor",
   "FIELD9": ""
 },
 {
   "symbol": "BLBD",
   "name": "Blue Bird Corporation",
   "last_sale": "25.35",
   "market_cap": "$687.27M",
   "IPOyear": "2014",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/blbd",
   "FIELD9": ""
 },
 {
   "symbol": "BHBK",
   "name": "Blue Hills Bancorp, Inc.",
   "last_sale": "25.25",
   "market_cap": "$679.26M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bhbk",
   "FIELD9": ""
 },
 {
   "symbol": "BLUE",
   "name": "bluebird bio, Inc.",
   "last_sale": "140.35",
   "market_cap": "$7.6B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/blue",
   "FIELD9": ""
 },
 {
   "symbol": "BKEP",
   "name": "Blueknight Energy Partners L.P., L.L.C.",
   "last_sale": "2.4",
   "market_cap": "$96.93M",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/bkep",
   "FIELD9": ""
 },
 {
   "symbol": "BKEPP",
   "name": "Blueknight Energy Partners L.P., L.L.C.",
   "last_sale": "6.45",
   "market_cap": "$194.52M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/bkepp",
   "FIELD9": ""
 },
 {
   "symbol": "BPMC",
   "name": "Blueprint Medicines Corporation",
   "last_sale": "69.54",
   "market_cap": "$3.05B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bpmc",
   "FIELD9": ""
 },
 {
   "symbol": "ITEQ",
   "name": "BlueStar Israel Technology ETF",
   "last_sale": "36.339",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iteq",
   "FIELD9": ""
 },
 {
   "symbol": "BMCH",
   "name": "BMC Stock Holdings, Inc.",
   "last_sale": "20.85",
   "market_cap": "$1.4B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/bmch",
   "FIELD9": ""
 },
 {
   "symbol": "WIFI",
   "name": "Boingo Wireless, Inc.",
   "last_sale": "32.42",
   "market_cap": "$1.37B",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/wifi",
   "FIELD9": ""
 },
 {
   "symbol": "BOJA",
   "name": "Bojangles&#39;, Inc.",
   "last_sale": "13.2",
   "market_cap": "$486.79M",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/boja",
   "FIELD9": ""
 },
 {
   "symbol": "BOKF",
   "name": "BOK Financial Corporation",
   "last_sale": "104.75",
   "market_cap": "$6.85B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bokf",
   "FIELD9": ""
 },
 {
   "symbol": "BOKFL",
   "name": "BOK Financial Corporation",
   "last_sale": "24.7",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bokfl",
   "FIELD9": ""
 },
 {
   "symbol": "BNSO",
   "name": "Bonso Electronics International, Inc.",
   "last_sale": "2.9351",
   "market_cap": "$13.83M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/bnso",
   "FIELD9": ""
 },
 {
   "symbol": "BKNG",
   "name": "Booking Holdings Inc.",
   "last_sale": "1958.01",
   "market_cap": "$92.95B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bkng",
   "FIELD9": ""
 },
 {
   "symbol": "BRQS",
   "name": "Borqs Technologies, Inc. ",
   "last_sale": "4.6",
   "market_cap": "$144M",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/brqs",
   "FIELD9": ""
 },
 {
   "symbol": "BOMN",
   "name": "Boston Omaha Corporation",
   "last_sale": "28.28",
   "market_cap": "$623.96M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/bomn",
   "FIELD9": ""
 },
 {
   "symbol": "BPFH",
   "name": "Boston Private Financial Holdings, Inc.",
   "last_sale": "14.325",
   "market_cap": "$1.21B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bpfh",
   "FIELD9": ""
 },
 {
   "symbol": "BPFHW",
   "name": "Boston Private Financial Holdings, Inc.",
   "last_sale": "8.46",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bpfhw",
   "FIELD9": ""
 },
 {
   "symbol": "EPAY",
   "name": "Bottomline Technologies, Inc.",
   "last_sale": "70.59",
   "market_cap": "$2.99B",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/epay",
   "FIELD9": ""
 },
 {
   "symbol": "BOXL",
   "name": "Boxlight Corporation",
   "last_sale": "3.05",
   "market_cap": "$30.67M",
   "IPOyear": "2017",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/boxl",
   "FIELD9": ""
 },
 {
   "symbol": "BBRX",
   "name": "Braeburn Pharmaceuticals, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbrx",
   "FIELD9": ""
 },
 {
   "symbol": "BCLI",
   "name": "Brainstorm Cell Therapeutics Inc.",
   "last_sale": "3.93",
   "market_cap": "$81.23M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/bcli",
   "FIELD9": ""
 },
 {
   "symbol": "BVNSC",
   "name": "Brandes Investment Trust",
   "last_sale": "99.99",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bvnsc",
   "FIELD9": ""
 },
 {
   "symbol": "BDGE",
   "name": "Bridge Bancorp, Inc.",
   "last_sale": "34.9",
   "market_cap": "$690.51M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bdge",
   "FIELD9": ""
 },
 {
   "symbol": "BLIN          ",
   "name": "Bridgeline Digital, Inc.",
   "last_sale": "0.99",
   "market_cap": "$4.2M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/blin",
   "FIELD9": ""
 },
 {
   "symbol": "BWB",
   "name": "Bridgewater Bancshares, Inc.",
   "last_sale": "13.5",
   "market_cap": "$405.92M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bwb",
   "FIELD9": ""
 },
 {
   "symbol": "BRID",
   "name": "Bridgford Foods Corporation",
   "last_sale": "16.9",
   "market_cap": "$153.4M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Specialty Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/brid",
   "FIELD9": ""
 },
 {
   "symbol": "BCOV",
   "name": "Brightcove Inc.",
   "last_sale": "8.2",
   "market_cap": "$294.53M",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bcov",
   "FIELD9": ""
 },
 {
   "symbol": "BHF",
   "name": "Brighthouse Financial, Inc.",
   "last_sale": "46.44",
   "market_cap": "$5.56B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/bhf",
   "FIELD9": ""
 },
 {
   "symbol": "BHFAL",
   "name": "Brighthouse Financial, Inc.",
   "last_sale": "25.04",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/bhfal",
   "FIELD9": ""
 },
 {
   "symbol": "AVGO",
   "name": "Broadcom Inc.",
   "last_sale": "248.76",
   "market_cap": "$102.85B",
   "IPOyear": "2009",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/avgo",
   "FIELD9": ""
 },
 {
   "symbol": "BVSN",
   "name": "BroadVision, Inc.",
   "last_sale": "1.6",
   "market_cap": "$8M",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/bvsn",
   "FIELD9": ""
 },
 {
   "symbol": "BYFC",
   "name": "Broadway Financial Corporation",
   "last_sale": "1.54",
   "market_cap": "$42.22M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/byfc",
   "FIELD9": ""
 },
 {
   "symbol": "BWEN",
   "name": "Broadwind Energy, Inc.",
   "last_sale": "2.29",
   "market_cap": "$35.43M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/bwen",
   "FIELD9": ""
 },
 {
   "symbol": "BPY",
   "name": "Brookfield Property Partners L.P.",
   "last_sale": "20.93",
   "market_cap": "$7.78B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/bpy",
   "FIELD9": ""
 },
 {
   "symbol": "BPR",
   "name": "Brookfield Property REIT Inc.",
   "last_sale": "20.85",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/bpr",
   "FIELD9": ""
 },
 {
   "symbol": "BPRAP",
   "name": "Brookfield Property REIT Inc.",
   "last_sale": "24.22",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/bprap",
   "FIELD9": ""
 },
 {
   "symbol": "BRKL",
   "name": "Brookline Bancorp, Inc.",
   "last_sale": "17.65",
   "market_cap": "$1.42B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/brkl",
   "FIELD9": ""
 },
 {
   "symbol": "BRKS",
   "name": "Brooks Automation, Inc.",
   "last_sale": "34.22",
   "market_cap": "$2.42B",
   "IPOyear": "1995",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/brks",
   "FIELD9": ""
 },
 {
   "symbol": "DOOO",
   "name": "BRP Inc.",
   "last_sale": "46.75",
   "market_cap": "$1.6B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/dooo",
   "FIELD9": ""
 },
 {
   "symbol": "BRKR",
   "name": "Bruker Corporation",
   "last_sale": "32.87",
   "market_cap": "$5.14B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/brkr",
   "FIELD9": ""
 },
 {
   "symbol": "BMTC",
   "name": "Bryn Mawr Bank Corporation",
   "last_sale": "47.95",
   "market_cap": "$970.77M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bmtc",
   "FIELD9": ""
 },
 {
   "symbol": "BLMT",
   "name": "BSB Bancorp, Inc.",
   "last_sale": "32.95",
   "market_cap": "$321.32M",
   "IPOyear": "2011",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/blmt",
   "FIELD9": ""
 },
 {
   "symbol": "BSQR",
   "name": "BSQUARE Corporation",
   "last_sale": "2.35",
   "market_cap": "$29.88M",
   "IPOyear": "1999",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bsqr",
   "FIELD9": ""
 },
 {
   "symbol": "BLDR",
   "name": "Builders FirstSource, Inc.",
   "last_sale": "15.68",
   "market_cap": "$1.8B",
   "IPOyear": "2005",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/bldr",
   "FIELD9": ""
 },
 {
   "symbol": "BFST",
   "name": "Business First Bancshares, Inc.",
   "last_sale": "26.46",
   "market_cap": "$305.17M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bfst",
   "FIELD9": ""
 },
 {
   "symbol": "CFFI",
   "name": "C&F Financial Corporation",
   "last_sale": "58.7",
   "market_cap": "$205.64M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cffi",
   "FIELD9": ""
 },
 {
   "symbol": "CHRW",
   "name": "C.H. Robinson Worldwide, Inc.",
   "last_sale": "97.56",
   "market_cap": "$13.52B",
   "IPOyear": "1997",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/chrw",
   "FIELD9": ""
 },
 {
   "symbol": "CA",
   "name": "CA Inc.",
   "last_sale": "44.09",
   "market_cap": "$18.44B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ca",
   "FIELD9": ""
 },
 {
   "symbol": "CCMP",
   "name": "Cabot Microelectronics Corporation",
   "last_sale": "104.26",
   "market_cap": "$2.66B",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/ccmp",
   "FIELD9": ""
 },
 {
   "symbol": "CDNS",
   "name": "Cadence Design Systems, Inc.",
   "last_sale": "45.53",
   "market_cap": "$12.88B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/cdns",
   "FIELD9": ""
 },
 {
   "symbol": "CDZI",
   "name": "Cadiz, Inc.",
   "last_sale": "11.3",
   "market_cap": "$276.29M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/cdzi",
   "FIELD9": ""
 },
 {
   "symbol": "CZR",
   "name": "Caesars Entertainment Corporation",
   "last_sale": "10.8",
   "market_cap": "$7.21B",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/czr",
   "FIELD9": ""
 },
 {
   "symbol": "CSTE",
   "name": "Caesarstone Ltd.",
   "last_sale": "21.3",
   "market_cap": "$731.63M",
   "IPOyear": "2012",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/cste",
   "FIELD9": ""
 },
 {
   "symbol": "PRSS",
   "name": "CafePress Inc.",
   "last_sale": "1.19",
   "market_cap": "$20.36M",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/prss",
   "FIELD9": ""
 },
 {
   "symbol": "CLBS",
   "name": "Caladrius Biosciences, Inc.",
   "last_sale": "5.95",
   "market_cap": "$57.87M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/clbs",
   "FIELD9": ""
 },
 {
   "symbol": "CHY",
   "name": "Calamos Convertible and High Income Fund",
   "last_sale": "13.2",
   "market_cap": "$963.71M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/chy",
   "FIELD9": ""
 },
 {
   "symbol": "CHI",
   "name": "Calamos Convertible Opportunities and Income Fund",
   "last_sale": "12.1",
   "market_cap": "$856.15M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/chi",
   "FIELD9": ""
 },
 {
   "symbol": "CCD",
   "name": "Calamos Dynamic Convertible & Income Fund",
   "last_sale": "21.91",
   "market_cap": "$534.27M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ccd",
   "FIELD9": ""
 },
 {
   "symbol": "CHW",
   "name": "Calamos Global Dynamic Income Fund",
   "last_sale": "9.2",
   "market_cap": "$543.22M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/chw",
   "FIELD9": ""
 },
 {
   "symbol": "CGO",
   "name": "Calamos Global Total Return Fund",
   "last_sale": "14.27",
   "market_cap": "$121.15M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cgo",
   "FIELD9": ""
 },
 {
   "symbol": "CSQ",
   "name": "Calamos Strategic Total Return Fund",
   "last_sale": "13.48",
   "market_cap": "$2.08B",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/csq",
   "FIELD9": ""
 },
 {
   "symbol": "CAMP",
   "name": "CalAmp Corp.",
   "last_sale": "22.63",
   "market_cap": "$798.42M",
   "IPOyear": "1983",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/camp",
   "FIELD9": ""
 },
 {
   "symbol": "CVGW",
   "name": "Calavo Growers, Inc.",
   "last_sale": "100.625",
   "market_cap": "$1.77B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/cvgw",
   "FIELD9": ""
 },
 {
   "symbol": "CALA",
   "name": "Calithera Biosciences, Inc.",
   "last_sale": "5",
   "market_cap": "$179.94M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cala",
   "FIELD9": ""
 },
 {
   "symbol": "CALM",
   "name": "Cal-Maine Foods, Inc.",
   "last_sale": "49.55",
   "market_cap": "$2.41B",
   "IPOyear": "1996",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/calm",
   "FIELD9": ""
 },
 {
   "symbol": "CLMT",
   "name": "Calumet Specialty Products Partners, L.P.",
   "last_sale": "6.55",
   "market_cap": "$505M",
   "IPOyear": "2006",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/clmt",
   "FIELD9": ""
 },
 {
   "symbol": "CRUSC",
   "name": "Calvert Management Series",
   "last_sale": "100.02",
   "market_cap": "$100.02M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/crusc",
   "FIELD9": ""
 },
 {
   "symbol": "CLXT",
   "name": "Calyxt, Inc.",
   "last_sale": "16.48",
   "market_cap": "$533.07M",
   "IPOyear": "2017",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/clxt",
   "FIELD9": ""
 },
 {
   "symbol": "ABCD",
   "name": "Cambium Learning Group, Inc.",
   "last_sale": "12.05",
   "market_cap": "$569.45M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Publishing",
   "summary_quote": "https://www.nasdaq.com/symbol/abcd",
   "FIELD9": ""
 },
 {
   "symbol": "CATC",
   "name": "Cambridge Bancorp",
   "last_sale": "87.04",
   "market_cap": "$357.24M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/catc",
   "FIELD9": ""
 },
 {
   "symbol": "CAC",
   "name": "Camden National Corporation",
   "last_sale": "44.415",
   "market_cap": "$691.82M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cac",
   "FIELD9": ""
 },
 {
   "symbol": "CAMT",
   "name": "Camtek Ltd.",
   "last_sale": "8.13",
   "market_cap": "$294.28M",
   "IPOyear": "2000",
   "sector": "Capital Goods",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/camt",
   "FIELD9": ""
 },
 {
   "symbol": "CSIQ",
   "name": "Canadian Solar Inc.",
   "last_sale": "14.705",
   "market_cap": "$861.44M",
   "IPOyear": "2006",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/csiq",
   "FIELD9": ""
 },
 {
   "symbol": "CGIX",
   "name": "Cancer Genetics, Inc.",
   "last_sale": "1.23",
   "market_cap": "$34.13M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/cgix",
   "FIELD9": ""
 },
 {
   "symbol": "CPHC",
   "name": "Canterbury Park Holding Corporation",
   "last_sale": "15.5",
   "market_cap": "$69.69M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/cphc",
   "FIELD9": ""
 },
 {
   "symbol": "CCBG",
   "name": "Capital City Bank Group",
   "last_sale": "24.08",
   "market_cap": "$410.7M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ccbg",
   "FIELD9": ""
 },
 {
   "symbol": "CPLP",
   "name": "Capital Product Partners L.P.",
   "last_sale": "2.77",
   "market_cap": "$352.47M",
   "IPOyear": "2007",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/cplp",
   "FIELD9": ""
 },
 {
   "symbol": "CSWC",
   "name": "Capital Southwest Corporation",
   "last_sale": "19.17",
   "market_cap": "$312.34M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Textiles",
   "summary_quote": "https://www.nasdaq.com/symbol/cswc",
   "FIELD9": ""
 },
 {
   "symbol": "CSWCL",
   "name": "Capital Southwest Corporation",
   "last_sale": "25.45",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Textiles",
   "summary_quote": "https://www.nasdaq.com/symbol/cswcl",
   "FIELD9": ""
 },
 {
   "symbol": "CPTA",
   "name": "Capitala Finance Corp.",
   "last_sale": "8.81",
   "market_cap": "$140.97M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cpta",
   "FIELD9": ""
 },
 {
   "symbol": "CPTAG",
   "name": "Capitala Finance Corp.",
   "last_sale": "24.61",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cptag",
   "FIELD9": ""
 },
 {
   "symbol": "CPTAL",
   "name": "Capitala Finance Corp.",
   "last_sale": "24.95",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cptal",
   "FIELD9": ""
 },
 {
   "symbol": "CFFN",
   "name": "Capitol Federal Financial, Inc.",
   "last_sale": "12.96",
   "market_cap": "$1.79B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/cffn",
   "FIELD9": ""
 },
 {
   "symbol": "CAPR",
   "name": "Capricor Therapeutics, Inc.",
   "last_sale": "1.08",
   "market_cap": "$33.21M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/capr",
   "FIELD9": ""
 },
 {
   "symbol": "CSTR",
   "name": "CapStar Financial Holdings, Inc.",
   "last_sale": "17.46",
   "market_cap": "$209.23M",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cstr",
   "FIELD9": ""
 },
 {
   "symbol": "CPST",
   "name": "Capstone Turbine Corporation",
   "last_sale": "0.947",
   "market_cap": "$60.79M",
   "IPOyear": "2000",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cpst",
   "FIELD9": ""
 },
 {
   "symbol": "CARA",
   "name": "Cara Therapeutics, Inc.",
   "last_sale": "23.18",
   "market_cap": "$910.75M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cara",
   "FIELD9": ""
 },
 {
   "symbol": "CBLK",
   "name": "Carbon Black, Inc.",
   "last_sale": "23.42",
   "market_cap": "$1.59B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/cblk",
   "FIELD9": ""
 },
 {
   "symbol": "CARB",
   "name": "Carbonite, Inc.",
   "last_sale": "36.95",
   "market_cap": "$1.24B",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/carb",
   "FIELD9": ""
 },
 {
   "symbol": "CSII",
   "name": "Cardiovascular Systems, Inc.",
   "last_sale": "36.77",
   "market_cap": "$1.23B",
   "IPOyear": "1981",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/csii",
   "FIELD9": ""
 },
 {
   "symbol": "CDLX",
   "name": "Cardlytics, Inc.",
   "last_sale": "25.29",
   "market_cap": "$538.6M",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/cdlx",
   "FIELD9": ""
 },
 {
   "symbol": "CATM",
   "name": "Cardtronics plc",
   "last_sale": "31.92",
   "market_cap": "$1.47B",
   "IPOyear": "2007",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/catm",
   "FIELD9": ""
 },
 {
   "symbol": "CDNA",
   "name": "CareDx, Inc.",
   "last_sale": "25.95",
   "market_cap": "$943.18M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/cdna",
   "FIELD9": ""
 },
 {
   "symbol": "CECO",
   "name": "Career Education Corporation",
   "last_sale": "14.68",
   "market_cap": "$1.02B",
   "IPOyear": "1998",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ceco",
   "FIELD9": ""
 },
 {
   "symbol": "CTRE",
   "name": "CareTrust REIT, Inc.",
   "last_sale": "17.92",
   "market_cap": "$1.45B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ctre",
   "FIELD9": ""
 },
 {
   "symbol": "CARG",
   "name": "CarGurus, Inc.",
   "last_sale": "51.62",
   "market_cap": "$5.65B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/carg",
   "FIELD9": ""
 },
 {
   "symbol": "CARO",
   "name": "Carolina Financial Corporation",
   "last_sale": "39.73",
   "market_cap": "$898.35M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/caro",
   "FIELD9": ""
 },
 {
   "symbol": "CART",
   "name": "Carolina Trust BancShares, Inc.",
   "last_sale": "8.27",
   "market_cap": "$59.19M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cart",
   "FIELD9": ""
 },
 {
   "symbol": "CRZO",
   "name": "Carrizo Oil & Gas, Inc.",
   "last_sale": "25.63",
   "market_cap": "$2.1B",
   "IPOyear": "1997",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/crzo",
   "FIELD9": ""
 },
 {
   "symbol": "TAST",
   "name": "Carrols Restaurant Group, Inc.",
   "last_sale": "14.1",
   "market_cap": "$515.2M",
   "IPOyear": "2006",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/tast",
   "FIELD9": ""
 },
 {
   "symbol": "CARV",
   "name": "Carver Bancorp, Inc.",
   "last_sale": "4.86",
   "market_cap": "$17.15M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/carv",
   "FIELD9": ""
 },
 {
   "symbol": "CASM",
   "name": "CAS Medical Systems, Inc.",
   "last_sale": "1.9702",
   "market_cap": "$56.65M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/casm",
   "FIELD9": ""
 },
 {
   "symbol": "CASA",
   "name": "Casa Systems, Inc.",
   "last_sale": "16.21",
   "market_cap": "$1.4B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/casa",
   "FIELD9": ""
 },
 {
   "symbol": "CWST",
   "name": "Casella Waste Systems, Inc.",
   "last_sale": "31.58",
   "market_cap": "$1.35B",
   "IPOyear": "1997",
   "sector": "Public Utilities",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cwst",
   "FIELD9": ""
 },
 {
   "symbol": "CASY",
   "name": "Caseys General Stores, Inc.",
   "last_sale": "128.79",
   "market_cap": "$4.71B",
   "IPOyear": "1983",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/casy",
   "FIELD9": ""
 },
 {
   "symbol": "CASI",
   "name": "CASI Pharmaceuticals, Inc.",
   "last_sale": "5.7",
   "market_cap": "$493.57M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/casi",
   "FIELD9": ""
 },
 {
   "symbol": "CASS",
   "name": "Cass Information Systems, Inc",
   "last_sale": "66.11",
   "market_cap": "$812.78M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cass",
   "FIELD9": ""
 },
 {
   "symbol": "CATB",
   "name": "Catabasis Pharmaceuticals, Inc.",
   "last_sale": "0.844",
   "market_cap": "$59.96M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/catb",
   "FIELD9": ""
 },
 {
   "symbol": "CBIO",
   "name": "Catalyst Biosciences, Inc. ",
   "last_sale": "10.17",
   "market_cap": "$121.46M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cbio",
   "FIELD9": ""
 },
 {
   "symbol": "CPRX",
   "name": "Catalyst Pharmaceuticals, Inc.",
   "last_sale": "3.15",
   "market_cap": "$323.19M",
   "IPOyear": "2006",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cprx",
   "FIELD9": ""
 },
 {
   "symbol": "CATS",
   "name": "Catasys, Inc.",
   "last_sale": "11.68",
   "market_cap": "$185.87M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/cats",
   "FIELD9": ""
 },
 {
   "symbol": "CATY",
   "name": "Cathay General Bancorp",
   "last_sale": "42.96",
   "market_cap": "$3.49B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/caty",
   "FIELD9": ""
 },
 {
   "symbol": "CATYW",
   "name": "Cathay General Bancorp",
   "last_sale": "22.37",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/catyw",
   "FIELD9": ""
 },
 {
   "symbol": "CGVIC",
   "name": "Causeway ETMF Trust",
   "last_sale": "100.1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cgvic",
   "FIELD9": ""
 },
 {
   "symbol": "CIVEC",
   "name": "Causeway ETMF Trust",
   "last_sale": "100.12",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/civec",
   "FIELD9": ""
 },
 {
   "symbol": "CVCO",
   "name": "Cavco Industries, Inc.",
   "last_sale": "247.65",
   "market_cap": "$2.25B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/cvco",
   "FIELD9": ""
 },
 {
   "symbol": "CBFV",
   "name": "CB Financial Services, Inc.",
   "last_sale": "30.5",
   "market_cap": "$165.14M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cbfv",
   "FIELD9": ""
 },
 {
   "symbol": "CBAK",
   "name": "CBAK Energy Technology, Inc.",
   "last_sale": "0.67",
   "market_cap": "$17.85M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cbak",
   "FIELD9": ""
 },
 {
   "symbol": "CBOE",
   "name": "Cboe Global Markets, Inc.",
   "last_sale": "107.15",
   "market_cap": "$11.98B",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cboe",
   "FIELD9": ""
 },
 {
   "symbol": "CBTX",
   "name": "CBTX, Inc.",
   "last_sale": "37.2",
   "market_cap": "$965.81M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cbtx",
   "FIELD9": ""
 },
 {
   "symbol": "CDK",
   "name": "CDK Global, Inc.",
   "last_sale": "63.16",
   "market_cap": "$8.18B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cdk",
   "FIELD9": ""
 },
 {
   "symbol": "CDTI",
   "name": "CDTI Advanced Materials, Inc.",
   "last_sale": "0.34",
   "market_cap": "$6.92M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Pollution Control Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/cdti",
   "FIELD9": ""
 },
 {
   "symbol": "CDW",
   "name": "CDW Corporation",
   "last_sale": "89.08",
   "market_cap": "$13.48B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/cdw",
   "FIELD9": ""
 },
 {
   "symbol": "CECE",
   "name": "CECO Environmental Corp.",
   "last_sale": "8.1",
   "market_cap": "$282.78M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Pollution Control Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/cece",
   "FIELD9": ""
 },
 {
   "symbol": "CELC",
   "name": "Celcuity Inc.",
   "last_sale": "29.51",
   "market_cap": "$298.62M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/celc",
   "FIELD9": ""
 },
 {
   "symbol": "CELG",
   "name": "Celgene Corporation",
   "last_sale": "87.72",
   "market_cap": "$61.7B",
   "IPOyear": "1987",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/celg",
   "FIELD9": ""
 },
 {
   "symbol": "CELGZ",
   "name": "Celgene Corporation",
   "last_sale": "1.57",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/celgz",
   "FIELD9": ""
 },
 {
   "symbol": "CLDX",
   "name": "Celldex Therapeutics, Inc.",
   "last_sale": "0.425",
   "market_cap": "$69.04M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/cldx",
   "FIELD9": ""
 },
 {
   "symbol": "APOP",
   "name": "Cellect Biotechnology Ltd.",
   "last_sale": "4.8503",
   "market_cap": "$31.57M",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/apop",
   "FIELD9": ""
 },
 {
   "symbol": "APOPW",
   "name": "Cellect Biotechnology Ltd.",
   "last_sale": "2.05",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/apopw",
   "FIELD9": ""
 },
 {
   "symbol": "CLRB",
   "name": "Cellectar Biosciences, Inc.",
   "last_sale": "2.67",
   "market_cap": "$10.14M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/clrb",
   "FIELD9": ""
 },
 {
   "symbol": "CLRBW",
   "name": "Cellectar Biosciences, Inc.",
   "last_sale": "0.1893",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/clrbw",
   "FIELD9": ""
 },
 {
   "symbol": "CLRBZ",
   "name": "Cellectar Biosciences, Inc.",
   "last_sale": "0.09",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/clrbz",
   "FIELD9": ""
 },
 {
   "symbol": "CLLS",
   "name": "Cellectis S.A.",
   "last_sale": "28.97",
   "market_cap": "$1.23B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/clls",
   "FIELD9": ""
 },
 {
   "symbol": "CBMG",
   "name": "Cellular Biomedicine Group, Inc.",
   "last_sale": "21.65",
   "market_cap": "$367.23M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/cbmg",
   "FIELD9": ""
 },
 {
   "symbol": "CLSN",
   "name": "Celsion Corporation",
   "last_sale": "2.79",
   "market_cap": "$49.51M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/clsn",
   "FIELD9": ""
 },
 {
   "symbol": "CELH",
   "name": "Celsius Holdings, Inc.",
   "last_sale": "4.15",
   "market_cap": "$212.16M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/celh",
   "FIELD9": ""
 },
 {
   "symbol": "CYAD",
   "name": "Celyad SA",
   "last_sale": "27.5127",
   "market_cap": "$328.57M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cyad",
   "FIELD9": ""
 },
 {
   "symbol": "CETX",
   "name": "Cemtrex Inc.",
   "last_sale": "1.48",
   "market_cap": "$19.08M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cetx",
   "FIELD9": ""
 },
 {
   "symbol": "CETXP",
   "name": "Cemtrex Inc.",
   "last_sale": "3.7988",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cetxp",
   "FIELD9": ""
 },
 {
   "symbol": "CETXW",
   "name": "Cemtrex Inc.",
   "last_sale": "0.1307",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cetxw",
   "FIELD9": ""
 },
 {
   "symbol": "CDEV",
   "name": "Centennial Resource Development, Inc.",
   "last_sale": "20.83",
   "market_cap": "$5.75B",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/cdev",
   "FIELD9": ""
 },
 {
   "symbol": "CSFL",
   "name": "CenterState Bank Corporation",
   "last_sale": "30.55",
   "market_cap": "$2.57B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/csfl",
   "FIELD9": ""
 },
 {
   "symbol": "CETV",
   "name": "Central European Media Enterprises Ltd.",
   "last_sale": "3.8",
   "market_cap": "$958.06M",
   "IPOyear": "1994",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/cetv",
   "FIELD9": ""
 },
 {
   "symbol": "CFBK",
   "name": "Central Federal Corporation",
   "last_sale": "14.75",
   "market_cap": "$62.71M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/cfbk",
   "FIELD9": ""
 },
 {
   "symbol": "CENT",
   "name": "Central Garden & Pet Company",
   "last_sale": "39.24",
   "market_cap": "$2.24B",
   "IPOyear": "1993",
   "sector": "Consumer Durables",
   "industry": "Consumer Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/cent",
   "FIELD9": ""
 },
 {
   "symbol": "CENTA",
   "name": "Central Garden & Pet Company",
   "last_sale": "35.99",
   "market_cap": "$2.06B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Consumer Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/centa",
   "FIELD9": ""
 },
 {
   "symbol": "CVCY",
   "name": "Central Valley Community Bancorp",
   "last_sale": "21.66",
   "market_cap": "$298.59M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cvcy",
   "FIELD9": ""
 },
 {
   "symbol": "CENX",
   "name": "Century Aluminum Company",
   "last_sale": "13.25",
   "market_cap": "$1.16B",
   "IPOyear": "1996",
   "sector": "Basic Industries",
   "industry": "Aluminum",
   "summary_quote": "https://www.nasdaq.com/symbol/cenx",
   "FIELD9": ""
 },
 {
   "symbol": "CNBKA",
   "name": "Century Bancorp, Inc.",
   "last_sale": "72.25",
   "market_cap": "$402.28M",
   "IPOyear": "1987",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cnbka",
   "FIELD9": ""
 },
 {
   "symbol": "CNTY",
   "name": "Century Casinos, Inc.",
   "last_sale": "7.55",
   "market_cap": "$221.96M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/cnty",
   "FIELD9": ""
 },
 {
   "symbol": "CRNT",
   "name": "Ceragon Networks Ltd.",
   "last_sale": "2.95",
   "market_cap": "$230.49M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/crnt",
   "FIELD9": ""
 },
 {
   "symbol": "CERC",
   "name": "Cerecor Inc.",
   "last_sale": "4.3",
   "market_cap": "$149.84M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cerc",
   "FIELD9": ""
 },
 {
   "symbol": "CERCW",
   "name": "Cerecor Inc.",
   "last_sale": "0.12",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cercw",
   "FIELD9": ""
 },
 {
   "symbol": "CERN",
   "name": "Cerner Corporation",
   "last_sale": "63.82",
   "market_cap": "$21B",
   "IPOyear": "1986",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cern",
   "FIELD9": ""
 },
 {
   "symbol": "CERS",
   "name": "Cerus Corporation",
   "last_sale": "7.36",
   "market_cap": "$984.87M",
   "IPOyear": "1997",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/cers",
   "FIELD9": ""
 },
 {
   "symbol": "KOOL",
   "name": "Cesca Therapeutics Inc.",
   "last_sale": "0.3926",
   "market_cap": "$8.11M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/kool",
   "FIELD9": ""
 },
 {
   "symbol": "CEVA",
   "name": "CEVA, Inc.",
   "last_sale": "29.1",
   "market_cap": "$641.11M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/ceva",
   "FIELD9": ""
 },
 {
   "symbol": "CSBR",
   "name": "Champions Oncology, Inc.",
   "last_sale": "13.23",
   "market_cap": "$147.71M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/csbr",
   "FIELD9": ""
 },
 {
   "symbol": "CYOU",
   "name": "Changyou.com Limited",
   "last_sale": "14.03",
   "market_cap": "$739.64M",
   "IPOyear": "2009",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/cyou",
   "FIELD9": ""
 },
 {
   "symbol": "BURG",
   "name": "Chanticleer Holdings, Inc.",
   "last_sale": "2.38",
   "market_cap": "$8.82M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/burg",
   "FIELD9": ""
 },
 {
   "symbol": "CTHR",
   "name": "Charles & Colvard Ltd.",
   "last_sale": "0.968",
   "market_cap": "$20.91M",
   "IPOyear": "1997",
   "sector": "Consumer Durables",
   "industry": "Consumer Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/cthr",
   "FIELD9": ""
 },
 {
   "symbol": "GTLS",
   "name": "Chart Industries, Inc.",
   "last_sale": "74.13",
   "market_cap": "$2.3B",
   "IPOyear": "2006",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/gtls",
   "FIELD9": ""
 },
 {
   "symbol": "CHTR",
   "name": "Charter Communications, Inc.",
   "last_sale": "332.59",
   "market_cap": "$77.12B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/chtr",
   "FIELD9": ""
 },
 {
   "symbol": "CHKP",
   "name": "Check Point Software Technologies Ltd.",
   "last_sale": "117.75",
   "market_cap": "$18.73B",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/chkp",
   "FIELD9": ""
 },
 {
   "symbol": "CHEK",
   "name": "Check-Cap Ltd.",
   "last_sale": "3.8",
   "market_cap": "$20.12M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical Electronics",
   "summary_quote": "https://www.nasdaq.com/symbol/chek",
   "FIELD9": ""
 },
 {
   "symbol": "CHEKW",
   "name": "Check-Cap Ltd.",
   "last_sale": "0.165",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical Electronics",
   "summary_quote": "https://www.nasdaq.com/symbol/chekw",
   "FIELD9": ""
 },
 {
   "symbol": "CHEKZ",
   "name": "Check-Cap Ltd.",
   "last_sale": "0.67",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Electronics",
   "summary_quote": "https://www.nasdaq.com/symbol/chekz",
   "FIELD9": ""
 },
 {
   "symbol": "CKPT",
   "name": "Checkpoint Therapeutics, Inc.",
   "last_sale": "4.7",
   "market_cap": "$150.91M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ckpt",
   "FIELD9": ""
 },
 {
   "symbol": "CEMI",
   "name": "Chembio Diagnostics, Inc.",
   "last_sale": "9.45",
   "market_cap": "$133.94M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cemi",
   "FIELD9": ""
 },
 {
   "symbol": "CHFC",
   "name": "Chemical Financial Corporation",
   "last_sale": "56.56",
   "market_cap": "$4.04B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/chfc",
   "FIELD9": ""
 },
 {
   "symbol": "CCXI",
   "name": "ChemoCentryx, Inc.",
   "last_sale": "12.91",
   "market_cap": "$650.39M",
   "IPOyear": "2012",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ccxi",
   "FIELD9": ""
 },
 {
   "symbol": "CHMG",
   "name": "Chemung Financial Corp",
   "last_sale": "43.97",
   "market_cap": "$211.23M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/chmg",
   "FIELD9": ""
 },
 {
   "symbol": "CHKE",
   "name": "Cherokee Inc.",
   "last_sale": "0.822",
   "market_cap": "$11.55M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/chke",
   "FIELD9": ""
 },
 {
   "symbol": "CHFS",
   "name": "CHF Solutions, Inc.",
   "last_sale": "1.2",
   "market_cap": "$8.49M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/chfs",
   "FIELD9": ""
 },
 {
   "symbol": "CHMA",
   "name": "Chiasma, Inc.",
   "last_sale": "3.25",
   "market_cap": "$79.26M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/chma",
   "FIELD9": ""
 },
 {
   "symbol": "CSSE",
   "name": "Chicken Soup for the Soul Entertainment, Inc.",
   "last_sale": "9.76",
   "market_cap": "$112.64M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Movies/Entertainment",
   "summary_quote": "https://www.nasdaq.com/symbol/csse",
   "FIELD9": ""
 },
 {
   "symbol": "CSSEP",
   "name": "Chicken Soup for the Soul Entertainment, Inc.",
   "last_sale": "25.31",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Movies/Entertainment",
   "summary_quote": "https://www.nasdaq.com/symbol/cssep",
   "FIELD9": ""
 },
 {
   "symbol": "PLCE",
   "name": "Children&#39;s Place, Inc. (The)",
   "last_sale": "124.75",
   "market_cap": "$2.05B",
   "IPOyear": "1997",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/plce",
   "FIELD9": ""
 },
 {
   "symbol": "CMRX",
   "name": "Chimerix, Inc.",
   "last_sale": "3.97",
   "market_cap": "$190.66M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cmrx",
   "FIELD9": ""
 },
 {
   "symbol": "CADC",
   "name": "China Advanced Construction Materials Group, Inc.",
   "last_sale": "3.95",
   "market_cap": "$18.84M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Engineering & Construction",
   "summary_quote": "https://www.nasdaq.com/symbol/cadc",
   "FIELD9": ""
 },
 {
   "symbol": "CAAS",
   "name": "China Automotive Systems, Inc.",
   "last_sale": "3.64",
   "market_cap": "$115.18M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/caas",
   "FIELD9": ""
 },
 {
   "symbol": "CBPO",
   "name": "China Biologic Products Holdings, Inc.",
   "last_sale": "81.52",
   "market_cap": "$2.73B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/cbpo",
   "FIELD9": ""
 },
 {
   "symbol": "CCCL",
   "name": "China Ceramics Co., Ltd.",
   "last_sale": "1.3",
   "market_cap": "$6.01M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/cccl",
   "FIELD9": ""
 },
 {
   "symbol": "GLG",
   "name": "China Commercial Credit, Inc.",
   "last_sale": "0.7001",
   "market_cap": "$17.22M",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/glg",
   "FIELD9": ""
 },
 {
   "symbol": "CCRC",
   "name": "China Customer Relations Centers, Inc.",
   "last_sale": "10.22",
   "market_cap": "$187.33M",
   "IPOyear": "2015",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ccrc",
   "FIELD9": ""
 },
 {
   "symbol": "JRJC",
   "name": "China Finance Online Co. Limited",
   "last_sale": "1.8",
   "market_cap": "$42.52M",
   "IPOyear": "2004",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/jrjc",
   "FIELD9": ""
 },
 {
   "symbol": "HGSH",
   "name": "China HGS Real Estate, Inc.",
   "last_sale": "1.301",
   "market_cap": "$58.61M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/hgsh",
   "FIELD9": ""
 },
 {
   "symbol": "CIFS",
   "name": "China Internet Nationwide Financial Services Inc.",
   "last_sale": "8.96",
   "market_cap": "$198.14M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cifs",
   "FIELD9": ""
 },
 {
   "symbol": "CJJD",
   "name": "China Jo-Jo Drugstores, Inc.",
   "last_sale": "1.55",
   "market_cap": "$44.85M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/cjjd",
   "FIELD9": ""
 },
 {
   "symbol": "CLDC",
   "name": "China Lending Corporation",
   "last_sale": "0.8451",
   "market_cap": "$20.08M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Diversified Financial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cldc",
   "FIELD9": ""
 },
 {
   "symbol": "CHNR",
   "name": "China Natural Resources, Inc.",
   "last_sale": "1.88",
   "market_cap": "$46.83M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/chnr",
   "FIELD9": ""
 },
 {
   "symbol": "CREG",
   "name": "China Recycling Energy Corporation",
   "last_sale": "1.17",
   "market_cap": "$9.72M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/creg",
   "FIELD9": ""
 },
 {
   "symbol": "CNTF",
   "name": "China TechFaith Wireless Communication Technology Limited",
   "last_sale": "2.2522",
   "market_cap": "$23.84M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cntf",
   "FIELD9": ""
 },
 {
   "symbol": "CXDC",
   "name": "China XD Plastics Company Limited",
   "last_sale": "3.595",
   "market_cap": "$180.78M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/cxdc",
   "FIELD9": ""
 },
 {
   "symbol": "CCIH",
   "name": "ChinaCache International Holdings Ltd.",
   "last_sale": "1.11",
   "market_cap": "$29.57M",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ccih",
   "FIELD9": ""
 },
 {
   "symbol": "CNET",
   "name": "ChinaNet Online Holdings, Inc.",
   "last_sale": "1.82",
   "market_cap": "$29.36M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/cnet",
   "FIELD9": ""
 },
 {
   "symbol": "IMOS",
   "name": "ChipMOS TECHNOLOGIES INC.",
   "last_sale": "15.13",
   "market_cap": "$546.81M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/imos",
   "FIELD9": ""
 },
 {
   "symbol": "CDXC",
   "name": "ChromaDex Corporation",
   "last_sale": "3.79",
   "market_cap": "$208.66M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/cdxc",
   "FIELD9": ""
 },
 {
   "symbol": "CHSCL",
   "name": "CHS Inc",
   "last_sale": "27.38",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/chscl",
   "FIELD9": ""
 },
 {
   "symbol": "CHSCM",
   "name": "CHS Inc",
   "last_sale": "26.23",
   "market_cap": "$498.37M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/chscm",
   "FIELD9": ""
 },
 {
   "symbol": "CHSCN",
   "name": "CHS Inc",
   "last_sale": "27.25",
   "market_cap": "$457.8M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/chscn",
   "FIELD9": ""
 },
 {
   "symbol": "CHSCO",
   "name": "CHS Inc",
   "last_sale": "28.36",
   "market_cap": "$321.01M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/chsco",
   "FIELD9": ""
 },
 {
   "symbol": "CHSCP",
   "name": "CHS Inc",
   "last_sale": "29.56",
   "market_cap": "$213.79M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/chscp",
   "FIELD9": ""
 },
 {
   "symbol": "CHDN",
   "name": "Churchill Downs, Incorporated",
   "last_sale": "277.55",
   "market_cap": "$3.76B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/chdn",
   "FIELD9": ""
 },
 {
   "symbol": "CHUY",
   "name": "Chuy&#39;s Holdings, Inc.",
   "last_sale": "27.3",
   "market_cap": "$462.65M",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/chuy",
   "FIELD9": ""
 },
 {
   "symbol": "CDTX",
   "name": "Cidara Therapeutics, Inc.",
   "last_sale": "4.25",
   "market_cap": "$117.64M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/cdtx",
   "FIELD9": ""
 },
 {
   "symbol": "CMCT",
   "name": "CIM Commercial Trust Corporation",
   "last_sale": "14.45",
   "market_cap": "$632.84M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cmct",
   "FIELD9": ""
 },
 {
   "symbol": "CMCTP",
   "name": "CIM Commercial Trust Corporation",
   "last_sale": "27.75",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cmctp",
   "FIELD9": ""
 },
 {
   "symbol": "CMPR",
   "name": "Cimpress N.V",
   "last_sale": "145.14",
   "market_cap": "$4.48B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Publishing",
   "summary_quote": "https://www.nasdaq.com/symbol/cmpr",
   "FIELD9": ""
 },
 {
   "symbol": "CINF",
   "name": "Cincinnati Financial Corporation",
   "last_sale": "79.03",
   "market_cap": "$12.85B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/cinf",
   "FIELD9": ""
 },
 {
   "symbol": "CIDM",
   "name": "Cinedigm Corp",
   "last_sale": "1.24",
   "market_cap": "$43.49M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Consumer Electronics/Video Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/cidm",
   "FIELD9": ""
 },
 {
   "symbol": "CTAS",
   "name": "Cintas Corporation",
   "last_sale": "211.69",
   "market_cap": "$22.5B",
   "IPOyear": "1983",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/ctas",
   "FIELD9": ""
 },
 {
   "symbol": "CRUS",
   "name": "Cirrus Logic, Inc.",
   "last_sale": "39.83",
   "market_cap": "$2.43B",
   "IPOyear": "1989",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/crus",
   "FIELD9": ""
 },
 {
   "symbol": "CSCO",
   "name": "Cisco Systems, Inc.",
   "last_sale": "48.56",
   "market_cap": "$221.98B",
   "IPOyear": "1990",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/csco",
   "FIELD9": ""
 },
 {
   "symbol": "CTRN",
   "name": "Citi Trends, Inc.",
   "last_sale": "29.29",
   "market_cap": "$380.05M",
   "IPOyear": "2005",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/ctrn",
   "FIELD9": ""
 },
 {
   "symbol": "CTXR",
   "name": "Citius Pharmaceuticals, Inc.",
   "last_sale": "1.6401",
   "market_cap": "$26.57M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ctxr",
   "FIELD9": ""
 },
 {
   "symbol": "CTXRW",
   "name": "Citius Pharmaceuticals, Inc.",
   "last_sale": "0.2601",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ctxrw",
   "FIELD9": ""
 },
 {
   "symbol": "CZNC",
   "name": "Citizens & Northern Corp",
   "last_sale": "26.76",
   "market_cap": "$328.66M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cznc",
   "FIELD9": ""
 },
 {
   "symbol": "CZWI",
   "name": "Citizens Community Bancorp, Inc.",
   "last_sale": "14",
   "market_cap": "$82.8M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/czwi",
   "FIELD9": ""
 },
 {
   "symbol": "CZFC",
   "name": "Citizens First Corporation",
   "last_sale": "27.1",
   "market_cap": "$68.77M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/czfc",
   "FIELD9": ""
 },
 {
   "symbol": "CIZN",
   "name": "Citizens Holding Company",
   "last_sale": "23.9",
   "market_cap": "$117.22M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cizn",
   "FIELD9": ""
 },
 {
   "symbol": "CTXS",
   "name": "Citrix Systems, Inc.",
   "last_sale": "110.36",
   "market_cap": "$14.97B",
   "IPOyear": "1995",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ctxs",
   "FIELD9": ""
 },
 {
   "symbol": "CHCO",
   "name": "City Holding Company",
   "last_sale": "78.04",
   "market_cap": "$1.21B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/chco",
   "FIELD9": ""
 },
 {
   "symbol": "CIVB",
   "name": "Civista Bancshares, Inc. ",
   "last_sale": "25.08",
   "market_cap": "$270.64M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/civb",
   "FIELD9": ""
 },
 {
   "symbol": "CIVBP",
   "name": "Civista Bancshares, Inc. ",
   "last_sale": "76.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/civbp",
   "FIELD9": ""
 },
 {
   "symbol": "CLAR",
   "name": "Clarus Corporation",
   "last_sale": "10.8",
   "market_cap": "$320.05M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/clar",
   "FIELD9": ""
 },
 {
   "symbol": "CLNE",
   "name": "Clean Energy Fuels Corp.",
   "last_sale": "2.675",
   "market_cap": "$544.27M",
   "IPOyear": "2007",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/clne",
   "FIELD9": ""
 },
 {
   "symbol": "CACG",
   "name": "ClearBridge All Cap Growth ETF",
   "last_sale": "31.34",
   "market_cap": "$61.11M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cacg",
   "FIELD9": ""
 },
 {
   "symbol": "YLDE",
   "name": "ClearBridge Dividend Strategy ESG ETF",
   "last_sale": "29.55",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ylde",
   "FIELD9": ""
 },
 {
   "symbol": "LRGE",
   "name": "ClearBridge Large Cap Growth ESG ETF",
   "last_sale": "33.8429",
   "market_cap": "$3.38M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lrge",
   "FIELD9": ""
 },
 {
   "symbol": "CLFD",
   "name": "Clearfield, Inc.",
   "last_sale": "13.25",
   "market_cap": "$181M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/clfd",
   "FIELD9": ""
 },
 {
   "symbol": "CLRO",
   "name": "ClearOne, Inc.",
   "last_sale": "2.1251",
   "market_cap": "$17.65M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/clro",
   "FIELD9": ""
 },
 {
   "symbol": "CLSD",
   "name": "Clearside Biomedical, Inc.",
   "last_sale": "6.225",
   "market_cap": "$199.35M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/clsd",
   "FIELD9": ""
 },
 {
   "symbol": "CLIR",
   "name": "ClearSign Combustion Corporation",
   "last_sale": "1.7",
   "market_cap": "$45.27M",
   "IPOyear": "2012",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/clir",
   "FIELD9": ""
 },
 {
   "symbol": "CLIRW",
   "name": "ClearSign Combustion Corporation",
   "last_sale": "0.4",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/clirw",
   "FIELD9": ""
 },
 {
   "symbol": "CMTA",
   "name": "Clementia Pharmaceuticals Inc.",
   "last_sale": "11.075",
   "market_cap": "$351.27M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cmta",
   "FIELD9": ""
 },
 {
   "symbol": "CBLI",
   "name": "Cleveland BioLabs, Inc.",
   "last_sale": "1.976",
   "market_cap": "$22.33M",
   "IPOyear": "2006",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/cbli",
   "FIELD9": ""
 },
 {
   "symbol": "CLVS",
   "name": "Clovis Oncology, Inc.",
   "last_sale": "32.39",
   "market_cap": "$1.71B",
   "IPOyear": "2011",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/clvs",
   "FIELD9": ""
 },
 {
   "symbol": "CLPS",
   "name": "CLPS Incorporation",
   "last_sale": "13.23",
   "market_cap": "$175.83M",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/clps",
   "FIELD9": ""
 },
 {
   "symbol": "CMFN",
   "name": "CM Finance Inc",
   "last_sale": "8.85",
   "market_cap": "$121.18M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cmfn",
   "FIELD9": ""
 },
 {
   "symbol": "CMFNL",
   "name": "CM Finance Inc",
   "last_sale": "25.3",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cmfnl",
   "FIELD9": ""
 },
 {
   "symbol": "CMSS",
   "name": "CM Seven Star Acquisition Corporation",
   "last_sale": "10.08",
   "market_cap": "$60.4M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cmss",
   "FIELD9": ""
 },
 {
   "symbol": "CMSSR",
   "name": "CM Seven Star Acquisition Corporation",
   "last_sale": "0.55",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cmssr",
   "FIELD9": ""
 },
 {
   "symbol": "CMSSU",
   "name": "CM Seven Star Acquisition Corporation",
   "last_sale": "11",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cmssu",
   "FIELD9": ""
 },
 {
   "symbol": "CMSSW",
   "name": "CM Seven Star Acquisition Corporation",
   "last_sale": "0.4999",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cmssw",
   "FIELD9": ""
 },
 {
   "symbol": "CME",
   "name": "CME Group Inc.",
   "last_sale": "175.07",
   "market_cap": "$59.63B",
   "IPOyear": "2002",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/cme",
   "FIELD9": ""
 },
 {
   "symbol": "CCNE",
   "name": "CNB Financial Corporation",
   "last_sale": "29.75",
   "market_cap": "$454.74M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ccne",
   "FIELD9": ""
 },
 {
   "symbol": "CCB",
   "name": "Coastal Financial Corporation",
   "last_sale": "16.55",
   "market_cap": "$196.67M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ccb",
   "FIELD9": ""
 },
 {
   "symbol": "CWAY",
   "name": "Coastway Bancorp, Inc.",
   "last_sale": "28.25",
   "market_cap": "$123.91M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/cway",
   "FIELD9": ""
 },
 {
   "symbol": "COBZ",
   "name": "CoBiz Financial Inc.",
   "last_sale": "23.45",
   "market_cap": "$994.26M",
   "IPOyear": "1998",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cobz",
   "FIELD9": ""
 },
 {
   "symbol": "COKE",
   "name": "Coca-Cola Bottling Co. Consolidated",
   "last_sale": "181.22",
   "market_cap": "$1.7B",
   "IPOyear": "1972",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/coke",
   "FIELD9": ""
 },
 {
   "symbol": "COCP",
   "name": "Cocrystal Pharma, Inc.",
   "last_sale": "2.8",
   "market_cap": "$83.78M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cocp",
   "FIELD9": ""
 },
 {
   "symbol": "CODA",
   "name": "Coda Octopus Group, Inc.",
   "last_sale": "6.03",
   "market_cap": "$62.8M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/coda",
   "FIELD9": ""
 },
 {
   "symbol": "CDXS",
   "name": "Codexis, Inc.",
   "last_sale": "17.95",
   "market_cap": "$960.55M",
   "IPOyear": "2010",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/cdxs",
   "FIELD9": ""
 },
 {
   "symbol": "CODX",
   "name": "Co-Diagnostics, Inc.",
   "last_sale": "2.65",
   "market_cap": "$32.72M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/codx",
   "FIELD9": ""
 },
 {
   "symbol": "CVLY",
   "name": "Codorus Valley Bancorp, Inc",
   "last_sale": "32.12",
   "market_cap": "$287.35M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/cvly",
   "FIELD9": ""
 },
 {
   "symbol": "JVA",
   "name": "Coffee Holding Co., Inc.",
   "last_sale": "4.68",
   "market_cap": "$26.31M",
   "IPOyear": "2005",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/jva",
   "FIELD9": ""
 },
 {
   "symbol": "CCOI",
   "name": "Cogent Communications Holdings, Inc.",
   "last_sale": "54.8",
   "market_cap": "$2.55B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ccoi",
   "FIELD9": ""
 },
 {
   "symbol": "CGNX",
   "name": "Cognex Corporation",
   "last_sale": "58.13",
   "market_cap": "$10B",
   "IPOyear": "1989",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cgnx",
   "FIELD9": ""
 },
 {
   "symbol": "CTSH",
   "name": "Cognizant Technology Solutions Corporation",
   "last_sale": "77.6003",
   "market_cap": "$45.03B",
   "IPOyear": "1998",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ctsh",
   "FIELD9": ""
 },
 {
   "symbol": "CWBR",
   "name": "CohBar, Inc.",
   "last_sale": "4.35",
   "market_cap": "$184.72M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cwbr",
   "FIELD9": ""
 },
 {
   "symbol": "COHR",
   "name": "Coherent, Inc.",
   "last_sale": "186.59",
   "market_cap": "$4.53B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/cohr",
   "FIELD9": ""
 },
 {
   "symbol": "CHRS",
   "name": "Coherus BioSciences, Inc.",
   "last_sale": "15.95",
   "market_cap": "$1.08B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/chrs",
   "FIELD9": ""
 },
 {
   "symbol": "COHU",
   "name": "Cohu, Inc.",
   "last_sale": "21.55",
   "market_cap": "$622.56M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/cohu",
   "FIELD9": ""
 },
 {
   "symbol": "CLCT",
   "name": "Collectors Universe, Inc.",
   "last_sale": "15.3",
   "market_cap": "$137.93M",
   "IPOyear": "1999",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/clct",
   "FIELD9": ""
 },
 {
   "symbol": "COLL",
   "name": "Collegium Pharmaceutical, Inc.",
   "last_sale": "15.3",
   "market_cap": "$508.29M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/coll",
   "FIELD9": ""
 },
 {
   "symbol": "CIGI",
   "name": "Colliers International Group Inc. ",
   "last_sale": "78.95",
   "market_cap": "$2.99B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/cigi",
   "FIELD9": ""
 },
 {
   "symbol": "CLGN",
   "name": "CollPlant Holdings, Ltd.",
   "last_sale": "5.1",
   "market_cap": "$19.43M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/clgn",
   "FIELD9": ""
 },
 {
   "symbol": "CBAN",
   "name": "Colony Bankcorp, Inc.",
   "last_sale": "18.5",
   "market_cap": "$156.13M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cban",
   "FIELD9": ""
 },
 {
   "symbol": "COLB",
   "name": "Columbia Banking System, Inc.",
   "last_sale": "40.46",
   "market_cap": "$2.96B",
   "IPOyear": "1992",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/colb",
   "FIELD9": ""
 },
 {
   "symbol": "CLBK",
   "name": "Columbia Financial, Inc.",
   "last_sale": "16.8",
   "market_cap": "$1.95B",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/clbk",
   "FIELD9": ""
 },
 {
   "symbol": "COLM",
   "name": "Columbia Sportswear Company",
   "last_sale": "91.2",
   "market_cap": "$6.34B",
   "IPOyear": "1998",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/colm",
   "FIELD9": ""
 },
 {
   "symbol": "CMCO",
   "name": "Columbus McKinnon Corporation",
   "last_sale": "42.9",
   "market_cap": "$998.38M",
   "IPOyear": "1996",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/cmco",
   "FIELD9": ""
 },
 {
   "symbol": "CMCSA",
   "name": "Comcast Corporation",
   "last_sale": "37.9",
   "market_cap": "$173.66B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cmcsa",
   "FIELD9": ""
 },
 {
   "symbol": "CCNI",
   "name": "Command Center, Inc.",
   "last_sale": "5.31",
   "market_cap": "$25.91M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ccni",
   "FIELD9": ""
 },
 {
   "symbol": "CBSH",
   "name": "Commerce Bancshares, Inc.",
   "last_sale": "68.94",
   "market_cap": "$7.35B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cbsh",
   "FIELD9": ""
 },
 {
   "symbol": "CBSHP",
   "name": "Commerce Bancshares, Inc.",
   "last_sale": "25.65",
   "market_cap": "$2.35B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cbshp",
   "FIELD9": ""
 },
 {
   "symbol": "CVGI",
   "name": "Commercial Vehicle Group, Inc.",
   "last_sale": "9.24",
   "market_cap": "$286.94M",
   "IPOyear": "2004",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/cvgi",
   "FIELD9": ""
 },
 {
   "symbol": "COMM",
   "name": "CommScope Holding Company, Inc.",
   "last_sale": "30.52",
   "market_cap": "$5.87B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/comm",
   "FIELD9": ""
 },
 {
   "symbol": "JCS",
   "name": "Communications Systems, Inc.",
   "last_sale": "3.21",
   "market_cap": "$29.37M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/jcs",
   "FIELD9": ""
 },
 {
   "symbol": "ESXB",
   "name": "Community Bankers Trust Corporation.",
   "last_sale": "9",
   "market_cap": "$199M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/esxb",
   "FIELD9": ""
 },
 {
   "symbol": "CFBI",
   "name": "Community First Bancshares, Inc.",
   "last_sale": "11.6",
   "market_cap": "$87.44M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/cfbi",
   "FIELD9": ""
 },
 {
   "symbol": "CYHHZ",
   "name": "Community Health Systems, Inc.",
   "last_sale": "0.0368",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/cyhhz",
   "FIELD9": ""
 },
 {
   "symbol": "CTBI",
   "name": "Community Trust Bancorp, Inc.",
   "last_sale": "47",
   "market_cap": "$833.27M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ctbi",
   "FIELD9": ""
 },
 {
   "symbol": "CWBC",
   "name": "Community West Bancshares",
   "last_sale": "11.9",
   "market_cap": "$98.22M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cwbc",
   "FIELD9": ""
 },
 {
   "symbol": "CVLT",
   "name": "Commvault Systems, Inc.",
   "last_sale": "68.5",
   "market_cap": "$3.13B",
   "IPOyear": "2006",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/cvlt",
   "FIELD9": ""
 },
 {
   "symbol": "CGEN",
   "name": "Compugen Ltd.",
   "last_sale": "3.95",
   "market_cap": "$225.93M",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/cgen",
   "FIELD9": ""
 },
 {
   "symbol": "CPSI",
   "name": "Computer Programs and Systems, Inc.",
   "last_sale": "27.45",
   "market_cap": "$386.66M",
   "IPOyear": "2002",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cpsi",
   "FIELD9": ""
 },
 {
   "symbol": "CTG",
   "name": "Computer Task Group, Incorporated",
   "last_sale": "5.3989",
   "market_cap": "$78.13M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ctg",
   "FIELD9": ""
 },
 {
   "symbol": "SCOR",
   "name": "comScore, Inc.",
   "last_sale": "20.52",
   "market_cap": "$1.19B",
   "IPOyear": "2018",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/scor",
   "FIELD9": ""
 },
 {
   "symbol": "CHCI",
   "name": "Comstock Holding Companies, Inc.",
   "last_sale": "2.63",
   "market_cap": "$10.29M",
   "IPOyear": "2004",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/chci",
   "FIELD9": ""
 },
 {
   "symbol": "CMTL",
   "name": "Comtech Telecommunications Corp.",
   "last_sale": "33.32",
   "market_cap": "$787.75M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/cmtl",
   "FIELD9": ""
 },
 {
   "symbol": "CNAT",
   "name": "Conatus Pharmaceuticals Inc.",
   "last_sale": "5.7",
   "market_cap": "$171.97M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cnat",
   "FIELD9": ""
 },
 {
   "symbol": "CNCE",
   "name": "Concert Pharmaceuticals, Inc.",
   "last_sale": "13.53",
   "market_cap": "$316.81M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cnce",
   "FIELD9": ""
 },
 {
   "symbol": "CDOR",
   "name": "Condor Hospitality Trust, Inc.",
   "last_sale": "10.45",
   "market_cap": "$124.19M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cdor",
   "FIELD9": ""
 },
 {
   "symbol": "CFMS",
   "name": "ConforMIS, Inc.",
   "last_sale": "1.19",
   "market_cap": "$75.18M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/cfms",
   "FIELD9": ""
 },
 {
   "symbol": "CNFR",
   "name": "Conifer Holdings, Inc.",
   "last_sale": "6",
   "market_cap": "$51.12M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/cnfr",
   "FIELD9": ""
 },
 {
   "symbol": "CNMD",
   "name": "CONMED Corporation",
   "last_sale": "77.89",
   "market_cap": "$2.19B",
   "IPOyear": "1987",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/cnmd",
   "FIELD9": ""
 },
 {
   "symbol": "CTWS",
   "name": "Connecticut Water Service, Inc.",
   "last_sale": "68.75",
   "market_cap": "$828.03M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/ctws",
   "FIELD9": ""
 },
 {
   "symbol": "CNOB",
   "name": "ConnectOne Bancorp, Inc.",
   "last_sale": "24.45",
   "market_cap": "$786.9M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cnob",
   "FIELD9": ""
 },
 {
   "symbol": "CONN",
   "name": "Conn&#39;s, Inc.",
   "last_sale": "37.25",
   "market_cap": "$1.18B",
   "IPOyear": "2003",
   "sector": "Consumer Services",
   "industry": "Consumer Electronics/Video Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/conn",
   "FIELD9": ""
 },
 {
   "symbol": "CNSL",
   "name": "Consolidated Communications Holdings, Inc.",
   "last_sale": "13.36",
   "market_cap": "$951.93M",
   "IPOyear": "2005",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/cnsl",
   "FIELD9": ""
 },
 {
   "symbol": "CWCO",
   "name": "Consolidated Water Co. Ltd.",
   "last_sale": "14.6",
   "market_cap": "$218.47M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/cwco",
   "FIELD9": ""
 },
 {
   "symbol": "CNAC",
   "name": "Constellation Alpha Capital Corp.",
   "last_sale": "10.09",
   "market_cap": "$51.49M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cnac",
   "FIELD9": ""
 },
 {
   "symbol": "CNACR",
   "name": "Constellation Alpha Capital Corp.",
   "last_sale": "0.45",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cnacr",
   "FIELD9": ""
 },
 {
   "symbol": "CNACU",
   "name": "Constellation Alpha Capital Corp.",
   "last_sale": "10.3",
   "market_cap": "$190.86M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cnacu",
   "FIELD9": ""
 },
 {
   "symbol": "CNACW",
   "name": "Constellation Alpha Capital Corp.",
   "last_sale": "0.26",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cnacw",
   "FIELD9": ""
 },
 {
   "symbol": "CNST",
   "name": "Constellation Pharmaceuticals, Inc.",
   "last_sale": "8.22",
   "market_cap": "$211.41M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cnst",
   "FIELD9": ""
 },
 {
   "symbol": "ROAD",
   "name": "Construction Partners, Inc.",
   "last_sale": "12.63",
   "market_cap": "$649.37M",
   "IPOyear": "2018",
   "sector": "Basic Industries",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/road",
   "FIELD9": ""
 },
 {
   "symbol": "CPSS",
   "name": "Consumer Portfolio Services, Inc.",
   "last_sale": "3.95",
   "market_cap": "$90.65M",
   "IPOyear": "1992",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cpss",
   "FIELD9": ""
 },
 {
   "symbol": "CFRX",
   "name": "ContraFect Corporation",
   "last_sale": "1.6",
   "market_cap": "$127.06M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cfrx",
   "FIELD9": ""
 },
 {
   "symbol": "CTRV",
   "name": "ContraVir Pharmaceuticals Inc.",
   "last_sale": "0.6371",
   "market_cap": "$9.21M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ctrv",
   "FIELD9": ""
 },
 {
   "symbol": "CTRL",
   "name": "Control4 Corporation",
   "last_sale": "34.48",
   "market_cap": "$899.78M",
   "IPOyear": "2013",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/ctrl",
   "FIELD9": ""
 },
 {
   "symbol": "CVON",
   "name": "ConvergeOne Holdings, Inc.",
   "last_sale": "9.49",
   "market_cap": "$725.02M",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/cvon",
   "FIELD9": ""
 },
 {
   "symbol": "AWSM",
   "name": "Cool Holdings Inc.",
   "last_sale": "18.03",
   "market_cap": "$127.77M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/awsm",
   "FIELD9": ""
 },
 {
   "symbol": "CPRT",
   "name": "Copart, Inc.",
   "last_sale": "52.58",
   "market_cap": "$12.21B",
   "IPOyear": "1994",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/cprt",
   "FIELD9": ""
 },
 {
   "symbol": "CRBP",
   "name": "Corbus Pharmaceuticals Holdings, Inc.",
   "last_sale": "6.95",
   "market_cap": "$397.58M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/crbp",
   "FIELD9": ""
 },
 {
   "symbol": "CORT",
   "name": "Corcept Therapeutics Incorporated",
   "last_sale": "14.35",
   "market_cap": "$1.67B",
   "IPOyear": "1982",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cort",
   "FIELD9": ""
 },
 {
   "symbol": "CORE",
   "name": "Core-Mark Holding Company, Inc.",
   "last_sale": "34.1",
   "market_cap": "$1.57B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/core",
   "FIELD9": ""
 },
 {
   "symbol": "CORI",
   "name": "Corium International, Inc.",
   "last_sale": "9.4",
   "market_cap": "$340.75M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cori",
   "FIELD9": ""
 },
 {
   "symbol": "CSOD",
   "name": "Cornerstone OnDemand, Inc.",
   "last_sale": "56.44",
   "market_cap": "$3.32B",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/csod",
   "FIELD9": ""
 },
 {
   "symbol": "CORV",
   "name": "Correvio Pharma Corp.",
   "last_sale": "4.02",
   "market_cap": "$140.18M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/corv",
   "FIELD9": ""
 },
 {
   "symbol": "CRVL",
   "name": "CorVel Corp.",
   "last_sale": "58.8",
   "market_cap": "$1.11B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/crvl",
   "FIELD9": ""
 },
 {
   "symbol": "CRVS",
   "name": "Corvus Pharmaceuticals, Inc.",
   "last_sale": "8.86",
   "market_cap": "$258.69M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/crvs",
   "FIELD9": ""
 },
 {
   "symbol": "CSGP",
   "name": "CoStar Group, Inc.",
   "last_sale": "419.65",
   "market_cap": "$15.27B",
   "IPOyear": "1998",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/csgp",
   "FIELD9": ""
 },
 {
   "symbol": "COST",
   "name": "Costco Wholesale Corporation",
   "last_sale": "234.75",
   "market_cap": "$102.96B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/cost",
   "FIELD9": ""
 },
 {
   "symbol": "CPAH",
   "name": "CounterPath Corporation",
   "last_sale": "2.12",
   "market_cap": "$12.57M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/cpah",
   "FIELD9": ""
 },
 {
   "symbol": "ICBK",
   "name": "County Bancorp, Inc.",
   "last_sale": "25.52",
   "market_cap": "$170.88M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/icbk",
   "FIELD9": ""
 },
 {
   "symbol": "COUP",
   "name": "Coupa Software Incorporated",
   "last_sale": "76.81",
   "market_cap": "$4.46B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/coup",
   "FIELD9": ""
 },
 {
   "symbol": "CVTI",
   "name": "Covenant Transportation Group, Inc.",
   "last_sale": "30.09",
   "market_cap": "$551.95M",
   "IPOyear": "1994",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cvti",
   "FIELD9": ""
 },
 {
   "symbol": "COWN",
   "name": "Cowen Inc.",
   "last_sale": "15.9",
   "market_cap": "$470.79M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/cown",
   "FIELD9": ""
 },
 {
   "symbol": "COWNL",
   "name": "Cowen Inc.",
   "last_sale": "25.15",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/cownl",
   "FIELD9": ""
 },
 {
   "symbol": "COWNZ",
   "name": "Cowen Inc.",
   "last_sale": "25.29",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/cownz",
   "FIELD9": ""
 },
 {
   "symbol": "PMTS",
   "name": "CPI Card Group Inc.",
   "last_sale": "3.71",
   "market_cap": "$41.4M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Finance Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/pmts",
   "FIELD9": ""
 },
 {
   "symbol": "CPSH",
   "name": "CPS Technologies Corp.",
   "last_sale": "1.54",
   "market_cap": "$20.33M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/cpsh",
   "FIELD9": ""
 },
 {
   "symbol": "CRAI",
   "name": "CRA International,Inc.",
   "last_sale": "52.24",
   "market_cap": "$422.09M",
   "IPOyear": "1998",
   "sector": "Miscellaneous",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/crai",
   "FIELD9": ""
 },
 {
   "symbol": "CBRL",
   "name": "Cracker Barrel Old Country Store, Inc.",
   "last_sale": "146.45",
   "market_cap": "$3.52B",
   "IPOyear": "1981",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/cbrl",
   "FIELD9": ""
 },
 {
   "symbol": "BREW",
   "name": "Craft Brew Alliance, Inc.",
   "last_sale": "17.55",
   "market_cap": "$339.81M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/brew",
   "FIELD9": ""
 },
 {
   "symbol": "CRAY",
   "name": "Cray Inc",
   "last_sale": "22.1",
   "market_cap": "$902.27M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/cray",
   "FIELD9": ""
 },
 {
   "symbol": "CACC",
   "name": "Credit Acceptance Corporation",
   "last_sale": "450.73",
   "market_cap": "$8.7B",
   "IPOyear": "1992",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cacc",
   "FIELD9": ""
 },
 {
   "symbol": "DGLD",
   "name": "Credit Suisse AG",
   "last_sale": "56.99",
   "market_cap": "$20.18M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/dgld",
   "FIELD9": ""
 },
 {
   "symbol": "DSLV",
   "name": "Credit Suisse AG",
   "last_sale": "36.67",
   "market_cap": "$15.18M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/dslv",
   "FIELD9": ""
 },
 {
   "symbol": "GLDI",
   "name": "Credit Suisse AG",
   "last_sale": "8.12",
   "market_cap": "$109.83M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/gldi",
   "FIELD9": ""
 },
 {
   "symbol": "SLVO",
   "name": "Credit Suisse AG",
   "last_sale": "6.54",
   "market_cap": "$5.56M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/slvo",
   "FIELD9": ""
 },
 {
   "symbol": "TVIX",
   "name": "Credit Suisse AG",
   "last_sale": "26.42",
   "market_cap": "$453.85M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/tvix",
   "FIELD9": ""
 },
 {
   "symbol": "UGLD",
   "name": "Credit Suisse AG",
   "last_sale": "8.03",
   "market_cap": "$125.39M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/ugld",
   "FIELD9": ""
 },
 {
   "symbol": "USLV",
   "name": "Credit Suisse AG",
   "last_sale": "6.1",
   "market_cap": "$289.25M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/uslv",
   "FIELD9": ""
 },
 {
   "symbol": "USOI",
   "name": "Credit Suisse AG",
   "last_sale": "29.52",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/usoi",
   "FIELD9": ""
 },
 {
   "symbol": "VIIX",
   "name": "Credit Suisse AG",
   "last_sale": "11.26",
   "market_cap": "$12.77M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/viix",
   "FIELD9": ""
 },
 {
   "symbol": "ZIV",
   "name": "Credit Suisse AG",
   "last_sale": "80.2125",
   "market_cap": "$143.82M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/ziv",
   "FIELD9": ""
 },
 {
   "symbol": "CREE",
   "name": "Cree, Inc.",
   "last_sale": "40.29",
   "market_cap": "$4.1B",
   "IPOyear": "1993",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/cree",
   "FIELD9": ""
 },
 {
   "symbol": "CRESY",
   "name": "Cresud S.A.C.I.F. y A.",
   "last_sale": "15.21",
   "market_cap": "$763M",
   "IPOyear": "1997",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/cresy",
   "FIELD9": ""
 },
 {
   "symbol": "CRNX",
   "name": "Crinetics Pharmaceuticals, Inc.",
   "last_sale": "31.18",
   "market_cap": "$749.08M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/crnx",
   "FIELD9": ""
 },
 {
   "symbol": "CRSP",
   "name": "CRISPR Therapeutics AG",
   "last_sale": "44.47",
   "market_cap": "$2.12B",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/crsp",
   "FIELD9": ""
 },
 {
   "symbol": "CRTO",
   "name": "Criteo S.A.",
   "last_sale": "23.83",
   "market_cap": "$1.6B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/crto",
   "FIELD9": ""
 },
 {
   "symbol": "CROX",
   "name": "Crocs, Inc.",
   "last_sale": "21.52",
   "market_cap": "$1.47B",
   "IPOyear": "2006",
   "sector": "Consumer Non-Durables",
   "industry": "Shoe Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/crox",
   "FIELD9": ""
 },
 {
   "symbol": "CRON",
   "name": "Cronos Group Inc.",
   "last_sale": "12.5001",
   "market_cap": "$2.21B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/cron",
   "FIELD9": ""
 },
 {
   "symbol": "CCRN",
   "name": "Cross Country Healthcare, Inc.",
   "last_sale": "8.72",
   "market_cap": "$316.49M",
   "IPOyear": "2001",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ccrn",
   "FIELD9": ""
 },
 {
   "symbol": "CRWS",
   "name": "Crown Crafts, Inc.",
   "last_sale": "5.95",
   "market_cap": "$59.91M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Textiles",
   "summary_quote": "https://www.nasdaq.com/symbol/crws",
   "FIELD9": ""
 },
 {
   "symbol": "CYRX",
   "name": "CryoPort, Inc.",
   "last_sale": "12.39",
   "market_cap": "$353.98M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/cyrx",
   "FIELD9": ""
 },
 {
   "symbol": "CYRXW",
   "name": "CryoPort, Inc.",
   "last_sale": "9.84",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/cyrxw",
   "FIELD9": ""
 },
 {
   "symbol": "CSGS",
   "name": "CSG Systems International, Inc.",
   "last_sale": "41.9",
   "market_cap": "$1.4B",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/csgs",
   "FIELD9": ""
 },
 {
   "symbol": "CCLP",
   "name": "CSI Compressco LP",
   "last_sale": "5.2301",
   "market_cap": "$226.3M",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/cclp",
   "FIELD9": ""
 },
 {
   "symbol": "CSPI",
   "name": "CSP Inc.",
   "last_sale": "13.56",
   "market_cap": "$54.47M",
   "IPOyear": "1982",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cspi",
   "FIELD9": ""
 },
 {
   "symbol": "CSWI",
   "name": "CSW Industrials, Inc.",
   "last_sale": "54.05",
   "market_cap": "$849.47M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/cswi",
   "FIELD9": ""
 },
 {
   "symbol": "CSX",
   "name": "CSX Corporation",
   "last_sale": "73.99",
   "market_cap": "$63.54B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/csx",
   "FIELD9": ""
 },
 {
   "symbol": "CTIC",
   "name": "CTI BioPharma Corp.",
   "last_sale": "1.99",
   "market_cap": "$115.4M",
   "IPOyear": "1997",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ctic",
   "FIELD9": ""
 },
 {
   "symbol": "CTIB",
   "name": "CTI Industries Corporation",
   "last_sale": "3.26",
   "market_cap": "$11.51M",
   "IPOyear": "1997",
   "sector": "Basic Industries",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/ctib",
   "FIELD9": ""
 },
 {
   "symbol": "CTRP",
   "name": "Ctrip.com International, Ltd.",
   "last_sale": "39.41",
   "market_cap": "$21.31B",
   "IPOyear": "2003",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ctrp",
   "FIELD9": ""
 },
 {
   "symbol": "CUE",
   "name": "Cue Biopharma, Inc.",
   "last_sale": "9.19",
   "market_cap": "$185.02M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cue",
   "FIELD9": ""
 },
 {
   "symbol": "CUI",
   "name": "CUI Global, Inc.",
   "last_sale": "2.38",
   "market_cap": "$67.9M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cui",
   "FIELD9": ""
 },
 {
   "symbol": "CPIX",
   "name": "Cumberland Pharmaceuticals Inc.",
   "last_sale": "5.65",
   "market_cap": "$87.96M",
   "IPOyear": "2009",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cpix",
   "FIELD9": ""
 },
 {
   "symbol": "CMLS",
   "name": "Cumulus Media Inc.",
   "last_sale": "17.55",
   "market_cap": "$287.06M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/cmls",
   "FIELD9": ""
 },
 {
   "symbol": "CRIS",
   "name": "Curis, Inc.",
   "last_sale": "1.62",
   "market_cap": "$53.75M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/cris",
   "FIELD9": ""
 },
 {
   "symbol": "CUTR",
   "name": "Cutera, Inc.",
   "last_sale": "30.1",
   "market_cap": "$416.49M",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/cutr",
   "FIELD9": ""
 },
 {
   "symbol": "CVBF",
   "name": "CVB Financial Corporation",
   "last_sale": "23.57",
   "market_cap": "$3.31B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cvbf",
   "FIELD9": ""
 },
 {
   "symbol": "CVV",
   "name": "CVD Equipment Corporation",
   "last_sale": "6.11",
   "market_cap": "$39.66M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cvv",
   "FIELD9": ""
 },
 {
   "symbol": "CYAN",
   "name": "Cyanotech Corporation",
   "last_sale": "3.54",
   "market_cap": "$20.49M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/cyan",
   "FIELD9": ""
 },
 {
   "symbol": "CYBR",
   "name": "CyberArk Software Ltd.",
   "last_sale": "72.52",
   "market_cap": "$2.58B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/cybr",
   "FIELD9": ""
 },
 {
   "symbol": "CYBE",
   "name": "CyberOptics Corporation",
   "last_sale": "20.25",
   "market_cap": "$142.59M",
   "IPOyear": "1987",
   "sector": "Capital Goods",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cybe",
   "FIELD9": ""
 },
 {
   "symbol": "CYCC",
   "name": "Cyclacel Pharmaceuticals, Inc.",
   "last_sale": "1.36",
   "market_cap": "$16.32M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cycc",
   "FIELD9": ""
 },
 {
   "symbol": "CYCCP",
   "name": "Cyclacel Pharmaceuticals, Inc.",
   "last_sale": "5",
   "market_cap": "$1.68M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cyccp",
   "FIELD9": ""
 },
 {
   "symbol": "CBAY",
   "name": "CymaBay Therapeutics Inc.",
   "last_sale": "11.39",
   "market_cap": "$672.61M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cbay",
   "FIELD9": ""
 },
 {
   "symbol": "CY",
   "name": "Cypress Semiconductor Corporation",
   "last_sale": "15.98",
   "market_cap": "$5.78B",
   "IPOyear": "1986",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/cy",
   "FIELD9": ""
 },
 {
   "symbol": "CYRN",
   "name": "CYREN Ltd.",
   "last_sale": "3.1",
   "market_cap": "$165.49M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/cyrn",
   "FIELD9": ""
 },
 {
   "symbol": "CONE",
   "name": "CyrusOne Inc",
   "last_sale": "68.24",
   "market_cap": "$6.76B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cone",
   "FIELD9": ""
 },
 {
   "symbol": "CYTK",
   "name": "Cytokinetics, Incorporated",
   "last_sale": "8.475",
   "market_cap": "$462.97M",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cytk",
   "FIELD9": ""
 },
 {
   "symbol": "CTMX",
   "name": "CytomX Therapeutics, Inc.",
   "last_sale": "18.09",
   "market_cap": "$813.39M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ctmx",
   "FIELD9": ""
 },
 {
   "symbol": "CYTX",
   "name": "Cytori Therapeutics Inc.",
   "last_sale": "0.413",
   "market_cap": "$3.18M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/cytx",
   "FIELD9": ""
 },
 {
   "symbol": "CYTXW",
   "name": "Cytori Therapeutics Inc.",
   "last_sale": "0.0083",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/cytxw",
   "FIELD9": ""
 },
 {
   "symbol": "CYTXZ",
   "name": "Cytori Therapeutics Inc.",
   "last_sale": "0.004",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/cytxz",
   "FIELD9": ""
 },
 {
   "symbol": "CTSO",
   "name": "Cytosorbents Corporation",
   "last_sale": "13.45",
   "market_cap": "$423.13M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/ctso",
   "FIELD9": ""
 },
 {
   "symbol": "CYTR",
   "name": "CytRx Corporation",
   "last_sale": "1.06",
   "market_cap": "$35.66M",
   "IPOyear": "1986",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/cytr",
   "FIELD9": ""
 },
 {
   "symbol": "DJCO",
   "name": "Daily Journal Corp. (S.C.)",
   "last_sale": "239",
   "market_cap": "$330M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Newspapers/Magazines",
   "summary_quote": "https://www.nasdaq.com/symbol/djco",
   "FIELD9": ""
 },
 {
   "symbol": "DAKT",
   "name": "Daktronics, Inc.",
   "last_sale": "8.01",
   "market_cap": "$357.15M",
   "IPOyear": "1994",
   "sector": "Consumer Durables",
   "industry": "Miscellaneous manufacturing industries",
   "summary_quote": "https://www.nasdaq.com/symbol/dakt",
   "FIELD9": ""
 },
 {
   "symbol": "DARE",
   "name": "Dare Bioscience, Inc.",
   "last_sale": "1",
   "market_cap": "$11.42M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/dare",
   "FIELD9": ""
 },
 {
   "symbol": "DRIO",
   "name": "DarioHealth Corp.",
   "last_sale": "0.95",
   "market_cap": "$20.27M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/drio",
   "FIELD9": ""
 },
 {
   "symbol": "DRIOW",
   "name": "DarioHealth Corp.",
   "last_sale": "0.14",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/driow",
   "FIELD9": ""
 },
 {
   "symbol": "DZSI",
   "name": "DASAN Zhone Solutions, Inc.",
   "last_sale": "11.91",
   "market_cap": "$196.49M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/dzsi",
   "FIELD9": ""
 },
 {
   "symbol": "DSKE",
   "name": "Daseke, Inc.",
   "last_sale": "8.47",
   "market_cap": "$545.85M",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dske",
   "FIELD9": ""
 },
 {
   "symbol": "DSKEW",
   "name": "Daseke, Inc.",
   "last_sale": "0.85",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dskew",
   "FIELD9": ""
 },
 {
   "symbol": "DAIO",
   "name": "Data I/O Corporation",
   "last_sale": "5.25",
   "market_cap": "$44.3M",
   "IPOyear": "1981",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/daio",
   "FIELD9": ""
 },
 {
   "symbol": "DWCH",
   "name": "Datawatch Corporation",
   "last_sale": "11.45",
   "market_cap": "$145.79M",
   "IPOyear": "1992",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/dwch",
   "FIELD9": ""
 },
 {
   "symbol": "PLAY",
   "name": "Dave & Buster&#39;s Entertainment, Inc.",
   "last_sale": "63.2",
   "market_cap": "$2.45B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/play",
   "FIELD9": ""
 },
 {
   "symbol": "DTEA",
   "name": "DAVIDsTEA Inc.",
   "last_sale": "2.5",
   "market_cap": "$64.99M",
   "IPOyear": "2015",
   "sector": "Consumer Non-Durables",
   "industry": "Food Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/dtea",
   "FIELD9": ""
 },
 {
   "symbol": "DFNL",
   "name": "Davis Select Financial ETF",
   "last_sale": "25.45",
   "market_cap": "$156.52M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dfnl",
   "FIELD9": ""
 },
 {
   "symbol": "DINT",
   "name": "Davis Select International ETF",
   "last_sale": "18.4662",
   "market_cap": "$58.17M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dint",
   "FIELD9": ""
 },
 {
   "symbol": "DUSA",
   "name": "Davis Select U.S. Equity ETF",
   "last_sale": "25.6722",
   "market_cap": "$139.91M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dusa",
   "FIELD9": ""
 },
 {
   "symbol": "DWLD",
   "name": "Davis Select Worldwide ETF",
   "last_sale": "25.86",
   "market_cap": "$257.31M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dwld",
   "FIELD9": ""
 },
 {
   "symbol": "DWSN",
   "name": "Dawson Geophysical Company",
   "last_sale": "6.2",
   "market_cap": "$142.11M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/dwsn",
   "FIELD9": ""
 },
 {
   "symbol": "DBVT",
   "name": "DBV Technologies S.A.",
   "last_sale": "24.57",
   "market_cap": "$1.48B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/dbvt",
   "FIELD9": ""
 },
 {
   "symbol": "DCPH",
   "name": "Deciphera Pharmaceuticals, Inc.",
   "last_sale": "38.97",
   "market_cap": "$1.47B",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/dcph",
   "FIELD9": ""
 },
 {
   "symbol": "DFRG",
   "name": "Del Frisco&#39;s Restaurant Group, Inc.",
   "last_sale": "8.75",
   "market_cap": "$291.55M",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/dfrg",
   "FIELD9": ""
 },
 {
   "symbol": "TACO",
   "name": "Del Taco Restaurants, Inc.",
   "last_sale": "11.27",
   "market_cap": "$431.64M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/taco",
   "FIELD9": ""
 },
 {
   "symbol": "TACOW",
   "name": "Del Taco Restaurants, Inc.",
   "last_sale": "2.0697",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/tacow",
   "FIELD9": ""
 },
 {
   "symbol": "DMPI",
   "name": "DelMar Pharmaceuticals, Inc.",
   "last_sale": "0.8036",
   "market_cap": "$17.69M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/dmpi",
   "FIELD9": ""
 },
 {
   "symbol": "DELT",
   "name": "Delta Technology Holdings Limited",
   "last_sale": "0.89",
   "market_cap": "$11.4M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/delt",
   "FIELD9": ""
 },
 {
   "symbol": "DNLI",
   "name": "Denali Therapeutics Inc.",
   "last_sale": "20.92",
   "market_cap": "$1.98B",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/dnli",
   "FIELD9": ""
 },
 {
   "symbol": "DENN",
   "name": "Denny's Corporation",
   "last_sale": "14.25",
   "market_cap": "$903.25M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/denn",
   "FIELD9": ""
 },
 {
   "symbol": "XRAY",
   "name": "DENTSPLY SIRONA Inc.",
   "last_sale": "38.76",
   "market_cap": "$8.62B",
   "IPOyear": "1987",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/xray",
   "FIELD9": ""
 },
 {
   "symbol": "DDOC",
   "name": "DERMAdoctor, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ddoc",
   "FIELD9": ""
 },
 {
   "symbol": "DERM",
   "name": "Dermira, Inc.",
   "last_sale": "10.33",
   "market_cap": "$434.13M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/derm",
   "FIELD9": ""
 },
 {
   "symbol": "DEST",
   "name": "Destination Maternity Corporation",
   "last_sale": "4.23",
   "market_cap": "$61.85M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/dest",
   "FIELD9": ""
 },
 {
   "symbol": "DXLG",
   "name": "Destination XL Group, Inc.",
   "last_sale": "2.6",
   "market_cap": "$127.88M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/dxlg",
   "FIELD9": ""
 },
 {
   "symbol": "DSWL",
   "name": "Deswell Industries, Inc.",
   "last_sale": "3.48",
   "market_cap": "$55.28M",
   "IPOyear": "1995",
   "sector": "Consumer Non-Durables",
   "industry": "Plastic Products",
   "summary_quote": "https://www.nasdaq.com/symbol/dswl",
   "FIELD9": ""
 },
 {
   "symbol": "DTRM",
   "name": "Determine, Inc. ",
   "last_sale": "0.73",
   "market_cap": "$10.98M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/dtrm",
   "FIELD9": ""
 },
 {
   "symbol": "DXCM",
   "name": "DexCom, Inc.",
   "last_sale": "139.37",
   "market_cap": "$12.31B",
   "IPOyear": "2005",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/dxcm",
   "FIELD9": ""
 },
 {
   "symbol": "DFBH",
   "name": "DFB Healthcare Acquisitions Corp.",
   "last_sale": "9.72",
   "market_cap": "$71.08M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dfbh",
   "FIELD9": ""
 },
 {
   "symbol": "DFBHU",
   "name": "DFB Healthcare Acquisitions Corp.",
   "last_sale": "10.1",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dfbhu",
   "FIELD9": ""
 },
 {
   "symbol": "DFBHW",
   "name": "DFB Healthcare Acquisitions Corp.",
   "last_sale": "1.45",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dfbhw",
   "FIELD9": ""
 },
 {
   "symbol": "DHXM",
   "name": "DHX Media Ltd.",
   "last_sale": "1.2",
   "market_cap": "$161.25M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dhxm",
   "FIELD9": ""
 },
 {
   "symbol": "DHIL",
   "name": "Diamond Hill Investment Group, Inc.",
   "last_sale": "164",
   "market_cap": "$578.94M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/dhil",
   "FIELD9": ""
 },
 {
   "symbol": "FANG",
   "name": "Diamondback Energy, Inc.",
   "last_sale": "128.55",
   "market_cap": "$12.68B",
   "IPOyear": "2012",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/fang",
   "FIELD9": ""
 },
 {
   "symbol": "DCIX",
   "name": "Diana Containerships Inc.",
   "last_sale": "1.17",
   "market_cap": "$11.65M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/dcix",
   "FIELD9": ""
 },
 {
   "symbol": "DRNA",
   "name": "Dicerna Pharmaceuticals, Inc.",
   "last_sale": "15.99",
   "market_cap": "$988.29M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/drna",
   "FIELD9": ""
 },
 {
   "symbol": "DFBG",
   "name": "Differential Brands Group Inc.",
   "last_sale": "4.29",
   "market_cap": "$60.4M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/dfbg",
   "FIELD9": ""
 },
 {
   "symbol": "DFFN",
   "name": "Diffusion Pharmaceuticals Inc.",
   "last_sale": "0.4403",
   "market_cap": "$22.27M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/dffn",
   "FIELD9": ""
 },
 {
   "symbol": "DGII",
   "name": "Digi International Inc.",
   "last_sale": "13.25",
   "market_cap": "$360.97M",
   "IPOyear": "1989",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/dgii",
   "FIELD9": ""
 },
 {
   "symbol": "DMRC",
   "name": "Digimarc Corporation",
   "last_sale": "31.45",
   "market_cap": "$373.64M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dmrc",
   "FIELD9": ""
 },
 {
   "symbol": "DRAD",
   "name": "Digirad Corporation",
   "last_sale": "1.5",
   "market_cap": "$30.18M",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/drad",
   "FIELD9": ""
 },
 {
   "symbol": "DGLY",
   "name": "Digital Ally, Inc.",
   "last_sale": "4.175",
   "market_cap": "$32.14M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/dgly",
   "FIELD9": ""
 },
 {
   "symbol": "APPS",
   "name": "Digital Turbine, Inc.",
   "last_sale": "1.255",
   "market_cap": "$96.4M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Multi-Sector Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/apps",
   "FIELD9": ""
 },
 {
   "symbol": "DCOM",
   "name": "Dime Community Bancshares, Inc.",
   "last_sale": "17.95",
   "market_cap": "$672.4M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/dcom",
   "FIELD9": ""
 },
 {
   "symbol": "DIOD",
   "name": "Diodes Incorporated",
   "last_sale": "34.24",
   "market_cap": "$1.72B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/diod",
   "FIELD9": ""
 },
 {
   "symbol": "DISCA",
   "name": "Discovery, Inc.",
   "last_sale": "31.79",
   "market_cap": "$16.61B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/disca",
   "FIELD9": ""
 },
 {
   "symbol": "DISCB",
   "name": "Discovery, Inc.",
   "last_sale": "31.65",
   "market_cap": "$16.53B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/discb",
   "FIELD9": ""
 },
 {
   "symbol": "DISCK",
   "name": "Discovery, Inc.",
   "last_sale": "29.07",
   "market_cap": "$15.19B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/disck",
   "FIELD9": ""
 },
 {
   "symbol": "DISH",
   "name": "DISH Network Corporation",
   "last_sale": "36.48",
   "market_cap": "$17.05B",
   "IPOyear": "1995",
   "sector": "Communication Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dish",
   "FIELD9": ""
 },
 {
   "symbol": "DVCR",
   "name": "Diversicare Healthcare Services Inc.",
   "last_sale": "6.32",
   "market_cap": "$41.31M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/dvcr",
   "FIELD9": ""
 },
 {
   "symbol": "SAUC",
   "name": "Diversified Restaurant Holdings, Inc.",
   "last_sale": "1.43",
   "market_cap": "$46.58M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/sauc",
   "FIELD9": ""
 },
 {
   "symbol": "DLHC",
   "name": "DLH Holdings Corp.",
   "last_sale": "5.62",
   "market_cap": "$66.88M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dlhc",
   "FIELD9": ""
 },
 {
   "symbol": "BOOM",
   "name": "DMC Global Inc.",
   "last_sale": "38.75",
   "market_cap": "$576.94M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/boom",
   "FIELD9": ""
 },
 {
   "symbol": "DNBF",
   "name": "DNB Financial Corp",
   "last_sale": "36.25",
   "market_cap": "$156.11M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/dnbf",
   "FIELD9": ""
 },
 {
   "symbol": "DOCU",
   "name": "DocuSign, Inc.",
   "last_sale": "52.54",
   "market_cap": "$8.24B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/docu",
   "FIELD9": ""
 },
 {
   "symbol": "DOGZ",
   "name": "Dogness (International) Corporation",
   "last_sale": "2.62",
   "market_cap": "$67.89M",
   "IPOyear": "2017",
   "sector": "Consumer Durables",
   "industry": "Miscellaneous manufacturing industries",
   "summary_quote": "https://www.nasdaq.com/symbol/dogz",
   "FIELD9": ""
 },
 {
   "symbol": "DLTR",
   "name": "Dollar Tree, Inc.",
   "last_sale": "85.07",
   "market_cap": "$20.24B",
   "IPOyear": "1995",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/dltr",
   "FIELD9": ""
 },
 {
   "symbol": "DLPN",
   "name": "Dolphin Entertainment, Inc.",
   "last_sale": "2.79",
   "market_cap": "$38.25M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dlpn",
   "FIELD9": ""
 },
 {
   "symbol": "DLPNW",
   "name": "Dolphin Entertainment, Inc.",
   "last_sale": "0.3285",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dlpnw",
   "FIELD9": ""
 },
 {
   "symbol": "DOMO",
   "name": "Domo, Inc.",
   "last_sale": "20.52",
   "market_cap": "$540.44M",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/domo",
   "FIELD9": ""
 },
 {
   "symbol": "DGICA",
   "name": "Donegal Group, Inc.",
   "last_sale": "13.96",
   "market_cap": "$394.96M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/dgica",
   "FIELD9": ""
 },
 {
   "symbol": "DGICB",
   "name": "Donegal Group, Inc.",
   "last_sale": "13.05",
   "market_cap": "$369.21M",
   "IPOyear": "1986",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/dgicb",
   "FIELD9": ""
 },
 {
   "symbol": "DMLP",
   "name": "Dorchester Minerals, L.P.",
   "last_sale": "19.05",
   "market_cap": "$614.93M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/dmlp",
   "FIELD9": ""
 },
 {
   "symbol": "DORM",
   "name": "Dorman Products, Inc.",
   "last_sale": "79.52",
   "market_cap": "$2.64B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/dorm",
   "FIELD9": ""
 },
 {
   "symbol": "DOVA",
   "name": "Dova Pharmaceuticals, Inc.",
   "last_sale": "23.95",
   "market_cap": "$675.44M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/dova",
   "FIELD9": ""
 },
 {
   "symbol": "LYL",
   "name": "Dragon Victory International Limited",
   "last_sale": "1.45",
   "market_cap": "$16.56M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Finance/Investors Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lyl",
   "FIELD9": ""
 },
 {
   "symbol": "DOTA",
   "name": "Draper Oakwood Technology Acquisition, Inc.",
   "last_sale": "10.1",
   "market_cap": "$23.5M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dota",
   "FIELD9": ""
 },
 {
   "symbol": "DOTAR",
   "name": "Draper Oakwood Technology Acquisition, Inc.",
   "last_sale": "0.45",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dotar",
   "FIELD9": ""
 },
 {
   "symbol": "DOTAU",
   "name": "Draper Oakwood Technology Acquisition, Inc.",
   "last_sale": "11.1",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dotau",
   "FIELD9": ""
 },
 {
   "symbol": "DOTAW",
   "name": "Draper Oakwood Technology Acquisition, Inc.",
   "last_sale": "0.55",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dotaw",
   "FIELD9": ""
 },
 {
   "symbol": "DBX",
   "name": "Dropbox, Inc.",
   "last_sale": "26.36",
   "market_cap": "$10.6B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/dbx",
   "FIELD9": ""
 },
 {
   "symbol": "DCAR",
   "name": "DropCar, Inc.",
   "last_sale": "0.5337",
   "market_cap": "$4.35M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/dcar",
   "FIELD9": ""
 },
 {
   "symbol": "DRYS",
   "name": "DryShips Inc.",
   "last_sale": "5.42",
   "market_cap": "$535M",
   "IPOyear": "2005",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/drys",
   "FIELD9": ""
 },
 {
   "symbol": "DSPG",
   "name": "DSP Group, Inc.",
   "last_sale": "11.75",
   "market_cap": "$263.66M",
   "IPOyear": "1994",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/dspg",
   "FIELD9": ""
 },
 {
   "symbol": "DLTH",
   "name": "Duluth Holdings Inc.",
   "last_sale": "29.81",
   "market_cap": "$971.46M",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/dlth",
   "FIELD9": ""
 },
 {
   "symbol": "DNKN",
   "name": "Dunkin&#39; Brands Group, Inc.",
   "last_sale": "73.3",
   "market_cap": "$6.14B",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/dnkn",
   "FIELD9": ""
 },
 {
   "symbol": "DRRX",
   "name": "DURECT Corporation",
   "last_sale": "1.07",
   "market_cap": "$173.34M",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/drrx",
   "FIELD9": ""
 },
 {
   "symbol": "DXPE",
   "name": "DXP Enterprises, Inc.",
   "last_sale": "41.12",
   "market_cap": "$714.96M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/dxpe",
   "FIELD9": ""
 },
 {
   "symbol": "DYSL",
   "name": "Dynasil Corporation of America",
   "last_sale": "1.35",
   "market_cap": "$23.38M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/dysl",
   "FIELD9": ""
 },
 {
   "symbol": "DYNT",
   "name": "Dynatronics Corporation",
   "last_sale": "3",
   "market_cap": "$24.27M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/dynt",
   "FIELD9": ""
 },
 {
   "symbol": "DVAX",
   "name": "Dynavax Technologies Corporation",
   "last_sale": "11.9",
   "market_cap": "$745.13M",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/dvax",
   "FIELD9": ""
 },
 {
   "symbol": "ETFC",
   "name": "E*TRADE Financial Corporation",
   "last_sale": "55.01",
   "market_cap": "$14.28B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/etfc",
   "FIELD9": ""
 },
 {
   "symbol": "SSP",
   "name": "E.W. Scripps Company (The)",
   "last_sale": "16.37",
   "market_cap": "$1.34B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/ssp",
   "FIELD9": ""
 },
 {
   "symbol": "EBMT",
   "name": "Eagle Bancorp Montana, Inc.",
   "last_sale": "18.9",
   "market_cap": "$103.2M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ebmt",
   "FIELD9": ""
 },
 {
   "symbol": "EGBN",
   "name": "Eagle Bancorp, Inc.",
   "last_sale": "53.3",
   "market_cap": "$1.83B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/egbn",
   "FIELD9": ""
 },
 {
   "symbol": "EGLE",
   "name": "Eagle Bulk Shipping Inc.",
   "last_sale": "5.66",
   "market_cap": "$413.39M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/egle",
   "FIELD9": ""
 },
 {
   "symbol": "EFBI",
   "name": "Eagle Financial Bancorp, Inc.",
   "last_sale": "15.9838",
   "market_cap": "$25.78M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/efbi",
   "FIELD9": ""
 },
 {
   "symbol": "EGRX",
   "name": "Eagle Pharmaceuticals, Inc.",
   "last_sale": "67.39",
   "market_cap": "$1.01B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/egrx",
   "FIELD9": ""
 },
 {
   "symbol": "IGLE",
   "name": "Eagleline Acquisition Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/igle",
   "FIELD9": ""
 },
 {
   "symbol": "EWBC",
   "name": "East West Bancorp, Inc.",
   "last_sale": "62.65",
   "market_cap": "$9.08B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ewbc",
   "FIELD9": ""
 },
 {
   "symbol": "EACQ",
   "name": "Easterly Acquisition Corp.",
   "last_sale": "10.35",
   "market_cap": "$67.62M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/eacq",
   "FIELD9": ""
 },
 {
   "symbol": "EACQU",
   "name": "Easterly Acquisition Corp.",
   "last_sale": "11.4",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/eacqu",
   "FIELD9": ""
 },
 {
   "symbol": "EACQW",
   "name": "Easterly Acquisition Corp.",
   "last_sale": "1.21",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/eacqw",
   "FIELD9": ""
 },
 {
   "symbol": "EML",
   "name": "Eastern Company (The)",
   "last_sale": "29.1",
   "market_cap": "$182.37M",
   "IPOyear": "n/a",
   "sector": "Industrials",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/eml",
   "FIELD9": ""
 },
 {
   "symbol": "EAST",
   "name": "Eastside Distilling, Inc.",
   "last_sale": "8.39",
   "market_cap": "$53.82M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/east",
   "FIELD9": ""
 },
 {
   "symbol": "EVGBC",
   "name": "Eaton Vance NextShares Trust",
   "last_sale": "100.02",
   "market_cap": "$60.01M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/evgbc",
   "FIELD9": ""
 },
 {
   "symbol": "EVSTC",
   "name": "Eaton Vance NextShares Trust",
   "last_sale": "100.02",
   "market_cap": "$95.02M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/evstc",
   "FIELD9": ""
 },
 {
   "symbol": "EVFTC",
   "name": "Eaton Vance NextShares Trust II",
   "last_sale": "100.05",
   "market_cap": "$52.53M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/evftc",
   "FIELD9": ""
 },
 {
   "symbol": "EVLMC",
   "name": "Eaton Vance NextShares Trust II",
   "last_sale": "100.04",
   "market_cap": "$70.03M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/evlmc",
   "FIELD9": ""
 },
 {
   "symbol": "OKDCC",
   "name": "Eaton Vance NextShares Trust II",
   "last_sale": "99.99",
   "market_cap": "$512.45M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/okdcc",
   "FIELD9": ""
 },
 {
   "symbol": "EBAY",
   "name": "eBay Inc.",
   "last_sale": "34.04",
   "market_cap": "$33.68B",
   "IPOyear": "1998",
   "sector": "Communication Services",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ebay",
   "FIELD9": ""
 },
 {
   "symbol": "EBAYL",
   "name": "eBay Inc.",
   "last_sale": "26.2",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ebayl",
   "FIELD9": ""
 },
 {
   "symbol": "EBIX",
   "name": "Ebix, Inc.",
   "last_sale": "80.375",
   "market_cap": "$2.53B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ebix",
   "FIELD9": ""
 },
 {
   "symbol": "ECHO",
   "name": "Echo Global Logistics, Inc.",
   "last_sale": "35.6",
   "market_cap": "$1.02B",
   "IPOyear": "2009",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/echo",
   "FIELD9": ""
 },
 {
   "symbol": "SATS",
   "name": "EchoStar Corporation",
   "last_sale": "46.56",
   "market_cap": "$4.48B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/sats",
   "FIELD9": ""
 },
 {
   "symbol": "EEI",
   "name": "Ecology and Environment, Inc.",
   "last_sale": "12.9",
   "market_cap": "$55.64M",
   "IPOyear": "1987",
   "sector": "Consumer Services",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/eei",
   "FIELD9": ""
 },
 {
   "symbol": "ESES",
   "name": "Eco-Stim Energy Solutions, Inc.",
   "last_sale": "0.39",
   "market_cap": "$29.2M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/eses",
   "FIELD9": ""
 },
 {
   "symbol": "EDAP",
   "name": "EDAP TMS S.A.",
   "last_sale": "2.92",
   "market_cap": "$84.67M",
   "IPOyear": "1997",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/edap",
   "FIELD9": ""
 },
 {
   "symbol": "EDGE",
   "name": "Edge Therapeutics, Inc.",
   "last_sale": "0.74",
   "market_cap": "$23.18M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/edge",
   "FIELD9": ""
 },
 {
   "symbol": "EDGW",
   "name": "Edgewater Technology, Inc.",
   "last_sale": "5.1",
   "market_cap": "$73.37M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/edgw",
   "FIELD9": ""
 },
 {
   "symbol": "EDNT",
   "name": "Edison Nation, Inc.",
   "last_sale": "7.55",
   "market_cap": "$33.13M",
   "IPOyear": "2018",
   "sector": "Consumer Non-Durables",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/ednt",
   "FIELD9": ""
 },
 {
   "symbol": "EDIT",
   "name": "Editas Medicine, Inc.",
   "last_sale": "30.1",
   "market_cap": "$1.44B",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/edit",
   "FIELD9": ""
 },
 {
   "symbol": "EDUC",
   "name": "Educational Development Corporation",
   "last_sale": "11.55",
   "market_cap": "$94.56M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Consumer Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/educ",
   "FIELD9": ""
 },
 {
   "symbol": "EGAN",
   "name": "eGain Corporation",
   "last_sale": "7.4",
   "market_cap": "$205.02M",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/egan",
   "FIELD9": ""
 },
 {
   "symbol": "EHTH",
   "name": "eHealth, Inc.",
   "last_sale": "27.62",
   "market_cap": "$529.64M",
   "IPOyear": "2006",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/ehth",
   "FIELD9": ""
 },
 {
   "symbol": "EIDX",
   "name": "Eidos Therapeutics, Inc.",
   "last_sale": "11.73",
   "market_cap": "$431.1M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/eidx",
   "FIELD9": ""
 },
 {
   "symbol": "EIGR",
   "name": "Eiger BioPharmaceuticals, Inc.",
   "last_sale": "11.7",
   "market_cap": "$166.66M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/eigr",
   "FIELD9": ""
 },
 {
   "symbol": "EKSO",
   "name": "Ekso Bionics Holdings, Inc.",
   "last_sale": "2.3",
   "market_cap": "$139.91M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/ekso",
   "FIELD9": ""
 },
 {
   "symbol": "LOCO",
   "name": "El Pollo Loco Holdings, Inc.",
   "last_sale": "12.7",
   "market_cap": "$490.33M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/loco",
   "FIELD9": ""
 },
 {
   "symbol": "EMITF",
   "name": "Elbit Imaging Ltd.",
   "last_sale": "2.2",
   "market_cap": "$20.22M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Building operators",
   "summary_quote": "https://www.nasdaq.com/symbol/emitf",
   "FIELD9": ""
 },
 {
   "symbol": "ESLT",
   "name": "Elbit Systems Ltd.",
   "last_sale": "133.46",
   "market_cap": "$5.71B",
   "IPOyear": "n/a",
   "sector": "Industrials",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/eslt",
   "FIELD9": ""
 },
 {
   "symbol": "ERI",
   "name": "Eldorado Resorts, Inc.",
   "last_sale": "48.2",
   "market_cap": "$3.73B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/eri",
   "FIELD9": ""
 },
 {
   "symbol": "SOLO",
   "name": "Electrameccanica Vehicles Corp. Ltd.",
   "last_sale": "2.576",
   "market_cap": "$71.12M",
   "IPOyear": "n/a",
   "sector": "Consumer Discretionary",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/solo",
   "FIELD9": ""
 },
 {
   "symbol": "SOLOW",
   "name": "Electrameccanica Vehicles Corp. Ltd.",
   "last_sale": "0.36",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Discretionary",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/solow",
   "FIELD9": ""
 },
 {
   "symbol": "ESIO",
   "name": "Electro Scientific Industries, Inc.",
   "last_sale": "17.8",
   "market_cap": "$607.65M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/esio",
   "FIELD9": ""
 },
 {
   "symbol": "ECOR",
   "name": "electroCore, Inc.",
   "last_sale": "13.68",
   "market_cap": "$402.88M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/ecor",
   "FIELD9": ""
 },
 {
   "symbol": "EA",
   "name": "Electronic Arts Inc.",
   "last_sale": "115.01",
   "market_cap": "$35.06B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ea",
   "FIELD9": ""
 },
 {
   "symbol": "EFII",
   "name": "Electronics for Imaging, Inc.",
   "last_sale": "34.7",
   "market_cap": "$1.54B",
   "IPOyear": "1992",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/efii",
   "FIELD9": ""
 },
 {
   "symbol": "ELSE",
   "name": "Electro-Sensors, Inc.",
   "last_sale": "3.799",
   "market_cap": "$12.9M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/else",
   "FIELD9": ""
 },
 {
   "symbol": "ESBK",
   "name": "Elmira Savings Bank NY (The)",
   "last_sale": "20.25",
   "market_cap": "$61.53M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/esbk",
   "FIELD9": ""
 },
 {
   "symbol": "ELOX",
   "name": "Eloxx Pharmaceuticals, Inc.",
   "last_sale": "16.04",
   "market_cap": "$559.12M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/elox",
   "FIELD9": ""
 },
 {
   "symbol": "ELTK",
   "name": "Eltek Ltd.",
   "last_sale": "3.71",
   "market_cap": "$7.53M",
   "IPOyear": "1997",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/eltk",
   "FIELD9": ""
 },
 {
   "symbol": "EMCI",
   "name": "EMC Insurance Group Inc.",
   "last_sale": "24.5",
   "market_cap": "$528.1M",
   "IPOyear": "1982",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/emci",
   "FIELD9": ""
 },
 {
   "symbol": "EMCF",
   "name": "Emclaire Financial Corp",
   "last_sale": "37.1",
   "market_cap": "$84.26M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/emcf",
   "FIELD9": ""
 },
 {
   "symbol": "EMKR",
   "name": "EMCORE Corporation",
   "last_sale": "4.6",
   "market_cap": "$126.47M",
   "IPOyear": "1997",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/emkr",
   "FIELD9": ""
 },
 {
   "symbol": "EMMS",
   "name": "Emmis Communications Corporation",
   "last_sale": "5.15",
   "market_cap": "$66.61M",
   "IPOyear": "1994",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/emms",
   "FIELD9": ""
 },
 {
   "symbol": "NYNY",
   "name": "Empire Resorts, Inc.",
   "last_sale": "9.05",
   "market_cap": "$296.25M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/nyny",
   "FIELD9": ""
 },
 {
   "symbol": "ENTA",
   "name": "Enanta Pharmaceuticals, Inc.",
   "last_sale": "92.41",
   "market_cap": "$1.79B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/enta",
   "FIELD9": ""
 },
 {
   "symbol": "ECPG",
   "name": "Encore Capital Group Inc",
   "last_sale": "38.2",
   "market_cap": "$1.18B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/ecpg",
   "FIELD9": ""
 },
 {
   "symbol": "WIRE",
   "name": "Encore Wire Corporation",
   "last_sale": "50.925",
   "market_cap": "$1.06B",
   "IPOyear": "1992",
   "sector": "Materials",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/wire",
   "FIELD9": ""
 },
 {
   "symbol": "ENDP",
   "name": "Endo International plc",
   "last_sale": "16.12",
   "market_cap": "$3.61B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/endp",
   "FIELD9": ""
 },
 {
   "symbol": "ECYT",
   "name": "Endocyte, Inc.",
   "last_sale": "17.53",
   "market_cap": "$1.23B",
   "IPOyear": "2011",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ecyt",
   "FIELD9": ""
 },
 {
   "symbol": "ELGX",
   "name": "Endologix, Inc.",
   "last_sale": "1.79",
   "market_cap": "$151.36M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/elgx",
   "FIELD9": ""
 },
 {
   "symbol": "NDRA",
   "name": "ENDRA Life Sciences Inc.",
   "last_sale": "3.63",
   "market_cap": "$14.24M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/ndra",
   "FIELD9": ""
 },
 {
   "symbol": "NDRAW",
   "name": "ENDRA Life Sciences Inc.",
   "last_sale": "0.7",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/ndraw",
   "FIELD9": ""
 },
 {
   "symbol": "EIGI",
   "name": "Endurance International Group Holdings, Inc.",
   "last_sale": "8.95",
   "market_cap": "$1.28B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/eigi",
   "FIELD9": ""
 },
 {
   "symbol": "WATT",
   "name": "Energous Corporation",
   "last_sale": "10.43",
   "market_cap": "$267.21M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/watt",
   "FIELD9": ""
 },
 {
   "symbol": "EFOI",
   "name": "Energy Focus, Inc.",
   "last_sale": "2.06",
   "market_cap": "$24.82M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Building Products",
   "summary_quote": "https://www.nasdaq.com/symbol/efoi",
   "FIELD9": ""
 },
 {
   "symbol": "EHR",
   "name": "Energy Hunter Resources, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ehr",
   "FIELD9": ""
 },
 {
   "symbol": "ERII",
   "name": "Energy Recovery, Inc.",
   "last_sale": "9.13",
   "market_cap": "$489.18M",
   "IPOyear": "2008",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/erii",
   "FIELD9": ""
 },
 {
   "symbol": "EGC",
   "name": "Energy XXI Gulf Coast, Inc.",
   "last_sale": "7.89",
   "market_cap": "$263.5M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/egc",
   "FIELD9": ""
 },
 {
   "symbol": "ENG",
   "name": "ENGlobal Corporation",
   "last_sale": "1.04",
   "market_cap": "$28.61M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/eng",
   "FIELD9": ""
 },
 {
   "symbol": "ENPH",
   "name": "Enphase Energy, Inc.",
   "last_sale": "4.39",
   "market_cap": "$458.09M",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/enph",
   "FIELD9": ""
 },
 {
   "symbol": "ESGR",
   "name": "Enstar Group Limited",
   "last_sale": "213.1",
   "market_cap": "$4.57B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/esgr",
   "FIELD9": ""
 },
 {
   "symbol": "ESGRP",
   "name": "Enstar Group Limited",
   "last_sale": "26.21",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/esgrp",
   "FIELD9": ""
 },
 {
   "symbol": "ENFC",
   "name": "Entegra Financial Corp.",
   "last_sale": "26.05",
   "market_cap": "$179.53M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/enfc",
   "FIELD9": ""
 },
 {
   "symbol": "ENTG",
   "name": "Entegris, Inc.",
   "last_sale": "30",
   "market_cap": "$4.25B",
   "IPOyear": "2000",
   "sector": "Consumer Non-Durables",
   "industry": "Plastic Products",
   "summary_quote": "https://www.nasdaq.com/symbol/entg",
   "FIELD9": ""
 },
 {
   "symbol": "ENTX",
   "name": "Entera Bio Ltd.",
   "last_sale": "5.24",
   "market_cap": "$59.88M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/entx",
   "FIELD9": ""
 },
 {
   "symbol": "ENTXW",
   "name": "Entera Bio Ltd.",
   "last_sale": "0.89",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/entxw",
   "FIELD9": ""
 },
 {
   "symbol": "EBTC",
   "name": "Enterprise Bancorp Inc",
   "last_sale": "35.9",
   "market_cap": "$419.85M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ebtc",
   "FIELD9": ""
 },
 {
   "symbol": "EFSC",
   "name": "Enterprise Financial Services Corporation",
   "last_sale": "54.7",
   "market_cap": "$1.27B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/efsc",
   "FIELD9": ""
 },
 {
   "symbol": "EPZM",
   "name": "Epizyme, Inc.",
   "last_sale": "10.3",
   "market_cap": "$715.88M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/epzm",
   "FIELD9": ""
 },
 {
   "symbol": "PLUS",
   "name": "ePlus inc.",
   "last_sale": "94",
   "market_cap": "$1.29B",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Retail: Computer Software & Peripheral Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/plus",
   "FIELD9": ""
 },
 {
   "symbol": "EQIX",
   "name": "Equinix, Inc.",
   "last_sale": "441.68",
   "market_cap": "$35.12B",
   "IPOyear": "2000",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/eqix",
   "FIELD9": ""
 },
 {
   "symbol": "EQBK",
   "name": "Equity Bancshares, Inc.",
   "last_sale": "40.73",
   "market_cap": "$643.03M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/eqbk",
   "FIELD9": ""
 },
 {
   "symbol": "ERIC",
   "name": "Ericsson",
   "last_sale": "8.79",
   "market_cap": "$29.31B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/eric",
   "FIELD9": ""
 },
 {
   "symbol": "ERIE",
   "name": "Erie Indemnity Company",
   "last_sale": "129.04",
   "market_cap": "$6.75B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/erie",
   "FIELD9": ""
 },
 {
   "symbol": "ERYP",
   "name": "Erytech Pharma S.A.",
   "last_sale": "9.9405",
   "market_cap": "$178.31M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/eryp",
   "FIELD9": ""
 },
 {
   "symbol": "ESCA",
   "name": "Escalade, Incorporated",
   "last_sale": "12.85",
   "market_cap": "$185.55M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/esca",
   "FIELD9": ""
 },
 {
   "symbol": "ESPR",
   "name": "Esperion Therapeutics, Inc.",
   "last_sale": "43.16",
   "market_cap": "$1.16B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/espr",
   "FIELD9": ""
 },
 {
   "symbol": "ESQ",
   "name": "Esquire Financial Holdings, Inc.",
   "last_sale": "24.71",
   "market_cap": "$183.98M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/esq",
   "FIELD9": ""
 },
 {
   "symbol": "ESSA",
   "name": "ESSA Bancorp, Inc.",
   "last_sale": "16.28",
   "market_cap": "$191.95M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/essa",
   "FIELD9": ""
 },
 {
   "symbol": "EPIX",
   "name": "ESSA Pharma Inc.",
   "last_sale": "2.67",
   "market_cap": "$15.42M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/epix",
   "FIELD9": ""
 },
 {
   "symbol": "ESND",
   "name": "Essendant Inc.",
   "last_sale": "12.88",
   "market_cap": "$484.86M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/esnd",
   "FIELD9": ""
 },
 {
   "symbol": "ESTA",
   "name": "Establishment Labs Holdings Inc.",
   "last_sale": "24.3",
   "market_cap": "$497.45M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/esta",
   "FIELD9": ""
 },
 {
   "symbol": "ESTR",
   "name": "Estre Ambiental, Inc.",
   "last_sale": "6.5",
   "market_cap": "$332.71M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/estr",
   "FIELD9": ""
 },
 {
   "symbol": "ESTRW",
   "name": "Estre Ambiental, Inc.",
   "last_sale": "0.35",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/estrw",
   "FIELD9": ""
 },
 {
   "symbol": "VBND",
   "name": "ETF Series Solutions Trust Vident Core U.S. Bond Strategy Fund",
   "last_sale": "47.34",
   "market_cap": "$407.12M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vbnd",
   "FIELD9": ""
 },
 {
   "symbol": "VUSE",
   "name": "ETF Series Solutions Trust Vident Core US Equity ETF",
   "last_sale": "34.8807",
   "market_cap": "$530.19M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vuse",
   "FIELD9": ""
 },
 {
   "symbol": "VIDI",
   "name": "ETF Series Solutions Trust Vident International Equity Fund",
   "last_sale": "25.6001",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vidi",
   "FIELD9": ""
 },
 {
   "symbol": "ETSY",
   "name": "Etsy, Inc.",
   "last_sale": "47.54",
   "market_cap": "$5.69B",
   "IPOyear": "2015",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/etsy",
   "FIELD9": ""
 },
 {
   "symbol": "CLWT",
   "name": "Euro Tech Holdings Company Limited",
   "last_sale": "3.75",
   "market_cap": "$7.73M",
   "IPOyear": "1997",
   "sector": "Consumer Durables",
   "industry": "Diversified Electronic Products",
   "summary_quote": "https://www.nasdaq.com/symbol/clwt",
   "FIELD9": ""
 },
 {
   "symbol": "EDRY",
   "name": "EuroDry Ltd.",
   "last_sale": "7.45",
   "market_cap": "$16.79M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/edry",
   "FIELD9": ""
 },
 {
   "symbol": "EEFT",
   "name": "Euronet Worldwide, Inc.",
   "last_sale": "102.17",
   "market_cap": "$5.21B",
   "IPOyear": "1997",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/eeft",
   "FIELD9": ""
 },
 {
   "symbol": "ESEA",
   "name": "Euroseas Ltd.",
   "last_sale": "1.45",
   "market_cap": "$16.35M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/esea",
   "FIELD9": ""
 },
 {
   "symbol": "EVLO",
   "name": "Evelo Biosciences, Inc.",
   "last_sale": "12.67",
   "market_cap": "$402.17M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/evlo",
   "FIELD9": ""
 },
 {
   "symbol": "EVBG",
   "name": "Everbridge, Inc.",
   "last_sale": "56.03",
   "market_cap": "$1.65B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/evbg",
   "FIELD9": ""
 },
 {
   "symbol": "EVK",
   "name": "Ever-Glory International Group, Inc.",
   "last_sale": "3.15",
   "market_cap": "$46.61M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/evk",
   "FIELD9": ""
 },
 {
   "symbol": "EVER",
   "name": "EverQuote, Inc.",
   "last_sale": "15.16",
   "market_cap": "$378.07M",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/ever",
   "FIELD9": ""
 },
 {
   "symbol": "MRAM",
   "name": "Everspin Technologies, Inc.",
   "last_sale": "7.48",
   "market_cap": "$126.44M",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/mram",
   "FIELD9": ""
 },
 {
   "symbol": "EVLV",
   "name": "EVINE Live Inc.",
   "last_sale": "1.09",
   "market_cap": "$72.31M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/evlv",
   "FIELD9": ""
 },
 {
   "symbol": "EVOP",
   "name": "EVO Payments, Inc.",
   "last_sale": "25.74",
   "market_cap": "$2.06B",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/evop",
   "FIELD9": ""
 },
 {
   "symbol": "EVFM",
   "name": "Evofem Biosciences, Inc.",
   "last_sale": "3.75",
   "market_cap": "$96.77M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/evfm",
   "FIELD9": ""
 },
 {
   "symbol": "EVGN",
   "name": "Evogene Ltd.",
   "last_sale": "3.1386",
   "market_cap": "$80.83M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/evgn",
   "FIELD9": ""
 },
 {
   "symbol": "EVOK",
   "name": "Evoke Pharma, Inc.",
   "last_sale": "3.14",
   "market_cap": "$53.06M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/evok",
   "FIELD9": ""
 },
 {
   "symbol": "EOLS",
   "name": "Evolus, Inc.",
   "last_sale": "18.86",
   "market_cap": "$503.09M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/eols",
   "FIELD9": ""
 },
 {
   "symbol": "EVOL",
   "name": "Evolving Systems, Inc.",
   "last_sale": "2.25",
   "market_cap": "$27.26M",
   "IPOyear": "1998",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/evol",
   "FIELD9": ""
 },
 {
   "symbol": "EXAS",
   "name": "Exact Sciences Corporation",
   "last_sale": "76.29",
   "market_cap": "$9.36B",
   "IPOyear": "2001",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/exas",
   "FIELD9": ""
 },
 {
   "symbol": "FLAG",
   "name": "Exchange Traded Concepts Trust FLAG-Forensic Accounting Long-S",
   "last_sale": "43.15",
   "market_cap": "$17.26M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/flag",
   "FIELD9": ""
 },
 {
   "symbol": "ROBO",
   "name": "Exchange Traded Concepts Trust ROBO Global Robotics and Automa",
   "last_sale": "42.78",
   "market_cap": "$196.79M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/robo",
   "FIELD9": ""
 },
 {
   "symbol": "XELA",
   "name": "Exela Technologies, Inc.",
   "last_sale": "6.96",
   "market_cap": "$1.05B",
   "IPOyear": "2015",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/xela",
   "FIELD9": ""
 },
 {
   "symbol": "EXEL",
   "name": "Exelixis, Inc.",
   "last_sale": "16.76",
   "market_cap": "$5B",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/exel",
   "FIELD9": ""
 },
 {
   "symbol": "EXFO",
   "name": "EXFO Inc",
   "last_sale": "3.95",
   "market_cap": "$92.72M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/exfo",
   "FIELD9": ""
 },
 {
   "symbol": "EXLS",
   "name": "ExlService Holdings, Inc.",
   "last_sale": "66.18",
   "market_cap": "$2.27B",
   "IPOyear": "2006",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/exls",
   "FIELD9": ""
 },
 {
   "symbol": "EXPI",
   "name": "eXp World Holdings, Inc.",
   "last_sale": "19.11",
   "market_cap": "$1.1B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/expi",
   "FIELD9": ""
 },
 {
   "symbol": "EXPE",
   "name": "Expedia Group, Inc.",
   "last_sale": "133.73",
   "market_cap": "$19.99B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/expe",
   "FIELD9": ""
 },
 {
   "symbol": "EXPD",
   "name": "Expeditors International of Washington, Inc.",
   "last_sale": "73.68",
   "market_cap": "$12.85B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/expd",
   "FIELD9": ""
 },
 {
   "symbol": "EXPO",
   "name": "Exponent, Inc.",
   "last_sale": "52.6",
   "market_cap": "$2.74B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/expo",
   "FIELD9": ""
 },
 {
   "symbol": "ESRX",
   "name": "Express Scripts Holding Company",
   "last_sale": "94.58",
   "market_cap": "$53.17B",
   "IPOyear": "1992",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/esrx",
   "FIELD9": ""
 },
 {
   "symbol": "STAY",
   "name": "Extended Stay America, Inc.",
   "last_sale": "19.835",
   "market_cap": "$3.75B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/stay",
   "FIELD9": ""
 },
 {
   "symbol": "XOG",
   "name": "Extraction Oil & Gas, Inc.",
   "last_sale": "11.02",
   "market_cap": "$1.93B",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/xog",
   "FIELD9": ""
 },
 {
   "symbol": "EXTR",
   "name": "Extreme Networks, Inc.",
   "last_sale": "5.92",
   "market_cap": "$700.46M",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/extr",
   "FIELD9": ""
 },
 {
   "symbol": "EYEG",
   "name": "Eyegate Pharmaceuticals, Inc.",
   "last_sale": "0.3471",
   "market_cap": "$15.08M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/eyeg",
   "FIELD9": ""
 },
 {
   "symbol": "EYEGW",
   "name": "Eyegate Pharmaceuticals, Inc.",
   "last_sale": "0.077",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/eyegw",
   "FIELD9": ""
 },
 {
   "symbol": "EYEN",
   "name": "Eyenovia, Inc.",
   "last_sale": "4.45",
   "market_cap": "$44.49M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/eyen",
   "FIELD9": ""
 },
 {
   "symbol": "EYPT",
   "name": "EyePoint Pharmaceuticals, Inc.",
   "last_sale": "2.6",
   "market_cap": "$193.73M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/eypt",
   "FIELD9": ""
 },
 {
   "symbol": "EZPW",
   "name": "EZCORP, Inc.",
   "last_sale": "10.95",
   "market_cap": "$596.39M",
   "IPOyear": "1991",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/ezpw",
   "FIELD9": ""
 },
 {
   "symbol": "FFIV",
   "name": "F5 Networks, Inc.",
   "last_sale": "194.55",
   "market_cap": "$11.83B",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ffiv",
   "FIELD9": ""
 },
 {
   "symbol": "FB",
   "name": "Facebook, Inc.",
   "last_sale": "162.93",
   "market_cap": "$470.41B",
   "IPOyear": "2012",
   "sector": "Communication Services",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/fb",
   "FIELD9": ""
 },
 {
   "symbol": "FLMN",
   "name": "Falcon Minerals Corporation",
   "last_sale": "11.25",
   "market_cap": "$965.87M",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/flmn",
   "FIELD9": ""
 },
 {
   "symbol": "FLMNW",
   "name": "Falcon Minerals Corporation",
   "last_sale": "1.744",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/flmnw",
   "FIELD9": ""
 },
 {
   "symbol": "DAVE",
   "name": "Famous Dave&#39;s of America, Inc.",
   "last_sale": "6.4",
   "market_cap": "$58.19M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/dave",
   "FIELD9": ""
 },
 {
   "symbol": "FANH",
   "name": "Fanhua Inc.",
   "last_sale": "28.4",
   "market_cap": "$1.85B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/fanh",
   "FIELD9": ""
 },
 {
   "symbol": "FARM",
   "name": "Farmer Brothers Company",
   "last_sale": "27.25",
   "market_cap": "$462.01M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/farm",
   "FIELD9": ""
 },
 {
   "symbol": "FMAO",
   "name": "Farmers & Merchants Bancorp, Inc.",
   "last_sale": "42.76",
   "market_cap": "$396.12M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/fmao",
   "FIELD9": ""
 },
 {
   "symbol": "FMNB",
   "name": "Farmers National Banc Corp.",
   "last_sale": "15.4",
   "market_cap": "$425.67M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fmnb",
   "FIELD9": ""
 },
 {
   "symbol": "FAMI",
   "name": "FARMMI, INC.",
   "last_sale": "4.88",
   "market_cap": "$57M",
   "IPOyear": "2018",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/fami",
   "FIELD9": ""
 },
 {
   "symbol": "FARO",
   "name": "FARO Technologies, Inc.",
   "last_sale": "65.6",
   "market_cap": "$1.11B",
   "IPOyear": "1997",
   "sector": "Industrials",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/faro",
   "FIELD9": ""
 },
 {
   "symbol": "FAST",
   "name": "Fastenal Company",
   "last_sale": "58.9",
   "market_cap": "$16.9B",
   "IPOyear": "1987",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/fast",
   "FIELD9": ""
 },
 {
   "symbol": "FAT",
   "name": "FAT Brands Inc.",
   "last_sale": "8.57",
   "market_cap": "$97.21M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/fat",
   "FIELD9": ""
 },
 {
   "symbol": "FATE",
   "name": "Fate Therapeutics, Inc.",
   "last_sale": "14.58",
   "market_cap": "$778.85M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/fate",
   "FIELD9": ""
 },
 {
   "symbol": "FBSS",
   "name": "Fauquier Bankshares, Inc.",
   "last_sale": "23.51",
   "market_cap": "$88.72M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fbss",
   "FIELD9": ""
 },
 {
   "symbol": "FSAC",
   "name": "Federal Street Acquisition Corp.",
   "last_sale": "10.13",
   "market_cap": "$152.6M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fsac",
   "FIELD9": ""
 },
 {
   "symbol": "FSACU",
   "name": "Federal Street Acquisition Corp.",
   "last_sale": "10.9",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fsacu",
   "FIELD9": ""
 },
 {
   "symbol": "FSACW",
   "name": "Federal Street Acquisition Corp.",
   "last_sale": "1.45",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fsacw",
   "FIELD9": ""
 },
 {
   "symbol": "FNHC",
   "name": "FedNat Holding Company",
   "last_sale": "25.12",
   "market_cap": "$319.83M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/fnhc",
   "FIELD9": ""
 },
 {
   "symbol": "FENC",
   "name": "Fennec Pharmaceuticals Inc.",
   "last_sale": "8.13",
   "market_cap": "$152.79M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/fenc",
   "FIELD9": ""
 },
 {
   "symbol": "GSM",
   "name": "Ferroglobe PLC",
   "last_sale": "8.44",
   "market_cap": "$1.45B",
   "IPOyear": "n/a",
   "sector": "Materials",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/gsm",
   "FIELD9": ""
 },
 {
   "symbol": "FFBW",
   "name": "FFBW, Inc.",
   "last_sale": "11.46",
   "market_cap": "$75.78M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/ffbw",
   "FIELD9": ""
 },
 {
   "symbol": "FCSC",
   "name": "Fibrocell Science Inc.",
   "last_sale": "2.16",
   "market_cap": "$20.12M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/fcsc",
   "FIELD9": ""
 },
 {
   "symbol": "FGEN",
   "name": "FibroGen, Inc",
   "last_sale": "57.8",
   "market_cap": "$4.87B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/fgen",
   "FIELD9": ""
 },
 {
   "symbol": "FDBC",
   "name": "Fidelity D & D Bancorp, Inc.",
   "last_sale": "74.9",
   "market_cap": "$281.03M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fdbc",
   "FIELD9": ""
 },
 {
   "symbol": "ONEQ",
   "name": "Fidelity Nasdaq Composite Index Tracking Stock",
   "last_sale": "313.17",
   "market_cap": "$1.66B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/oneq",
   "FIELD9": ""
 },
 {
   "symbol": "LION",
   "name": "Fidelity Southern Corporation",
   "last_sale": "25.55",
   "market_cap": "$695.33M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/lion",
   "FIELD9": ""
 },
 {
   "symbol": "FDUS",
   "name": "Fidus Investment Corporation",
   "last_sale": "14.75",
   "market_cap": "$360.83M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fdus",
   "FIELD9": ""
 },
 {
   "symbol": "FDUSL",
   "name": "Fidus Investment Corporation",
   "last_sale": "25.6935",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fdusl",
   "FIELD9": ""
 },
 {
   "symbol": "FRGI",
   "name": "Fiesta Restaurant Group, Inc.",
   "last_sale": "26.25",
   "market_cap": "$715.73M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/frgi",
   "FIELD9": ""
 },
 {
   "symbol": "FITB",
   "name": "Fifth Third Bancorp",
   "last_sale": "29.5",
   "market_cap": "$19.66B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fitb",
   "FIELD9": ""
 },
 {
   "symbol": "FITBI",
   "name": "Fifth Third Bancorp",
   "last_sale": "27.79",
   "market_cap": "$500.22M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fitbi",
   "FIELD9": ""
 },
 {
   "symbol": "FISI",
   "name": "Financial Institutions, Inc.",
   "last_sale": "32.3",
   "market_cap": "$514.38M",
   "IPOyear": "1999",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fisi",
   "FIELD9": ""
 },
 {
   "symbol": "FNSR",
   "name": "Finisar Corporation",
   "last_sale": "18.47",
   "market_cap": "$2.16B",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/fnsr",
   "FIELD9": ""
 },
 {
   "symbol": "FNJN",
   "name": "Finjan Holdings, Inc.",
   "last_sale": "4.42",
   "market_cap": "$120.42M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Multi-Sector Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/fnjn",
   "FIELD9": ""
 },
 {
   "symbol": "FEYE",
   "name": "FireEye, Inc.",
   "last_sale": "16.83",
   "market_cap": "$3.28B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/feye",
   "FIELD9": ""
 },
 {
   "symbol": "FBNC",
   "name": "First Bancorp",
   "last_sale": "40.67",
   "market_cap": "$1.21B",
   "IPOyear": "1987",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fbnc",
   "FIELD9": ""
 },
 {
   "symbol": "FNLC",
   "name": "First Bancorp, Inc (ME)",
   "last_sale": "29.74",
   "market_cap": "$322.82M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fnlc",
   "FIELD9": ""
 },
 {
   "symbol": "FRBA",
   "name": "First Bank",
   "last_sale": "13.35",
   "market_cap": "$249.17M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/frba",
   "FIELD9": ""
 },
 {
   "symbol": "BUSE",
   "name": "First Busey Corporation",
   "last_sale": "31.3",
   "market_cap": "$1.53B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/buse",
   "FIELD9": ""
 },
 {
   "symbol": "FBIZ",
   "name": "First Business Financial Services, Inc.",
   "last_sale": "23.8",
   "market_cap": "$208.49M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fbiz",
   "FIELD9": ""
 },
 {
   "symbol": "FCAP",
   "name": "First Capital, Inc.",
   "last_sale": "39.49",
   "market_cap": "$132.53M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/fcap",
   "FIELD9": ""
 },
 {
   "symbol": "FCFS",
   "name": "First Cash, Inc.",
   "last_sale": "83",
   "market_cap": "$3.68B",
   "IPOyear": "1991",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/fcfs",
   "FIELD9": ""
 },
 {
   "symbol": "FCBP",
   "name": "First Choice Bancorp",
   "last_sale": "26.89",
   "market_cap": "$193.78M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fcbp",
   "FIELD9": ""
 },
 {
   "symbol": "FCNCA",
   "name": "First Citizens BancShares, Inc.",
   "last_sale": "465.32",
   "market_cap": "$5.54B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fcnca",
   "FIELD9": ""
 },
 {
   "symbol": "FCBC",
   "name": "First Community Bancshares, Inc.",
   "last_sale": "34.05",
   "market_cap": "$564.37M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fcbc",
   "FIELD9": ""
 },
 {
   "symbol": "FCCO",
   "name": "First Community Corporation",
   "last_sale": "24.8",
   "market_cap": "$188.61M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fcco",
   "FIELD9": ""
 },
 {
   "symbol": "FBNK",
   "name": "First Connecticut Bancorp, Inc.",
   "last_sale": "31.05",
   "market_cap": "$497.92M",
   "IPOyear": "2011",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fbnk",
   "FIELD9": ""
 },
 {
   "symbol": "FDEF",
   "name": "First Defiance Financial Corp.",
   "last_sale": "31.33",
   "market_cap": "$639.16M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/fdef",
   "FIELD9": ""
 },
 {
   "symbol": "FFBC",
   "name": "First Financial Bancorp.",
   "last_sale": "30.35",
   "market_cap": "$2.97B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ffbc",
   "FIELD9": ""
 },
 {
   "symbol": "FFBCW",
   "name": "First Financial Bancorp.",
   "last_sale": "20.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ffbcw",
   "FIELD9": ""
 },
 {
   "symbol": "FFIN",
   "name": "First Financial Bankshares, Inc.",
   "last_sale": "61",
   "market_cap": "$4.13B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ffin",
   "FIELD9": ""
 },
 {
   "symbol": "THFF",
   "name": "First Financial Corporation Indiana",
   "last_sale": "51.85",
   "market_cap": "$635.42M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/thff",
   "FIELD9": ""
 },
 {
   "symbol": "FFNW",
   "name": "First Financial Northwest, Inc.",
   "last_sale": "17",
   "market_cap": "$185.55M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ffnw",
   "FIELD9": ""
 },
 {
   "symbol": "FFWM",
   "name": "First Foundation Inc.",
   "last_sale": "16.71",
   "market_cap": "$741.87M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ffwm",
   "FIELD9": ""
 },
 {
   "symbol": "FGBI",
   "name": "First Guaranty Bancshares, Inc.",
   "last_sale": "26",
   "market_cap": "$228.99M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/fgbi",
   "FIELD9": ""
 },
 {
   "symbol": "FHB",
   "name": "First Hawaiian, Inc.",
   "last_sale": "28.24",
   "market_cap": "$3.81B",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fhb",
   "FIELD9": ""
 },
 {
   "symbol": "INBK",
   "name": "First Internet Bancorp",
   "last_sale": "31",
   "market_cap": "$315.63M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/inbk",
   "FIELD9": ""
 },
 {
   "symbol": "INBKL",
   "name": "First Internet Bancorp",
   "last_sale": "25.5901",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/inbkl",
   "FIELD9": ""
 },
 {
   "symbol": "FIBK",
   "name": "First Interstate BancSystem, Inc.",
   "last_sale": "45.7",
   "market_cap": "$2.77B",
   "IPOyear": "2010",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fibk",
   "FIELD9": ""
 },
 {
   "symbol": "FRME",
   "name": "First Merchants Corporation",
   "last_sale": "47.76",
   "market_cap": "$2.37B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/frme",
   "FIELD9": ""
 },
 {
   "symbol": "FMBH",
   "name": "First Mid-Illinois Bancshares, Inc.",
   "last_sale": "40.34",
   "market_cap": "$616.8M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fmbh",
   "FIELD9": ""
 },
 {
   "symbol": "FMBI",
   "name": "First Midwest Bancorp, Inc.",
   "last_sale": "27.46",
   "market_cap": "$2.83B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fmbi",
   "FIELD9": ""
 },
 {
   "symbol": "FNWB",
   "name": "First Northwest Bancorp",
   "last_sale": "15.34",
   "market_cap": "$176.19M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fnwb",
   "FIELD9": ""
 },
 {
   "symbol": "FSFG",
   "name": "First Savings Financial Group, Inc.",
   "last_sale": "69.2",
   "market_cap": "$158.61M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/fsfg",
   "FIELD9": ""
 },
 {
   "symbol": "FSLR",
   "name": "First Solar, Inc.",
   "last_sale": "49.97",
   "market_cap": "$5.24B",
   "IPOyear": "2006",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/fslr",
   "FIELD9": ""
 },
 {
   "symbol": "FAAR",
   "name": "First Trust Alternative Absolute Return Strategy ETF",
   "last_sale": "28.6497",
   "market_cap": "$18.62M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/faar",
   "FIELD9": ""
 },
 {
   "symbol": "FPA",
   "name": "First Trust Asia Pacific Ex-Japan AlphaDEX Fund",
   "last_sale": "31.6887",
   "market_cap": "$41.2M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fpa",
   "FIELD9": ""
 },
 {
   "symbol": "BICK",
   "name": "First Trust BICK Index Fund",
   "last_sale": "26.4713",
   "market_cap": "$190.59M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bick",
   "FIELD9": ""
 },
 {
   "symbol": "FBZ",
   "name": "First Trust Brazil AlphaDEX Fund",
   "last_sale": "11.46",
   "market_cap": "$7.45M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fbz",
   "FIELD9": ""
 },
 {
   "symbol": "FTHI",
   "name": "First Trust BuyWrite Income ETF",
   "last_sale": "23.34",
   "market_cap": "$69.42M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fthi",
   "FIELD9": ""
 },
 {
   "symbol": "FCAL",
   "name": "First Trust California Municipal High income ETF",
   "last_sale": "49.9169",
   "market_cap": "$19.97M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fcal",
   "FIELD9": ""
 },
 {
   "symbol": "FCAN",
   "name": "First Trust Canada AlphaDEX Fund",
   "last_sale": "25.52",
   "market_cap": "$17.86M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fcan",
   "FIELD9": ""
 },
 {
   "symbol": "FTCS",
   "name": "First Trust Capital Strength ETF",
   "last_sale": "55.82",
   "market_cap": "$1.18B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftcs",
   "FIELD9": ""
 },
 {
   "symbol": "FCEF",
   "name": "First Trust CEF Income Opportunity ETF",
   "last_sale": "22.23",
   "market_cap": "$45.68M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fcef",
   "FIELD9": ""
 },
 {
   "symbol": "FCA",
   "name": "First Trust China AlphaDEX Fund",
   "last_sale": "28.0701",
   "market_cap": "$9.82M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fca",
   "FIELD9": ""
 },
 {
   "symbol": "SKYY",
   "name": "First Trust Cloud Computing ETF",
   "last_sale": "56.19",
   "market_cap": "$2.03B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/skyy",
   "FIELD9": ""
 },
 {
   "symbol": "RNDM",
   "name": "First Trust Developed International Equity Select ETF",
   "last_sale": "50.79",
   "market_cap": "$27.93M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rndm",
   "FIELD9": ""
 },
 {
   "symbol": "FDT",
   "name": "First Trust Developed Markets Ex-US AlphaDEX Fund",
   "last_sale": "59.89",
   "market_cap": "$1.23B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fdt",
   "FIELD9": ""
 },
 {
   "symbol": "FDTS",
   "name": "First Trust Developed Markets ex-US Small Cap AlphaDEX Fund",
   "last_sale": "41.7256",
   "market_cap": "$14.6M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fdts",
   "FIELD9": ""
 },
 {
   "symbol": "FVC",
   "name": "First Trust Dorsey Wright Dynamic Focus 5 ETF",
   "last_sale": "29.002",
   "market_cap": "$619.19M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fvc",
   "FIELD9": ""
 },
 {
   "symbol": "FV",
   "name": "First Trust Dorsey Wright Focus 5 ETF",
   "last_sale": "31.18",
   "market_cap": "$2.88B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fv",
   "FIELD9": ""
 },
 {
   "symbol": "IFV",
   "name": "First Trust Dorsey Wright International Focus 5 ETF",
   "last_sale": "20.57",
   "market_cap": "$795.03M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ifv",
   "FIELD9": ""
 },
 {
   "symbol": "DDIV",
   "name": "First Trust Dorsey Wright Momentum & Dividend ETF",
   "last_sale": "25.48",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ddiv",
   "FIELD9": ""
 },
 {
   "symbol": "DVOL",
   "name": "First Trust Dorsey Wright Momentum & Low Volatility ETF",
   "last_sale": "20.1488",
   "market_cap": "$10.07M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dvol",
   "FIELD9": ""
 },
 {
   "symbol": "DVLU",
   "name": "First Trust Dorsey Wright Momentum & Value ETF",
   "last_sale": "19.9081",
   "market_cap": "$9.95M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dvlu",
   "FIELD9": ""
 },
 {
   "symbol": "DWPP",
   "name": "First Trust Dorsey Wright People&#39;s Portfolio ETF",
   "last_sale": "30.79",
   "market_cap": "$38.49M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dwpp",
   "FIELD9": ""
 },
 {
   "symbol": "DALI",
   "name": "First Trust DorseyWright DALI 1 ETF",
   "last_sale": "21.18",
   "market_cap": "$48.71M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dali",
   "FIELD9": ""
 },
 {
   "symbol": "FEM",
   "name": "First Trust Emerging Markets AlphaDEX Fund",
   "last_sale": "25.4",
   "market_cap": "$533.4M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fem",
   "FIELD9": ""
 },
 {
   "symbol": "RNEM",
   "name": "First Trust Emerging Markets Equity Select ETF",
   "last_sale": "49.39",
   "market_cap": "$4.94M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rnem",
   "FIELD9": ""
 },
 {
   "symbol": "FEMB",
   "name": "First Trust Emerging Markets Local Currency Bond ETF",
   "last_sale": "36.62",
   "market_cap": "$58.59M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/femb",
   "FIELD9": ""
 },
 {
   "symbol": "FEMS",
   "name": "First Trust Emerging Markets Small Cap AlphaDEX Fund",
   "last_sale": "36.2",
   "market_cap": "$200.91M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fems",
   "FIELD9": ""
 },
 {
   "symbol": "FTSM",
   "name": "First Trust Enhanced Short Maturity ETF",
   "last_sale": "59.98",
   "market_cap": "$2.61B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftsm",
   "FIELD9": ""
 },
 {
   "symbol": "FEP",
   "name": "First Trust Europe AlphaDEX Fund",
   "last_sale": "38.94",
   "market_cap": "$881.99M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fep",
   "FIELD9": ""
 },
 {
   "symbol": "FEUZ",
   "name": "First Trust Eurozone AlphaDEX ETF",
   "last_sale": "43.2181",
   "market_cap": "$99.4M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/feuz",
   "FIELD9": ""
 },
 {
   "symbol": "FGM",
   "name": "First Trust Germany AlphaDEX Fund",
   "last_sale": "47.7125",
   "market_cap": "$224.25M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fgm",
   "FIELD9": ""
 },
 {
   "symbol": "FTGC",
   "name": "First Trust Global Tactical Commodity Strategy Fund",
   "last_sale": "19.6577",
   "market_cap": "$224.16M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftgc",
   "FIELD9": ""
 },
 {
   "symbol": "FTLB",
   "name": "First Trust Hedged BuyWrite Income ETF",
   "last_sale": "22.9744",
   "market_cap": "$13.78M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftlb",
   "FIELD9": ""
 },
 {
   "symbol": "HYLS",
   "name": "First Trust High Yield Long/Short ETF",
   "last_sale": "47.67",
   "market_cap": "$1.24B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hyls",
   "FIELD9": ""
 },
 {
   "symbol": "FHK",
   "name": "First Trust Hong Kong AlphaDEX Fund",
   "last_sale": "36.72",
   "market_cap": "$3.67M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fhk",
   "FIELD9": ""
 },
 {
   "symbol": "NFTY",
   "name": "First Trust India Nifty 50 Equal Weight ETF",
   "last_sale": "36.4",
   "market_cap": "$3.64M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nfty",
   "FIELD9": ""
 },
 {
   "symbol": "FTAG",
   "name": "First Trust Indxx Global Agriculture ETF",
   "last_sale": "26.8593",
   "market_cap": "$5.1M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftag",
   "FIELD9": ""
 },
 {
   "symbol": "FTRI",
   "name": "First Trust Indxx Global Natural Resources Income ETF",
   "last_sale": "12.69",
   "market_cap": "$8.88M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftri",
   "FIELD9": ""
 },
 {
   "symbol": "LEGR",
   "name": "First Trust Indxx Innovative Transaction & Process ETF",
   "last_sale": "30.6698",
   "market_cap": "$50.61M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/legr",
   "FIELD9": ""
 },
 {
   "symbol": "FPXI",
   "name": "First Trust International IPO ETF",
   "last_sale": "35.1199",
   "market_cap": "$26.34M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fpxi",
   "FIELD9": ""
 },
 {
   "symbol": "FJP",
   "name": "First Trust Japan AlphaDEX Fund",
   "last_sale": "57.2557",
   "market_cap": "$174.63M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fjp",
   "FIELD9": ""
 },
 {
   "symbol": "FEX",
   "name": "First Trust Large Cap Core AlphaDEX Fund",
   "last_sale": "63.01",
   "market_cap": "$1.6B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fex",
   "FIELD9": ""
 },
 {
   "symbol": "FTC",
   "name": "First Trust Large Cap Growth AlphaDEX Fund",
   "last_sale": "70.115",
   "market_cap": "$971.09M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftc",
   "FIELD9": ""
 },
 {
   "symbol": "RNLC",
   "name": "First Trust Large Cap US Equity Select ETF",
   "last_sale": "23.16",
   "market_cap": "$20.84M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rnlc",
   "FIELD9": ""
 },
 {
   "symbol": "FTA",
   "name": "First Trust Large Cap Value AlphaDEX Fund",
   "last_sale": "55.43",
   "market_cap": "$1.21B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fta",
   "FIELD9": ""
 },
 {
   "symbol": "FLN",
   "name": "First Trust Latin America AlphaDEX Fund",
   "last_sale": "18.61",
   "market_cap": "$21.4M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fln",
   "FIELD9": ""
 },
 {
   "symbol": "LMBS",
   "name": "First Trust Low Duration Opportunities ETF",
   "last_sale": "50.9417",
   "market_cap": "$1.62B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lmbs",
   "FIELD9": ""
 },
 {
   "symbol": "FMB",
   "name": "First Trust Managed Municipal ETF",
   "last_sale": "52.2501",
   "market_cap": "$438.9M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fmb",
   "FIELD9": ""
 },
 {
   "symbol": "FMK",
   "name": "First Trust Mega Cap AlphaDEX Fund",
   "last_sale": "37.2999",
   "market_cap": "$16.79M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fmk",
   "FIELD9": ""
 },
 {
   "symbol": "FNX",
   "name": "First Trust Mid Cap Core AlphaDEX Fund",
   "last_sale": "72.25",
   "market_cap": "$964.54M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fnx",
   "FIELD9": ""
 },
 {
   "symbol": "FNY",
   "name": "First Trust Mid Cap Growth AlphaDEX Fund",
   "last_sale": "46.16",
   "market_cap": "$251.57M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fny",
   "FIELD9": ""
 },
 {
   "symbol": "RNMC",
   "name": "First Trust Mid Cap US Equity Select ETF",
   "last_sale": "22.8",
   "market_cap": "$9.12M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rnmc",
   "FIELD9": ""
 },
 {
   "symbol": "FNK",
   "name": "First Trust Mid Cap Value AlphaDEX Fund",
   "last_sale": "37.5879",
   "market_cap": "$50.74M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fnk",
   "FIELD9": ""
 },
 {
   "symbol": "FAD",
   "name": "First Trust Multi Cap Growth AlphaDEX Fund",
   "last_sale": "76.64",
   "market_cap": "$218.42M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fad",
   "FIELD9": ""
 },
 {
   "symbol": "FAB",
   "name": "First Trust Multi Cap Value AlphaDEX Fund",
   "last_sale": "58.7072",
   "market_cap": "$93.93M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fab",
   "FIELD9": ""
 },
 {
   "symbol": "MDIV",
   "name": "First Trust Multi-Asset Diversified Income Index Fund",
   "last_sale": "18.64",
   "market_cap": "$690.61M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mdiv",
   "FIELD9": ""
 },
 {
   "symbol": "MCEF",
   "name": "First Trust Municipal CEF Income Opportunity ETF",
   "last_sale": "17.61",
   "market_cap": "$13.21M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mcef",
   "FIELD9": ""
 },
 {
   "symbol": "FMHI",
   "name": "First Trust Municipal High Income ETF",
   "last_sale": "50.2",
   "market_cap": "$30.12M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fmhi",
   "FIELD9": ""
 },
 {
   "symbol": "QABA",
   "name": "First Trust NASDAQ ABA Community Bank Index Fund",
   "last_sale": "55.64",
   "market_cap": "$400.61M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qaba",
   "FIELD9": ""
 },
 {
   "symbol": "ROBT",
   "name": "First Trust Nasdaq Artificial Intelligence and Robotics ETF",
   "last_sale": "32.4444",
   "market_cap": "$29.2M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/robt",
   "FIELD9": ""
 },
 {
   "symbol": "FTXO",
   "name": "First Trust Nasdaq Bank ETF",
   "last_sale": "29.34",
   "market_cap": "$1.42B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftxo",
   "FIELD9": ""
 },
 {
   "symbol": "QCLN",
   "name": "First Trust NASDAQ Clean Edge Green Energy Index Fund",
   "last_sale": "20.52",
   "market_cap": "$95.42M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qcln",
   "FIELD9": ""
 },
 {
   "symbol": "GRID",
   "name": "First Trust NASDAQ Clean Edge Smart Grid Infrastructure Index ",
   "last_sale": "49.79",
   "market_cap": "$34.85M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/grid",
   "FIELD9": ""
 },
 {
   "symbol": "CIBR",
   "name": "First Trust NASDAQ Cybersecurity ETF",
   "last_sale": "28.14",
   "market_cap": "$818.87M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cibr",
   "FIELD9": ""
 },
 {
   "symbol": "FTXG",
   "name": "First Trust Nasdaq Food & Beverage ETF",
   "last_sale": "19.7189",
   "market_cap": "$985984.44",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftxg",
   "FIELD9": ""
 },
 {
   "symbol": "CARZ",
   "name": "First Trust NASDAQ Global Auto Index Fund",
   "last_sale": "37.64",
   "market_cap": "$18.82M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/carz",
   "FIELD9": ""
 },
 {
   "symbol": "FTXN",
   "name": "First Trust Nasdaq Oil & Gas ETF",
   "last_sale": "24.44",
   "market_cap": "$22M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftxn",
   "FIELD9": ""
 },
 {
   "symbol": "FTXH",
   "name": "First Trust Nasdaq Pharmaceuticals ETF",
   "last_sale": "23.42",
   "market_cap": "$5.86M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftxh",
   "FIELD9": ""
 },
 {
   "symbol": "FTXD",
   "name": "First Trust Nasdaq Retail ETF",
   "last_sale": "24.55",
   "market_cap": "$2.46M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftxd",
   "FIELD9": ""
 },
 {
   "symbol": "FTXL",
   "name": "First Trust Nasdaq Semiconductor ETF",
   "last_sale": "31.15",
   "market_cap": "$37.38M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftxl",
   "FIELD9": ""
 },
 {
   "symbol": "FONE",
   "name": "First Trust NASDAQ Smartphone Index Fund",
   "last_sale": "49.6494",
   "market_cap": "$17.38M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fone",
   "FIELD9": ""
 },
 {
   "symbol": "TDIV",
   "name": "First Trust NASDAQ Technology Dividend Index Fund",
   "last_sale": "38.5483",
   "market_cap": "$948.48M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tdiv",
   "FIELD9": ""
 },
 {
   "symbol": "FTXR",
   "name": "First Trust Nasdaq Transportation ETF",
   "last_sale": "25.9085",
   "market_cap": "$3.89M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftxr",
   "FIELD9": ""
 },
 {
   "symbol": "QQEW",
   "name": "First Trust NASDAQ-100 Equal Weighted Index Fund",
   "last_sale": "63.68",
   "market_cap": "$582.67M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qqew",
   "FIELD9": ""
 },
 {
   "symbol": "QQXT",
   "name": "First Trust NASDAQ-100 Ex-Technology Sector Index Fund",
   "last_sale": "53.38",
   "market_cap": "$96.08M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qqxt",
   "FIELD9": ""
 },
 {
   "symbol": "QTEC",
   "name": "First Trust NASDAQ-100- Technology Index Fund",
   "last_sale": "79.2",
   "market_cap": "$2.59B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qtec",
   "FIELD9": ""
 },
 {
   "symbol": "AIRR",
   "name": "First Trust RBA American Industrial Renaissance ETF",
   "last_sale": "28.5",
   "market_cap": "$192.38M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/airr",
   "FIELD9": ""
 },
 {
   "symbol": "RDVY",
   "name": "First Trust Rising Dividend Achievers ETF",
   "last_sale": "31.91",
   "market_cap": "$686.07M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rdvy",
   "FIELD9": ""
 },
 {
   "symbol": "RFAP",
   "name": "First Trust RiverFront Dynamic Asia Pacific ETF",
   "last_sale": "56.97",
   "market_cap": "$56.97M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rfap",
   "FIELD9": ""
 },
 {
   "symbol": "RFDI",
   "name": "First Trust RiverFront Dynamic Developed International ETF",
   "last_sale": "62.33",
   "market_cap": "$589.02M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rfdi",
   "FIELD9": ""
 },
 {
   "symbol": "RFEM",
   "name": "First Trust RiverFront Dynamic Emerging Markets ETF",
   "last_sale": "63.15",
   "market_cap": "$113.67M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rfem",
   "FIELD9": ""
 },
 {
   "symbol": "RFEU",
   "name": "First Trust RiverFront Dynamic Europe ETF",
   "last_sale": "64.165",
   "market_cap": "$121.91M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rfeu",
   "FIELD9": ""
 },
 {
   "symbol": "FID",
   "name": "First Trust S&P International Dividend Aristocrats ETF",
   "last_sale": "17.52",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fid",
   "FIELD9": ""
 },
 {
   "symbol": "FTSL",
   "name": "First Trust Senior Loan Fund ETF",
   "last_sale": "48",
   "market_cap": "$1.83B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftsl",
   "FIELD9": ""
 },
 {
   "symbol": "FYX",
   "name": "First Trust Small Cap Core AlphaDEX Fund",
   "last_sale": "69.41",
   "market_cap": "$787.8M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fyx",
   "FIELD9": ""
 },
 {
   "symbol": "FYC",
   "name": "First Trust Small Cap Growth AlphaDEX Fund",
   "last_sale": "52.02",
   "market_cap": "$470.78M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fyc",
   "FIELD9": ""
 },
 {
   "symbol": "RNSC",
   "name": "First Trust Small Cap US Equity Select ETF",
   "last_sale": "23.18",
   "market_cap": "$4.64M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rnsc",
   "FIELD9": ""
 },
 {
   "symbol": "FYT",
   "name": "First Trust Small Cap Value AlphaDEX Fund",
   "last_sale": "39.71",
   "market_cap": "$73.46M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fyt",
   "FIELD9": ""
 },
 {
   "symbol": "SDVY",
   "name": "First Trust SMID Cap Rising Dividend Achievers ETF",
   "last_sale": "21.7846",
   "market_cap": "$4.36M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sdvy",
   "FIELD9": ""
 },
 {
   "symbol": "FKO",
   "name": "First Trust South Korea AlphaDEX Fund",
   "last_sale": "25.4584",
   "market_cap": "$2.55M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fko",
   "FIELD9": ""
 },
 {
   "symbol": "FCVT",
   "name": "First Trust SSI Strategic Convertible Securities ETF",
   "last_sale": "30.73",
   "market_cap": "$187.45M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fcvt",
   "FIELD9": ""
 },
 {
   "symbol": "FDIV",
   "name": "First Trust Strategic Income ETF",
   "last_sale": "49.4544",
   "market_cap": "$84.07M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fdiv",
   "FIELD9": ""
 },
 {
   "symbol": "FSZ",
   "name": "First Trust Switzerland AlphaDEX Fund",
   "last_sale": "52.0013",
   "market_cap": "$231.41M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fsz",
   "FIELD9": ""
 },
 {
   "symbol": "FIXD",
   "name": "First Trust TCW Opportunistic Fixed Income ETF",
   "last_sale": "48.82",
   "market_cap": "$322.21M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fixd",
   "FIELD9": ""
 },
 {
   "symbol": "TUSA",
   "name": "First Trust Total US Market AlphaDEX ETF",
   "last_sale": "36.36",
   "market_cap": "$16.36M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tusa",
   "FIELD9": ""
 },
 {
   "symbol": "FKU",
   "name": "First Trust United Kingdom AlphaDEX Fund",
   "last_sale": "38.39",
   "market_cap": "$11.52M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fku",
   "FIELD9": ""
 },
 {
   "symbol": "RNDV",
   "name": "First Trust US Equity Dividend Select ETF",
   "last_sale": "22.74",
   "market_cap": "$4.55M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rndv",
   "FIELD9": ""
 },
 {
   "symbol": "FUNC",
   "name": "First United Corporation",
   "last_sale": "18.9",
   "market_cap": "$133.86M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/func",
   "FIELD9": ""
 },
 {
   "symbol": "FUSB",
   "name": "First US Bancshares, Inc.",
   "last_sale": "11",
   "market_cap": "$67.01M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fusb",
   "FIELD9": ""
 },
 {
   "symbol": "MYFW",
   "name": "First Western Financial, Inc.",
   "last_sale": "16.53",
   "market_cap": "$124.69M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/myfw",
   "FIELD9": ""
 },
 {
   "symbol": "SVVC",
   "name": "Firsthand Technology Value Fund, Inc.",
   "last_sale": "16.29",
   "market_cap": "$118.95M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/svvc",
   "FIELD9": ""
 },
 {
   "symbol": "FSV",
   "name": "FirstService Corporation",
   "last_sale": "85.17",
   "market_cap": "$2.95B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/fsv",
   "FIELD9": ""
 },
 {
   "symbol": "FISV",
   "name": "Fiserv, Inc.",
   "last_sale": "81.42",
   "market_cap": "$32.97B",
   "IPOyear": "1986",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fisv",
   "FIELD9": ""
 },
 {
   "symbol": "FIVE",
   "name": "Five Below, Inc.",
   "last_sale": "125.24",
   "market_cap": "$6.98B",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/five",
   "FIELD9": ""
 },
 {
   "symbol": "FPRX",
   "name": "Five Prime Therapeutics, Inc.",
   "last_sale": "13.87",
   "market_cap": "$493.48M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/fprx",
   "FIELD9": ""
 },
 {
   "symbol": "FVE",
   "name": "Five Star Senior Living Inc.",
   "last_sale": "0.92",
   "market_cap": "$46.54M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/fve",
   "FIELD9": ""
 },
 {
   "symbol": "FIVN",
   "name": "Five9, Inc.",
   "last_sale": "43.2",
   "market_cap": "$2.52B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fivn",
   "FIELD9": ""
 },
 {
   "symbol": "FLEX",
   "name": "Flex Ltd.",
   "last_sale": "13.35",
   "market_cap": "$7.11B",
   "IPOyear": "1994",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/flex",
   "FIELD9": ""
 },
 {
   "symbol": "FLKS",
   "name": "Flex Pharma, Inc.",
   "last_sale": "0.431",
   "market_cap": "$7.79M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/flks",
   "FIELD9": ""
 },
 {
   "symbol": "FLXN",
   "name": "Flexion Therapeutics, Inc.",
   "last_sale": "18.4",
   "market_cap": "$695.81M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/flxn",
   "FIELD9": ""
 },
 {
   "symbol": "SKOR",
   "name": "FlexShares Credit-Scored US Corporate Bond Index Fund",
   "last_sale": "48.972",
   "market_cap": "$61.22M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/skor",
   "FIELD9": ""
 },
 {
   "symbol": "LKOR",
   "name": "FlexShares Credit-Scored US Long Corporate Bond Index Fund",
   "last_sale": "49.8",
   "market_cap": "$27.39M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lkor",
   "FIELD9": ""
 },
 {
   "symbol": "MBSD",
   "name": "FlexShares Disciplined Duration MBS Index Fund",
   "last_sale": "22.86",
   "market_cap": "$70.87M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mbsd",
   "FIELD9": ""
 },
 {
   "symbol": "ASET",
   "name": "FlexShares Real Assets Allocation Index Fund",
   "last_sale": "28.4101",
   "market_cap": "$14.92M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aset",
   "FIELD9": ""
 },
 {
   "symbol": "ESGG",
   "name": "FlexShares STOXX Global ESG Impact Index Fund",
   "last_sale": "99.9137",
   "market_cap": "$79.93M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/esgg",
   "FIELD9": ""
 },
 {
   "symbol": "ESG",
   "name": "FlexShares STOXX US ESG Impact Index Fund",
   "last_sale": "69.455",
   "market_cap": "$27.78M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/esg",
   "FIELD9": ""
 },
 {
   "symbol": "QLC",
   "name": "FlexShares US Quality Large Cap Index Fund",
   "last_sale": "36.18",
   "market_cap": "$61.51M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qlc",
   "FIELD9": ""
 },
 {
   "symbol": "FPAY",
   "name": "FlexShopper, Inc.",
   "last_sale": "1.8",
   "market_cap": "$9.85M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fpay",
   "FIELD9": ""
 },
 {
   "symbol": "FLXS",
   "name": "Flexsteel Industries, Inc.",
   "last_sale": "31.66",
   "market_cap": "$248.69M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/flxs",
   "FIELD9": ""
 },
 {
   "symbol": "FLIR",
   "name": "FLIR Systems, Inc.",
   "last_sale": "61.11",
   "market_cap": "$8.43B",
   "IPOyear": "1993",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/flir",
   "FIELD9": ""
 },
 {
   "symbol": "FLNT",
   "name": "Fluent, Inc.",
   "last_sale": "2.15",
   "market_cap": "$161.87M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/flnt",
   "FIELD9": ""
 },
 {
   "symbol": "FLDM",
   "name": "Fluidigm Corporation",
   "last_sale": "7.89",
   "market_cap": "$309M",
   "IPOyear": "2011",
   "sector": "Health Care",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/fldm",
   "FIELD9": ""
 },
 {
   "symbol": "FFIC",
   "name": "Flushing Financial Corporation",
   "last_sale": "25.52",
   "market_cap": "$722.1M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ffic",
   "FIELD9": ""
 },
 {
   "symbol": "FNCB",
   "name": "FNCB Bancorp Inc.",
   "last_sale": "10.89",
   "market_cap": "$183.16M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fncb",
   "FIELD9": ""
 },
 {
   "symbol": "FOMX",
   "name": "Foamix Pharmaceuticals Ltd.",
   "last_sale": "5.97",
   "market_cap": "$243.75M",
   "IPOyear": "2014",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/fomx",
   "FIELD9": ""
 },
 {
   "symbol": "FOCS",
   "name": "Focus Financial Partners Inc.",
   "last_sale": "47.68",
   "market_cap": "$3.11B",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/focs",
   "FIELD9": ""
 },
 {
   "symbol": "FONR",
   "name": "Fonar Corporation",
   "last_sale": "24.655",
   "market_cap": "$158.17M",
   "IPOyear": "1981",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/fonr",
   "FIELD9": ""
 },
 {
   "symbol": "FSCT",
   "name": "ForeScout Technologies, Inc.",
   "last_sale": "40.18",
   "market_cap": "$1.68B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/fsct",
   "FIELD9": ""
 },
 {
   "symbol": "FRSX",
   "name": "Foresight Autonomous Holdings Ltd.",
   "last_sale": "3.16",
   "market_cap": "$83.38M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/frsx",
   "FIELD9": ""
 },
 {
   "symbol": "FORM",
   "name": "FormFactor, Inc.",
   "last_sale": "13.2",
   "market_cap": "$974.98M",
   "IPOyear": "2003",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/form",
   "FIELD9": ""
 },
 {
   "symbol": "FORTY",
   "name": "Formula Systems (1985) Ltd.",
   "last_sale": "42.93",
   "market_cap": "$632.74M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/forty",
   "FIELD9": ""
 },
 {
   "symbol": "FORR",
   "name": "Forrester Research, Inc.",
   "last_sale": "45.25",
   "market_cap": "$817.85M",
   "IPOyear": "1996",
   "sector": "Consumer Services",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/forr",
   "FIELD9": ""
 },
 {
   "symbol": "FRTA",
   "name": "Forterra, Inc.",
   "last_sale": "7.98",
   "market_cap": "$512.43M",
   "IPOyear": "2016",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/frta",
   "FIELD9": ""
 },
 {
   "symbol": "FTNT",
   "name": "Fortinet, Inc.",
   "last_sale": "85.48",
   "market_cap": "$14.46B",
   "IPOyear": "2009",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ftnt",
   "FIELD9": ""
 },
 {
   "symbol": "FBIO",
   "name": "Fortress Biotech, Inc.",
   "last_sale": "1.58",
   "market_cap": "$85.86M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/fbio",
   "FIELD9": ""
 },
 {
   "symbol": "FBIOP",
   "name": "Fortress Biotech, Inc.",
   "last_sale": "18.75",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/fbiop",
   "FIELD9": ""
 },
 {
   "symbol": "FTSV",
   "name": "Forty Seven, Inc.",
   "last_sale": "13.245",
   "market_cap": "$411.23M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ftsv",
   "FIELD9": ""
 },
 {
   "symbol": "FMCI",
   "name": "Forum Merger II Corporation",
   "last_sale": "9.57",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fmci",
   "FIELD9": ""
 },
 {
   "symbol": "FMCIU",
   "name": "Forum Merger II Corporation",
   "last_sale": "10.1156",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fmciu",
   "FIELD9": ""
 },
 {
   "symbol": "FMCIW",
   "name": "Forum Merger II Corporation",
   "last_sale": "0.6",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fmciw",
   "FIELD9": ""
 },
 {
   "symbol": "FWRD",
   "name": "Forward Air Corporation",
   "last_sale": "69.36",
   "market_cap": "$2.04B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/fwrd",
   "FIELD9": ""
 },
 {
   "symbol": "FORD",
   "name": "Forward Industries, Inc.",
   "last_sale": "1.61",
   "market_cap": "$15.35M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Plastic Products",
   "summary_quote": "https://www.nasdaq.com/symbol/ford",
   "FIELD9": ""
 },
 {
   "symbol": "FWP",
   "name": "Forward Pharma A/S",
   "last_sale": "2.3",
   "market_cap": "$108.52M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/fwp",
   "FIELD9": ""
 },
 {
   "symbol": "FOSL",
   "name": "Fossil Group, Inc.",
   "last_sale": "22.92",
   "market_cap": "$1.13B",
   "IPOyear": "1993",
   "sector": "Consumer Non-Durables",
   "industry": "Consumer Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/fosl",
   "FIELD9": ""
 },
 {
   "symbol": "FOXF",
   "name": "Fox Factory Holding Corp.",
   "last_sale": "71.85",
   "market_cap": "$2.72B",
   "IPOyear": "2013",
   "sector": "Consumer Non-Durables",
   "industry": "Motor Vehicles",
   "summary_quote": "https://www.nasdaq.com/symbol/foxf",
   "FIELD9": ""
 },
 {
   "symbol": "FRAN",
   "name": "Francesca&#39;s Holdings Corporation",
   "last_sale": "3.86",
   "market_cap": "$139.82M",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/fran",
   "FIELD9": ""
 },
 {
   "symbol": "FELE",
   "name": "Franklin Electric Co., Inc.",
   "last_sale": "47.45",
   "market_cap": "$2.22B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/fele",
   "FIELD9": ""
 },
 {
   "symbol": "FKLY",
   "name": "Frankly, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fkly",
   "FIELD9": ""
 },
 {
   "symbol": "FRED",
   "name": "Fred&#39;s, Inc.",
   "last_sale": "1.97",
   "market_cap": "$73.4M",
   "IPOyear": "1992",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/fred",
   "FIELD9": ""
 },
 {
   "symbol": "RAIL",
   "name": "Freightcar America, Inc.",
   "last_sale": "16.31",
   "market_cap": "$203.28M",
   "IPOyear": "2005",
   "sector": "Capital Goods",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/rail",
   "FIELD9": ""
 },
 {
   "symbol": "FEIM",
   "name": "Frequency Electronics, Inc.",
   "last_sale": "9.7",
   "market_cap": "$84.68M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/feim",
   "FIELD9": ""
 },
 {
   "symbol": "FRPT",
   "name": "Freshpet, Inc.",
   "last_sale": "34.8",
   "market_cap": "$1.23B",
   "IPOyear": "2014",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/frpt",
   "FIELD9": ""
 },
 {
   "symbol": "FTDRV",
   "name": "frontdoor, inc.",
   "last_sale": "38.71",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ftdrv",
   "FIELD9": ""
 },
 {
   "symbol": "FTEO",
   "name": "FRONTEO, Inc.",
   "last_sale": "19.02",
   "market_cap": "$362.44M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fteo",
   "FIELD9": ""
 },
 {
   "symbol": "FTR",
   "name": "Frontier Communications Corporation",
   "last_sale": "6.47",
   "market_cap": "$684.59M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ftr",
   "FIELD9": ""
 },
 {
   "symbol": "FRPH",
   "name": "FRP Holdings, Inc.",
   "last_sale": "64.5",
   "market_cap": "$647.97M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/frph",
   "FIELD9": ""
 },
 {
   "symbol": "FSBW",
   "name": "FS Bancorp, Inc.",
   "last_sale": "54.155",
   "market_cap": "$200.84M",
   "IPOyear": "2012",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fsbw",
   "FIELD9": ""
 },
 {
   "symbol": "FSBC",
   "name": "FSB Bancorp, Inc.",
   "last_sale": "18",
   "market_cap": "$34.98M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/fsbc",
   "FIELD9": ""
 },
 {
   "symbol": "FTD",
   "name": "FTD Companies, Inc.",
   "last_sale": "2.75",
   "market_cap": "$76.83M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ftd",
   "FIELD9": ""
 },
 {
   "symbol": "FTEK",
   "name": "Fuel Tech, Inc.",
   "last_sale": "1.35",
   "market_cap": "$32.63M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Pollution Control Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ftek",
   "FIELD9": ""
 },
 {
   "symbol": "FCEL",
   "name": "FuelCell Energy, Inc.",
   "last_sale": "1.08",
   "market_cap": "$100.81M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/fcel",
   "FIELD9": ""
 },
 {
   "symbol": "FLGT",
   "name": "Fulgent Genetics, Inc.",
   "last_sale": "3.3",
   "market_cap": "$59.46M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/flgt",
   "FIELD9": ""
 },
 {
   "symbol": "FORK",
   "name": "Fuling Global Inc.",
   "last_sale": "3.5",
   "market_cap": "$55.23M",
   "IPOyear": "2015",
   "sector": "Consumer Non-Durables",
   "industry": "Plastic Products",
   "summary_quote": "https://www.nasdaq.com/symbol/fork",
   "FIELD9": ""
 },
 {
   "symbol": "FLL",
   "name": "Full House Resorts, Inc.",
   "last_sale": "3.1",
   "market_cap": "$83.49M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/fll",
   "FIELD9": ""
 },
 {
   "symbol": "FMAX",
   "name": "Full Spectrum Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fmax",
   "FIELD9": ""
 },
 {
   "symbol": "FULT",
   "name": "Fulton Financial Corporation",
   "last_sale": "17.55",
   "market_cap": "$3.09B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fult",
   "FIELD9": ""
 },
 {
   "symbol": "FNKO",
   "name": "Funko, Inc.",
   "last_sale": "20.72",
   "market_cap": "$1B",
   "IPOyear": "2017",
   "sector": "Consumer Non-Durables",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/fnko",
   "FIELD9": ""
 },
 {
   "symbol": "FSNN",
   "name": "Fusion Connect, Inc.",
   "last_sale": "2.9",
   "market_cap": "$227.55M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/fsnn",
   "FIELD9": ""
 },
 {
   "symbol": "FTFT",
   "name": "Future FinTech Group Inc.",
   "last_sale": "1.2211",
   "market_cap": "$31.77M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/ftft",
   "FIELD9": ""
 },
 {
   "symbol": "FFHL",
   "name": "Fuwei Films (Holdings) Co., Ltd.",
   "last_sale": "2.1005",
   "market_cap": "$6.86M",
   "IPOyear": "2006",
   "sector": "Capital Goods",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/ffhl",
   "FIELD9": ""
 },
 {
   "symbol": "FVCB",
   "name": "FVCBankcorp, Inc.",
   "last_sale": "20",
   "market_cap": "$203.58M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fvcb",
   "FIELD9": ""
 },
 {
   "symbol": "WILC",
   "name": "G. Willi-Food International,  Ltd.",
   "last_sale": "6.9",
   "market_cap": "$91.36M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/wilc",
   "FIELD9": ""
 },
 {
   "symbol": "GTHX",
   "name": "G1 Therapeutics, Inc.",
   "last_sale": "56.61",
   "market_cap": "$1.89B",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/gthx",
   "FIELD9": ""
 },
 {
   "symbol": "FOANC",
   "name": "Gabelli NextShares Trust",
   "last_sale": "100.04",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/foanc",
   "FIELD9": ""
 },
 {
   "symbol": "GRBIC",
   "name": "Gabelli NextShares Trust",
   "last_sale": "99.99",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/grbic",
   "FIELD9": ""
 },
 {
   "symbol": "MOGLC",
   "name": "Gabelli NextShares Trust",
   "last_sale": "100.04",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/moglc",
   "FIELD9": ""
 },
 {
   "symbol": "PETZC",
   "name": "Gabelli NextShares Trust",
   "last_sale": "100.04",
   "market_cap": "$5M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/petzc",
   "FIELD9": ""
 },
 {
   "symbol": "GAIA",
   "name": "Gaia, Inc.",
   "last_sale": "15.8",
   "market_cap": "$282.82M",
   "IPOyear": "1999",
   "sector": "Consumer Services",
   "industry": "Movies/Entertainment",
   "summary_quote": "https://www.nasdaq.com/symbol/gaia",
   "FIELD9": ""
 },
 {
   "symbol": "GLPG",
   "name": "Galapagos NV",
   "last_sale": "113.31",
   "market_cap": "$6.15B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/glpg",
   "FIELD9": ""
 },
 {
   "symbol": "GALT",
   "name": "Galectin Therapeutics Inc.",
   "last_sale": "6.49",
   "market_cap": "$265.53M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/galt",
   "FIELD9": ""
 },
 {
   "symbol": "GLMD",
   "name": "Galmed Pharmaceuticals Ltd.",
   "last_sale": "12.8",
   "market_cap": "$267.68M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/glmd",
   "FIELD9": ""
 },
 {
   "symbol": "GLPI",
   "name": "Gaming and Leisure Properties, Inc.",
   "last_sale": "34.56",
   "market_cap": "$7.39B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/glpi",
   "FIELD9": ""
 },
 {
   "symbol": "GPIC",
   "name": "Gaming Partners International Corporation",
   "last_sale": "8.64",
   "market_cap": "$68.73M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/gpic",
   "FIELD9": ""
 },
 {
   "symbol": "GRMN",
   "name": "Garmin Ltd.",
   "last_sale": "70.04",
   "market_cap": "$13.22B",
   "IPOyear": "2000",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/grmn",
   "FIELD9": ""
 },
 {
   "symbol": "GARS",
   "name": "Garrison Capital Inc.",
   "last_sale": "8.28",
   "market_cap": "$132.89M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gars",
   "FIELD9": ""
 },
 {
   "symbol": "GLIBA",
   "name": "GCI Liberty, Inc.",
   "last_sale": "50.82",
   "market_cap": "$5.54B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/gliba",
   "FIELD9": ""
 },
 {
   "symbol": "GLIBP",
   "name": "GCI Liberty, Inc.",
   "last_sale": "25.3",
   "market_cap": "$908.14M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/glibp",
   "FIELD9": ""
 },
 {
   "symbol": "GDS",
   "name": "GDS Holdings Limited",
   "last_sale": "34.3",
   "market_cap": "$4.04B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/gds",
   "FIELD9": ""
 },
 {
   "symbol": "GEMP",
   "name": "Gemphire Therapeutics Inc.",
   "last_sale": "2.33",
   "market_cap": "$33.24M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/gemp",
   "FIELD9": ""
 },
 {
   "symbol": "GENC",
   "name": "Gencor Industries Inc.",
   "last_sale": "12.55",
   "market_cap": "$181.9M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/genc",
   "FIELD9": ""
 },
 {
   "symbol": "GFN",
   "name": "General Finance Corporation",
   "last_sale": "14.15",
   "market_cap": "$378.61M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gfn",
   "FIELD9": ""
 },
 {
   "symbol": "GFNCP",
   "name": "General Finance Corporation",
   "last_sale": "103.9",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gfncp",
   "FIELD9": ""
 },
 {
   "symbol": "GFNSL",
   "name": "General Finance Corporation",
   "last_sale": "25.7295",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gfnsl",
   "FIELD9": ""
 },
 {
   "symbol": "GENE",
   "name": "Genetic Technologies Ltd",
   "last_sale": "1.1",
   "market_cap": "$17.86M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/gene",
   "FIELD9": ""
 },
 {
   "symbol": "GNUS",
   "name": "Genius Brands International, Inc.",
   "last_sale": "2.1",
   "market_cap": "$19.18M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Movies/Entertainment",
   "summary_quote": "https://www.nasdaq.com/symbol/gnus",
   "FIELD9": ""
 },
 {
   "symbol": "GNMK",
   "name": "GenMark Diagnostics, Inc.",
   "last_sale": "7.85",
   "market_cap": "$437.66M",
   "IPOyear": "2010",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/gnmk",
   "FIELD9": ""
 },
 {
   "symbol": "GNCA",
   "name": "Genocea Biosciences, Inc.",
   "last_sale": "0.5311",
   "market_cap": "$46.01M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/gnca",
   "FIELD9": ""
 },
 {
   "symbol": "GHDX",
   "name": "Genomic Health, Inc.",
   "last_sale": "69.17",
   "market_cap": "$2.48B",
   "IPOyear": "2005",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/ghdx",
   "FIELD9": ""
 },
 {
   "symbol": "GNPX",
   "name": "Genprex, Inc.",
   "last_sale": "2.41",
   "market_cap": "$36.24M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/gnpx",
   "FIELD9": ""
 },
 {
   "symbol": "GNST",
   "name": "GenSight Biologics S.A.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gnst",
   "FIELD9": ""
 },
 {
   "symbol": "GNTX",
   "name": "Gentex Corporation",
   "last_sale": "22.49",
   "market_cap": "$6.05B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/gntx",
   "FIELD9": ""
 },
 {
   "symbol": "THRM",
   "name": "Gentherm Inc",
   "last_sale": "48.85",
   "market_cap": "$1.78B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/thrm",
   "FIELD9": ""
 },
 {
   "symbol": "GEOS",
   "name": "Geospace Technologies Corporation",
   "last_sale": "13.26",
   "market_cap": "$180.3M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/geos",
   "FIELD9": ""
 },
 {
   "symbol": "GABC",
   "name": "German American Bancorp, Inc.",
   "last_sale": "36.8",
   "market_cap": "$845.23M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/gabc",
   "FIELD9": ""
 },
 {
   "symbol": "GERN",
   "name": "Geron Corporation",
   "last_sale": "5.46",
   "market_cap": "$1B",
   "IPOyear": "1996",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/gern",
   "FIELD9": ""
 },
 {
   "symbol": "GEVO",
   "name": "Gevo, Inc.",
   "last_sale": "4.4",
   "market_cap": "$35.57M",
   "IPOyear": "2011",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/gevo",
   "FIELD9": ""
 },
 {
   "symbol": "ROCK",
   "name": "Gibraltar Industries, Inc.",
   "last_sale": "46.4",
   "market_cap": "$1.48B",
   "IPOyear": "1993",
   "sector": "Capital Goods",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/rock",
   "FIELD9": ""
 },
 {
   "symbol": "GIGM",
   "name": "GigaMedia Limited",
   "last_sale": "3.0065",
   "market_cap": "$33.23M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/gigm",
   "FIELD9": ""
 },
 {
   "symbol": "GIII",
   "name": "G-III Apparel Group, LTD.",
   "last_sale": "47.49",
   "market_cap": "$2.34B",
   "IPOyear": "1989",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/giii",
   "FIELD9": ""
 },
 {
   "symbol": "GILT",
   "name": "Gilat Satellite Networks Ltd.",
   "last_sale": "9.02",
   "market_cap": "$494.3M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/gilt",
   "FIELD9": ""
 },
 {
   "symbol": "GILD",
   "name": "Gilead Sciences, Inc.",
   "last_sale": "75.5",
   "market_cap": "$97.87B",
   "IPOyear": "1992",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/gild",
   "FIELD9": ""
 },
 {
   "symbol": "GBCI",
   "name": "Glacier Bancorp, Inc.",
   "last_sale": "44.31",
   "market_cap": "$3.74B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/gbci",
   "FIELD9": ""
 },
 {
   "symbol": "GLAD",
   "name": "Gladstone Capital Corporation",
   "last_sale": "9.57",
   "market_cap": "$266.05M",
   "IPOyear": "2001",
   "sector": "Consumer Non-Durables",
   "industry": "Textiles",
   "summary_quote": "https://www.nasdaq.com/symbol/glad",
   "FIELD9": ""
 },
 {
   "symbol": "GLADN",
   "name": "Gladstone Capital Corporation",
   "last_sale": "25.672",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Textiles",
   "summary_quote": "https://www.nasdaq.com/symbol/gladn",
   "FIELD9": ""
 },
 {
   "symbol": "GOOD",
   "name": "Gladstone Commercial Corporation",
   "last_sale": "18.99",
   "market_cap": "$561.25M",
   "IPOyear": "2003",
   "sector": "Consumer Services",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/good",
   "FIELD9": ""
 },
 {
   "symbol": "GOODM",
   "name": "Gladstone Commercial Corporation",
   "last_sale": "25.1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/goodm",
   "FIELD9": ""
 },
 {
   "symbol": "GOODO",
   "name": "Gladstone Commercial Corporation",
   "last_sale": "26.8",
   "market_cap": "$30.82M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/goodo",
   "FIELD9": ""
 },
 {
   "symbol": "GOODP",
   "name": "Gladstone Commercial Corporation",
   "last_sale": "26.3132",
   "market_cap": "$26.31M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/goodp",
   "FIELD9": ""
 },
 {
   "symbol": "GAIN",
   "name": "Gladstone Investment Corporation",
   "last_sale": "11.57",
   "market_cap": "$379.76M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gain",
   "FIELD9": ""
 },
 {
   "symbol": "GAINL",
   "name": "Gladstone Investment Corporation",
   "last_sale": "25.32",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gainl",
   "FIELD9": ""
 },
 {
   "symbol": "GAINM",
   "name": "Gladstone Investment Corporation",
   "last_sale": "25.29",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gainm",
   "FIELD9": ""
 },
 {
   "symbol": "LAND",
   "name": "Gladstone Land Corporation",
   "last_sale": "12.45",
   "market_cap": "$200.08M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/land",
   "FIELD9": ""
 },
 {
   "symbol": "LANDP",
   "name": "Gladstone Land Corporation",
   "last_sale": "25.45",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/landp",
   "FIELD9": ""
 },
 {
   "symbol": "GLBZ",
   "name": "Glen Burnie Bancorp",
   "last_sale": "12.34",
   "market_cap": "$34.69M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/glbz",
   "FIELD9": ""
 },
 {
   "symbol": "GBT",
   "name": "Global Blood Therapeutics, Inc.",
   "last_sale": "39.8",
   "market_cap": "$2.07B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/gbt",
   "FIELD9": ""
 },
 {
   "symbol": "ENT",
   "name": "Global Eagle Entertainment Inc.",
   "last_sale": "2.26",
   "market_cap": "$206.3M",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ent",
   "FIELD9": ""
 },
 {
   "symbol": "GBLI",
   "name": "Global Indemnity Limited",
   "last_sale": "37.35",
   "market_cap": "$530.96M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/gbli",
   "FIELD9": ""
 },
 {
   "symbol": "GBLIL",
   "name": "Global Indemnity Limited",
   "last_sale": "26.06",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/gblil",
   "FIELD9": ""
 },
 {
   "symbol": "GBLIZ",
   "name": "Global Indemnity Limited",
   "last_sale": "25.6792",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/gbliz",
   "FIELD9": ""
 },
 {
   "symbol": "SELF",
   "name": "Global Self Storage, Inc.",
   "last_sale": "4.26",
   "market_cap": "$32.77M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/self",
   "FIELD9": ""
 },
 {
   "symbol": "GWRS",
   "name": "Global Water Resources, Inc.",
   "last_sale": "10.05",
   "market_cap": "$215.63M",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/gwrs",
   "FIELD9": ""
 },
 {
   "symbol": "DRIV",
   "name": "Global X Autonomous & Electric Vehicles ETF",
   "last_sale": "15.0397",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/driv",
   "FIELD9": ""
 },
 {
   "symbol": "KRMA",
   "name": "Global X Conscious Companies ETF",
   "last_sale": "21.46",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/krma",
   "FIELD9": ""
 },
 {
   "symbol": "FINX",
   "name": "Global X FinTech ETF",
   "last_sale": "28.49",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/finx",
   "FIELD9": ""
 },
 {
   "symbol": "AIQ",
   "name": "Global X Future Analytics Tech ETF",
   "last_sale": "15.8145",
   "market_cap": "$48.23M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aiq",
   "FIELD9": ""
 },
 {
   "symbol": "BFIT",
   "name": "Global X Health & Wellness Thematic ETF",
   "last_sale": "19.4689",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bfit",
   "FIELD9": ""
 },
 {
   "symbol": "SNSR",
   "name": "Global X Internet of Things ETF",
   "last_sale": "20.7926",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/snsr",
   "FIELD9": ""
 },
 {
   "symbol": "LNGR",
   "name": "Global X Longevity Thematic ETF",
   "last_sale": "22.0701",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lngr",
   "FIELD9": ""
 },
 {
   "symbol": "MILN",
   "name": "Global X Millennials Thematic ETF",
   "last_sale": "23.4969",
   "market_cap": "$17.63M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/miln",
   "FIELD9": ""
 },
 {
   "symbol": "EFAS",
   "name": "Global X MSCI SuperDividend EAFE ETF",
   "last_sale": "17.3008",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/efas",
   "FIELD9": ""
 },
 {
   "symbol": "QQQC",
   "name": "Global X NASDAQ China Technology ETF",
   "last_sale": "26.78",
   "market_cap": "$21.42M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qqqc",
   "FIELD9": ""
 },
 {
   "symbol": "BOTZ",
   "name": "Global X Robotics & Artificial Intelligence ETF",
   "last_sale": "23.09",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/botz",
   "FIELD9": ""
 },
 {
   "symbol": "CATH",
   "name": "Global X S&P 500 Catholic Values ETF",
   "last_sale": "36.41",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cath",
   "FIELD9": ""
 },
 {
   "symbol": "SOCL",
   "name": "Global X Social Media ETF",
   "last_sale": "32.0801",
   "market_cap": "$133.13M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/socl",
   "FIELD9": ""
 },
 {
   "symbol": "ALTY",
   "name": "Global X SuperDividend Alternatives ETF",
   "last_sale": "15.21",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/alty",
   "FIELD9": ""
 },
 {
   "symbol": "SRET",
   "name": "Global X SuperDividend REIT ETF",
   "last_sale": "15.2598",
   "market_cap": "$3.05M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sret",
   "FIELD9": ""
 },
 {
   "symbol": "YLCO",
   "name": "Global X Yieldco Index ETF",
   "last_sale": "12.1",
   "market_cap": "$3.03M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ylco",
   "FIELD9": ""
 },
 {
   "symbol": "GLBS",
   "name": "Globus Maritime Limited",
   "last_sale": "0.4099",
   "market_cap": "$13.12M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/glbs",
   "FIELD9": ""
 },
 {
   "symbol": "GLUU",
   "name": "Glu Mobile Inc.",
   "last_sale": "7.3",
   "market_cap": "$1.04B",
   "IPOyear": "2007",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gluu",
   "FIELD9": ""
 },
 {
   "symbol": "GLYC",
   "name": "GlycoMimetics, Inc.",
   "last_sale": "14.18",
   "market_cap": "$610.55M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/glyc",
   "FIELD9": ""
 },
 {
   "symbol": "GOGO",
   "name": "Gogo Inc.",
   "last_sale": "5.42",
   "market_cap": "$473.44M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/gogo",
   "FIELD9": ""
 },
 {
   "symbol": "GLNG",
   "name": "Golar LNG Limited",
   "last_sale": "28.32",
   "market_cap": "$2.86B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/glng",
   "FIELD9": ""
 },
 {
   "symbol": "GMLP",
   "name": "Golar LNG Partners LP",
   "last_sale": "13.61",
   "market_cap": "$950.66M",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/gmlp",
   "FIELD9": ""
 },
 {
   "symbol": "GMLPP",
   "name": "Golar LNG Partners LP",
   "last_sale": "25.4",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/gmlpp",
   "FIELD9": ""
 },
 {
   "symbol": "DNJR",
   "name": "GOLDEN BULL LIMITED",
   "last_sale": "7.87",
   "market_cap": "$116.34M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dnjr",
   "FIELD9": ""
 },
 {
   "symbol": "GDEN",
   "name": "Golden Entertainment, Inc.",
   "last_sale": "23.29",
   "market_cap": "$640.75M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/gden",
   "FIELD9": ""
 },
 {
   "symbol": "GOGL",
   "name": "Golden Ocean Group Limited",
   "last_sale": "9.46",
   "market_cap": "$1.36B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/gogl",
   "FIELD9": ""
 },
 {
   "symbol": "GBDC",
   "name": "Golub Capital BDC, Inc.",
   "last_sale": "18.82",
   "market_cap": "$1.13B",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gbdc",
   "FIELD9": ""
 },
 {
   "symbol": "GTIM",
   "name": "Good Times Restaurants Inc.",
   "last_sale": "5.05",
   "market_cap": "$62.98M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/gtim",
   "FIELD9": ""
 },
 {
   "symbol": "GBLK",
   "name": "GoodBulk Ltd.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gblk",
   "FIELD9": ""
 },
 {
   "symbol": "GSHD",
   "name": "Goosehead Insurance, Inc.",
   "last_sale": "35.5",
   "market_cap": "$1.29B",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/gshd",
   "FIELD9": ""
 },
 {
   "symbol": "GPRO",
   "name": "GoPro, Inc.",
   "last_sale": "6.45",
   "market_cap": "$959.7M",
   "IPOyear": "2014",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/gpro",
   "FIELD9": ""
 },
 {
   "symbol": "GPAQ",
   "name": "Gordon Pointe Acquisition Corp.",
   "last_sale": "9.87",
   "market_cap": "$39.81M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gpaq",
   "FIELD9": ""
 },
 {
   "symbol": "GPAQU",
   "name": "Gordon Pointe Acquisition Corp.",
   "last_sale": "10.45",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gpaqu",
   "FIELD9": ""
 },
 {
   "symbol": "GPAQW",
   "name": "Gordon Pointe Acquisition Corp.",
   "last_sale": "0.6",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gpaqw",
   "FIELD9": ""
 },
 {
   "symbol": "GSHT",
   "name": "Gores Holdings II, Inc.",
   "last_sale": "10.485",
   "market_cap": "$122.74M",
   "IPOyear": "2017",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gsht",
   "FIELD9": ""
 },
 {
   "symbol": "GSHTU",
   "name": "Gores Holdings II, Inc.",
   "last_sale": "10.9",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gshtu",
   "FIELD9": ""
 },
 {
   "symbol": "GSHTW",
   "name": "Gores Holdings II, Inc.",
   "last_sale": "2.01",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gshtw",
   "FIELD9": ""
 },
 {
   "symbol": "GRSHU",
   "name": "Gores Holdings III, Inc.",
   "last_sale": "10.2",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/grshu",
   "FIELD9": ""
 },
 {
   "symbol": "GOV",
   "name": "Government Properties Income Trust",
   "last_sale": "11.7",
   "market_cap": "$1.16B",
   "IPOyear": "2009",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/gov",
   "FIELD9": ""
 },
 {
   "symbol": "GOVNI",
   "name": "Government Properties Income Trust",
   "last_sale": "25.115",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/govni",
   "FIELD9": ""
 },
 {
   "symbol": "LOPE",
   "name": "Grand Canyon Education, Inc.",
   "last_sale": "110.6",
   "market_cap": "$5.33B",
   "IPOyear": "2008",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lope",
   "FIELD9": ""
 },
 {
   "symbol": "GRVY",
   "name": "GRAVITY Co., Ltd.",
   "last_sale": "18.21",
   "market_cap": "$126.54M",
   "IPOyear": "2005",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/grvy",
   "FIELD9": ""
 },
 {
   "symbol": "GECC",
   "name": "Great Elm Capital Corp.",
   "last_sale": "9.64",
   "market_cap": "$102.69M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gecc",
   "FIELD9": ""
 },
 {
   "symbol": "GECCL",
   "name": "Great Elm Capital Corp.",
   "last_sale": "25.6235",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/geccl",
   "FIELD9": ""
 },
 {
   "symbol": "GECCM",
   "name": "Great Elm Capital Corp.",
   "last_sale": "24.99",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/geccm",
   "FIELD9": ""
 },
 {
   "symbol": "GEC",
   "name": "Great Elm Capital Group, Inc. ",
   "last_sale": "3.3",
   "market_cap": "$85.48M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/gec",
   "FIELD9": ""
 },
 {
   "symbol": "GLDD",
   "name": "Great Lakes Dredge & Dock Corporation",
   "last_sale": "5.9",
   "market_cap": "$367.6M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/gldd",
   "FIELD9": ""
 },
 {
   "symbol": "GSBC",
   "name": "Great Southern Bancorp, Inc.",
   "last_sale": "57.7",
   "market_cap": "$816.02M",
   "IPOyear": "1989",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/gsbc",
   "FIELD9": ""
 },
 {
   "symbol": "GNBC",
   "name": "Green Bancorp, Inc.",
   "last_sale": "23.45",
   "market_cap": "$874.88M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/gnbc",
   "FIELD9": ""
 },
 {
   "symbol": "GRBK",
   "name": "Green Brick Partners, Inc.",
   "last_sale": "9.875",
   "market_cap": "$500.86M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/grbk",
   "FIELD9": ""
 },
 {
   "symbol": "GPP",
   "name": "Green Plains Partners LP",
   "last_sale": "14.65",
   "market_cap": "$466.32M",
   "IPOyear": "2015",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/gpp",
   "FIELD9": ""
 },
 {
   "symbol": "GPRE",
   "name": "Green Plains, Inc.",
   "last_sale": "17.375",
   "market_cap": "$719.84M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/gpre",
   "FIELD9": ""
 },
 {
   "symbol": "GCBC",
   "name": "Greene County Bancorp, Inc.",
   "last_sale": "33.75",
   "market_cap": "$288.15M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/gcbc",
   "FIELD9": ""
 },
 {
   "symbol": "GLAC",
   "name": "Greenland Acquisition Corporation",
   "last_sale": "9.695",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/glac",
   "FIELD9": ""
 },
 {
   "symbol": "GLACR",
   "name": "Greenland Acquisition Corporation",
   "last_sale": "0.39",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/glacr",
   "FIELD9": ""
 },
 {
   "symbol": "GLACU",
   "name": "Greenland Acquisition Corporation",
   "last_sale": "10.2947",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/glacu",
   "FIELD9": ""
 },
 {
   "symbol": "GLACW",
   "name": "Greenland Acquisition Corporation",
   "last_sale": "0.27",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/glacw",
   "FIELD9": ""
 },
 {
   "symbol": "GLRE",
   "name": "Greenlight Reinsurance, Ltd.",
   "last_sale": "12.65",
   "market_cap": "$473.3M",
   "IPOyear": "2007",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/glre",
   "FIELD9": ""
 },
 {
   "symbol": "GRNQ",
   "name": "Greenpro Capital Corp.",
   "last_sale": "2.8",
   "market_cap": "$153.2M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/grnq",
   "FIELD9": ""
 },
 {
   "symbol": "GSKY",
   "name": "GreenSky, Inc.",
   "last_sale": "20.24",
   "market_cap": "$3.78B",
   "IPOyear": "2018",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gsky",
   "FIELD9": ""
 },
 {
   "symbol": "GSUM",
   "name": "Gridsum Holding Inc.",
   "last_sale": "6.05",
   "market_cap": "$185.95M",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/gsum",
   "FIELD9": ""
 },
 {
   "symbol": "GRIF",
   "name": "Griffin Industrial Realty, Inc.",
   "last_sale": "39.14",
   "market_cap": "$196.82M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/grif",
   "FIELD9": ""
 },
 {
   "symbol": "GRFS",
   "name": "Grifols, S.A.",
   "last_sale": "21.13",
   "market_cap": "$14.45B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/grfs",
   "FIELD9": ""
 },
 {
   "symbol": "GRIN",
   "name": "Grindrod Shipping Holdings Ltd.",
   "last_sale": "7.3",
   "market_cap": "$139.17M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/grin",
   "FIELD9": ""
 },
 {
   "symbol": "GRPN",
   "name": "Groupon, Inc.",
   "last_sale": "3.89",
   "market_cap": "$2.21B",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/grpn",
   "FIELD9": ""
 },
 {
   "symbol": "OMAB",
   "name": "Grupo Aeroportuario del Centro Norte S.A.B. de C.V.",
   "last_sale": "55",
   "market_cap": "$2.7B",
   "IPOyear": "2006",
   "sector": "Transportation",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/omab",
   "FIELD9": ""
 },
 {
   "symbol": "GGAL",
   "name": "Grupo Financiero Galicia S.A.",
   "last_sale": "29.76",
   "market_cap": "$4.25B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ggal",
   "FIELD9": ""
 },
 {
   "symbol": "GVP",
   "name": "GSE Systems, Inc.",
   "last_sale": "3.65",
   "market_cap": "$72.02M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/gvp",
   "FIELD9": ""
 },
 {
   "symbol": "GSIT",
   "name": "GSI Technology, Inc.",
   "last_sale": "6.88",
   "market_cap": "$149.77M",
   "IPOyear": "2007",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/gsit",
   "FIELD9": ""
 },
 {
   "symbol": "GSVC",
   "name": "GSV Capital Corp",
   "last_sale": "6.865",
   "market_cap": "$140.87M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gsvc",
   "FIELD9": ""
 },
 {
   "symbol": "GTXI",
   "name": "GTx, Inc.",
   "last_sale": "1.8",
   "market_cap": "$43.28M",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/gtxi",
   "FIELD9": ""
 },
 {
   "symbol": "GTYH",
   "name": "GTY Technology Holdings, Inc.",
   "last_sale": "10.15",
   "market_cap": "$155.61M",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gtyh",
   "FIELD9": ""
 },
 {
   "symbol": "GTYHU",
   "name": "GTY Technology Holdings, Inc.",
   "last_sale": "10.8059",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gtyhu",
   "FIELD9": ""
 },
 {
   "symbol": "GTYHW",
   "name": "GTY Technology Holdings, Inc.",
   "last_sale": "1.1",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gtyhw",
   "FIELD9": ""
 },
 {
   "symbol": "GBNK",
   "name": "Guaranty Bancorp",
   "last_sale": "30.2",
   "market_cap": "$885.13M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/gbnk",
   "FIELD9": ""
 },
 {
   "symbol": "GNTY",
   "name": "Guaranty Bancshares, Inc.",
   "last_sale": "31.58",
   "market_cap": "$377.72M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/gnty",
   "FIELD9": ""
 },
 {
   "symbol": "GFED",
   "name": "Guaranty Federal Bancshares, Inc.",
   "last_sale": "25.2255",
   "market_cap": "$112.3M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/gfed",
   "FIELD9": ""
 },
 {
   "symbol": "GIFI",
   "name": "Gulf Island Fabrication, Inc.",
   "last_sale": "9.45",
   "market_cap": "$142.16M",
   "IPOyear": "1997",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/gifi",
   "FIELD9": ""
 },
 {
   "symbol": "GURE",
   "name": "Gulf Resources, Inc.",
   "last_sale": "1.0896",
   "market_cap": "$51M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/gure",
   "FIELD9": ""
 },
 {
   "symbol": "GPOR",
   "name": "Gulfport Energy Corporation",
   "last_sale": "11.76",
   "market_cap": "$2.04B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/gpor",
   "FIELD9": ""
 },
 {
   "symbol": "GWPH",
   "name": "GW Pharmaceuticals Plc",
   "last_sale": "165.21",
   "market_cap": "$4.66B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/gwph",
   "FIELD9": ""
 },
 {
   "symbol": "GWGH",
   "name": "GWG Holdings, Inc",
   "last_sale": "6.52",
   "market_cap": "$37.9M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/gwgh",
   "FIELD9": ""
 },
 {
   "symbol": "GYRO",
   "name": "Gyrodyne , LLC",
   "last_sale": "20.51",
   "market_cap": "$30.41M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Building operators",
   "summary_quote": "https://www.nasdaq.com/symbol/gyro",
   "FIELD9": ""
 },
 {
   "symbol": "HEES",
   "name": "H&E Equipment Services, Inc.",
   "last_sale": "37",
   "market_cap": "$1.32B",
   "IPOyear": "2006",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hees",
   "FIELD9": ""
 },
 {
   "symbol": "HLG",
   "name": "Hailiang Education Group Inc.",
   "last_sale": "67.87",
   "market_cap": "$1.75B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hlg",
   "FIELD9": ""
 },
 {
   "symbol": "HNRG",
   "name": "Hallador Energy Company",
   "last_sale": "5.98",
   "market_cap": "$180.46M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/hnrg",
   "FIELD9": ""
 },
 {
   "symbol": "HALL",
   "name": "Hallmark Financial Services, Inc.",
   "last_sale": "10.93",
   "market_cap": "$197.38M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/hall",
   "FIELD9": ""
 },
 {
   "symbol": "HALO",
   "name": "Halozyme Therapeutics, Inc.",
   "last_sale": "17.53",
   "market_cap": "$2.53B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/halo",
   "FIELD9": ""
 },
 {
   "symbol": "HBK",
   "name": "Hamilton Bancorp, Inc.",
   "last_sale": "14.4",
   "market_cap": "$49.2M",
   "IPOyear": "2012",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/hbk",
   "FIELD9": ""
 },
 {
   "symbol": "HLNE",
   "name": "Hamilton Lane Incorporated",
   "last_sale": "47.48",
   "market_cap": "$2.38B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/hlne",
   "FIELD9": ""
 },
 {
   "symbol": "HJLI",
   "name": "Hancock Jaffe Laboratories, Inc.",
   "last_sale": "2.63",
   "market_cap": "$30.82M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/hjli",
   "FIELD9": ""
 },
 {
   "symbol": "HJLIW",
   "name": "Hancock Jaffe Laboratories, Inc.",
   "last_sale": "0.65",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/hjliw",
   "FIELD9": ""
 },
 {
   "symbol": "HWC",
   "name": "Hancock Whitney Corporation",
   "last_sale": "49.85",
   "market_cap": "$4.25B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hwc",
   "FIELD9": ""
 },
 {
   "symbol": "HWCPL",
   "name": "Hancock Whitney Corporation",
   "last_sale": "25.3",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hwcpl",
   "FIELD9": ""
 },
 {
   "symbol": "HAFC",
   "name": "Hanmi Financial Corporation",
   "last_sale": "25.6",
   "market_cap": "$832.33M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hafc",
   "FIELD9": ""
 },
 {
   "symbol": "HQCL",
   "name": "Hanwha Q CELLS Co., Ltd. ",
   "last_sale": "8.71",
   "market_cap": "$725.12M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/hqcl",
   "FIELD9": ""
 },
 {
   "symbol": "HONE",
   "name": "HarborOne Bancorp, Inc.",
   "last_sale": "19.63",
   "market_cap": "$640.38M",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hone",
   "FIELD9": ""
 },
 {
   "symbol": "HLIT",
   "name": "Harmonic Inc.",
   "last_sale": "5.3",
   "market_cap": "$455.97M",
   "IPOyear": "1995",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/hlit",
   "FIELD9": ""
 },
 {
   "symbol": "HFGIC",
   "name": "Hartford Funds NextShares Trust",
   "last_sale": "100.1",
   "market_cap": "$27.53M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hfgic",
   "FIELD9": ""
 },
 {
   "symbol": "HBIO",
   "name": "Harvard Bioscience, Inc.",
   "last_sale": "5.2",
   "market_cap": "$190.21M",
   "IPOyear": "2000",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/hbio",
   "FIELD9": ""
 },
 {
   "symbol": "HCAP",
   "name": "Harvest Capital Credit Corporation",
   "last_sale": "11.02",
   "market_cap": "$70.5M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hcap",
   "FIELD9": ""
 },
 {
   "symbol": "HCAPZ",
   "name": "Harvest Capital Credit Corporation",
   "last_sale": "25.46",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hcapz",
   "FIELD9": ""
 },
 {
   "symbol": "HAS",
   "name": "Hasbro, Inc.",
   "last_sale": "107.46",
   "market_cap": "$13.64B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/has",
   "FIELD9": ""
 },
 {
   "symbol": "HA",
   "name": "Hawaiian Holdings, Inc.",
   "last_sale": "40.15",
   "market_cap": "$2.04B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ha",
   "FIELD9": ""
 },
 {
   "symbol": "HWKN",
   "name": "Hawkins, Inc.",
   "last_sale": "41.9",
   "market_cap": "$448.85M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/hwkn",
   "FIELD9": ""
 },
 {
   "symbol": "HWBK",
   "name": "Hawthorn Bancshares, Inc.",
   "last_sale": "23.7",
   "market_cap": "$142.7M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hwbk",
   "FIELD9": ""
 },
 {
   "symbol": "HYAC",
   "name": "Haymaker Acquisition Corp.",
   "last_sale": "9.82",
   "market_cap": "$96.85M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hyac",
   "FIELD9": ""
 },
 {
   "symbol": "HYACU",
   "name": "Haymaker Acquisition Corp.",
   "last_sale": "10.34",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hyacu",
   "FIELD9": ""
 },
 {
   "symbol": "HYACW",
   "name": "Haymaker Acquisition Corp.",
   "last_sale": "1.3",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hyacw",
   "FIELD9": ""
 },
 {
   "symbol": "HAYN",
   "name": "Haynes International, Inc.",
   "last_sale": "35.47",
   "market_cap": "$443.7M",
   "IPOyear": "2007",
   "sector": "Capital Goods",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/hayn",
   "FIELD9": ""
 },
 {
   "symbol": "HDS",
   "name": "HD Supply Holdings, Inc.",
   "last_sale": "42.54",
   "market_cap": "$7.82B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hds",
   "FIELD9": ""
 },
 {
   "symbol": "HIIQ",
   "name": "Health Insurance Innovations, Inc.",
   "last_sale": "57.4",
   "market_cap": "$963.39M",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/hiiq",
   "FIELD9": ""
 },
 {
   "symbol": "HCSG",
   "name": "Healthcare Services Group, Inc.",
   "last_sale": "43.63",
   "market_cap": "$3.22B",
   "IPOyear": "1983",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/hcsg",
   "FIELD9": ""
 },
 {
   "symbol": "HQY",
   "name": "HealthEquity, Inc.",
   "last_sale": "92.5",
   "market_cap": "$5.76B",
   "IPOyear": "2014",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hqy",
   "FIELD9": ""
 },
 {
   "symbol": "HSTM",
   "name": "HealthStream, Inc.",
   "last_sale": "30.2",
   "market_cap": "$976.15M",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/hstm",
   "FIELD9": ""
 },
 {
   "symbol": "HTLD",
   "name": "Heartland Express, Inc.",
   "last_sale": "19.97",
   "market_cap": "$1.64B",
   "IPOyear": "1986",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/htld",
   "FIELD9": ""
 },
 {
   "symbol": "HTLF",
   "name": "Heartland Financial USA, Inc.",
   "last_sale": "61.05",
   "market_cap": "$2.1B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/htlf",
   "FIELD9": ""
 },
 {
   "symbol": "HTBX",
   "name": "Heat Biologics, Inc.",
   "last_sale": "1.94",
   "market_cap": "$44.87M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/htbx",
   "FIELD9": ""
 },
 {
   "symbol": "HEBT",
   "name": "Hebron Technology Co., Ltd.",
   "last_sale": "1.56",
   "market_cap": "$25.38M",
   "IPOyear": "2016",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/hebt",
   "FIELD9": ""
 },
 {
   "symbol": "HSII",
   "name": "Heidrick & Struggles International, Inc.",
   "last_sale": "35.45",
   "market_cap": "$672.08M",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hsii",
   "FIELD9": ""
 },
 {
   "symbol": "HELE",
   "name": "Helen of Troy Limited",
   "last_sale": "130.6",
   "market_cap": "$3.44B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/hele",
   "FIELD9": ""
 },
 {
   "symbol": "HMNY",
   "name": "Helios and Matheson Analytics Inc",
   "last_sale": "0.0139",
   "market_cap": "$8.85M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hmny",
   "FIELD9": ""
 },
 {
   "symbol": "HSDT",
   "name": "Helius Medical Technologies, Inc.",
   "last_sale": "9.72",
   "market_cap": "$227.23M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/hsdt",
   "FIELD9": ""
 },
 {
   "symbol": "HMTV",
   "name": "Hemisphere Media Group, Inc.",
   "last_sale": "13.7",
   "market_cap": "$539.28M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hmtv",
   "FIELD9": ""
 },
 {
   "symbol": "HNNA",
   "name": "Hennessy Advisors, Inc.",
   "last_sale": "14.43",
   "market_cap": "$112.68M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/hnna",
   "FIELD9": ""
 },
 {
   "symbol": "HSIC",
   "name": "Henry Schein, Inc.",
   "last_sale": "85.67",
   "market_cap": "$13.12B",
   "IPOyear": "1995",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/hsic",
   "FIELD9": ""
 },
 {
   "symbol": "HTBK",
   "name": "Heritage Commerce Corp",
   "last_sale": "15.36",
   "market_cap": "$663.89M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/htbk",
   "FIELD9": ""
 },
 {
   "symbol": "HFWA",
   "name": "Heritage Financial Corporation",
   "last_sale": "37",
   "market_cap": "$1.36B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hfwa",
   "FIELD9": ""
 },
 {
   "symbol": "HCCI",
   "name": "Heritage-Crystal Clean, Inc.",
   "last_sale": "20.6",
   "market_cap": "$474.8M",
   "IPOyear": "2008",
   "sector": "Basic Industries",
   "industry": "Miscellaneous",
   "summary_quote": "https://www.nasdaq.com/symbol/hcci",
   "FIELD9": ""
 },
 {
   "symbol": "MLHR",
   "name": "Herman Miller, Inc.",
   "last_sale": "39.45",
   "market_cap": "$2.35B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mlhr",
   "FIELD9": ""
 },
 {
   "symbol": "HRTX",
   "name": "Heron Therapeutics, Inc.  ",
   "last_sale": "31.4",
   "market_cap": "$2.44B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/hrtx",
   "FIELD9": ""
 },
 {
   "symbol": "HSKA",
   "name": "Heska Corporation",
   "last_sale": "111.14",
   "market_cap": "$833.3M",
   "IPOyear": "1997",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/hska",
   "FIELD9": ""
 },
 {
   "symbol": "HX",
   "name": "Hexindai Inc.",
   "last_sale": "8.345",
   "market_cap": "$400.21M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hx",
   "FIELD9": ""
 },
 {
   "symbol": "HFFG",
   "name": "HF Foods Group Inc.",
   "last_sale": "14.51",
   "market_cap": "$29.06M",
   "IPOyear": "2017",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/hffg",
   "FIELD9": ""
 },
 {
   "symbol": "HIBB",
   "name": "Hibbett Sports, Inc.",
   "last_sale": "19.9",
   "market_cap": "$369.27M",
   "IPOyear": "1996",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/hibb",
   "FIELD9": ""
 },
 {
   "symbol": "SNLN",
   "name": "Highland/iBoxx Senior Loan ETF",
   "last_sale": "18.21",
   "market_cap": "$475.23M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/snln",
   "FIELD9": ""
 },
 {
   "symbol": "HPJ",
   "name": "Highpower International Inc",
   "last_sale": "2.6",
   "market_cap": "$40.46M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/hpj",
   "FIELD9": ""
 },
 {
   "symbol": "HIHO",
   "name": "Highway Holdings Limited",
   "last_sale": "4.25",
   "market_cap": "$16.16M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/hiho",
   "FIELD9": ""
 },
 {
   "symbol": "HIMX",
   "name": "Himax Technologies, Inc.",
   "last_sale": "5.97",
   "market_cap": "$1.03B",
   "IPOyear": "2006",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/himx",
   "FIELD9": ""
 },
 {
   "symbol": "HIFS",
   "name": "Hingham Institution for Savings",
   "last_sale": "217.93",
   "market_cap": "$464.79M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hifs",
   "FIELD9": ""
 },
 {
   "symbol": "HSGX",
   "name": "Histogenics Corporation",
   "last_sale": "0.615",
   "market_cap": "$17.71M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/hsgx",
   "FIELD9": ""
 },
 {
   "symbol": "HCCH",
   "name": "HL Acquisitions Corp.",
   "last_sale": "9.54",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hcch",
   "FIELD9": ""
 },
 {
   "symbol": "HCCHR",
   "name": "HL Acquisitions Corp.",
   "last_sale": "0.42",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hcchr",
   "FIELD9": ""
 },
 {
   "symbol": "HCCHU",
   "name": "HL Acquisitions Corp.",
   "last_sale": "10.2204",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hcchu",
   "FIELD9": ""
 },
 {
   "symbol": "HCCHW",
   "name": "HL Acquisitions Corp.",
   "last_sale": "0.39",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hcchw",
   "FIELD9": ""
 },
 {
   "symbol": "HMNF",
   "name": "HMN Financial, Inc.",
   "last_sale": "20.75",
   "market_cap": "$95.65M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/hmnf",
   "FIELD9": ""
 },
 {
   "symbol": "HMSY",
   "name": "HMS Holdings Corp",
   "last_sale": "31.98",
   "market_cap": "$2.67B",
   "IPOyear": "1992",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hmsy",
   "FIELD9": ""
 },
 {
   "symbol": "HOLI",
   "name": "Hollysys Automation Technologies, Ltd.",
   "last_sale": "20.96",
   "market_cap": "$1.26B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/holi",
   "FIELD9": ""
 },
 {
   "symbol": "HOLX",
   "name": "Hologic, Inc.",
   "last_sale": "41.24",
   "market_cap": "$11.22B",
   "IPOyear": "1990",
   "sector": "Health Care",
   "industry": "Medical Electronics",
   "summary_quote": "https://www.nasdaq.com/symbol/holx",
   "FIELD9": ""
 },
 {
   "symbol": "HBCP",
   "name": "Home Bancorp, Inc.",
   "last_sale": "44.34",
   "market_cap": "$419.48M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hbcp",
   "FIELD9": ""
 },
 {
   "symbol": "HOMB",
   "name": "Home BancShares, Inc.",
   "last_sale": "23.36",
   "market_cap": "$4.08B",
   "IPOyear": "2006",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/homb",
   "FIELD9": ""
 },
 {
   "symbol": "HFBL",
   "name": "Home Federal Bancorp, Inc. of Louisiana",
   "last_sale": "37.3",
   "market_cap": "$70.65M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/hfbl",
   "FIELD9": ""
 },
 {
   "symbol": "HMST",
   "name": "HomeStreet, Inc.",
   "last_sale": "28.55",
   "market_cap": "$770.44M",
   "IPOyear": "2012",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hmst",
   "FIELD9": ""
 },
 {
   "symbol": "HMTA",
   "name": "HomeTown Bankshares Corporation",
   "last_sale": "14.8",
   "market_cap": "$86.01M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hmta",
   "FIELD9": ""
 },
 {
   "symbol": "HTBI",
   "name": "HomeTrust Bancshares, Inc.",
   "last_sale": "29.8",
   "market_cap": "$567.44M",
   "IPOyear": "2012",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/htbi",
   "FIELD9": ""
 },
 {
   "symbol": "FIXX",
   "name": "Homology Medicines, Inc.",
   "last_sale": "21.49",
   "market_cap": "$805.33M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/fixx",
   "FIELD9": ""
 },
 {
   "symbol": "HOFT",
   "name": "Hooker Furniture Corporation",
   "last_sale": "35.2",
   "market_cap": "$414.52M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/hoft",
   "FIELD9": ""
 },
 {
   "symbol": "HOPE",
   "name": "Hope Bancorp, Inc.",
   "last_sale": "16.77",
   "market_cap": "$2.18B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hope",
   "FIELD9": ""
 },
 {
   "symbol": "HFBC",
   "name": "HopFed Bancorp, Inc.",
   "last_sale": "18.1",
   "market_cap": "$120.36M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hfbc",
   "FIELD9": ""
 },
 {
   "symbol": "HBNC",
   "name": "Horizon Bancorp, Inc.",
   "last_sale": "19.99",
   "market_cap": "$766.87M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hbnc",
   "FIELD9": ""
 },
 {
   "symbol": "HZNP",
   "name": "Horizon Pharma plc",
   "last_sale": "18.82",
   "market_cap": "$3.14B",
   "IPOyear": "2011",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/hznp",
   "FIELD9": ""
 },
 {
   "symbol": "HRZN",
   "name": "Horizon Technology Finance Corporation",
   "last_sale": "11.3",
   "market_cap": "$130.28M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hrzn",
   "FIELD9": ""
 },
 {
   "symbol": "DAX",
   "name": "Horizons DAX Germany ETF",
   "last_sale": "29.1181",
   "market_cap": "$18.93M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dax",
   "FIELD9": ""
 },
 {
   "symbol": "QYLD",
   "name": "Horizons NASDAQ-100 Covered Call ETF",
   "last_sale": "25.07",
   "market_cap": "$377.3M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qyld",
   "FIELD9": ""
 },
 {
   "symbol": "HDP",
   "name": "Hortonworks, Inc.",
   "last_sale": "22.58",
   "market_cap": "$1.84B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/hdp",
   "FIELD9": ""
 },
 {
   "symbol": "HPT",
   "name": "Hospitality Properties Trust",
   "last_sale": "28.82",
   "market_cap": "$4.74B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/hpt",
   "FIELD9": ""
 },
 {
   "symbol": "TWNK",
   "name": "Hostess Brands, Inc.",
   "last_sale": "11.68",
   "market_cap": "$1.52B",
   "IPOyear": "2015",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/twnk",
   "FIELD9": ""
 },
 {
   "symbol": "TWNKW",
   "name": "Hostess Brands, Inc.",
   "last_sale": "1.23",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/twnkw",
   "FIELD9": ""
 },
 {
   "symbol": "HMHC",
   "name": "Houghton Mifflin Harcourt Company",
   "last_sale": "7.7",
   "market_cap": "$951.36M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Books",
   "summary_quote": "https://www.nasdaq.com/symbol/hmhc",
   "FIELD9": ""
 },
 {
   "symbol": "HWCC",
   "name": "Houston Wire & Cable Company",
   "last_sale": "7.9",
   "market_cap": "$130.56M",
   "IPOyear": "2006",
   "sector": "Consumer Non-Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/hwcc",
   "FIELD9": ""
 },
 {
   "symbol": "HOVNP",
   "name": "Hovnanian Enterprises Inc",
   "last_sale": "5",
   "market_cap": "$25M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/hovnp",
   "FIELD9": ""
 },
 {
   "symbol": "HBMD",
   "name": "Howard Bancorp, Inc.",
   "last_sale": "18.05",
   "market_cap": "$343.39M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hbmd",
   "FIELD9": ""
 },
 {
   "symbol": "HTGM",
   "name": "HTG Molecular Diagnostics, Inc.",
   "last_sale": "4.36",
   "market_cap": "$123.92M",
   "IPOyear": "2015",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/htgm",
   "FIELD9": ""
 },
 {
   "symbol": "HTHT",
   "name": "Huazhu Group Limited",
   "last_sale": "31.61",
   "market_cap": "$9.2B",
   "IPOyear": "2010",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/htht",
   "FIELD9": ""
 },
 {
   "symbol": "HUBG",
   "name": "Hub Group, Inc.",
   "last_sale": "47.25",
   "market_cap": "$1.62B",
   "IPOyear": "1996",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/hubg",
   "FIELD9": ""
 },
 {
   "symbol": "HSON",
   "name": "Hudson Global, Inc.",
   "last_sale": "1.63",
   "market_cap": "$52.21M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hson",
   "FIELD9": ""
 },
 {
   "symbol": "HDSN",
   "name": "Hudson Technologies, Inc.",
   "last_sale": "1.34",
   "market_cap": "$56.82M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/hdsn",
   "FIELD9": ""
 },
 {
   "symbol": "HUNT",
   "name": "Hunter Maritime Acquisition Corp.",
   "last_sale": "9.93",
   "market_cap": "$188.34M",
   "IPOyear": "2017",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/hunt",
   "FIELD9": ""
 },
 {
   "symbol": "HUNTU",
   "name": "Hunter Maritime Acquisition Corp.",
   "last_sale": "10.038",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/huntu",
   "FIELD9": ""
 },
 {
   "symbol": "HUNTW",
   "name": "Hunter Maritime Acquisition Corp.",
   "last_sale": "0.3101",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/huntw",
   "FIELD9": ""
 },
 {
   "symbol": "HBAN",
   "name": "Huntington Bancshares Incorporated",
   "last_sale": "15.95",
   "market_cap": "$17.61B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hban",
   "FIELD9": ""
 },
 {
   "symbol": "HBANN",
   "name": "Huntington Bancshares Incorporated",
   "last_sale": "25.45",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hbann",
   "FIELD9": ""
 },
 {
   "symbol": "HBANO",
   "name": "Huntington Bancshares Incorporated",
   "last_sale": "26.12",
   "market_cap": "$20.81B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hbano",
   "FIELD9": ""
 },
 {
   "symbol": "HURC",
   "name": "Hurco Companies, Inc.",
   "last_sale": "45.7",
   "market_cap": "$306.96M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/hurc",
   "FIELD9": ""
 },
 {
   "symbol": "HURN",
   "name": "Huron Consulting Group Inc.",
   "last_sale": "49.75",
   "market_cap": "$1.12B",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hurn",
   "FIELD9": ""
 },
 {
   "symbol": "HCM",
   "name": "Hutchison China MediTech Limited",
   "last_sale": "28.65",
   "market_cap": "$3.81B",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/hcm",
   "FIELD9": ""
 },
 {
   "symbol": "HBP",
   "name": "Huttig Building Products, Inc.",
   "last_sale": "5.03",
   "market_cap": "$131.14M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/hbp",
   "FIELD9": ""
 },
 {
   "symbol": "HVBC",
   "name": "HV Bancorp, Inc.",
   "last_sale": "15.5",
   "market_cap": "$33.82M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hvbc",
   "FIELD9": ""
 },
 {
   "symbol": "HYGS",
   "name": "Hydrogenics Corporation",
   "last_sale": "7.5",
   "market_cap": "$115.81M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/hygs",
   "FIELD9": ""
 },
 {
   "symbol": "HYRE",
   "name": "HyreCar Inc.",
   "last_sale": "2.85",
   "market_cap": "$33.37M",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Rental/Leasing Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/hyre",
   "FIELD9": ""
 },
 {
   "symbol": "IDSY",
   "name": "I.D. Systems, Inc.",
   "last_sale": "6.54",
   "market_cap": "$116.11M",
   "IPOyear": "1999",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/idsy",
   "FIELD9": ""
 },
 {
   "symbol": "IIIV",
   "name": "i3 Verticals, Inc.",
   "last_sale": "22.55",
   "market_cap": "$593.02M",
   "IPOyear": "2018",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/iiiv",
   "FIELD9": ""
 },
 {
   "symbol": "IAC",
   "name": "IAC/InterActiveCorp",
   "last_sale": "210.49",
   "market_cap": "$17.52B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/iac",
   "FIELD9": ""
 },
 {
   "symbol": "IAM",
   "name": "I-AM Capital Acquisition Company",
   "last_sale": "10.15",
   "market_cap": "$22.87M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/iam",
   "FIELD9": ""
 },
 {
   "symbol": "IAMXR",
   "name": "I-AM Capital Acquisition Company",
   "last_sale": "0.4522",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/iamxr",
   "FIELD9": ""
 },
 {
   "symbol": "IAMXW",
   "name": "I-AM Capital Acquisition Company",
   "last_sale": "0.3999",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/iamxw",
   "FIELD9": ""
 },
 {
   "symbol": "IBKC",
   "name": "IBERIABANK Corporation",
   "last_sale": "84.2",
   "market_cap": "$4.72B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ibkc",
   "FIELD9": ""
 },
 {
   "symbol": "IBKCO",
   "name": "IBERIABANK Corporation",
   "last_sale": "27.2",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ibkco",
   "FIELD9": ""
 },
 {
   "symbol": "IBKCP",
   "name": "IBERIABANK Corporation",
   "last_sale": "27.3598",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ibkcp",
   "FIELD9": ""
 },
 {
   "symbol": "IBEX",
   "name": "IBEX Holdings Limited",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ibex",
   "FIELD9": ""
 },
 {
   "symbol": "ICAD",
   "name": "icad inc.",
   "last_sale": "2.99",
   "market_cap": "$50.42M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/icad",
   "FIELD9": ""
 },
 {
   "symbol": "IEP",
   "name": "Icahn Enterprises L.P.",
   "last_sale": "68.78",
   "market_cap": "$12.53B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/iep",
   "FIELD9": ""
 },
 {
   "symbol": "ICCH",
   "name": "ICC Holdings, Inc.",
   "last_sale": "15.105",
   "market_cap": "$52.87M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/icch",
   "FIELD9": ""
 },
 {
   "symbol": "ICFI",
   "name": "ICF International, Inc.",
   "last_sale": "73.95",
   "market_cap": "$1.39B",
   "IPOyear": "2006",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/icfi",
   "FIELD9": ""
 },
 {
   "symbol": "ICHR",
   "name": "Ichor Holdings",
   "last_sale": "21.31",
   "market_cap": "$519.08M",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/ichr",
   "FIELD9": ""
 },
 {
   "symbol": "ICLK",
   "name": "iClick Interactive Asia Group Limited",
   "last_sale": "4.3",
   "market_cap": "$224.87M",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/iclk",
   "FIELD9": ""
 },
 {
   "symbol": "ICLR",
   "name": "ICON plc",
   "last_sale": "150.25",
   "market_cap": "$8.16B",
   "IPOyear": "1998",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/iclr",
   "FIELD9": ""
 },
 {
   "symbol": "ICON",
   "name": "Iconix Brand Group, Inc.",
   "last_sale": "0.2372",
   "market_cap": "$16.21M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Shoe Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/icon",
   "FIELD9": ""
 },
 {
   "symbol": "ICUI",
   "name": "ICU Medical, Inc.",
   "last_sale": "265.25",
   "market_cap": "$5.43B",
   "IPOyear": "1992",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/icui",
   "FIELD9": ""
 },
 {
   "symbol": "IPWR",
   "name": "Ideal Power Inc.",
   "last_sale": "0.64",
   "market_cap": "$8.96M",
   "IPOyear": "2013",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/ipwr",
   "FIELD9": ""
 },
 {
   "symbol": "INVE",
   "name": "Identiv, Inc.",
   "last_sale": "5.71",
   "market_cap": "$87.67M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/inve",
   "FIELD9": ""
 },
 {
   "symbol": "IDRA",
   "name": "Idera Pharmaceuticals, Inc.",
   "last_sale": "8.45",
   "market_cap": "$229.62M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/idra",
   "FIELD9": ""
 },
 {
   "symbol": "IDXX",
   "name": "IDEXX Laboratories, Inc.",
   "last_sale": "241.13",
   "market_cap": "$20.88B",
   "IPOyear": "1991",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/idxx",
   "FIELD9": ""
 },
 {
   "symbol": "IESC",
   "name": "IES Holdings, Inc.",
   "last_sale": "19.45",
   "market_cap": "$412.45M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Engineering & Construction",
   "summary_quote": "https://www.nasdaq.com/symbol/iesc",
   "FIELD9": ""
 },
 {
   "symbol": "IROQ",
   "name": "IF Bancorp, Inc.",
   "last_sale": "24.5251",
   "market_cap": "$94.95M",
   "IPOyear": "2011",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/iroq",
   "FIELD9": ""
 },
 {
   "symbol": "IFMK",
   "name": "iFresh Inc.",
   "last_sale": "2.97",
   "market_cap": "$43.51M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Food Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/ifmk",
   "FIELD9": ""
 },
 {
   "symbol": "INFO",
   "name": "IHS Markit Ltd.",
   "last_sale": "55.21",
   "market_cap": "$21.64B",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/info",
   "FIELD9": ""
 },
 {
   "symbol": "IIVI",
   "name": "II-VI Incorporated",
   "last_sale": "48.05",
   "market_cap": "$3.06B",
   "IPOyear": "1987",
   "sector": "Capital Goods",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/iivi",
   "FIELD9": ""
 },
 {
   "symbol": "KANG",
   "name": "iKang Healthcare Group, Inc.",
   "last_sale": "17.67",
   "market_cap": "$1.23B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kang",
   "FIELD9": ""
 },
 {
   "symbol": "IKNX",
   "name": "Ikonics Corporation",
   "last_sale": "10.6444",
   "market_cap": "$21.11M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/iknx",
   "FIELD9": ""
 },
 {
   "symbol": "ILMN",
   "name": "Illumina, Inc.",
   "last_sale": "358.16",
   "market_cap": "$52.65B",
   "IPOyear": "2000",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/ilmn",
   "FIELD9": ""
 },
 {
   "symbol": "ISNS",
   "name": "Image Sensing Systems, Inc.",
   "last_sale": "5.65",
   "market_cap": "$29.77M",
   "IPOyear": "1995",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/isns",
   "FIELD9": ""
 },
 {
   "symbol": "IMMR",
   "name": "Immersion Corporation",
   "last_sale": "10.18",
   "market_cap": "$313.24M",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/immr",
   "FIELD9": ""
 },
 {
   "symbol": "ICCC",
   "name": "ImmuCell Corporation",
   "last_sale": "8.965",
   "market_cap": "$49.16M",
   "IPOyear": "1987",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/iccc",
   "FIELD9": ""
 },
 {
   "symbol": "IMDZ",
   "name": "Immune Design Corp.",
   "last_sale": "3.5",
   "market_cap": "$168.58M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/imdz",
   "FIELD9": ""
 },
 {
   "symbol": "IMGN",
   "name": "ImmunoGen, Inc.",
   "last_sale": "9.05",
   "market_cap": "$1.35B",
   "IPOyear": "1989",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/imgn",
   "FIELD9": ""
 },
 {
   "symbol": "IMMU",
   "name": "Immunomedics, Inc.",
   "last_sale": "21.53",
   "market_cap": "$4.02B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/immu",
   "FIELD9": ""
 },
 {
   "symbol": "IMRN",
   "name": "Immuron Limited",
   "last_sale": "9.849",
   "market_cap": "$35.16M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/imrn",
   "FIELD9": ""
 },
 {
   "symbol": "IMRNW",
   "name": "Immuron Limited",
   "last_sale": "3",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/imrnw",
   "FIELD9": ""
 },
 {
   "symbol": "IMMP",
   "name": "Immutep Limited",
   "last_sale": "2.99",
   "market_cap": "$90.48M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/immp",
   "FIELD9": ""
 },
 {
   "symbol": "IMPV",
   "name": "Imperva, Inc.",
   "last_sale": "45.65",
   "market_cap": "$1.6B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/impv",
   "FIELD9": ""
 },
 {
   "symbol": "PI",
   "name": "Impinj, Inc.",
   "last_sale": "24.88",
   "market_cap": "$607.39M",
   "IPOyear": "2016",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/pi",
   "FIELD9": ""
 },
 {
   "symbol": "IMMY",
   "name": "Imprimis Pharmaceuticals, Inc.",
   "last_sale": "2.76",
   "market_cap": "$58.1M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/immy",
   "FIELD9": ""
 },
 {
   "symbol": "IMV",
   "name": "IMV Inc.",
   "last_sale": "5.16",
   "market_cap": "$231.65M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/imv",
   "FIELD9": ""
 },
 {
   "symbol": "INCY",
   "name": "Incyte Corporation",
   "last_sale": "66.59",
   "market_cap": "$14.16B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/incy",
   "FIELD9": ""
 },
 {
   "symbol": "INDB",
   "name": "Independent Bank Corp.",
   "last_sale": "87.9",
   "market_cap": "$2.42B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/indb",
   "FIELD9": ""
 },
 {
   "symbol": "IBCP",
   "name": "Independent Bank Corporation",
   "last_sale": "24.2",
   "market_cap": "$584.45M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ibcp",
   "FIELD9": ""
 },
 {
   "symbol": "IBTX",
   "name": "Independent Bank Group, Inc",
   "last_sale": "67.55",
   "market_cap": "$2.06B",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ibtx",
   "FIELD9": ""
 },
 {
   "symbol": "INDU",
   "name": "Industrea Acquisition Corp.",
   "last_sale": "10.18",
   "market_cap": "$70.07M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/indu",
   "FIELD9": ""
 },
 {
   "symbol": "INDUU",
   "name": "Industrea Acquisition Corp.",
   "last_sale": "11.13",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/induu",
   "FIELD9": ""
 },
 {
   "symbol": "INDUW",
   "name": "Industrea Acquisition Corp.",
   "last_sale": "0.96",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/induw",
   "FIELD9": ""
 },
 {
   "symbol": "ILPT",
   "name": "Industrial Logistics Properties Trust",
   "last_sale": "21.68",
   "market_cap": "$1.41B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ilpt",
   "FIELD9": ""
 },
 {
   "symbol": "IDSA",
   "name": "Industrial Services of America, Inc.",
   "last_sale": "2.35",
   "market_cap": "$19.05M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/idsa",
   "FIELD9": ""
 },
 {
   "symbol": "INFN",
   "name": "Infinera Corporation",
   "last_sale": "7.04",
   "market_cap": "$1.08B",
   "IPOyear": "2007",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/infn",
   "FIELD9": ""
 },
 {
   "symbol": "INFI",
   "name": "Infinity Pharmaceuticals, Inc.",
   "last_sale": "2.4",
   "market_cap": "$136.44M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/infi",
   "FIELD9": ""
 },
 {
   "symbol": "IFRX",
   "name": "InflaRx N.V.",
   "last_sale": "33.1",
   "market_cap": "$849.42M",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ifrx",
   "FIELD9": ""
 },
 {
   "symbol": "III",
   "name": "Information Services Group, Inc.",
   "last_sale": "4.795",
   "market_cap": "$216.27M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/iii",
   "FIELD9": ""
 },
 {
   "symbol": "IEA",
   "name": "Infrastructure and Energy Alternatives, Inc.",
   "last_sale": "10.5",
   "market_cap": "$226.57M",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/iea",
   "FIELD9": ""
 },
 {
   "symbol": "IEAWW",
   "name": "Infrastructure and Energy Alternatives, Inc.",
   "last_sale": "1.55",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ieaww",
   "FIELD9": ""
 },
 {
   "symbol": "IMKTA",
   "name": "Ingles Markets, Incorporated",
   "last_sale": "34.05",
   "market_cap": "$689.85M",
   "IPOyear": "1987",
   "sector": "Consumer Services",
   "industry": "Food Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/imkta",
   "FIELD9": ""
 },
 {
   "symbol": "INWK",
   "name": "InnerWorkings, Inc.",
   "last_sale": "8.11",
   "market_cap": "$423.11M",
   "IPOyear": "2006",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/inwk",
   "FIELD9": ""
 },
 {
   "symbol": "INOD",
   "name": "Innodata Inc.",
   "last_sale": "1.32",
   "market_cap": "$34.16M",
   "IPOyear": "1993",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/inod",
   "FIELD9": ""
 },
 {
   "symbol": "IPHS",
   "name": "Innophos Holdings, Inc.",
   "last_sale": "45.73",
   "market_cap": "$896.7M",
   "IPOyear": "2006",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/iphs",
   "FIELD9": ""
 },
 {
   "symbol": "IOSP",
   "name": "Innospec Inc.",
   "last_sale": "76.3",
   "market_cap": "$1.86B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/iosp",
   "FIELD9": ""
 },
 {
   "symbol": "INNT",
   "name": "Innovate Biopharmaceuticals, Inc.",
   "last_sale": "6.94",
   "market_cap": "$178.96M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/innt",
   "FIELD9": ""
 },
 {
   "symbol": "ISSC",
   "name": "Innovative Solutions and Support, Inc.",
   "last_sale": "2.55",
   "market_cap": "$42.94M",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/issc",
   "FIELD9": ""
 },
 {
   "symbol": "INVA",
   "name": "Innoviva, Inc.",
   "last_sale": "14.95",
   "market_cap": "$1.52B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/inva",
   "FIELD9": ""
 },
 {
   "symbol": "INGN",
   "name": "Inogen, Inc",
   "last_sale": "254.72",
   "market_cap": "$5.44B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/ingn",
   "FIELD9": ""
 },
 {
   "symbol": "INOV",
   "name": "Inovalon Holdings, Inc.",
   "last_sale": "10.65",
   "market_cap": "$1.63B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/inov",
   "FIELD9": ""
 },
 {
   "symbol": "INO",
   "name": "Inovio Pharmaceuticals, Inc.",
   "last_sale": "4.73",
   "market_cap": "$432.78M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/ino",
   "FIELD9": ""
 },
 {
   "symbol": "INPX",
   "name": "Inpixon ",
   "last_sale": "0.155",
   "market_cap": "$6.8M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/inpx",
   "FIELD9": ""
 },
 {
   "symbol": "INSG",
   "name": "Inseego Corp.",
   "last_sale": "4.09",
   "market_cap": "$296.17M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/insg",
   "FIELD9": ""
 },
 {
   "symbol": "NSIT",
   "name": "Insight Enterprises, Inc.",
   "last_sale": "55.48",
   "market_cap": "$1.97B",
   "IPOyear": "1995",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/nsit",
   "FIELD9": ""
 },
 {
   "symbol": "ISIG",
   "name": "Insignia Systems, Inc.",
   "last_sale": "1.74",
   "market_cap": "$20.59M",
   "IPOyear": "1991",
   "sector": "Consumer Services",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/isig",
   "FIELD9": ""
 },
 {
   "symbol": "INSM",
   "name": "Insmed, Inc.",
   "last_sale": "21.31",
   "market_cap": "$1.64B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/insm",
   "FIELD9": ""
 },
 {
   "symbol": "INSE",
   "name": "Inspired Entertainment, Inc.",
   "last_sale": "6.35",
   "market_cap": "$136.43M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/inse",
   "FIELD9": ""
 },
 {
   "symbol": "IIIN",
   "name": "Insteel Industries, Inc.",
   "last_sale": "36.18",
   "market_cap": "$690.51M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/iiin",
   "FIELD9": ""
 },
 {
   "symbol": "PODD",
   "name": "Insulet Corporation",
   "last_sale": "102.175",
   "market_cap": "$6.03B",
   "IPOyear": "2007",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/podd",
   "FIELD9": ""
 },
 {
   "symbol": "INSY",
   "name": "Insys Therapeutics, Inc.",
   "last_sale": "9.14",
   "market_cap": "$678.6M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/insy",
   "FIELD9": ""
 },
 {
   "symbol": "NTEC",
   "name": "Intec Pharma Ltd.",
   "last_sale": "4.25",
   "market_cap": "$141.21M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ntec",
   "FIELD9": ""
 },
 {
   "symbol": "IART",
   "name": "Integra LifeSciences Holdings Corporation",
   "last_sale": "63.15",
   "market_cap": "$5.38B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/iart",
   "FIELD9": ""
 },
 {
   "symbol": "IDTI",
   "name": "Integrated Device Technology, Inc.",
   "last_sale": "47.08",
   "market_cap": "$6.07B",
   "IPOyear": "1984",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/idti",
   "FIELD9": ""
 },
 {
   "symbol": "IMTE",
   "name": "Integrated Media Technology Limited",
   "last_sale": "10.2",
   "market_cap": "$26.96M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/imte",
   "FIELD9": ""
 },
 {
   "symbol": "INTC",
   "name": "Intel Corporation",
   "last_sale": "46.65",
   "market_cap": "$215.1B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/intc",
   "FIELD9": ""
 },
 {
   "symbol": "NTLA",
   "name": "Intellia Therapeutics, Inc.",
   "last_sale": "26.78",
   "market_cap": "$1.16B",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/ntla",
   "FIELD9": ""
 },
 {
   "symbol": "IPCI",
   "name": "Intellipharmaceutics International Inc.",
   "last_sale": "2.9811",
   "market_cap": "$12.98M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ipci",
   "FIELD9": ""
 },
 {
   "symbol": "IPAR",
   "name": "Inter Parfums, Inc.",
   "last_sale": "64.8",
   "market_cap": "$2.03B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/ipar",
   "FIELD9": ""
 },
 {
   "symbol": "IBKR",
   "name": "Interactive Brokers Group, Inc.",
   "last_sale": "57.43",
   "market_cap": "$23.85B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/ibkr",
   "FIELD9": ""
 },
 {
   "symbol": "ICPT",
   "name": "Intercept Pharmaceuticals, Inc.",
   "last_sale": "114.17",
   "market_cap": "$3.38B",
   "IPOyear": "2012",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/icpt",
   "FIELD9": ""
 },
 {
   "symbol": "IDCC",
   "name": "InterDigital, Inc.",
   "last_sale": "79.8",
   "market_cap": "$2.78B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Multi-Sector Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/idcc",
   "FIELD9": ""
 },
 {
   "symbol": "TILE",
   "name": "Interface, Inc.",
   "last_sale": "23.5",
   "market_cap": "$1.4B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/tile",
   "FIELD9": ""
 },
 {
   "symbol": "LINK",
   "name": "Interlink Electronics, Inc.",
   "last_sale": "4.3",
   "market_cap": "$27.88M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/link",
   "FIELD9": ""
 },
 {
   "symbol": "IMI",
   "name": "Intermolecular, Inc.",
   "last_sale": "1.2",
   "market_cap": "$59.69M",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/imi",
   "FIELD9": ""
 },
 {
   "symbol": "INAP",
   "name": "Internap Corporation",
   "last_sale": "13.14",
   "market_cap": "$278.81M",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/inap",
   "FIELD9": ""
 },
 {
   "symbol": "IBOC",
   "name": "International Bancshares Corporation",
   "last_sale": "46.95",
   "market_cap": "$3.11B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/iboc",
   "FIELD9": ""
 },
 {
   "symbol": "IMXI",
   "name": "International Money Express, Inc.",
   "last_sale": "11.25",
   "market_cap": "$268.8M",
   "IPOyear": "2017",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/imxi",
   "FIELD9": ""
 },
 {
   "symbol": "IMXIW",
   "name": "International Money Express, Inc.",
   "last_sale": "1.98",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/imxiw",
   "FIELD9": ""
 },
 {
   "symbol": "ISCA",
   "name": "International Speedway Corporation",
   "last_sale": "45.05",
   "market_cap": "$1.99B",
   "IPOyear": "1996",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/isca",
   "FIELD9": ""
 },
 {
   "symbol": "IGLD",
   "name": "Internet Gold Golden Lines Ltd.",
   "last_sale": "2.7",
   "market_cap": "$75.61M",
   "IPOyear": "1999",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/igld",
   "FIELD9": ""
 },
 {
   "symbol": "IIJI",
   "name": "Internet Initiative Japan, Inc.",
   "last_sale": "10.04",
   "market_cap": "$905.02M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/iiji",
   "FIELD9": ""
 },
 {
   "symbol": "IDXG",
   "name": "Interpace Diagnostics Group, Inc.",
   "last_sale": "1.53",
   "market_cap": "$43.14M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/idxg",
   "FIELD9": ""
 },
 {
   "symbol": "XENT",
   "name": "Intersect ENT, Inc.",
   "last_sale": "29.65",
   "market_cap": "$902.98M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/xent",
   "FIELD9": ""
 },
 {
   "symbol": "INTX",
   "name": "Intersections, Inc.",
   "last_sale": "1.79",
   "market_cap": "$43.6M",
   "IPOyear": "2004",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/intx",
   "FIELD9": ""
 },
 {
   "symbol": "IVAC",
   "name": "Intevac, Inc.",
   "last_sale": "5.1",
   "market_cap": "$115.17M",
   "IPOyear": "1995",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/ivac",
   "FIELD9": ""
 },
 {
   "symbol": "INTL",
   "name": "INTL FCStone Inc.",
   "last_sale": "48.47",
   "market_cap": "$916.41M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/intl",
   "FIELD9": ""
 },
 {
   "symbol": "ITCI",
   "name": "Intra-Cellular Therapies Inc.",
   "last_sale": "21.06",
   "market_cap": "$1.15B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/itci",
   "FIELD9": ""
 },
 {
   "symbol": "IIN",
   "name": "IntriCon Corporation",
   "last_sale": "66.7",
   "market_cap": "$561.25M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/iin",
   "FIELD9": ""
 },
 {
   "symbol": "INTU",
   "name": "Intuit Inc.",
   "last_sale": "220.44",
   "market_cap": "$57.02B",
   "IPOyear": "1993",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/intu",
   "FIELD9": ""
 },
 {
   "symbol": "ISRG",
   "name": "Intuitive Surgical, Inc.",
   "last_sale": "556.77",
   "market_cap": "$63.33B",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/isrg",
   "FIELD9": ""
 },
 {
   "symbol": "PLW",
   "name": "Invesco 1-30 Laddered Treasury ETF",
   "last_sale": "31.05",
   "market_cap": "$150.59M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/plw",
   "FIELD9": ""
 },
 {
   "symbol": "ADRA",
   "name": "Invesco BLDRS Asia 50 ADR Index Fund",
   "last_sale": "32.847",
   "market_cap": "$19.71M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/adra",
   "FIELD9": ""
 },
 {
   "symbol": "ADRD",
   "name": "Invesco BLDRS Developed Markets 100 ADR Index Fund",
   "last_sale": "22.7242",
   "market_cap": "$57.95M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/adrd",
   "FIELD9": ""
 },
 {
   "symbol": "ADRE",
   "name": "Invesco BLDRS Emerging Markets 50 ADR Index Fund",
   "last_sale": "40.8467",
   "market_cap": "$145.01M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/adre",
   "FIELD9": ""
 },
 {
   "symbol": "ADRU",
   "name": "Invesco BLDRS Europe Select ADR Index Fund",
   "last_sale": "22.085",
   "market_cap": "$15.46M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/adru",
   "FIELD9": ""
 },
 {
   "symbol": "PKW",
   "name": "Invesco BuyBack Achievers ETF",
   "last_sale": "62.16",
   "market_cap": "$1.32B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pkw",
   "FIELD9": ""
 },
 {
   "symbol": "PFM",
   "name": "Invesco Dividend Achievers ETF",
   "last_sale": "28.02",
   "market_cap": "$308.22M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pfm",
   "FIELD9": ""
 },
 {
   "symbol": "PYZ",
   "name": "Invesco DWA Basic Materials Momentum ETF",
   "last_sale": "70.78",
   "market_cap": "$102.63M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pyz",
   "FIELD9": ""
 },
 {
   "symbol": "PEZ",
   "name": "Invesco DWA Consumer Cyclicals Momentum ETF",
   "last_sale": "59.28",
   "market_cap": "$77.06M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pez",
   "FIELD9": ""
 },
 {
   "symbol": "PSL",
   "name": "Invesco DWA Consumer Staples Momentum ETF",
   "last_sale": "72.7",
   "market_cap": "$149.04M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psl",
   "FIELD9": ""
 },
 {
   "symbol": "PIZ",
   "name": "Invesco DWA Developed Markets Momentum ETF",
   "last_sale": "27.8",
   "market_cap": "$252.98M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/piz",
   "FIELD9": ""
 },
 {
   "symbol": "PIE",
   "name": "Invesco DWA Emerging Markets Momentum ETF",
   "last_sale": "18.39",
   "market_cap": "$246.43M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pie",
   "FIELD9": ""
 },
 {
   "symbol": "PXI",
   "name": "Invesco DWA Energy Momentum ETF",
   "last_sale": "42.94",
   "market_cap": "$96.62M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pxi",
   "FIELD9": ""
 },
 {
   "symbol": "PFI",
   "name": "Invesco DWA Financial Momentum ETF",
   "last_sale": "35.3899",
   "market_cap": "$38.93M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pfi",
   "FIELD9": ""
 },
 {
   "symbol": "PTH",
   "name": "Invesco DWA Healthcare Momentum ETF",
   "last_sale": "95.86",
   "market_cap": "$349.89M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pth",
   "FIELD9": ""
 },
 {
   "symbol": "PRN",
   "name": "Invesco DWA Industrials Momentum ETF",
   "last_sale": "65.03",
   "market_cap": "$123.56M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/prn",
   "FIELD9": ""
 },
 {
   "symbol": "DWLV",
   "name": "Invesco DWA Momentum & Low Volatility Rotation ETF",
   "last_sale": "33.7802",
   "market_cap": "$45.6M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dwlv",
   "FIELD9": ""
 },
 {
   "symbol": "PDP",
   "name": "Invesco DWA Momentum ETF",
   "last_sale": "59.15",
   "market_cap": "$1.63B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pdp",
   "FIELD9": ""
 },
 {
   "symbol": "DWAQ",
   "name": "Invesco DWA NASDAQ Momentum ETF",
   "last_sale": "115.74",
   "market_cap": "$57.87M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dwaq",
   "FIELD9": ""
 },
 {
   "symbol": "DWAS",
   "name": "Invesco DWA SmallCap Momentum ETF",
   "last_sale": "57.4701",
   "market_cap": "$448.27M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dwas",
   "FIELD9": ""
 },
 {
   "symbol": "DWIN",
   "name": "Invesco DWA Tactical Multi-Asset Income ETF",
   "last_sale": "25.1635",
   "market_cap": "$61.65M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dwin",
   "FIELD9": ""
 },
 {
   "symbol": "DWTR",
   "name": "Invesco DWA Tactical Sector Rotation ETF",
   "last_sale": "31.31",
   "market_cap": "$87.67M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dwtr",
   "FIELD9": ""
 },
 {
   "symbol": "PTF",
   "name": "Invesco DWA Technology Momentum ETF",
   "last_sale": "64.5325",
   "market_cap": "$154.88M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ptf",
   "FIELD9": ""
 },
 {
   "symbol": "PUI",
   "name": "Invesco DWA Utilities Momentum ETF",
   "last_sale": "29.0969",
   "market_cap": "$42.19M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pui",
   "FIELD9": ""
 },
 {
   "symbol": "IDLB",
   "name": "Invesco FTSE International Low Beta Equal Weight ETF",
   "last_sale": "29.57",
   "market_cap": "$121.24M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/idlb",
   "FIELD9": ""
 },
 {
   "symbol": "PRFZ",
   "name": "Invesco FTSE RAFI US 1500 Small-Mid ETF",
   "last_sale": "143.47",
   "market_cap": "$2.12B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/prfz",
   "FIELD9": ""
 },
 {
   "symbol": "PAGG",
   "name": "Invesco Global Agriculture ETF",
   "last_sale": "27.827",
   "market_cap": "$20.87M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pagg",
   "FIELD9": ""
 },
 {
   "symbol": "PSAU",
   "name": "Invesco Global Gold and Precious Metals ETF",
   "last_sale": "15.46",
   "market_cap": "$23.96M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psau",
   "FIELD9": ""
 },
 {
   "symbol": "PIO",
   "name": "Invesco Global Water ETF",
   "last_sale": "26.2",
   "market_cap": "$184.71M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pio",
   "FIELD9": ""
 },
 {
   "symbol": "PGJ",
   "name": "Invesco Golden Dragon China ETF",
   "last_sale": "39.1186",
   "market_cap": "$207.33M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pgj",
   "FIELD9": ""
 },
 {
   "symbol": "PEY",
   "name": "Invesco High Yield Equity Dividend Achievers ETF",
   "last_sale": "18.34",
   "market_cap": "$790.45M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pey",
   "FIELD9": ""
 },
 {
   "symbol": "IPKW",
   "name": "Invesco International BuyBack Achievers ETF",
   "last_sale": "34.521",
   "market_cap": "$291.7M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ipkw",
   "FIELD9": ""
 },
 {
   "symbol": "PID",
   "name": "Invesco International Dividend Achievers ETF",
   "last_sale": "16.01",
   "market_cap": "$788.49M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pid",
   "FIELD9": ""
 },
 {
   "symbol": "KBWB",
   "name": "Invesco KBW Bank ETF",
   "last_sale": "57.02",
   "market_cap": "$980.74M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kbwb",
   "FIELD9": ""
 },
 {
   "symbol": "KBWD",
   "name": "Invesco KBW High Dividend Yield Financial ETF",
   "last_sale": "23.44",
   "market_cap": "$341.05M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kbwd",
   "FIELD9": ""
 },
 {
   "symbol": "KBWY",
   "name": "Invesco KBW Premium Yield Equity REIT ETF",
   "last_sale": "34.08",
   "market_cap": "$429.41M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kbwy",
   "FIELD9": ""
 },
 {
   "symbol": "KBWP",
   "name": "Invesco KBW Property & Casualty Insurance ETF",
   "last_sale": "64.8",
   "market_cap": "$68.04M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kbwp",
   "FIELD9": ""
 },
 {
   "symbol": "KBWR",
   "name": "Invesco KBW Regional Banking ETF",
   "last_sale": "58.445",
   "market_cap": "$189.95M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kbwr",
   "FIELD9": ""
 },
 {
   "symbol": "LDRI",
   "name": "Invesco LadderRite 0-5 Year Corporate Bond ETF",
   "last_sale": "24.61",
   "market_cap": "$12.31M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ldri",
   "FIELD9": ""
 },
 {
   "symbol": "LALT",
   "name": "Invesco Multi-Strategy Alternative ETF",
   "last_sale": "21.5145",
   "market_cap": "$4.3M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lalt",
   "FIELD9": ""
 },
 {
   "symbol": "PNQI",
   "name": "Invesco Nasdaq Internet ETF",
   "last_sale": "133.61",
   "market_cap": "$641.33M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pnqi",
   "FIELD9": ""
 },
 {
   "symbol": "PDBC",
   "name": "Invesco Optimum Yield Diversified Commodity Strategy No K-1 ET",
   "last_sale": "18.28",
   "market_cap": "$2.22B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pdbc",
   "FIELD9": ""
 },
 {
   "symbol": "QQQ",
   "name": "Invesco QQQ Trust, Series 1",
   "last_sale": "183.71",
   "market_cap": "$71.21B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qqq",
   "FIELD9": ""
 },
 {
   "symbol": "USLB",
   "name": "Invesco Russell 1000 Low Beta Equal Weight ETF",
   "last_sale": "33.27",
   "market_cap": "$164.69M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/uslb",
   "FIELD9": ""
 },
 {
   "symbol": "PSCD",
   "name": "Invesco S&P SmallCap Consumer Discretionary ETF",
   "last_sale": "69.8267",
   "market_cap": "$94.27M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pscd",
   "FIELD9": ""
 },
 {
   "symbol": "PSCC",
   "name": "Invesco S&P SmallCap Consumer Staples ETF",
   "last_sale": "85.07",
   "market_cap": "$97.83M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pscc",
   "FIELD9": ""
 },
 {
   "symbol": "PSCE",
   "name": "Invesco S&P SmallCap Energy ETF",
   "last_sale": "16.19",
   "market_cap": "$55.86M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psce",
   "FIELD9": ""
 },
 {
   "symbol": "PSCF",
   "name": "Invesco S&P SmallCap Financials ETF",
   "last_sale": "58.88",
   "market_cap": "$264.96M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pscf",
   "FIELD9": ""
 },
 {
   "symbol": "PSCH",
   "name": "Invesco S&P SmallCap Health Care ETF",
   "last_sale": "140.34",
   "market_cap": "$1.35B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psch",
   "FIELD9": ""
 },
 {
   "symbol": "PSCI",
   "name": "Invesco S&P SmallCap Industrials ETF",
   "last_sale": "73.8",
   "market_cap": "$151.29M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psci",
   "FIELD9": ""
 },
 {
   "symbol": "PSCT",
   "name": "Invesco S&P SmallCap Information Technology ETF",
   "last_sale": "85.8",
   "market_cap": "$450.45M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psct",
   "FIELD9": ""
 },
 {
   "symbol": "PSCM",
   "name": "Invesco S&P SmallCap Materials ETF",
   "last_sale": "56.79",
   "market_cap": "$31.23M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pscm",
   "FIELD9": ""
 },
 {
   "symbol": "PSCU",
   "name": "Invesco S&P SmallCap Utilities ETF",
   "last_sale": "57.4",
   "market_cap": "$68.88M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pscu",
   "FIELD9": ""
 },
 {
   "symbol": "ISDX",
   "name": "Invesco Strategic Developed ex-US ETF",
   "last_sale": "25.9",
   "market_cap": "$2.59M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/isdx",
   "FIELD9": ""
 },
 {
   "symbol": "ISDS",
   "name": "Invesco Strategic Developed ex-US Small Company ETF",
   "last_sale": "25.41",
   "market_cap": "$2.54M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/isds",
   "FIELD9": ""
 },
 {
   "symbol": "ISEM",
   "name": "Invesco Strategic Emerging Markets ETF",
   "last_sale": "26.05",
   "market_cap": "$2.61M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/isem",
   "FIELD9": ""
 },
 {
   "symbol": "IUS",
   "name": "Invesco Strategic US ETF",
   "last_sale": "25.375",
   "market_cap": "$2.54M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ius",
   "FIELD9": ""
 },
 {
   "symbol": "IUSS",
   "name": "Invesco Strategic US Small Company ETF",
   "last_sale": "25.14",
   "market_cap": "$2.51M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iuss",
   "FIELD9": ""
 },
 {
   "symbol": "VRIG",
   "name": "Invesco Variable Rate Investment Grade ETF",
   "last_sale": "25.15",
   "market_cap": "$404.92M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vrig",
   "FIELD9": ""
 },
 {
   "symbol": "PHO",
   "name": "Invesco Water Resources ETF",
   "last_sale": "32.36",
   "market_cap": "$883.43M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pho",
   "FIELD9": ""
 },
 {
   "symbol": "ISTR",
   "name": "Investar Holding Corporation",
   "last_sale": "27",
   "market_cap": "$258.42M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/istr",
   "FIELD9": ""
 },
 {
   "symbol": "ISBC",
   "name": "Investors Bancorp, Inc.",
   "last_sale": "12.63",
   "market_cap": "$3.76B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/isbc",
   "FIELD9": ""
 },
 {
   "symbol": "ITIC",
   "name": "Investors Title Company",
   "last_sale": "171.5",
   "market_cap": "$323.56M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/itic",
   "FIELD9": ""
 },
 {
   "symbol": "NVIV",
   "name": "InVivo Therapeutics Holdings Corp.",
   "last_sale": "1.9",
   "market_cap": "$14.75M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/nviv",
   "FIELD9": ""
 },
 {
   "symbol": "IVTY",
   "name": "Invuity, Inc.",
   "last_sale": "7.375",
   "market_cap": "$177.54M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/ivty",
   "FIELD9": ""
 },
 {
   "symbol": "IONS",
   "name": "Ionis Pharmaceuticals, Inc.",
   "last_sale": "49.14",
   "market_cap": "$6.75B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ions",
   "FIELD9": ""
 },
 {
   "symbol": "IOVA",
   "name": "Iovance Biotherapeutics, Inc.",
   "last_sale": "13.55",
   "market_cap": "$1.3B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/iova",
   "FIELD9": ""
 },
 {
   "symbol": "IPAS",
   "name": "iPass Inc.",
   "last_sale": "1.95",
   "market_cap": "$16.38M",
   "IPOyear": "2003",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ipas",
   "FIELD9": ""
 },
 {
   "symbol": "IPGP",
   "name": "IPG Photonics Corporation",
   "last_sale": "169.36",
   "market_cap": "$9.21B",
   "IPOyear": "2006",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/ipgp",
   "FIELD9": ""
 },
 {
   "symbol": "IPIC",
   "name": "iPic Entertainment Inc.",
   "last_sale": "6.42",
   "market_cap": "$73.42M",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/ipic",
   "FIELD9": ""
 },
 {
   "symbol": "CLRG",
   "name": "IQ Chaikin U.S. Large Cap ETF",
   "last_sale": "26.5",
   "market_cap": "$377.63M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/clrg",
   "FIELD9": ""
 },
 {
   "symbol": "CSML",
   "name": "IQ Chaikin U.S. Small Cap ETF",
   "last_sale": "28.83",
   "market_cap": "$514.62M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/csml",
   "FIELD9": ""
 },
 {
   "symbol": "IQ",
   "name": "iQIYI, Inc.",
   "last_sale": "26.21",
   "market_cap": "$18.55B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Consumer Electronics/Video Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/iq",
   "FIELD9": ""
 },
 {
   "symbol": "IRMD",
   "name": "iRadimed Corporation",
   "last_sale": "33.4",
   "market_cap": "$356.72M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/irmd",
   "FIELD9": ""
 },
 {
   "symbol": "IRTC",
   "name": "iRhythm Technologies, Inc.",
   "last_sale": "91.41",
   "market_cap": "$2.19B",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/irtc",
   "FIELD9": ""
 },
 {
   "symbol": "IRIX",
   "name": "IRIDEX Corporation",
   "last_sale": "6.52",
   "market_cap": "$76.05M",
   "IPOyear": "1996",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/irix",
   "FIELD9": ""
 },
 {
   "symbol": "IRDM",
   "name": "Iridium Communications Inc",
   "last_sale": "20.1",
   "market_cap": "$2.23B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/irdm",
   "FIELD9": ""
 },
 {
   "symbol": "IRDMB",
   "name": "Iridium Communications Inc",
   "last_sale": "673.97",
   "market_cap": "$336.99M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/irdmb",
   "FIELD9": ""
 },
 {
   "symbol": "IRBT",
   "name": "iRobot Corporation",
   "last_sale": "104.06",
   "market_cap": "$2.85B",
   "IPOyear": "2005",
   "sector": "Consumer Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/irbt",
   "FIELD9": ""
 },
 {
   "symbol": "IRWD",
   "name": "Ironwood Pharmaceuticals, Inc.",
   "last_sale": "17.17",
   "market_cap": "$2.63B",
   "IPOyear": "2010",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/irwd",
   "FIELD9": ""
 },
 {
   "symbol": "IRCP",
   "name": "IRSA Propiedades Comerciales S.A.",
   "last_sale": "26",
   "market_cap": "$819.09M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Building operators",
   "summary_quote": "https://www.nasdaq.com/symbol/ircp",
   "FIELD9": ""
 },
 {
   "symbol": "PMPT",
   "name": "iSectors Post-MPT Growth ETF",
   "last_sale": "27.69",
   "market_cap": "$9.69M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pmpt",
   "FIELD9": ""
 },
 {
   "symbol": "SLQD",
   "name": "iShares 0-5 Year Investment Grade Corporate Bond ETF",
   "last_sale": "49.61",
   "market_cap": "$1.38B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/slqd",
   "FIELD9": ""
 },
 {
   "symbol": "ISHG",
   "name": "iShares 1-3 Year International Treasury Bond ETF",
   "last_sale": "82.3116",
   "market_cap": "$78.2M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ishg",
   "FIELD9": ""
 },
 {
   "symbol": "SHY",
   "name": "iShares 1-3 Year Treasury Bond ETF",
   "last_sale": "83.06",
   "market_cap": "$13.79B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/shy",
   "FIELD9": ""
 },
 {
   "symbol": "TLT",
   "name": "iShares 20+ Year Treasury Bond ETF",
   "last_sale": "117.1",
   "market_cap": "$9.33B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tlt",
   "FIELD9": ""
 },
 {
   "symbol": "IEI",
   "name": "iShares 3-7 Year Treasury Bond ETF",
   "last_sale": "118.94",
   "market_cap": "$7.4B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iei",
   "FIELD9": ""
 },
 {
   "symbol": "IEF",
   "name": "iShares 7-10 Year Treasury Bond ETF",
   "last_sale": "101",
   "market_cap": "$9.19B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ief",
   "FIELD9": ""
 },
 {
   "symbol": "AIA",
   "name": "iShares Asia 50 ETF",
   "last_sale": "62.79",
   "market_cap": "$1.02B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aia",
   "FIELD9": ""
 },
 {
   "symbol": "USIG",
   "name": "iShares Broad USD Investment Grade Corporate Bond ETF",
   "last_sale": "53.5",
   "market_cap": "$1.54B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/usig",
   "FIELD9": ""
 },
 {
   "symbol": "COMT",
   "name": "iShares Commodities Select Strategy ETF",
   "last_sale": "38.59",
   "market_cap": "$764.08M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/comt",
   "FIELD9": ""
 },
 {
   "symbol": "ISTB",
   "name": "iShares Core 1-5 Year USD Bond ETF",
   "last_sale": "48.94",
   "market_cap": "$2.18B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/istb",
   "FIELD9": ""
 },
 {
   "symbol": "IXUS",
   "name": "iShares Core MSCI Total International Stock ETF",
   "last_sale": "60.87",
   "market_cap": "$11.02B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ixus",
   "FIELD9": ""
 },
 {
   "symbol": "IUSG",
   "name": "iShares Core S&P U.S. Growth ETF",
   "last_sale": "62",
   "market_cap": "$5.35B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iusg",
   "FIELD9": ""
 },
 {
   "symbol": "IUSV",
   "name": "iShares Core S&P U.S. Value ETF",
   "last_sale": "57.68",
   "market_cap": "$4.73B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iusv",
   "FIELD9": ""
 },
 {
   "symbol": "IUSB",
   "name": "iShares Core Total USD Bond Market ETF",
   "last_sale": "49.06",
   "market_cap": "$2.32B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iusb",
   "FIELD9": ""
 },
 {
   "symbol": "HEWG",
   "name": "iShares Currency Hedged MSCI Germany ETF",
   "last_sale": "27.66",
   "market_cap": "$337.45M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hewg",
   "FIELD9": ""
 },
 {
   "symbol": "SUSB",
   "name": "iShares ESG 1-5 Year USD Corporate Bond ETF",
   "last_sale": "24.54",
   "market_cap": "$39.26M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/susb",
   "FIELD9": ""
 },
 {
   "symbol": "SUSC",
   "name": "iShares ESG USD Corporate Bond ETF",
   "last_sale": "24.2",
   "market_cap": "$18.15M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/susc",
   "FIELD9": ""
 },
 {
   "symbol": "XT",
   "name": "iShares Exponential Technologies ETF",
   "last_sale": "38.85",
   "market_cap": "$2.47B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/xt",
   "FIELD9": ""
 },
 {
   "symbol": "FALN",
   "name": "iShares Fallen Angels USD Bond ETF",
   "last_sale": "26.5296",
   "market_cap": "$68.98M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/faln",
   "FIELD9": ""
 },
 {
   "symbol": "IFEU",
   "name": "iShares FTSE EPRA/NAREIT Europe Index Fund",
   "last_sale": "39.6793",
   "market_cap": "$41.66M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ifeu",
   "FIELD9": ""
 },
 {
   "symbol": "IFGL",
   "name": "iShares FTSE EPRA/NAREIT Global Real Estate ex-U.S. Index Fund",
   "last_sale": "29.18",
   "market_cap": "$472.72M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ifgl",
   "FIELD9": ""
 },
 {
   "symbol": "IGF",
   "name": "iShares Global Infrastructure ETF",
   "last_sale": "42.7",
   "market_cap": "$2.69B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/igf",
   "FIELD9": ""
 },
 {
   "symbol": "GNMA",
   "name": "iShares GNMA Bond ETF",
   "last_sale": "48.0916",
   "market_cap": "$103.4M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gnma",
   "FIELD9": ""
 },
 {
   "symbol": "HYXE",
   "name": "iShares iBoxx $ High Yield ex Oil & Gas Corporate Bond ETF",
   "last_sale": "50.7799",
   "market_cap": "$10.16M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hyxe",
   "FIELD9": ""
 },
 {
   "symbol": "IGIB",
   "name": "iShares Intermediate-Term Corporate Bond ETF",
   "last_sale": "52.975",
   "market_cap": "$5.84B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/igib",
   "FIELD9": ""
 },
 {
   "symbol": "IGOV",
   "name": "iShares International Treasury Bond ETF",
   "last_sale": "48.7999",
   "market_cap": "$880.84M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/igov",
   "FIELD9": ""
 },
 {
   "symbol": "EMB",
   "name": "iShares J.P. Morgan USD Emerging Markets Bond ETF",
   "last_sale": "107.25",
   "market_cap": "$14.21B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/emb",
   "FIELD9": ""
 },
 {
   "symbol": "MBB",
   "name": "iShares MBS ETF",
   "last_sale": "103.13",
   "market_cap": "$12B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mbb",
   "FIELD9": ""
 },
 {
   "symbol": "JKI",
   "name": "iShares Morningstar Mid-Cap ETF",
   "last_sale": "166.11",
   "market_cap": "$473.41M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jki",
   "FIELD9": ""
 },
 {
   "symbol": "ACWX",
   "name": "iShares MSCI ACWI ex US Index Fund",
   "last_sale": "48.15",
   "market_cap": "$3.05B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/acwx",
   "FIELD9": ""
 },
 {
   "symbol": "ACWI",
   "name": "iShares MSCI ACWI Index Fund",
   "last_sale": "74.68",
   "market_cap": "$8.99B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/acwi",
   "FIELD9": ""
 },
 {
   "symbol": "AAXJ",
   "name": "iShares MSCI All Country Asia ex Japan Index Fund",
   "last_sale": "71.23",
   "market_cap": "$4.02B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aaxj",
   "FIELD9": ""
 },
 {
   "symbol": "EWZS",
   "name": "iShares MSCI Brazil Small-Cap ETF",
   "last_sale": "12",
   "market_cap": "$49.2M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ewzs",
   "FIELD9": ""
 },
 {
   "symbol": "MCHI",
   "name": "iShares MSCI China ETF",
   "last_sale": "60.61",
   "market_cap": "$3.43B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mchi",
   "FIELD9": ""
 },
 {
   "symbol": "ESGD",
   "name": "iShares MSCI EAFE ESG Optimized ETF",
   "last_sale": "66.8673",
   "market_cap": "$367.77M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/esgd",
   "FIELD9": ""
 },
 {
   "symbol": "SCZ",
   "name": "iShares MSCI EAFE Small-Cap ETF",
   "last_sale": "63.09",
   "market_cap": "$10.44B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/scz",
   "FIELD9": ""
 },
 {
   "symbol": "ESGE",
   "name": "iShares MSCI EM ESG Optimized ETF",
   "last_sale": "33.54",
   "market_cap": "$345.46M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/esge",
   "FIELD9": ""
 },
 {
   "symbol": "EEMA",
   "name": "iShares MSCI Emerging Markets Asia ETF",
   "last_sale": "68.54",
   "market_cap": "$424.95M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eema",
   "FIELD9": ""
 },
 {
   "symbol": "EMXC",
   "name": "iShares MSCI Emerging Markets ex China ETF",
   "last_sale": "49.612",
   "market_cap": "$9.92M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/emxc",
   "FIELD9": ""
 },
 {
   "symbol": "EUFN",
   "name": "iShares MSCI Europe Financials Sector Index Fund",
   "last_sale": "20.99",
   "market_cap": "$1.28B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eufn",
   "FIELD9": ""
 },
 {
   "symbol": "IEUS",
   "name": "iShares MSCI Europe Small-Cap ETF",
   "last_sale": "56.88",
   "market_cap": "$233.21M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ieus",
   "FIELD9": ""
 },
 {
   "symbol": "RING",
   "name": "iShares MSCI Global Gold Miners ETF",
   "last_sale": "14.5",
   "market_cap": "$234.18M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ring",
   "FIELD9": ""
 },
 {
   "symbol": "MPCT",
   "name": "iShares MSCI Global Impact ETF",
   "last_sale": "58.95",
   "market_cap": "$38.32M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mpct",
   "FIELD9": ""
 },
 {
   "symbol": "ENZL",
   "name": "iShares MSCI New Zealand ETF",
   "last_sale": "49.365",
   "market_cap": "$177.71M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/enzl",
   "FIELD9": ""
 },
 {
   "symbol": "QAT",
   "name": "iShares MSCI Qatar ETF",
   "last_sale": "17.81",
   "market_cap": "$49.87M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qat",
   "FIELD9": ""
 },
 {
   "symbol": "TUR",
   "name": "iShares MSCI Turkey ETF",
   "last_sale": "22.415",
   "market_cap": "$422.52M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tur",
   "FIELD9": ""
 },
 {
   "symbol": "UAE",
   "name": "iShares MSCI UAE ETF",
   "last_sale": "15.3",
   "market_cap": "$33.66M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/uae",
   "FIELD9": ""
 },
 {
   "symbol": "ESGU",
   "name": "iShares MSCI USA ESG Optimized ETF",
   "last_sale": "64.53",
   "market_cap": "$100.02M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/esgu",
   "FIELD9": ""
 },
 {
   "symbol": "IBB",
   "name": "iShares Nasdaq Biotechnology Index Fund",
   "last_sale": "118.8",
   "market_cap": "$9.39B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ibb",
   "FIELD9": ""
 },
 {
   "symbol": "SOXX",
   "name": "iShares PHLX SOX Semiconductor Sector Index Fund",
   "last_sale": "188.19",
   "market_cap": "$1.59B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/soxx",
   "FIELD9": ""
 },
 {
   "symbol": "AMCA",
   "name": "iShares Russell 1000 Pure U.S. Revenue ETF",
   "last_sale": "28.97",
   "market_cap": "$10.14M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/amca",
   "FIELD9": ""
 },
 {
   "symbol": "EMIF",
   "name": "iShares S&P Emerging Markets Infrastructure Index Fund",
   "last_sale": "28.3273",
   "market_cap": "$32.58M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/emif",
   "FIELD9": ""
 },
 {
   "symbol": "ICLN",
   "name": "iShares S&P Global Clean Energy Index Fund",
   "last_sale": "8.74",
   "market_cap": "$168.68M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/icln",
   "FIELD9": ""
 },
 {
   "symbol": "WOOD",
   "name": "iShares S&P Global Timber & Forestry Index Fund",
   "last_sale": "76.9883",
   "market_cap": "$461.93M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wood",
   "FIELD9": ""
 },
 {
   "symbol": "INDY",
   "name": "iShares S&P India Nifty 50 Index Fund",
   "last_sale": "35.14",
   "market_cap": "$892.56M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/indy",
   "FIELD9": ""
 },
 {
   "symbol": "IJT",
   "name": "iShares S&P Small-Cap 600 Growth ETF",
   "last_sale": "204",
   "market_cap": "$7.17B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ijt",
   "FIELD9": ""
 },
 {
   "symbol": "DVY",
   "name": "iShares Select Dividend ETF",
   "last_sale": "102.23",
   "market_cap": "$17.64B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dvy",
   "FIELD9": ""
 },
 {
   "symbol": "SHV",
   "name": "iShares Short Treasury Bond ETF",
   "last_sale": "110.37",
   "market_cap": "$15.2B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/shv",
   "FIELD9": ""
 },
 {
   "symbol": "IGSB",
   "name": "iShares Short-Term Corporate Bond ETF",
   "last_sale": "51.78",
   "market_cap": "$10.25B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/igsb",
   "FIELD9": ""
 },
 {
   "symbol": "PFF",
   "name": "iShares U.S. Preferred Stock ETF",
   "last_sale": "37.16",
   "market_cap": "$16.65B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pff",
   "FIELD9": ""
 },
 {
   "symbol": "ISRL",
   "name": "Isramco, Inc.",
   "last_sale": "120",
   "market_cap": "$326.12M",
   "IPOyear": "1983",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/isrl",
   "FIELD9": ""
 },
 {
   "symbol": "ITI",
   "name": "Iteris, Inc.",
   "last_sale": "5.32",
   "market_cap": "$176.84M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/iti",
   "FIELD9": ""
 },
 {
   "symbol": "ITRM",
   "name": "Iterum Therapeutics plc",
   "last_sale": "7.5311",
   "market_cap": "$106.64M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/itrm",
   "FIELD9": ""
 },
 {
   "symbol": "ITRI",
   "name": "Itron, Inc.",
   "last_sale": "66",
   "market_cap": "$2.59B",
   "IPOyear": "1993",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/itri",
   "FIELD9": ""
 },
 {
   "symbol": "ITRN",
   "name": "Ituran Location and Control Ltd.",
   "last_sale": "33.6",
   "market_cap": "$788.77M",
   "IPOyear": "2005",
   "sector": "Consumer Non-Durables",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/itrn",
   "FIELD9": ""
 },
 {
   "symbol": "ITUS",
   "name": "ITUS Corporation",
   "last_sale": "4.89",
   "market_cap": "$91.42M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/itus",
   "FIELD9": ""
 },
 {
   "symbol": "IVENC",
   "name": "Ivy NextShares",
   "last_sale": "100.02",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ivenc",
   "FIELD9": ""
 },
 {
   "symbol": "IVFGC",
   "name": "Ivy NextShares",
   "last_sale": "100.02",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ivfgc",
   "FIELD9": ""
 },
 {
   "symbol": "IVFVC",
   "name": "Ivy NextShares",
   "last_sale": "100.02",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ivfvc",
   "FIELD9": ""
 },
 {
   "symbol": "IZEA",
   "name": "IZEA Worldwide, Inc.",
   "last_sale": "1.69",
   "market_cap": "$18.03M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/izea",
   "FIELD9": ""
 },
 {
   "symbol": "JJSF",
   "name": "J & J Snack Foods Corp.",
   "last_sale": "147.71",
   "market_cap": "$2.76B",
   "IPOyear": "1986",
   "sector": "Consumer Non-Durables",
   "industry": "Specialty Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/jjsf",
   "FIELD9": ""
 },
 {
   "symbol": "MAYS",
   "name": "J. W. Mays, Inc.",
   "last_sale": "39.55",
   "market_cap": "$79.72M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Building operators",
   "summary_quote": "https://www.nasdaq.com/symbol/mays",
   "FIELD9": ""
 },
 {
   "symbol": "JBHT",
   "name": "J.B. Hunt Transport Services, Inc.",
   "last_sale": "119",
   "market_cap": "$13.01B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/jbht",
   "FIELD9": ""
 },
 {
   "symbol": "JCOM",
   "name": "j2 Global, Inc.",
   "last_sale": "81.36",
   "market_cap": "$4.01B",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/jcom",
   "FIELD9": ""
 },
 {
   "symbol": "JKHY",
   "name": "Jack Henry & Associates, Inc.",
   "last_sale": "159.21",
   "market_cap": "$12.29B",
   "IPOyear": "1985",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/jkhy",
   "FIELD9": ""
 },
 {
   "symbol": "JACK",
   "name": "Jack In The Box Inc.",
   "last_sale": "84.13",
   "market_cap": "$2.29B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/jack",
   "FIELD9": ""
 },
 {
   "symbol": "JAGX",
   "name": "Jaguar Health, Inc.",
   "last_sale": "0.635",
   "market_cap": "$31.64M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/jagx",
   "FIELD9": ""
 },
 {
   "symbol": "JAKK",
   "name": "JAKKS Pacific, Inc.",
   "last_sale": "2.9",
   "market_cap": "$84.59M",
   "IPOyear": "1996",
   "sector": "Consumer Non-Durables",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/jakk",
   "FIELD9": ""
 },
 {
   "symbol": "JRVR",
   "name": "James River Group Holdings, Ltd.",
   "last_sale": "42.87",
   "market_cap": "$1.28B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/jrvr",
   "FIELD9": ""
 },
 {
   "symbol": "JSML",
   "name": "Janus Henderson Small Cap Growth Alpha ETF",
   "last_sale": "45.26",
   "market_cap": "$9.14M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jsml",
   "FIELD9": ""
 },
 {
   "symbol": "JSMD",
   "name": "Janus Henderson Small/Mid Cap Growth Alpha ETF",
   "last_sale": "46.49",
   "market_cap": "$16.36M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jsmd",
   "FIELD9": ""
 },
 {
   "symbol": "JASN",
   "name": "Jason Industries, Inc.",
   "last_sale": "3.14",
   "market_cap": "$86.02M",
   "IPOyear": "2013",
   "sector": "Consumer Durables",
   "industry": "Miscellaneous manufacturing industries",
   "summary_quote": "https://www.nasdaq.com/symbol/jasn",
   "FIELD9": ""
 },
 {
   "symbol": "JASNW",
   "name": "Jason Industries, Inc.",
   "last_sale": "0.0101",
   "market_cap": "n/a",
   "IPOyear": "2013",
   "sector": "Consumer Durables",
   "industry": "Miscellaneous manufacturing industries",
   "summary_quote": "https://www.nasdaq.com/symbol/jasnw",
   "FIELD9": ""
 },
 {
   "symbol": "JAZZ",
   "name": "Jazz Pharmaceuticals plc",
   "last_sale": "163.74",
   "market_cap": "$9.89B",
   "IPOyear": "2007",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/jazz",
   "FIELD9": ""
 },
 {
   "symbol": "JD",
   "name": "JD.com, Inc.",
   "last_sale": "26.49",
   "market_cap": "$38.31B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/jd",
   "FIELD9": ""
 },
 {
   "symbol": "JSYN",
   "name": "Jensyn Acquistion Corp.",
   "last_sale": "11.4",
   "market_cap": "$23.73M",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/jsyn",
   "FIELD9": ""
 },
 {
   "symbol": "JSYNR",
   "name": "Jensyn Acquistion Corp.",
   "last_sale": "0.37",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/jsynr",
   "FIELD9": ""
 },
 {
   "symbol": "JSYNU",
   "name": "Jensyn Acquistion Corp.",
   "last_sale": "12.25",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/jsynu",
   "FIELD9": ""
 },
 {
   "symbol": "JSYNW",
   "name": "Jensyn Acquistion Corp.",
   "last_sale": "0.136",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/jsynw",
   "FIELD9": ""
 },
 {
   "symbol": "JRSH",
   "name": "Jerash Holdings (US), Inc.",
   "last_sale": "5.25",
   "market_cap": "$59.46M",
   "IPOyear": "2018",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/jrsh",
   "FIELD9": ""
 },
 {
   "symbol": "JBLU",
   "name": "JetBlue Airways Corporation",
   "last_sale": "19.89",
   "market_cap": "$6.22B",
   "IPOyear": "2002",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/jblu",
   "FIELD9": ""
 },
 {
   "symbol": "JTPY",
   "name": "JetPay Corporation",
   "last_sale": "1.725",
   "market_cap": "$26.63M",
   "IPOyear": "2011",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/jtpy",
   "FIELD9": ""
 },
 {
   "symbol": "JCTCF",
   "name": "Jewett-Cameron Trading Company",
   "last_sale": "8.45",
   "market_cap": "$37.66M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/jctcf",
   "FIELD9": ""
 },
 {
   "symbol": "JMU",
   "name": "JMU Limited",
   "last_sale": "1.27",
   "market_cap": "$104.09M",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/jmu",
   "FIELD9": ""
 },
 {
   "symbol": "JBSS",
   "name": "John B. Sanfilippo & Son, Inc.",
   "last_sale": "71.67",
   "market_cap": "$813.1M",
   "IPOyear": "1991",
   "sector": "Consumer Non-Durables",
   "industry": "Specialty Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/jbss",
   "FIELD9": ""
 },
 {
   "symbol": "JOUT",
   "name": "Johnson Outdoors Inc.",
   "last_sale": "95.58",
   "market_cap": "$962.18M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/jout",
   "FIELD9": ""
 },
 {
   "symbol": "JNCE",
   "name": "Jounce Therapeutics, Inc.",
   "last_sale": "6.75",
   "market_cap": "$220.24M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/jnce",
   "FIELD9": ""
 },
 {
   "symbol": "KTWO",
   "name": "K2M Group Holdings, Inc.",
   "last_sale": "27.29",
   "market_cap": "$1.19B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/ktwo",
   "FIELD9": ""
 },
 {
   "symbol": "KALU",
   "name": "Kaiser Aluminum Corporation",
   "last_sale": "110.31",
   "market_cap": "$1.83B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/kalu",
   "FIELD9": ""
 },
 {
   "symbol": "KALA",
   "name": "Kala Pharmaceuticals, Inc.",
   "last_sale": "10.75",
   "market_cap": "$264.37M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/kala",
   "FIELD9": ""
 },
 {
   "symbol": "KALV",
   "name": "KalVista Pharmaceuticals, Inc.",
   "last_sale": "21.72",
   "market_cap": "$373.14M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/kalv",
   "FIELD9": ""
 },
 {
   "symbol": "KMDA",
   "name": "Kamada Ltd.",
   "last_sale": "6",
   "market_cap": "$241.61M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/kmda",
   "FIELD9": ""
 },
 {
   "symbol": "KNDI",
   "name": "Kandi Technologies Group, Inc.",
   "last_sale": "5.362",
   "market_cap": "$275.99M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/kndi",
   "FIELD9": ""
 },
 {
   "symbol": "KPTI",
   "name": "Karyopharm Therapeutics Inc.",
   "last_sale": "18.32",
   "market_cap": "$1.11B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/kpti",
   "FIELD9": ""
 },
 {
   "symbol": "KAAC",
   "name": "Kayne Anderson Acquisition Corp.",
   "last_sale": "10.15",
   "market_cap": "$111.74M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kaac",
   "FIELD9": ""
 },
 {
   "symbol": "KAACU",
   "name": "Kayne Anderson Acquisition Corp.",
   "last_sale": "10.6008",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kaacu",
   "FIELD9": ""
 },
 {
   "symbol": "KAACW",
   "name": "Kayne Anderson Acquisition Corp.",
   "last_sale": "1.4",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kaacw",
   "FIELD9": ""
 },
 {
   "symbol": "KZIA",
   "name": "Kazia Therapeutics Limited",
   "last_sale": "3.2565",
   "market_cap": "$15.76M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Miscellaneous",
   "summary_quote": "https://www.nasdaq.com/symbol/kzia",
   "FIELD9": ""
 },
 {
   "symbol": "KBLM",
   "name": "KBL Merger Corp. IV",
   "last_sale": "10.09",
   "market_cap": "$42.01M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kblm",
   "FIELD9": ""
 },
 {
   "symbol": "KBLMR",
   "name": "KBL Merger Corp. IV",
   "last_sale": "0.44",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kblmr",
   "FIELD9": ""
 },
 {
   "symbol": "KBLMU",
   "name": "KBL Merger Corp. IV",
   "last_sale": "11.5",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kblmu",
   "FIELD9": ""
 },
 {
   "symbol": "KBLMW",
   "name": "KBL Merger Corp. IV",
   "last_sale": "0.24",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kblmw",
   "FIELD9": ""
 },
 {
   "symbol": "KBSF",
   "name": "KBS Fashion Group Limited",
   "last_sale": "4.05",
   "market_cap": "$8.94M",
   "IPOyear": "2013",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/kbsf",
   "FIELD9": ""
 },
 {
   "symbol": "KCAP",
   "name": "KCAP Financial, Inc.",
   "last_sale": "3.3",
   "market_cap": "$123.28M",
   "IPOyear": "2006",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kcap",
   "FIELD9": ""
 },
 {
   "symbol": "KCAPL",
   "name": "KCAP Financial, Inc.",
   "last_sale": "25.08",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kcapl",
   "FIELD9": ""
 },
 {
   "symbol": "KRNY",
   "name": "Kearny Financial",
   "last_sale": "13.9",
   "market_cap": "$1.38B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/krny",
   "FIELD9": ""
 },
 {
   "symbol": "KELYA",
   "name": "Kelly Services, Inc.",
   "last_sale": "24.36",
   "market_cap": "$945.28M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kelya",
   "FIELD9": ""
 },
 {
   "symbol": "KELYB",
   "name": "Kelly Services, Inc.",
   "last_sale": "24",
   "market_cap": "$931.31M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kelyb",
   "FIELD9": ""
 },
 {
   "symbol": "KMPH",
   "name": "KemPharm, Inc.",
   "last_sale": "4.45",
   "market_cap": "$71.39M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/kmph",
   "FIELD9": ""
 },
 {
   "symbol": "KFFB",
   "name": "Kentucky First Federal Bancorp",
   "last_sale": "8.1",
   "market_cap": "$68.4M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/kffb",
   "FIELD9": ""
 },
 {
   "symbol": "KERX",
   "name": "Keryx Biopharmaceuticals, Inc.",
   "last_sale": "3.14",
   "market_cap": "$378.24M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/kerx",
   "FIELD9": ""
 },
 {
   "symbol": "KEQU",
   "name": "Kewaunee Scientific Corporation",
   "last_sale": "32",
   "market_cap": "$87.72M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/kequ",
   "FIELD9": ""
 },
 {
   "symbol": "KTCC",
   "name": "Key Tronic Corporation",
   "last_sale": "7.8",
   "market_cap": "$83.93M",
   "IPOyear": "1983",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ktcc",
   "FIELD9": ""
 },
 {
   "symbol": "KZR",
   "name": "Kezar Life Sciences, Inc.",
   "last_sale": "19.64",
   "market_cap": "$375.29M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/kzr",
   "FIELD9": ""
 },
 {
   "symbol": "KFRC",
   "name": "Kforce, Inc.",
   "last_sale": "38.3",
   "market_cap": "$1B",
   "IPOyear": "1995",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kfrc",
   "FIELD9": ""
 },
 {
   "symbol": "KE",
   "name": "Kimball Electronics, Inc.",
   "last_sale": "19.6",
   "market_cap": "$523.22M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/ke",
   "FIELD9": ""
 },
 {
   "symbol": "KBAL",
   "name": "Kimball International, Inc.",
   "last_sale": "17.77",
   "market_cap": "$660.37M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/kbal",
   "FIELD9": ""
 },
 {
   "symbol": "KIN",
   "name": "Kindred Biosciences, Inc.",
   "last_sale": "13.15",
   "market_cap": "$444.47M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/kin",
   "FIELD9": ""
 },
 {
   "symbol": "KGJI",
   "name": "Kingold Jewelry Inc.",
   "last_sale": "1.0327",
   "market_cap": "$68.28M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kgji",
   "FIELD9": ""
 },
 {
   "symbol": "KINS",
   "name": "Kingstone Companies, Inc",
   "last_sale": "19.35",
   "market_cap": "$206.34M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/kins",
   "FIELD9": ""
 },
 {
   "symbol": "KNSA",
   "name": "Kiniksa Pharmaceuticals, Ltd.",
   "last_sale": "29.77",
   "market_cap": "$1.47B",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/knsa",
   "FIELD9": ""
 },
 {
   "symbol": "KNSL",
   "name": "Kinsale Capital Group, Inc.",
   "last_sale": "63.12",
   "market_cap": "$1.34B",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/knsl",
   "FIELD9": ""
 },
 {
   "symbol": "KIRK",
   "name": "Kirkland&#39;s, Inc.",
   "last_sale": "9.36",
   "market_cap": "$146.61M",
   "IPOyear": "2002",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/kirk",
   "FIELD9": ""
 },
 {
   "symbol": "KTOV",
   "name": "Kitov Pharma Ltd.",
   "last_sale": "1.74",
   "market_cap": "$27.77M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ktov",
   "FIELD9": ""
 },
 {
   "symbol": "KTOVW",
   "name": "Kitov Pharma Ltd.",
   "last_sale": "0.55",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ktovw",
   "FIELD9": ""
 },
 {
   "symbol": "KLAC",
   "name": "KLA-Tencor Corporation",
   "last_sale": "104.52",
   "market_cap": "$16.32B",
   "IPOyear": "1980",
   "sector": "Capital Goods",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/klac",
   "FIELD9": ""
 },
 {
   "symbol": "KLXE",
   "name": "KLX Energy Services Holdings, Inc. ",
   "last_sale": "29.33",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/klxe",
   "FIELD9": ""
 },
 {
   "symbol": "KLXI",
   "name": "KLX Inc.",
   "last_sale": "62.75",
   "market_cap": "$3.18B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/klxi",
   "FIELD9": ""
 },
 {
   "symbol": "KONA",
   "name": "Kona Grill, Inc.",
   "last_sale": "2.4",
   "market_cap": "$31.82M",
   "IPOyear": "2005",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/kona",
   "FIELD9": ""
 },
 {
   "symbol": "KOPN",
   "name": "Kopin Corporation",
   "last_sale": "2.41",
   "market_cap": "$184.67M",
   "IPOyear": "1992",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/kopn",
   "FIELD9": ""
 },
 {
   "symbol": "KRNT",
   "name": "Kornit Digital Ltd.",
   "last_sale": "21.45",
   "market_cap": "$735.25M",
   "IPOyear": "2015",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/krnt",
   "FIELD9": ""
 },
 {
   "symbol": "KOSS",
   "name": "Koss Corporation",
   "last_sale": "2.65",
   "market_cap": "$19.56M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/koss",
   "FIELD9": ""
 },
 {
   "symbol": "KWEB",
   "name": "KraneShares Trust KraneShares CSI China Internet ETF",
   "last_sale": "49.71",
   "market_cap": "$169.01M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kweb",
   "FIELD9": ""
 },
 {
   "symbol": "KTOS",
   "name": "Kratos Defense & Security Solutions, Inc.",
   "last_sale": "14.09",
   "market_cap": "$1.46B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/ktos",
   "FIELD9": ""
 },
 {
   "symbol": "KRYS",
   "name": "Krystal Biotech, Inc.",
   "last_sale": "16.89",
   "market_cap": "$185.43M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/krys",
   "FIELD9": ""
 },
 {
   "symbol": "KLIC",
   "name": "Kulicke and Soffa Industries, Inc.",
   "last_sale": "25.31",
   "market_cap": "$1.71B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/klic",
   "FIELD9": ""
 },
 {
   "symbol": "KURA",
   "name": "Kura Oncology, Inc.",
   "last_sale": "17.1",
   "market_cap": "$649.38M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/kura",
   "FIELD9": ""
 },
 {
   "symbol": "KVHI",
   "name": "KVH Industries, Inc.",
   "last_sale": "12.2",
   "market_cap": "$215.51M",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/kvhi",
   "FIELD9": ""
 },
 {
   "symbol": "FSTR",
   "name": "L.B. Foster Company",
   "last_sale": "22.85",
   "market_cap": "$241.37M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/fstr",
   "FIELD9": ""
 },
 {
   "symbol": "LJPC",
   "name": "La Jolla Pharmaceutical Company",
   "last_sale": "21.44",
   "market_cap": "$562.29M",
   "IPOyear": "1994",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/ljpc",
   "FIELD9": ""
 },
 {
   "symbol": "LSBK",
   "name": "Lake Shore Bancorp, Inc.",
   "last_sale": "17.05",
   "market_cap": "$103.25M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/lsbk",
   "FIELD9": ""
 },
 {
   "symbol": "LBAI",
   "name": "Lakeland Bancorp, Inc.",
   "last_sale": "18.45",
   "market_cap": "$876.1M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/lbai",
   "FIELD9": ""
 },
 {
   "symbol": "LKFN",
   "name": "Lakeland Financial Corporation",
   "last_sale": "48.43",
   "market_cap": "$1.23B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/lkfn",
   "FIELD9": ""
 },
 {
   "symbol": "LAKE",
   "name": "Lakeland Industries, Inc.",
   "last_sale": "13.35",
   "market_cap": "$108.35M",
   "IPOyear": "1986",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/lake",
   "FIELD9": ""
 },
 {
   "symbol": "LRCX",
   "name": "Lam Research Corporation",
   "last_sale": "155.68",
   "market_cap": "$24.53B",
   "IPOyear": "1984",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/lrcx",
   "FIELD9": ""
 },
 {
   "symbol": "LAMR",
   "name": "Lamar Advertising Company",
   "last_sale": "76.89",
   "market_cap": "$7.6B",
   "IPOyear": "1996",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/lamr",
   "FIELD9": ""
 },
 {
   "symbol": "LANC",
   "name": "Lancaster Colony Corporation",
   "last_sale": "151.84",
   "market_cap": "$4.17B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/lanc",
   "FIELD9": ""
 },
 {
   "symbol": "LCA",
   "name": "Landcadia Holdings, Inc.",
   "last_sale": "10.25",
   "market_cap": "$78.06M",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lca",
   "FIELD9": ""
 },
 {
   "symbol": "LCAHU",
   "name": "Landcadia Holdings, Inc.",
   "last_sale": "11.16",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lcahu",
   "FIELD9": ""
 },
 {
   "symbol": "LCAHW",
   "name": "Landcadia Holdings, Inc.",
   "last_sale": "0.87",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lcahw",
   "FIELD9": ""
 },
 {
   "symbol": "LNDC",
   "name": "Landec Corporation",
   "last_sale": "13.3",
   "market_cap": "$369.07M",
   "IPOyear": "1996",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/lndc",
   "FIELD9": ""
 },
 {
   "symbol": "LARK",
   "name": "Landmark Bancorp Inc.",
   "last_sale": "28.95",
   "market_cap": "$120.51M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/lark",
   "FIELD9": ""
 },
 {
   "symbol": "LMRK",
   "name": "Landmark Infrastructure Partners LP",
   "last_sale": "13",
   "market_cap": "$326.7M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/lmrk",
   "FIELD9": ""
 },
 {
   "symbol": "LMRKN",
   "name": "Landmark Infrastructure Partners LP",
   "last_sale": "22.8839",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/lmrkn",
   "FIELD9": ""
 },
 {
   "symbol": "LMRKO",
   "name": "Landmark Infrastructure Partners LP",
   "last_sale": "24.569",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/lmrko",
   "FIELD9": ""
 },
 {
   "symbol": "LMRKP",
   "name": "Landmark Infrastructure Partners LP",
   "last_sale": "25.35",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/lmrkp",
   "FIELD9": ""
 },
 {
   "symbol": "LE",
   "name": "Lands&#39; End, Inc.",
   "last_sale": "18.05",
   "market_cap": "$581.43M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/le",
   "FIELD9": ""
 },
 {
   "symbol": "LSTR",
   "name": "Landstar System, Inc.",
   "last_sale": "121.25",
   "market_cap": "$4.98B",
   "IPOyear": "1993",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lstr",
   "FIELD9": ""
 },
 {
   "symbol": "LNTH",
   "name": "Lantheus Holdings, Inc.",
   "last_sale": "15.65",
   "market_cap": "$599.39M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/lnth",
   "FIELD9": ""
 },
 {
   "symbol": "LTRX",
   "name": "Lantronix, Inc.",
   "last_sale": "4.12",
   "market_cap": "$78.76M",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ltrx",
   "FIELD9": ""
 },
 {
   "symbol": "LSCC",
   "name": "Lattice Semiconductor Corporation",
   "last_sale": "7.71",
   "market_cap": "$977.31M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/lscc",
   "FIELD9": ""
 },
 {
   "symbol": "LAUR",
   "name": "Laureate Education, Inc.",
   "last_sale": "16",
   "market_cap": "$3.58B",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/laur",
   "FIELD9": ""
 },
 {
   "symbol": "LAWS",
   "name": "Lawson Products, Inc.",
   "last_sale": "31.15",
   "market_cap": "$277.82M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/laws",
   "FIELD9": ""
 },
 {
   "symbol": "LAZY",
   "name": "Lazydays Holdings, Inc.",
   "last_sale": "7.2",
   "market_cap": "$61M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/lazy",
   "FIELD9": ""
 },
 {
   "symbol": "LCNB",
   "name": "LCNB Corporation",
   "last_sale": "19",
   "market_cap": "$252.7M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/lcnb",
   "FIELD9": ""
 },
 {
   "symbol": "LPTX",
   "name": "LEAP THERAPEUTICS, INC.",
   "last_sale": "6.53",
   "market_cap": "$96M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/lptx",
   "FIELD9": ""
 },
 {
   "symbol": "LGCY",
   "name": "Legacy Reserves Inc.",
   "last_sale": "5.26",
   "market_cap": "$404.65M",
   "IPOyear": "2007",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/lgcy",
   "FIELD9": ""
 },
 {
   "symbol": "LTXB",
   "name": "LegacyTexas Financial Group, Inc.",
   "last_sale": "45.2",
   "market_cap": "$2.19B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/ltxb",
   "FIELD9": ""
 },
 {
   "symbol": "DDBI",
   "name": "Legg Mason Developed EX-US Diversified Core ETF",
   "last_sale": "29.85",
   "market_cap": "$11.94M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ddbi",
   "FIELD9": ""
 },
 {
   "symbol": "EDBI",
   "name": "Legg Mason Emerging Markets Diversified Core ETF",
   "last_sale": "29.7699",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/edbi",
   "FIELD9": ""
 },
 {
   "symbol": "INFR",
   "name": "Legg Mason Global Infrastructure ETF",
   "last_sale": "27.94",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/infr",
   "FIELD9": ""
 },
 {
   "symbol": "LVHD",
   "name": "Legg Mason Low Volatility High Dividend ETF",
   "last_sale": "31.4",
   "market_cap": "$637.42M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lvhd",
   "FIELD9": ""
 },
 {
   "symbol": "SQLV",
   "name": "Legg Mason Small-Cap Quality Value ETF",
   "last_sale": "30.4",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sqlv",
   "FIELD9": ""
 },
 {
   "symbol": "UDBI",
   "name": "Legg Mason US Diversified Core ETF",
   "last_sale": "33.76",
   "market_cap": "$3.51M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/udbi",
   "FIELD9": ""
 },
 {
   "symbol": "LACQ",
   "name": "Leisure Acquisition Corp.",
   "last_sale": "9.7",
   "market_cap": "$58.3M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lacq",
   "FIELD9": ""
 },
 {
   "symbol": "LACQU",
   "name": "Leisure Acquisition Corp.",
   "last_sale": "10.2",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lacqu",
   "FIELD9": ""
 },
 {
   "symbol": "LACQW",
   "name": "Leisure Acquisition Corp.",
   "last_sale": "1.0699",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lacqw",
   "FIELD9": ""
 },
 {
   "symbol": "LMAT",
   "name": "LeMaitre Vascular, Inc.",
   "last_sale": "34.55",
   "market_cap": "$672.41M",
   "IPOyear": "2006",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/lmat",
   "FIELD9": ""
 },
 {
   "symbol": "TREE",
   "name": "LendingTree, Inc.",
   "last_sale": "227.5",
   "market_cap": "$2.92B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tree",
   "FIELD9": ""
 },
 {
   "symbol": "LEVL",
   "name": "Level One Bancorp, Inc.",
   "last_sale": "28.09",
   "market_cap": "$217.67M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/levl",
   "FIELD9": ""
 },
 {
   "symbol": "LXRX",
   "name": "Lexicon Pharmaceuticals, Inc.",
   "last_sale": "10.49",
   "market_cap": "$1.11B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/lxrx",
   "FIELD9": ""
 },
 {
   "symbol": "LX",
   "name": "LexinFintech Holdings Ltd.",
   "last_sale": "10.36",
   "market_cap": "$1.7B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lx",
   "FIELD9": ""
 },
 {
   "symbol": "LFAC",
   "name": "LF Capital Acquistion Corp.",
   "last_sale": "9.59",
   "market_cap": "$46.57M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lfac",
   "FIELD9": ""
 },
 {
   "symbol": "LFACU",
   "name": "LF Capital Acquistion Corp.",
   "last_sale": "10.05",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lfacu",
   "FIELD9": ""
 },
 {
   "symbol": "LFACW",
   "name": "LF Capital Acquistion Corp.",
   "last_sale": "0.55",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lfacw",
   "FIELD9": ""
 },
 {
   "symbol": "LGIH",
   "name": "LGI Homes, Inc.",
   "last_sale": "50.43",
   "market_cap": "$1.14B",
   "IPOyear": "2013",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/lgih",
   "FIELD9": ""
 },
 {
   "symbol": "LHCG",
   "name": "LHC Group",
   "last_sale": "98.5",
   "market_cap": "$3.09B",
   "IPOyear": "2005",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lhcg",
   "FIELD9": ""
 },
 {
   "symbol": "LLIT",
   "name": "Lianluo Smart Limited",
   "last_sale": "1.7457",
   "market_cap": "$30.74M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/llit",
   "FIELD9": ""
 },
 {
   "symbol": "LBRDA",
   "name": "Liberty Broadband Corporation",
   "last_sale": "84.81",
   "market_cap": "$15.38B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lbrda",
   "FIELD9": ""
 },
 {
   "symbol": "LBRDK",
   "name": "Liberty Broadband Corporation",
   "last_sale": "85.01",
   "market_cap": "$15.42B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lbrdk",
   "FIELD9": ""
 },
 {
   "symbol": "LEXEA",
   "name": "Liberty Expedia Holdings, Inc.",
   "last_sale": "47.67",
   "market_cap": "$2.73B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lexea",
   "FIELD9": ""
 },
 {
   "symbol": "LEXEB",
   "name": "Liberty Expedia Holdings, Inc.",
   "last_sale": "48.05",
   "market_cap": "$2.75B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lexeb",
   "FIELD9": ""
 },
 {
   "symbol": "LBTYA",
   "name": "Liberty Global plc",
   "last_sale": "29.25",
   "market_cap": "$22.52B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lbtya",
   "FIELD9": ""
 },
 {
   "symbol": "LBTYB",
   "name": "Liberty Global plc",
   "last_sale": "29.1",
   "market_cap": "$22.4B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lbtyb",
   "FIELD9": ""
 },
 {
   "symbol": "LBTYK",
   "name": "Liberty Global plc",
   "last_sale": "28.25",
   "market_cap": "$21.75B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lbtyk",
   "FIELD9": ""
 },
 {
   "symbol": "LILA",
   "name": "Liberty Latin America Ltd.",
   "last_sale": "21.75",
   "market_cap": "$3.73B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lila",
   "FIELD9": ""
 },
 {
   "symbol": "LILAK",
   "name": "Liberty Latin America Ltd.",
   "last_sale": "21.55",
   "market_cap": "$3.69B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lilak",
   "FIELD9": ""
 },
 {
   "symbol": "BATRA",
   "name": "Liberty Media Corporation",
   "last_sale": "26.19",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/batra",
   "FIELD9": ""
 },
 {
   "symbol": "BATRK",
   "name": "Liberty Media Corporation",
   "last_sale": "26.36",
   "market_cap": "$1.34B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/batrk",
   "FIELD9": ""
 },
 {
   "symbol": "FWONA",
   "name": "Liberty Media Corporation",
   "last_sale": "35.57",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/fwona",
   "FIELD9": ""
 },
 {
   "symbol": "FWONK",
   "name": "Liberty Media Corporation",
   "last_sale": "37.4",
   "market_cap": "$8.64B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/fwonk",
   "FIELD9": ""
 },
 {
   "symbol": "LSXMA",
   "name": "Liberty Media Corporation",
   "last_sale": "46.09",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/lsxma",
   "FIELD9": ""
 },
 {
   "symbol": "LSXMB",
   "name": "Liberty Media Corporation",
   "last_sale": "47.1044",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/lsxmb",
   "FIELD9": ""
 },
 {
   "symbol": "LSXMK",
   "name": "Liberty Media Corporation",
   "last_sale": "46.42",
   "market_cap": "$15.34B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/lsxmk",
   "FIELD9": ""
 },
 {
   "symbol": "LTRPA",
   "name": "Liberty TripAdvisor Holdings, Inc.",
   "last_sale": "14.55",
   "market_cap": "$1.09B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ltrpa",
   "FIELD9": ""
 },
 {
   "symbol": "LTRPB",
   "name": "Liberty TripAdvisor Holdings, Inc.",
   "last_sale": "14.4",
   "market_cap": "$1.08B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ltrpb",
   "FIELD9": ""
 },
 {
   "symbol": "LPNT",
   "name": "LifePoint Health, Inc.",
   "last_sale": "64.55",
   "market_cap": "$2.5B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/lpnt",
   "FIELD9": ""
 },
 {
   "symbol": "LCUT",
   "name": "Lifetime Brands, Inc.",
   "last_sale": "11.15",
   "market_cap": "$231.26M",
   "IPOyear": "1991",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/lcut",
   "FIELD9": ""
 },
 {
   "symbol": "LFVN",
   "name": "Lifevantage Corporation",
   "last_sale": "11.83",
   "market_cap": "$166.67M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/lfvn",
   "FIELD9": ""
 },
 {
   "symbol": "LWAY",
   "name": "Lifeway Foods, Inc.",
   "last_sale": "3.11",
   "market_cap": "$49.38M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/lway",
   "FIELD9": ""
 },
 {
   "symbol": "LGND",
   "name": "Ligand Pharmaceuticals Incorporated",
   "last_sale": "259.84",
   "market_cap": "$5.48B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/lgnd",
   "FIELD9": ""
 },
 {
   "symbol": "LTBR",
   "name": "Lightbridge Corporation",
   "last_sale": "0.9901",
   "market_cap": "$29.18M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ltbr",
   "FIELD9": ""
 },
 {
   "symbol": "LPTH",
   "name": "LightPath Technologies, Inc.",
   "last_sale": "2.05",
   "market_cap": "$52.84M",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/lpth",
   "FIELD9": ""
 },
 {
   "symbol": "LLEX",
   "name": "Lilis Energy, Inc.",
   "last_sale": "5.09",
   "market_cap": "$327.02M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/llex",
   "FIELD9": ""
 },
 {
   "symbol": "LMB",
   "name": "Limbach Holdings, Inc.",
   "last_sale": "10.77",
   "market_cap": "$81.75M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Engineering & Construction",
   "summary_quote": "https://www.nasdaq.com/symbol/lmb",
   "FIELD9": ""
 },
 {
   "symbol": "LLNW",
   "name": "Limelight Networks, Inc.",
   "last_sale": "5.07",
   "market_cap": "$571.1M",
   "IPOyear": "2007",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/llnw",
   "FIELD9": ""
 },
 {
   "symbol": "LMST",
   "name": "Limestone Bancorp, Inc.",
   "last_sale": "15.31",
   "market_cap": "$114.14M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/lmst",
   "FIELD9": ""
 },
 {
   "symbol": "LMNR",
   "name": "Limoneira Co",
   "last_sale": "27.56",
   "market_cap": "$486.97M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/lmnr",
   "FIELD9": ""
 },
 {
   "symbol": "LINC",
   "name": "Lincoln Educational Services Corporation",
   "last_sale": "2.33",
   "market_cap": "$57.42M",
   "IPOyear": "2005",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/linc",
   "FIELD9": ""
 },
 {
   "symbol": "LECO",
   "name": "Lincoln Electric Holdings, Inc.",
   "last_sale": "97.63",
   "market_cap": "$6.36B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/leco",
   "FIELD9": ""
 },
 {
   "symbol": "LIND",
   "name": "Lindblad Expeditions Holdings Inc. ",
   "last_sale": "14.87",
   "market_cap": "$680.85M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lind",
   "FIELD9": ""
 },
 {
   "symbol": "LINDW",
   "name": "Lindblad Expeditions Holdings Inc. ",
   "last_sale": "3.9",
   "market_cap": "n/a",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lindw",
   "FIELD9": ""
 },
 {
   "symbol": "LPCN",
   "name": "Lipocine Inc.",
   "last_sale": "1.54",
   "market_cap": "$32.75M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/lpcn",
   "FIELD9": ""
 },
 {
   "symbol": "YVR",
   "name": "Liquid Media Group Ltd.",
   "last_sale": "0.814",
   "market_cap": "$7.53M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/yvr",
   "FIELD9": ""
 },
 {
   "symbol": "LQDA",
   "name": "Liquidia Technologies, Inc.",
   "last_sale": "20.3",
   "market_cap": "$313.27M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/lqda",
   "FIELD9": ""
 },
 {
   "symbol": "LQDT",
   "name": "Liquidity Services, Inc.",
   "last_sale": "6.2",
   "market_cap": "$199.16M",
   "IPOyear": "2006",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lqdt",
   "FIELD9": ""
 },
 {
   "symbol": "LFUS",
   "name": "Littelfuse, Inc.",
   "last_sale": "208.75",
   "market_cap": "$5.24B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/lfus",
   "FIELD9": ""
 },
 {
   "symbol": "LIVN",
   "name": "LivaNova PLC",
   "last_sale": "122.32",
   "market_cap": "$5.94B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/livn",
   "FIELD9": ""
 },
 {
   "symbol": "LOB",
   "name": "Live Oak Bancshares, Inc.",
   "last_sale": "28.75",
   "market_cap": "$1.15B",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/lob",
   "FIELD9": ""
 },
 {
   "symbol": "LIVE",
   "name": "Live Ventures Incorporated",
   "last_sale": "9.6224",
   "market_cap": "$18.86M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance/Investors Services",
   "summary_quote": "https://www.nasdaq.com/symbol/live",
   "FIELD9": ""
 },
 {
   "symbol": "LPSN",
   "name": "LivePerson, Inc.",
   "last_sale": "25.7",
   "market_cap": "$1.6B",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/lpsn",
   "FIELD9": ""
 },
 {
   "symbol": "LIVX",
   "name": "LiveXLive Media, Inc.",
   "last_sale": "3.87",
   "market_cap": "$200.86M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/livx",
   "FIELD9": ""
 },
 {
   "symbol": "LKQ",
   "name": "LKQ Corporation",
   "last_sale": "32.39",
   "market_cap": "$10.3B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Motor Vehicles",
   "summary_quote": "https://www.nasdaq.com/symbol/lkq",
   "FIELD9": ""
 },
 {
   "symbol": "LMFA",
   "name": "LM Funding America, Inc.",
   "last_sale": "0.5",
   "market_cap": "$3.15M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lmfa",
   "FIELD9": ""
 },
 {
   "symbol": "LMFAW",
   "name": "LM Funding America, Inc.",
   "last_sale": "0.0211",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lmfaw",
   "FIELD9": ""
 },
 {
   "symbol": "LOGI",
   "name": "Logitech International S.A.",
   "last_sale": "45.69",
   "market_cap": "$7.56B",
   "IPOyear": "1997",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/logi",
   "FIELD9": ""
 },
 {
   "symbol": "LOGM",
   "name": "LogMein, Inc.",
   "last_sale": "87.45",
   "market_cap": "$4.54B",
   "IPOyear": "2009",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/logm",
   "FIELD9": ""
 },
 {
   "symbol": "CNCR",
   "name": "Loncar Cancer Immunotherapy ETF",
   "last_sale": "24.77",
   "market_cap": "$56.97M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cncr",
   "FIELD9": ""
 },
 {
   "symbol": "CHNA",
   "name": "Loncar China BioPharma ETF",
   "last_sale": "23.3796",
   "market_cap": "$2.34M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/chna",
   "FIELD9": ""
 },
 {
   "symbol": "LONE",
   "name": "Lonestar Resources US Inc.",
   "last_sale": "7.84",
   "market_cap": "$193.16M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/lone",
   "FIELD9": ""
 },
 {
   "symbol": "LOACU",
   "name": "Longevity Acquisition Corporation",
   "last_sale": "10.2",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/loacu",
   "FIELD9": ""
 },
 {
   "symbol": "LOOP",
   "name": "Loop Industries, Inc.",
   "last_sale": "9.73",
   "market_cap": "$328.93M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/loop",
   "FIELD9": ""
 },
 {
   "symbol": "LORL",
   "name": "Loral Space and Communications, Inc.",
   "last_sale": "44.15",
   "market_cap": "$1.37B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/lorl",
   "FIELD9": ""
 },
 {
   "symbol": "LOXO",
   "name": "Loxo Oncology, Inc.",
   "last_sale": "159.27",
   "market_cap": "$4.85B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/loxo",
   "FIELD9": ""
 },
 {
   "symbol": "LPLA",
   "name": "LPL Financial Holdings Inc.",
   "last_sale": "65.67",
   "market_cap": "$5.79B",
   "IPOyear": "2010",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/lpla",
   "FIELD9": ""
 },
 {
   "symbol": "LRAD",
   "name": "LRAD Corporation",
   "last_sale": "3.05",
   "market_cap": "$100.46M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/lrad",
   "FIELD9": ""
 },
 {
   "symbol": "LYTS",
   "name": "LSI Industries Inc.",
   "last_sale": "4.75",
   "market_cap": "$121.8M",
   "IPOyear": "1985",
   "sector": "Consumer Durables",
   "industry": "Building Products",
   "summary_quote": "https://www.nasdaq.com/symbol/lyts",
   "FIELD9": ""
 },
 {
   "symbol": "LULU",
   "name": "lululemon athletica inc.",
   "last_sale": "156.99",
   "market_cap": "$20.78B",
   "IPOyear": "2007",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/lulu",
   "FIELD9": ""
 },
 {
   "symbol": "LITE",
   "name": "Lumentum Holdings Inc.",
   "last_sale": "61.5",
   "market_cap": "$3.89B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/lite",
   "FIELD9": ""
 },
 {
   "symbol": "LMNX",
   "name": "Luminex Corporation",
   "last_sale": "29.35",
   "market_cap": "$1.31B",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/lmnx",
   "FIELD9": ""
 },
 {
   "symbol": "LUNA",
   "name": "Luna Innovations Incorporated",
   "last_sale": "3.22",
   "market_cap": "$89.94M",
   "IPOyear": "2006",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/luna",
   "FIELD9": ""
 },
 {
   "symbol": "LBC",
   "name": "Luther Burbank Corporation",
   "last_sale": "11.24",
   "market_cap": "$635.61M",
   "IPOyear": "2003",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/lbc",
   "FIELD9": ""
 },
 {
   "symbol": "MBTF",
   "name": "M B T Financial Corp",
   "last_sale": "11.3",
   "market_cap": "$259.72M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mbtf",
   "FIELD9": ""
 },
 {
   "symbol": "MCBC",
   "name": "Macatawa Bank Corporation",
   "last_sale": "12.09",
   "market_cap": "$411.23M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mcbc",
   "FIELD9": ""
 },
 {
   "symbol": "MFNC",
   "name": "Mackinac Financial Corporation",
   "last_sale": "16.34",
   "market_cap": "$175.05M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mfnc",
   "FIELD9": ""
 },
 {
   "symbol": "MTSI",
   "name": "MACOM Technology Solutions Holdings, Inc.",
   "last_sale": "21.41",
   "market_cap": "$1.4B",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/mtsi",
   "FIELD9": ""
 },
 {
   "symbol": "MGNX",
   "name": "MacroGenics, Inc.",
   "last_sale": "22.19",
   "market_cap": "$937.25M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mgnx",
   "FIELD9": ""
 },
 {
   "symbol": "MDGL",
   "name": "Madrigal Pharmaceuticals, Inc.",
   "last_sale": "211.69",
   "market_cap": "$3.25B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mdgl",
   "FIELD9": ""
 },
 {
   "symbol": "MAGS",
   "name": "Magal Security Systems Ltd.",
   "last_sale": "5.58",
   "market_cap": "$128.58M",
   "IPOyear": "1993",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/mags",
   "FIELD9": ""
 },
 {
   "symbol": "MGLN",
   "name": "Magellan Health, Inc.",
   "last_sale": "73.5",
   "market_cap": "$1.8B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/mgln",
   "FIELD9": ""
 },
 {
   "symbol": "MGTA",
   "name": "Magenta Therapeutics, Inc.",
   "last_sale": "11.69",
   "market_cap": "$385.12M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mgta",
   "FIELD9": ""
 },
 {
   "symbol": "MGIC",
   "name": "Magic Software Enterprises Ltd.",
   "last_sale": "9.05",
   "market_cap": "$441.26M",
   "IPOyear": "1991",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mgic",
   "FIELD9": ""
 },
 {
   "symbol": "CALL",
   "name": "magicJack VocalTec Ltd",
   "last_sale": "8.5",
   "market_cap": "$137.75M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/call",
   "FIELD9": ""
 },
 {
   "symbol": "MNGA",
   "name": "MagneGas Corporation",
   "last_sale": "0.1429",
   "market_cap": "$5.71M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/mnga",
   "FIELD9": ""
 },
 {
   "symbol": "MGYR",
   "name": "Magyar Bancorp, Inc.",
   "last_sale": "12.2",
   "market_cap": "$71.01M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/mgyr",
   "FIELD9": ""
 },
 {
   "symbol": "MHLD",
   "name": "Maiden Holdings, Ltd.",
   "last_sale": "2.9",
   "market_cap": "$241.12M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/mhld",
   "FIELD9": ""
 },
 {
   "symbol": "MMYT",
   "name": "MakeMyTrip Limited",
   "last_sale": "28.2",
   "market_cap": "$2.88B",
   "IPOyear": "2010",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mmyt",
   "FIELD9": ""
 },
 {
   "symbol": "MBUU",
   "name": "Malibu Boats, Inc.",
   "last_sale": "53.04",
   "market_cap": "$1.09B",
   "IPOyear": "2014",
   "sector": "Capital Goods",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/mbuu",
   "FIELD9": ""
 },
 {
   "symbol": "MLVF",
   "name": "Malvern Bancorp, Inc.",
   "last_sale": "25.3",
   "market_cap": "$166.35M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/mlvf",
   "FIELD9": ""
 },
 {
   "symbol": "MAMS",
   "name": "MAM Software Group, Inc.",
   "last_sale": "7.51",
   "market_cap": "$94.57M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mams",
   "FIELD9": ""
 },
 {
   "symbol": "TUSK",
   "name": "Mammoth Energy Services, Inc.",
   "last_sale": "29.18",
   "market_cap": "$1.31B",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tusk",
   "FIELD9": ""
 },
 {
   "symbol": "RPIBC",
   "name": "Managed Portfolio Series",
   "last_sale": "100.03",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rpibc",
   "FIELD9": ""
 },
 {
   "symbol": "MANH",
   "name": "Manhattan Associates, Inc.",
   "last_sale": "57.43",
   "market_cap": "$3.78B",
   "IPOyear": "1998",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/manh",
   "FIELD9": ""
 },
 {
   "symbol": "LOAN",
   "name": "Manhattan Bridge Capital, Inc",
   "last_sale": "6.455",
   "market_cap": "$61.62M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/loan",
   "FIELD9": ""
 },
 {
   "symbol": "MNTX",
   "name": "Manitex International, Inc.",
   "last_sale": "10.44",
   "market_cap": "$204.69M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/mntx",
   "FIELD9": ""
 },
 {
   "symbol": "MTEX",
   "name": "Mannatech, Incorporated",
   "last_sale": "20.2",
   "market_cap": "$48.53M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/mtex",
   "FIELD9": ""
 },
 {
   "symbol": "MNKD",
   "name": "MannKind Corporation",
   "last_sale": "1.71",
   "market_cap": "$261.61M",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mnkd",
   "FIELD9": ""
 },
 {
   "symbol": "MANT",
   "name": "ManTech International Corporation",
   "last_sale": "62.36",
   "market_cap": "$2.47B",
   "IPOyear": "2002",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mant",
   "FIELD9": ""
 },
 {
   "symbol": "MAPI",
   "name": "Mapi - Pharma Ltd.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mapi",
   "FIELD9": ""
 },
 {
   "symbol": "MARA",
   "name": "Marathon Patent Group, Inc.",
   "last_sale": "0.8482",
   "market_cap": "$20.41M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Multi-Sector Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/mara",
   "FIELD9": ""
 },
 {
   "symbol": "MCHX",
   "name": "Marchex, Inc.",
   "last_sale": "2.95",
   "market_cap": "$123.26M",
   "IPOyear": "2004",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mchx",
   "FIELD9": ""
 },
 {
   "symbol": "MRIN",
   "name": "Marin Software Incorporated",
   "last_sale": "3.3",
   "market_cap": "$19.09M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mrin",
   "FIELD9": ""
 },
 {
   "symbol": "MARPS",
   "name": "Marine Petroleum Trust",
   "last_sale": "3.735",
   "market_cap": "$7.47M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/marps",
   "FIELD9": ""
 },
 {
   "symbol": "MRNS",
   "name": "Marinus Pharmaceuticals, Inc.",
   "last_sale": "8.78",
   "market_cap": "$355.81M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mrns",
   "FIELD9": ""
 },
 {
   "symbol": "MKTX",
   "name": "MarketAxess Holdings, Inc.",
   "last_sale": "181.845",
   "market_cap": "$6.83B",
   "IPOyear": "2004",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/mktx",
   "FIELD9": ""
 },
 {
   "symbol": "MRLN",
   "name": "Marlin Business Services Corp.",
   "last_sale": "28.45",
   "market_cap": "$353.89M",
   "IPOyear": "2003",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mrln",
   "FIELD9": ""
 },
 {
   "symbol": "MAR",
   "name": "Marriott International",
   "last_sale": "130.89",
   "market_cap": "$45.42B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/mar",
   "FIELD9": ""
 },
 {
   "symbol": "MBII",
   "name": "Marrone Bio Innovations, Inc.",
   "last_sale": "1.89",
   "market_cap": "$209.01M",
   "IPOyear": "2013",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/mbii",
   "FIELD9": ""
 },
 {
   "symbol": "MRTN",
   "name": "Marten Transport, Ltd.",
   "last_sale": "21.1",
   "market_cap": "$1.15B",
   "IPOyear": "1986",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mrtn",
   "FIELD9": ""
 },
 {
   "symbol": "MMLP",
   "name": "Martin Midstream Partners L.P.",
   "last_sale": "11.05",
   "market_cap": "$431.53M",
   "IPOyear": "2002",
   "sector": "Energy",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/mmlp",
   "FIELD9": ""
 },
 {
   "symbol": "MRVL",
   "name": "Marvell Technology Group Ltd.",
   "last_sale": "18.84",
   "market_cap": "$12.4B",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/mrvl",
   "FIELD9": ""
 },
 {
   "symbol": "MASI",
   "name": "Masimo Corporation",
   "last_sale": "122.5",
   "market_cap": "$6.39B",
   "IPOyear": "2007",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/masi",
   "FIELD9": ""
 },
 {
   "symbol": "MTCH",
   "name": "Match Group, Inc.",
   "last_sale": "55.38",
   "market_cap": "$15.33B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/mtch",
   "FIELD9": ""
 },
 {
   "symbol": "MTLS",
   "name": "Materialise NV",
   "last_sale": "14.1",
   "market_cap": "$667.29M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mtls",
   "FIELD9": ""
 },
 {
   "symbol": "MPAC",
   "name": "Matlin & Partners Acquisition Corporation",
   "last_sale": "10.05",
   "market_cap": "$93.68M",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/mpac",
   "FIELD9": ""
 },
 {
   "symbol": "MPACU",
   "name": "Matlin & Partners Acquisition Corporation",
   "last_sale": "10.75",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/mpacu",
   "FIELD9": ""
 },
 {
   "symbol": "MPACW",
   "name": "Matlin & Partners Acquisition Corporation",
   "last_sale": "0.79",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/mpacw",
   "FIELD9": ""
 },
 {
   "symbol": "MTRX",
   "name": "Matrix Service Company",
   "last_sale": "24.75",
   "market_cap": "$668.48M",
   "IPOyear": "1990",
   "sector": "Basic Industries",
   "industry": "Engineering & Construction",
   "summary_quote": "https://www.nasdaq.com/symbol/mtrx",
   "FIELD9": ""
 },
 {
   "symbol": "MAT",
   "name": "Mattel, Inc.",
   "last_sale": "16.53",
   "market_cap": "$5.69B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/mat",
   "FIELD9": ""
 },
 {
   "symbol": "MATW",
   "name": "Matthews International Corporation",
   "last_sale": "51.35",
   "market_cap": "$1.65B",
   "IPOyear": "1994",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/matw",
   "FIELD9": ""
 },
 {
   "symbol": "MXIM",
   "name": "Maxim Integrated Products, Inc.",
   "last_sale": "59.52",
   "market_cap": "$16.55B",
   "IPOyear": "1988",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/mxim",
   "FIELD9": ""
 },
 {
   "symbol": "MXWL",
   "name": "Maxwell Technologies, Inc.",
   "last_sale": "3.56",
   "market_cap": "$135.83M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/mxwl",
   "FIELD9": ""
 },
 {
   "symbol": "MZOR",
   "name": "Mazor Robotics Ltd.",
   "last_sale": "58.18",
   "market_cap": "$1.54B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/mzor",
   "FIELD9": ""
 },
 {
   "symbol": "MBFI",
   "name": "MB Financial Inc.",
   "last_sale": "48.1",
   "market_cap": "$4.05B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mbfi",
   "FIELD9": ""
 },
 {
   "symbol": "MBFIO",
   "name": "MB Financial Inc.",
   "last_sale": "25.1271",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mbfio",
   "FIELD9": ""
 },
 {
   "symbol": "MCFT",
   "name": "MCBC Holdings, Inc.",
   "last_sale": "36.9",
   "market_cap": "$691M",
   "IPOyear": "2015",
   "sector": "Capital Goods",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/mcft",
   "FIELD9": ""
 },
 {
   "symbol": "MGRC",
   "name": "McGrath RentCorp",
   "last_sale": "54.85",
   "market_cap": "$1.33B",
   "IPOyear": "1984",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mgrc",
   "FIELD9": ""
 },
 {
   "symbol": "MDCA",
   "name": "MDC Partners Inc.",
   "last_sale": "4.65",
   "market_cap": "$232.2M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/mdca",
   "FIELD9": ""
 },
 {
   "symbol": "MFIN",
   "name": "Medallion Financial Corp.",
   "last_sale": "6.7",
   "market_cap": "$163.74M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mfin",
   "FIELD9": ""
 },
 {
   "symbol": "MFINL",
   "name": "Medallion Financial Corp.",
   "last_sale": "25.98",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mfinl",
   "FIELD9": ""
 },
 {
   "symbol": "MTBC",
   "name": "Medical Transcription Billing, Corp.",
   "last_sale": "4.69",
   "market_cap": "$55.56M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mtbc",
   "FIELD9": ""
 },
 {
   "symbol": "MTBCP",
   "name": "Medical Transcription Billing, Corp.",
   "last_sale": "27.5",
   "market_cap": "$25.56M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mtbcp",
   "FIELD9": ""
 },
 {
   "symbol": "MNOV",
   "name": "MediciNova, Inc.",
   "last_sale": "11.96",
   "market_cap": "$500.87M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mnov",
   "FIELD9": ""
 },
 {
   "symbol": "MDSO",
   "name": "Medidata Solutions, Inc.",
   "last_sale": "74.07",
   "market_cap": "$4.52B",
   "IPOyear": "2009",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mdso",
   "FIELD9": ""
 },
 {
   "symbol": "MDGS",
   "name": "Medigus Ltd.",
   "last_sale": "3.15",
   "market_cap": "$11.96M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/mdgs",
   "FIELD9": ""
 },
 {
   "symbol": "MDGSW",
   "name": "Medigus Ltd.",
   "last_sale": "0.52",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/mdgsw",
   "FIELD9": ""
 },
 {
   "symbol": "MDWD",
   "name": "MediWound Ltd.",
   "last_sale": "6.35",
   "market_cap": "$172.59M",
   "IPOyear": "2014",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/mdwd",
   "FIELD9": ""
 },
 {
   "symbol": "MEDP",
   "name": "Medpace Holdings, Inc.",
   "last_sale": "57.9",
   "market_cap": "$2.06B",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/medp",
   "FIELD9": ""
 },
 {
   "symbol": "MEIP",
   "name": "MEI Pharma, Inc.",
   "last_sale": "4.42",
   "market_cap": "$314.2M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/meip",
   "FIELD9": ""
 },
 {
   "symbol": "MGTX",
   "name": "MeiraGTx Holdings plc",
   "last_sale": "12.95",
   "market_cap": "$352.03M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/mgtx",
   "FIELD9": ""
 },
 {
   "symbol": "MLCO",
   "name": "Melco Resorts & Entertainment Limited",
   "last_sale": "22.06",
   "market_cap": "$10.81B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/mlco",
   "FIELD9": ""
 },
 {
   "symbol": "MLNT",
   "name": "Melinta Therapeutics, Inc.",
   "last_sale": "4.45",
   "market_cap": "$249.25M",
   "IPOyear": "2012",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mlnt",
   "FIELD9": ""
 },
 {
   "symbol": "MLNX",
   "name": "Mellanox Technologies, Ltd.",
   "last_sale": "76.85",
   "market_cap": "$4.07B",
   "IPOyear": "2007",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/mlnx",
   "FIELD9": ""
 },
 {
   "symbol": "MELR",
   "name": "Melrose Bancorp, Inc.",
   "last_sale": "20",
   "market_cap": "$51.97M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/melr",
   "FIELD9": ""
 },
 {
   "symbol": "MNLO",
   "name": "Menlo Therapeutics Inc.",
   "last_sale": "11.41",
   "market_cap": "$262.18M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mnlo",
   "FIELD9": ""
 },
 {
   "symbol": "MTSL",
   "name": "MER Telemanagement Solutions Ltd.",
   "last_sale": "1.5203",
   "market_cap": "$5.01M",
   "IPOyear": "1997",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/mtsl",
   "FIELD9": ""
 },
 {
   "symbol": "MELI",
   "name": "MercadoLibre, Inc.",
   "last_sale": "319.68",
   "market_cap": "$14.44B",
   "IPOyear": "2007",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/meli",
   "FIELD9": ""
 },
 {
   "symbol": "MBNAA",
   "name": "Mercantil Bank Holding Corporation",
   "last_sale": "13",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mbnaa",
   "FIELD9": ""
 },
 {
   "symbol": "MBNAB",
   "name": "Mercantil Bank Holding Corporation",
   "last_sale": "8.45",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mbnab",
   "FIELD9": ""
 },
 {
   "symbol": "MBWM",
   "name": "Mercantile Bank Corporation",
   "last_sale": "34.63",
   "market_cap": "$575.22M",
   "IPOyear": "1998",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mbwm",
   "FIELD9": ""
 },
 {
   "symbol": "MERC",
   "name": "Mercer International Inc.",
   "last_sale": "17.15",
   "market_cap": "$1.12B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/merc",
   "FIELD9": ""
 },
 {
   "symbol": "MBIN",
   "name": "Merchants Bancorp",
   "last_sale": "26.92",
   "market_cap": "$772.44M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mbin",
   "FIELD9": ""
 },
 {
   "symbol": "MRCY",
   "name": "Mercury Systems Inc",
   "last_sale": "52.93",
   "market_cap": "$2.56B",
   "IPOyear": "1998",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/mrcy",
   "FIELD9": ""
 },
 {
   "symbol": "MREO",
   "name": "Mereo BioPharma Group plc",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mreo",
   "FIELD9": ""
 },
 {
   "symbol": "EBSB",
   "name": "Meridian Bancorp, Inc.",
   "last_sale": "17.8",
   "market_cap": "$959.95M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ebsb",
   "FIELD9": ""
 },
 {
   "symbol": "VIVO",
   "name": "Meridian Bioscience Inc.",
   "last_sale": "15.15",
   "market_cap": "$642.29M",
   "IPOyear": "1986",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/vivo",
   "FIELD9": ""
 },
 {
   "symbol": "MRBK",
   "name": "Meridian Corporation",
   "last_sale": "18.21",
   "market_cap": "$116.4M",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mrbk",
   "FIELD9": ""
 },
 {
   "symbol": "MMSI",
   "name": "Merit Medical Systems, Inc.",
   "last_sale": "61.4",
   "market_cap": "$3.36B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/mmsi",
   "FIELD9": ""
 },
 {
   "symbol": "MACK",
   "name": "Merrimack Pharmaceuticals, Inc.",
   "last_sale": "5.57",
   "market_cap": "$74.32M",
   "IPOyear": "2012",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mack",
   "FIELD9": ""
 },
 {
   "symbol": "MRSN",
   "name": "Mersana Therapeutics, Inc.",
   "last_sale": "11.69",
   "market_cap": "$270.66M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mrsn",
   "FIELD9": ""
 },
 {
   "symbol": "MRUS",
   "name": "Merus N.V.",
   "last_sale": "19",
   "market_cap": "$430.02M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mrus",
   "FIELD9": ""
 },
 {
   "symbol": "MESA",
   "name": "Mesa Air Group, Inc.",
   "last_sale": "13.81",
   "market_cap": "$329.33M",
   "IPOyear": "2018",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mesa",
   "FIELD9": ""
 },
 {
   "symbol": "MLAB",
   "name": "Mesa Laboratories, Inc.",
   "last_sale": "181.26",
   "market_cap": "$697.52M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/mlab",
   "FIELD9": ""
 },
 {
   "symbol": "MESO",
   "name": "Mesoblast Limited",
   "last_sale": "6.85",
   "market_cap": "$656.42M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/meso",
   "FIELD9": ""
 },
 {
   "symbol": "CASH",
   "name": "Meta Financial Group, Inc.",
   "last_sale": "83.35",
   "market_cap": "$1.09B",
   "IPOyear": "1993",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/cash",
   "FIELD9": ""
 },
 {
   "symbol": "MEOH",
   "name": "Methanex Corporation",
   "last_sale": "78.05",
   "market_cap": "$6.2B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/meoh",
   "FIELD9": ""
 },
 {
   "symbol": "MGEE",
   "name": "MGE Energy Inc.",
   "last_sale": "65",
   "market_cap": "$2.25B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/mgee",
   "FIELD9": ""
 },
 {
   "symbol": "MGPI",
   "name": "MGP Ingredients, Inc.",
   "last_sale": "79.07",
   "market_cap": "$1.33B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/mgpi",
   "FIELD9": ""
 },
 {
   "symbol": "MBOT",
   "name": "Microbot Medical Inc. ",
   "last_sale": "6.85",
   "market_cap": "$1.33M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/mbot",
   "FIELD9": ""
 },
 {
   "symbol": "MCHP",
   "name": "Microchip Technology Incorporated",
   "last_sale": "82.74",
   "market_cap": "$19.49B",
   "IPOyear": "1993",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/mchp",
   "FIELD9": ""
 },
 {
   "symbol": "MU",
   "name": "Micron Technology, Inc.",
   "last_sale": "44.71",
   "market_cap": "$51.86B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/mu",
   "FIELD9": ""
 },
 {
   "symbol": "MSFT",
   "name": "Microsoft Corporation",
   "last_sale": "114.81",
   "market_cap": "$880.39B",
   "IPOyear": "1986",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/msft",
   "FIELD9": ""
 },
 {
   "symbol": "MSTR",
   "name": "MicroStrategy Incorporated",
   "last_sale": "148.12",
   "market_cap": "$1.7B",
   "IPOyear": "1998",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mstr",
   "FIELD9": ""
 },
 {
   "symbol": "MVIS",
   "name": "Microvision, Inc.",
   "last_sale": "1.16",
   "market_cap": "$107.97M",
   "IPOyear": "1996",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/mvis",
   "FIELD9": ""
 },
 {
   "symbol": "MICT",
   "name": "MICT, Inc.",
   "last_sale": "1.23",
   "market_cap": "$11.49M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/mict",
   "FIELD9": ""
 },
 {
   "symbol": "MPB",
   "name": "Mid Penn Bancorp",
   "last_sale": "29.3",
   "market_cap": "$247.61M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mpb",
   "FIELD9": ""
 },
 {
   "symbol": "MTP",
   "name": "Midatech Pharma PLC",
   "last_sale": "0.775",
   "market_cap": "$23.71M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mtp",
   "FIELD9": ""
 },
 {
   "symbol": "MCEP",
   "name": "Mid-Con Energy Partners, LP",
   "last_sale": "1.51",
   "market_cap": "$45.96M",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/mcep",
   "FIELD9": ""
 },
 {
   "symbol": "MBCN",
   "name": "Middlefield Banc Corp.",
   "last_sale": "47.4",
   "market_cap": "$153.29M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mbcn",
   "FIELD9": ""
 },
 {
   "symbol": "MSEX",
   "name": "Middlesex Water Company",
   "last_sale": "49",
   "market_cap": "$803.23M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/msex",
   "FIELD9": ""
 },
 {
   "symbol": "MSBI",
   "name": "Midland States Bancorp, Inc.",
   "last_sale": "33.09",
   "market_cap": "$783.41M",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/msbi",
   "FIELD9": ""
 },
 {
   "symbol": "MSVB",
   "name": "Mid-Southern Bancorp, Inc.",
   "last_sale": "12.56",
   "market_cap": "$44.85M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/msvb",
   "FIELD9": ""
 },
 {
   "symbol": "MOFG",
   "name": "MidWestOne Financial Group, Inc.",
   "last_sale": "34.04",
   "market_cap": "$416.01M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mofg",
   "FIELD9": ""
 },
 {
   "symbol": "MIME",
   "name": "Mimecast Limited",
   "last_sale": "42.1",
   "market_cap": "$2.51B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mime",
   "FIELD9": ""
 },
 {
   "symbol": "MDXG",
   "name": "MiMedx Group, Inc",
   "last_sale": "6.355",
   "market_cap": "$705.63M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/mdxg",
   "FIELD9": ""
 },
 {
   "symbol": "MNDO",
   "name": "MIND C.T.I. Ltd.",
   "last_sale": "2.31",
   "market_cap": "$44.6M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mndo",
   "FIELD9": ""
 },
 {
   "symbol": "MB",
   "name": "MINDBODY, Inc.",
   "last_sale": "41.85",
   "market_cap": "$2B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mb",
   "FIELD9": ""
 },
 {
   "symbol": "NERV",
   "name": "Minerva Neurosciences, Inc",
   "last_sale": "12.15",
   "market_cap": "$471.11M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/nerv",
   "FIELD9": ""
 },
 {
   "symbol": "MGEN",
   "name": "Miragen Therapeutics, Inc.",
   "last_sale": "5.6",
   "market_cap": "$169.92M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/mgen",
   "FIELD9": ""
 },
 {
   "symbol": "MRTX",
   "name": "Mirati Therapeutics, Inc.",
   "last_sale": "59.3",
   "market_cap": "$1.92B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mrtx",
   "FIELD9": ""
 },
 {
   "symbol": "MSON",
   "name": "MISONIX, Inc.",
   "last_sale": "17.65",
   "market_cap": "$166.65M",
   "IPOyear": "1992",
   "sector": "Capital Goods",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/mson",
   "FIELD9": ""
 },
 {
   "symbol": "MIND",
   "name": "Mitcham Industries, Inc.",
   "last_sale": "3.98",
   "market_cap": "$48.24M",
   "IPOyear": "1994",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mind",
   "FIELD9": ""
 },
 {
   "symbol": "MINDP",
   "name": "Mitcham Industries, Inc.",
   "last_sale": "23.8152",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mindp",
   "FIELD9": ""
 },
 {
   "symbol": "MITK",
   "name": "Mitek Systems, Inc.",
   "last_sale": "7.2",
   "market_cap": "$272.14M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/mitk",
   "FIELD9": ""
 },
 {
   "symbol": "MITL",
   "name": "Mitel Networks Corporation",
   "last_sale": "11.025",
   "market_cap": "$1.36B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/mitl",
   "FIELD9": ""
 },
 {
   "symbol": "MKSI",
   "name": "MKS Instruments, Inc.",
   "last_sale": "83.7",
   "market_cap": "$4.59B",
   "IPOyear": "1999",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/mksi",
   "FIELD9": ""
 },
 {
   "symbol": "MMAC",
   "name": "MMA Capital Management, LLC",
   "last_sale": "27.7989",
   "market_cap": "$161.26M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/mmac",
   "FIELD9": ""
 },
 {
   "symbol": "MINI",
   "name": "Mobile Mini, Inc.",
   "last_sale": "43.35",
   "market_cap": "$1.94B",
   "IPOyear": "1994",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/mini",
   "FIELD9": ""
 },
 {
   "symbol": "MOBL",
   "name": "MobileIron, Inc.",
   "last_sale": "5.25",
   "market_cap": "$539.37M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mobl",
   "FIELD9": ""
 },
 {
   "symbol": "MMDM",
   "name": "Modern Media Acquisition Corp.",
   "last_sale": "10.1",
   "market_cap": "$63.37M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mmdm",
   "FIELD9": ""
 },
 {
   "symbol": "MMDMR",
   "name": "Modern Media Acquisition Corp.",
   "last_sale": "0.449",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mmdmr",
   "FIELD9": ""
 },
 {
   "symbol": "MMDMU",
   "name": "Modern Media Acquisition Corp.",
   "last_sale": "10.85",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mmdmu",
   "FIELD9": ""
 },
 {
   "symbol": "MMDMW",
   "name": "Modern Media Acquisition Corp.",
   "last_sale": "0.6",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mmdmw",
   "FIELD9": ""
 },
 {
   "symbol": "MOGO",
   "name": "Mogo Finance Technology Inc.",
   "last_sale": "3.1123",
   "market_cap": "$71.34M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mogo",
   "FIELD9": ""
 },
 {
   "symbol": "MTEM",
   "name": "Molecular Templates, Inc.",
   "last_sale": "5.52",
   "market_cap": "$149.4M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mtem",
   "FIELD9": ""
 },
 {
   "symbol": "MBRX",
   "name": "Moleculin Biotech, Inc.",
   "last_sale": "1.63",
   "market_cap": "$43.78M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mbrx",
   "FIELD9": ""
 },
 {
   "symbol": "MNTA",
   "name": "Momenta Pharmaceuticals, Inc.",
   "last_sale": "26.9",
   "market_cap": "$2.11B",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/mnta",
   "FIELD9": ""
 },
 {
   "symbol": "MOMO",
   "name": "Momo Inc.",
   "last_sale": "46.44",
   "market_cap": "$9.5B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/momo",
   "FIELD9": ""
 },
 {
   "symbol": "MKGI",
   "name": "Monaker Group, Inc.",
   "last_sale": "2.81",
   "market_cap": "$22.58M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mkgi",
   "FIELD9": ""
 },
 {
   "symbol": "MCRI",
   "name": "Monarch Casino & Resort, Inc.",
   "last_sale": "45.57",
   "market_cap": "$815M",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/mcri",
   "FIELD9": ""
 },
 {
   "symbol": "MDLZ",
   "name": "Mondelez International, Inc.",
   "last_sale": "43.93",
   "market_cap": "$64.43B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/mdlz",
   "FIELD9": ""
 },
 {
   "symbol": "MGI",
   "name": "Moneygram International, Inc.",
   "last_sale": "5.89",
   "market_cap": "$327.94M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mgi",
   "FIELD9": ""
 },
 {
   "symbol": "MDB",
   "name": "MongoDB, Inc.",
   "last_sale": "81.38",
   "market_cap": "$4.25B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mdb",
   "FIELD9": ""
 },
 {
   "symbol": "MPWR",
   "name": "Monolithic Power Systems, Inc.",
   "last_sale": "132.9",
   "market_cap": "$5.62B",
   "IPOyear": "2004",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/mpwr",
   "FIELD9": ""
 },
 {
   "symbol": "TYPE",
   "name": "Monotype Imaging Holdings Inc.",
   "last_sale": "20.3",
   "market_cap": "$854.71M",
   "IPOyear": "2007",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/type",
   "FIELD9": ""
 },
 {
   "symbol": "MNRO",
   "name": "Monro, Inc. ",
   "last_sale": "71.975",
   "market_cap": "$2.37B",
   "IPOyear": "1991",
   "sector": "Consumer Services",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/mnro",
   "FIELD9": ""
 },
 {
   "symbol": "MRCC",
   "name": "Monroe Capital Corporation",
   "last_sale": "13.72",
   "market_cap": "$280.5M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mrcc",
   "FIELD9": ""
 },
 {
   "symbol": "MRCCL",
   "name": "Monroe Capital Corporation",
   "last_sale": "24.8",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mrccl",
   "FIELD9": ""
 },
 {
   "symbol": "MNST",
   "name": "Monster Beverage Corporation",
   "last_sale": "59.84",
   "market_cap": "$33.06B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/mnst",
   "FIELD9": ""
 },
 {
   "symbol": "MORN",
   "name": "Morningstar, Inc.",
   "last_sale": "131.34",
   "market_cap": "$5.6B",
   "IPOyear": "2005",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/morn",
   "FIELD9": ""
 },
 {
   "symbol": "MOR",
   "name": "MorphoSys AG",
   "last_sale": "26.84",
   "market_cap": "$3.38B",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mor",
   "FIELD9": ""
 },
 {
   "symbol": "MOSY",
   "name": "MoSys, Inc.",
   "last_sale": "0.6462",
   "market_cap": "$5.28M",
   "IPOyear": "2001",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/mosy",
   "FIELD9": ""
 },
 {
   "symbol": "MOTA",
   "name": "Mota Group, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mota",
   "FIELD9": ""
 },
 {
   "symbol": "MTFB",
   "name": "Motif Bio plc",
   "last_sale": "8.4593",
   "market_cap": "$125.48M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mtfb",
   "FIELD9": ""
 },
 {
   "symbol": "MTFBW",
   "name": "Motif Bio plc",
   "last_sale": "2.6495",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mtfbw",
   "FIELD9": ""
 },
 {
   "symbol": "MPAA",
   "name": "Motorcar Parts of America, Inc.",
   "last_sale": "25.01",
   "market_cap": "$473.09M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/mpaa",
   "FIELD9": ""
 },
 {
   "symbol": "MOTS",
   "name": "Motus GI Holdings, Inc.",
   "last_sale": "5.27",
   "market_cap": "$82.62M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/mots",
   "FIELD9": ""
 },
 {
   "symbol": "MPVD",
   "name": "Mountain Province Diamonds Inc.",
   "last_sale": "2.1",
   "market_cap": "$441.01M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/mpvd",
   "FIELD9": ""
 },
 {
   "symbol": "MOXC",
   "name": "Moxian, Inc.",
   "last_sale": "0.9162",
   "market_cap": "$61.71M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/moxc",
   "FIELD9": ""
 },
 {
   "symbol": "MRIC",
   "name": "MRI Interventions Inc",
   "last_sale": "1.39",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mric",
   "FIELD9": ""
 },
 {
   "symbol": "MSBF",
   "name": "MSB Financial Corp.",
   "last_sale": "21.45",
   "market_cap": "$118.26M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/msbf",
   "FIELD9": ""
 },
 {
   "symbol": "MTEC",
   "name": "MTech Acquisition Corp.",
   "last_sale": "10.2",
   "market_cap": "$21.8M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mtec",
   "FIELD9": ""
 },
 {
   "symbol": "MTECU",
   "name": "MTech Acquisition Corp.",
   "last_sale": "11.55",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mtecu",
   "FIELD9": ""
 },
 {
   "symbol": "MTECW",
   "name": "MTech Acquisition Corp.",
   "last_sale": "1.25",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mtecw",
   "FIELD9": ""
 },
 {
   "symbol": "MTSC",
   "name": "MTS Systems Corporation",
   "last_sale": "55.45",
   "market_cap": "$990.34M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/mtsc",
   "FIELD9": ""
 },
 {
   "symbol": "MUDS",
   "name": "Mudrick Capital Acquisition Corporation",
   "last_sale": "9.67",
   "market_cap": "$60.66M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/muds",
   "FIELD9": ""
 },
 {
   "symbol": "MUDSU",
   "name": "Mudrick Capital Acquisition Corporation",
   "last_sale": "10.32",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mudsu",
   "FIELD9": ""
 },
 {
   "symbol": "MUDSW",
   "name": "Mudrick Capital Acquisition Corporation",
   "last_sale": "0.7",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mudsw",
   "FIELD9": ""
 },
 {
   "symbol": "LABL",
   "name": "Multi-Color Corporation",
   "last_sale": "65.35",
   "market_cap": "$1.34B",
   "IPOyear": "1987",
   "sector": "Miscellaneous",
   "industry": "Publishing",
   "summary_quote": "https://www.nasdaq.com/symbol/labl",
   "FIELD9": ""
 },
 {
   "symbol": "MBIO",
   "name": "Mustang Bio, Inc.",
   "last_sale": "6.14",
   "market_cap": "$167.4M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mbio",
   "FIELD9": ""
 },
 {
   "symbol": "MFSF",
   "name": "MutualFirst Financial Inc.",
   "last_sale": "37.1",
   "market_cap": "$318.59M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mfsf",
   "FIELD9": ""
 },
 {
   "symbol": "MVBF",
   "name": "MVB Financial Corp.",
   "last_sale": "19.05",
   "market_cap": "$215.98M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mvbf",
   "FIELD9": ""
 },
 {
   "symbol": "MYSZ",
   "name": "My Size, Inc.",
   "last_sale": "1.2537",
   "market_cap": "$37.25M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mysz",
   "FIELD9": ""
 },
 {
   "symbol": "MYL",
   "name": "Mylan N.V.",
   "last_sale": "38.98",
   "market_cap": "$20.1B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/myl",
   "FIELD9": ""
 },
 {
   "symbol": "MYND",
   "name": "MYnd Analytics, Inc.",
   "last_sale": "1.73",
   "market_cap": "$10.87M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/mynd",
   "FIELD9": ""
 },
 {
   "symbol": "MYNDW",
   "name": "MYnd Analytics, Inc.",
   "last_sale": "0.3",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/myndw",
   "FIELD9": ""
 },
 {
   "symbol": "MYOK",
   "name": "MyoKardia, Inc.",
   "last_sale": "63.1",
   "market_cap": "$2.53B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/myok",
   "FIELD9": ""
 },
 {
   "symbol": "MYOS",
   "name": "MYOS RENS Technology Inc.",
   "last_sale": "1.28",
   "market_cap": "$9.57M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/myos",
   "FIELD9": ""
 },
 {
   "symbol": "MYRG",
   "name": "MYR Group, Inc.",
   "last_sale": "32.76",
   "market_cap": "$542.69M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/myrg",
   "FIELD9": ""
 },
 {
   "symbol": "MYGN",
   "name": "Myriad Genetics, Inc.",
   "last_sale": "46.27",
   "market_cap": "$3.28B",
   "IPOyear": "1995",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/mygn",
   "FIELD9": ""
 },
 {
   "symbol": "NBRV",
   "name": "Nabriva Therapeutics plc",
   "last_sale": "2.53",
   "market_cap": "$168.2M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/nbrv",
   "FIELD9": ""
 },
 {
   "symbol": "NAKD",
   "name": "Naked Brand Group Limited",
   "last_sale": "2.71",
   "market_cap": "$62.22M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/nakd",
   "FIELD9": ""
 },
 {
   "symbol": "NNDM",
   "name": "Nano Dimension Ltd.",
   "last_sale": "2.08",
   "market_cap": "$200.87M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/nndm",
   "FIELD9": ""
 },
 {
   "symbol": "NANO",
   "name": "Nanometrics Incorporated",
   "last_sale": "35.85",
   "market_cap": "$865.3M",
   "IPOyear": "1984",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/nano",
   "FIELD9": ""
 },
 {
   "symbol": "NSTG",
   "name": "NanoString Technologies, Inc.",
   "last_sale": "16.72",
   "market_cap": "$498.05M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/nstg",
   "FIELD9": ""
 },
 {
   "symbol": "NAOV",
   "name": "NanoVibronix, Inc.",
   "last_sale": "4.35",
   "market_cap": "$17.22M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/naov",
   "FIELD9": ""
 },
 {
   "symbol": "NH",
   "name": "NantHealth, Inc.",
   "last_sale": "1.55",
   "market_cap": "$169.68M",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nh",
   "FIELD9": ""
 },
 {
   "symbol": "NK",
   "name": "NantKwest, Inc.",
   "last_sale": "3.3",
   "market_cap": "$261.39M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/nk",
   "FIELD9": ""
 },
 {
   "symbol": "NSSC",
   "name": "NAPCO Security Technologies, Inc.",
   "last_sale": "14.5",
   "market_cap": "$271.61M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/nssc",
   "FIELD9": ""
 },
 {
   "symbol": "NDAQ",
   "name": "Nasdaq, Inc.",
   "last_sale": "90.55",
   "market_cap": "$14.9B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/ndaq",
   "FIELD9": ""
 },
 {
   "symbol": "NTRA",
   "name": "Natera, Inc.",
   "last_sale": "24.05",
   "market_cap": "$1.47B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/ntra",
   "FIELD9": ""
 },
 {
   "symbol": "NATH",
   "name": "Nathan&#39;s Famous, Inc.",
   "last_sale": "86.55",
   "market_cap": "$362.43M",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/nath",
   "FIELD9": ""
 },
 {
   "symbol": "NAUH",
   "name": "National American University Holdings, Inc.",
   "last_sale": "0.87",
   "market_cap": "$21.18M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nauh",
   "FIELD9": ""
 },
 {
   "symbol": "NKSH",
   "name": "National Bankshares, Inc.",
   "last_sale": "45.85",
   "market_cap": "$319.02M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/nksh",
   "FIELD9": ""
 },
 {
   "symbol": "FIZZ",
   "name": "National Beverage Corp.",
   "last_sale": "113.44",
   "market_cap": "$5.29B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/fizz",
   "FIELD9": ""
 },
 {
   "symbol": "NCMI",
   "name": "National CineMedia, Inc.",
   "last_sale": "9.725",
   "market_cap": "$768.23M",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/ncmi",
   "FIELD9": ""
 },
 {
   "symbol": "NCOM",
   "name": "National Commerce Corporation",
   "last_sale": "43.5",
   "market_cap": "$897.12M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ncom",
   "FIELD9": ""
 },
 {
   "symbol": "NESR",
   "name": "National Energy Services Reunited Corp.",
   "last_sale": "12.06",
   "market_cap": "$1.03B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/nesr",
   "FIELD9": ""
 },
 {
   "symbol": "NESRW",
   "name": "National Energy Services Reunited Corp.",
   "last_sale": "2.17",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/nesrw",
   "FIELD9": ""
 },
 {
   "symbol": "NGHC",
   "name": "National General Holdings Corp",
   "last_sale": "26.18",
   "market_cap": "$2.8B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/nghc",
   "FIELD9": ""
 },
 {
   "symbol": "NGHCN",
   "name": "National General Holdings Corp",
   "last_sale": "24.45",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/nghcn",
   "FIELD9": ""
 },
 {
   "symbol": "NGHCO",
   "name": "National General Holdings Corp",
   "last_sale": "24.56",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/nghco",
   "FIELD9": ""
 },
 {
   "symbol": "NGHCP",
   "name": "National General Holdings Corp",
   "last_sale": "25",
   "market_cap": "$55M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/nghcp",
   "FIELD9": ""
 },
 {
   "symbol": "NGHCZ",
   "name": "National General Holdings Corp",
   "last_sale": "25.3173",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/nghcz",
   "FIELD9": ""
 },
 {
   "symbol": "NHLD",
   "name": "National Holdings Corporation",
   "last_sale": "3.3",
   "market_cap": "$41.22M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/nhld",
   "FIELD9": ""
 },
 {
   "symbol": "NHLDW",
   "name": "National Holdings Corporation",
   "last_sale": "0.7501",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/nhldw",
   "FIELD9": ""
 },
 {
   "symbol": "NATI",
   "name": "National Instruments Corporation",
   "last_sale": "48.68",
   "market_cap": "$6.44B",
   "IPOyear": "1995",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/nati",
   "FIELD9": ""
 },
 {
   "symbol": "NRC",
   "name": "National Research Corporation",
   "last_sale": "37.875",
   "market_cap": "$936.99M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/nrc",
   "FIELD9": ""
 },
 {
   "symbol": "NSEC",
   "name": "National Security Group, Inc.",
   "last_sale": "14.68",
   "market_cap": "$37.1M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/nsec",
   "FIELD9": ""
 },
 {
   "symbol": "EYE",
   "name": "National Vision Holdings, Inc.",
   "last_sale": "43.33",
   "market_cap": "$3.27B",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Ophthalmic Goods",
   "summary_quote": "https://www.nasdaq.com/symbol/eye",
   "FIELD9": ""
 },
 {
   "symbol": "NWLI",
   "name": "National Western Life Group, Inc.",
   "last_sale": "320.55",
   "market_cap": "$1.17B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/nwli",
   "FIELD9": ""
 },
 {
   "symbol": "NAII",
   "name": "Natural Alternatives International, Inc.",
   "last_sale": "10.25",
   "market_cap": "$77.47M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/naii",
   "FIELD9": ""
 },
 {
   "symbol": "NHTC",
   "name": "Natural Health Trends Corp.",
   "last_sale": "24.15",
   "market_cap": "$274.73M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Consumer Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/nhtc",
   "FIELD9": ""
 },
 {
   "symbol": "NATR",
   "name": "Nature&#39;s Sunshine Products, Inc.",
   "last_sale": "9",
   "market_cap": "$172.17M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/natr",
   "FIELD9": ""
 },
 {
   "symbol": "BABY",
   "name": "Natus Medical Incorporated",
   "last_sale": "34.45",
   "market_cap": "$1.15B",
   "IPOyear": "2001",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/baby",
   "FIELD9": ""
 },
 {
   "symbol": "JSM",
   "name": "Navient Corporation",
   "last_sale": "22.4125",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/jsm",
   "FIELD9": ""
 },
 {
   "symbol": "NAVI",
   "name": "Navient Corporation",
   "last_sale": "14.35",
   "market_cap": "$3.8B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/navi",
   "FIELD9": ""
 },
 {
   "symbol": "NMCI",
   "name": "Navios Maritime Containers L.P.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nmci",
   "FIELD9": ""
 },
 {
   "symbol": "NBCP",
   "name": "NB Capital Acquisition Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nbcp",
   "FIELD9": ""
 },
 {
   "symbol": "NBTB",
   "name": "NBT Bancorp Inc.",
   "last_sale": "39.78",
   "market_cap": "$1.74B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/nbtb",
   "FIELD9": ""
 },
 {
   "symbol": "NCSM",
   "name": "NCS Multistage Holdings, Inc.",
   "last_sale": "16.1305",
   "market_cap": "$724.4M",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ncsm",
   "FIELD9": ""
 },
 {
   "symbol": "NEBU",
   "name": "Nebula Acquisition Corporation",
   "last_sale": "9.69",
   "market_cap": "$78.48M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nebu",
   "FIELD9": ""
 },
 {
   "symbol": "NEBUU",
   "name": "Nebula Acquisition Corporation",
   "last_sale": "10.0749",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nebuu",
   "FIELD9": ""
 },
 {
   "symbol": "NEBUW",
   "name": "Nebula Acquisition Corporation",
   "last_sale": "1.39",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nebuw",
   "FIELD9": ""
 },
 {
   "symbol": "NKTR",
   "name": "Nektar Therapeutics",
   "last_sale": "59",
   "market_cap": "$10.18B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/nktr",
   "FIELD9": ""
 },
 {
   "symbol": "NMRD",
   "name": "Nemaura Medical Inc.",
   "last_sale": "3.07",
   "market_cap": "$629.35M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/nmrd",
   "FIELD9": ""
 },
 {
   "symbol": "NEOG",
   "name": "Neogen Corporation",
   "last_sale": "89.4",
   "market_cap": "$4.63B",
   "IPOyear": "1989",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/neog",
   "FIELD9": ""
 },
 {
   "symbol": "NEO",
   "name": "NeoGenomics, Inc.",
   "last_sale": "14.2",
   "market_cap": "$1.16B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Precision Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/neo",
   "FIELD9": ""
 },
 {
   "symbol": "NTGN",
   "name": "Neon Therapeutics, Inc.",
   "last_sale": "7.6",
   "market_cap": "$215.1M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/ntgn",
   "FIELD9": ""
 },
 {
   "symbol": "NEON",
   "name": "Neonode Inc.",
   "last_sale": "0.3",
   "market_cap": "$17.58M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/neon",
   "FIELD9": ""
 },
 {
   "symbol": "NEOS",
   "name": "Neos Therapeutics, Inc.",
   "last_sale": "5",
   "market_cap": "$148.37M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/neos",
   "FIELD9": ""
 },
 {
   "symbol": "NVCN",
   "name": "Neovasc Inc.",
   "last_sale": "2.9601",
   "market_cap": "$56.11M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/nvcn",
   "FIELD9": ""
 },
 {
   "symbol": "NEPT",
   "name": "Neptune Wellness Solutions Inc.",
   "last_sale": "4.32",
   "market_cap": "$343.52M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/nept",
   "FIELD9": ""
 },
 {
   "symbol": "UEPS",
   "name": "Net 1 UEPS Technologies, Inc.",
   "last_sale": "7.65",
   "market_cap": "$431.23M",
   "IPOyear": "2005",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/ueps",
   "FIELD9": ""
 },
 {
   "symbol": "NETE",
   "name": "Net Element, Inc.",
   "last_sale": "5.45",
   "market_cap": "$21.03M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nete",
   "FIELD9": ""
 },
 {
   "symbol": "NTAP",
   "name": "NetApp, Inc.",
   "last_sale": "86.85",
   "market_cap": "$22.52B",
   "IPOyear": "1995",
   "sector": "Technology",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/ntap",
   "FIELD9": ""
 },
 {
   "symbol": "NTES",
   "name": "NetEase, Inc.",
   "last_sale": "214.78",
   "market_cap": "$28.21B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ntes",
   "FIELD9": ""
 },
 {
   "symbol": "NFLX",
   "name": "Netflix, Inc.",
   "last_sale": "360.98",
   "market_cap": "$157.19B",
   "IPOyear": "2002",
   "sector": "Communication Services",
   "industry": "Consumer Electronics/Video Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/nflx",
   "FIELD9": ""
 },
 {
   "symbol": "NTGR",
   "name": "NETGEAR, Inc.",
   "last_sale": "62.9",
   "market_cap": "$2B",
   "IPOyear": "2003",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ntgr",
   "FIELD9": ""
 },
 {
   "symbol": "NLST",
   "name": "Netlist, Inc.",
   "last_sale": "0.615",
   "market_cap": "$71.97M",
   "IPOyear": "2006",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/nlst",
   "FIELD9": ""
 },
 {
   "symbol": "NTCT",
   "name": "NetScout Systems, Inc.",
   "last_sale": "25.7",
   "market_cap": "$2.07B",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ntct",
   "FIELD9": ""
 },
 {
   "symbol": "NTWK",
   "name": "NetSol Technologies Inc.",
   "last_sale": "6.2167",
   "market_cap": "$71.23M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ntwk",
   "FIELD9": ""
 },
 {
   "symbol": "CUR",
   "name": "Neuralstem, Inc.",
   "last_sale": "1.08",
   "market_cap": "$16.37M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/cur",
   "FIELD9": ""
 },
 {
   "symbol": "NBIX",
   "name": "Neurocrine Biosciences, Inc.",
   "last_sale": "119.6",
   "market_cap": "$10.82B",
   "IPOyear": "1996",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/nbix",
   "FIELD9": ""
 },
 {
   "symbol": "NURO",
   "name": "NeuroMetrix, Inc.",
   "last_sale": "1.31",
   "market_cap": "$9.64M",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/nuro",
   "FIELD9": ""
 },
 {
   "symbol": "NUROW",
   "name": "NeuroMetrix, Inc.",
   "last_sale": "0.0354",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/nurow",
   "FIELD9": ""
 },
 {
   "symbol": "STIM",
   "name": "Neuronetics, Inc.",
   "last_sale": "34.295",
   "market_cap": "$602.8M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/stim",
   "FIELD9": ""
 },
 {
   "symbol": "NTRP",
   "name": "Neurotrope, Inc.",
   "last_sale": "8.32",
   "market_cap": "$65.81M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ntrp",
   "FIELD9": ""
 },
 {
   "symbol": "NBEV",
   "name": "New Age Beverages Corporation",
   "last_sale": "6.15",
   "market_cap": "$303.8M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/nbev",
   "FIELD9": ""
 },
 {
   "symbol": "NYMT",
   "name": "New York Mortgage Trust, Inc.",
   "last_sale": "6.31",
   "market_cap": "$786.77M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/nymt",
   "FIELD9": ""
 },
 {
   "symbol": "NYMTN",
   "name": "New York Mortgage Trust, Inc.",
   "last_sale": "24.3",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/nymtn",
   "FIELD9": ""
 },
 {
   "symbol": "NYMTO",
   "name": "New York Mortgage Trust, Inc.",
   "last_sale": "24.75",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/nymto",
   "FIELD9": ""
 },
 {
   "symbol": "NYMTP",
   "name": "New York Mortgage Trust, Inc.",
   "last_sale": "24.82",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nymtp",
   "FIELD9": ""
 },
 {
   "symbol": "NEWA",
   "name": "Newater Technology, Inc.",
   "last_sale": "10.18",
   "market_cap": "$110.04M",
   "IPOyear": "2017",
   "sector": "Basic Industries",
   "industry": "Miscellaneous",
   "summary_quote": "https://www.nasdaq.com/symbol/newa",
   "FIELD9": ""
 },
 {
   "symbol": "NLNK",
   "name": "NewLink Genetics Corporation",
   "last_sale": "2.37",
   "market_cap": "$88.2M",
   "IPOyear": "2011",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/nlnk",
   "FIELD9": ""
 },
 {
   "symbol": "NMRK",
   "name": "Newmark Group, Inc.",
   "last_sale": "11.38",
   "market_cap": "$1.76B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/nmrk",
   "FIELD9": ""
 },
 {
   "symbol": "NWS",
   "name": "News Corporation",
   "last_sale": "13.2",
   "market_cap": "$7.7B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Newspapers/Magazines",
   "summary_quote": "https://www.nasdaq.com/symbol/nws",
   "FIELD9": ""
 },
 {
   "symbol": "NWSA",
   "name": "News Corporation",
   "last_sale": "12.8",
   "market_cap": "$7.46B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Newspapers/Magazines",
   "summary_quote": "https://www.nasdaq.com/symbol/nwsa",
   "FIELD9": ""
 },
 {
   "symbol": "NEWT",
   "name": "Newtek Business Services Corp.",
   "last_sale": "21.54",
   "market_cap": "$404.79M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/newt",
   "FIELD9": ""
 },
 {
   "symbol": "NEWTI",
   "name": "Newtek Business Services Corp.",
   "last_sale": "25.8983",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/newti",
   "FIELD9": ""
 },
 {
   "symbol": "NEWTZ",
   "name": "Newtek Business Services Corp.",
   "last_sale": "25.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/newtz",
   "FIELD9": ""
 },
 {
   "symbol": "NXEO",
   "name": "Nexeo Solutions, Inc.",
   "last_sale": "12.42",
   "market_cap": "$1.11B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/nxeo",
   "FIELD9": ""
 },
 {
   "symbol": "NXEOU",
   "name": "Nexeo Solutions, Inc.",
   "last_sale": "13.25",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/nxeou",
   "FIELD9": ""
 },
 {
   "symbol": "NXEOW",
   "name": "Nexeo Solutions, Inc.",
   "last_sale": "1.05",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/nxeow",
   "FIELD9": ""
 },
 {
   "symbol": "NXMD",
   "name": "Nexeon Medsystems, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nxmd",
   "FIELD9": ""
 },
 {
   "symbol": "NXST",
   "name": "Nexstar Media Group, Inc.",
   "last_sale": "82.5",
   "market_cap": "$3.76B",
   "IPOyear": "2003",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/nxst",
   "FIELD9": ""
 },
 {
   "symbol": "NEXT",
   "name": "NextDecade Corporation",
   "last_sale": "4.69",
   "market_cap": "$510.51M",
   "IPOyear": "2015",
   "sector": "Public Utilities",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/next",
   "FIELD9": ""
 },
 {
   "symbol": "NXGN",
   "name": "NextGen Healthcare, Inc.",
   "last_sale": "20.48",
   "market_cap": "$1.32B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nxgn",
   "FIELD9": ""
 },
 {
   "symbol": "NFEC",
   "name": "NF Energy Saving Corporation",
   "last_sale": "4.75",
   "market_cap": "$35.97M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/nfec",
   "FIELD9": ""
 },
 {
   "symbol": "NODK",
   "name": "NI Holdings, Inc.",
   "last_sale": "17.11",
   "market_cap": "$382.58M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/nodk",
   "FIELD9": ""
 },
 {
   "symbol": "EGOV",
   "name": "NIC Inc.",
   "last_sale": "14.55",
   "market_cap": "$968.45M",
   "IPOyear": "1999",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/egov",
   "FIELD9": ""
 },
 {
   "symbol": "NICE",
   "name": "NICE Ltd",
   "last_sale": "113.27",
   "market_cap": "$6.95B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/nice",
   "FIELD9": ""
 },
 {
   "symbol": "NICK",
   "name": "Nicholas Financial, Inc.",
   "last_sale": "12.01",
   "market_cap": "$94.99M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/nick",
   "FIELD9": ""
 },
 {
   "symbol": "NCBS",
   "name": "Nicolet Bankshares Inc.",
   "last_sale": "55.025",
   "market_cap": "$530.7M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ncbs",
   "FIELD9": ""
 },
 {
   "symbol": "NITE",
   "name": "Nightstar Therapeutics plc",
   "last_sale": "25.5",
   "market_cap": "$736.95M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/nite",
   "FIELD9": ""
 },
 {
   "symbol": "NIHD",
   "name": "NII Holdings, Inc.",
   "last_sale": "4.95",
   "market_cap": "$497.33M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/nihd",
   "FIELD9": ""
 },
 {
   "symbol": "LASR",
   "name": "nLIGHT, Inc.",
   "last_sale": "26.24",
   "market_cap": "$913.19M",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/lasr",
   "FIELD9": ""
 },
 {
   "symbol": "NMIH",
   "name": "NMI Holdings Inc",
   "last_sale": "22.8",
   "market_cap": "$1.5B",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/nmih",
   "FIELD9": ""
 },
 {
   "symbol": "NNBR",
   "name": "NN, Inc.",
   "last_sale": "15.675",
   "market_cap": "$434.66M",
   "IPOyear": "1994",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/nnbr",
   "FIELD9": ""
 },
 {
   "symbol": "NDLS",
   "name": "Noodles & Company",
   "last_sale": "12.5",
   "market_cap": "$547.48M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/ndls",
   "FIELD9": ""
 },
 {
   "symbol": "NDSN",
   "name": "Nordson Corporation",
   "last_sale": "145.27",
   "market_cap": "$8.45B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/ndsn",
   "FIELD9": ""
 },
 {
   "symbol": "NSYS",
   "name": "Nortech Systems Incorporated",
   "last_sale": "4.1",
   "market_cap": "$11M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/nsys",
   "FIELD9": ""
 },
 {
   "symbol": "NBN",
   "name": "Northeast Bancorp",
   "last_sale": "21.65",
   "market_cap": "$193.53M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/nbn",
   "FIELD9": ""
 },
 {
   "symbol": "NTIC",
   "name": "Northern Technologies International Corporation",
   "last_sale": "35",
   "market_cap": "$158.95M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/ntic",
   "FIELD9": ""
 },
 {
   "symbol": "NTRS",
   "name": "Northern Trust Corporation",
   "last_sale": "106.35",
   "market_cap": "$23.75B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ntrs",
   "FIELD9": ""
 },
 {
   "symbol": "NTRSP",
   "name": "Northern Trust Corporation",
   "last_sale": "25.75",
   "market_cap": "$412M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ntrsp",
   "FIELD9": ""
 },
 {
   "symbol": "NFBK",
   "name": "Northfield Bancorp, Inc.",
   "last_sale": "16.06",
   "market_cap": "$794.86M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/nfbk",
   "FIELD9": ""
 },
 {
   "symbol": "NRIM",
   "name": "Northrim BanCorp Inc",
   "last_sale": "42.95",
   "market_cap": "$295.19M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/nrim",
   "FIELD9": ""
 },
 {
   "symbol": "NWBI",
   "name": "Northwest Bancshares, Inc.",
   "last_sale": "18.04",
   "market_cap": "$1.86B",
   "IPOyear": "2009",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/nwbi",
   "FIELD9": ""
 },
 {
   "symbol": "NWPX",
   "name": "Northwest Pipe Company",
   "last_sale": "20.84",
   "market_cap": "$202.88M",
   "IPOyear": "1995",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/nwpx",
   "FIELD9": ""
 },
 {
   "symbol": "NCLH",
   "name": "Norwegian Cruise Line Holdings Ltd.",
   "last_sale": "57.88",
   "market_cap": "$12.82B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/nclh",
   "FIELD9": ""
 },
 {
   "symbol": "NWFL",
   "name": "Norwood Financial Corp.",
   "last_sale": "39.5",
   "market_cap": "$247.39M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/nwfl",
   "FIELD9": ""
 },
 {
   "symbol": "NVFY",
   "name": "Nova Lifestyle, Inc",
   "last_sale": "1.71",
   "market_cap": "$47.17M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/nvfy",
   "FIELD9": ""
 },
 {
   "symbol": "NVMI",
   "name": "Nova Measuring Instruments Ltd.",
   "last_sale": "26.31",
   "market_cap": "$734.8M",
   "IPOyear": "2000",
   "sector": "Capital Goods",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/nvmi",
   "FIELD9": ""
 },
 {
   "symbol": "NOVN",
   "name": "Novan, Inc.",
   "last_sale": "2.8",
   "market_cap": "$72.91M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/novn",
   "FIELD9": ""
 },
 {
   "symbol": "NOVT",
   "name": "Novanta Inc.",
   "last_sale": "70.6",
   "market_cap": "$2.45B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/novt",
   "FIELD9": ""
 },
 {
   "symbol": "NVAX",
   "name": "Novavax, Inc.",
   "last_sale": "1.6",
   "market_cap": "$612.15M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/nvax",
   "FIELD9": ""
 },
 {
   "symbol": "NVLN",
   "name": "Novelion Therapeutics Inc. ",
   "last_sale": "3.56",
   "market_cap": "$66.07M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/nvln",
   "FIELD9": ""
 },
 {
   "symbol": "NVCR",
   "name": "NovoCure Limited",
   "last_sale": "48.65",
   "market_cap": "$4.52B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/nvcr",
   "FIELD9": ""
 },
 {
   "symbol": "NVMM",
   "name": "Novume Solutions, Inc.",
   "last_sale": "1.7",
   "market_cap": "$24.73M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/nvmm",
   "FIELD9": ""
 },
 {
   "symbol": "NVUS",
   "name": "Novus Therapeutics, Inc.",
   "last_sale": "4.87",
   "market_cap": "$45.89M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/nvus",
   "FIELD9": ""
 },
 {
   "symbol": "NUAN",
   "name": "Nuance Communications, Inc.",
   "last_sale": "16.83",
   "market_cap": "$4.83B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/nuan",
   "FIELD9": ""
 },
 {
   "symbol": "NCNA",
   "name": "NuCana plc",
   "last_sale": "22.41",
   "market_cap": "$712.88M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ncna",
   "FIELD9": ""
 },
 {
   "symbol": "NTNX",
   "name": "Nutanix, Inc.",
   "last_sale": "46.47",
   "market_cap": "$7.93B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ntnx",
   "FIELD9": ""
 },
 {
   "symbol": "NTRI",
   "name": "NutriSystem Inc",
   "last_sale": "37.55",
   "market_cap": "$1.11B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/ntri",
   "FIELD9": ""
 },
 {
   "symbol": "NUVA",
   "name": "NuVasive, Inc.",
   "last_sale": "68.88",
   "market_cap": "$3.54B",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/nuva",
   "FIELD9": ""
 },
 {
   "symbol": "NVTR",
   "name": "Nuvectra Corporation",
   "last_sale": "22.46",
   "market_cap": "$393.26M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/nvtr",
   "FIELD9": ""
 },
 {
   "symbol": "QQQX",
   "name": "Nuveen NASDAQ 100 Dynamic Overwrite Fund",
   "last_sale": "23.97",
   "market_cap": "$877.57M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qqqx",
   "FIELD9": ""
 },
 {
   "symbol": "NVEE",
   "name": "NV5 Global, Inc.",
   "last_sale": "89.75",
   "market_cap": "$1.11B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nvee",
   "FIELD9": ""
 },
 {
   "symbol": "NVEC",
   "name": "NVE Corporation",
   "last_sale": "105.04",
   "market_cap": "$508.6M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/nvec",
   "FIELD9": ""
 },
 {
   "symbol": "NVDA",
   "name": "NVIDIA Corporation",
   "last_sale": "263.45",
   "market_cap": "$160.18B",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/nvda",
   "FIELD9": ""
 },
 {
   "symbol": "NXPI",
   "name": "NXP Semiconductors N.V.",
   "last_sale": "93.73",
   "market_cap": "$32.27B",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/nxpi",
   "FIELD9": ""
 },
 {
   "symbol": "NXTM",
   "name": "NxStage Medical, Inc.",
   "last_sale": "28.16",
   "market_cap": "$1.85B",
   "IPOyear": "2005",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/nxtm",
   "FIELD9": ""
 },
 {
   "symbol": "NXTD",
   "name": "NXT-ID Inc.",
   "last_sale": "1.42",
   "market_cap": "$35M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nxtd",
   "FIELD9": ""
 },
 {
   "symbol": "NXTDW",
   "name": "NXT-ID Inc.",
   "last_sale": "0.09",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nxtdw",
   "FIELD9": ""
 },
 {
   "symbol": "NYMX",
   "name": "Nymox Pharmaceutical Corporation",
   "last_sale": "2.65",
   "market_cap": "$160.97M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/nymx",
   "FIELD9": ""
 },
 {
   "symbol": "OIIM",
   "name": "O2Micro International Limited",
   "last_sale": "2.21",
   "market_cap": "$57.52M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/oiim",
   "FIELD9": ""
 },
 {
   "symbol": "OVLY",
   "name": "Oak Valley Bancorp (CA)",
   "last_sale": "19.65",
   "market_cap": "$160.8M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ovly",
   "FIELD9": ""
 },
 {
   "symbol": "OCSL",
   "name": "Oaktree Specialty Lending Corporation",
   "last_sale": "4.99",
   "market_cap": "$703.39M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ocsl",
   "FIELD9": ""
 },
 {
   "symbol": "OCSLL",
   "name": "Oaktree Specialty Lending Corporation",
   "last_sale": "24.89",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ocsll",
   "FIELD9": ""
 },
 {
   "symbol": "OCSI",
   "name": "Oaktree Strategic Income Corporation",
   "last_sale": "8.61",
   "market_cap": "$253.71M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ocsi",
   "FIELD9": ""
 },
 {
   "symbol": "OASM",
   "name": "Oasmia Pharmaceutical AB",
   "last_sale": "3.424",
   "market_cap": "$204.65M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/oasm",
   "FIELD9": ""
 },
 {
   "symbol": "OBLN",
   "name": "Obalon Therapeutics, Inc.",
   "last_sale": "2.59",
   "market_cap": "$60.37M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/obln",
   "FIELD9": ""
 },
 {
   "symbol": "OBSV",
   "name": "ObsEva SA",
   "last_sale": "18.18",
   "market_cap": "$779.4M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/obsv",
   "FIELD9": ""
 },
 {
   "symbol": "OBCI",
   "name": "Ocean Bio-Chem, Inc.",
   "last_sale": "4.3",
   "market_cap": "$39.81M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/obci",
   "FIELD9": ""
 },
 {
   "symbol": "OPTT",
   "name": "Ocean Power Technologies, Inc.",
   "last_sale": "0.6602",
   "market_cap": "$12.41M",
   "IPOyear": "2007",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/optt",
   "FIELD9": ""
 },
 {
   "symbol": "ORIG",
   "name": "Ocean Rig UDW Inc.",
   "last_sale": "33.82",
   "market_cap": "$3.1B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/orig",
   "FIELD9": ""
 },
 {
   "symbol": "OCFC",
   "name": "OceanFirst Financial Corp.",
   "last_sale": "28.31",
   "market_cap": "$1.37B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/ocfc",
   "FIELD9": ""
 },
 {
   "symbol": "OCLR",
   "name": "Oclaro, Inc.",
   "last_sale": "9.16",
   "market_cap": "$1.56B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/oclr",
   "FIELD9": ""
 },
 {
   "symbol": "OFED",
   "name": "Oconee Federal Financial Corp.",
   "last_sale": "26.53",
   "market_cap": "$153.2M",
   "IPOyear": "2011",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/ofed",
   "FIELD9": ""
 },
 {
   "symbol": "OCUL",
   "name": "Ocular Therapeutix, Inc.",
   "last_sale": "6.4475",
   "market_cap": "$248.82M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ocul",
   "FIELD9": ""
 },
 {
   "symbol": "ODT",
   "name": "Odonate Therapeutics, Inc.",
   "last_sale": "21.22",
   "market_cap": "$570.64M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/odt",
   "FIELD9": ""
 },
 {
   "symbol": "OMEX",
   "name": "Odyssey Marine Exploration, Inc.",
   "last_sale": "7.86",
   "market_cap": "$66.55M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/omex",
   "FIELD9": ""
 },
 {
   "symbol": "ODP",
   "name": "Office Depot, Inc.",
   "last_sale": "3.31",
   "market_cap": "$1.84B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/odp",
   "FIELD9": ""
 },
 {
   "symbol": "OFS",
   "name": "OFS Capital Corporation",
   "last_sale": "11.99",
   "market_cap": "$160.07M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ofs",
   "FIELD9": ""
 },
 {
   "symbol": "OFSSL",
   "name": "OFS Capital Corporation",
   "last_sale": "25.2752",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ofssl",
   "FIELD9": ""
 },
 {
   "symbol": "OHAI",
   "name": "OHA Investment Corporation",
   "last_sale": "1.57",
   "market_cap": "$31.67M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ohai",
   "FIELD9": ""
 },
 {
   "symbol": "OVBC",
   "name": "Ohio Valley Banc Corp.",
   "last_sale": "38.05",
   "market_cap": "$179.88M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ovbc",
   "FIELD9": ""
 },
 {
   "symbol": "OHRP",
   "name": "Ohr Pharmaceutical, Inc.",
   "last_sale": "0.19",
   "market_cap": "$10.73M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ohrp",
   "FIELD9": ""
 },
 {
   "symbol": "OKTA",
   "name": "Okta, Inc.",
   "last_sale": "68.5",
   "market_cap": "$7.48B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/okta",
   "FIELD9": ""
 },
 {
   "symbol": "ODFL",
   "name": "Old Dominion Freight Line, Inc.",
   "last_sale": "156.77",
   "market_cap": "$12.85B",
   "IPOyear": "1991",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/odfl",
   "FIELD9": ""
 },
 {
   "symbol": "OLBK",
   "name": "Old Line Bancshares, Inc.",
   "last_sale": "33.18",
   "market_cap": "$563.69M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/olbk",
   "FIELD9": ""
 },
 {
   "symbol": "ONB",
   "name": "Old National Bancorp",
   "last_sale": "20.2",
   "market_cap": "$3.08B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/onb",
   "FIELD9": ""
 },
 {
   "symbol": "OPOF",
   "name": "Old Point Financial Corporation",
   "last_sale": "27.65",
   "market_cap": "$143.26M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/opof",
   "FIELD9": ""
 },
 {
   "symbol": "OSBC",
   "name": "Old Second Bancorp, Inc.",
   "last_sale": "15.45",
   "market_cap": "$459.59M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/osbc",
   "FIELD9": ""
 },
 {
   "symbol": "OSBCP",
   "name": "Old Second Bancorp, Inc.",
   "last_sale": "10.6463",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/osbcp",
   "FIELD9": ""
 },
 {
   "symbol": "OLLI",
   "name": "Ollie&#39;s Bargain Outlet Holdings, Inc.",
   "last_sale": "92.8",
   "market_cap": "$5.82B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/olli",
   "FIELD9": ""
 },
 {
   "symbol": "ZEUS",
   "name": "Olympic Steel, Inc.",
   "last_sale": "21.06",
   "market_cap": "$231.84M",
   "IPOyear": "1994",
   "sector": "Basic Industries",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/zeus",
   "FIELD9": ""
 },
 {
   "symbol": "OFLX",
   "name": "Omega Flex, Inc.",
   "last_sale": "74.45",
   "market_cap": "$751.34M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/oflx",
   "FIELD9": ""
 },
 {
   "symbol": "OMER",
   "name": "Omeros Corporation",
   "last_sale": "25.02",
   "market_cap": "$1.21B",
   "IPOyear": "2009",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/omer",
   "FIELD9": ""
 },
 {
   "symbol": "OMCL",
   "name": "Omnicell, Inc.",
   "last_sale": "70",
   "market_cap": "$2.75B",
   "IPOyear": "2001",
   "sector": "Technology",
   "industry": "Computer Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/omcl",
   "FIELD9": ""
 },
 {
   "symbol": "ON",
   "name": "ON Semiconductor Corporation",
   "last_sale": "19.15",
   "market_cap": "$8.16B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/on",
   "FIELD9": ""
 },
 {
   "symbol": "OTIV",
   "name": "On Track Innovations Ltd",
   "last_sale": "0.97",
   "market_cap": "$40.06M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/otiv",
   "FIELD9": ""
 },
 {
   "symbol": "ONS",
   "name": "Oncobiologics, Inc.",
   "last_sale": "0.95",
   "market_cap": "$68.59M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/ons",
   "FIELD9": ""
 },
 {
   "symbol": "ONSIW",
   "name": "Oncobiologics, Inc.",
   "last_sale": "0.0138",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/onsiw",
   "FIELD9": ""
 },
 {
   "symbol": "ONCY",
   "name": "Oncolytics Biotech Inc.",
   "last_sale": "4.16",
   "market_cap": "$68.77M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/oncy",
   "FIELD9": ""
 },
 {
   "symbol": "OMED",
   "name": "OncoMed Pharmaceuticals, Inc.",
   "last_sale": "2.32",
   "market_cap": "$89.32M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/omed",
   "FIELD9": ""
 },
 {
   "symbol": "ONTX",
   "name": "Onconova Therapeutics, Inc.",
   "last_sale": "0.5183",
   "market_cap": "$44.11M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ontx",
   "FIELD9": ""
 },
 {
   "symbol": "ONTXW",
   "name": "Onconova Therapeutics, Inc.",
   "last_sale": "0.1859",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ontxw",
   "FIELD9": ""
 },
 {
   "symbol": "ONCS",
   "name": "OncoSec Medical Incorporated",
   "last_sale": "1.41",
   "market_cap": "$73.81M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/oncs",
   "FIELD9": ""
 },
 {
   "symbol": "OHGI",
   "name": "One Horizon Group, Inc.",
   "last_sale": "0.1831",
   "market_cap": "$10.75M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ohgi",
   "FIELD9": ""
 },
 {
   "symbol": "OSS",
   "name": "One Stop Systems, Inc.",
   "last_sale": "4.02",
   "market_cap": "$51.37M",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/oss",
   "FIELD9": ""
 },
 {
   "symbol": "OSPN",
   "name": "OneSpan Inc.",
   "last_sale": "18.275",
   "market_cap": "$735.12M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ospn",
   "FIELD9": ""
 },
 {
   "symbol": "OPBK",
   "name": "OP Bancorp",
   "last_sale": "11.72",
   "market_cap": "$184.69M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/opbk",
   "FIELD9": ""
 },
 {
   "symbol": "OTEX",
   "name": "Open Text Corporation",
   "last_sale": "38.17",
   "market_cap": "$10.22B",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/otex",
   "FIELD9": ""
 },
 {
   "symbol": "OPRA",
   "name": "Opera Limited",
   "last_sale": "9.66",
   "market_cap": "$1.06B",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/opra",
   "FIELD9": ""
 },
 {
   "symbol": "OPES",
   "name": "Opes Acquisition Corp.",
   "last_sale": "9.8",
   "market_cap": "$36.9M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/opes",
   "FIELD9": ""
 },
 {
   "symbol": "OPESU",
   "name": "Opes Acquisition Corp.",
   "last_sale": "10.16",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/opesu",
   "FIELD9": ""
 },
 {
   "symbol": "OPESW",
   "name": "Opes Acquisition Corp.",
   "last_sale": "0.3981",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/opesw",
   "FIELD9": ""
 },
 {
   "symbol": "OPGN",
   "name": "OpGen, Inc.",
   "last_sale": "2.16",
   "market_cap": "$13.42M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/opgn",
   "FIELD9": ""
 },
 {
   "symbol": "OPGNW",
   "name": "OpGen, Inc.",
   "last_sale": "0.3",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/opgnw",
   "FIELD9": ""
 },
 {
   "symbol": "OPHT",
   "name": "Ophthotech Corporation",
   "last_sale": "2.38",
   "market_cap": "$86.15M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/opht",
   "FIELD9": ""
 },
 {
   "symbol": "OPNT",
   "name": "Opiant Pharmaceuticals, Inc.",
   "last_sale": "21.84",
   "market_cap": "$61.65M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/opnt",
   "FIELD9": ""
 },
 {
   "symbol": "OPK",
   "name": "Opko Health, Inc.",
   "last_sale": "4.3",
   "market_cap": "$2.41B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/opk",
   "FIELD9": ""
 },
 {
   "symbol": "OBAS",
   "name": "Optibase Ltd.",
   "last_sale": "8.8501",
   "market_cap": "$46.15M",
   "IPOyear": "1999",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/obas",
   "FIELD9": ""
 },
 {
   "symbol": "OCC",
   "name": "Optical Cable Corporation",
   "last_sale": "4.45",
   "market_cap": "$34.24M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/occ",
   "FIELD9": ""
 },
 {
   "symbol": "OPRX",
   "name": "OptimizeRx Corporation",
   "last_sale": "17.2",
   "market_cap": "$200.17M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/oprx",
   "FIELD9": ""
 },
 {
   "symbol": "OPHC",
   "name": "OptimumBank Holdings, Inc.",
   "last_sale": "5.17",
   "market_cap": "$7.8M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ophc",
   "FIELD9": ""
 },
 {
   "symbol": "OPTN",
   "name": "OptiNose, Inc.",
   "last_sale": "13.58",
   "market_cap": "$559.78M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/optn",
   "FIELD9": ""
 },
 {
   "symbol": "OPB",
   "name": "Opus Bank",
   "last_sale": "28.9",
   "market_cap": "$1.04B",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/opb",
   "FIELD9": ""
 },
 {
   "symbol": "ORMP",
   "name": "Oramed Pharmaceuticals Inc.",
   "last_sale": "4.89",
   "market_cap": "$84.9M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ormp",
   "FIELD9": ""
 },
 {
   "symbol": "OSUR",
   "name": "OraSure Technologies, Inc.",
   "last_sale": "15.33",
   "market_cap": "$937.79M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/osur",
   "FIELD9": ""
 },
 {
   "symbol": "ORBC",
   "name": "ORBCOMM Inc.",
   "last_sale": "10.99",
   "market_cap": "$863.58M",
   "IPOyear": "2006",
   "sector": "Consumer Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/orbc",
   "FIELD9": ""
 },
 {
   "symbol": "ORBK",
   "name": "Orbotech Ltd.",
   "last_sale": "61.09",
   "market_cap": "$2.97B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/orbk",
   "FIELD9": ""
 },
 {
   "symbol": "ORLY",
   "name": "O&#39;Reilly Automotive, Inc.",
   "last_sale": "344.51",
   "market_cap": "$27.75B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/orly",
   "FIELD9": ""
 },
 {
   "symbol": "ONVO",
   "name": "Organovo Holdings, Inc.",
   "last_sale": "1.16",
   "market_cap": "$131.6M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/onvo",
   "FIELD9": ""
 },
 {
   "symbol": "ORGS",
   "name": "Orgenesis Inc.",
   "last_sale": "5.44",
   "market_cap": "$79.26M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/orgs",
   "FIELD9": ""
 },
 {
   "symbol": "SEED",
   "name": "Origin Agritech Limited",
   "last_sale": "5.07",
   "market_cap": "$1.18M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/seed",
   "FIELD9": ""
 },
 {
   "symbol": "OBNK",
   "name": "Origin Bancorp, Inc.",
   "last_sale": "38.75",
   "market_cap": "$913.53M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/obnk",
   "FIELD9": ""
 },
 {
   "symbol": "OESX",
   "name": "Orion Energy Systems, Inc.",
   "last_sale": "0.9764",
   "market_cap": "$28.73M",
   "IPOyear": "2015",
   "sector": "Consumer Durables",
   "industry": "Building Products",
   "summary_quote": "https://www.nasdaq.com/symbol/oesx",
   "FIELD9": ""
 },
 {
   "symbol": "ORIT",
   "name": "Oritani Financial Corp.",
   "last_sale": "15.95",
   "market_cap": "$743.62M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/orit",
   "FIELD9": ""
 },
 {
   "symbol": "ORRF",
   "name": "Orrstown Financial Services Inc",
   "last_sale": "24.3",
   "market_cap": "$204.14M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/orrf",
   "FIELD9": ""
 },
 {
   "symbol": "OFIX",
   "name": "Orthofix Medical Inc. ",
   "last_sale": "54.18",
   "market_cap": "$1.02B",
   "IPOyear": "1992",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/ofix",
   "FIELD9": ""
 },
 {
   "symbol": "KIDS",
   "name": "OrthoPediatrics Corp.",
   "last_sale": "32.65",
   "market_cap": "$417.6M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/kids",
   "FIELD9": ""
 },
 {
   "symbol": "OSIS",
   "name": "OSI Systems, Inc.",
   "last_sale": "78.32",
   "market_cap": "$1.42B",
   "IPOyear": "1997",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/osis",
   "FIELD9": ""
 },
 {
   "symbol": "OSIR",
   "name": "Osiris Therapeutics, Inc.",
   "last_sale": "11.11",
   "market_cap": "$383.58M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/osir",
   "FIELD9": ""
 },
 {
   "symbol": "OSN",
   "name": "Ossen Innovation Co., Ltd.",
   "last_sale": "2.2",
   "market_cap": "$7.26M",
   "IPOyear": "2010",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/osn",
   "FIELD9": ""
 },
 {
   "symbol": "OTEL",
   "name": "Otelco Inc.",
   "last_sale": "16.8",
   "market_cap": "$56.93M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/otel",
   "FIELD9": ""
 },
 {
   "symbol": "OTG",
   "name": "OTG EXP, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/otg",
   "FIELD9": ""
 },
 {
   "symbol": "OTIC",
   "name": "Otonomy, Inc.",
   "last_sale": "2.7",
   "market_cap": "$82.7M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/otic",
   "FIELD9": ""
 },
 {
   "symbol": "OTTW",
   "name": "Ottawa Bancorp, Inc.",
   "last_sale": "13.95",
   "market_cap": "$47.37M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/ottw",
   "FIELD9": ""
 },
 {
   "symbol": "OTTR",
   "name": "Otter Tail Corporation",
   "last_sale": "48.15",
   "market_cap": "$1.91B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/ottr",
   "FIELD9": ""
 },
 {
   "symbol": "OVAS",
   "name": "OvaScience Inc.",
   "last_sale": "0.75",
   "market_cap": "$26.84M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ovas",
   "FIELD9": ""
 },
 {
   "symbol": "OSTK",
   "name": "Overstock.com, Inc.",
   "last_sale": "27.1",
   "market_cap": "$786.17M",
   "IPOyear": "2002",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/ostk",
   "FIELD9": ""
 },
 {
   "symbol": "OVID",
   "name": "Ovid Therapeutics Inc.",
   "last_sale": "5.6",
   "market_cap": "$137.94M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ovid",
   "FIELD9": ""
 },
 {
   "symbol": "OXBR",
   "name": "Oxbridge Re Holdings Limited",
   "last_sale": "1.9",
   "market_cap": "$10.89M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/oxbr",
   "FIELD9": ""
 },
 {
   "symbol": "OXBRW",
   "name": "Oxbridge Re Holdings Limited",
   "last_sale": "0.0741",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/oxbrw",
   "FIELD9": ""
 },
 {
   "symbol": "OXFD",
   "name": "Oxford Immunotec Global PLC",
   "last_sale": "15.99",
   "market_cap": "$415.22M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/oxfd",
   "FIELD9": ""
 },
 {
   "symbol": "OXLC",
   "name": "Oxford Lane Capital Corp.",
   "last_sale": "10.69",
   "market_cap": "$345.12M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/oxlc",
   "FIELD9": ""
 },
 {
   "symbol": "OXLCM",
   "name": "Oxford Lane Capital Corp.",
   "last_sale": "25.56",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/oxlcm",
   "FIELD9": ""
 },
 {
   "symbol": "OXLCO",
   "name": "Oxford Lane Capital Corp.",
   "last_sale": "25.42",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/oxlco",
   "FIELD9": ""
 },
 {
   "symbol": "OXSQ",
   "name": "Oxford Square Capital Corp.",
   "last_sale": "7.11",
   "market_cap": "$350.2M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/oxsq",
   "FIELD9": ""
 },
 {
   "symbol": "OXSQL",
   "name": "Oxford Square Capital Corp.",
   "last_sale": "25.35",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/oxsql",
   "FIELD9": ""
 },
 {
   "symbol": "PFIN",
   "name": "P & F Industries, Inc.",
   "last_sale": "8.25",
   "market_cap": "$30.53M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/pfin",
   "FIELD9": ""
 },
 {
   "symbol": "PTSI",
   "name": "P.A.M. Transportation Services, Inc.",
   "last_sale": "62.75",
   "market_cap": "$379.9M",
   "IPOyear": "1986",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ptsi",
   "FIELD9": ""
 },
 {
   "symbol": "PCAR",
   "name": "PACCAR Inc.",
   "last_sale": "72.19",
   "market_cap": "$25.31B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/pcar",
   "FIELD9": ""
 },
 {
   "symbol": "VETS",
   "name": "Pacer Military Times Best Employers ETF",
   "last_sale": "28.04",
   "market_cap": "$2.8M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vets",
   "FIELD9": ""
 },
 {
   "symbol": "PACB",
   "name": "Pacific Biosciences of California, Inc.",
   "last_sale": "4.8",
   "market_cap": "$633.32M",
   "IPOyear": "2010",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/pacb",
   "FIELD9": ""
 },
 {
   "symbol": "PCB",
   "name": "Pacific City Financial Corporation",
   "last_sale": "19.93",
   "market_cap": "$315.32M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pcb",
   "FIELD9": ""
 },
 {
   "symbol": "PEIX",
   "name": "Pacific Ethanol, Inc.",
   "last_sale": "1.875",
   "market_cap": "$84.29M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/peix",
   "FIELD9": ""
 },
 {
   "symbol": "PMBC",
   "name": "Pacific Mercantile Bancorp",
   "last_sale": "9.25",
   "market_cap": "$216.25M",
   "IPOyear": "2000",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pmbc",
   "FIELD9": ""
 },
 {
   "symbol": "PPBI",
   "name": "Pacific Premier Bancorp Inc",
   "last_sale": "38.5",
   "market_cap": "$2.4B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ppbi",
   "FIELD9": ""
 },
 {
   "symbol": "PCRX",
   "name": "Pacira Pharmaceuticals, Inc.",
   "last_sale": "50.45",
   "market_cap": "$2.07B",
   "IPOyear": "2011",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/pcrx",
   "FIELD9": ""
 },
 {
   "symbol": "PACW",
   "name": "PacWest Bancorp",
   "last_sale": "50.74",
   "market_cap": "$6.29B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pacw",
   "FIELD9": ""
 },
 {
   "symbol": "PTIE",
   "name": "Pain Therapeutics, Inc.",
   "last_sale": "0.955",
   "market_cap": "$16.35M",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ptie",
   "FIELD9": ""
 },
 {
   "symbol": "PAAS",
   "name": "Pan American Silver Corp.",
   "last_sale": "14.9",
   "market_cap": "$2.28B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/paas",
   "FIELD9": ""
 },
 {
   "symbol": "PANL",
   "name": "Pangaea Logistics Solutions Ltd.",
   "last_sale": "3.75",
   "market_cap": "$165.24M",
   "IPOyear": "1996",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/panl",
   "FIELD9": ""
 },
 {
   "symbol": "PZZA",
   "name": "Papa John&#39;s International, Inc.",
   "last_sale": "46.23",
   "market_cap": "$1.46B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/pzza",
   "FIELD9": ""
 },
 {
   "symbol": "FRSH",
   "name": "Papa Murphy&#39;s Holdings, Inc.",
   "last_sale": "5.4",
   "market_cap": "$91.98M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/frsh",
   "FIELD9": ""
 },
 {
   "symbol": "PRTK",
   "name": "Paratek Pharmaceuticals, Inc. ",
   "last_sale": "9.65",
   "market_cap": "$306.19M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/prtk",
   "FIELD9": ""
 },
 {
   "symbol": "PCYG",
   "name": "Park City Group, Inc.",
   "last_sale": "9.6",
   "market_cap": "$190.01M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pcyg",
   "FIELD9": ""
 },
 {
   "symbol": "PKBK",
   "name": "Parke Bancorp, Inc.",
   "last_sale": "23",
   "market_cap": "$224.81M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pkbk",
   "FIELD9": ""
 },
 {
   "symbol": "PKOH",
   "name": "Park-Ohio Holdings Corp.",
   "last_sale": "38.95",
   "market_cap": "$499.62M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/pkoh",
   "FIELD9": ""
 },
 {
   "symbol": "PTNR",
   "name": "Partner Communications Company Ltd.",
   "last_sale": "5.05",
   "market_cap": "$838.67M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ptnr",
   "FIELD9": ""
 },
 {
   "symbol": "PBHC",
   "name": "Pathfinder Bancorp, Inc.",
   "last_sale": "15.09",
   "market_cap": "$65.6M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pbhc",
   "FIELD9": ""
 },
 {
   "symbol": "PATK",
   "name": "Patrick Industries, Inc.",
   "last_sale": "61.5",
   "market_cap": "$1.51B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Forest Products",
   "summary_quote": "https://www.nasdaq.com/symbol/patk",
   "FIELD9": ""
 },
 {
   "symbol": "PNBK",
   "name": "Patriot National Bancorp Inc.",
   "last_sale": "24.25",
   "market_cap": "$94.69M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pnbk",
   "FIELD9": ""
 },
 {
   "symbol": "PATI",
   "name": "Patriot Transportation Holding, Inc.",
   "last_sale": "20",
   "market_cap": "$66.57M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pati",
   "FIELD9": ""
 },
 {
   "symbol": "PEGI",
   "name": "Pattern Energy Group Inc.",
   "last_sale": "20.58",
   "market_cap": "$2.02B",
   "IPOyear": "2013",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/pegi",
   "FIELD9": ""
 },
 {
   "symbol": "PDCO",
   "name": "Patterson Companies, Inc.",
   "last_sale": "25.67",
   "market_cap": "$2.43B",
   "IPOyear": "1992",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/pdco",
   "FIELD9": ""
 },
 {
   "symbol": "PTEN",
   "name": "Patterson-UTI Energy, Inc.",
   "last_sale": "17.88",
   "market_cap": "$3.93B",
   "IPOyear": "1993",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pten",
   "FIELD9": ""
 },
 {
   "symbol": "PAVM",
   "name": "PAVmed Inc.",
   "last_sale": "1.31",
   "market_cap": "$34.77M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/pavm",
   "FIELD9": ""
 },
 {
   "symbol": "PAVMW",
   "name": "PAVmed Inc.",
   "last_sale": "0.2258",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/pavmw",
   "FIELD9": ""
 },
 {
   "symbol": "PAVMZ",
   "name": "PAVmed Inc.",
   "last_sale": "0.45",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/pavmz",
   "FIELD9": ""
 },
 {
   "symbol": "PAYX",
   "name": "Paychex, Inc.",
   "last_sale": "75.25",
   "market_cap": "$27.07B",
   "IPOyear": "1983",
   "sector": "Consumer Services",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/payx",
   "FIELD9": ""
 },
 {
   "symbol": "PCTY",
   "name": "Paylocity Holding Corporation",
   "last_sale": "81.52",
   "market_cap": "$4.3B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/pcty",
   "FIELD9": ""
 },
 {
   "symbol": "PYDS",
   "name": "Payment Data Systems, Inc.",
   "last_sale": "1.83",
   "market_cap": "$29.28M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/pyds",
   "FIELD9": ""
 },
 {
   "symbol": "PYPL",
   "name": "PayPal Holdings, Inc.",
   "last_sale": "90.71",
   "market_cap": "$107.37B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pypl",
   "FIELD9": ""
 },
 {
   "symbol": "PBBI",
   "name": "PB Bancorp, Inc.",
   "last_sale": "12",
   "market_cap": "$91.7M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/pbbi",
   "FIELD9": ""
 },
 {
   "symbol": "CNXN",
   "name": "PC Connection, Inc.",
   "last_sale": "39.67",
   "market_cap": "$1.06B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/cnxn",
   "FIELD9": ""
 },
 {
   "symbol": "PCMI",
   "name": "PCM, Inc.",
   "last_sale": "19.5",
   "market_cap": "$232.92M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/pcmi",
   "FIELD9": ""
 },
 {
   "symbol": "PCSB",
   "name": "PCSB Financial Corporation",
   "last_sale": "20.55",
   "market_cap": "$373.29M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pcsb",
   "FIELD9": ""
 },
 {
   "symbol": "PCTI",
   "name": "PC-Tel, Inc.",
   "last_sale": "4.44",
   "market_cap": "$81.32M",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/pcti",
   "FIELD9": ""
 },
 {
   "symbol": "PDCE",
   "name": "PDC Energy, Inc.",
   "last_sale": "48.86",
   "market_cap": "$3.23B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pdce",
   "FIELD9": ""
 },
 {
   "symbol": "PDFS",
   "name": "PDF Solutions, Inc.",
   "last_sale": "9.12",
   "market_cap": "$293.12M",
   "IPOyear": "2001",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pdfs",
   "FIELD9": ""
 },
 {
   "symbol": "PDLI",
   "name": "PDL BioPharma, Inc.",
   "last_sale": "2.41",
   "market_cap": "$350.41M",
   "IPOyear": "1992",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/pdli",
   "FIELD9": ""
 },
 {
   "symbol": "PDLB",
   "name": "PDL Community Bancorp",
   "last_sale": "14.98",
   "market_cap": "$276.58M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/pdlb",
   "FIELD9": ""
 },
 {
   "symbol": "PDVW",
   "name": "pdvWireless, Inc.",
   "last_sale": "31.55",
   "market_cap": "$457.78M",
   "IPOyear": "2015",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/pdvw",
   "FIELD9": ""
 },
 {
   "symbol": "SKIS",
   "name": "Peak Resorts, Inc.",
   "last_sale": "5.2",
   "market_cap": "$72.71M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/skis",
   "FIELD9": ""
 },
 {
   "symbol": "PGC",
   "name": "Peapack-Gladstone Financial Corporation",
   "last_sale": "32.29",
   "market_cap": "$613.87M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pgc",
   "FIELD9": ""
 },
 {
   "symbol": "PEGA",
   "name": "Pegasystems Inc.",
   "last_sale": "63.15",
   "market_cap": "$4.97B",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pega",
   "FIELD9": ""
 },
 {
   "symbol": "PENN",
   "name": "Penn National Gaming, Inc.",
   "last_sale": "32.41",
   "market_cap": "$2.99B",
   "IPOyear": "1994",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/penn",
   "FIELD9": ""
 },
 {
   "symbol": "PVAC",
   "name": "Penn Virginia Corporation",
   "last_sale": "77",
   "market_cap": "$1.16B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pvac",
   "FIELD9": ""
 },
 {
   "symbol": "PFLT",
   "name": "PennantPark Floating Rate Capital Ltd.",
   "last_sale": "13.38",
   "market_cap": "$518.77M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pflt",
   "FIELD9": ""
 },
 {
   "symbol": "PNNT",
   "name": "PennantPark Investment Corporation",
   "last_sale": "7.59",
   "market_cap": "$531.21M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pnnt",
   "FIELD9": ""
 },
 {
   "symbol": "PWOD",
   "name": "Penns Woods Bancorp, Inc.",
   "last_sale": "44.16",
   "market_cap": "$207.14M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pwod",
   "FIELD9": ""
 },
 {
   "symbol": "WRLS",
   "name": "Pensare Acquisition Corp.",
   "last_sale": "9.96",
   "market_cap": "$85.16M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wrls",
   "FIELD9": ""
 },
 {
   "symbol": "WRLSR",
   "name": "Pensare Acquisition Corp.",
   "last_sale": "0.45",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wrlsr",
   "FIELD9": ""
 },
 {
   "symbol": "WRLSU",
   "name": "Pensare Acquisition Corp.",
   "last_sale": "10.58",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wrlsu",
   "FIELD9": ""
 },
 {
   "symbol": "WRLSW",
   "name": "Pensare Acquisition Corp.",
   "last_sale": "0.6",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wrlsw",
   "FIELD9": ""
 },
 {
   "symbol": "PEBO",
   "name": "Peoples Bancorp Inc.",
   "last_sale": "36.89",
   "market_cap": "$720.67M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pebo",
   "FIELD9": ""
 },
 {
   "symbol": "PEBK",
   "name": "Peoples Bancorp of North Carolina, Inc.",
   "last_sale": "29",
   "market_cap": "$173.86M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pebk",
   "FIELD9": ""
 },
 {
   "symbol": "PFIS",
   "name": "Peoples Financial Services Corp. ",
   "last_sale": "45.04",
   "market_cap": "$333.25M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pfis",
   "FIELD9": ""
 },
 {
   "symbol": "PBCT",
   "name": "People&#39;s United Financial, Inc.",
   "last_sale": "17.94",
   "market_cap": "$6.26B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/pbct",
   "FIELD9": ""
 },
 {
   "symbol": "PBCTP",
   "name": "People&#39;s United Financial, Inc.",
   "last_sale": "25.75",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/pbctp",
   "FIELD9": ""
 },
 {
   "symbol": "PUB",
   "name": "People&#39;s Utah Bancorp",
   "last_sale": "35.95",
   "market_cap": "$672.47M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pub",
   "FIELD9": ""
 },
 {
   "symbol": "PEP",
   "name": "Pepsico, Inc.",
   "last_sale": "114.88",
   "market_cap": "$162.48B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/pep",
   "FIELD9": ""
 },
 {
   "symbol": "PRCP",
   "name": "Perceptron, Inc.",
   "last_sale": "9.79",
   "market_cap": "$93.55M",
   "IPOyear": "1992",
   "sector": "Capital Goods",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/prcp",
   "FIELD9": ""
 },
 {
   "symbol": "PRFT",
   "name": "Perficient, Inc.",
   "last_sale": "28.09",
   "market_cap": "$941.29M",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/prft",
   "FIELD9": ""
 },
 {
   "symbol": "PFMT",
   "name": "Performant Financial Corporation",
   "last_sale": "1.75",
   "market_cap": "$90.9M",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pfmt",
   "FIELD9": ""
 },
 {
   "symbol": "PERI",
   "name": "Perion Network Ltd",
   "last_sale": "3.16",
   "market_cap": "$27.23M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/peri",
   "FIELD9": ""
 },
 {
   "symbol": "PESI",
   "name": "Perma-Fix Environmental Services, Inc.",
   "last_sale": "4.461",
   "market_cap": "$53.18M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pesi",
   "FIELD9": ""
 },
 {
   "symbol": "PPIH",
   "name": "Perma-Pipe International Holdings, Inc.",
   "last_sale": "9.2",
   "market_cap": "$72.46M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Pollution Control Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ppih",
   "FIELD9": ""
 },
 {
   "symbol": "PTX",
   "name": "Pernix Therapeutics Holdings, Inc.",
   "last_sale": "0.8",
   "market_cap": "$11.14M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ptx",
   "FIELD9": ""
 },
 {
   "symbol": "PERY",
   "name": "Perry Ellis International Inc.",
   "last_sale": "27.31",
   "market_cap": "$433.8M",
   "IPOyear": "1993",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/pery",
   "FIELD9": ""
 },
 {
   "symbol": "PGLC",
   "name": "Pershing Gold Corporation",
   "last_sale": "1.08",
   "market_cap": "$36.24M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/pglc",
   "FIELD9": ""
 },
 {
   "symbol": "PETQ",
   "name": "PetIQ, Inc.",
   "last_sale": "41.64",
   "market_cap": "$1.07B",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Other Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/petq",
   "FIELD9": ""
 },
 {
   "symbol": "PETS",
   "name": "PetMed Express, Inc.",
   "last_sale": "36.13",
   "market_cap": "$747.37M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pets",
   "FIELD9": ""
 },
 {
   "symbol": "PFSW",
   "name": "PFSweb, Inc.",
   "last_sale": "7.86",
   "market_cap": "$151.37M",
   "IPOyear": "1999",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pfsw",
   "FIELD9": ""
 },
 {
   "symbol": "PGTI",
   "name": "PGT Innovations, Inc.",
   "last_sale": "21.65",
   "market_cap": "$1.25B",
   "IPOyear": "2006",
   "sector": "Capital Goods",
   "industry": "Building Products",
   "summary_quote": "https://www.nasdaq.com/symbol/pgti",
   "FIELD9": ""
 },
 {
   "symbol": "PHII",
   "name": "PHI, Inc.",
   "last_sale": "8.87",
   "market_cap": "$140.25M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/phii",
   "FIELD9": ""
 },
 {
   "symbol": "PHIIK",
   "name": "PHI, Inc.",
   "last_sale": "9.18",
   "market_cap": "$145.15M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/phiik",
   "FIELD9": ""
 },
 {
   "symbol": "PAHC",
   "name": "Phibro Animal Health Corporation",
   "last_sale": "42.3",
   "market_cap": "$1.71B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/pahc",
   "FIELD9": ""
 },
 {
   "symbol": "PLAB",
   "name": "Photronics, Inc.",
   "last_sale": "9.9",
   "market_cap": "$677.04M",
   "IPOyear": "1987",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/plab",
   "FIELD9": ""
 },
 {
   "symbol": "PICO",
   "name": "PICO Holdings Inc.",
   "last_sale": "12.55",
   "market_cap": "$274.94M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/pico",
   "FIELD9": ""
 },
 {
   "symbol": "PLLL",
   "name": "Piedmont Lithium Limited",
   "last_sale": "10.7",
   "market_cap": "$59.84M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/plll",
   "FIELD9": ""
 },
 {
   "symbol": "PIRS",
   "name": "Pieris Pharmaceuticals, Inc.",
   "last_sale": "5.33",
   "market_cap": "$288M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/pirs",
   "FIELD9": ""
 },
 {
   "symbol": "PPC",
   "name": "Pilgrim&#39;s Pride Corporation",
   "last_sale": "18.61",
   "market_cap": "$4.63B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Meat/Poultry/Fish",
   "summary_quote": "https://www.nasdaq.com/symbol/ppc",
   "FIELD9": ""
 },
 {
   "symbol": "PDD",
   "name": "Pinduoduo Inc.",
   "last_sale": "25.6",
   "market_cap": "$28.36B",
   "IPOyear": "2018",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pdd",
   "FIELD9": ""
 },
 {
   "symbol": "PME",
   "name": "Pingtan Marine Enterprise Ltd.",
   "last_sale": "2.29",
   "market_cap": "$181.04M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pme",
   "FIELD9": ""
 },
 {
   "symbol": "PNK",
   "name": "Pinnacle Entertainment, Inc.",
   "last_sale": "33.41",
   "market_cap": "$1.97B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/pnk",
   "FIELD9": ""
 },
 {
   "symbol": "PNFP",
   "name": "Pinnacle Financial Partners, Inc.",
   "last_sale": "64.05",
   "market_cap": "$4.99B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pnfp",
   "FIELD9": ""
 },
 {
   "symbol": "PPSI",
   "name": "Pioneer Power Solutions, Inc.",
   "last_sale": "5.2",
   "market_cap": "$45.38M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/ppsi",
   "FIELD9": ""
 },
 {
   "symbol": "PXLW",
   "name": "Pixelworks, Inc.",
   "last_sale": "4.92",
   "market_cap": "$176.7M",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/pxlw",
   "FIELD9": ""
 },
 {
   "symbol": "EAGL",
   "name": "Platinum Eagle Acquisition Corp.",
   "last_sale": "9.8",
   "market_cap": "$92.93M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/eagl",
   "FIELD9": ""
 },
 {
   "symbol": "EAGLU",
   "name": "Platinum Eagle Acquisition Corp.",
   "last_sale": "10.29",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/eaglu",
   "FIELD9": ""
 },
 {
   "symbol": "EAGLW",
   "name": "Platinum Eagle Acquisition Corp.",
   "last_sale": "1.35",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/eaglw",
   "FIELD9": ""
 },
 {
   "symbol": "PLYA",
   "name": "Playa Hotels & Resorts N.V.",
   "last_sale": "9.64",
   "market_cap": "$1.26B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/plya",
   "FIELD9": ""
 },
 {
   "symbol": "PLXS",
   "name": "Plexus Corp.",
   "last_sale": "61.34",
   "market_cap": "$1.98B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/plxs",
   "FIELD9": ""
 },
 {
   "symbol": "PLUG",
   "name": "Plug Power, Inc.",
   "last_sale": "1.9",
   "market_cap": "$408.11M",
   "IPOyear": "1999",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/plug",
   "FIELD9": ""
 },
 {
   "symbol": "PLBC",
   "name": "Plumas Bancorp",
   "last_sale": "26.6",
   "market_cap": "$136.16M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/plbc",
   "FIELD9": ""
 },
 {
   "symbol": "PS",
   "name": "Pluralsight, Inc.",
   "last_sale": "33.06",
   "market_cap": "$4.47B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/ps",
   "FIELD9": ""
 },
 {
   "symbol": "PSTI",
   "name": "Pluristem Therapeutics, Inc.",
   "last_sale": "1.3065",
   "market_cap": "$148.41M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/psti",
   "FIELD9": ""
 },
 {
   "symbol": "PLXP",
   "name": "PLx Pharma Inc.",
   "last_sale": "3.725",
   "market_cap": "$32.54M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/plxp",
   "FIELD9": ""
 },
 {
   "symbol": "PBSK",
   "name": "Poage Bankshares, Inc.",
   "last_sale": "25.6",
   "market_cap": "$89.53M",
   "IPOyear": "2011",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/pbsk",
   "FIELD9": ""
 },
 {
   "symbol": "PNTR",
   "name": "Pointer Telocation Ltd.",
   "last_sale": "12.9",
   "market_cap": "$104.9M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/pntr",
   "FIELD9": ""
 },
 {
   "symbol": "PCOM",
   "name": "Points International, Ltd.",
   "last_sale": "13.05",
   "market_cap": "$185.54M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pcom",
   "FIELD9": ""
 },
 {
   "symbol": "POLA",
   "name": "Polar Power, Inc.",
   "last_sale": "5.32",
   "market_cap": "$53.96M",
   "IPOyear": "2016",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/pola",
   "FIELD9": ""
 },
 {
   "symbol": "PTE",
   "name": "PolarityTE, Inc.",
   "last_sale": "21.79",
   "market_cap": "$467.95M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pte",
   "FIELD9": ""
 },
 {
   "symbol": "POLY",
   "name": "PolyPid Ltd.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/poly",
   "FIELD9": ""
 },
 {
   "symbol": "POOL",
   "name": "Pool Corporation",
   "last_sale": "169.31",
   "market_cap": "$6.84B",
   "IPOyear": "1995",
   "sector": "Consumer Durables",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/pool",
   "FIELD9": ""
 },
 {
   "symbol": "POPE",
   "name": "Pope Resources",
   "last_sale": "72.6402",
   "market_cap": "$316.43M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pope",
   "FIELD9": ""
 },
 {
   "symbol": "BPOP",
   "name": "Popular, Inc.",
   "last_sale": "52.68",
   "market_cap": "$5.39B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bpop",
   "FIELD9": ""
 },
 {
   "symbol": "BPOPM",
   "name": "Popular, Inc.",
   "last_sale": "24.69",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bpopm",
   "FIELD9": ""
 },
 {
   "symbol": "BPOPN",
   "name": "Popular, Inc.",
   "last_sale": "25.24",
   "market_cap": "$302.88M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bpopn",
   "FIELD9": ""
 },
 {
   "symbol": "PTLA",
   "name": "Portola Pharmaceuticals, Inc.",
   "last_sale": "27.55",
   "market_cap": "$1.82B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ptla",
   "FIELD9": ""
 },
 {
   "symbol": "PBPB",
   "name": "Potbelly Corporation",
   "last_sale": "12.45",
   "market_cap": "$316.95M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/pbpb",
   "FIELD9": ""
 },
 {
   "symbol": "PCH",
   "name": "PotlatchDeltic Corporation",
   "last_sale": "46.1",
   "market_cap": "$2.89B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/pch",
   "FIELD9": ""
 },
 {
   "symbol": "POWL",
   "name": "Powell Industries, Inc.",
   "last_sale": "35.5",
   "market_cap": "$407.19M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/powl",
   "FIELD9": ""
 },
 {
   "symbol": "POWI",
   "name": "Power Integrations, Inc.",
   "last_sale": "68.15",
   "market_cap": "$2B",
   "IPOyear": "1997",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/powi",
   "FIELD9": ""
 },
 {
   "symbol": "PRAA",
   "name": "PRA Group, Inc.",
   "last_sale": "38.825",
   "market_cap": "$1.76B",
   "IPOyear": "2002",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/praa",
   "FIELD9": ""
 },
 {
   "symbol": "PRAH",
   "name": "PRA Health Sciences, Inc.",
   "last_sale": "107.78",
   "market_cap": "$6.94B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/prah",
   "FIELD9": ""
 },
 {
   "symbol": "PRAN",
   "name": "Prana Biotechnology Ltd",
   "last_sale": "2.124",
   "market_cap": "$19.01M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/pran",
   "FIELD9": ""
 },
 {
   "symbol": "PRPO",
   "name": "Precipio, Inc.",
   "last_sale": "0.42",
   "market_cap": "$9.73M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/prpo",
   "FIELD9": ""
 },
 {
   "symbol": "AIPT",
   "name": "Precision Therapeutics Inc.",
   "last_sale": "1.01",
   "market_cap": "$13.53M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/aipt",
   "FIELD9": ""
 },
 {
   "symbol": "PFBC",
   "name": "Preferred Bank",
   "last_sale": "61.38",
   "market_cap": "$940.66M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pfbc",
   "FIELD9": ""
 },
 {
   "symbol": "PLPC",
   "name": "Preformed Line Products Company",
   "last_sale": "74.96",
   "market_cap": "$377.55M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/plpc",
   "FIELD9": ""
 },
 {
   "symbol": "PFBI",
   "name": "Premier Financial Bancorp, Inc.",
   "last_sale": "19.01",
   "market_cap": "$2.16B",
   "IPOyear": "1996",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pfbi",
   "FIELD9": ""
 },
 {
   "symbol": "PINC",
   "name": "Premier, Inc.",
   "last_sale": "43.51",
   "market_cap": "$2.32B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pinc",
   "FIELD9": ""
 },
 {
   "symbol": "LENS",
   "name": "Presbia PLC",
   "last_sale": "1.6807",
   "market_cap": "$28.9M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/lens",
   "FIELD9": ""
 },
 {
   "symbol": "PSDO",
   "name": "Presidio, Inc.",
   "last_sale": "15.68",
   "market_cap": "$1.29B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Retail: Computer Software & Peripheral Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/psdo",
   "FIELD9": ""
 },
 {
   "symbol": "PBIO",
   "name": "Pressure BioSciences, Inc.",
   "last_sale": "3.75",
   "market_cap": "$4.13M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pbio",
   "FIELD9": ""
 },
 {
   "symbol": "PRGX",
   "name": "PRGX Global, Inc.",
   "last_sale": "9",
   "market_cap": "$211.64M",
   "IPOyear": "1996",
   "sector": "Consumer Services",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/prgx",
   "FIELD9": ""
 },
 {
   "symbol": "PSMT",
   "name": "PriceSmart, Inc.",
   "last_sale": "84.6",
   "market_cap": "$2.58B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/psmt",
   "FIELD9": ""
 },
 {
   "symbol": "PNRG",
   "name": "PrimeEnergy Corporation",
   "last_sale": "77.85",
   "market_cap": "$160.52M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pnrg",
   "FIELD9": ""
 },
 {
   "symbol": "PRMW",
   "name": "Primo Water Corporation",
   "last_sale": "18.45",
   "market_cap": "$695.48M",
   "IPOyear": "2010",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/prmw",
   "FIELD9": ""
 },
 {
   "symbol": "PRIM",
   "name": "Primoris Services Corporation",
   "last_sale": "25.1",
   "market_cap": "$1.29B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/prim",
   "FIELD9": ""
 },
 {
   "symbol": "PVAL",
   "name": "Principal Contrarian Value Index ETF",
   "last_sale": "27.5",
   "market_cap": "$4.13M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pval",
   "FIELD9": ""
 },
 {
   "symbol": "PFG",
   "name": "Principal Financial Group Inc",
   "last_sale": "59.54",
   "market_cap": "$16.95B",
   "IPOyear": "2001",
   "sector": "Finance",
   "industry": "Accident &Health Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/pfg",
   "FIELD9": ""
 },
 {
   "symbol": "BTEC",
   "name": "Principal Healthcare Innovators Index ETF",
   "last_sale": "36.68",
   "market_cap": "$56.85M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/btec",
   "FIELD9": ""
 },
 {
   "symbol": "PXUS",
   "name": "Principal International Multi-Factor Index ETF",
   "last_sale": "101.6811",
   "market_cap": "$15.25M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pxus",
   "FIELD9": ""
 },
 {
   "symbol": "GENY",
   "name": "Principal Millennials Index ETF",
   "last_sale": "38.44",
   "market_cap": "$21.14M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/geny",
   "FIELD9": ""
 },
 {
   "symbol": "PSET",
   "name": "Principal Price Setters Index ETF",
   "last_sale": "35.55",
   "market_cap": "$23.11M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pset",
   "FIELD9": ""
 },
 {
   "symbol": "PY",
   "name": "Principal Shareholder Yield Index ETF",
   "last_sale": "34.06",
   "market_cap": "$15.33M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/py",
   "FIELD9": ""
 },
 {
   "symbol": "PMOM",
   "name": "Principal Sustainable Momentum Index ETF",
   "last_sale": "29.8901",
   "market_cap": "$5.98M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pmom",
   "FIELD9": ""
 },
 {
   "symbol": "USMC",
   "name": "Principal U.S. Mega-Cap Multi-Factor Index ETF",
   "last_sale": "28.4683",
   "market_cap": "$1.61B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/usmc",
   "FIELD9": ""
 },
 {
   "symbol": "PSC",
   "name": "Principal U.S. Small-Cap Multi-Factor Index ETF",
   "last_sale": "35.48",
   "market_cap": "$372.54M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psc",
   "FIELD9": ""
 },
 {
   "symbol": "PRNB",
   "name": "Principia Biopharma Inc.",
   "last_sale": "26.97",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/prnb",
   "FIELD9": ""
 },
 {
   "symbol": "PRTH",
   "name": "Priority Technology Holdings, Inc.",
   "last_sale": "10.35",
   "market_cap": "$691.97M",
   "IPOyear": "2016",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/prth",
   "FIELD9": ""
 },
 {
   "symbol": "PRTHU",
   "name": "Priority Technology Holdings, Inc.",
   "last_sale": "13",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/prthu",
   "FIELD9": ""
 },
 {
   "symbol": "PRTHW",
   "name": "Priority Technology Holdings, Inc.",
   "last_sale": "1.64",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/prthw",
   "FIELD9": ""
 },
 {
   "symbol": "PDEX",
   "name": "Pro-Dex, Inc.",
   "last_sale": "12.15",
   "market_cap": "$52.75M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/pdex",
   "FIELD9": ""
 },
 {
   "symbol": "IPDN",
   "name": "Professional Diversity Network, Inc.",
   "last_sale": "3.18",
   "market_cap": "$15.4M",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/ipdn",
   "FIELD9": ""
 },
 {
   "symbol": "PFIE",
   "name": "Profire Energy, Inc.",
   "last_sale": "3.25",
   "market_cap": "$156.27M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/pfie",
   "FIELD9": ""
 },
 {
   "symbol": "PGNX",
   "name": "Progenics Pharmaceuticals Inc.",
   "last_sale": "6.41",
   "market_cap": "$541.33M",
   "IPOyear": "1997",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/pgnx",
   "FIELD9": ""
 },
 {
   "symbol": "PRGS",
   "name": "Progress Software Corporation",
   "last_sale": "42.22",
   "market_cap": "$1.9B",
   "IPOyear": "1991",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/prgs",
   "FIELD9": ""
 },
 {
   "symbol": "LUNG",
   "name": "ProLung, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lung",
   "FIELD9": ""
 },
 {
   "symbol": "PFPT",
   "name": "Proofpoint, Inc.",
   "last_sale": "104.73",
   "market_cap": "$5.37B",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pfpt",
   "FIELD9": ""
 },
 {
   "symbol": "PRPH",
   "name": "ProPhase Labs, Inc.",
   "last_sale": "3",
   "market_cap": "$34.63M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/prph",
   "FIELD9": ""
 },
 {
   "symbol": "PRQR",
   "name": "ProQR Therapeutics N.V.",
   "last_sale": "20.2",
   "market_cap": "$645.08M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/prqr",
   "FIELD9": ""
 },
 {
   "symbol": "EQRR",
   "name": "ProShares Equities for Rising Rates ETF",
   "last_sale": "50.88",
   "market_cap": "$8.9M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eqrr",
   "FIELD9": ""
 },
 {
   "symbol": "BIB",
   "name": "ProShares Ultra Nasdaq Biotechnology",
   "last_sale": "66.05",
   "market_cap": "$373.18M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bib",
   "FIELD9": ""
 },
 {
   "symbol": "UBIO",
   "name": "Proshares UltraPro Nasdaq Biotechnology",
   "last_sale": "40.74",
   "market_cap": "$32.59M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ubio",
   "FIELD9": ""
 },
 {
   "symbol": "TQQQ",
   "name": "ProShares UltraPro QQQ",
   "last_sale": "68.55",
   "market_cap": "$4.36B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tqqq",
   "FIELD9": ""
 },
 {
   "symbol": "ZBIO",
   "name": "ProShares UltraPro Short NASDAQ Biotechnology",
   "last_sale": "13.88",
   "market_cap": "$2.78M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/zbio",
   "FIELD9": ""
 },
 {
   "symbol": "SQQQ",
   "name": "ProShares UltraPro Short QQQ",
   "last_sale": "11.65",
   "market_cap": "$595.14M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sqqq",
   "FIELD9": ""
 },
 {
   "symbol": "BIS",
   "name": "ProShares UltraShort Nasdaq Biotechnology",
   "last_sale": "16.52",
   "market_cap": "$29.49M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bis",
   "FIELD9": ""
 },
 {
   "symbol": "PSEC",
   "name": "Prospect Capital Corporation",
   "last_sale": "7.39",
   "market_cap": "$2.7B",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psec",
   "FIELD9": ""
 },
 {
   "symbol": "PTGX",
   "name": "Protagonist Therapeutics, Inc.",
   "last_sale": "8.61",
   "market_cap": "$182.69M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ptgx",
   "FIELD9": ""
 },
 {
   "symbol": "PTVCA",
   "name": "Protective Insurance Corporation",
   "last_sale": "22.44",
   "market_cap": "$336.47M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/ptvca",
   "FIELD9": ""
 },
 {
   "symbol": "PTVCB",
   "name": "Protective Insurance Corporation",
   "last_sale": "23.2",
   "market_cap": "$347.86M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/ptvcb",
   "FIELD9": ""
 },
 {
   "symbol": "PRTO",
   "name": "Proteon Therapeutics, Inc.",
   "last_sale": "2.05",
   "market_cap": "$36.34M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/prto",
   "FIELD9": ""
 },
 {
   "symbol": "PTI",
   "name": "Proteostasis Therapeutics, Inc.",
   "last_sale": "2.58",
   "market_cap": "$94.68M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/pti",
   "FIELD9": ""
 },
 {
   "symbol": "PRTA",
   "name": "Prothena Corporation plc",
   "last_sale": "13.34",
   "market_cap": "$531.42M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/prta",
   "FIELD9": ""
 },
 {
   "symbol": "PRVB",
   "name": "Provention Bio, Inc.",
   "last_sale": "4.31",
   "market_cap": "$160.99M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/prvb",
   "FIELD9": ""
 },
 {
   "symbol": "PVBC",
   "name": "Provident Bancorp, Inc.",
   "last_sale": "29.2",
   "market_cap": "$281.15M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/pvbc",
   "FIELD9": ""
 },
 {
   "symbol": "PROV",
   "name": "Provident Financial Holdings, Inc.",
   "last_sale": "18.35",
   "market_cap": "$136.18M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/prov",
   "FIELD9": ""
 },
 {
   "symbol": "PBIP",
   "name": "Prudential Bancorp, Inc.",
   "last_sale": "18.15",
   "market_cap": "$163.51M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pbip",
   "FIELD9": ""
 },
 {
   "symbol": "PMD",
   "name": "Psychemedics Corporation",
   "last_sale": "19.24",
   "market_cap": "$105.96M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/pmd",
   "FIELD9": ""
 },
 {
   "symbol": "PTC",
   "name": "PTC Inc.",
   "last_sale": "103.06",
   "market_cap": "$12.14B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ptc",
   "FIELD9": ""
 },
 {
   "symbol": "PTCT",
   "name": "PTC Therapeutics, Inc.",
   "last_sale": "45.13",
   "market_cap": "$2.27B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ptct",
   "FIELD9": ""
 },
 {
   "symbol": "PULM",
   "name": "Pulmatrix, Inc.",
   "last_sale": "0.3877",
   "market_cap": "$18.19M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/pulm",
   "FIELD9": ""
 },
 {
   "symbol": "PLSE",
   "name": "Pulse Biosciences, Inc",
   "last_sale": "13.85",
   "market_cap": "$233.88M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/plse",
   "FIELD9": ""
 },
 {
   "symbol": "PBYI",
   "name": "Puma Biotechnology Inc",
   "last_sale": "47.5",
   "market_cap": "$1.81B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/pbyi",
   "FIELD9": ""
 },
 {
   "symbol": "PACQ",
   "name": "Pure Acquisition Corp.",
   "last_sale": "9.7",
   "market_cap": "$103.44M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pacq",
   "FIELD9": ""
 },
 {
   "symbol": "PACQU",
   "name": "Pure Acquisition Corp.",
   "last_sale": "10.31",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pacqu",
   "FIELD9": ""
 },
 {
   "symbol": "PACQW",
   "name": "Pure Acquisition Corp.",
   "last_sale": "1.35",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pacqw",
   "FIELD9": ""
 },
 {
   "symbol": "PCYO",
   "name": "Pure Cycle Corporation",
   "last_sale": "11.525",
   "market_cap": "$273.88M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/pcyo",
   "FIELD9": ""
 },
 {
   "symbol": "PRPL",
   "name": "Purple Innovation, Inc.",
   "last_sale": "5.79",
   "market_cap": "$311.51M",
   "IPOyear": "2015",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/prpl",
   "FIELD9": ""
 },
 {
   "symbol": "PRPLW",
   "name": "Purple Innovation, Inc.",
   "last_sale": "0.23",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/prplw",
   "FIELD9": ""
 },
 {
   "symbol": "PXS",
   "name": "Pyxis Tankers Inc.",
   "last_sale": "0.91",
   "market_cap": "$19M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/pxs",
   "FIELD9": ""
 },
 {
   "symbol": "QADA",
   "name": "QAD Inc.",
   "last_sale": "58.2",
   "market_cap": "$1.13B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/qada",
   "FIELD9": ""
 },
 {
   "symbol": "QADB",
   "name": "QAD Inc.",
   "last_sale": "44.22",
   "market_cap": "$867.64M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/qadb",
   "FIELD9": ""
 },
 {
   "symbol": "QCRH",
   "name": "QCR Holdings, Inc.",
   "last_sale": "42.7",
   "market_cap": "$668.87M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/qcrh",
   "FIELD9": ""
 },
 {
   "symbol": "QGEN",
   "name": "Qiagen N.V.",
   "last_sale": "37.47",
   "market_cap": "$8.51B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/qgen",
   "FIELD9": ""
 },
 {
   "symbol": "QIWI",
   "name": "QIWI plc",
   "last_sale": "13.2",
   "market_cap": "$805.12M",
   "IPOyear": "2013",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/qiwi",
   "FIELD9": ""
 },
 {
   "symbol": "QRVO",
   "name": "Qorvo, Inc.",
   "last_sale": "78.62",
   "market_cap": "$9.88B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/qrvo",
   "FIELD9": ""
 },
 {
   "symbol": "QCOM",
   "name": "QUALCOMM Incorporated",
   "last_sale": "73.13",
   "market_cap": "$107.44B",
   "IPOyear": "1991",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/qcom",
   "FIELD9": ""
 },
 {
   "symbol": "QBAK",
   "name": "Qualstar Corporation",
   "last_sale": "7.91",
   "market_cap": "$16.2M",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/qbak",
   "FIELD9": ""
 },
 {
   "symbol": "QLYS",
   "name": "Qualys, Inc.",
   "last_sale": "86.7",
   "market_cap": "$3.38B",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/qlys",
   "FIELD9": ""
 },
 {
   "symbol": "QTNA",
   "name": "Quantenna Communications, Inc.",
   "last_sale": "18.87",
   "market_cap": "$696.4M",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/qtna",
   "FIELD9": ""
 },
 {
   "symbol": "QTRX",
   "name": "Quanterix Corporation",
   "last_sale": "19.33",
   "market_cap": "$427.19M",
   "IPOyear": "2017",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/qtrx",
   "FIELD9": ""
 },
 {
   "symbol": "QTRH",
   "name": "Quarterhill Inc.",
   "last_sale": "1.46",
   "market_cap": "$173.47M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Multi-Sector Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/qtrh",
   "FIELD9": ""
 },
 {
   "symbol": "QRHC",
   "name": "Quest Resource Holding Corporation.",
   "last_sale": "2.6",
   "market_cap": "$39.81M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/qrhc",
   "FIELD9": ""
 },
 {
   "symbol": "QUIK",
   "name": "QuickLogic Corporation",
   "last_sale": "1.06",
   "market_cap": "$100.26M",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/quik",
   "FIELD9": ""
 },
 {
   "symbol": "QDEL",
   "name": "Quidel Corporation",
   "last_sale": "64.84",
   "market_cap": "$2.53B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/qdel",
   "FIELD9": ""
 },
 {
   "symbol": "QNST",
   "name": "QuinStreet, Inc.",
   "last_sale": "13.24",
   "market_cap": "$649.79M",
   "IPOyear": "2010",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/qnst",
   "FIELD9": ""
 },
 {
   "symbol": "QUMU",
   "name": "Qumu Corporation",
   "last_sale": "2.7",
   "market_cap": "$25.73M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/qumu",
   "FIELD9": ""
 },
 {
   "symbol": "QTNT",
   "name": "Quotient Limited",
   "last_sale": "6.64",
   "market_cap": "$331.66M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/qtnt",
   "FIELD9": ""
 },
 {
   "symbol": "QRTEA",
   "name": "Qurate Retail, Inc.",
   "last_sale": "22.635",
   "market_cap": "$10.42B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/qrtea",
   "FIELD9": ""
 },
 {
   "symbol": "QRTEB",
   "name": "Qurate Retail, Inc.",
   "last_sale": "21.92",
   "market_cap": "$10.09B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/qrteb",
   "FIELD9": ""
 },
 {
   "symbol": "QTT",
   "name": "Qutoutiao Inc.",
   "last_sale": "8.5558",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qtt",
   "FIELD9": ""
 },
 {
   "symbol": "RRD",
   "name": "R.R. Donnelley & Sons Company",
   "last_sale": "5.91",
   "market_cap": "$416.06M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Publishing",
   "summary_quote": "https://www.nasdaq.com/symbol/rrd",
   "FIELD9": ""
 },
 {
   "symbol": "RCM",
   "name": "R1 RCM Inc.",
   "last_sale": "9.6",
   "market_cap": "$1.06B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rcm",
   "FIELD9": ""
 },
 {
   "symbol": "RARX",
   "name": "Ra Pharmaceuticals, Inc.",
   "last_sale": "16.36",
   "market_cap": "$529.08M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rarx",
   "FIELD9": ""
 },
 {
   "symbol": "RADA",
   "name": "RADA Electronic Industries Ltd.",
   "last_sale": "3.09",
   "market_cap": "$101.69M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/rada",
   "FIELD9": ""
 },
 {
   "symbol": "RDCM",
   "name": "Radcom Ltd.",
   "last_sale": "12.8",
   "market_cap": "$174.61M",
   "IPOyear": "1997",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/rdcm",
   "FIELD9": ""
 },
 {
   "symbol": "RSYS",
   "name": "RadiSys Corporation",
   "last_sale": "1.65",
   "market_cap": "$65.37M",
   "IPOyear": "1995",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/rsys",
   "FIELD9": ""
 },
 {
   "symbol": "RDUS",
   "name": "Radius Health, Inc.",
   "last_sale": "17.94",
   "market_cap": "$815.85M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rdus",
   "FIELD9": ""
 },
 {
   "symbol": "RDNT",
   "name": "RadNet, Inc.",
   "last_sale": "15.55",
   "market_cap": "$750.83M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/rdnt",
   "FIELD9": ""
 },
 {
   "symbol": "RDWR",
   "name": "Radware Ltd.",
   "last_sale": "25.32",
   "market_cap": "$1.13B",
   "IPOyear": "1999",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rdwr",
   "FIELD9": ""
 },
 {
   "symbol": "METC",
   "name": "Ramaco Resources, Inc.",
   "last_sale": "7.4",
   "market_cap": "$296.61M",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/metc",
   "FIELD9": ""
 },
 {
   "symbol": "RMBS",
   "name": "Rambus, Inc.",
   "last_sale": "11.26",
   "market_cap": "$1.21B",
   "IPOyear": "1997",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/rmbs",
   "FIELD9": ""
 },
 {
   "symbol": "RAND",
   "name": "Rand Capital Corporation",
   "last_sale": "2.58",
   "market_cap": "$16.31M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Textiles",
   "summary_quote": "https://www.nasdaq.com/symbol/rand",
   "FIELD9": ""
 },
 {
   "symbol": "GOLD",
   "name": "Randgold Resources Limited",
   "last_sale": "63.92",
   "market_cap": "$6.04B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/gold",
   "FIELD9": ""
 },
 {
   "symbol": "RNDB",
   "name": "Randolph Bancorp, Inc.",
   "last_sale": "17.09",
   "market_cap": "$102.33M",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/rndb",
   "FIELD9": ""
 },
 {
   "symbol": "RPD",
   "name": "Rapid7, Inc.",
   "last_sale": "36.22",
   "market_cap": "$1.7B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/rpd",
   "FIELD9": ""
 },
 {
   "symbol": "RAVE",
   "name": "Rave Restaurant Group, Inc.",
   "last_sale": "1.4",
   "market_cap": "$21.07M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/rave",
   "FIELD9": ""
 },
 {
   "symbol": "RAVN",
   "name": "Raven Industries, Inc.",
   "last_sale": "46.5",
   "market_cap": "$1.67B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/ravn",
   "FIELD9": ""
 },
 {
   "symbol": "RBB",
   "name": "RBB Bancorp",
   "last_sale": "27.75",
   "market_cap": "$459.11M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/rbb",
   "FIELD9": ""
 },
 {
   "symbol": "ROLL",
   "name": "RBC Bearings Incorporated",
   "last_sale": "152.85",
   "market_cap": "$3.76B",
   "IPOyear": "2005",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/roll",
   "FIELD9": ""
 },
 {
   "symbol": "RICK",
   "name": "RCI Hospitality Holdings, Inc.",
   "last_sale": "30.13",
   "market_cap": "$292.82M",
   "IPOyear": "1995",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/rick",
   "FIELD9": ""
 },
 {
   "symbol": "RCMT",
   "name": "RCM Technologies, Inc.",
   "last_sale": "4.56",
   "market_cap": "$56.02M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rcmt",
   "FIELD9": ""
 },
 {
   "symbol": "RDI",
   "name": "Reading International Inc",
   "last_sale": "15.57",
   "market_cap": "$357.96M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Movies/Entertainment",
   "summary_quote": "https://www.nasdaq.com/symbol/rdi",
   "FIELD9": ""
 },
 {
   "symbol": "RDIB",
   "name": "Reading International Inc",
   "last_sale": "26.3",
   "market_cap": "$591.29M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Movies/Entertainment",
   "summary_quote": "https://www.nasdaq.com/symbol/rdib",
   "FIELD9": ""
 },
 {
   "symbol": "RGSE",
   "name": "Real Goods Solar, Inc.",
   "last_sale": "0.4083",
   "market_cap": "$20.45M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Engineering & Construction",
   "summary_quote": "https://www.nasdaq.com/symbol/rgse",
   "FIELD9": ""
 },
 {
   "symbol": "BCNA",
   "name": "Reality Shares Nasdaq NexGen Economy China ETF",
   "last_sale": "21.7318",
   "market_cap": "$2.17M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bcna",
   "FIELD9": ""
 },
 {
   "symbol": "BLCN",
   "name": "Reality Shares Nasdaq NextGen Economy ETF",
   "last_sale": "23.7239",
   "market_cap": "$103.2M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/blcn",
   "FIELD9": ""
 },
 {
   "symbol": "RLM",
   "name": "Realm Therapeutics plc",
   "last_sale": "3.57",
   "market_cap": "$16.65M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rlm",
   "FIELD9": ""
 },
 {
   "symbol": "RNWK",
   "name": "RealNetworks, Inc.",
   "last_sale": "2.82",
   "market_cap": "$106.07M",
   "IPOyear": "1997",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rnwk",
   "FIELD9": ""
 },
 {
   "symbol": "RP",
   "name": "RealPage, Inc.",
   "last_sale": "62.3",
   "market_cap": "$5.84B",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/rp",
   "FIELD9": ""
 },
 {
   "symbol": "RETA",
   "name": "Reata Pharmaceuticals, Inc.",
   "last_sale": "87.56",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/reta",
   "FIELD9": ""
 },
 {
   "symbol": "RCON",
   "name": "Recon Technology, Ltd.",
   "last_sale": "1.25",
   "market_cap": "$22.85M",
   "IPOyear": "2009",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/rcon",
   "FIELD9": ""
 },
 {
   "symbol": "REPH",
   "name": "Recro Pharma, Inc.",
   "last_sale": "7.04",
   "market_cap": "$145.86M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/reph",
   "FIELD9": ""
 },
 {
   "symbol": "RRGB",
   "name": "Red Robin Gourmet Burgers, Inc.",
   "last_sale": "39.15",
   "market_cap": "$508.81M",
   "IPOyear": "2002",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/rrgb",
   "FIELD9": ""
 },
 {
   "symbol": "RRR",
   "name": "Red Rock Resorts, Inc.",
   "last_sale": "28.02",
   "market_cap": "$3.26B",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/rrr",
   "FIELD9": ""
 },
 {
   "symbol": "RDVT",
   "name": "Red Violet, Inc.",
   "last_sale": "6.13",
   "market_cap": "$62.93M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/rdvt",
   "FIELD9": ""
 },
 {
   "symbol": "RDFN",
   "name": "Redfin Corporation",
   "last_sale": "17.91",
   "market_cap": "$1.59B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/rdfn",
   "FIELD9": ""
 },
 {
   "symbol": "RDHL",
   "name": "Redhill Biopharma Ltd.",
   "last_sale": "8.04",
   "market_cap": "$171.61M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rdhl",
   "FIELD9": ""
 },
 {
   "symbol": "REGN",
   "name": "Regeneron Pharmaceuticals, Inc.",
   "last_sale": "390.28",
   "market_cap": "$42.17B",
   "IPOyear": "1991",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/regn",
   "FIELD9": ""
 },
 {
   "symbol": "RGNX",
   "name": "REGENXBIO Inc.",
   "last_sale": "69.35",
   "market_cap": "$2.24B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/rgnx",
   "FIELD9": ""
 },
 {
   "symbol": "RGLS",
   "name": "Regulus Therapeutics Inc.",
   "last_sale": "0.201",
   "market_cap": "$21.07M",
   "IPOyear": "2012",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rgls",
   "FIELD9": ""
 },
 {
   "symbol": "REIS",
   "name": "Reis, Inc",
   "last_sale": "22.95",
   "market_cap": "$265.52M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/reis",
   "FIELD9": ""
 },
 {
   "symbol": "RBNC",
   "name": "Reliant Bancorp, Inc.",
   "last_sale": "26.96",
   "market_cap": "$310.77M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/rbnc",
   "FIELD9": ""
 },
 {
   "symbol": "RELV",
   "name": "Reliv&#39; International, Inc.",
   "last_sale": "5.041",
   "market_cap": "$9.3M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/relv",
   "FIELD9": ""
 },
 {
   "symbol": "MARK",
   "name": "Remark Holdings, Inc.",
   "last_sale": "3.32",
   "market_cap": "$115.5M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/mark",
   "FIELD9": ""
 },
 {
   "symbol": "RRI",
   "name": "Remora Royalties, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rri",
   "FIELD9": ""
 },
 {
   "symbol": "RNST",
   "name": "Renasant Corporation",
   "last_sale": "43.7",
   "market_cap": "$2.16B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/rnst",
   "FIELD9": ""
 },
 {
   "symbol": "REGI",
   "name": "Renewable Energy Group, Inc.",
   "last_sale": "27.3",
   "market_cap": "$1.02B",
   "IPOyear": "2012",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/regi",
   "FIELD9": ""
 },
 {
   "symbol": "ABAC",
   "name": "Renmin Tianli Group, Inc.",
   "last_sale": "2.26",
   "market_cap": "$18.04M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/abac",
   "FIELD9": ""
 },
 {
   "symbol": "RCII",
   "name": "Rent-A-Center Inc.",
   "last_sale": "14.39",
   "market_cap": "$769.98M",
   "IPOyear": "1995",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rcii",
   "FIELD9": ""
 },
 {
   "symbol": "RGEN",
   "name": "Repligen Corporation",
   "last_sale": "55.24",
   "market_cap": "$2.42B",
   "IPOyear": "1986",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/rgen",
   "FIELD9": ""
 },
 {
   "symbol": "REPL",
   "name": "Replimune Group, Inc.",
   "last_sale": "18.69",
   "market_cap": "$589.74M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/repl",
   "FIELD9": ""
 },
 {
   "symbol": "RBCAA",
   "name": "Republic Bancorp, Inc.",
   "last_sale": "48",
   "market_cap": "$1B",
   "IPOyear": "1998",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/rbcaa",
   "FIELD9": ""
 },
 {
   "symbol": "FRBK",
   "name": "Republic First Bancorp, Inc.",
   "last_sale": "7.2",
   "market_cap": "$423.07M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/frbk",
   "FIELD9": ""
 },
 {
   "symbol": "REFR",
   "name": "Research Frontiers Incorporated",
   "last_sale": "1.21",
   "market_cap": "$33.4M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Multi-Sector Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/refr",
   "FIELD9": ""
 },
 {
   "symbol": "RSLS",
   "name": "ReShape Lifesciences Inc.",
   "last_sale": "0.0387",
   "market_cap": "$2.38M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/rsls",
   "FIELD9": ""
 },
 {
   "symbol": "RESN",
   "name": "Resonant Inc.",
   "last_sale": "4.32",
   "market_cap": "$116.56M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/resn",
   "FIELD9": ""
 },
 {
   "symbol": "RECN",
   "name": "Resources Connection, Inc.",
   "last_sale": "17.05",
   "market_cap": "$537.04M",
   "IPOyear": "2000",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/recn",
   "FIELD9": ""
 },
 {
   "symbol": "HAIR",
   "name": "Restoration Robotics, Inc.",
   "last_sale": "2.62",
   "market_cap": "$76.42M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/hair",
   "FIELD9": ""
 },
 {
   "symbol": "TORC",
   "name": "resTORbio, Inc.",
   "last_sale": "15.09",
   "market_cap": "$423.25M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/torc",
   "FIELD9": ""
 },
 {
   "symbol": "ROIC",
   "name": "Retail Opportunity Investments Corp.",
   "last_sale": "18.61",
   "market_cap": "$2.1B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/roic",
   "FIELD9": ""
 },
 {
   "symbol": "RETO",
   "name": "ReTo Eco-Solutions, Inc.",
   "last_sale": "3.97",
   "market_cap": "$90.36M",
   "IPOyear": "2017",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/reto",
   "FIELD9": ""
 },
 {
   "symbol": "RTRX",
   "name": "Retrophin, Inc.",
   "last_sale": "27.82",
   "market_cap": "$1.14B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rtrx",
   "FIELD9": ""
 },
 {
   "symbol": "RVNC",
   "name": "Revance Therapeutics, Inc.",
   "last_sale": "25.075",
   "market_cap": "$926.22M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rvnc",
   "FIELD9": ""
 },
 {
   "symbol": "RVEN",
   "name": "Reven Housing REIT, Inc.",
   "last_sale": "3.9773",
   "market_cap": "$42.83M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/rven",
   "FIELD9": ""
 },
 {
   "symbol": "RBIO",
   "name": "rEVO Biologics, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rbio",
   "FIELD9": ""
 },
 {
   "symbol": "RVLT",
   "name": "Revolution Lighting Technologies, Inc.",
   "last_sale": "2.9",
   "market_cap": "$68.2M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Building Products",
   "summary_quote": "https://www.nasdaq.com/symbol/rvlt",
   "FIELD9": ""
 },
 {
   "symbol": "RWLK",
   "name": "ReWalk Robotics Ltd",
   "last_sale": "0.9",
   "market_cap": "$31.97M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/rwlk",
   "FIELD9": ""
 },
 {
   "symbol": "RFIL",
   "name": "RF Industries, Ltd.",
   "last_sale": "7.8",
   "market_cap": "$72.46M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/rfil",
   "FIELD9": ""
 },
 {
   "symbol": "RGCO",
   "name": "RGC Resources Inc.",
   "last_sale": "27.9",
   "market_cap": "$222.83M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/rgco",
   "FIELD9": ""
 },
 {
   "symbol": "RYTM",
   "name": "Rhythm Pharmaceuticals, Inc.",
   "last_sale": "32.07",
   "market_cap": "$1.1B",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rytm",
   "FIELD9": ""
 },
 {
   "symbol": "RBBN",
   "name": "Ribbon Communications Inc. ",
   "last_sale": "7.04",
   "market_cap": "$732.27M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rbbn",
   "FIELD9": ""
 },
 {
   "symbol": "RIBT",
   "name": "RiceBran Technologies",
   "last_sale": "2.94",
   "market_cap": "$71.31M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/ribt",
   "FIELD9": ""
 },
 {
   "symbol": "RIBTW",
   "name": "RiceBran Technologies",
   "last_sale": "0.1591",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/ribtw",
   "FIELD9": ""
 },
 {
   "symbol": "RELL",
   "name": "Richardson Electronics, Ltd.",
   "last_sale": "8.8",
   "market_cap": "$114.06M",
   "IPOyear": "1983",
   "sector": "Consumer Non-Durables",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/rell",
   "FIELD9": ""
 },
 {
   "symbol": "RIGL",
   "name": "Rigel Pharmaceuticals, Inc.",
   "last_sale": "3.24",
   "market_cap": "$539.28M",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rigl",
   "FIELD9": ""
 },
 {
   "symbol": "RNET",
   "name": "RigNet, Inc.",
   "last_sale": "18.85",
   "market_cap": "$364.93M",
   "IPOyear": "2010",
   "sector": "Consumer Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/rnet",
   "FIELD9": ""
 },
 {
   "symbol": "RMNI",
   "name": "Rimini Street, Inc.",
   "last_sale": "6.75",
   "market_cap": "$425.3M",
   "IPOyear": "2015",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rmni",
   "FIELD9": ""
 },
 {
   "symbol": "RIOT",
   "name": "Riot Blockchain, Inc",
   "last_sale": "3.9897",
   "market_cap": "$56M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/riot",
   "FIELD9": ""
 },
 {
   "symbol": "REDU",
   "name": "RISE Education Cayman Ltd",
   "last_sale": "12.25",
   "market_cap": "$740.01M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/redu",
   "FIELD9": ""
 },
 {
   "symbol": "RTTR",
   "name": "Ritter Pharmaceuticals, Inc.",
   "last_sale": "1.94",
   "market_cap": "$10.74M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rttr",
   "FIELD9": ""
 },
 {
   "symbol": "RVSB",
   "name": "Riverview Bancorp Inc",
   "last_sale": "9.17",
   "market_cap": "$207.03M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/rvsb",
   "FIELD9": ""
 },
 {
   "symbol": "RIVE",
   "name": "Riverview Financial Corporation",
   "last_sale": "13.7153",
   "market_cap": "$124.74M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/rive",
   "FIELD9": ""
 },
 {
   "symbol": "RLJE",
   "name": "RLJ Entertainment, Inc.",
   "last_sale": "6.29",
   "market_cap": "$98.22M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Movies/Entertainment",
   "summary_quote": "https://www.nasdaq.com/symbol/rlje",
   "FIELD9": ""
 },
 {
   "symbol": "RMGN",
   "name": "RMG Networks Holding Corporation",
   "last_sale": "1.27",
   "market_cap": "$14.17M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rmgn",
   "FIELD9": ""
 },
 {
   "symbol": "RCKT",
   "name": "Rocket Pharmaceuticals, Inc.",
   "last_sale": "23.39",
   "market_cap": "$927.67M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rckt",
   "FIELD9": ""
 },
 {
   "symbol": "RMTI",
   "name": "Rockwell Medical, Inc.",
   "last_sale": "4.44",
   "market_cap": "$229.85M",
   "IPOyear": "1998",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/rmti",
   "FIELD9": ""
 },
 {
   "symbol": "RCKY",
   "name": "Rocky Brands, Inc.",
   "last_sale": "28.15",
   "market_cap": "$208.65M",
   "IPOyear": "1993",
   "sector": "Consumer Non-Durables",
   "industry": "Shoe Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/rcky",
   "FIELD9": ""
 },
 {
   "symbol": "RMCF",
   "name": "Rocky Mountain Chocolate Factory, Inc.",
   "last_sale": "10.35",
   "market_cap": "$61.12M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Specialty Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/rmcf",
   "FIELD9": ""
 },
 {
   "symbol": "ROKU",
   "name": "Roku, Inc.",
   "last_sale": "72.45",
   "market_cap": "$7.69B",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/roku",
   "FIELD9": ""
 },
 {
   "symbol": "ROSE",
   "name": "Rosehill Resources Inc.",
   "last_sale": "8.12",
   "market_cap": "$295.16M",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/rose",
   "FIELD9": ""
 },
 {
   "symbol": "ROSEU",
   "name": "Rosehill Resources Inc.",
   "last_sale": "9.5",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/roseu",
   "FIELD9": ""
 },
 {
   "symbol": "ROSEW",
   "name": "Rosehill Resources Inc.",
   "last_sale": "1.33",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/rosew",
   "FIELD9": ""
 },
 {
   "symbol": "ROST",
   "name": "Ross Stores, Inc.",
   "last_sale": "97.5",
   "market_cap": "$36.4B",
   "IPOyear": "1985",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/rost",
   "FIELD9": ""
 },
 {
   "symbol": "RGLD",
   "name": "Royal Gold, Inc.",
   "last_sale": "76.89",
   "market_cap": "$5.04B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/rgld",
   "FIELD9": ""
 },
 {
   "symbol": "RTIX",
   "name": "RTI Surgical, Inc.",
   "last_sale": "4.45",
   "market_cap": "$282.03M",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/rtix",
   "FIELD9": ""
 },
 {
   "symbol": "RBCN",
   "name": "Rubicon Technology, Inc.",
   "last_sale": "8.7473",
   "market_cap": "$23.98M",
   "IPOyear": "2007",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/rbcn",
   "FIELD9": ""
 },
 {
   "symbol": "RUBY",
   "name": "Rubius Therapeutics, Inc.",
   "last_sale": "22.82",
   "market_cap": "$1.8B",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/ruby",
   "FIELD9": ""
 },
 {
   "symbol": "RMBL",
   "name": "RumbleOn, Inc.",
   "last_sale": "9.89",
   "market_cap": "$152.68M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rmbl",
   "FIELD9": ""
 },
 {
   "symbol": "RUSHA",
   "name": "Rush Enterprises, Inc.",
   "last_sale": "42.01",
   "market_cap": "$1.64B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/rusha",
   "FIELD9": ""
 },
 {
   "symbol": "RUSHB",
   "name": "Rush Enterprises, Inc.",
   "last_sale": "43.19",
   "market_cap": "$1.69B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/rushb",
   "FIELD9": ""
 },
 {
   "symbol": "RUTH",
   "name": "Ruth&#39;s Hospitality Group, Inc.",
   "last_sale": "30.75",
   "market_cap": "$943.27M",
   "IPOyear": "2005",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/ruth",
   "FIELD9": ""
 },
 {
   "symbol": "RXII",
   "name": "RXi Pharmaceuticals Corporation",
   "last_sale": "1.2",
   "market_cap": "$5.28M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rxii",
   "FIELD9": ""
 },
 {
   "symbol": "RXIIW",
   "name": "RXi Pharmaceuticals Corporation",
   "last_sale": "0.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rxiiw",
   "FIELD9": ""
 },
 {
   "symbol": "RYAAY",
   "name": "Ryanair Holdings plc",
   "last_sale": "98.34",
   "market_cap": "$22.37B",
   "IPOyear": "1997",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ryaay",
   "FIELD9": ""
 },
 {
   "symbol": "STBA",
   "name": "S&T Bancorp, Inc.",
   "last_sale": "45.61",
   "market_cap": "$1.6B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/stba",
   "FIELD9": ""
 },
 {
   "symbol": "SANW",
   "name": "S&W Seed Company",
   "last_sale": "2.9",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/sanw",
   "FIELD9": ""
 },
 {
   "symbol": "SCAC",
   "name": "Saban Capital Acquisition Corp.",
   "last_sale": "10.13",
   "market_cap": "$75.54M",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/scac",
   "FIELD9": ""
 },
 {
   "symbol": "SCACU",
   "name": "Saban Capital Acquisition Corp.",
   "last_sale": "10.6",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/scacu",
   "FIELD9": ""
 },
 {
   "symbol": "SCACW",
   "name": "Saban Capital Acquisition Corp.",
   "last_sale": "1.2",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/scacw",
   "FIELD9": ""
 },
 {
   "symbol": "SBRA",
   "name": "Sabra Health Care REIT, Inc.",
   "last_sale": "23.3",
   "market_cap": "$4.15B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/sbra",
   "FIELD9": ""
 },
 {
   "symbol": "SABR",
   "name": "Sabre Corporation",
   "last_sale": "25.83",
   "market_cap": "$7.11B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/sabr",
   "FIELD9": ""
 },
 {
   "symbol": "SAEX",
   "name": "SAExploration Holdings, Inc.",
   "last_sale": "7.25",
   "market_cap": "$633961.75",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/saex",
   "FIELD9": ""
 },
 {
   "symbol": "SFET",
   "name": "Safe-T Group Ltd.",
   "last_sale": "10.9472",
   "market_cap": "$1.55M",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/sfet",
   "FIELD9": ""
 },
 {
   "symbol": "SAFT",
   "name": "Safety Insurance Group, Inc.",
   "last_sale": "91.95",
   "market_cap": "$1.41B",
   "IPOyear": "2002",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/saft",
   "FIELD9": ""
 },
 {
   "symbol": "SGA",
   "name": "Saga Communications, Inc.",
   "last_sale": "36.55",
   "market_cap": "$216.61M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/sga",
   "FIELD9": ""
 },
 {
   "symbol": "SAGE",
   "name": "Sage Therapeutics, Inc.",
   "last_sale": "145.98",
   "market_cap": "$6.81B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sage",
   "FIELD9": ""
 },
 {
   "symbol": "SAIA",
   "name": "Saia, Inc.",
   "last_sale": "77.25",
   "market_cap": "$1.98B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/saia",
   "FIELD9": ""
 },
 {
   "symbol": "SALM",
   "name": "Salem Media Group, Inc.",
   "last_sale": "4",
   "market_cap": "$104.73M",
   "IPOyear": "1999",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/salm",
   "FIELD9": ""
 },
 {
   "symbol": "SAL",
   "name": "Salisbury Bancorp, Inc.",
   "last_sale": "41.85",
   "market_cap": "$117.38M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/sal",
   "FIELD9": ""
 },
 {
   "symbol": "SAFM",
   "name": "Sanderson Farms, Inc.",
   "last_sale": "99.88",
   "market_cap": "$2.28B",
   "IPOyear": "1987",
   "sector": "Consumer Non-Durables",
   "industry": "Meat/Poultry/Fish",
   "summary_quote": "https://www.nasdaq.com/symbol/safm",
   "FIELD9": ""
 },
 {
   "symbol": "SASR",
   "name": "Sandy Spring Bancorp, Inc.",
   "last_sale": "40.1",
   "market_cap": "$1.42B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sasr",
   "FIELD9": ""
 },
 {
   "symbol": "SGMO",
   "name": "Sangamo Therapeutics, Inc.",
   "last_sale": "15.75",
   "market_cap": "$1.6B",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/sgmo",
   "FIELD9": ""
 },
 {
   "symbol": "SANM",
   "name": "Sanmina Corporation",
   "last_sale": "29.15",
   "market_cap": "$1.98B",
   "IPOyear": "1993",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/sanm",
   "FIELD9": ""
 },
 {
   "symbol": "GCVRZ",
   "name": "Sanofi",
   "last_sale": "0.55",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/gcvrz",
   "FIELD9": ""
 },
 {
   "symbol": "SPNS",
   "name": "Sapiens International Corporation N.V.",
   "last_sale": "12.35",
   "market_cap": "$614.77M",
   "IPOyear": "1992",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/spns",
   "FIELD9": ""
 },
 {
   "symbol": "SRPT",
   "name": "Sarepta Therapeutics, Inc.",
   "last_sale": "147.59",
   "market_cap": "$9.81B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/srpt",
   "FIELD9": ""
 },
 {
   "symbol": "SVRA",
   "name": "Savara, Inc.",
   "last_sale": "11.21",
   "market_cap": "$393.41M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/svra",
   "FIELD9": ""
 },
 {
   "symbol": "SBFG",
   "name": "SB Financial Group, Inc.",
   "last_sale": "20.17",
   "market_cap": "$131.17M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sbfg",
   "FIELD9": ""
 },
 {
   "symbol": "SBFGP",
   "name": "SB Financial Group, Inc.",
   "last_sale": "20.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sbfgp",
   "FIELD9": ""
 },
 {
   "symbol": "SBBX",
   "name": "SB One Bancorp",
   "last_sale": "26.9",
   "market_cap": "$213.31M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sbbx",
   "FIELD9": ""
 },
 {
   "symbol": "SBAC",
   "name": "SBA Communications Corporation",
   "last_sale": "160.53",
   "market_cap": "$18.44B",
   "IPOyear": "1999",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/sbac",
   "FIELD9": ""
 },
 {
   "symbol": "SCSC",
   "name": "ScanSource, Inc.",
   "last_sale": "40.25",
   "market_cap": "$1.03B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Retail: Computer Software & Peripheral Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/scsc",
   "FIELD9": ""
 },
 {
   "symbol": "SMIT",
   "name": "Schmitt Industries, Inc.",
   "last_sale": "2.85",
   "market_cap": "$11.38M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/smit",
   "FIELD9": ""
 },
 {
   "symbol": "SCHN",
   "name": "Schnitzer Steel Industries, Inc.",
   "last_sale": "27.55",
   "market_cap": "$742.45M",
   "IPOyear": "1993",
   "sector": "Consumer Durables",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/schn",
   "FIELD9": ""
 },
 {
   "symbol": "SRRK",
   "name": "Scholar Rock Holding Corporation",
   "last_sale": "24.3",
   "market_cap": "$613.42M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/srrk",
   "FIELD9": ""
 },
 {
   "symbol": "SCHL",
   "name": "Scholastic Corporation",
   "last_sale": "43.5",
   "market_cap": "$1.52B",
   "IPOyear": "1992",
   "sector": "Consumer Services",
   "industry": "Books",
   "summary_quote": "https://www.nasdaq.com/symbol/schl",
   "FIELD9": ""
 },
 {
   "symbol": "SGMS",
   "name": "Scientific Games Corp",
   "last_sale": "26.15",
   "market_cap": "$2.39B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sgms",
   "FIELD9": ""
 },
 {
   "symbol": "SCPH",
   "name": "scPharmaceuticals Inc.",
   "last_sale": "5.1",
   "market_cap": "$94.7M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/scph",
   "FIELD9": ""
 },
 {
   "symbol": "SCYX",
   "name": "SCYNEXIS, Inc.",
   "last_sale": "1.25",
   "market_cap": "$58.77M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/scyx",
   "FIELD9": ""
 },
 {
   "symbol": "SEAC",
   "name": "SeaChange International, Inc.",
   "last_sale": "1.83",
   "market_cap": "$65.42M",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/seac",
   "FIELD9": ""
 },
 {
   "symbol": "SBCF",
   "name": "Seacoast Banking Corporation of Florida",
   "last_sale": "30.95",
   "market_cap": "$1.46B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sbcf",
   "FIELD9": ""
 },
 {
   "symbol": "STX",
   "name": "Seagate Technology PLC",
   "last_sale": "49.28",
   "market_cap": "$14.19B",
   "IPOyear": "2002",
   "sector": "Technology",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/stx",
   "FIELD9": ""
 },
 {
   "symbol": "SHIP",
   "name": "Seanergy Maritime Holdings Corp",
   "last_sale": "0.8801",
   "market_cap": "$33.61M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/ship",
   "FIELD9": ""
 },
 {
   "symbol": "SHIPW",
   "name": "Seanergy Maritime Holdings Corp",
   "last_sale": "0.11",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/shipw",
   "FIELD9": ""
 },
 {
   "symbol": "SHLD",
   "name": "Sears Holdings Corporation",
   "last_sale": "1.28",
   "market_cap": "$139.51M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/shld",
   "FIELD9": ""
 },
 {
   "symbol": "SHLDW",
   "name": "Sears Holdings Corporation",
   "last_sale": "0.09",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/shldw",
   "FIELD9": ""
 },
 {
   "symbol": "SHOS",
   "name": "Sears Hometown and Outlet Stores, Inc.",
   "last_sale": "3.35",
   "market_cap": "$76.05M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/shos",
   "FIELD9": ""
 },
 {
   "symbol": "SPNE",
   "name": "SeaSpine Holdings Corporation",
   "last_sale": "15.86",
   "market_cap": "$233.82M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/spne",
   "FIELD9": ""
 },
 {
   "symbol": "SGEN",
   "name": "Seattle Genetics, Inc.",
   "last_sale": "77.75",
   "market_cap": "$12.35B",
   "IPOyear": "2001",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/sgen",
   "FIELD9": ""
 },
 {
   "symbol": "EYES",
   "name": "Second Sight Medical Products, Inc.",
   "last_sale": "1.85",
   "market_cap": "$130.06M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/eyes",
   "FIELD9": ""
 },
 {
   "symbol": "EYESW",
   "name": "Second Sight Medical Products, Inc.",
   "last_sale": "0.775",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/eyesw",
   "FIELD9": ""
 },
 {
   "symbol": "SECO",
   "name": "Secoo Holding Limited",
   "last_sale": "12.5",
   "market_cap": "$632M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/seco",
   "FIELD9": ""
 },
 {
   "symbol": "SCWX",
   "name": "SecureWorks Corp.",
   "last_sale": "12.82",
   "market_cap": "$1.05B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/scwx",
   "FIELD9": ""
 },
 {
   "symbol": "SNFCA",
   "name": "Security National Financial Corporation",
   "last_sale": "5.55",
   "market_cap": "$92.46M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/snfca",
   "FIELD9": ""
 },
 {
   "symbol": "SEIC",
   "name": "SEI Investments Company",
   "last_sale": "61.74",
   "market_cap": "$9.68B",
   "IPOyear": "1981",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/seic",
   "FIELD9": ""
 },
 {
   "symbol": "SLCT",
   "name": "Select Bancorp, Inc.",
   "last_sale": "12.45",
   "market_cap": "$240.24M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/slct",
   "FIELD9": ""
 },
 {
   "symbol": "SIR",
   "name": "Select Income REIT",
   "last_sale": "21.54",
   "market_cap": "$1.93B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/sir",
   "FIELD9": ""
 },
 {
   "symbol": "SIC",
   "name": "Select Interior Concepts, Inc.",
   "last_sale": "10.21",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/sic",
   "FIELD9": ""
 },
 {
   "symbol": "SELB",
   "name": "Selecta Biosciences, Inc.",
   "last_sale": "15.65",
   "market_cap": "$350.5M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/selb",
   "FIELD9": ""
 },
 {
   "symbol": "SIGI",
   "name": "Selective Insurance Group, Inc.",
   "last_sale": "63.8",
   "market_cap": "$3.75B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/sigi",
   "FIELD9": ""
 },
 {
   "symbol": "SLS",
   "name": "SELLAS Life Sciences Group, Inc. ",
   "last_sale": "1.08",
   "market_cap": "$21.14M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sls",
   "FIELD9": ""
 },
 {
   "symbol": "LEDS",
   "name": "SemiLEDS Corporation",
   "last_sale": "4.24",
   "market_cap": "$15.08M",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/leds",
   "FIELD9": ""
 },
 {
   "symbol": "SMTC",
   "name": "Semtech Corporation",
   "last_sale": "57.3",
   "market_cap": "$3.79B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/smtc",
   "FIELD9": ""
 },
 {
   "symbol": "SENEA",
   "name": "Seneca Foods Corp.",
   "last_sale": "31.9",
   "market_cap": "$310.85M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/senea",
   "FIELD9": ""
 },
 {
   "symbol": "SENEB",
   "name": "Seneca Foods Corp.",
   "last_sale": "31.9",
   "market_cap": "$310.85M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/seneb",
   "FIELD9": ""
 },
 {
   "symbol": "SNES",
   "name": "SenesTech, Inc.",
   "last_sale": "0.8",
   "market_cap": "$18.74M",
   "IPOyear": "2016",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/snes",
   "FIELD9": ""
 },
 {
   "symbol": "SNH",
   "name": "Senior Housing Properties Trust",
   "last_sale": "17.9",
   "market_cap": "$4.25B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/snh",
   "FIELD9": ""
 },
 {
   "symbol": "SNHNI",
   "name": "Senior Housing Properties Trust",
   "last_sale": "24.31",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/snhni",
   "FIELD9": ""
 },
 {
   "symbol": "SNHNL",
   "name": "Senior Housing Properties Trust",
   "last_sale": "26.33",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/snhnl",
   "FIELD9": ""
 },
 {
   "symbol": "AIHS",
   "name": "Senmiao Technology Limited",
   "last_sale": "5.23",
   "market_cap": "$135.35M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/aihs",
   "FIELD9": ""
 },
 {
   "symbol": "SNMX",
   "name": "Senomyx, Inc.",
   "last_sale": "1.47",
   "market_cap": "$72M",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/snmx",
   "FIELD9": ""
 },
 {
   "symbol": "SRTS",
   "name": "Sensus Healthcare, Inc.",
   "last_sale": "7.59",
   "market_cap": "$102.83M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/srts",
   "FIELD9": ""
 },
 {
   "symbol": "SRTSW",
   "name": "Sensus Healthcare, Inc.",
   "last_sale": "1.6799",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/srtsw",
   "FIELD9": ""
 },
 {
   "symbol": "STNL",
   "name": "Sentinel Energy Services Inc.",
   "last_sale": "9.9",
   "market_cap": "$99.19M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/stnl",
   "FIELD9": ""
 },
 {
   "symbol": "STNLU",
   "name": "Sentinel Energy Services Inc.",
   "last_sale": "10.2347",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/stnlu",
   "FIELD9": ""
 },
 {
   "symbol": "STNLW",
   "name": "Sentinel Energy Services Inc.",
   "last_sale": "1.2438",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/stnlw",
   "FIELD9": ""
 },
 {
   "symbol": "SQBG",
   "name": "Sequential Brands Group, Inc.",
   "last_sale": "1.74",
   "market_cap": "$111.58M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/sqbg",
   "FIELD9": ""
 },
 {
   "symbol": "MCRB",
   "name": "Seres Therapeutics, Inc.",
   "last_sale": "7.47",
   "market_cap": "$304.74M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mcrb",
   "FIELD9": ""
 },
 {
   "symbol": "SREV",
   "name": "ServiceSource International, Inc.",
   "last_sale": "2.89",
   "market_cap": "$265.42M",
   "IPOyear": "2011",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/srev",
   "FIELD9": ""
 },
 {
   "symbol": "SFBS",
   "name": "ServisFirst Bancshares, Inc.",
   "last_sale": "40.7",
   "market_cap": "$2.16B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sfbs",
   "FIELD9": ""
 },
 {
   "symbol": "SESN",
   "name": "Sesen Bio, Inc.",
   "last_sale": "2.1",
   "market_cap": "$161.72M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sesn",
   "FIELD9": ""
 },
 {
   "symbol": "SSC",
   "name": "Seven Stars Cloud Group, Inc.",
   "last_sale": "4.66",
   "market_cap": "$340.84M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ssc",
   "FIELD9": ""
 },
 {
   "symbol": "SVBI",
   "name": "Severn Bancorp Inc",
   "last_sale": "9.5306",
   "market_cap": "$120.99M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/svbi",
   "FIELD9": ""
 },
 {
   "symbol": "SGBX",
   "name": "SG Blocks, Inc.",
   "last_sale": "3.6",
   "market_cap": "$15.34M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/sgbx",
   "FIELD9": ""
 },
 {
   "symbol": "SGOC",
   "name": "SGOCO Group, Ltd",
   "last_sale": "0.99",
   "market_cap": "$24.6M",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/sgoc",
   "FIELD9": ""
 },
 {
   "symbol": "SEII",
   "name": "Sharing Economy International Inc.",
   "last_sale": "3.2",
   "market_cap": "$23.62M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/seii",
   "FIELD9": ""
 },
 {
   "symbol": "SMED",
   "name": "Sharps Compliance Corp.",
   "last_sale": "3.51",
   "market_cap": "$56.45M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/smed",
   "FIELD9": ""
 },
 {
   "symbol": "SHSP",
   "name": "SharpSpring, Inc.",
   "last_sale": "13.33",
   "market_cap": "$113.48M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/shsp",
   "FIELD9": ""
 },
 {
   "symbol": "SHEN",
   "name": "Shenandoah Telecommunications Co",
   "last_sale": "38",
   "market_cap": "$1.88B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/shen",
   "FIELD9": ""
 },
 {
   "symbol": "PIXY",
   "name": "ShiftPixy, Inc.",
   "last_sale": "3.86",
   "market_cap": "$111.27M",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pixy",
   "FIELD9": ""
 },
 {
   "symbol": "SHLO",
   "name": "Shiloh Industries, Inc.",
   "last_sale": "11.6",
   "market_cap": "$271.42M",
   "IPOyear": "1993",
   "sector": "Capital Goods",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/shlo",
   "FIELD9": ""
 },
 {
   "symbol": "SCCI",
   "name": "Shimmick Construction Company, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/scci",
   "FIELD9": ""
 },
 {
   "symbol": "TYHT",
   "name": "Shineco, Inc.",
   "last_sale": "1.01",
   "market_cap": "$21.45M",
   "IPOyear": "2016",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/tyht",
   "FIELD9": ""
 },
 {
   "symbol": "SHPG",
   "name": "Shire plc",
   "last_sale": "178.42",
   "market_cap": "$46.64B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/shpg",
   "FIELD9": ""
 },
 {
   "symbol": "SCVL",
   "name": "Shoe Carnival, Inc.",
   "last_sale": "40.35",
   "market_cap": "$649.2M",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/scvl",
   "FIELD9": ""
 },
 {
   "symbol": "SHBI",
   "name": "Shore Bancshares Inc",
   "last_sale": "18.36",
   "market_cap": "$234.06M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/shbi",
   "FIELD9": ""
 },
 {
   "symbol": "SSTI",
   "name": "ShotSpotter, Inc.",
   "last_sale": "61.83",
   "market_cap": "$666.05M",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ssti",
   "FIELD9": ""
 },
 {
   "symbol": "SFLY",
   "name": "Shutterfly, Inc.",
   "last_sale": "68.64",
   "market_cap": "$2.3B",
   "IPOyear": "2006",
   "sector": "Miscellaneous",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sfly",
   "FIELD9": ""
 },
 {
   "symbol": "SIFI",
   "name": "SI Financial Group, Inc.",
   "last_sale": "14.05",
   "market_cap": "$169.06M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/sifi",
   "FIELD9": ""
 },
 {
   "symbol": "SIEB",
   "name": "Siebert Financial Corp.",
   "last_sale": "14.48",
   "market_cap": "$393.24M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/sieb",
   "FIELD9": ""
 },
 {
   "symbol": "SNNA",
   "name": "Sienna Biopharmaceuticals, Inc.",
   "last_sale": "15.42",
   "market_cap": "$320.73M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/snna",
   "FIELD9": ""
 },
 {
   "symbol": "SIEN",
   "name": "Sientra, Inc.",
   "last_sale": "24.33",
   "market_cap": "$691.64M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/sien",
   "FIELD9": ""
 },
 {
   "symbol": "BSRR",
   "name": "Sierra Bancorp",
   "last_sale": "29.91",
   "market_cap": "$456.52M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bsrr",
   "FIELD9": ""
 },
 {
   "symbol": "SRRA",
   "name": "Sierra Oncology, Inc.",
   "last_sale": "1.87",
   "market_cap": "$139.02M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/srra",
   "FIELD9": ""
 },
 {
   "symbol": "SWIR",
   "name": "Sierra Wireless, Inc.",
   "last_sale": "21",
   "market_cap": "$757.99M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/swir",
   "FIELD9": ""
 },
 {
   "symbol": "SIFY",
   "name": "Sify Technologies Limited",
   "last_sale": "1.65",
   "market_cap": "$294.83M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/sify",
   "FIELD9": ""
 },
 {
   "symbol": "SIGA",
   "name": "SIGA Technologies Inc.",
   "last_sale": "7.25",
   "market_cap": "$573.91M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/siga",
   "FIELD9": ""
 },
 {
   "symbol": "SGLB",
   "name": "Sigma Labs, Inc.",
   "last_sale": "1.08",
   "market_cap": "$8.91M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Miscellaneous manufacturing industries",
   "summary_quote": "https://www.nasdaq.com/symbol/sglb",
   "FIELD9": ""
 },
 {
   "symbol": "SGLBW",
   "name": "Sigma Labs, Inc.",
   "last_sale": "0.35",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Miscellaneous manufacturing industries",
   "summary_quote": "https://www.nasdaq.com/symbol/sglbw",
   "FIELD9": ""
 },
 {
   "symbol": "SGMA",
   "name": "SigmaTron International, Inc.",
   "last_sale": "5.9796",
   "market_cap": "$25.29M",
   "IPOyear": "1994",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/sgma",
   "FIELD9": ""
 },
 {
   "symbol": "SBNY",
   "name": "Signature Bank",
   "last_sale": "118.39",
   "market_cap": "$6.55B",
   "IPOyear": "2004",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sbny",
   "FIELD9": ""
 },
 {
   "symbol": "SBNYW",
   "name": "Signature Bank",
   "last_sale": "89.35",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sbnyw",
   "FIELD9": ""
 },
 {
   "symbol": "SLGN",
   "name": "Silgan Holdings Inc.",
   "last_sale": "28.62",
   "market_cap": "$3.17B",
   "IPOyear": "1997",
   "sector": "Consumer Durables",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/slgn",
   "FIELD9": ""
 },
 {
   "symbol": "SILC",
   "name": "Silicom Ltd",
   "last_sale": "38.47",
   "market_cap": "$290.51M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/silc",
   "FIELD9": ""
 },
 {
   "symbol": "SLAB",
   "name": "Silicon Laboratories, Inc.",
   "last_sale": "93.95",
   "market_cap": "$4.07B",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/slab",
   "FIELD9": ""
 },
 {
   "symbol": "SIMO",
   "name": "Silicon Motion Technology Corporation",
   "last_sale": "53.89",
   "market_cap": "$1.95B",
   "IPOyear": "2005",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/simo",
   "FIELD9": ""
 },
 {
   "symbol": "SAMG",
   "name": "Silvercrest Asset Management Group Inc.",
   "last_sale": "15.05",
   "market_cap": "$198.82M",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/samg",
   "FIELD9": ""
 },
 {
   "symbol": "SSNT",
   "name": "SilverSun Technologies, Inc.",
   "last_sale": "3.65",
   "market_cap": "$16.43M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ssnt",
   "FIELD9": ""
 },
 {
   "symbol": "SFNC",
   "name": "Simmons First National Corporation",
   "last_sale": "31.75",
   "market_cap": "$2.93B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sfnc",
   "FIELD9": ""
 },
 {
   "symbol": "SLP",
   "name": "Simulations Plus, Inc.",
   "last_sale": "20.05",
   "market_cap": "$348.17M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/slp",
   "FIELD9": ""
 },
 {
   "symbol": "SINA",
   "name": "Sina Corporation",
   "last_sale": "70.37",
   "market_cap": "$5.03B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/sina",
   "FIELD9": ""
 },
 {
   "symbol": "SBGI",
   "name": "Sinclair Broadcast Group, Inc.",
   "last_sale": "28.35",
   "market_cap": "$2.9B",
   "IPOyear": "1995",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/sbgi",
   "FIELD9": ""
 },
 {
   "symbol": "SINO",
   "name": "Sino-Global Shipping America, Ltd.",
   "last_sale": "1.1",
   "market_cap": "$13.68M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/sino",
   "FIELD9": ""
 },
 {
   "symbol": "SVA",
   "name": "Sinovac Biotech, Ltd.",
   "last_sale": "7.92",
   "market_cap": "$547.13M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sva",
   "FIELD9": ""
 },
 {
   "symbol": "SIRI",
   "name": "Sirius XM Holdings Inc.",
   "last_sale": "6.98",
   "market_cap": "$31.33B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/siri",
   "FIELD9": ""
 },
 {
   "symbol": "SRVA",
   "name": "SIRVA, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/srva",
   "FIELD9": ""
 },
 {
   "symbol": "SITO",
   "name": "SITO Mobile, Ltd.",
   "last_sale": "2",
   "market_cap": "$50.75M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sito",
   "FIELD9": ""
 },
 {
   "symbol": "SKYS",
   "name": "Sky Solar Holdings, Ltd.",
   "last_sale": "1.07",
   "market_cap": "$56.11M",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/skys",
   "FIELD9": ""
 },
 {
   "symbol": "SKYW",
   "name": "SkyWest, Inc.",
   "last_sale": "58.8",
   "market_cap": "$3.06B",
   "IPOyear": "1986",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/skyw",
   "FIELD9": ""
 },
 {
   "symbol": "SWKS",
   "name": "Skyworks Solutions, Inc.",
   "last_sale": "92.17",
   "market_cap": "$16.5B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/swks",
   "FIELD9": ""
 },
 {
   "symbol": "SNBR",
   "name": "Sleep Number Corporation",
   "last_sale": "36.57",
   "market_cap": "$1.28B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/snbr",
   "FIELD9": ""
 },
 {
   "symbol": "SLM",
   "name": "SLM Corporation",
   "last_sale": "11.89",
   "market_cap": "$5.18B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/slm",
   "FIELD9": ""
 },
 {
   "symbol": "SLMBP",
   "name": "SLM Corporation",
   "last_sale": "69.2",
   "market_cap": "$276.8M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/slmbp",
   "FIELD9": ""
 },
 {
   "symbol": "SGH",
   "name": "SMART Global Holdings, Inc.",
   "last_sale": "29.86",
   "market_cap": "$666.1M",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/sgh",
   "FIELD9": ""
 },
 {
   "symbol": "SND",
   "name": "Smart Sand, Inc.",
   "last_sale": "4.98",
   "market_cap": "$207.17M",
   "IPOyear": "2016",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/snd",
   "FIELD9": ""
 },
 {
   "symbol": "SMBK",
   "name": "SmartFinancial, Inc.",
   "last_sale": "24",
   "market_cap": "$304.91M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/smbk",
   "FIELD9": ""
 },
 {
   "symbol": "SMSI",
   "name": "Smith Micro Software, Inc.",
   "last_sale": "2.81",
   "market_cap": "$70.33M",
   "IPOyear": "1995",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/smsi",
   "FIELD9": ""
 },
 {
   "symbol": "SMTX",
   "name": "SMTC Corporation",
   "last_sale": "2.7",
   "market_cap": "$62.32M",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/smtx",
   "FIELD9": ""
 },
 {
   "symbol": "SRAX",
   "name": "Social Reality, Inc.",
   "last_sale": "4.05",
   "market_cap": "$41.61M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/srax",
   "FIELD9": ""
 },
 {
   "symbol": "SCKT",
   "name": "Socket Mobile, Inc.",
   "last_sale": "2.5",
   "market_cap": "$14.71M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/sckt",
   "FIELD9": ""
 },
 {
   "symbol": "SODA",
   "name": "SodaStream International Ltd.",
   "last_sale": "143",
   "market_cap": "$3.25B",
   "IPOyear": "2010",
   "sector": "Consumer Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/soda",
   "FIELD9": ""
 },
 {
   "symbol": "SOHU",
   "name": "Sohu.com Limited ",
   "last_sale": "21.35",
   "market_cap": "$830.87M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sohu",
   "FIELD9": ""
 },
 {
   "symbol": "SLRC",
   "name": "Solar Capital Ltd.",
   "last_sale": "21.59",
   "market_cap": "$912.41M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/slrc",
   "FIELD9": ""
 },
 {
   "symbol": "SUNS",
   "name": "Solar Senior Capital Ltd.",
   "last_sale": "16.9",
   "market_cap": "$271.08M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/suns",
   "FIELD9": ""
 },
 {
   "symbol": "SEDG",
   "name": "SolarEdge Technologies, Inc.",
   "last_sale": "42.6",
   "market_cap": "$1.94B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/sedg",
   "FIELD9": ""
 },
 {
   "symbol": "SLNO",
   "name": "Soleno Therapeutics, Inc.",
   "last_sale": "2.19",
   "market_cap": "$46.9M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/slno",
   "FIELD9": ""
 },
 {
   "symbol": "SLNOW",
   "name": "Soleno Therapeutics, Inc.",
   "last_sale": "0.1201",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/slnow",
   "FIELD9": ""
 },
 {
   "symbol": "SLGL",
   "name": "Sol-Gel Technologies Ltd.",
   "last_sale": "6.85",
   "market_cap": "$129.81M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/slgl",
   "FIELD9": ""
 },
 {
   "symbol": "SLDB",
   "name": "Solid Biosciences Inc.",
   "last_sale": "51.22",
   "market_cap": "$1.81B",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/sldb",
   "FIELD9": ""
 },
 {
   "symbol": "SNGX",
   "name": "Soligenix, Inc.",
   "last_sale": "1.53",
   "market_cap": "$27.05M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sngx",
   "FIELD9": ""
 },
 {
   "symbol": "SNGXW",
   "name": "Soligenix, Inc.",
   "last_sale": "0.35",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sngxw",
   "FIELD9": ""
 },
 {
   "symbol": "SONC",
   "name": "Sonic Corp.",
   "last_sale": "35.91",
   "market_cap": "$1.3B",
   "IPOyear": "1991",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/sonc",
   "FIELD9": ""
 },
 {
   "symbol": "SOFO",
   "name": "Sonic Foundry, Inc.",
   "last_sale": "1.7",
   "market_cap": "$8.36M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/sofo",
   "FIELD9": ""
 },
 {
   "symbol": "SNOA",
   "name": "Sonoma Pharmaceuticals, Inc.",
   "last_sale": "1.49",
   "market_cap": "$9.62M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/snoa",
   "FIELD9": ""
 },
 {
   "symbol": "SNOAW",
   "name": "Sonoma Pharmaceuticals, Inc.",
   "last_sale": "0.04",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/snoaw",
   "FIELD9": ""
 },
 {
   "symbol": "SONO",
   "name": "Sonos, Inc.",
   "last_sale": "13.39",
   "market_cap": "$1.34B",
   "IPOyear": "2018",
   "sector": "Consumer Non-Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/sono",
   "FIELD9": ""
 },
 {
   "symbol": "SPHS",
   "name": "Sophiris Bio, Inc.",
   "last_sale": "2.635",
   "market_cap": "$79.34M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sphs",
   "FIELD9": ""
 },
 {
   "symbol": "SORL",
   "name": "SORL Auto Parts, Inc.",
   "last_sale": "4.38",
   "market_cap": "$84.56M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/sorl",
   "FIELD9": ""
 },
 {
   "symbol": "SRNE",
   "name": "Sorrento Therapeutics, Inc.",
   "last_sale": "4.35",
   "market_cap": "$507.79M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/srne",
   "FIELD9": ""
 },
 {
   "symbol": "SOHO",
   "name": "Sotherly Hotels Inc.",
   "last_sale": "7.35",
   "market_cap": "$103.79M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/soho",
   "FIELD9": ""
 },
 {
   "symbol": "SOHOB",
   "name": "Sotherly Hotels Inc.",
   "last_sale": "25.7874",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/sohob",
   "FIELD9": ""
 },
 {
   "symbol": "SOHOO",
   "name": "Sotherly Hotels Inc.",
   "last_sale": "25.35",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/sohoo",
   "FIELD9": ""
 },
 {
   "symbol": "SOHOK",
   "name": "Sotherly Hotels LP",
   "last_sale": "25.74",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/sohok",
   "FIELD9": ""
 },
 {
   "symbol": "SFBC",
   "name": "Sound Financial Bancorp, Inc.",
   "last_sale": "40",
   "market_cap": "$101.59M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/sfbc",
   "FIELD9": ""
 },
 {
   "symbol": "SSB",
   "name": "South State Corporation",
   "last_sale": "84.4",
   "market_cap": "$3.11B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ssb",
   "FIELD9": ""
 },
 {
   "symbol": "SFST",
   "name": "Southern First Bancshares, Inc.",
   "last_sale": "41.075",
   "market_cap": "$305.01M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sfst",
   "FIELD9": ""
 },
 {
   "symbol": "SMBC",
   "name": "Southern Missouri Bancorp, Inc.",
   "last_sale": "38.93",
   "market_cap": "$350.24M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/smbc",
   "FIELD9": ""
 },
 {
   "symbol": "SONA",
   "name": "Southern National Bancorp of Virginia, Inc.",
   "last_sale": "16.8",
   "market_cap": "$404.01M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sona",
   "FIELD9": ""
 },
 {
   "symbol": "SBSI",
   "name": "Southside Bancshares, Inc.",
   "last_sale": "36.71",
   "market_cap": "$1.29B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sbsi",
   "FIELD9": ""
 },
 {
   "symbol": "SP",
   "name": "SP Plus Corporation",
   "last_sale": "39.35",
   "market_cap": "$894.41M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Rental/Leasing Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/sp",
   "FIELD9": ""
 },
 {
   "symbol": "SGRP",
   "name": "SPAR Group, Inc.",
   "last_sale": "1.13",
   "market_cap": "$23.34M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sgrp",
   "FIELD9": ""
 },
 {
   "symbol": "SPKE",
   "name": "Spark Energy, Inc.",
   "last_sale": "8.1",
   "market_cap": "$282.52M",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/spke",
   "FIELD9": ""
 },
 {
   "symbol": "SPKEP",
   "name": "Spark Energy, Inc.",
   "last_sale": "24.4",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/spkep",
   "FIELD9": ""
 },
 {
   "symbol": "ONCE",
   "name": "Spark Therapeutics, Inc.",
   "last_sale": "55.58",
   "market_cap": "$2.09B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/once",
   "FIELD9": ""
 },
 {
   "symbol": "SPAR",
   "name": "Spartan Motors, Inc.",
   "last_sale": "15.4",
   "market_cap": "$541.95M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/spar",
   "FIELD9": ""
 },
 {
   "symbol": "SPTN",
   "name": "SpartanNash Company",
   "last_sale": "20.73",
   "market_cap": "$744.89M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/sptn",
   "FIELD9": ""
 },
 {
   "symbol": "DWFI",
   "name": "SPDR Dorsey Wright Fixed Income Allocation ETF",
   "last_sale": "23.491",
   "market_cap": "$146.23M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dwfi",
   "FIELD9": ""
 },
 {
   "symbol": "SPPI",
   "name": "Spectrum Pharmaceuticals, Inc.",
   "last_sale": "21.36",
   "market_cap": "$2.26B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sppi",
   "FIELD9": ""
 },
 {
   "symbol": "SPRO",
   "name": "Spero Therapeutics, Inc.",
   "last_sale": "10.255",
   "market_cap": "$186.32M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/spro",
   "FIELD9": ""
 },
 {
   "symbol": "ANY",
   "name": "Sphere 3D Corp.",
   "last_sale": "0.235",
   "market_cap": "$3.6M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/any",
   "FIELD9": ""
 },
 {
   "symbol": "SPEX",
   "name": "Spherix Incorporated",
   "last_sale": "1.03",
   "market_cap": "$8.8M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Multi-Sector Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/spex",
   "FIELD9": ""
 },
 {
   "symbol": "SPI",
   "name": "SPI Energy Co., Ltd.",
   "last_sale": "0.265",
   "market_cap": "$19.21M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/spi",
   "FIELD9": ""
 },
 {
   "symbol": "SAVE",
   "name": "Spirit Airlines, Inc.",
   "last_sale": "48.29",
   "market_cap": "$3.3B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/save",
   "FIELD9": ""
 },
 {
   "symbol": "STXB",
   "name": "Spirit of Texas Bancshares, Inc.",
   "last_sale": "21.97",
   "market_cap": "$215.03M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/stxb",
   "FIELD9": ""
 },
 {
   "symbol": "SPLK",
   "name": "Splunk Inc.",
   "last_sale": "116.4",
   "market_cap": "$17.07B",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/splk",
   "FIELD9": ""
 },
 {
   "symbol": "SPOK",
   "name": "Spok Holdings, Inc.",
   "last_sale": "14.6",
   "market_cap": "$284.09M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/spok",
   "FIELD9": ""
 },
 {
   "symbol": "SPWH",
   "name": "Sportsman&#39;s Warehouse Holdings, Inc.",
   "last_sale": "6.1",
   "market_cap": "$261.92M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/spwh",
   "FIELD9": ""
 },
 {
   "symbol": "SBPH",
   "name": "Spring Bank Pharmaceuticals, Inc.",
   "last_sale": "11.7",
   "market_cap": "$154.27M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sbph",
   "FIELD9": ""
 },
 {
   "symbol": "FUND",
   "name": "Sprott Focus Trust, Inc.",
   "last_sale": "7.45",
   "market_cap": "$193.88M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Miscellaneous",
   "summary_quote": "https://www.nasdaq.com/symbol/fund",
   "FIELD9": ""
 },
 {
   "symbol": "SFM",
   "name": "Sprouts Farmers Market, Inc.",
   "last_sale": "27.54",
   "market_cap": "$3.5B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Food Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/sfm",
   "FIELD9": ""
 },
 {
   "symbol": "SPSC",
   "name": "SPS Commerce, Inc.",
   "last_sale": "96.05",
   "market_cap": "$1.68B",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/spsc",
   "FIELD9": ""
 },
 {
   "symbol": "SSNC",
   "name": "SS&C Technologies Holdings, Inc.",
   "last_sale": "55.02",
   "market_cap": "$13.19B",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ssnc",
   "FIELD9": ""
 },
 {
   "symbol": "SSLJ",
   "name": "SSLJ.com Limited",
   "last_sale": "0.55",
   "market_cap": "$24.2M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sslj",
   "FIELD9": ""
 },
 {
   "symbol": "SSRM",
   "name": "SSR Mining Inc.",
   "last_sale": "8.98",
   "market_cap": "$1.08B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/ssrm",
   "FIELD9": ""
 },
 {
   "symbol": "STAA",
   "name": "STAAR Surgical Company",
   "last_sale": "46.95",
   "market_cap": "$2.06B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Ophthalmic Goods",
   "summary_quote": "https://www.nasdaq.com/symbol/staa",
   "FIELD9": ""
 },
 {
   "symbol": "STAF",
   "name": "Staffing 360 Solutions, Inc.",
   "last_sale": "2.09",
   "market_cap": "$10.27M",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/staf",
   "FIELD9": ""
 },
 {
   "symbol": "STMP",
   "name": "Stamps.com Inc.",
   "last_sale": "225.95",
   "market_cap": "$4.1B",
   "IPOyear": "1999",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/stmp",
   "FIELD9": ""
 },
 {
   "symbol": "STND",
   "name": "Standard AVB Financial Corp.",
   "last_sale": "31",
   "market_cap": "$148.7M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/stnd",
   "FIELD9": ""
 },
 {
   "symbol": "SBLK",
   "name": "Star Bulk Carriers Corp.",
   "last_sale": "12.9",
   "market_cap": "$827.66M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/sblk",
   "FIELD9": ""
 },
 {
   "symbol": "SBLKZ",
   "name": "Star Bulk Carriers Corp.",
   "last_sale": "25.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/sblkz",
   "FIELD9": ""
 },
 {
   "symbol": "SBUX",
   "name": "Starbucks Corporation",
   "last_sale": "57.41",
   "market_cap": "$77.45B",
   "IPOyear": "1992",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/sbux",
   "FIELD9": ""
 },
 {
   "symbol": "STFC",
   "name": "State Auto Financial Corporation",
   "last_sale": "31.38",
   "market_cap": "$1.35B",
   "IPOyear": "1991",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/stfc",
   "FIELD9": ""
 },
 {
   "symbol": "STBZ",
   "name": "State Bank Financial Corporation.",
   "last_sale": "31.43",
   "market_cap": "$1.23B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/stbz",
   "FIELD9": ""
 },
 {
   "symbol": "GASS",
   "name": "StealthGas, Inc.",
   "last_sale": "3.6",
   "market_cap": "$143.5M",
   "IPOyear": "2005",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/gass",
   "FIELD9": ""
 },
 {
   "symbol": "STCN",
   "name": "Steel Connect, Inc.",
   "last_sale": "2.15",
   "market_cap": "$130.59M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/stcn",
   "FIELD9": ""
 },
 {
   "symbol": "STLD",
   "name": "Steel Dynamics, Inc.",
   "last_sale": "45.61",
   "market_cap": "$10.71B",
   "IPOyear": "1996",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/stld",
   "FIELD9": ""
 },
 {
   "symbol": "SMRT",
   "name": "Stein Mart, Inc.",
   "last_sale": "2.16",
   "market_cap": "$103.53M",
   "IPOyear": "1992",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/smrt",
   "FIELD9": ""
 },
 {
   "symbol": "STLR",
   "name": "Stellar Acquisition III Inc.",
   "last_sale": "10.5",
   "market_cap": "$29.58M",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/stlr",
   "FIELD9": ""
 },
 {
   "symbol": "STLRU",
   "name": "Stellar Acquisition III Inc.",
   "last_sale": "10.55",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/stlru",
   "FIELD9": ""
 },
 {
   "symbol": "STLRW",
   "name": "Stellar Acquisition III Inc.",
   "last_sale": "0.15",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/stlrw",
   "FIELD9": ""
 },
 {
   "symbol": "SBOT",
   "name": "Stellar Biotechnologies, Inc.",
   "last_sale": "1.37",
   "market_cap": "$7.3M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sbot",
   "FIELD9": ""
 },
 {
   "symbol": "STML",
   "name": "Stemline Therapeutics, Inc.",
   "last_sale": "17.225",
   "market_cap": "$533.55M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/stml",
   "FIELD9": ""
 },
 {
   "symbol": "SRCL",
   "name": "Stericycle, Inc.",
   "last_sale": "61.49",
   "market_cap": "$5.28B",
   "IPOyear": "1996",
   "sector": "Basic Industries",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/srcl",
   "FIELD9": ""
 },
 {
   "symbol": "SBT",
   "name": "Sterling Bancorp, Inc.",
   "last_sale": "12.41",
   "market_cap": "$657.88M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/sbt",
   "FIELD9": ""
 },
 {
   "symbol": "STRL",
   "name": "Sterling Construction Company Inc",
   "last_sale": "14.18",
   "market_cap": "$383.77M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/strl",
   "FIELD9": ""
 },
 {
   "symbol": "SHOO",
   "name": "Steven Madden, Ltd.",
   "last_sale": "56.55",
   "market_cap": "$3.3B",
   "IPOyear": "1993",
   "sector": "Consumer Non-Durables",
   "industry": "Shoe Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/shoo",
   "FIELD9": ""
 },
 {
   "symbol": "SSFN",
   "name": "Stewardship Financial Corp",
   "last_sale": "10.85",
   "market_cap": "$94.14M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ssfn",
   "FIELD9": ""
 },
 {
   "symbol": "SFIX",
   "name": "Stitch Fix, Inc.",
   "last_sale": "40.44",
   "market_cap": "$3.96B",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/sfix",
   "FIELD9": ""
 },
 {
   "symbol": "SYBT",
   "name": "Stock Yards Bancorp, Inc.",
   "last_sale": "37.15",
   "market_cap": "$845.06M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sybt",
   "FIELD9": ""
 },
 {
   "symbol": "BANX",
   "name": "StoneCastle Financial Corp",
   "last_sale": "22.5",
   "market_cap": "$147.34M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/banx",
   "FIELD9": ""
 },
 {
   "symbol": "SSKN",
   "name": "Strata Skin Sciences, Inc.",
   "last_sale": "3.75",
   "market_cap": "$112.08M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/sskn",
   "FIELD9": ""
 },
 {
   "symbol": "SSYS",
   "name": "Stratasys, Ltd.",
   "last_sale": "23.05",
   "market_cap": "$1.24B",
   "IPOyear": "1994",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ssys",
   "FIELD9": ""
 },
 {
   "symbol": "STRA",
   "name": "Strategic Education, Inc.",
   "last_sale": "136.87",
   "market_cap": "$2.97B",
   "IPOyear": "1996",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/stra",
   "FIELD9": ""
 },
 {
   "symbol": "HNDL",
   "name": "Strategy Shares Nasdaq 7HANDL Index ETF",
   "last_sale": "24.07",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hndl",
   "FIELD9": ""
 },
 {
   "symbol": "STRT",
   "name": "Strattec Security Corporation",
   "last_sale": "34.5",
   "market_cap": "$128.96M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/strt",
   "FIELD9": ""
 },
 {
   "symbol": "STRS",
   "name": "Stratus Properties Inc.",
   "last_sale": "31.65",
   "market_cap": "$258.05M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/strs",
   "FIELD9": ""
 },
 {
   "symbol": "STRM",
   "name": "Streamline Health Solutions, Inc.",
   "last_sale": "1.18",
   "market_cap": "$23.64M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/strm",
   "FIELD9": ""
 },
 {
   "symbol": "SBBP",
   "name": "Strongbridge Biopharma plc",
   "last_sale": "4.35",
   "market_cap": "$203.19M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sbbp",
   "FIELD9": ""
 },
 {
   "symbol": "SUMR",
   "name": "Summer Infant, Inc.",
   "last_sale": "1.65",
   "market_cap": "$30.97M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Miscellaneous manufacturing industries",
   "summary_quote": "https://www.nasdaq.com/symbol/sumr",
   "FIELD9": ""
 },
 {
   "symbol": "SMMF",
   "name": "Summit Financial Group, Inc.",
   "last_sale": "24.24",
   "market_cap": "$302.28M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/smmf",
   "FIELD9": ""
 },
 {
   "symbol": "SSBI",
   "name": "Summit State Bank",
   "last_sale": "15.1",
   "market_cap": "$91.6M",
   "IPOyear": "2006",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ssbi",
   "FIELD9": ""
 },
 {
   "symbol": "SMMT",
   "name": "Summit Therapeutics plc",
   "last_sale": "2.28",
   "market_cap": "$37.45M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/smmt",
   "FIELD9": ""
 },
 {
   "symbol": "WISA",
   "name": "Summit Wireless Technologies, Inc.",
   "last_sale": "4.45",
   "market_cap": "$65.7M",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/wisa",
   "FIELD9": ""
 },
 {
   "symbol": "SNHY",
   "name": "Sun Hydraulics Corporation",
   "last_sale": "57.94",
   "market_cap": "$1.85B",
   "IPOyear": "1997",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/snhy",
   "FIELD9": ""
 },
 {
   "symbol": "SNDE",
   "name": "Sundance Energy Australia Limited",
   "last_sale": "5.5",
   "market_cap": "$377.72M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/snde",
   "FIELD9": ""
 },
 {
   "symbol": "SNSS",
   "name": "Sunesis Pharmaceuticals, Inc.",
   "last_sale": "2.07",
   "market_cap": "$74.8M",
   "IPOyear": "2005",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/snss",
   "FIELD9": ""
 },
 {
   "symbol": "STKL",
   "name": "SunOpta, Inc.",
   "last_sale": "7.2",
   "market_cap": "$627.39M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/stkl",
   "FIELD9": ""
 },
 {
   "symbol": "SPWR",
   "name": "SunPower Corporation",
   "last_sale": "7.89",
   "market_cap": "$1.11B",
   "IPOyear": "2005",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/spwr",
   "FIELD9": ""
 },
 {
   "symbol": "RUN",
   "name": "Sunrun Inc.",
   "last_sale": "12.5",
   "market_cap": "$1.39B",
   "IPOyear": "2015",
   "sector": "Capital Goods",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/run",
   "FIELD9": ""
 },
 {
   "symbol": "SUNW",
   "name": "Sunworks, Inc.",
   "last_sale": "0.558",
   "market_cap": "$14.34M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/sunw",
   "FIELD9": ""
 },
 {
   "symbol": "SPCB",
   "name": "SuperCom, Ltd.",
   "last_sale": "1.77",
   "market_cap": "$26.48M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/spcb",
   "FIELD9": ""
 },
 {
   "symbol": "SCON",
   "name": "Superconductor Technologies Inc.",
   "last_sale": "1.74",
   "market_cap": "$5.34M",
   "IPOyear": "1993",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/scon",
   "FIELD9": ""
 },
 {
   "symbol": "SGC",
   "name": "Superior Group of Companies, Inc.",
   "last_sale": "19.9",
   "market_cap": "$304.7M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/sgc",
   "FIELD9": ""
 },
 {
   "symbol": "SUPN",
   "name": "Supernus Pharmaceuticals, Inc.",
   "last_sale": "48.9",
   "market_cap": "$2.55B",
   "IPOyear": "2012",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/supn",
   "FIELD9": ""
 },
 {
   "symbol": "SPRT",
   "name": "support.com, Inc.",
   "last_sale": "2.96",
   "market_cap": "$55.66M",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sprt",
   "FIELD9": ""
 },
 {
   "symbol": "SURF",
   "name": "Surface Oncology, Inc.",
   "last_sale": "12.01",
   "market_cap": "$331.65M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/surf",
   "FIELD9": ""
 },
 {
   "symbol": "SGRY",
   "name": "Surgery Partners, Inc.",
   "last_sale": "15.4",
   "market_cap": "$753.09M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/sgry",
   "FIELD9": ""
 },
 {
   "symbol": "SRDX",
   "name": "Surmodics, Inc.",
   "last_sale": "72.8",
   "market_cap": "$972M",
   "IPOyear": "1998",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/srdx",
   "FIELD9": ""
 },
 {
   "symbol": "SIVB",
   "name": "SVB Financial Group",
   "last_sale": "324.09",
   "market_cap": "$17.25B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sivb",
   "FIELD9": ""
 },
 {
   "symbol": "SYKE",
   "name": "Sykes Enterprises, Incorporated",
   "last_sale": "30.78",
   "market_cap": "$1.32B",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/syke",
   "FIELD9": ""
 },
 {
   "symbol": "SYMC",
   "name": "Symantec Corporation",
   "last_sale": "20.9",
   "market_cap": "$12.99B",
   "IPOyear": "1989",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/symc",
   "FIELD9": ""
 },
 {
   "symbol": "SYNC",
   "name": "Synacor, Inc.",
   "last_sale": "1.65",
   "market_cap": "$64.29M",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/sync",
   "FIELD9": ""
 },
 {
   "symbol": "SYNL",
   "name": "Synalloy Corporation",
   "last_sale": "22.7",
   "market_cap": "$199.81M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/synl",
   "FIELD9": ""
 },
 {
   "symbol": "SYNA",
   "name": "Synaptics Incorporated",
   "last_sale": "47.09",
   "market_cap": "$1.64B",
   "IPOyear": "2002",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/syna",
   "FIELD9": ""
 },
 {
   "symbol": "SNDX",
   "name": "Syndax Pharmaceuticals, Inc.",
   "last_sale": "6.77",
   "market_cap": "$158.11M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sndx",
   "FIELD9": ""
 },
 {
   "symbol": "SYNH",
   "name": "Syneos Health, Inc.",
   "last_sale": "49.1",
   "market_cap": "$5.05B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/synh",
   "FIELD9": ""
 },
 {
   "symbol": "SGYP",
   "name": "Synergy Pharmaceuticals, Inc.",
   "last_sale": "1.69",
   "market_cap": "$419.1M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sgyp",
   "FIELD9": ""
 },
 {
   "symbol": "SYBX",
   "name": "Synlogic, Inc.",
   "last_sale": "13",
   "market_cap": "$330.6M",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sybx",
   "FIELD9": ""
 },
 {
   "symbol": "SNPS",
   "name": "Synopsys, Inc.",
   "last_sale": "99.22",
   "market_cap": "$14.74B",
   "IPOyear": "1992",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/snps",
   "FIELD9": ""
 },
 {
   "symbol": "SYNT",
   "name": "Syntel, Inc.",
   "last_sale": "40.94",
   "market_cap": "$3.4B",
   "IPOyear": "1997",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/synt",
   "FIELD9": ""
 },
 {
   "symbol": "SES",
   "name": "Synthesis Energy Systems, Inc.",
   "last_sale": "2.3",
   "market_cap": "$25.3M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/ses",
   "FIELD9": ""
 },
 {
   "symbol": "SYPR",
   "name": "Sypris Solutions, Inc.",
   "last_sale": "1.36",
   "market_cap": "$29.1M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/sypr",
   "FIELD9": ""
 },
 {
   "symbol": "SYRS",
   "name": "Syros Pharmaceuticals, Inc.",
   "last_sale": "12.92",
   "market_cap": "$434.81M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/syrs",
   "FIELD9": ""
 },
 {
   "symbol": "TROW",
   "name": "T. Rowe Price Group, Inc.",
   "last_sale": "111.74",
   "market_cap": "$27.17B",
   "IPOyear": "1986",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/trow",
   "FIELD9": ""
 },
 {
   "symbol": "TTOO",
   "name": "T2 Biosystems, Inc.",
   "last_sale": "6.32",
   "market_cap": "$276.61M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/ttoo",
   "FIELD9": ""
 },
 {
   "symbol": "TRHC",
   "name": "Tabula Rasa HealthCare, Inc.",
   "last_sale": "77.83",
   "market_cap": "$1.58B",
   "IPOyear": "2016",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/trhc",
   "FIELD9": ""
 },
 {
   "symbol": "TCMD",
   "name": "Tactile Systems Technology, Inc.",
   "last_sale": "63.91",
   "market_cap": "$1.17B",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/tcmd",
   "FIELD9": ""
 },
 {
   "symbol": "TAIT",
   "name": "Taitron Components Incorporated",
   "last_sale": "2.13",
   "market_cap": "$11.94M",
   "IPOyear": "1995",
   "sector": "Consumer Non-Durables",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/tait",
   "FIELD9": ""
 },
 {
   "symbol": "TLC",
   "name": "Taiwan Liposome Company, Ltd.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tlc",
   "FIELD9": ""
 },
 {
   "symbol": "TTWO",
   "name": "Take-Two Interactive Software, Inc.",
   "last_sale": "132.06",
   "market_cap": "$15.03B",
   "IPOyear": "1997",
   "sector": "Communication Services",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ttwo",
   "FIELD9": ""
 },
 {
   "symbol": "TLND",
   "name": "Talend S.A.",
   "last_sale": "69.78",
   "market_cap": "$2.09B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/tlnd",
   "FIELD9": ""
 },
 {
   "symbol": "TNDM",
   "name": "Tandem Diabetes Care, Inc.",
   "last_sale": "43.59",
   "market_cap": "$2.49B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/tndm",
   "FIELD9": ""
 },
 {
   "symbol": "TLF",
   "name": "Tandy Leather Factory, Inc.",
   "last_sale": "7.45",
   "market_cap": "$68.2M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/tlf",
   "FIELD9": ""
 },
 {
   "symbol": "TANH",
   "name": "Tantech Holdings Ltd.",
   "last_sale": "1.63",
   "market_cap": "$46.79M",
   "IPOyear": "2015",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/tanh",
   "FIELD9": ""
 },
 {
   "symbol": "TAOP",
   "name": "Taoping Inc.",
   "last_sale": "1.31",
   "market_cap": "$53.4M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/taop",
   "FIELD9": ""
 },
 {
   "symbol": "TPIV",
   "name": "TapImmune Inc.",
   "last_sale": "9.57",
   "market_cap": "$131.21M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/tpiv",
   "FIELD9": ""
 },
 {
   "symbol": "TEDU",
   "name": "Tarena International, Inc.",
   "last_sale": "8.6",
   "market_cap": "$475.39M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tedu",
   "FIELD9": ""
 },
 {
   "symbol": "TATT",
   "name": "TAT Technologies Ltd.",
   "last_sale": "6.8501",
   "market_cap": "$62.49M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/tatt",
   "FIELD9": ""
 },
 {
   "symbol": "TAYD",
   "name": "Taylor Devices, Inc.",
   "last_sale": "11.7756",
   "market_cap": "$40.76M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/tayd",
   "FIELD9": ""
 },
 {
   "symbol": "CGBD",
   "name": "TCG BDC, Inc.",
   "last_sale": "17.2",
   "market_cap": "$1.08B",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cgbd",
   "FIELD9": ""
 },
 {
   "symbol": "AMTD",
   "name": "TD Ameritrade Holding Corporation",
   "last_sale": "55.48",
   "market_cap": "$31.49B",
   "IPOyear": "1997",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/amtd",
   "FIELD9": ""
 },
 {
   "symbol": "PETZ",
   "name": "TDH Holdings, Inc.",
   "last_sale": "1.68",
   "market_cap": "$15.83M",
   "IPOyear": "2017",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/petz",
   "FIELD9": ""
 },
 {
   "symbol": "TECD",
   "name": "Tech Data Corporation",
   "last_sale": "74.51",
   "market_cap": "$2.86B",
   "IPOyear": "1986",
   "sector": "Technology",
   "industry": "Retail: Computer Software & Peripheral Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tecd",
   "FIELD9": ""
 },
 {
   "symbol": "TCCO",
   "name": "Technical Communications Corporation",
   "last_sale": "4.7",
   "market_cap": "$8.69M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tcco",
   "FIELD9": ""
 },
 {
   "symbol": "TTGT",
   "name": "TechTarget, Inc.",
   "last_sale": "20",
   "market_cap": "$551.62M",
   "IPOyear": "2007",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ttgt",
   "FIELD9": ""
 },
 {
   "symbol": "TGLS",
   "name": "Tecnoglass Inc.",
   "last_sale": "9.25",
   "market_cap": "$342.64M",
   "IPOyear": "2012",
   "sector": "Consumer Durables",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/tgls",
   "FIELD9": ""
 },
 {
   "symbol": "TGEN",
   "name": "Tecogen Inc.",
   "last_sale": "3.04",
   "market_cap": "$75.45M",
   "IPOyear": "2014",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/tgen",
   "FIELD9": ""
 },
 {
   "symbol": "TNAV",
   "name": "Telenav, Inc.",
   "last_sale": "5.05",
   "market_cap": "$226.6M",
   "IPOyear": "2010",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/tnav",
   "FIELD9": ""
 },
 {
   "symbol": "TLGT",
   "name": "Teligent, Inc.",
   "last_sale": "3.82",
   "market_cap": "$204.51M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/tlgt",
   "FIELD9": ""
 },
 {
   "symbol": "TELL",
   "name": "Tellurian Inc.",
   "last_sale": "9.02",
   "market_cap": "$2.17B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/tell",
   "FIELD9": ""
 },
 {
   "symbol": "TENB",
   "name": "Tenable Holdings, Inc.",
   "last_sale": "37.36",
   "market_cap": "$3.48B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/tenb",
   "FIELD9": ""
 },
 {
   "symbol": "TENX",
   "name": "Tenax Therapeutics, Inc.",
   "last_sale": "5.41",
   "market_cap": "$7.93M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/tenx",
   "FIELD9": ""
 },
 {
   "symbol": "TZACU",
   "name": "Tenzing Acquisition Corp.",
   "last_sale": "10.075",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tzacu",
   "FIELD9": ""
 },
 {
   "symbol": "TERP",
   "name": "TerraForm Power, Inc.",
   "last_sale": "11.85",
   "market_cap": "$2.48B",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/terp",
   "FIELD9": ""
 },
 {
   "symbol": "TRTL",
   "name": "Terrapin 4 Acquisition Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/trtl",
   "FIELD9": ""
 },
 {
   "symbol": "TBNK",
   "name": "Territorial Bancorp Inc.",
   "last_sale": "29.53",
   "market_cap": "$287.61M",
   "IPOyear": "2009",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/tbnk",
   "FIELD9": ""
 },
 {
   "symbol": "TSRO",
   "name": "TESARO, Inc.",
   "last_sale": "37.69",
   "market_cap": "$2.07B",
   "IPOyear": "2012",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/tsro",
   "FIELD9": ""
 },
 {
   "symbol": "TSLA",
   "name": "Tesla, Inc. ",
   "last_sale": "299.1",
   "market_cap": "$51.02B",
   "IPOyear": "2010",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/tsla",
   "FIELD9": ""
 },
 {
   "symbol": "TESS",
   "name": "TESSCO Technologies Incorporated",
   "last_sale": "15.85",
   "market_cap": "$133.56M",
   "IPOyear": "1994",
   "sector": "Consumer Non-Durables",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/tess",
   "FIELD9": ""
 },
 {
   "symbol": "TTEK",
   "name": "Tetra Tech, Inc.",
   "last_sale": "69",
   "market_cap": "$3.82B",
   "IPOyear": "1991",
   "sector": "Consumer Services",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/ttek",
   "FIELD9": ""
 },
 {
   "symbol": "TTPH",
   "name": "Tetraphase Pharmaceuticals, Inc.",
   "last_sale": "2.92",
   "market_cap": "$154.35M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ttph",
   "FIELD9": ""
 },
 {
   "symbol": "TCBI",
   "name": "Texas Capital Bancshares, Inc.",
   "last_sale": "88.5",
   "market_cap": "$4.44B",
   "IPOyear": "2003",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tcbi",
   "FIELD9": ""
 },
 {
   "symbol": "TCBIL",
   "name": "Texas Capital Bancshares, Inc.",
   "last_sale": "25.6422",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tcbil",
   "FIELD9": ""
 },
 {
   "symbol": "TCBIP",
   "name": "Texas Capital Bancshares, Inc.",
   "last_sale": "25.279",
   "market_cap": "$151.67M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tcbip",
   "FIELD9": ""
 },
 {
   "symbol": "TCBIW",
   "name": "Texas Capital Bancshares, Inc.",
   "last_sale": "77",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tcbiw",
   "FIELD9": ""
 },
 {
   "symbol": "TXN",
   "name": "Texas Instruments Incorporated",
   "last_sale": "110.05",
   "market_cap": "$106.99B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/txn",
   "FIELD9": ""
 },
 {
   "symbol": "TXRH",
   "name": "Texas Roadhouse, Inc.",
   "last_sale": "70.57",
   "market_cap": "$5.04B",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/txrh",
   "FIELD9": ""
 },
 {
   "symbol": "TFIG",
   "name": "TFI TAB Gida Yatirimlari A.S.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tfig",
   "FIELD9": ""
 },
 {
   "symbol": "TFSL",
   "name": "TFS Financial Corporation",
   "last_sale": "15.58",
   "market_cap": "$4.37B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/tfsl",
   "FIELD9": ""
 },
 {
   "symbol": "TGTX",
   "name": "TG Therapeutics, Inc.",
   "last_sale": "9.05",
   "market_cap": "$749.51M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/tgtx",
   "FIELD9": ""
 },
 {
   "symbol": "ANDE",
   "name": "The Andersons, Inc.",
   "last_sale": "38.6",
   "market_cap": "$1.09B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/ande",
   "FIELD9": ""
 },
 {
   "symbol": "TBBK",
   "name": "The Bancorp, Inc.",
   "last_sale": "9.75",
   "market_cap": "$550.35M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tbbk",
   "FIELD9": ""
 },
 {
   "symbol": "BPRN",
   "name": "The Bank of Princeton",
   "last_sale": "33.02",
   "market_cap": "$219.29M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bprn",
   "FIELD9": ""
 },
 {
   "symbol": "CG",
   "name": "The Carlyle Group L.P.",
   "last_sale": "23.95",
   "market_cap": "$8.02B",
   "IPOyear": "2012",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/cg",
   "FIELD9": ""
 },
 {
   "symbol": "TCGP",
   "name": "The Carlyle Group L.P.",
   "last_sale": "22.77",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/tcgp",
   "FIELD9": ""
 },
 {
   "symbol": "CAKE",
   "name": "The Cheesecake Factory Incorporated",
   "last_sale": "52.32",
   "market_cap": "$2.4B",
   "IPOyear": "1992",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/cake",
   "FIELD9": ""
 },
 {
   "symbol": "CHEF",
   "name": "The Chefs&#39; Warehouse, Inc.",
   "last_sale": "37.05",
   "market_cap": "$1.11B",
   "IPOyear": "2011",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/chef",
   "FIELD9": ""
 },
 {
   "symbol": "TCFC",
   "name": "The Community Financial Corporation",
   "last_sale": "33.05",
   "market_cap": "$184.26M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tcfc",
   "FIELD9": ""
 },
 {
   "symbol": "DSGX",
   "name": "The Descartes Systems Group Inc.",
   "last_sale": "35.35",
   "market_cap": "$2.72B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/dsgx",
   "FIELD9": ""
 },
 {
   "symbol": "DXYN",
   "name": "The Dixie Group, Inc.",
   "last_sale": "1.9",
   "market_cap": "$31.26M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/dxyn",
   "FIELD9": ""
 },
 {
   "symbol": "ENSG",
   "name": "The Ensign Group, Inc.",
   "last_sale": "36.26",
   "market_cap": "$1.89B",
   "IPOyear": "2007",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/ensg",
   "FIELD9": ""
 },
 {
   "symbol": "XONE",
   "name": "The ExOne Company",
   "last_sale": "9.53",
   "market_cap": "$154.41M",
   "IPOyear": "2013",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/xone",
   "FIELD9": ""
 },
 {
   "symbol": "FBMS",
   "name": "The First Bancshares, Inc.",
   "last_sale": "40.15",
   "market_cap": "$524.6M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fbms",
   "FIELD9": ""
 },
 {
   "symbol": "FLIC",
   "name": "The First of Long Island Corporation",
   "last_sale": "22.55",
   "market_cap": "$573.24M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/flic",
   "FIELD9": ""
 },
 {
   "symbol": "GT",
   "name": "The Goodyear Tire & Rubber Company",
   "last_sale": "24.57",
   "market_cap": "$5.82B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/gt",
   "FIELD9": ""
 },
 {
   "symbol": "HABT",
   "name": "The Habit Restaurants, Inc.",
   "last_sale": "15.95",
   "market_cap": "$415.48M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/habt",
   "FIELD9": ""
 },
 {
   "symbol": "HCKT",
   "name": "The Hackett Group, Inc.",
   "last_sale": "20.27",
   "market_cap": "$597.19M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hckt",
   "FIELD9": ""
 },
 {
   "symbol": "HAIN",
   "name": "The Hain Celestial Group, Inc.",
   "last_sale": "26.26",
   "market_cap": "$2.73B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/hain",
   "FIELD9": ""
 },
 {
   "symbol": "CUBA",
   "name": "The Herzfeld Caribbean Basin Fund, Inc.",
   "last_sale": "6.6",
   "market_cap": "$40.48M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cuba",
   "FIELD9": ""
 },
 {
   "symbol": "INTG",
   "name": "The Intergroup Corporation",
   "last_sale": "33.95",
   "market_cap": "$79.79M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Building operators",
   "summary_quote": "https://www.nasdaq.com/symbol/intg",
   "FIELD9": ""
 },
 {
   "symbol": "JYNT",
   "name": "The Joint Corp.",
   "last_sale": "8.805",
   "market_cap": "$120.86M",
   "IPOyear": "2014",
   "sector": "Miscellaneous",
   "industry": "Multi-Sector Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/jynt",
   "FIELD9": ""
 },
 {
   "symbol": "KEYW",
   "name": "The KEYW Holding Corporation",
   "last_sale": "8.77",
   "market_cap": "$437.44M",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/keyw",
   "FIELD9": ""
 },
 {
   "symbol": "KHC",
   "name": "The Kraft Heinz Company",
   "last_sale": "57.12",
   "market_cap": "$69.64B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/khc",
   "FIELD9": ""
 },
 {
   "symbol": "OLD",
   "name": "The Long-Term Care ETF",
   "last_sale": "26.74",
   "market_cap": "$2.67M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/old",
   "FIELD9": ""
 },
 {
   "symbol": "LOVE",
   "name": "The Lovesac Company",
   "last_sale": "24.35",
   "market_cap": "$314.77M",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/love",
   "FIELD9": ""
 },
 {
   "symbol": "MSG",
   "name": "The Madison Square Garden Company",
   "last_sale": "304.16",
   "market_cap": "$7.2B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/msg",
   "FIELD9": ""
 },
 {
   "symbol": "MDCO",
   "name": "The Medicines Company",
   "last_sale": "33.76",
   "market_cap": "$2.49B",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mdco",
   "FIELD9": ""
 },
 {
   "symbol": "MEET",
   "name": "The Meet Group, Inc.",
   "last_sale": "4.81",
   "market_cap": "$352.86M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/meet",
   "FIELD9": ""
 },
 {
   "symbol": "MIK",
   "name": "The Michaels Companies, Inc.",
   "last_sale": "16.59",
   "market_cap": "$2.84B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/mik",
   "FIELD9": ""
 },
 {
   "symbol": "MIDD",
   "name": "The Middleby Corporation",
   "last_sale": "128.81",
   "market_cap": "$7.18B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/midd",
   "FIELD9": ""
 },
 {
   "symbol": "NAVG",
   "name": "The Navigators Group, Inc.",
   "last_sale": "69.1",
   "market_cap": "$2.06B",
   "IPOyear": "1986",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/navg",
   "FIELD9": ""
 },
 {
   "symbol": "SLIM",
   "name": "The Obesity ETF",
   "last_sale": "37.8623",
   "market_cap": "$3.79M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/slim",
   "FIELD9": ""
 },
 {
   "symbol": "STKS",
   "name": "The ONE Group Hospitality, Inc.",
   "last_sale": "3.1668",
   "market_cap": "$87.69M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/stks",
   "FIELD9": ""
 },
 {
   "symbol": "ORG",
   "name": "The Organics ETF",
   "last_sale": "31.8626",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/org",
   "FIELD9": ""
 },
 {
   "symbol": "PRSC",
   "name": "The Providence Service Corporation",
   "last_sale": "66.11",
   "market_cap": "$846.82M",
   "IPOyear": "2003",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/prsc",
   "FIELD9": ""
 },
 {
   "symbol": "RMR",
   "name": "The RMR Group Inc.",
   "last_sale": "89.9",
   "market_cap": "$2.8B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rmr",
   "FIELD9": ""
 },
 {
   "symbol": "SMPL",
   "name": "The Simply Good Foods Company",
   "last_sale": "18.04",
   "market_cap": "$1.27B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/smpl",
   "FIELD9": ""
 },
 {
   "symbol": "SMPLW",
   "name": "The Simply Good Foods Company",
   "last_sale": "6.53",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/smplw",
   "FIELD9": ""
 },
 {
   "symbol": "TSG",
   "name": "The Stars Group Inc.",
   "last_sale": "25.1",
   "market_cap": "$6.83B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/tsg",
   "FIELD9": ""
 },
 {
   "symbol": "TTD",
   "name": "The Trade Desk, Inc.",
   "last_sale": "141.86",
   "market_cap": "$6.09B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/ttd",
   "FIELD9": ""
 },
 {
   "symbol": "ULTI",
   "name": "The Ultimate Software Group, Inc.",
   "last_sale": "312.66",
   "market_cap": "$9.75B",
   "IPOyear": "1998",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ulti",
   "FIELD9": ""
 },
 {
   "symbol": "YORW",
   "name": "The York Water Company",
   "last_sale": "29.85",
   "market_cap": "$385.51M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/yorw",
   "FIELD9": ""
 },
 {
   "symbol": "NCTY",
   "name": "The9 Limited",
   "last_sale": "1.78",
   "market_cap": "$13.75M",
   "IPOyear": "2004",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ncty",
   "FIELD9": ""
 },
 {
   "symbol": "TXMD",
   "name": "TherapeuticsMD, Inc.",
   "last_sale": "6.605",
   "market_cap": "$1.55B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/txmd",
   "FIELD9": ""
 },
 {
   "symbol": "TRPX",
   "name": "Therapix Biosciences Ltd.",
   "last_sale": "4.81",
   "market_cap": "$16.82M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/trpx",
   "FIELD9": ""
 },
 {
   "symbol": "TBPH",
   "name": "Theravance Biopharma, Inc.",
   "last_sale": "29.04",
   "market_cap": "$1.6B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/tbph",
   "FIELD9": ""
 },
 {
   "symbol": "TST",
   "name": "TheStreet, Inc.",
   "last_sale": "2.29",
   "market_cap": "$113.59M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Newspapers/Magazines",
   "summary_quote": "https://www.nasdaq.com/symbol/tst",
   "FIELD9": ""
 },
 {
   "symbol": "TCRD",
   "name": "THL Credit, Inc.",
   "last_sale": "8.21",
   "market_cap": "$268.25M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tcrd",
   "FIELD9": ""
 },
 {
   "symbol": "TBRG",
   "name": "Thunder Bridge Acquisition, Ltd.",
   "last_sale": "9.7",
   "market_cap": "$75.65M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tbrg",
   "FIELD9": ""
 },
 {
   "symbol": "TBRGU",
   "name": "Thunder Bridge Acquisition, Ltd.",
   "last_sale": "10.13",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tbrgu",
   "FIELD9": ""
 },
 {
   "symbol": "TBRGW",
   "name": "Thunder Bridge Acquisition, Ltd.",
   "last_sale": "0.45",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tbrgw",
   "FIELD9": ""
 },
 {
   "symbol": "TIBR",
   "name": "Tiberius Acquisition Corporation",
   "last_sale": "9.67",
   "market_cap": "$54.43M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tibr",
   "FIELD9": ""
 },
 {
   "symbol": "TIBRU",
   "name": "Tiberius Acquisition Corporation",
   "last_sale": "10.22",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tibru",
   "FIELD9": ""
 },
 {
   "symbol": "TIBRW",
   "name": "Tiberius Acquisition Corporation",
   "last_sale": "0.62",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tibrw",
   "FIELD9": ""
 },
 {
   "symbol": "TTS",
   "name": "Tile Shop Hldgs, Inc.",
   "last_sale": "7.9",
   "market_cap": "$416.37M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/tts",
   "FIELD9": ""
 },
 {
   "symbol": "TLRY",
   "name": "Tilray, Inc.",
   "last_sale": "123",
   "market_cap": "$11.46B",
   "IPOyear": "2018",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/tlry",
   "FIELD9": ""
 },
 {
   "symbol": "TSBK",
   "name": "Timberland Bancorp, Inc.",
   "last_sale": "32.78",
   "market_cap": "$242.44M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tsbk",
   "FIELD9": ""
 },
 {
   "symbol": "TIPT",
   "name": "Tiptree Inc.",
   "last_sale": "6.4",
   "market_cap": "$234M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/tipt",
   "FIELD9": ""
 },
 {
   "symbol": "TITN",
   "name": "Titan Machinery Inc.",
   "last_sale": "17.76",
   "market_cap": "$394.59M",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/titn",
   "FIELD9": ""
 },
 {
   "symbol": "TMDI",
   "name": "Titan Medical Inc.",
   "last_sale": "2.255",
   "market_cap": "$48.88M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/tmdi",
   "FIELD9": ""
 },
 {
   "symbol": "TTNP",
   "name": "Titan Pharmaceuticals, Inc.",
   "last_sale": "0.2167",
   "market_cap": "$4.59M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/ttnp",
   "FIELD9": ""
 },
 {
   "symbol": "TVTY",
   "name": "Tivity Health, Inc.",
   "last_sale": "33.4",
   "market_cap": "$1.34B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/tvty",
   "FIELD9": ""
 },
 {
   "symbol": "TIVO",
   "name": "TiVo Corporation",
   "last_sale": "13.45",
   "market_cap": "$1.66B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Multi-Sector Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/tivo",
   "FIELD9": ""
 },
 {
   "symbol": "TKKS",
   "name": "TKK Symphony Acquisition Corporation",
   "last_sale": "9.51",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tkks",
   "FIELD9": ""
 },
 {
   "symbol": "TKKSR",
   "name": "TKK Symphony Acquisition Corporation",
   "last_sale": "0.4",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tkksr",
   "FIELD9": ""
 },
 {
   "symbol": "TKKSU",
   "name": "TKK Symphony Acquisition Corporation",
   "last_sale": "10.1",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tkksu",
   "FIELD9": ""
 },
 {
   "symbol": "TKKSW",
   "name": "TKK Symphony Acquisition Corporation",
   "last_sale": "0.23",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tkksw",
   "FIELD9": ""
 },
 {
   "symbol": "TMUS",
   "name": "T-Mobile US, Inc.",
   "last_sale": "69.07",
   "market_cap": "$58.52B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tmus",
   "FIELD9": ""
 },
 {
   "symbol": "TMSR",
   "name": "TMSR Holding Company Limited",
   "last_sale": "2",
   "market_cap": "$48.14M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tmsr",
   "FIELD9": ""
 },
 {
   "symbol": "TOCA",
   "name": "Tocagen Inc.",
   "last_sale": "13.62",
   "market_cap": "$271.73M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/toca",
   "FIELD9": ""
 },
 {
   "symbol": "TNXP",
   "name": "Tonix Pharmaceuticals Holding Corp.",
   "last_sale": "0.6434",
   "market_cap": "$6.12M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/tnxp",
   "FIELD9": ""
 },
 {
   "symbol": "TISA",
   "name": "Top Image Systems, Ltd.",
   "last_sale": "0.9499",
   "market_cap": "$17.34M",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tisa",
   "FIELD9": ""
 },
 {
   "symbol": "TOPS",
   "name": "TOP Ships Inc.",
   "last_sale": "1.1852",
   "market_cap": "$20.12M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/tops",
   "FIELD9": ""
 },
 {
   "symbol": "TRCH",
   "name": "Torchlight Energy Resources, Inc.",
   "last_sale": "1.07",
   "market_cap": "$74.97M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/trch",
   "FIELD9": ""
 },
 {
   "symbol": "TRMD",
   "name": "TORM plc",
   "last_sale": "5.9392",
   "market_cap": "$438.91M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/trmd",
   "FIELD9": ""
 },
 {
   "symbol": "TOTA",
   "name": "Tottenham Acquisition I Limited",
   "last_sale": "9.6699",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tota",
   "FIELD9": ""
 },
 {
   "symbol": "TOTAR",
   "name": "Tottenham Acquisition I Limited",
   "last_sale": "0.39",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/totar",
   "FIELD9": ""
 },
 {
   "symbol": "TOTAU",
   "name": "Tottenham Acquisition I Limited",
   "last_sale": "11.51",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/totau",
   "FIELD9": ""
 },
 {
   "symbol": "TOTAW",
   "name": "Tottenham Acquisition I Limited",
   "last_sale": "0.2",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/totaw",
   "FIELD9": ""
 },
 {
   "symbol": "TSEM",
   "name": "Tower Semiconductor Ltd.",
   "last_sale": "22.47",
   "market_cap": "$2.23B",
   "IPOyear": "1994",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/tsem",
   "FIELD9": ""
 },
 {
   "symbol": "CLUB",
   "name": "Town Sports International Holdings, Inc.",
   "last_sale": "8.75",
   "market_cap": "$237.92M",
   "IPOyear": "2006",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/club",
   "FIELD9": ""
 },
 {
   "symbol": "TOWN",
   "name": "Towne Bank",
   "last_sale": "32.05",
   "market_cap": "$2.32B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/town",
   "FIELD9": ""
 },
 {
   "symbol": "TPIC",
   "name": "TPI Composites, Inc.",
   "last_sale": "28.26",
   "market_cap": "$972.5M",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/tpic",
   "FIELD9": ""
 },
 {
   "symbol": "TCON",
   "name": "TRACON Pharmaceuticals, Inc.",
   "last_sale": "2.075",
   "market_cap": "$61.92M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/tcon",
   "FIELD9": ""
 },
 {
   "symbol": "TSCO",
   "name": "Tractor Supply Company",
   "last_sale": "89.97",
   "market_cap": "$10.96B",
   "IPOyear": "1994",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/tsco",
   "FIELD9": ""
 },
 {
   "symbol": "TWMC",
   "name": "Trans World Entertainment Corp.",
   "last_sale": "0.89",
   "market_cap": "$32.24M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Consumer Electronics/Video Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/twmc",
   "FIELD9": ""
 },
 {
   "symbol": "TACT",
   "name": "TransAct Technologies Incorporated",
   "last_sale": "14.7",
   "market_cap": "$108.45M",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tact",
   "FIELD9": ""
 },
 {
   "symbol": "TRNS",
   "name": "Transcat, Inc.",
   "last_sale": "22.1",
   "market_cap": "$159.12M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/trns",
   "FIELD9": ""
 },
 {
   "symbol": "TGA",
   "name": "TransGlobe Energy Corporation",
   "last_sale": "3.32",
   "market_cap": "$239.72M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/tga",
   "FIELD9": ""
 },
 {
   "symbol": "TBIO",
   "name": "Translate Bio, Inc.",
   "last_sale": "10.08",
   "market_cap": "$455.03M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/tbio",
   "FIELD9": ""
 },
 {
   "symbol": "TA",
   "name": "TravelCenters of America LLC",
   "last_sale": "5.6",
   "market_cap": "$222.72M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/ta",
   "FIELD9": ""
 },
 {
   "symbol": "TANNI",
   "name": "TravelCenters of America LLC",
   "last_sale": "25.15",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/tanni",
   "FIELD9": ""
 },
 {
   "symbol": "TANNL",
   "name": "TravelCenters of America LLC",
   "last_sale": "24.6478",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/tannl",
   "FIELD9": ""
 },
 {
   "symbol": "TANNZ",
   "name": "TravelCenters of America LLC",
   "last_sale": "24.95",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/tannz",
   "FIELD9": ""
 },
 {
   "symbol": "TZOO",
   "name": "Travelzoo",
   "last_sale": "11.05",
   "market_cap": "$135.74M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tzoo",
   "FIELD9": ""
 },
 {
   "symbol": "TRMT",
   "name": "Tremont Mortgage Trust",
   "last_sale": "11.62",
   "market_cap": "$36.52M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/trmt",
   "FIELD9": ""
 },
 {
   "symbol": "TRVN",
   "name": "Trevena, Inc.",
   "last_sale": "1.72",
   "market_cap": "$130.86M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/trvn",
   "FIELD9": ""
 },
 {
   "symbol": "TCDA",
   "name": "Tricida, Inc.",
   "last_sale": "36.52",
   "market_cap": "$1.54B",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/tcda",
   "FIELD9": ""
 },
 {
   "symbol": "TCBK",
   "name": "TriCo Bancshares",
   "last_sale": "39.23",
   "market_cap": "$1.19B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tcbk",
   "FIELD9": ""
 },
 {
   "symbol": "TDAC",
   "name": "Trident Acquisitions Corp.",
   "last_sale": "9.82",
   "market_cap": "$69.07M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tdac",
   "FIELD9": ""
 },
 {
   "symbol": "TDACU",
   "name": "Trident Acquisitions Corp.",
   "last_sale": "10.04",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tdacu",
   "FIELD9": ""
 },
 {
   "symbol": "TDACW",
   "name": "Trident Acquisitions Corp.",
   "last_sale": "0.3399",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tdacw",
   "FIELD9": ""
 },
 {
   "symbol": "TRIL",
   "name": "Trillium Therapeutics Inc.",
   "last_sale": "6",
   "market_cap": "$86.55M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/tril",
   "FIELD9": ""
 },
 {
   "symbol": "TRS",
   "name": "TriMas Corporation",
   "last_sale": "31.5",
   "market_cap": "$1.44B",
   "IPOyear": "2007",
   "sector": "Capital Goods",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/trs",
   "FIELD9": ""
 },
 {
   "symbol": "TRMB",
   "name": "Trimble Inc.",
   "last_sale": "43.64",
   "market_cap": "$10.91B",
   "IPOyear": "1990",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/trmb",
   "FIELD9": ""
 },
 {
   "symbol": "TRIB",
   "name": "Trinity Biotech plc",
   "last_sale": "3.92",
   "market_cap": "$82.04M",
   "IPOyear": "1992",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/trib",
   "FIELD9": ""
 },
 {
   "symbol": "TMCX",
   "name": "Trinity Merger Corp.",
   "last_sale": "9.8",
   "market_cap": "$103.27M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tmcx",
   "FIELD9": ""
 },
 {
   "symbol": "TMCXU",
   "name": "Trinity Merger Corp.",
   "last_sale": "10.25",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tmcxu",
   "FIELD9": ""
 },
 {
   "symbol": "TMCXW",
   "name": "Trinity Merger Corp.",
   "last_sale": "0.52",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tmcxw",
   "FIELD9": ""
 },
 {
   "symbol": "TRIP",
   "name": "TripAdvisor, Inc.",
   "last_sale": "50",
   "market_cap": "$6.88B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/trip",
   "FIELD9": ""
 },
 {
   "symbol": "TSC",
   "name": "TriState Capital Holdings, Inc.",
   "last_sale": "28.45",
   "market_cap": "$823.61M",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tsc",
   "FIELD9": ""
 },
 {
   "symbol": "TSCAP",
   "name": "TriState Capital Holdings, Inc.",
   "last_sale": "25.94",
   "market_cap": "$750.95M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tscap",
   "FIELD9": ""
 },
 {
   "symbol": "TBK",
   "name": "Triumph Bancorp, Inc.",
   "last_sale": "41.65",
   "market_cap": "$1.09B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tbk",
   "FIELD9": ""
 },
 {
   "symbol": "TRVG",
   "name": "trivago N.V.",
   "last_sale": "6.035",
   "market_cap": "$2.12B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/trvg",
   "FIELD9": ""
 },
 {
   "symbol": "TRNC",
   "name": "tronc, Inc.",
   "last_sale": "16.56",
   "market_cap": "$587.23M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Newspapers/Magazines",
   "summary_quote": "https://www.nasdaq.com/symbol/trnc",
   "FIELD9": ""
 },
 {
   "symbol": "TROV",
   "name": "TrovaGene, Inc.",
   "last_sale": "0.81",
   "market_cap": "$14.33M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/trov",
   "FIELD9": ""
 },
 {
   "symbol": "TRUE",
   "name": "TrueCar, Inc.",
   "last_sale": "14",
   "market_cap": "$1.43B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/true",
   "FIELD9": ""
 },
 {
   "symbol": "THST",
   "name": "Truett-Hurst, Inc.",
   "last_sale": "1.96",
   "market_cap": "$8.81M",
   "IPOyear": "2013",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/thst",
   "FIELD9": ""
 },
 {
   "symbol": "TRUP",
   "name": "Trupanion, Inc.",
   "last_sale": "34.95",
   "market_cap": "$1.16B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/trup",
   "FIELD9": ""
 },
 {
   "symbol": "TRST",
   "name": "TrustCo Bank Corp NY",
   "last_sale": "8.6",
   "market_cap": "$830.25M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/trst",
   "FIELD9": ""
 },
 {
   "symbol": "TRMK",
   "name": "Trustmark Corporation",
   "last_sale": "34.99",
   "market_cap": "$2.37B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/trmk",
   "FIELD9": ""
 },
 {
   "symbol": "TSRI",
   "name": "TSR, Inc.",
   "last_sale": "7.43",
   "market_cap": "$14.58M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tsri",
   "FIELD9": ""
 },
 {
   "symbol": "TTEC",
   "name": "TTEC Holdings, Inc.",
   "last_sale": "26.55",
   "market_cap": "$1.23B",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ttec",
   "FIELD9": ""
 },
 {
   "symbol": "TTMI",
   "name": "TTM Technologies, Inc.",
   "last_sale": "17.31",
   "market_cap": "$1.79B",
   "IPOyear": "2000",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/ttmi",
   "FIELD9": ""
 },
 {
   "symbol": "TCX",
   "name": "Tucows Inc.",
   "last_sale": "55.75",
   "market_cap": "$591.45M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tcx",
   "FIELD9": ""
 },
 {
   "symbol": "TUES",
   "name": "Tuesday Morning Corp.",
   "last_sale": "3.05",
   "market_cap": "$140.05M",
   "IPOyear": "1999",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/tues",
   "FIELD9": ""
 },
 {
   "symbol": "TOUR",
   "name": "Tuniu Corporation",
   "last_sale": "7.16",
   "market_cap": "$928.22M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tour",
   "FIELD9": ""
 },
 {
   "symbol": "HEAR",
   "name": "Turtle Beach Corporation",
   "last_sale": "20.7",
   "market_cap": "$285.58M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/hear",
   "FIELD9": ""
 },
 {
   "symbol": "TWLV",
   "name": "Twelve Seas Investment Company",
   "last_sale": "9.58",
   "market_cap": "$256.54M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/twlv",
   "FIELD9": ""
 },
 {
   "symbol": "TWLVR",
   "name": "Twelve Seas Investment Company",
   "last_sale": "0.41",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/twlvr",
   "FIELD9": ""
 },
 {
   "symbol": "TWLVU",
   "name": "Twelve Seas Investment Company",
   "last_sale": "10.3",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/twlvu",
   "FIELD9": ""
 },
 {
   "symbol": "TWLVW",
   "name": "Twelve Seas Investment Company",
   "last_sale": "0.4",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/twlvw",
   "FIELD9": ""
 },
 {
   "symbol": "FOX",
   "name": "Twenty-First Century Fox, Inc.",
   "last_sale": "43.89",
   "market_cap": "$81.31B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fox",
   "FIELD9": ""
 },
 {
   "symbol": "FOXA",
   "name": "Twenty-First Century Fox, Inc.",
   "last_sale": "44.33",
   "market_cap": "$54.12B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/foxa",
   "FIELD9": ""
 },
 {
   "symbol": "TWIN",
   "name": "Twin Disc, Incorporated",
   "last_sale": "22.81",
   "market_cap": "$263.11M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/twin",
   "FIELD9": ""
 },
 {
   "symbol": "TRCB",
   "name": "Two River Bancorp",
   "last_sale": "17.31",
   "market_cap": "$148.14M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/trcb",
   "FIELD9": ""
 },
 {
   "symbol": "TYME",
   "name": "Tyme Technologies, Inc.",
   "last_sale": "2.37",
   "market_cap": "$239.91M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/tyme",
   "FIELD9": ""
 },
 {
   "symbol": "USCR",
   "name": "U S Concrete, Inc.",
   "last_sale": "51.85",
   "market_cap": "$872.01M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/uscr",
   "FIELD9": ""
 },
 {
   "symbol": "PRTS",
   "name": "U.S. Auto Parts Network, Inc.",
   "last_sale": "1.6",
   "market_cap": "$51.52M",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/prts",
   "FIELD9": ""
 },
 {
   "symbol": "USEG",
   "name": "U.S. Energy Corp.",
   "last_sale": "0.9002",
   "market_cap": "$11.8M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/useg",
   "FIELD9": ""
 },
 {
   "symbol": "GROW",
   "name": "U.S. Global Investors, Inc.",
   "last_sale": "1.59",
   "market_cap": "$24.08M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/grow",
   "FIELD9": ""
 },
 {
   "symbol": "USAU",
   "name": "U.S. Gold Corp.",
   "last_sale": "1.02",
   "market_cap": "$17.98M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/usau",
   "FIELD9": ""
 },
 {
   "symbol": "UBNT",
   "name": "Ubiquiti Networks, Inc.",
   "last_sale": "98.58",
   "market_cap": "$7.3B",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ubnt",
   "FIELD9": ""
 },
 {
   "symbol": "UFPT",
   "name": "UFP Technologies, Inc.",
   "last_sale": "36.7",
   "market_cap": "$270.1M",
   "IPOyear": "1993",
   "sector": "Capital Goods",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/ufpt",
   "FIELD9": ""
 },
 {
   "symbol": "ULTA",
   "name": "Ulta Beauty, Inc.",
   "last_sale": "280.76",
   "market_cap": "$16.78B",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/ulta",
   "FIELD9": ""
 },
 {
   "symbol": "UCTT",
   "name": "Ultra Clean Holdings, Inc.",
   "last_sale": "13.66",
   "market_cap": "$531.86M",
   "IPOyear": "2004",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/uctt",
   "FIELD9": ""
 },
 {
   "symbol": "UPL",
   "name": "Ultra Petroleum Corp.",
   "last_sale": "1.3",
   "market_cap": "$256.17M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/upl",
   "FIELD9": ""
 },
 {
   "symbol": "RARE",
   "name": "Ultragenyx Pharmaceutical Inc.",
   "last_sale": "84.91",
   "market_cap": "$4.26B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rare",
   "FIELD9": ""
 },
 {
   "symbol": "ULBI",
   "name": "Ultralife Corporation",
   "last_sale": "9",
   "market_cap": "$143.51M",
   "IPOyear": "1992",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/ulbi",
   "FIELD9": ""
 },
 {
   "symbol": "UMBF",
   "name": "UMB Financial Corporation",
   "last_sale": "73.32",
   "market_cap": "$3.67B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/umbf",
   "FIELD9": ""
 },
 {
   "symbol": "UMPQ",
   "name": "Umpqua Holdings Corporation",
   "last_sale": "21.94",
   "market_cap": "$4.83B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/umpq",
   "FIELD9": ""
 },
 {
   "symbol": "UNAM",
   "name": "Unico American Corporation",
   "last_sale": "7.05",
   "market_cap": "$37.42M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/unam",
   "FIELD9": ""
 },
 {
   "symbol": "UBSH",
   "name": "Union Bankshares Corporation",
   "last_sale": "40.14",
   "market_cap": "$2.65B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ubsh",
   "FIELD9": ""
 },
 {
   "symbol": "UNB",
   "name": "Union Bankshares, Inc.",
   "last_sale": "53.4",
   "market_cap": "$238.47M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/unb",
   "FIELD9": ""
 },
 {
   "symbol": "QURE",
   "name": "uniQure N.V.",
   "last_sale": "38.46",
   "market_cap": "$1.43B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/qure",
   "FIELD9": ""
 },
 {
   "symbol": "UBCP",
   "name": "United Bancorp, Inc.",
   "last_sale": "13.2",
   "market_cap": "$71.07M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ubcp",
   "FIELD9": ""
 },
 {
   "symbol": "UBOH",
   "name": "United Bancshares, Inc.",
   "last_sale": "23.4",
   "market_cap": "$76.47M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/uboh",
   "FIELD9": ""
 },
 {
   "symbol": "UBSI",
   "name": "United Bankshares, Inc.",
   "last_sale": "38",
   "market_cap": "$3.95B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ubsi",
   "FIELD9": ""
 },
 {
   "symbol": "UCBI",
   "name": "United Community Banks, Inc.",
   "last_sale": "29.23",
   "market_cap": "$2.31B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ucbi",
   "FIELD9": ""
 },
 {
   "symbol": "UCFC",
   "name": "United Community Financial Corp.",
   "last_sale": "10.02",
   "market_cap": "$500.29M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ucfc",
   "FIELD9": ""
 },
 {
   "symbol": "UAL",
   "name": "United Continental Holdings, Inc.",
   "last_sale": "89.93",
   "market_cap": "$24.52B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ual",
   "FIELD9": ""
 },
 {
   "symbol": "UBNK",
   "name": "United Financial Bancorp, Inc. ",
   "last_sale": "17.35",
   "market_cap": "$887.01M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ubnk",
   "FIELD9": ""
 },
 {
   "symbol": "UFCS",
   "name": "United Fire Group, Inc",
   "last_sale": "51.76",
   "market_cap": "$1.3B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/ufcs",
   "FIELD9": ""
 },
 {
   "symbol": "UIHC",
   "name": "United Insurance Holdings Corp.",
   "last_sale": "21.4",
   "market_cap": "$916.39M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/uihc",
   "FIELD9": ""
 },
 {
   "symbol": "UNFI",
   "name": "United Natural Foods, Inc.",
   "last_sale": "30.97",
   "market_cap": "$1.56B",
   "IPOyear": "1996",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/unfi",
   "FIELD9": ""
 },
 {
   "symbol": "UBFO",
   "name": "United Security Bancshares",
   "last_sale": "11.275",
   "market_cap": "$190.57M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ubfo",
   "FIELD9": ""
 },
 {
   "symbol": "USLM",
   "name": "United States Lime & Minerals, Inc.",
   "last_sale": "77.58",
   "market_cap": "$434.29M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/uslm",
   "FIELD9": ""
 },
 {
   "symbol": "UTHR",
   "name": "United Therapeutics Corporation",
   "last_sale": "122.74",
   "market_cap": "$5.35B",
   "IPOyear": "1999",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/uthr",
   "FIELD9": ""
 },
 {
   "symbol": "UG",
   "name": "United-Guardian, Inc.",
   "last_sale": "16.5",
   "market_cap": "$75.81M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/ug",
   "FIELD9": ""
 },
 {
   "symbol": "UNIT",
   "name": "Uniti Group Inc.",
   "last_sale": "20.86",
   "market_cap": "$3.66B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/unit",
   "FIELD9": ""
 },
 {
   "symbol": "UNTY",
   "name": "Unity Bancorp, Inc.",
   "last_sale": "23.05",
   "market_cap": "$247.47M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/unty",
   "FIELD9": ""
 },
 {
   "symbol": "UBX",
   "name": "Unity Biotechnology, Inc.",
   "last_sale": "16",
   "market_cap": "$677.04M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ubx",
   "FIELD9": ""
 },
 {
   "symbol": "OLED",
   "name": "Universal Display Corporation",
   "last_sale": "121.4",
   "market_cap": "$5.72B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/oled",
   "FIELD9": ""
 },
 {
   "symbol": "UEIC",
   "name": "Universal Electronics Inc.",
   "last_sale": "40.1",
   "market_cap": "$554.62M",
   "IPOyear": "1993",
   "sector": "Consumer Non-Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/ueic",
   "FIELD9": ""
 },
 {
   "symbol": "UFPI",
   "name": "Universal Forest Products, Inc.",
   "last_sale": "35.52",
   "market_cap": "$2.19B",
   "IPOyear": "1993",
   "sector": "Basic Industries",
   "industry": "Forest Products",
   "summary_quote": "https://www.nasdaq.com/symbol/ufpi",
   "FIELD9": ""
 },
 {
   "symbol": "ULH",
   "name": "Universal Logistics Holdings, Inc.",
   "last_sale": "36.15",
   "market_cap": "$1.03B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ulh",
   "FIELD9": ""
 },
 {
   "symbol": "USAP",
   "name": "Universal Stainless & Alloy Products, Inc.",
   "last_sale": "27.07",
   "market_cap": "$235.22M",
   "IPOyear": "1994",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/usap",
   "FIELD9": ""
 },
 {
   "symbol": "UVSP",
   "name": "Univest Corporation of Pennsylvania",
   "last_sale": "27.25",
   "market_cap": "$801.25M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/uvsp",
   "FIELD9": ""
 },
 {
   "symbol": "UMRX",
   "name": "Unum Therapeutics Inc.",
   "last_sale": "12.16",
   "market_cap": "$363.19M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/umrx",
   "FIELD9": ""
 },
 {
   "symbol": "UPLD",
   "name": "Upland Software, Inc.",
   "last_sale": "33.47",
   "market_cap": "$721.54M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/upld",
   "FIELD9": ""
 },
 {
   "symbol": "UONE",
   "name": "Urban One, Inc. ",
   "last_sale": "2.25",
   "market_cap": "$107.09M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/uone",
   "FIELD9": ""
 },
 {
   "symbol": "UONEK",
   "name": "Urban One, Inc. ",
   "last_sale": "1.95",
   "market_cap": "$92.81M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/uonek",
   "FIELD9": ""
 },
 {
   "symbol": "URBN",
   "name": "Urban Outfitters, Inc.",
   "last_sale": "40.72",
   "market_cap": "$4.44B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/urbn",
   "FIELD9": ""
 },
 {
   "symbol": "URGN",
   "name": "UroGen Pharma Ltd.",
   "last_sale": "49.54",
   "market_cap": "$785.37M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/urgn",
   "FIELD9": ""
 },
 {
   "symbol": "ECOL",
   "name": "US Ecology, Inc.",
   "last_sale": "76.55",
   "market_cap": "$1.68B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ecol",
   "FIELD9": ""
 },
 {
   "symbol": "USAT",
   "name": "USA Technologies, Inc.",
   "last_sale": "8.75",
   "market_cap": "$469.62M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/usat",
   "FIELD9": ""
 },
 {
   "symbol": "USATP",
   "name": "USA Technologies, Inc.",
   "last_sale": "22.5",
   "market_cap": "$10.01M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/usatp",
   "FIELD9": ""
 },
 {
   "symbol": "USAK",
   "name": "USA Truck, Inc.",
   "last_sale": "21.09",
   "market_cap": "$175.31M",
   "IPOyear": "1992",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/usak",
   "FIELD9": ""
 },
 {
   "symbol": "UTMD",
   "name": "Utah Medical Products, Inc.",
   "last_sale": "95.2",
   "market_cap": "$355.38M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/utmd",
   "FIELD9": ""
 },
 {
   "symbol": "UTSI",
   "name": "UTStarcom Holdings Corp",
   "last_sale": "3.82",
   "market_cap": "$137.11M",
   "IPOyear": "2000",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/utsi",
   "FIELD9": ""
 },
 {
   "symbol": "UXIN",
   "name": "Uxin Limited",
   "last_sale": "5.45",
   "market_cap": "$1.59B",
   "IPOyear": "2018",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/uxin",
   "FIELD9": ""
 },
 {
   "symbol": "VCNX",
   "name": "Vaccinex, Inc.",
   "last_sale": "8.18",
   "market_cap": "$93.87M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vcnx",
   "FIELD9": ""
 },
 {
   "symbol": "VLRX",
   "name": "Valeritas Holdings, Inc.",
   "last_sale": "1.003",
   "market_cap": "$24.93M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/vlrx",
   "FIELD9": ""
 },
 {
   "symbol": "VALX",
   "name": "Validea Market Legends ETF",
   "last_sale": "29.75",
   "market_cap": "$26.78M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/valx",
   "FIELD9": ""
 },
 {
   "symbol": "VALU",
   "name": "Value Line, Inc.",
   "last_sale": "24.5431",
   "market_cap": "$237.81M",
   "IPOyear": "1983",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/valu",
   "FIELD9": ""
 },
 {
   "symbol": "VNDA",
   "name": "Vanda Pharmaceuticals Inc.",
   "last_sale": "20.05",
   "market_cap": "$1.05B",
   "IPOyear": "2006",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vnda",
   "FIELD9": ""
 },
 {
   "symbol": "BBH",
   "name": "VanEck Vectors Biotech ETF",
   "last_sale": "132.32",
   "market_cap": "$462.66M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbh",
   "FIELD9": ""
 },
 {
   "symbol": "GNRX",
   "name": "VanEck Vectors Generic Drugs ETF",
   "last_sale": "25.45",
   "market_cap": "$3.82M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gnrx",
   "FIELD9": ""
 },
 {
   "symbol": "PPH",
   "name": "VanEck Vectors Pharmaceutical ETF",
   "last_sale": "64.37",
   "market_cap": "$276.03M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pph",
   "FIELD9": ""
 },
 {
   "symbol": "VWOB",
   "name": "Vanguard Emerging Markets Government Bond ETF",
   "last_sale": "75.37",
   "market_cap": "$1.02B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vwob",
   "FIELD9": ""
 },
 {
   "symbol": "VNQI",
   "name": "Vanguard Global ex-U.S. Real Estate ETF",
   "last_sale": "57.57",
   "market_cap": "$5.97B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vnqi",
   "FIELD9": ""
 },
 {
   "symbol": "VCIT",
   "name": "Vanguard Intermediate-Term Corporate Bond ETF",
   "last_sale": "83.39",
   "market_cap": "$19.11B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vcit",
   "FIELD9": ""
 },
 {
   "symbol": "VGIT",
   "name": "Vanguard Intermediate-Term Treasury ETF",
   "last_sale": "62.03",
   "market_cap": "$2.66B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vgit",
   "FIELD9": ""
 },
 {
   "symbol": "VIGI",
   "name": "Vanguard International Dividend Appreciation ETF",
   "last_sale": "65.05",
   "market_cap": "$925.35M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vigi",
   "FIELD9": ""
 },
 {
   "symbol": "VYMI",
   "name": "Vanguard International High Dividend Yield ETF",
   "last_sale": "63.85",
   "market_cap": "$996.73M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vymi",
   "FIELD9": ""
 },
 {
   "symbol": "VCLT",
   "name": "Vanguard Long-Term Corporate Bond ETF",
   "last_sale": "87.58",
   "market_cap": "$2.55B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vclt",
   "FIELD9": ""
 },
 {
   "symbol": "VGLT",
   "name": "Vanguard Long-Treasury ETF",
   "last_sale": "72.05",
   "market_cap": "$642.49M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vglt",
   "FIELD9": ""
 },
 {
   "symbol": "VMBS",
   "name": "Vanguard Mortgage-Backed Securities ETF",
   "last_sale": "50.92",
   "market_cap": "$7.15B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vmbs",
   "FIELD9": ""
 },
 {
   "symbol": "VONE",
   "name": "Vanguard Russell 1000 ETF",
   "last_sale": "134.77",
   "market_cap": "$1B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vone",
   "FIELD9": ""
 },
 {
   "symbol": "VONG",
   "name": "Vanguard Russell 1000 Growth ETF",
   "last_sale": "159.4",
   "market_cap": "$2.23B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vong",
   "FIELD9": ""
 },
 {
   "symbol": "VONV",
   "name": "Vanguard Russell 1000 Value ETF",
   "last_sale": "113.31",
   "market_cap": "$1.63B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vonv",
   "FIELD9": ""
 },
 {
   "symbol": "VTWO",
   "name": "Vanguard Russell 2000 ETF",
   "last_sale": "136.8901",
   "market_cap": "$1.7B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vtwo",
   "FIELD9": ""
 },
 {
   "symbol": "VTWG",
   "name": "Vanguard Russell 2000 Growth ETF",
   "last_sale": "156.71",
   "market_cap": "$325.17M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vtwg",
   "FIELD9": ""
 },
 {
   "symbol": "VTWV",
   "name": "Vanguard Russell 2000 Value ETF",
   "last_sale": "117.8447",
   "market_cap": "$220.96M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vtwv",
   "FIELD9": ""
 },
 {
   "symbol": "VTHR",
   "name": "Vanguard Russell 3000 ETF",
   "last_sale": "135.15",
   "market_cap": "$415.59M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vthr",
   "FIELD9": ""
 },
 {
   "symbol": "VCSH",
   "name": "Vanguard Short-Term Corporate Bond ETF",
   "last_sale": "78.06",
   "market_cap": "$21.41B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vcsh",
   "FIELD9": ""
 },
 {
   "symbol": "VTIP",
   "name": "Vanguard Short-Term Inflation-Protected Securities Index Fund",
   "last_sale": "48.83",
   "market_cap": "$5.42B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vtip",
   "FIELD9": ""
 },
 {
   "symbol": "VGSH",
   "name": "Vanguard Short-Term Treasury ETF",
   "last_sale": "59.71",
   "market_cap": "$3.16B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vgsh",
   "FIELD9": ""
 },
 {
   "symbol": "BND",
   "name": "Vanguard Total Bond Market ETF",
   "last_sale": "78.6",
   "market_cap": "$35.97B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bnd",
   "FIELD9": ""
 },
 {
   "symbol": "VTC",
   "name": "Vanguard Total Corporate Bond ETF",
   "last_sale": "80.96",
   "market_cap": "$54.65M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vtc",
   "FIELD9": ""
 },
 {
   "symbol": "BNDX",
   "name": "Vanguard Total International Bond ETF",
   "last_sale": "54.6",
   "market_cap": "$11.93B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bndx",
   "FIELD9": ""
 },
 {
   "symbol": "VXUS",
   "name": "Vanguard Total International Stock ETF",
   "last_sale": "54.69",
   "market_cap": "$11.47B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vxus",
   "FIELD9": ""
 },
 {
   "symbol": "BNDW",
   "name": "Vanguard Total World Bond ETF",
   "last_sale": "74.7696",
   "market_cap": "$22.43M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bndw",
   "FIELD9": ""
 },
 {
   "symbol": "VEAC",
   "name": "Vantage Energy Acquisition Corp.",
   "last_sale": "10.05",
   "market_cap": "$158.09M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/veac",
   "FIELD9": ""
 },
 {
   "symbol": "VEACU",
   "name": "Vantage Energy Acquisition Corp.",
   "last_sale": "10.6",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/veacu",
   "FIELD9": ""
 },
 {
   "symbol": "VEACW",
   "name": "Vantage Energy Acquisition Corp.",
   "last_sale": "1.35",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/veacw",
   "FIELD9": ""
 },
 {
   "symbol": "VREX",
   "name": "Varex Imaging Corporation",
   "last_sale": "29.95",
   "market_cap": "$1.14B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/vrex",
   "FIELD9": ""
 },
 {
   "symbol": "VRNS",
   "name": "Varonis Systems, Inc.",
   "last_sale": "71.3",
   "market_cap": "$2.08B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/vrns",
   "FIELD9": ""
 },
 {
   "symbol": "VBLT",
   "name": "Vascular Biogenics Ltd.",
   "last_sale": "1.6",
   "market_cap": "$57.37M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vblt",
   "FIELD9": ""
 },
 {
   "symbol": "VXRT",
   "name": "Vaxart, Inc.",
   "last_sale": "3.05",
   "market_cap": "$21.78M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/vxrt",
   "FIELD9": ""
 },
 {
   "symbol": "VBIV",
   "name": "VBI Vaccines, Inc.",
   "last_sale": "1.92",
   "market_cap": "$123.62M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/vbiv",
   "FIELD9": ""
 },
 {
   "symbol": "VTIQ",
   "name": "VectoIQ Acquisition Corp.",
   "last_sale": "9.57",
   "market_cap": "$66.94M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/vtiq",
   "FIELD9": ""
 },
 {
   "symbol": "VTIQU",
   "name": "VectoIQ Acquisition Corp.",
   "last_sale": "10.15",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/vtiqu",
   "FIELD9": ""
 },
 {
   "symbol": "VTIQW",
   "name": "VectoIQ Acquisition Corp.",
   "last_sale": "0.63",
   "market_cap": "$4.41M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/vtiqw",
   "FIELD9": ""
 },
 {
   "symbol": "VECO",
   "name": "Veeco Instruments Inc.",
   "last_sale": "10.7",
   "market_cap": "$522.07M",
   "IPOyear": "1994",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/veco",
   "FIELD9": ""
 },
 {
   "symbol": "VEON",
   "name": "VEON Ltd.",
   "last_sale": "2.935",
   "market_cap": "$5.13B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/veon",
   "FIELD9": ""
 },
 {
   "symbol": "VRA",
   "name": "Vera Bradley, Inc.",
   "last_sale": "15.4",
   "market_cap": "$544.49M",
   "IPOyear": "2010",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/vra",
   "FIELD9": ""
 },
 {
   "symbol": "VCYT",
   "name": "Veracyte, Inc.",
   "last_sale": "10.03",
   "market_cap": "$346.37M",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/vcyt",
   "FIELD9": ""
 },
 {
   "symbol": "VSTM",
   "name": "Verastem, Inc.",
   "last_sale": "8.67",
   "market_cap": "$638.04M",
   "IPOyear": "2012",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vstm",
   "FIELD9": ""
 },
 {
   "symbol": "VCEL",
   "name": "Vericel Corporation",
   "last_sale": "14.1",
   "market_cap": "$602.44M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/vcel",
   "FIELD9": ""
 },
 {
   "symbol": "VRNT",
   "name": "Verint Systems Inc.",
   "last_sale": "48.4",
   "market_cap": "$3.14B",
   "IPOyear": "2002",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/vrnt",
   "FIELD9": ""
 },
 {
   "symbol": "VRSN",
   "name": "VeriSign, Inc.",
   "last_sale": "159.85",
   "market_cap": "$19.49B",
   "IPOyear": "1998",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/vrsn",
   "FIELD9": ""
 },
 {
   "symbol": "VRSK",
   "name": "Verisk Analytics, Inc.",
   "last_sale": "120.03",
   "market_cap": "$19.77B",
   "IPOyear": "2009",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/vrsk",
   "FIELD9": ""
 },
 {
   "symbol": "VBTX",
   "name": "Veritex Holdings, Inc.",
   "last_sale": "29.64",
   "market_cap": "$716.76M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/vbtx",
   "FIELD9": ""
 },
 {
   "symbol": "VERI",
   "name": "Veritone, Inc.",
   "last_sale": "10.69",
   "market_cap": "$201.12M",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/veri",
   "FIELD9": ""
 },
 {
   "symbol": "VRML",
   "name": "Vermillion, Inc.",
   "last_sale": "0.71",
   "market_cap": "$53.44M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: In Vitro & In Vivo Diagnostic Substances",
   "summary_quote": "https://www.nasdaq.com/symbol/vrml",
   "FIELD9": ""
 },
 {
   "symbol": "VRNA",
   "name": "Verona Pharma plc",
   "last_sale": "12.5",
   "market_cap": "$164.18M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vrna",
   "FIELD9": ""
 },
 {
   "symbol": "VRCA",
   "name": "Verrica Pharmaceuticals Inc.",
   "last_sale": "16.32",
   "market_cap": "$419.36M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vrca",
   "FIELD9": ""
 },
 {
   "symbol": "VSAR",
   "name": "Versartis, Inc.",
   "last_sale": "1.4",
   "market_cap": "$50.74M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vsar",
   "FIELD9": ""
 },
 {
   "symbol": "VTNR",
   "name": "Vertex Energy, Inc",
   "last_sale": "1.76",
   "market_cap": "$61.64M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/vtnr",
   "FIELD9": ""
 },
 {
   "symbol": "VRTX",
   "name": "Vertex Pharmaceuticals Incorporated",
   "last_sale": "180.08",
   "market_cap": "$46.02B",
   "IPOyear": "1991",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vrtx",
   "FIELD9": ""
 },
 {
   "symbol": "VERU",
   "name": "Veru Inc.",
   "last_sale": "1.83",
   "market_cap": "$101.17M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/veru",
   "FIELD9": ""
 },
 {
   "symbol": "VIA",
   "name": "Viacom Inc.",
   "last_sale": "34.55",
   "market_cap": "$13.92B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/via",
   "FIELD9": ""
 },
 {
   "symbol": "VIAB",
   "name": "Viacom Inc.",
   "last_sale": "32.37",
   "market_cap": "$11.25B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/viab",
   "FIELD9": ""
 },
 {
   "symbol": "VMET",
   "name": "Viamet Pharmaceuticals Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vmet",
   "FIELD9": ""
 },
 {
   "symbol": "VSAT",
   "name": "ViaSat, Inc.",
   "last_sale": "62.88",
   "market_cap": "$3.74B",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/vsat",
   "FIELD9": ""
 },
 {
   "symbol": "VIAV",
   "name": "Viavi Solutions Inc.",
   "last_sale": "11.25",
   "market_cap": "$2.55B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/viav",
   "FIELD9": ""
 },
 {
   "symbol": "VICL",
   "name": "Vical Incorporated",
   "last_sale": "1.37",
   "market_cap": "$29.89M",
   "IPOyear": "1993",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/vicl",
   "FIELD9": ""
 },
 {
   "symbol": "VICR",
   "name": "Vicor Corporation",
   "last_sale": "49.25",
   "market_cap": "$1.97B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/vicr",
   "FIELD9": ""
 },
 {
   "symbol": "VCTR",
   "name": "Victory Capital Holdings, Inc.",
   "last_sale": "9.09",
   "market_cap": "$617.28M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/vctr",
   "FIELD9": ""
 },
 {
   "symbol": "CIZ",
   "name": "VictoryShares Developed Enhanced Volatility Wtd ETF",
   "last_sale": "34.5302",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ciz",
   "FIELD9": ""
 },
 {
   "symbol": "VSDA",
   "name": "VictoryShares Dividend Accelerator ETF",
   "last_sale": "31.45",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vsda",
   "FIELD9": ""
 },
 {
   "symbol": "CEY",
   "name": "VictoryShares Emerging Market High Div Volatility Wtd ETF",
   "last_sale": "24.04",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cey",
   "FIELD9": ""
 },
 {
   "symbol": "CEZ",
   "name": "VictoryShares Emerging Market Volatility Wtd ETF",
   "last_sale": "27.3345",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cez",
   "FIELD9": ""
 },
 {
   "symbol": "CID",
   "name": "VictoryShares International High Div Volatility Wtd ETF",
   "last_sale": "33.9585",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cid",
   "FIELD9": ""
 },
 {
   "symbol": "CIL",
   "name": "VictoryShares International Volatility Wtd ETF",
   "last_sale": "40.32",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cil",
   "FIELD9": ""
 },
 {
   "symbol": "CFO",
   "name": "VictoryShares US 500 Enhanced Volatility Wtd ETF",
   "last_sale": "52.5338",
   "market_cap": "$36.77M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cfo",
   "FIELD9": ""
 },
 {
   "symbol": "CFA",
   "name": "VictoryShares US 500 Volatility Wtd ETF",
   "last_sale": "52.53",
   "market_cap": "$10.51M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cfa",
   "FIELD9": ""
 },
 {
   "symbol": "CSF",
   "name": "VictoryShares US Discovery Enhanced Volatility Wtd ETF",
   "last_sale": "49.2901",
   "market_cap": "$125.69M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/csf",
   "FIELD9": ""
 },
 {
   "symbol": "CDC",
   "name": "VictoryShares US EQ Income Enhanced Volatility Wtd ETF",
   "last_sale": "48.35",
   "market_cap": "$31.43M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cdc",
   "FIELD9": ""
 },
 {
   "symbol": "CDL",
   "name": "VictoryShares US Large Cap High Div Volatility Wtd ETF",
   "last_sale": "47.078",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cdl",
   "FIELD9": ""
 },
 {
   "symbol": "VSMV",
   "name": "VictoryShares US Multi-Factor Minimum Volatility ETF",
   "last_sale": "30.29",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vsmv",
   "FIELD9": ""
 },
 {
   "symbol": "CSB",
   "name": "VictoryShares US Small Cap High Div Volatility Wtd ETF",
   "last_sale": "48.055",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/csb",
   "FIELD9": ""
 },
 {
   "symbol": "CSA",
   "name": "VictoryShares US Small Cap Volatility Wtd ETF",
   "last_sale": "50.46",
   "market_cap": "$2.59B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/csa",
   "FIELD9": ""
 },
 {
   "symbol": "VRAY",
   "name": "ViewRay, Inc.",
   "last_sale": "9.74",
   "market_cap": "$914.15M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/vray",
   "FIELD9": ""
 },
 {
   "symbol": "VKTX",
   "name": "Viking Therapeutics, Inc.",
   "last_sale": "18.2",
   "market_cap": "$1.1B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vktx",
   "FIELD9": ""
 },
 {
   "symbol": "VKTXW",
   "name": "Viking Therapeutics, Inc.",
   "last_sale": "16.8",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vktxw",
   "FIELD9": ""
 },
 {
   "symbol": "VBFC",
   "name": "Village Bank and Trust Financial Corp.",
   "last_sale": "35",
   "market_cap": "$50.19M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/vbfc",
   "FIELD9": ""
 },
 {
   "symbol": "VLGEA",
   "name": "Village Super Market, Inc.",
   "last_sale": "28.5",
   "market_cap": "$409.7M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Food Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/vlgea",
   "FIELD9": ""
 },
 {
   "symbol": "VIOT",
   "name": "Viomi Technology Co., Ltd",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/viot",
   "FIELD9": ""
 },
 {
   "symbol": "VNOM",
   "name": "Viper Energy Partners LP",
   "last_sale": "41.72",
   "market_cap": "$5.17B",
   "IPOyear": "2014",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/vnom",
   "FIELD9": ""
 },
 {
   "symbol": "VIRC",
   "name": "Virco Manufacturing Corporation",
   "last_sale": "4.15",
   "market_cap": "$63.73M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/virc",
   "FIELD9": ""
 },
 {
   "symbol": "VTSI",
   "name": "VirTra, Inc.",
   "last_sale": "5.3",
   "market_cap": "$41.93M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/vtsi",
   "FIELD9": ""
 },
 {
   "symbol": "VIRT",
   "name": "Virtu Financial, Inc.",
   "last_sale": "22",
   "market_cap": "$4.19B",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/virt",
   "FIELD9": ""
 },
 {
   "symbol": "VRTS",
   "name": "Virtus Investment Partners, Inc.",
   "last_sale": "121.7",
   "market_cap": "$872.12M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/vrts",
   "FIELD9": ""
 },
 {
   "symbol": "VRTSP",
   "name": "Virtus Investment Partners, Inc.",
   "last_sale": "102.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/vrtsp",
   "FIELD9": ""
 },
 {
   "symbol": "BBC",
   "name": "Virtus LifeSci Biotech Clinical Trials ETF",
   "last_sale": "34.52",
   "market_cap": "$34.52M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbc",
   "FIELD9": ""
 },
 {
   "symbol": "BBP",
   "name": "Virtus LifeSci Biotech Products ETF",
   "last_sale": "44.2099",
   "market_cap": "$44.21M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbp",
   "FIELD9": ""
 },
 {
   "symbol": "VRTU",
   "name": "Virtusa Corporation",
   "last_sale": "53.42",
   "market_cap": "$1.59B",
   "IPOyear": "2007",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/vrtu",
   "FIELD9": ""
 },
 {
   "symbol": "VTGN",
   "name": "VistaGen Therapeutics, Inc.",
   "last_sale": "1.3524",
   "market_cap": "$34.91M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vtgn",
   "FIELD9": ""
 },
 {
   "symbol": "VC",
   "name": "Visteon Corporation",
   "last_sale": "102.43",
   "market_cap": "$3.01B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/vc",
   "FIELD9": ""
 },
 {
   "symbol": "VIST",
   "name": "Visterra, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vist",
   "FIELD9": ""
 },
 {
   "symbol": "VTL",
   "name": "Vital Therapies, Inc.",
   "last_sale": "0.3062",
   "market_cap": "$12.97M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vtl",
   "FIELD9": ""
 },
 {
   "symbol": "VIVE",
   "name": "Viveve Medical, Inc.",
   "last_sale": "3",
   "market_cap": "$94.47M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/vive",
   "FIELD9": ""
 },
 {
   "symbol": "VVPR",
   "name": "VivoPower International PLC",
   "last_sale": "1.48",
   "market_cap": "$20.06M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/vvpr",
   "FIELD9": ""
 },
 {
   "symbol": "VVUS",
   "name": "VIVUS, Inc.",
   "last_sale": "5.15",
   "market_cap": "$5.47M",
   "IPOyear": "1994",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vvus",
   "FIELD9": ""
 },
 {
   "symbol": "VOD",
   "name": "Vodafone Group Plc",
   "last_sale": "22.81",
   "market_cap": "$60.94B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/vod",
   "FIELD9": ""
 },
 {
   "symbol": "VOXX",
   "name": "VOXX International Corporation",
   "last_sale": "5.275",
   "market_cap": "$127.65M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/voxx",
   "FIELD9": ""
 },
 {
   "symbol": "VYGR",
   "name": "Voyager Therapeutics, Inc.",
   "last_sale": "18.22",
   "market_cap": "$590.98M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/vygr",
   "FIELD9": ""
 },
 {
   "symbol": "VSEC",
   "name": "VSE Corporation",
   "last_sale": "33.78",
   "market_cap": "$367.56M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/vsec",
   "FIELD9": ""
 },
 {
   "symbol": "VTVT",
   "name": "vTv Therapeutics Inc.",
   "last_sale": "0.8001",
   "market_cap": "$29.59M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/vtvt",
   "FIELD9": ""
 },
 {
   "symbol": "VUZI",
   "name": "Vuzix Corporation",
   "last_sale": "6.25",
   "market_cap": "$171.42M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/vuzi",
   "FIELD9": ""
 },
 {
   "symbol": "WBA",
   "name": "Walgreens Boots Alliance, Inc.",
   "last_sale": "72.99",
   "market_cap": "$72.44B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wba",
   "FIELD9": ""
 },
 {
   "symbol": "WAFD",
   "name": "Washington Federal, Inc.",
   "last_sale": "33.25",
   "market_cap": "$2.78B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wafd",
   "FIELD9": ""
 },
 {
   "symbol": "WAFDW",
   "name": "Washington Federal, Inc.",
   "last_sale": "16.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wafdw",
   "FIELD9": ""
 },
 {
   "symbol": "WASH",
   "name": "Washington Trust Bancorp, Inc.",
   "last_sale": "57.45",
   "market_cap": "$992.63M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wash",
   "FIELD9": ""
 },
 {
   "symbol": "WSBF",
   "name": "Waterstone Financial, Inc.",
   "last_sale": "17.05",
   "market_cap": "$499.65M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/wsbf",
   "FIELD9": ""
 },
 {
   "symbol": "WVE",
   "name": "WAVE Life Sciences Ltd.",
   "last_sale": "52.3",
   "market_cap": "$1.53B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/wve",
   "FIELD9": ""
 },
 {
   "symbol": "WNFM",
   "name": "Wayne Farms, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wnfm",
   "FIELD9": ""
 },
 {
   "symbol": "WSTG",
   "name": "Wayside Technology Group, Inc.",
   "last_sale": "12.15",
   "market_cap": "$54.65M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Retail: Computer Software & Peripheral Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/wstg",
   "FIELD9": ""
 },
 {
   "symbol": "WCFB",
   "name": "WCF Bancorp, Inc.",
   "last_sale": "9.2",
   "market_cap": "$23.57M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wcfb",
   "FIELD9": ""
 },
 {
   "symbol": "WDFC",
   "name": "WD-40 Company",
   "last_sale": "172.2",
   "market_cap": "$2.39B",
   "IPOyear": "1973",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/wdfc",
   "FIELD9": ""
 },
 {
   "symbol": "WEB",
   "name": "Web.com Group, Inc.",
   "last_sale": "27.9",
   "market_cap": "$1.4B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/web",
   "FIELD9": ""
 },
 {
   "symbol": "WB",
   "name": "Weibo Corporation",
   "last_sale": "77.72",
   "market_cap": "$17.31B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/wb",
   "FIELD9": ""
 },
 {
   "symbol": "WEBK",
   "name": "Wellesley Bancorp, Inc.",
   "last_sale": "34.5",
   "market_cap": "$86.77M",
   "IPOyear": "2012",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/webk",
   "FIELD9": ""
 },
 {
   "symbol": "WEN",
   "name": "Wendy&#39;s Company (The)",
   "last_sale": "17.16",
   "market_cap": "$4.07B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/wen",
   "FIELD9": ""
 },
 {
   "symbol": "WERN",
   "name": "Werner Enterprises, Inc.",
   "last_sale": "35.6",
   "market_cap": "$2.55B",
   "IPOyear": "1986",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wern",
   "FIELD9": ""
 },
 {
   "symbol": "WSBC",
   "name": "WesBanco, Inc.",
   "last_sale": "46.13",
   "market_cap": "$2.52B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wsbc",
   "FIELD9": ""
 },
 {
   "symbol": "WTBA",
   "name": "West Bancorporation",
   "last_sale": "24.25",
   "market_cap": "$395.17M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wtba",
   "FIELD9": ""
 },
 {
   "symbol": "WABC",
   "name": "Westamerica Bancorporation",
   "last_sale": "62.07",
   "market_cap": "$1.66B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wabc",
   "FIELD9": ""
 },
 {
   "symbol": "WSTL",
   "name": "Westell Technologies, Inc.",
   "last_sale": "2.66",
   "market_cap": "$41.54M",
   "IPOyear": "1995",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/wstl",
   "FIELD9": ""
 },
 {
   "symbol": "WDC",
   "name": "Western Digital Corporation",
   "last_sale": "60.71",
   "market_cap": "$17.69B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/wdc",
   "FIELD9": ""
 },
 {
   "symbol": "WNEB",
   "name": "Western New England Bancorp, Inc.",
   "last_sale": "10.8",
   "market_cap": "$321.26M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/wneb",
   "FIELD9": ""
 },
 {
   "symbol": "WPRT",
   "name": "Westport Fuel Systems Inc",
   "last_sale": "3.26",
   "market_cap": "$427.97M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/wprt",
   "FIELD9": ""
 },
 {
   "symbol": "WWR",
   "name": "Westwater Resources, Inc.",
   "last_sale": "0.185",
   "market_cap": "$9.62M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/wwr",
   "FIELD9": ""
 },
 {
   "symbol": "WEYS",
   "name": "Weyco Group, Inc.",
   "last_sale": "35.18",
   "market_cap": "$357.43M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/weys",
   "FIELD9": ""
 },
 {
   "symbol": "WHLR",
   "name": "Wheeler Real Estate Investment Trust, Inc.",
   "last_sale": "4.19",
   "market_cap": "$39.32M",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/whlr",
   "FIELD9": ""
 },
 {
   "symbol": "WHLRD",
   "name": "Wheeler Real Estate Investment Trust, Inc.",
   "last_sale": "21.15",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/whlrd",
   "FIELD9": ""
 },
 {
   "symbol": "WHLRP",
   "name": "Wheeler Real Estate Investment Trust, Inc.",
   "last_sale": "19.2",
   "market_cap": "$13.82M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/whlrp",
   "FIELD9": ""
 },
 {
   "symbol": "WHLRW",
   "name": "Wheeler Real Estate Investment Trust, Inc.",
   "last_sale": "0.0122",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/whlrw",
   "FIELD9": ""
 },
 {
   "symbol": "WHF",
   "name": "WhiteHorse Finance, Inc.",
   "last_sale": "13.89",
   "market_cap": "$285.38M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/whf",
   "FIELD9": ""
 },
 {
   "symbol": "WHLM",
   "name": "Wilhelmina International, Inc.",
   "last_sale": "6",
   "market_cap": "$31.62M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/whlm",
   "FIELD9": ""
 },
 {
   "symbol": "WVVI",
   "name": "Willamette Valley Vineyards, Inc.",
   "last_sale": "7.9",
   "market_cap": "$39.22M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/wvvi",
   "FIELD9": ""
 },
 {
   "symbol": "WVVIP",
   "name": "Willamette Valley Vineyards, Inc.",
   "last_sale": "4.8",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/wvvip",
   "FIELD9": ""
 },
 {
   "symbol": "WLDN",
   "name": "Willdan Group, Inc.",
   "last_sale": "29.9",
   "market_cap": "$266.5M",
   "IPOyear": "2006",
   "sector": "Consumer Services",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/wldn",
   "FIELD9": ""
 },
 {
   "symbol": "WLFC",
   "name": "Willis Lease Finance Corporation",
   "last_sale": "35",
   "market_cap": "$219.43M",
   "IPOyear": "1996",
   "sector": "Consumer Durables",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/wlfc",
   "FIELD9": ""
 },
 {
   "symbol": "WLTW",
   "name": "Willis Towers Watson Public Limited Company",
   "last_sale": "148.48",
   "market_cap": "$19.42B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/wltw",
   "FIELD9": ""
 },
 {
   "symbol": "WSC",
   "name": "WillScot Corporation",
   "last_sale": "17.15",
   "market_cap": "$1.84B",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wsc",
   "FIELD9": ""
 },
 {
   "symbol": "WIN",
   "name": "Windstream Holdings, Inc.",
   "last_sale": "4.93",
   "market_cap": "$211.68M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/win",
   "FIELD9": ""
 },
 {
   "symbol": "WING",
   "name": "Wingstop Inc.",
   "last_sale": "66.35",
   "market_cap": "$1.94B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/wing",
   "FIELD9": ""
 },
 {
   "symbol": "WINA",
   "name": "Winmark Corporation",
   "last_sale": "163.8",
   "market_cap": "$633.66M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/wina",
   "FIELD9": ""
 },
 {
   "symbol": "WINS",
   "name": "Wins Finance Holdings Inc.",
   "last_sale": "56",
   "market_cap": "$1.11B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wins",
   "FIELD9": ""
 },
 {
   "symbol": "WTFC",
   "name": "Wintrust Financial Corporation",
   "last_sale": "90.26",
   "market_cap": "$5.09B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wtfc",
   "FIELD9": ""
 },
 {
   "symbol": "WTFCM",
   "name": "Wintrust Financial Corporation",
   "last_sale": "26.8074",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wtfcm",
   "FIELD9": ""
 },
 {
   "symbol": "WTFCW",
   "name": "Wintrust Financial Corporation",
   "last_sale": "66.62",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wtfcw",
   "FIELD9": ""
 },
 {
   "symbol": "AGND",
   "name": "WisdomTree Barclays Negative Duration U.S. Aggregate Bond Fund",
   "last_sale": "44.02",
   "market_cap": "$30.81M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/agnd",
   "FIELD9": ""
 },
 {
   "symbol": "CXSE",
   "name": "WisdomTree China ex-State-Owned Enterprises Fund",
   "last_sale": "73.43",
   "market_cap": "$165.22M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cxse",
   "FIELD9": ""
 },
 {
   "symbol": "EMCG",
   "name": "WisdomTree Emerging Markets Consumer Growth Fund",
   "last_sale": "21.91",
   "market_cap": "$35.06M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/emcg",
   "FIELD9": ""
 },
 {
   "symbol": "EMCB",
   "name": "WisdomTree Emerging Markets Corporate Bond Fund",
   "last_sale": "68.84",
   "market_cap": "$41.3M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/emcb",
   "FIELD9": ""
 },
 {
   "symbol": "DGRE",
   "name": "WisdomTree Emerging Markets Quality Dividend Growth Fund",
   "last_sale": "24.32",
   "market_cap": "$80.26M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dgre",
   "FIELD9": ""
 },
 {
   "symbol": "DXGE",
   "name": "WisdomTree Germany Hedged Equity Fund",
   "last_sale": "30.58",
   "market_cap": "$74.92M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dxge",
   "FIELD9": ""
 },
 {
   "symbol": "HYZD",
   "name": "WisdomTree Interest Rate Hedged High Yield Bond Fund",
   "last_sale": "24.25",
   "market_cap": "$276.45M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hyzd",
   "FIELD9": ""
 },
 {
   "symbol": "AGZD",
   "name": "WisdomTree Interest Rate Hedged U.S. Aggregate Bond Fund",
   "last_sale": "48.17",
   "market_cap": "$52.99M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/agzd",
   "FIELD9": ""
 },
 {
   "symbol": "WETF",
   "name": "WisdomTree Investments, Inc.",
   "last_sale": "8.19",
   "market_cap": "$1.25B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/wetf",
   "FIELD9": ""
 },
 {
   "symbol": "DXJS",
   "name": "WisdomTree Japan Hedged SmallCap Equity Fund",
   "last_sale": "44.67",
   "market_cap": "$151.88M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dxjs",
   "FIELD9": ""
 },
 {
   "symbol": "GULF",
   "name": "WisdomTree Middle East Dividend Fund",
   "last_sale": "18.89",
   "market_cap": "$17M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gulf",
   "FIELD9": ""
 },
 {
   "symbol": "HYND",
   "name": "WisdomTree Negative Duration High Yield Bond Fund",
   "last_sale": "21.55",
   "market_cap": "$56.03M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hynd",
   "FIELD9": ""
 },
 {
   "symbol": "DGRW",
   "name": "WisdomTree U.S. Quality Dividend Growth Fund",
   "last_sale": "44.81",
   "market_cap": "$2.42B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dgrw",
   "FIELD9": ""
 },
 {
   "symbol": "DGRS",
   "name": "WisdomTree U.S. SmallCap Quality Dividend Growth Fund",
   "last_sale": "38.18",
   "market_cap": "$120.27M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dgrs",
   "FIELD9": ""
 },
 {
   "symbol": "WIX",
   "name": "Wix.com Ltd.",
   "last_sale": "113.5",
   "market_cap": "$5.32B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/wix",
   "FIELD9": ""
 },
 {
   "symbol": "WMIH",
   "name": "WMIH Corp.",
   "last_sale": "1.34",
   "market_cap": "$1.46B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wmih",
   "FIELD9": ""
 },
 {
   "symbol": "WWD",
   "name": "Woodward, Inc.",
   "last_sale": "81.39",
   "market_cap": "$5.02B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/wwd",
   "FIELD9": ""
 },
 {
   "symbol": "WDAY",
   "name": "Workday, Inc.",
   "last_sale": "138.64",
   "market_cap": "$30.08B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wday",
   "FIELD9": ""
 },
 {
   "symbol": "WKHS",
   "name": "Workhorse Group, Inc.",
   "last_sale": "1.07",
   "market_cap": "$58.83M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/wkhs",
   "FIELD9": ""
 },
 {
   "symbol": "WRLD",
   "name": "World Acceptance Corporation",
   "last_sale": "118.37",
   "market_cap": "$1.08B",
   "IPOyear": "1991",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wrld",
   "FIELD9": ""
 },
 {
   "symbol": "WMGI",
   "name": "Wright Medical Group N.V.",
   "last_sale": "28",
   "market_cap": "$2.99B",
   "IPOyear": "2011",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/wmgi",
   "FIELD9": ""
 },
 {
   "symbol": "WMGIZ",
   "name": "Wright Medical Group N.V.",
   "last_sale": "1.4",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/wmgiz",
   "FIELD9": ""
 },
 {
   "symbol": "WSFS",
   "name": "WSFS Financial Corporation",
   "last_sale": "47.65",
   "market_cap": "$1.51B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wsfs",
   "FIELD9": ""
 },
 {
   "symbol": "WSCI",
   "name": "WSI Industries Inc.",
   "last_sale": "6.95",
   "market_cap": "$20.64M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/wsci",
   "FIELD9": ""
 },
 {
   "symbol": "WVFC",
   "name": "WVS Financial Corp.",
   "last_sale": "16.01",
   "market_cap": "$32.15M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wvfc",
   "FIELD9": ""
 },
 {
   "symbol": "WYNN",
   "name": "Wynn Resorts, Limited",
   "last_sale": "136.74",
   "market_cap": "$14.86B",
   "IPOyear": "2002",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/wynn",
   "FIELD9": ""
 },
 {
   "symbol": "XBIT",
   "name": "XBiotech Inc.",
   "last_sale": "2.75",
   "market_cap": "$98.5M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/xbit",
   "FIELD9": ""
 },
 {
   "symbol": "XELB",
   "name": "Xcel Brands, Inc",
   "last_sale": "2.2",
   "market_cap": "$40.19M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Multi-Sector Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/xelb",
   "FIELD9": ""
 },
 {
   "symbol": "XEL",
   "name": "Xcel Energy Inc.",
   "last_sale": "47.51",
   "market_cap": "$24.19B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/xel",
   "FIELD9": ""
 },
 {
   "symbol": "XCRA",
   "name": "Xcerra Corporation",
   "last_sale": "13.52",
   "market_cap": "$742.45M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/xcra",
   "FIELD9": ""
 },
 {
   "symbol": "XNCR",
   "name": "Xencor, Inc.",
   "last_sale": "42.89",
   "market_cap": "$2.39B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/xncr",
   "FIELD9": ""
 },
 {
   "symbol": "XBIO",
   "name": "Xenetic Biosciences, Inc.",
   "last_sale": "3.33",
   "market_cap": "$31.31M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/xbio",
   "FIELD9": ""
 },
 {
   "symbol": "XENE",
   "name": "Xenon Pharmaceuticals Inc.",
   "last_sale": "13.05",
   "market_cap": "$268.33M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/xene",
   "FIELD9": ""
 },
 {
   "symbol": "XERS",
   "name": "Xeris Pharmaceuticals, Inc.",
   "last_sale": "20.21",
   "market_cap": "$420.72M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/xers",
   "FIELD9": ""
 },
 {
   "symbol": "XGTI",
   "name": "XG Technology, Inc",
   "last_sale": "0.4101",
   "market_cap": "$6.95M",
   "IPOyear": "2013",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/xgti",
   "FIELD9": ""
 },
 {
   "symbol": "XLNX",
   "name": "Xilinx, Inc.",
   "last_sale": "78.73",
   "market_cap": "$19.91B",
   "IPOyear": "1990",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/xlnx",
   "FIELD9": ""
 },
 {
   "symbol": "XOMA",
   "name": "XOMA Corporation",
   "last_sale": "15.85",
   "market_cap": "$132.94M",
   "IPOyear": "1986",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/xoma",
   "FIELD9": ""
 },
 {
   "symbol": "XPER",
   "name": "Xperi Corporation",
   "last_sale": "15.65",
   "market_cap": "$768.37M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/xper",
   "FIELD9": ""
 },
 {
   "symbol": "XSPA",
   "name": "XpresSpa Group, Inc. ",
   "last_sale": "0.14",
   "market_cap": "$3.8M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/xspa",
   "FIELD9": ""
 },
 {
   "symbol": "XTLB",
   "name": "XTL Biopharmaceuticals Ltd.",
   "last_sale": "1.7789",
   "market_cap": "$9.15M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/xtlb",
   "FIELD9": ""
 },
 {
   "symbol": "XNET",
   "name": "Xunlei Limited",
   "last_sale": "8.37",
   "market_cap": "$561.38M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/xnet",
   "FIELD9": ""
 },
 {
   "symbol": "YNDX",
   "name": "Yandex N.V.",
   "last_sale": "33",
   "market_cap": "$10.84B",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/yndx",
   "FIELD9": ""
 },
 {
   "symbol": "YRIV",
   "name": "Yangtze River Port and Logistics Limited ",
   "last_sale": "11.53",
   "market_cap": "$1.99B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/yriv",
   "FIELD9": ""
 },
 {
   "symbol": "YTRA",
   "name": "Yatra Online, Inc.",
   "last_sale": "5.5827",
   "market_cap": "$251.64M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ytra",
   "FIELD9": ""
 },
 {
   "symbol": "YTEN",
   "name": "Yield10 Bioscience, Inc.",
   "last_sale": "1.31",
   "market_cap": "$13.11M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/yten",
   "FIELD9": ""
 },
 {
   "symbol": "YIN",
   "name": "Yintech Investment Holdings Limited",
   "last_sale": "6.31",
   "market_cap": "$445.03M",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/yin",
   "FIELD9": ""
 },
 {
   "symbol": "YMAB",
   "name": "Y-mAbs Therapeutics, Inc.",
   "last_sale": "24",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ymab",
   "FIELD9": ""
 },
 {
   "symbol": "YOGA",
   "name": "YogaWorks, Inc.",
   "last_sale": "1.06",
   "market_cap": "$17.45M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/yoga",
   "FIELD9": ""
 },
 {
   "symbol": "YGYI",
   "name": "Youngevity International, Inc.",
   "last_sale": "5.2",
   "market_cap": "$112.12M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/ygyi",
   "FIELD9": ""
 },
 {
   "symbol": "YRCW",
   "name": "YRC Worldwide, Inc.",
   "last_sale": "9.36",
   "market_cap": "$318.72M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/yrcw",
   "FIELD9": ""
 },
 {
   "symbol": "YECO",
   "name": "Yulong Eco-Materials Limited",
   "last_sale": "1.36",
   "market_cap": "$3.28M",
   "IPOyear": "2017",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/yeco",
   "FIELD9": ""
 },
 {
   "symbol": "YY",
   "name": "YY Inc.",
   "last_sale": "74.89",
   "market_cap": "$4.74B",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/yy",
   "FIELD9": ""
 },
 {
   "symbol": "ZFGN",
   "name": "Zafgen, Inc.",
   "last_sale": "10.77",
   "market_cap": "$396.4M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/zfgn",
   "FIELD9": ""
 },
 {
   "symbol": "ZAGG",
   "name": "ZAGG Inc",
   "last_sale": "15.65",
   "market_cap": "$440.69M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/zagg",
   "FIELD9": ""
 },
 {
   "symbol": "ZLAB",
   "name": "Zai Lab Limited",
   "last_sale": "19.18",
   "market_cap": "$970.62M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/zlab",
   "FIELD9": ""
 },
 {
   "symbol": "ZEAL",
   "name": "Zealand Pharma A/S",
   "last_sale": "16.69",
   "market_cap": "$512.17M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/zeal",
   "FIELD9": ""
 },
 {
   "symbol": "ZBRA",
   "name": "Zebra Technologies Corporation",
   "last_sale": "175.41",
   "market_cap": "$9.42B",
   "IPOyear": "1991",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/zbra",
   "FIELD9": ""
 },
 {
   "symbol": "Z",
   "name": "Zillow Group, Inc.",
   "last_sale": "42.81",
   "market_cap": "$8.66B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/z",
   "FIELD9": ""
 },
 {
   "symbol": "ZG",
   "name": "Zillow Group, Inc.",
   "last_sale": "42.58",
   "market_cap": "$8.61B",
   "IPOyear": "2011",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/zg",
   "FIELD9": ""
 },
 {
   "symbol": "ZN",
   "name": "Zion Oil & Gas Inc",
   "last_sale": "1.05",
   "market_cap": "$62.3M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/zn",
   "FIELD9": ""
 },
 {
   "symbol": "ZNWAA",
   "name": "Zion Oil & Gas Inc",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/znwaa",
   "FIELD9": ""
 },
 {
   "symbol": "ZION",
   "name": "Zions Bancorporation",
   "last_sale": "52.56",
   "market_cap": "$10.22B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/zion",
   "FIELD9": ""
 },
 {
   "symbol": "ZIONW",
   "name": "Zions Bancorporation",
   "last_sale": "20.27",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/zionw",
   "FIELD9": ""
 },
 {
   "symbol": "ZIONZ",
   "name": "Zions Bancorporation",
   "last_sale": "17.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/zionz",
   "FIELD9": ""
 },
 {
   "symbol": "ZIOP",
   "name": "ZIOPHARM Oncology Inc",
   "last_sale": "3.08",
   "market_cap": "$438.53M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ziop",
   "FIELD9": ""
 },
 {
   "symbol": "ZIXI",
   "name": "Zix Corporation",
   "last_sale": "5.49",
   "market_cap": "$297.36M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/zixi",
   "FIELD9": ""
 },
 {
   "symbol": "ZKIN",
   "name": "ZK International Group Co., Ltd",
   "last_sale": "2.95",
   "market_cap": "$38.99M",
   "IPOyear": "2017",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/zkin",
   "FIELD9": ""
 },
 {
   "symbol": "ZGNX",
   "name": "Zogenix, Inc.",
   "last_sale": "49.15",
   "market_cap": "$1.76B",
   "IPOyear": "2010",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/zgnx",
   "FIELD9": ""
 },
 {
   "symbol": "ZSAN",
   "name": "Zosano Pharma Corporation",
   "last_sale": "4.01",
   "market_cap": "$48.01M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/zsan",
   "FIELD9": ""
 },
 {
   "symbol": "ZS",
   "name": "Zscaler, Inc.",
   "last_sale": "40.15",
   "market_cap": "$4.81B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/zs",
   "FIELD9": ""
 },
 {
   "symbol": "ZUMZ",
   "name": "Zumiez Inc.",
   "last_sale": "28.1",
   "market_cap": "$717.09M",
   "IPOyear": "2005",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/zumz",
   "FIELD9": ""
 },
 {
   "symbol": "ZYNE",
   "name": "Zynerba Pharmaceuticals, Inc.",
   "last_sale": "8.47",
   "market_cap": "$149.27M",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/zyne",
   "FIELD9": ""
 },
 {
   "symbol": "ZNGA",
   "name": "Zynga Inc.",
   "last_sale": "3.9152",
   "market_cap": "$3.37B",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/znga",
   "FIELD9": ""
 },

 {
   "symbol": "DDD",
   "name": "3D Systems Corporation",
   "last_sale": "18.85",
   "market_cap": "$2.15B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ddd",
   "FIELD9": ""
 },
 {
   "symbol": "MMM",
   "name": "3M Company",
   "last_sale": "216.33",
   "market_cap": "$126.9B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/mmm",
   "FIELD9": ""
 },
 {
   "symbol": "WBAI",
   "name": "500.com Limited",
   "last_sale": "10.86",
   "market_cap": "$458.89M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/wbai",
   "FIELD9": ""
 },
 {
   "symbol": "WUBA",
   "name": "58.com Inc.",
   "last_sale": "74.01",
   "market_cap": "$10.92B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/wuba",
   "FIELD9": ""
 },
 {
   "symbol": "EGHT",
   "name": "8x8 Inc",
   "last_sale": "21.2",
   "market_cap": "$1.98B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/eght",
   "FIELD9": ""
 },
 {
   "symbol": "AHC",
   "name": "A.H. Belo Corporation",
   "last_sale": "4.5",
   "market_cap": "$97.64M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Newspapers/Magazines",
   "summary_quote": "https://www.nasdaq.com/symbol/ahc",
   "FIELD9": ""
 },
 {
   "symbol": "ATEN",
   "name": "A10 Networks, Inc.",
   "last_sale": "6.08",
   "market_cap": "$442.06M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/aten",
   "FIELD9": ""
 },
 {
   "symbol": "AAC",
   "name": "AAC Holdings, Inc.",
   "last_sale": "7.4",
   "market_cap": "$182.02M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/aac",
   "FIELD9": ""
 },
 {
   "symbol": "AIR",
   "name": "AAR Corp.",
   "last_sale": "44.91",
   "market_cap": "$1.57B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/air",
   "FIELD9": ""
 },
 {
   "symbol": "AAN",
   "name": "Aaron&#39;s,  Inc.",
   "last_sale": "55.45",
   "market_cap": "$4.02B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/aan",
   "FIELD9": ""
 },
 {
   "symbol": "ABB",
   "name": "ABB Ltd",
   "last_sale": "24.31",
   "market_cap": "$51.82B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/abb",
   "FIELD9": ""
 },
 {
   "symbol": "ABT",
   "name": "Abbott Laboratories",
   "last_sale": "69.05",
   "market_cap": "$121.14B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/abt",
   "FIELD9": ""
 },
 {
   "symbol": "ABBV",
   "name": "AbbVie Inc.",
   "last_sale": "92.26",
   "market_cap": "$139.71B",
   "IPOyear": "2012",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/abbv",
   "FIELD9": ""
 },
 {
   "symbol": "ANF",
   "name": "Abercrombie & Fitch Company",
   "last_sale": "20.41",
   "market_cap": "$1.36B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/anf",
   "FIELD9": ""
 },
 {
   "symbol": "AGD",
   "name": "Aberdeen Global Dynamic Dividend Fund",
   "last_sale": "10.46",
   "market_cap": "$131.27M",
   "IPOyear": "2006",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/agd",
   "FIELD9": ""
 },
 {
   "symbol": "AWP",
   "name": "Aberdeen Global Premier Properties Fund",
   "last_sale": "6.25",
   "market_cap": "$533.8M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/awp",
   "FIELD9": ""
 },
 {
   "symbol": "ACP",
   "name": "Aberdeen Income Credit Strategies Fund",
   "last_sale": "14.2201",
   "market_cap": "$185.91M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/acp",
   "FIELD9": ""
 },
 {
   "symbol": "JEQ",
   "name": "Aberdeen Japan Equity Fund, Inc. ",
   "last_sale": "8.35",
   "market_cap": "$111.8M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jeq",
   "FIELD9": ""
 },
 {
   "symbol": "AOD",
   "name": "Aberdeen Total Dynamic Dividend Fund",
   "last_sale": "8.88",
   "market_cap": "$955.43M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aod",
   "FIELD9": ""
 },
 {
   "symbol": "ABM",
   "name": "ABM Industries Incorporated",
   "last_sale": "33.76",
   "market_cap": "$2.22B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/abm",
   "FIELD9": ""
 },
 {
   "symbol": "AKR",
   "name": "Acadia Realty Trust",
   "last_sale": "28.46",
   "market_cap": "$2.32B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/akr",
   "FIELD9": ""
 },
 {
   "symbol": "ACN",
   "name": "Accenture plc",
   "last_sale": "174.19",
   "market_cap": "$111.73B",
   "IPOyear": "2001",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/acn",
   "FIELD9": ""
 },
 {
   "symbol": "ACCO",
   "name": "Acco Brands Corporation",
   "last_sale": "11.95",
   "market_cap": "$1.25B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Publishing",
   "summary_quote": "https://www.nasdaq.com/symbol/acco",
   "FIELD9": ""
 },
 {
   "symbol": "ATV",
   "name": "Acorn International, Inc.",
   "last_sale": "19.0994",
   "market_cap": "$51.19M",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/atv",
   "FIELD9": ""
 },
 {
   "symbol": "ATU",
   "name": "Actuant Corporation",
   "last_sale": "29.8",
   "market_cap": "$1.81B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/atu",
   "FIELD9": ""
 },
 {
   "symbol": "AYI",
   "name": "Acuity Brands Inc",
   "last_sale": "165.06",
   "market_cap": "$6.63B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Building Products",
   "summary_quote": "https://www.nasdaq.com/symbol/ayi",
   "FIELD9": ""
 },
 {
   "symbol": "GOLF",
   "name": "Acushnet Holdings Corp.",
   "last_sale": "26.91",
   "market_cap": "$2.01B",
   "IPOyear": "2016",
   "sector": "Consumer Non-Durables",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/golf",
   "FIELD9": ""
 },
 {
   "symbol": "ADX",
   "name": "Adams Diversified Equity Fund, Inc.",
   "last_sale": "16.74",
   "market_cap": "$1.69B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/adx",
   "FIELD9": ""
 },
 {
   "symbol": "PEO",
   "name": "Adams Natural Resources Fund, Inc.",
   "last_sale": "19.85",
   "market_cap": "$575.56M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/peo",
   "FIELD9": ""
 },
 {
   "symbol": "AGRO",
   "name": "Adecoagro S.A.",
   "last_sale": "7.78",
   "market_cap": "$906.8M",
   "IPOyear": "2011",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/agro",
   "FIELD9": ""
 },
 {
   "symbol": "ADNT",
   "name": "Adient plc",
   "last_sale": "44.18",
   "market_cap": "$4.13B",
   "IPOyear": "2016",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/adnt",
   "FIELD9": ""
 },
 {
   "symbol": "ADT",
   "name": "ADT Inc.",
   "last_sale": "9.37",
   "market_cap": "$7.18B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/adt",
   "FIELD9": ""
 },
 {
   "symbol": "ATGE",
   "name": "Adtalem Global Education Inc.",
   "last_sale": "45.35",
   "market_cap": "$2.72B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/atge",
   "FIELD9": ""
 },
 {
   "symbol": "AAP",
   "name": "Advance Auto Parts Inc",
   "last_sale": "168.44",
   "market_cap": "$12.48B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/aap",
   "FIELD9": ""
 },
 {
   "symbol": "ADSW",
   "name": "Advanced Disposal Services, Inc.",
   "last_sale": "27.34",
   "market_cap": "$2.42B",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/adsw",
   "FIELD9": ""
 },
 {
   "symbol": "WMS",
   "name": "Advanced Drainage Systems, Inc.",
   "last_sale": "32.35",
   "market_cap": "$1.84B",
   "IPOyear": "2014",
   "sector": "Capital Goods",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/wms",
   "FIELD9": ""
 },
 {
   "symbol": "ASIX",
   "name": "AdvanSix Inc.",
   "last_sale": "34.86",
   "market_cap": "$1.06B",
   "IPOyear": "2016",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/asix",
   "FIELD9": ""
 },
 {
   "symbol": "AAV",
   "name": "Advantage Oil & Gas Ltd",
   "last_sale": "2.5",
   "market_cap": "$464.86M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/aav",
   "FIELD9": ""
 },
 {
   "symbol": "AVK",
   "name": "Advent Claymore Convertible Securities and Income Fund",
   "last_sale": "15.66",
   "market_cap": "$540.66M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/avk",
   "FIELD9": ""
 },
 {
   "symbol": "ACM",
   "name": "AECOM",
   "last_sale": "33.03",
   "market_cap": "$5.31B",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/acm",
   "FIELD9": ""
 },
 {
   "symbol": "ANW",
   "name": "Aegean Marine Petroleum Network Inc.",
   "last_sale": "1.48",
   "market_cap": "$60.15M",
   "IPOyear": "2006",
   "sector": "Energy",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/anw",
   "FIELD9": ""
 },
 {
   "symbol": "AEB",
   "name": "Aegon NV",
   "last_sale": "24.365",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/aeb",
   "FIELD9": ""
 },
 {
   "symbol": "AED",
   "name": "Aegon NV",
   "last_sale": "25.73",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/aed",
   "FIELD9": ""
 },
 {
   "symbol": "AEG",
   "name": "Aegon NV",
   "last_sale": "6.5",
   "market_cap": "$13.29B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/aeg",
   "FIELD9": ""
 },
 {
   "symbol": "AEH",
   "name": "Aegon NV",
   "last_sale": "25.62",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/aeh",
   "FIELD9": ""
 },
 {
   "symbol": "AER",
   "name": "Aercap Holdings N.V.",
   "last_sale": "57.56",
   "market_cap": "$8.54B",
   "IPOyear": "2006",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/aer",
   "FIELD9": ""
 },
 {
   "symbol": "HIVE",
   "name": "Aerohive Networks, Inc.",
   "last_sale": "4.06",
   "market_cap": "$224.61M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hive",
   "FIELD9": ""
 },
 {
   "symbol": "AJRD",
   "name": "Aerojet Rocketdyne Holdings, Inc. ",
   "last_sale": "33.92",
   "market_cap": "$2.56B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/ajrd",
   "FIELD9": ""
 },
 {
   "symbol": "AET",
   "name": "Aetna Inc.",
   "last_sale": "204.27",
   "market_cap": "$66.88B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/aet",
   "FIELD9": ""
 },
 {
   "symbol": "AMG",
   "name": "Affiliated Managers Group, Inc.",
   "last_sale": "147.63",
   "market_cap": "$7.89B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/amg",
   "FIELD9": ""
 },
 {
   "symbol": "AFL",
   "name": "Aflac Incorporated",
   "last_sale": "48.04",
   "market_cap": "$36.89B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Accident &Health Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/afl",
   "FIELD9": ""
 },
 {
   "symbol": "MITT",
   "name": "AG Mortgage Investment Trust, Inc.",
   "last_sale": "18.68",
   "market_cap": "$527.27M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mitt",
   "FIELD9": ""
 },
 {
   "symbol": "MITT^A",
   "name": "AG Mortgage Investment Trust, Inc.",
   "last_sale": "25.51",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mitt^a",
   "FIELD9": ""
 },
 {
   "symbol": "MITT^B",
   "name": "AG Mortgage Investment Trust, Inc.",
   "last_sale": "25.259",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mitt^b",
   "FIELD9": ""
 },
 {
   "symbol": "AGCO",
   "name": "AGCO Corporation",
   "last_sale": "60.24",
   "market_cap": "$4.77B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/agco",
   "FIELD9": ""
 },
 {
   "symbol": "A",
   "name": "Agilent Technologies, Inc.",
   "last_sale": "70.72",
   "market_cap": "$22.54B",
   "IPOyear": "1999",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/a",
   "FIELD9": ""
 },
 {
   "symbol": "AEM",
   "name": "Agnico Eagle Mines Limited",
   "last_sale": "34.67",
   "market_cap": "$8.12B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/aem",
   "FIELD9": ""
 },
 {
   "symbol": "ADC",
   "name": "Agree Realty Corporation",
   "last_sale": "53.47",
   "market_cap": "$1.87B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/adc",
   "FIELD9": ""
 },
 {
   "symbol": "AL",
   "name": "Air Lease Corporation",
   "last_sale": "46.15",
   "market_cap": "$4.8B",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/al",
   "FIELD9": ""
 },
 {
   "symbol": "APD",
   "name": "Air Products and Chemicals, Inc.",
   "last_sale": "170.61",
   "market_cap": "$37.41B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/apd",
   "FIELD9": ""
 },
 {
   "symbol": "AYR",
   "name": "Aircastle Limited",
   "last_sale": "21.06",
   "market_cap": "$1.65B",
   "IPOyear": "2006",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ayr",
   "FIELD9": ""
 },
 {
   "symbol": "AKS",
   "name": "AK Steel Holding Corporation",
   "last_sale": "4.74",
   "market_cap": "$1.5B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/aks",
   "FIELD9": ""
 },
 {
   "symbol": "ALP^Q",
   "name": "Alabama Power Company",
   "last_sale": "25.1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/alp^q",
   "FIELD9": ""
 },
 {
   "symbol": "ALG",
   "name": "Alamo Group, Inc.",
   "last_sale": "95.62",
   "market_cap": "$1.12B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/alg",
   "FIELD9": ""
 },
 {
   "symbol": "AGI",
   "name": "Alamos Gold Inc.",
   "last_sale": "4.64",
   "market_cap": "$1.81B",
   "IPOyear": "2015",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/agi",
   "FIELD9": ""
 },
 {
   "symbol": "ALK",
   "name": "Alaska Air Group, Inc.",
   "last_sale": "70.08",
   "market_cap": "$8.63B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/alk",
   "FIELD9": ""
 },
 {
   "symbol": "AIN",
   "name": "Albany International Corporation",
   "last_sale": "78.2",
   "market_cap": "$2.52B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Textiles",
   "summary_quote": "https://www.nasdaq.com/symbol/ain",
   "FIELD9": ""
 },
 {
   "symbol": "ALB",
   "name": "Albemarle Corporation",
   "last_sale": "105.42",
   "market_cap": "$11.43B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/alb",
   "FIELD9": ""
 },
 {
   "symbol": "AA",
   "name": "Alcoa Corporation",
   "last_sale": "43.79",
   "market_cap": "$8.17B",
   "IPOyear": "2016",
   "sector": "Basic Industries",
   "industry": "Aluminum",
   "summary_quote": "https://www.nasdaq.com/symbol/aa",
   "FIELD9": ""
 },
 {
   "symbol": "ALEX",
   "name": "Alexander & Baldwin, Inc.",
   "last_sale": "22.92",
   "market_cap": "$1.65B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/alex",
   "FIELD9": ""
 },
 {
   "symbol": "ALX",
   "name": "Alexander&#39;s, Inc.",
   "last_sale": "345.07",
   "market_cap": "$1.76B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/alx",
   "FIELD9": ""
 },
 {
   "symbol": "ARE",
   "name": "Alexandria Real Estate Equities, Inc.",
   "last_sale": "126.8",
   "market_cap": "$13.41B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/are",
   "FIELD9": ""
 },
 {
   "symbol": "ARE^D",
   "name": "Alexandria Real Estate Equities, Inc.",
   "last_sale": "35.1201",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/are^d",
   "FIELD9": ""
 },
 {
   "symbol": "AQN",
   "name": "Algonquin Power & Utilities Corp.",
   "last_sale": "10.63",
   "market_cap": "$5B",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/aqn",
   "FIELD9": ""
 },
 {
   "symbol": "BABA",
   "name": "Alibaba Group Holding Limited",
   "last_sale": "164.63",
   "market_cap": "$423.42B",
   "IPOyear": "2014",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/baba",
   "FIELD9": ""
 },
 {
   "symbol": "Y",
   "name": "Alleghany Corporation",
   "last_sale": "649.85",
   "market_cap": "$9.71B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/y",
   "FIELD9": ""
 },
 {
   "symbol": "ATI",
   "name": "Allegheny Technologies Incorporated",
   "last_sale": "28.66",
   "market_cap": "$3.6B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/ati",
   "FIELD9": ""
 },
 {
   "symbol": "ALLE",
   "name": "Allegion plc",
   "last_sale": "90.07",
   "market_cap": "$8.56B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/alle",
   "FIELD9": ""
 },
 {
   "symbol": "AGN",
   "name": "Allergan plc.",
   "last_sale": "191.31",
   "market_cap": "$64.94B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/agn",
   "FIELD9": ""
 },
 {
   "symbol": "ALE",
   "name": "Allete, Inc.",
   "last_sale": "76.85",
   "market_cap": "$3.95B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/ale",
   "FIELD9": ""
 },
 {
   "symbol": "AKP",
   "name": "Alliance California Municipal Income Fund Inc",
   "last_sale": "13.43",
   "market_cap": "$114.89M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/akp",
   "FIELD9": ""
 },
 {
   "symbol": "ADS",
   "name": "Alliance Data Systems Corporation",
   "last_sale": "248.69",
   "market_cap": "$13.66B",
   "IPOyear": "2001",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ads",
   "FIELD9": ""
 },
 {
   "symbol": "AFB",
   "name": "Alliance National Municipal Income Fund Inc",
   "last_sale": "12.24",
   "market_cap": "$351.84M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/afb",
   "FIELD9": ""
 },
 {
   "symbol": "AWF",
   "name": "Alliance World Dollar Government Fund II",
   "last_sale": "11.64",
   "market_cap": "$1B",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/awf",
   "FIELD9": ""
 },
 {
   "symbol": "AB",
   "name": "AllianceBernstein Holding L.P.",
   "last_sale": "30.5",
   "market_cap": "$2.99B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/ab",
   "FIELD9": ""
 },
 {
   "symbol": "LNT",
   "name": "Alliant Energy Corporation",
   "last_sale": "43.23",
   "market_cap": "$10.11B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/lnt",
   "FIELD9": ""
 },
 {
   "symbol": "CBH",
   "name": "AllianzGI Convertible & Income 2024 Target Term Fund",
   "last_sale": "9.2",
   "market_cap": "$167.96M",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cbh",
   "FIELD9": ""
 },
 {
   "symbol": "NCV",
   "name": "AllianzGI Convertible & Income Fund",
   "last_sale": "6.94",
   "market_cap": "$619.38M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ncv",
   "FIELD9": ""
 },
 {
   "symbol": "NCV^A",
   "name": "AllianzGI Convertible & Income Fund",
   "last_sale": "24.77",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ncv^a",
   "FIELD9": ""
 },
 {
   "symbol": "NCZ",
   "name": "AllianzGI Convertible & Income Fund II",
   "last_sale": "6.18",
   "market_cap": "$465.18M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ncz",
   "FIELD9": ""
 },
 {
   "symbol": "NCZ^A",
   "name": "AllianzGI Convertible & Income Fund II",
   "last_sale": "24.845",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ncz^a",
   "FIELD9": ""
 },
 {
   "symbol": "ACV",
   "name": "AllianzGI Diversified Income & Convertible Fund",
   "last_sale": "24.5",
   "market_cap": "$252.2M",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/acv",
   "FIELD9": ""
 },
 {
   "symbol": "NIE",
   "name": "AllianzGI Equity & Convertible Income Fund",
   "last_sale": "23.09",
   "market_cap": "$639.8M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nie",
   "FIELD9": ""
 },
 {
   "symbol": "NFJ",
   "name": "AllianzGI NFJ Dividend, Interest & Premium Strategy Fund",
   "last_sale": "13.17",
   "market_cap": "$1.25B",
   "IPOyear": "2005",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nfj",
   "FIELD9": ""
 },
 {
   "symbol": "ALSN",
   "name": "Allison Transmission Holdings, Inc.",
   "last_sale": "53.44",
   "market_cap": "$6.97B",
   "IPOyear": "2012",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/alsn",
   "FIELD9": ""
 },
 {
   "symbol": "ALL",
   "name": "Allstate Corporation (The)",
   "last_sale": "101.82",
   "market_cap": "$35.25B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/all",
   "FIELD9": ""
 },
 {
   "symbol": "ALL^A",
   "name": "Allstate Corporation (The)",
   "last_sale": "25.1309",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/all^a",
   "FIELD9": ""
 },
 {
   "symbol": "ALL^B",
   "name": "Allstate Corporation (The)",
   "last_sale": "25.51",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/all^b",
   "FIELD9": ""
 },
 {
   "symbol": "ALL^C.CL",
   "name": "Allstate Corporation (The)",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/all^c.cl",
   "FIELD9": ""
 },
 {
   "symbol": "ALL^D",
   "name": "Allstate Corporation (The)",
   "last_sale": "25.8257",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/all^d",
   "FIELD9": ""
 },
 {
   "symbol": "ALL^E",
   "name": "Allstate Corporation (The)",
   "last_sale": "25.83",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/all^e",
   "FIELD9": ""
 },
 {
   "symbol": "ALL^F",
   "name": "Allstate Corporation (The)",
   "last_sale": "25.94",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/all^f",
   "FIELD9": ""
 },
 {
   "symbol": "ALL^G",
   "name": "Allstate Corporation (The)",
   "last_sale": "25.299",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/all^g",
   "FIELD9": ""
 },
 {
   "symbol": "ALLY",
   "name": "Ally Financial Inc.",
   "last_sale": "27.54",
   "market_cap": "$11.62B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ally",
   "FIELD9": ""
 },
 {
   "symbol": "ALLY^A",
   "name": "Ally Financial Inc.",
   "last_sale": "26.15",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ally^a",
   "FIELD9": ""
 },
 {
   "symbol": "AYX",
   "name": "Alteryx, Inc.",
   "last_sale": "58.98",
   "market_cap": "$3.59B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ayx",
   "FIELD9": ""
 },
 {
   "symbol": "ATUS",
   "name": "Altice USA, Inc.",
   "last_sale": "19.16",
   "market_cap": "$14.12B",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/atus",
   "FIELD9": ""
 },
 {
   "symbol": "MO",
   "name": "Altria Group",
   "last_sale": "62.55",
   "market_cap": "$117.92B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/mo",
   "FIELD9": ""
 },
 {
   "symbol": "ACH",
   "name": "Aluminum Corporation of China Limited",
   "last_sale": "11.14",
   "market_cap": "$6.64B",
   "IPOyear": "2001",
   "sector": "Basic Industries",
   "industry": "Aluminum",
   "summary_quote": "https://www.nasdaq.com/symbol/ach",
   "FIELD9": ""
 },
 {
   "symbol": "AMBR",
   "name": "Amber Road, Inc.",
   "last_sale": "9.06",
   "market_cap": "$249.34M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ambr",
   "FIELD9": ""
 },
 {
   "symbol": "ABEV",
   "name": "Ambev S.A.",
   "last_sale": "4.68",
   "market_cap": "$73.57B",
   "IPOyear": "2013",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/abev",
   "FIELD9": ""
 },
 {
   "symbol": "AMC",
   "name": "AMC Entertainment Holdings, Inc.",
   "last_sale": "21.35",
   "market_cap": "$2.72B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Movies/Entertainment",
   "summary_quote": "https://www.nasdaq.com/symbol/amc",
   "FIELD9": ""
 },
 {
   "symbol": "AEE",
   "name": "Ameren Corporation",
   "last_sale": "64.42",
   "market_cap": "$15.72B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/aee",
   "FIELD9": ""
 },
 {
   "symbol": "AMRC",
   "name": "Ameresco, Inc.",
   "last_sale": "13.4",
   "market_cap": "$613.02M",
   "IPOyear": "2010",
   "sector": "Basic Industries",
   "industry": "Engineering & Construction",
   "summary_quote": "https://www.nasdaq.com/symbol/amrc",
   "FIELD9": ""
 },
 {
   "symbol": "AMOV",
   "name": "America Movil, S.A.B. de C.V.",
   "last_sale": "16.3701",
   "market_cap": "$54.06B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/amov",
   "FIELD9": ""
 },
 {
   "symbol": "AMX",
   "name": "America Movil, S.A.B. de C.V.",
   "last_sale": "16.5",
   "market_cap": "$54.49B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/amx",
   "FIELD9": ""
 },
 {
   "symbol": "AAT",
   "name": "American Assets Trust, Inc.",
   "last_sale": "37.59",
   "market_cap": "$1.78B",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/aat",
   "FIELD9": ""
 },
 {
   "symbol": "AXL",
   "name": "American Axle & Manufacturing Holdings, Inc.",
   "last_sale": "18.54",
   "market_cap": "$2.07B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/axl",
   "FIELD9": ""
 },
 {
   "symbol": "ACC",
   "name": "American Campus Communities Inc",
   "last_sale": "42.03",
   "market_cap": "$5.76B",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/acc",
   "FIELD9": ""
 },
 {
   "symbol": "AEO",
   "name": "American Eagle Outfitters, Inc.",
   "last_sale": "23.81",
   "market_cap": "$4.22B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/aeo",
   "FIELD9": ""
 },
 {
   "symbol": "AEP",
   "name": "American Electric Power Company, Inc.",
   "last_sale": "71.4",
   "market_cap": "$35.2B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/aep",
   "FIELD9": ""
 },
 {
   "symbol": "AEL",
   "name": "American Equity Investment Life Holding Company",
   "last_sale": "36.78",
   "market_cap": "$3.32B",
   "IPOyear": "2003",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/ael",
   "FIELD9": ""
 },
 {
   "symbol": "AXP",
   "name": "American Express Company",
   "last_sale": "110.9",
   "market_cap": "$95.49B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/axp",
   "FIELD9": ""
 },
 {
   "symbol": "AFG",
   "name": "American Financial Group, Inc.",
   "last_sale": "113.51",
   "market_cap": "$10.11B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/afg",
   "FIELD9": ""
 },
 {
   "symbol": "AFGE",
   "name": "American Financial Group, Inc.",
   "last_sale": "25.6208",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/afge",
   "FIELD9": ""
 },
 {
   "symbol": "AFGH",
   "name": "American Financial Group, Inc.",
   "last_sale": "25.46",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/afgh",
   "FIELD9": ""
 },
 {
   "symbol": "AMH",
   "name": "American Homes 4 Rent",
   "last_sale": "22.75",
   "market_cap": "$6.73B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/amh",
   "FIELD9": ""
 },
 {
   "symbol": "AMH^D",
   "name": "American Homes 4 Rent",
   "last_sale": "25.05",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/amh^d",
   "FIELD9": ""
 },
 {
   "symbol": "AMH^E",
   "name": "American Homes 4 Rent",
   "last_sale": "24.7699",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/amh^e",
   "FIELD9": ""
 },
 {
   "symbol": "AMH^F",
   "name": "American Homes 4 Rent",
   "last_sale": "23.51",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/amh^f",
   "FIELD9": ""
 },
 {
   "symbol": "AMH^G",
   "name": "American Homes 4 Rent",
   "last_sale": "23.65",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/amh^g",
   "FIELD9": ""
 },
 {
   "symbol": "AIG",
   "name": "American International Group, Inc.",
   "last_sale": "54.67",
   "market_cap": "$48.57B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/aig",
   "FIELD9": ""
 },
 {
   "symbol": "AIG.WS",
   "name": "American International Group, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aig.ws",
   "FIELD9": ""
 },
 {
   "symbol": "AMID",
   "name": "American Midstream Partners, LP",
   "last_sale": "6.05",
   "market_cap": "$320.54M",
   "IPOyear": "2011",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/amid",
   "FIELD9": ""
 },
 {
   "symbol": "ARL",
   "name": "American Realty Investors, Inc.",
   "last_sale": "16.41",
   "market_cap": "$262.51M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/arl",
   "FIELD9": ""
 },
 {
   "symbol": "ARA",
   "name": "American Renal Associates Holdings, Inc",
   "last_sale": "20.11",
   "market_cap": "$652.91M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/ara",
   "FIELD9": ""
 },
 {
   "symbol": "AWR",
   "name": "American States Water Company",
   "last_sale": "59.77",
   "market_cap": "$2.2B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/awr",
   "FIELD9": ""
 },
 {
   "symbol": "AMT",
   "name": "American Tower Corporation (REIT)",
   "last_sale": "148.49",
   "market_cap": "$65.46B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/amt",
   "FIELD9": ""
 },
 {
   "symbol": "AVD",
   "name": "American Vanguard Corporation",
   "last_sale": "19.9",
   "market_cap": "$603.46M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/avd",
   "FIELD9": ""
 },
 {
   "symbol": "AWK",
   "name": "American Water Works",
   "last_sale": "88.6",
   "market_cap": "$15.99B",
   "IPOyear": "2008",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/awk",
   "FIELD9": ""
 },
 {
   "symbol": "COLD",
   "name": "Americold Realty Trust",
   "last_sale": "25.38",
   "market_cap": "$3.74B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cold",
   "FIELD9": ""
 },
 {
   "symbol": "APU",
   "name": "AmeriGas Partners, L.P.",
   "last_sale": "40.13",
   "market_cap": "$3.73B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/apu",
   "FIELD9": ""
 },
 {
   "symbol": "AMP",
   "name": "AMERIPRISE FINANCIAL SERVICES, INC.",
   "last_sale": "149.99",
   "market_cap": "$21.28B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/amp",
   "FIELD9": ""
 },
 {
   "symbol": "ABC",
   "name": "AmerisourceBergen Corporation (Holding Co)",
   "last_sale": "90.13",
   "market_cap": "$19.5B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Other Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/abc",
   "FIELD9": ""
 },
 {
   "symbol": "ANFI",
   "name": "Amira Nature Foods Ltd",
   "last_sale": "1.83",
   "market_cap": "$64.84M",
   "IPOyear": "2012",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/anfi",
   "FIELD9": ""
 },
 {
   "symbol": "AMN",
   "name": "AMN Healthcare Services Inc",
   "last_sale": "51.3",
   "market_cap": "$2.44B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/amn",
   "FIELD9": ""
 },
 {
   "symbol": "AMRX",
   "name": "Amneal Pharmaceuticals, Inc.",
   "last_sale": "23.56",
   "market_cap": "$7.03B",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/amrx",
   "FIELD9": ""
 },
 {
   "symbol": "AP",
   "name": "Ampco-Pittsburgh Corporation",
   "last_sale": "7",
   "market_cap": "$87.44M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Fluid Controls",
   "summary_quote": "https://www.nasdaq.com/symbol/ap",
   "FIELD9": ""
 },
 {
   "symbol": "APH",
   "name": "Amphenol Corporation",
   "last_sale": "95.36",
   "market_cap": "$28.64B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/aph",
   "FIELD9": ""
 },
 {
   "symbol": "AXR",
   "name": "AMREP Corporation",
   "last_sale": "8.04",
   "market_cap": "$65.35M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Newspapers/Magazines",
   "summary_quote": "https://www.nasdaq.com/symbol/axr",
   "FIELD9": ""
 },
 {
   "symbol": "AME",
   "name": "AMTEK, Inc.",
   "last_sale": "81.53",
   "market_cap": "$18.91B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/ame",
   "FIELD9": ""
 },
 {
   "symbol": "AFSI^A",
   "name": "AmTrust Financial Services, Inc.",
   "last_sale": "16.9328",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/afsi^a",
   "FIELD9": ""
 },
 {
   "symbol": "AFSI^B",
   "name": "AmTrust Financial Services, Inc.",
   "last_sale": "17.9336",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/afsi^b",
   "FIELD9": ""
 },
 {
   "symbol": "AFSI^C",
   "name": "AmTrust Financial Services, Inc.",
   "last_sale": "18.56",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/afsi^c",
   "FIELD9": ""
 },
 {
   "symbol": "AFSI^D",
   "name": "AmTrust Financial Services, Inc.",
   "last_sale": "18.79",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/afsi^d",
   "FIELD9": ""
 },
 {
   "symbol": "AFSI^E",
   "name": "AmTrust Financial Services, Inc.",
   "last_sale": "19.19",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/afsi^e",
   "FIELD9": ""
 },
 {
   "symbol": "AFSI^F",
   "name": "AmTrust Financial Services, Inc.",
   "last_sale": "17.03",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/afsi^f",
   "FIELD9": ""
 },
 {
   "symbol": "AFSS",
   "name": "AmTrust Financial Services, Inc.",
   "last_sale": "23.68",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/afss",
   "FIELD9": ""
 },
 {
   "symbol": "AFST",
   "name": "AmTrust Financial Services, Inc.",
   "last_sale": "24.68",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/afst",
   "FIELD9": ""
 },
 {
   "symbol": "APC",
   "name": "Anadarko Petroleum Corporation",
   "last_sale": "64.64",
   "market_cap": "$33.1B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/apc",
   "FIELD9": ""
 },
 {
   "symbol": "ANDV",
   "name": "Andeavor",
   "last_sale": "154.73",
   "market_cap": "$23.38B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/andv",
   "FIELD9": ""
 },
 {
   "symbol": "ANDX",
   "name": "Andeavor Logistics LP",
   "last_sale": "49.88",
   "market_cap": "$12.24B",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/andx",
   "FIELD9": ""
 },
 {
   "symbol": "AU",
   "name": "AngloGold Ashanti Limited",
   "last_sale": "8.81",
   "market_cap": "$3.63B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/au",
   "FIELD9": ""
 },
 {
   "symbol": "BUD",
   "name": "Anheuser-Busch Inbev SA",
   "last_sale": "92.04",
   "market_cap": "$180.08B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/bud",
   "FIELD9": ""
 },
 {
   "symbol": "AXE",
   "name": "Anixter International Inc.",
   "last_sale": "72.7",
   "market_cap": "$2.43B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/axe",
   "FIELD9": ""
 },
 {
   "symbol": "NLY",
   "name": "Annaly Capital Management Inc",
   "last_sale": "10.29",
   "market_cap": "$13.41B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/nly",
   "FIELD9": ""
 },
 {
   "symbol": "NLY^C",
   "name": "Annaly Capital Management Inc",
   "last_sale": "25.49",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nly^c",
   "FIELD9": ""
 },
 {
   "symbol": "NLY^D",
   "name": "Annaly Capital Management Inc",
   "last_sale": "25.39",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nly^d",
   "FIELD9": ""
 },
 {
   "symbol": "NLY^F",
   "name": "Annaly Capital Management Inc",
   "last_sale": "25.56",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nly^f",
   "FIELD9": ""
 },
 {
   "symbol": "NLY^G",
   "name": "Annaly Capital Management Inc",
   "last_sale": "24.2",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nly^g",
   "FIELD9": ""
 },
 {
   "symbol": "NLY^H",
   "name": "Annaly Capital Management Inc",
   "last_sale": "25.7406",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nly^h",
   "FIELD9": ""
 },
 {
   "symbol": "AMGP",
   "name": "Antero Midstream GP LP",
   "last_sale": "17.35",
   "market_cap": "$3.23B",
   "IPOyear": "2017",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/amgp",
   "FIELD9": ""
 },
 {
   "symbol": "AM",
   "name": "Antero Midstream Partners LP",
   "last_sale": "30.05",
   "market_cap": "$5.62B",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/am",
   "FIELD9": ""
 },
 {
   "symbol": "AR",
   "name": "Antero Resources Corporation",
   "last_sale": "19.08",
   "market_cap": "$6.05B",
   "IPOyear": "2013",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/ar",
   "FIELD9": ""
 },
 {
   "symbol": "ANTM",
   "name": "Anthem, Inc.",
   "last_sale": "272.52",
   "market_cap": "$70.84B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/antm",
   "FIELD9": ""
 },
 {
   "symbol": "ANH",
   "name": "Anworth Mortgage Asset  Corporation",
   "last_sale": "4.81",
   "market_cap": "$473.17M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/anh",
   "FIELD9": ""
 },
 {
   "symbol": "ANH^A",
   "name": "Anworth Mortgage Asset  Corporation",
   "last_sale": "26.999",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/anh^a",
   "FIELD9": ""
 },
 {
   "symbol": "ANH^B",
   "name": "Anworth Mortgage Asset  Corporation",
   "last_sale": "25.75",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/anh^b",
   "FIELD9": ""
 },
 {
   "symbol": "ANH^C",
   "name": "Anworth Mortgage Asset  Corporation",
   "last_sale": "25.33",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/anh^c",
   "FIELD9": ""
 },
 {
   "symbol": "AON",
   "name": "Aon plc",
   "last_sale": "156.47",
   "market_cap": "$37.97B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/aon",
   "FIELD9": ""
 },
 {
   "symbol": "APA",
   "name": "Apache Corporation",
   "last_sale": "45.96",
   "market_cap": "$17.58B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/apa",
   "FIELD9": ""
 },
 {
   "symbol": "AIV",
   "name": "Apartment Investment and Management Company",
   "last_sale": "44.63",
   "market_cap": "$7.02B",
   "IPOyear": "1994",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/aiv",
   "FIELD9": ""
 },
 {
   "symbol": "AIV^A",
   "name": "Apartment Investment and Management Company",
   "last_sale": "26.26",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aiv^a",
   "FIELD9": ""
 },
 {
   "symbol": "APY",
   "name": "Apergy Corporation",
   "last_sale": "44.48",
   "market_cap": "$3.44B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/apy",
   "FIELD9": ""
 },
 {
   "symbol": "ARI",
   "name": "Apollo Commercial Real Estate Finance",
   "last_sale": "19.37",
   "market_cap": "$2.58B",
   "IPOyear": "2009",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ari",
   "FIELD9": ""
 },
 {
   "symbol": "ARI^C",
   "name": "Apollo Commercial Real Estate Finance",
   "last_sale": "25.75",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ari^c",
   "FIELD9": ""
 },
 {
   "symbol": "APO",
   "name": "Apollo Global Management, LLC",
   "last_sale": "36.07",
   "market_cap": "$14.58B",
   "IPOyear": "2011",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/apo",
   "FIELD9": ""
 },
 {
   "symbol": "APO^A",
   "name": "Apollo Global Management, LLC",
   "last_sale": "25.14",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/apo^a",
   "FIELD9": ""
 },
 {
   "symbol": "APO^B",
   "name": "Apollo Global Management, LLC",
   "last_sale": "24.71",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/apo^b",
   "FIELD9": ""
 },
 {
   "symbol": "AIY",
   "name": "Apollo Investment Corporation",
   "last_sale": "25.44",
   "market_cap": "n/a",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aiy",
   "FIELD9": ""
 },
 {
   "symbol": "AFT",
   "name": "Apollo Senior Floating Rate Fund Inc.",
   "last_sale": "16.05",
   "market_cap": "$249.95M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aft",
   "FIELD9": ""
 },
 {
   "symbol": "AIF",
   "name": "Apollo Tactical Income Fund Inc.",
   "last_sale": "15.5878",
   "market_cap": "$225.46M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aif",
   "FIELD9": ""
 },
 {
   "symbol": "APLE",
   "name": "Apple Hospitality REIT, Inc.",
   "last_sale": "17.43",
   "market_cap": "$4.01B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/aple",
   "FIELD9": ""
 },
 {
   "symbol": "AIT",
   "name": "Applied Industrial Technologies, Inc.",
   "last_sale": "81.15",
   "market_cap": "$3.14B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/ait",
   "FIELD9": ""
 },
 {
   "symbol": "ATR",
   "name": "AptarGroup, Inc.",
   "last_sale": "110.32",
   "market_cap": "$6.86B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Plastic Products",
   "summary_quote": "https://www.nasdaq.com/symbol/atr",
   "FIELD9": ""
 },
 {
   "symbol": "APTV",
   "name": "Aptiv PLC",
   "last_sale": "90.27",
   "market_cap": "$23.9B",
   "IPOyear": "2011",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/aptv",
   "FIELD9": ""
 },
 {
   "symbol": "WTR",
   "name": "Aqua America, Inc.",
   "last_sale": "37.21",
   "market_cap": "$6.62B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/wtr",
   "FIELD9": ""
 },
 {
   "symbol": "AQ",
   "name": "Aquantia Corp.",
   "last_sale": "13.05",
   "market_cap": "$447.1M",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/aq",
   "FIELD9": ""
 },
 {
   "symbol": "WAAS",
   "name": "AquaVenture Holdings Limited",
   "last_sale": "18.19",
   "market_cap": "$483.51M",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/waas",
   "FIELD9": ""
 },
 {
   "symbol": "ARMK",
   "name": "Aramark",
   "last_sale": "42.97",
   "market_cap": "$10.59B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/armk",
   "FIELD9": ""
 },
 {
   "symbol": "ABR",
   "name": "Arbor Realty Trust",
   "last_sale": "11.62",
   "market_cap": "$876.04M",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/abr",
   "FIELD9": ""
 },
 {
   "symbol": "ABR^A",
   "name": "Arbor Realty Trust",
   "last_sale": "25.7648",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/abr^a",
   "FIELD9": ""
 },
 {
   "symbol": "ABR^B",
   "name": "Arbor Realty Trust",
   "last_sale": "25.5728",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/abr^b",
   "FIELD9": ""
 },
 {
   "symbol": "ABR^C",
   "name": "Arbor Realty Trust",
   "last_sale": "26.13",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/abr^c",
   "FIELD9": ""
 },
 {
   "symbol": "ARC",
   "name": "ARC Document Solutions, Inc.",
   "last_sale": "3.05",
   "market_cap": "$139.3M",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/arc",
   "FIELD9": ""
 },
 {
   "symbol": "MT",
   "name": "ArcelorMittal",
   "last_sale": "32.05",
   "market_cap": "$32.48B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/mt",
   "FIELD9": ""
 },
 {
   "symbol": "ARCH",
   "name": "Arch Coal, Inc.",
   "last_sale": "90.51",
   "market_cap": "$1.77B",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/arch",
   "FIELD9": ""
 },
 {
   "symbol": "ADM",
   "name": "Archer-Daniels-Midland Company",
   "last_sale": "50.32",
   "market_cap": "$28.17B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/adm",
   "FIELD9": ""
 },
 {
   "symbol": "AROC",
   "name": "Archrock, Inc.",
   "last_sale": "11.8",
   "market_cap": "$1.53B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/aroc",
   "FIELD9": ""
 },
 {
   "symbol": "ARNC",
   "name": "Arconic Inc.",
   "last_sale": "22.88",
   "market_cap": "$11.05B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/arnc",
   "FIELD9": ""
 },
 {
   "symbol": "ARCO",
   "name": "Arcos Dorados Holdings Inc.",
   "last_sale": "6.6",
   "market_cap": "$1.38B",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/arco",
   "FIELD9": ""
 },
 {
   "symbol": "RCUS",
   "name": "Arcus Biosciences, Inc.",
   "last_sale": "13.51",
   "market_cap": "$600.61M",
   "IPOyear": "2018",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rcus",
   "FIELD9": ""
 },
 {
   "symbol": "ARD",
   "name": "Ardagh Group S.A.",
   "last_sale": "16.68",
   "market_cap": "$3.94B",
   "IPOyear": "2017",
   "sector": "Consumer Durables",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/ard",
   "FIELD9": ""
 },
 {
   "symbol": "ASC",
   "name": "Ardmore Shipping Corporation",
   "last_sale": "6.95",
   "market_cap": "$230.03M",
   "IPOyear": "2013",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/asc",
   "FIELD9": ""
 },
 {
   "symbol": "AFC",
   "name": "Ares Capital Corporation",
   "last_sale": "25.735",
   "market_cap": "$205.88M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/afc",
   "FIELD9": ""
 },
 {
   "symbol": "ACRE",
   "name": "Ares Commercial Real Estate Corporation",
   "last_sale": "14.27",
   "market_cap": "$409.53M",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/acre",
   "FIELD9": ""
 },
 {
   "symbol": "ARDC",
   "name": "Ares Dynamic Credit Allocation Fund, Inc.",
   "last_sale": "15.76",
   "market_cap": "$361.89M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ardc",
   "FIELD9": ""
 },
 {
   "symbol": "ARES",
   "name": "Ares Management L.P.",
   "last_sale": "23.3",
   "market_cap": "$5.09B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/ares",
   "FIELD9": ""
 },
 {
   "symbol": "ARES^A",
   "name": "Ares Management L.P.",
   "last_sale": "26.49",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ares^a",
   "FIELD9": ""
 },
 {
   "symbol": "AGX",
   "name": "Argan, Inc.",
   "last_sale": "44.05",
   "market_cap": "$685.8M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Engineering & Construction",
   "summary_quote": "https://www.nasdaq.com/symbol/agx",
   "FIELD9": ""
 },
 {
   "symbol": "ARGD",
   "name": "Argo Group International Holdings, Ltd.",
   "last_sale": "25.1722",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/argd",
   "FIELD9": ""
 },
 {
   "symbol": "ARGO",
   "name": "Argo Group International Holdings, Ltd.",
   "last_sale": "61.5",
   "market_cap": "$2.09B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/argo",
   "FIELD9": ""
 },
 {
   "symbol": "ANET",
   "name": "Arista Networks, Inc.",
   "last_sale": "269.29",
   "market_cap": "$20.15B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/anet",
   "FIELD9": ""
 },
 {
   "symbol": "AI",
   "name": "Arlington Asset Investment Corp",
   "last_sale": "10.14",
   "market_cap": "$291.35M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance/Investors Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ai",
   "FIELD9": ""
 },
 {
   "symbol": "AI^B",
   "name": "Arlington Asset Investment Corp",
   "last_sale": "24.1975",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ai^b",
   "FIELD9": ""
 },
 {
   "symbol": "AIC",
   "name": "Arlington Asset Investment Corp",
   "last_sale": "24.0698",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Finance/Investors Services",
   "summary_quote": "https://www.nasdaq.com/symbol/aic",
   "FIELD9": ""
 },
 {
   "symbol": "AIW",
   "name": "Arlington Asset Investment Corp",
   "last_sale": "24.5076",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance/Investors Services",
   "summary_quote": "https://www.nasdaq.com/symbol/aiw",
   "FIELD9": ""
 },
 {
   "symbol": "ARLO",
   "name": "Arlo Technologies, Inc.",
   "last_sale": "14.9",
   "market_cap": "$1.11B",
   "IPOyear": "2018",
   "sector": "Consumer Non-Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/arlo",
   "FIELD9": ""
 },
 {
   "symbol": "AHH",
   "name": "Armada Hoffler Properties, Inc.",
   "last_sale": "14.89",
   "market_cap": "$728M",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/ahh",
   "FIELD9": ""
 },
 {
   "symbol": "ARR",
   "name": "ARMOUR Residential REIT, Inc.",
   "last_sale": "22.85",
   "market_cap": "$961.45M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/arr",
   "FIELD9": ""
 },
 {
   "symbol": "ARR^A",
   "name": "ARMOUR Residential REIT, Inc.",
   "last_sale": "25.55",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/arr^a",
   "FIELD9": ""
 },
 {
   "symbol": "ARR^B",
   "name": "ARMOUR Residential REIT, Inc.",
   "last_sale": "25.06",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/arr^b",
   "FIELD9": ""
 },
 {
   "symbol": "AFI",
   "name": "Armstrong Flooring, Inc.",
   "last_sale": "19.81",
   "market_cap": "$510.55M",
   "IPOyear": "2016",
   "sector": "Consumer Non-Durables",
   "industry": "Plastic Products",
   "summary_quote": "https://www.nasdaq.com/symbol/afi",
   "FIELD9": ""
 },
 {
   "symbol": "AWI",
   "name": "Armstrong World Industries Inc",
   "last_sale": "69.7",
   "market_cap": "$3.6B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Plastic Products",
   "summary_quote": "https://www.nasdaq.com/symbol/awi",
   "FIELD9": ""
 },
 {
   "symbol": "ARW",
   "name": "Arrow Electronics, Inc.",
   "last_sale": "77.13",
   "market_cap": "$6.74B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/arw",
   "FIELD9": ""
 },
 {
   "symbol": "AJG",
   "name": "Arthur J. Gallagher & Co.",
   "last_sale": "75.91",
   "market_cap": "$13.86B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/ajg",
   "FIELD9": ""
 },
 {
   "symbol": "APAM",
   "name": "Artisan Partners Asset Management Inc.",
   "last_sale": "33.35",
   "market_cap": "$2.57B",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/apam",
   "FIELD9": ""
 },
 {
   "symbol": "ASA",
   "name": "ASA Gold and Precious Metals Limited",
   "last_sale": "8.81",
   "market_cap": "$169.94M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/asa",
   "FIELD9": ""
 },
 {
   "symbol": "ABG",
   "name": "Asbury Automotive Group Inc",
   "last_sale": "72.25",
   "market_cap": "$1.47B",
   "IPOyear": "2002",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/abg",
   "FIELD9": ""
 },
 {
   "symbol": "ASX",
   "name": "ASE Technology Holding Co., Ltd.",
   "last_sale": "4.65",
   "market_cap": "$9.71B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/asx",
   "FIELD9": ""
 },
 {
   "symbol": "ASGN",
   "name": "ASGN Incorporated",
   "last_sale": "79.43",
   "market_cap": "$4.16B",
   "IPOyear": "1992",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/asgn",
   "FIELD9": ""
 },
 {
   "symbol": "AHT",
   "name": "Ashford Hospitality Trust Inc",
   "last_sale": "6.45",
   "market_cap": "$636.05M",
   "IPOyear": "2003",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/aht",
   "FIELD9": ""
 },
 {
   "symbol": "AHT^D",
   "name": "Ashford Hospitality Trust Inc",
   "last_sale": "26.2",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aht^d",
   "FIELD9": ""
 },
 {
   "symbol": "AHT^F",
   "name": "Ashford Hospitality Trust Inc",
   "last_sale": "24.09",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aht^f",
   "FIELD9": ""
 },
 {
   "symbol": "AHT^G",
   "name": "Ashford Hospitality Trust Inc",
   "last_sale": "24.1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aht^g",
   "FIELD9": ""
 },
 {
   "symbol": "AHT^H",
   "name": "Ashford Hospitality Trust Inc",
   "last_sale": "24.53",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aht^h",
   "FIELD9": ""
 },
 {
   "symbol": "AHT^I",
   "name": "Ashford Hospitality Trust Inc",
   "last_sale": "24.3",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/aht^i",
   "FIELD9": ""
 },
 {
   "symbol": "ASH",
   "name": "Ashland Global Holdings Inc.",
   "last_sale": "85.67",
   "market_cap": "$5.35B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/ash",
   "FIELD9": ""
 },
 {
   "symbol": "APB",
   "name": "Asia Pacific Fund, Inc. (The)",
   "last_sale": "13.5",
   "market_cap": "$139.64M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/apb",
   "FIELD9": ""
 },
 {
   "symbol": "ASPN",
   "name": "Aspen Aerogels, Inc.",
   "last_sale": "4.45",
   "market_cap": "$106.53M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/aspn",
   "FIELD9": ""
 },
 {
   "symbol": "AHL",
   "name": "Aspen Insurance Holdings Limited",
   "last_sale": "41.5",
   "market_cap": "$2.48B",
   "IPOyear": "2003",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/ahl",
   "FIELD9": ""
 },
 {
   "symbol": "AHL^C",
   "name": "Aspen Insurance Holdings Limited",
   "last_sale": "25.45",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ahl^c",
   "FIELD9": ""
 },
 {
   "symbol": "AHL^D",
   "name": "Aspen Insurance Holdings Limited",
   "last_sale": "24",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ahl^d",
   "FIELD9": ""
 },
 {
   "symbol": "ASB",
   "name": "Associated Banc-Corp",
   "last_sale": "26.9",
   "market_cap": "$4.63B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/asb",
   "FIELD9": ""
 },
 {
   "symbol": "ASB^C",
   "name": "Associated Banc-Corp",
   "last_sale": "25.535",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/asb^c",
   "FIELD9": ""
 },
 {
   "symbol": "ASB^D",
   "name": "Associated Banc-Corp",
   "last_sale": "24",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/asb^d",
   "FIELD9": ""
 },
 {
   "symbol": "AC",
   "name": "Associated Capital Group, Inc.",
   "last_sale": "40.35",
   "market_cap": "$927.7M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/ac",
   "FIELD9": ""
 },
 {
   "symbol": "AIZ",
   "name": "Assurant, Inc.",
   "last_sale": "105.21",
   "market_cap": "$6.57B",
   "IPOyear": "2004",
   "sector": "Finance",
   "industry": "Accident &Health Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/aiz",
   "FIELD9": ""
 },
 {
   "symbol": "AIZP",
   "name": "Assurant, Inc.",
   "last_sale": "112.36",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Accident &Health Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/aizp",
   "FIELD9": ""
 },
 {
   "symbol": "AGO",
   "name": "Assured Guaranty Ltd.",
   "last_sale": "42.28",
   "market_cap": "$4.58B",
   "IPOyear": "2004",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/ago",
   "FIELD9": ""
 },
 {
   "symbol": "AGO^B",
   "name": "Assured Guaranty Ltd.",
   "last_sale": "25.79",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ago^b",
   "FIELD9": ""
 },
 {
   "symbol": "AGO^E",
   "name": "Assured Guaranty Ltd.",
   "last_sale": "25.245",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ago^e",
   "FIELD9": ""
 },
 {
   "symbol": "AGO^F",
   "name": "Assured Guaranty Ltd.",
   "last_sale": "25.01",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ago^f",
   "FIELD9": ""
 },
 {
   "symbol": "AZN",
   "name": "Astrazeneca PLC",
   "last_sale": "37.68",
   "market_cap": "$95.46B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/azn",
   "FIELD9": ""
 },
 {
   "symbol": "HOME",
   "name": "At Home Group Inc.",
   "last_sale": "33.04",
   "market_cap": "$2.1B",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/home",
   "FIELD9": ""
 },
 {
   "symbol": "T",
   "name": "AT&T Inc.",
   "last_sale": "33.78",
   "market_cap": "$245.31B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/t",
   "FIELD9": ""
 },
 {
   "symbol": "TBB",
   "name": "AT&T Inc.",
   "last_sale": "24.92",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tbb",
   "FIELD9": ""
 },
 {
   "symbol": "TBC",
   "name": "AT&T Inc.",
   "last_sale": "24.81",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tbc",
   "FIELD9": ""
 },
 {
   "symbol": "ATTO",
   "name": "Atento S.A.",
   "last_sale": "8.2",
   "market_cap": "$606.05M",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/atto",
   "FIELD9": ""
 },
 {
   "symbol": "ATH",
   "name": "Athene Holding Ltd.",
   "last_sale": "53.37",
   "market_cap": "$10.66B",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/ath",
   "FIELD9": ""
 },
 {
   "symbol": "ATKR",
   "name": "Atkore International Group Inc.",
   "last_sale": "26.52",
   "market_cap": "$1.22B",
   "IPOyear": "2016",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/atkr",
   "FIELD9": ""
 },
 {
   "symbol": "AT",
   "name": "Atlantic Power Corporation",
   "last_sale": "2.15",
   "market_cap": "$240.08M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/at",
   "FIELD9": ""
 },
 {
   "symbol": "ATO",
   "name": "Atmos Energy Corporation",
   "last_sale": "94.01",
   "market_cap": "$10.45B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil/Gas Transmission",
   "summary_quote": "https://www.nasdaq.com/symbol/ato",
   "FIELD9": ""
 },
 {
   "symbol": "AUO",
   "name": "AU Optronics Corp",
   "last_sale": "4.14",
   "market_cap": "$3.98B",
   "IPOyear": "2002",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/auo",
   "FIELD9": ""
 },
 {
   "symbol": "ATHM",
   "name": "Autohome Inc.",
   "last_sale": "82.76",
   "market_cap": "$9.69B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/athm",
   "FIELD9": ""
 },
 {
   "symbol": "ALV",
   "name": "Autoliv, Inc.",
   "last_sale": "93.36",
   "market_cap": "$8.13B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/alv",
   "FIELD9": ""
 },
 {
   "symbol": "AN",
   "name": "AutoNation, Inc.",
   "last_sale": "44.39",
   "market_cap": "$3.99B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/an",
   "FIELD9": ""
 },
 {
   "symbol": "AZO",
   "name": "AutoZone, Inc.",
   "last_sale": "769.87",
   "market_cap": "$19.82B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/azo",
   "FIELD9": ""
 },
 {
   "symbol": "AVLR",
   "name": "Avalara, Inc.",
   "last_sale": "40.48",
   "market_cap": "$2.69B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/avlr",
   "FIELD9": ""
 },
 {
   "symbol": "AVB",
   "name": "AvalonBay Communities, Inc.",
   "last_sale": "185.19",
   "market_cap": "$25.6B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/avb",
   "FIELD9": ""
 },
 {
   "symbol": "AGR",
   "name": "Avangrid, Inc.",
   "last_sale": "49.12",
   "market_cap": "$15.18B",
   "IPOyear": "2015",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/agr",
   "FIELD9": ""
 },
 {
   "symbol": "AVNS",
   "name": "Avanos Medical, Inc.",
   "last_sale": "68.33",
   "market_cap": "$3.23B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/avns",
   "FIELD9": ""
 },
 {
   "symbol": "AVYA",
   "name": "Avaya Holdings Corp.",
   "last_sale": "21.56",
   "market_cap": "$2.37B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/avya",
   "FIELD9": ""
 },
 {
   "symbol": "AVY",
   "name": "Avery Dennison Corporation",
   "last_sale": "112.76",
   "market_cap": "$9.86B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/avy",
   "FIELD9": ""
 },
 {
   "symbol": "AVH",
   "name": "Avianca Holdings S.A.",
   "last_sale": "5.78",
   "market_cap": "$720.32M",
   "IPOyear": "2013",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/avh",
   "FIELD9": ""
 },
 {
   "symbol": "AVA",
   "name": "Avista Corporation",
   "last_sale": "50.46",
   "market_cap": "$3.31B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/ava",
   "FIELD9": ""
 },
 {
   "symbol": "AVP",
   "name": "Avon Products, Inc.",
   "last_sale": "2.44",
   "market_cap": "$1.08B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/avp",
   "FIELD9": ""
 },
 {
   "symbol": "AVX",
   "name": "AVX Corporation",
   "last_sale": "19.19",
   "market_cap": "$3.24B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/avx",
   "FIELD9": ""
 },
 {
   "symbol": "EQH",
   "name": "AXA Equitable Holdings, Inc.",
   "last_sale": "22.46",
   "market_cap": "$12.6B",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/eqh",
   "FIELD9": ""
 },
 {
   "symbol": "AXTA",
   "name": "Axalta Coating Systems Ltd.",
   "last_sale": "30.7",
   "market_cap": "$7.39B",
   "IPOyear": "2014",
   "sector": "Basic Industries",
   "industry": "Paints/Coatings",
   "summary_quote": "https://www.nasdaq.com/symbol/axta",
   "FIELD9": ""
 },
 {
   "symbol": "AXS",
   "name": "Axis Capital Holdings Limited",
   "last_sale": "58.22",
   "market_cap": "$4.86B",
   "IPOyear": "2003",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/axs",
   "FIELD9": ""
 },
 {
   "symbol": "AXS^D",
   "name": "Axis Capital Holdings Limited",
   "last_sale": "24.12",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/axs^d",
   "FIELD9": ""
 },
 {
   "symbol": "AXS^E",
   "name": "Axis Capital Holdings Limited",
   "last_sale": "24.241",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/axs^e",
   "FIELD9": ""
 },
 {
   "symbol": "AZUL",
   "name": "Azul S.A.",
   "last_sale": "18.5",
   "market_cap": "$2.08B",
   "IPOyear": "2017",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/azul",
   "FIELD9": ""
 },
 {
   "symbol": "AZRE",
   "name": "Azure Power Global Limited",
   "last_sale": "15.8",
   "market_cap": "$411.18M",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/azre",
   "FIELD9": ""
 },
 {
   "symbol": "AZZ",
   "name": "AZZ Inc.",
   "last_sale": "51.45",
   "market_cap": "$1.34B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Building Products",
   "summary_quote": "https://www.nasdaq.com/symbol/azz",
   "FIELD9": ""
 },
 {
   "symbol": "BGS",
   "name": "B&G Foods, Inc.",
   "last_sale": "30.3",
   "market_cap": "$2B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/bgs",
   "FIELD9": ""
 },
 {
   "symbol": "BW",
   "name": "Babcock",
   "last_sale": "1.01",
   "market_cap": "$170.36M",
   "IPOyear": "2015",
   "sector": "Capital Goods",
   "industry": "Building Products",
   "summary_quote": "https://www.nasdaq.com/symbol/bw",
   "FIELD9": ""
 },
 {
   "symbol": "BGH",
   "name": "Babson Global Short Duration High Yield Fund",
   "last_sale": "19.5175",
   "market_cap": "$391.48M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bgh",
   "FIELD9": ""
 },
 {
   "symbol": "BMI",
   "name": "Badger Meter, Inc.",
   "last_sale": "54.25",
   "market_cap": "$1.58B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/bmi",
   "FIELD9": ""
 },
 {
   "symbol": "BHGE",
   "name": "Baker Hughes, a GE company",
   "last_sale": "32.9",
   "market_cap": "$36.17B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/bhge",
   "FIELD9": ""
 },
 {
   "symbol": "BBN",
   "name": "BalckRock Taxable Municipal Bond Trust",
   "last_sale": "21.28",
   "market_cap": "$1.22B",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbn",
   "FIELD9": ""
 },
 {
   "symbol": "BLL",
   "name": "Ball Corporation",
   "last_sale": "44.57",
   "market_cap": "$15.33B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/bll",
   "FIELD9": ""
 },
 {
   "symbol": "BANC",
   "name": "Banc of California, Inc.",
   "last_sale": "19.5",
   "market_cap": "$987.84M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/banc",
   "FIELD9": ""
 },
 {
   "symbol": "BANC^D",
   "name": "Banc of California, Inc.",
   "last_sale": "26.02",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/banc^d",
   "FIELD9": ""
 },
 {
   "symbol": "BANC^E",
   "name": "Banc of California, Inc.",
   "last_sale": "25.89",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/banc^e",
   "FIELD9": ""
 },
 {
   "symbol": "BBVA",
   "name": "Banco Bilbao Viscaya Argentaria S.A.",
   "last_sale": "6.61",
   "market_cap": "$44.07B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bbva",
   "FIELD9": ""
 },
 {
   "symbol": "BBD",
   "name": "Banco Bradesco Sa",
   "last_sale": "7.23",
   "market_cap": "$48.39B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bbd",
   "FIELD9": ""
 },
 {
   "symbol": "BBDO",
   "name": "Banco Bradesco Sa",
   "last_sale": "6.05",
   "market_cap": "$40.5B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bbdo",
   "FIELD9": ""
 },
 {
   "symbol": "BCH",
   "name": "Banco De Chile",
   "last_sale": "92.57",
   "market_cap": "$16.04B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bch",
   "FIELD9": ""
 },
 {
   "symbol": "BLX",
   "name": "Banco Latinoamericano de Comercio Exterior, S.A.",
   "last_sale": "21.75",
   "market_cap": "$862.12M",
   "IPOyear": "1992",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/blx",
   "FIELD9": ""
 },
 {
   "symbol": "BSMX",
   "name": "Banco Santander (Mexico), S.A., Institucion de Ban",
   "last_sale": "7.62",
   "market_cap": "$10.34B",
   "IPOyear": "2012",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bsmx",
   "FIELD9": ""
 },
 {
   "symbol": "BSBR",
   "name": "Banco Santander Brasil SA",
   "last_sale": "9.03",
   "market_cap": "$67.51B",
   "IPOyear": "2009",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bsbr",
   "FIELD9": ""
 },
 {
   "symbol": "BSAC",
   "name": "Banco Santander Chile",
   "last_sale": "33.04",
   "market_cap": "$15.57B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bsac",
   "FIELD9": ""
 },
 {
   "symbol": "SAN",
   "name": "Banco Santander, S.A.",
   "last_sale": "5.37",
   "market_cap": "$86.65B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/san",
   "FIELD9": ""
 },
 {
   "symbol": "SAN^B",
   "name": "Banco Santander, S.A.",
   "last_sale": "23.3",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/san^b",
   "FIELD9": ""
 },
 {
   "symbol": "CIB",
   "name": "BanColombia S.A.",
   "last_sale": "42.04",
   "market_cap": "$10.11B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cib",
   "FIELD9": ""
 },
 {
   "symbol": "BXS",
   "name": "BancorpSouth Bank",
   "last_sale": "34.1",
   "market_cap": "$3.37B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bxs",
   "FIELD9": ""
 },
 {
   "symbol": "BAC",
   "name": "Bank of America Corporation",
   "last_sale": "31.03",
   "market_cap": "$309.86B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bac",
   "FIELD9": ""
 },
 {
   "symbol": "BAC.WS.A",
   "name": "Bank of America Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bac.ws.a",
   "FIELD9": ""
 },
 {
   "symbol": "BAC.WS.B",
   "name": "Bank of America Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bac.ws.b",
   "FIELD9": ""
 },
 {
   "symbol": "BAC^A",
   "name": "Bank of America Corporation",
   "last_sale": "26.12",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bac^a",
   "FIELD9": ""
 },
 {
   "symbol": "BAC^B",
   "name": "Bank of America Corporation",
   "last_sale": "25.69",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bac^b",
   "FIELD9": ""
 },
 {
   "symbol": "BAC^C",
   "name": "Bank of America Corporation",
   "last_sale": "26.19",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bac^c",
   "FIELD9": ""
 },
 {
   "symbol": "BAC^E",
   "name": "Bank of America Corporation",
   "last_sale": "24.1799",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bac^e",
   "FIELD9": ""
 },
 {
   "symbol": "BAC^K",
   "name": "Bank of America Corporation",
   "last_sale": "25.37",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bac^k",
   "FIELD9": ""
 },
 {
   "symbol": "BAC^L",
   "name": "Bank of America Corporation",
   "last_sale": "1292.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bac^l",
   "FIELD9": ""
 },
 {
   "symbol": "BAC^W",
   "name": "Bank of America Corporation",
   "last_sale": "25.95",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bac^w",
   "FIELD9": ""
 },
 {
   "symbol": "BAC^Y",
   "name": "Bank of America Corporation",
   "last_sale": "26.29",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bac^y",
   "FIELD9": ""
 },
 {
   "symbol": "BML^G",
   "name": "Bank of America Corporation",
   "last_sale": "22.1328",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bml^g",
   "FIELD9": ""
 },
 {
   "symbol": "BML^H",
   "name": "Bank of America Corporation",
   "last_sale": "22.07",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bml^h",
   "FIELD9": ""
 },
 {
   "symbol": "BML^J",
   "name": "Bank of America Corporation",
   "last_sale": "24.5024",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bml^j",
   "FIELD9": ""
 },
 {
   "symbol": "BML^L",
   "name": "Bank of America Corporation",
   "last_sale": "23.7741",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bml^l",
   "FIELD9": ""
 },
 {
   "symbol": "BOH",
   "name": "Bank of Hawaii Corporation",
   "last_sale": "81.5",
   "market_cap": "$3.43B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/boh",
   "FIELD9": ""
 },
 {
   "symbol": "BMO",
   "name": "Bank Of Montreal",
   "last_sale": "83.81",
   "market_cap": "$53.63B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bmo",
   "FIELD9": ""
 },
 {
   "symbol": "NTB",
   "name": "Bank of N.T. Butterfield & Son Limited (The)",
   "last_sale": "51.49",
   "market_cap": "$2.84B",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ntb",
   "FIELD9": ""
 },
 {
   "symbol": "BK",
   "name": "Bank Of New York Mellon Corporation (The)",
   "last_sale": "53.39",
   "market_cap": "$53.39B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bk",
   "FIELD9": ""
 },
 {
   "symbol": "BK^C",
   "name": "Bank Of New York Mellon Corporation (The)",
   "last_sale": "24.79",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bk^c",
   "FIELD9": ""
 },
 {
   "symbol": "BNS",
   "name": "Bank of Nova Scotia (The)",
   "last_sale": "60.37",
   "market_cap": "$74.36B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bns",
   "FIELD9": ""
 },
 {
   "symbol": "BKU",
   "name": "BankUnited, Inc.",
   "last_sale": "37.19",
   "market_cap": "$3.92B",
   "IPOyear": "2011",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/bku",
   "FIELD9": ""
 },
 {
   "symbol": "BCS",
   "name": "Barclays PLC",
   "last_sale": "9.42",
   "market_cap": "$40.33B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bcs",
   "FIELD9": ""
 },
 {
   "symbol": "BCS^D",
   "name": "Barclays PLC",
   "last_sale": "26.05",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bcs^d",
   "FIELD9": ""
 },
 {
   "symbol": "BBDC",
   "name": "Barings BDC, Inc.",
   "last_sale": "10.13",
   "market_cap": "$519.51M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbdc",
   "FIELD9": ""
 },
 {
   "symbol": "MCI",
   "name": "Barings Corporate Investors",
   "last_sale": "15.4925",
   "market_cap": "$310.02M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mci",
   "FIELD9": ""
 },
 {
   "symbol": "MPV",
   "name": "Barings Participation Investors",
   "last_sale": "14.7532",
   "market_cap": "$154.81M",
   "IPOyear": "1988",
   "sector": "Consumer Services",
   "industry": "Miscellaneous",
   "summary_quote": "https://www.nasdaq.com/symbol/mpv",
   "FIELD9": ""
 },
 {
   "symbol": "BNED",
   "name": "Barnes & Noble Education, Inc",
   "last_sale": "5.7",
   "market_cap": "$267.42M",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/bned",
   "FIELD9": ""
 },
 {
   "symbol": "BKS",
   "name": "Barnes & Noble, Inc.",
   "last_sale": "5.75",
   "market_cap": "$419.85M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/bks",
   "FIELD9": ""
 },
 {
   "symbol": "B",
   "name": "Barnes Group, Inc.",
   "last_sale": "71.66",
   "market_cap": "$3.67B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/b",
   "FIELD9": ""
 },
 {
   "symbol": "ABX",
   "name": "Barrick Gold Corporation",
   "last_sale": "10.47",
   "market_cap": "$12.22B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/abx",
   "FIELD9": ""
 },
 {
   "symbol": "BAS",
   "name": "Basic Energy Services, Inc.",
   "last_sale": "9.25",
   "market_cap": "$244.85M",
   "IPOyear": "2005",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/bas",
   "FIELD9": ""
 },
 {
   "symbol": "BHC",
   "name": "Bausch Health Companies Inc.",
   "last_sale": "24.92",
   "market_cap": "$8.71B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bhc",
   "FIELD9": ""
 },
 {
   "symbol": "BAX",
   "name": "Baxter International Inc.",
   "last_sale": "77.37",
   "market_cap": "$41.34B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/bax",
   "FIELD9": ""
 },
 {
   "symbol": "BTE",
   "name": "Baytex Energy Corp",
   "last_sale": "2.68",
   "market_cap": "$1.48B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/bte",
   "FIELD9": ""
 },
 {
   "symbol": "BBT",
   "name": "BB&T Corporation",
   "last_sale": "51.44",
   "market_cap": "$39.84B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bbt",
   "FIELD9": ""
 },
 {
   "symbol": "BBT^D",
   "name": "BB&T Corporation",
   "last_sale": "25.54",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbt^d",
   "FIELD9": ""
 },
 {
   "symbol": "BBT^E",
   "name": "BB&T Corporation",
   "last_sale": "24.96",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbt^e",
   "FIELD9": ""
 },
 {
   "symbol": "BBT^F",
   "name": "BB&T Corporation",
   "last_sale": "24.74",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbt^f",
   "FIELD9": ""
 },
 {
   "symbol": "BBT^G",
   "name": "BB&T Corporation",
   "last_sale": "24.6735",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbt^g",
   "FIELD9": ""
 },
 {
   "symbol": "BBT^H",
   "name": "BB&T Corporation",
   "last_sale": "25.06",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbt^h",
   "FIELD9": ""
 },
 {
   "symbol": "BFR",
   "name": "BBVA Banco Frances S.A.",
   "last_sale": "12.13",
   "market_cap": "$2.48B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bfr",
   "FIELD9": ""
 },
 {
   "symbol": "BBX",
   "name": "BBX Capital Corporation",
   "last_sale": "7.32",
   "market_cap": "$711.75M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/bbx",
   "FIELD9": ""
 },
 {
   "symbol": "BCE",
   "name": "BCE, Inc.",
   "last_sale": "40.59",
   "market_cap": "$36.45B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/bce",
   "FIELD9": ""
 },
 {
   "symbol": "BZH",
   "name": "Beazer Homes USA, Inc.",
   "last_sale": "11.2",
   "market_cap": "$377.15M",
   "IPOyear": "1994",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/bzh",
   "FIELD9": ""
 },
 {
   "symbol": "BDX",
   "name": "Becton, Dickinson and Company",
   "last_sale": "261.52",
   "market_cap": "$69.97B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/bdx",
   "FIELD9": ""
 },
 {
   "symbol": "BDXA",
   "name": "Becton, Dickinson and Company",
   "last_sale": "65.77",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/bdxa",
   "FIELD9": ""
 },
 {
   "symbol": "BDC",
   "name": "Belden Inc",
   "last_sale": "72.63",
   "market_cap": "$2.95B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/bdc",
   "FIELD9": ""
 },
 {
   "symbol": "BDC^B",
   "name": "Belden Inc",
   "last_sale": "97.33",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bdc^b",
   "FIELD9": ""
 },
 {
   "symbol": "BXE",
   "name": "Bellatrix Exploration Ltd",
   "last_sale": "0.9401",
   "market_cap": "$58.06M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/bxe",
   "FIELD9": ""
 },
 {
   "symbol": "BEL",
   "name": "Belmond Ltd.",
   "last_sale": "17",
   "market_cap": "$1.75B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/bel",
   "FIELD9": ""
 },
 {
   "symbol": "BMS",
   "name": "Bemis Company, Inc.",
   "last_sale": "48.38",
   "market_cap": "$4.4B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/bms",
   "FIELD9": ""
 },
 {
   "symbol": "BHE",
   "name": "Benchmark Electronics, Inc.",
   "last_sale": "25.15",
   "market_cap": "$1.17B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/bhe",
   "FIELD9": ""
 },
 {
   "symbol": "BRK.A",
   "name": "Berkshire Hathaway Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/brk.a",
   "FIELD9": ""
 },
 {
   "symbol": "BRK.B",
   "name": "Berkshire Hathaway Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/brk.b",
   "FIELD9": ""
 },
 {
   "symbol": "BHLB",
   "name": "Berkshire Hills Bancorp, Inc.",
   "last_sale": "42.25",
   "market_cap": "$1.92B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bhlb",
   "FIELD9": ""
 },
 {
   "symbol": "BERY",
   "name": "Berry Global Group, Inc.",
   "last_sale": "50.14",
   "market_cap": "$6.61B",
   "IPOyear": "2012",
   "sector": "Consumer Non-Durables",
   "industry": "Plastic Products",
   "summary_quote": "https://www.nasdaq.com/symbol/bery",
   "FIELD9": ""
 },
 {
   "symbol": "BBY",
   "name": "Best Buy Co., Inc.",
   "last_sale": "80.64",
   "market_cap": "$22.14B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Consumer Electronics/Video Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/bby",
   "FIELD9": ""
 },
 {
   "symbol": "BSTI",
   "name": "BEST Inc.",
   "last_sale": "6.64",
   "market_cap": "$2.57B",
   "IPOyear": "2017",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bsti",
   "FIELD9": ""
 },
 {
   "symbol": "BHP",
   "name": "BHP Billiton Limited",
   "last_sale": "49.22",
   "market_cap": "$131.01B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/bhp",
   "FIELD9": ""
 },
 {
   "symbol": "BBL",
   "name": "BHP Billiton plc",
   "last_sale": "44.04",
   "market_cap": "$117.22B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/bbl",
   "FIELD9": ""
 },
 {
   "symbol": "BIG",
   "name": "Big Lots, Inc.",
   "last_sale": "41.18",
   "market_cap": "$1.65B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/big",
   "FIELD9": ""
 },
 {
   "symbol": "BH",
   "name": "Biglari Holdings Inc.",
   "last_sale": "185.16",
   "market_cap": "$382.86M",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/bh",
   "FIELD9": ""
 },
 {
   "symbol": "BH.A",
   "name": "Biglari Holdings Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bh.a",
   "FIELD9": ""
 },
 {
   "symbol": "BHVN",
   "name": "Biohaven Pharmaceutical Holding Company Ltd.",
   "last_sale": "37.67",
   "market_cap": "$1.51B",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bhvn",
   "FIELD9": ""
 },
 {
   "symbol": "BIO",
   "name": "Bio-Rad Laboratories, Inc.",
   "last_sale": "298.49",
   "market_cap": "$8.91B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/bio",
   "FIELD9": ""
 },
 {
   "symbol": "BIO.B",
   "name": "Bio-Rad Laboratories, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bio.b",
   "FIELD9": ""
 },
 {
   "symbol": "BITA",
   "name": "Bitauto Holdings Limited",
   "last_sale": "23.62",
   "market_cap": "$1.72B",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bita",
   "FIELD9": ""
 },
 {
   "symbol": "BJ",
   "name": "BJ&#39;s Wholesale Club Holdings, Inc.",
   "last_sale": "29.15",
   "market_cap": "$3.95B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/bj",
   "FIELD9": ""
 },
 {
   "symbol": "BKH",
   "name": "Black Hills Corporation",
   "last_sale": "59.15",
   "market_cap": "$3.17B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/bkh",
   "FIELD9": ""
 },
 {
   "symbol": "BKHU",
   "name": "Black Hills Corporation",
   "last_sale": "63.77",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/bkhu",
   "FIELD9": ""
 },
 {
   "symbol": "BKI",
   "name": "Black Knight, Inc.",
   "last_sale": "53.45",
   "market_cap": "$7.99B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/bki",
   "FIELD9": ""
 },
 {
   "symbol": "BSM",
   "name": "Black Stone Minerals, L.P.",
   "last_sale": "18.4",
   "market_cap": "$3.72B",
   "IPOyear": "2015",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/bsm",
   "FIELD9": ""
 },
 {
   "symbol": "BB",
   "name": "BlackBerry Limited",
   "last_sale": "10.41",
   "market_cap": "$5.6B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/bb",
   "FIELD9": ""
 },
 {
   "symbol": "BGIO",
   "name": "BlackRock 2022 Global Income Opportunity Trust",
   "last_sale": "8.86",
   "market_cap": "$196.06M",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bgio",
   "FIELD9": ""
 },
 {
   "symbol": "BJZ",
   "name": "Blackrock California Municipal 2018 Term Trust",
   "last_sale": "14.92",
   "market_cap": "$95.98M",
   "IPOyear": "2001",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bjz",
   "FIELD9": ""
 },
 {
   "symbol": "BFZ",
   "name": "BlackRock California Municipal Income Trust",
   "last_sale": "12.31",
   "market_cap": "$392.72M",
   "IPOyear": "2001",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bfz",
   "FIELD9": ""
 },
 {
   "symbol": "CII",
   "name": "Blackrock Capital and Income Strategies Fund Inc",
   "last_sale": "17.23",
   "market_cap": "$760.21M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cii",
   "FIELD9": ""
 },
 {
   "symbol": "BHK",
   "name": "Blackrock Core Bond Trust",
   "last_sale": "12.81",
   "market_cap": "$690.91M",
   "IPOyear": "2001",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bhk",
   "FIELD9": ""
 },
 {
   "symbol": "HYT",
   "name": "Blackrock Corporate High Yield Fund, Inc.",
   "last_sale": "10.55",
   "market_cap": "$1.32B",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hyt",
   "FIELD9": ""
 },
 {
   "symbol": "BTZ",
   "name": "BlackRock Credit Allocation Income Trust",
   "last_sale": "12.39",
   "market_cap": "$1.32B",
   "IPOyear": "2006",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/btz",
   "FIELD9": ""
 },
 {
   "symbol": "DSU",
   "name": "Blackrock Debt Strategies Fund, Inc.",
   "last_sale": "11.25",
   "market_cap": "$595.27M",
   "IPOyear": "1998",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dsu",
   "FIELD9": ""
 },
 {
   "symbol": "BGR",
   "name": "BlackRock Energy and Resources Trust",
   "last_sale": "14.39",
   "market_cap": "$429.19M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bgr",
   "FIELD9": ""
 },
 {
   "symbol": "BDJ",
   "name": "Blackrock Enhanced Equity Dividend Trust",
   "last_sale": "9.55",
   "market_cap": "$1.79B",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bdj",
   "FIELD9": ""
 },
 {
   "symbol": "EGF",
   "name": "Blackrock Enhanced Government Fund, Inc",
   "last_sale": "12.83",
   "market_cap": "$75M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/egf",
   "FIELD9": ""
 },
 {
   "symbol": "FRA",
   "name": "Blackrock Floating Rate Income Strategies Fund Inc",
   "last_sale": "13.79",
   "market_cap": "$513.44M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fra",
   "FIELD9": ""
 },
 {
   "symbol": "BFO",
   "name": "Blackrock Florida Municipal 2020 Term Trust",
   "last_sale": "14.23",
   "market_cap": "$79.15M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bfo",
   "FIELD9": ""
 },
 {
   "symbol": "BGT",
   "name": "Blackrock Global",
   "last_sale": "13.15",
   "market_cap": "$311.22M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bgt",
   "FIELD9": ""
 },
 {
   "symbol": "BOE",
   "name": "Blackrock Global",
   "last_sale": "11.12",
   "market_cap": "$766.3M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/boe",
   "FIELD9": ""
 },
 {
   "symbol": "BME",
   "name": "Blackrock Health Sciences Trust",
   "last_sale": "41.31",
   "market_cap": "$384.23M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bme",
   "FIELD9": ""
 },
 {
   "symbol": "BAF",
   "name": "BlackRock Income Investment Quality Trust",
   "last_sale": "12.95",
   "market_cap": "$113.3M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/baf",
   "FIELD9": ""
 },
 {
   "symbol": "BKT",
   "name": "BlackRock Income Trust Inc. (The)",
   "last_sale": "5.72",
   "market_cap": "$364.92M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bkt",
   "FIELD9": ""
 },
 {
   "symbol": "BGY",
   "name": "Sanoor Capital Management Lp, LTD.",
   "last_sale": "5.74",
   "market_cap": "$625.94M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bgy",
   "FIELD9": ""
 },
 {
   "symbol": "BKN",
   "name": "BlackRock Investment Quality Municipal Trust Inc. (The)",
   "last_sale": "13.36",
   "market_cap": "$229.6M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bkn",
   "FIELD9": ""
 },
 {
   "symbol": "BTA",
   "name": "BlackRock Long-Term Municipal Advantage Trust",
   "last_sale": "11.43",
   "market_cap": "$153.42M",
   "IPOyear": "2006",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bta",
   "FIELD9": ""
 },
 {
   "symbol": "BZM",
   "name": "BlackRock Maryland Municipal Bond Trust",
   "last_sale": "13.71",
   "market_cap": "$28.53M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bzm",
   "FIELD9": ""
 },
 {
   "symbol": "MHE",
   "name": "BlackRock Massachusetts Tax-Exempt Trust",
   "last_sale": "12",
   "market_cap": "$28.45M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mhe",
   "FIELD9": ""
 },
 {
   "symbol": "BIT",
   "name": "BlackRock Multi-Sector Income Trust",
   "last_sale": "17.36",
   "market_cap": "$657.1M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bit",
   "FIELD9": ""
 },
 {
   "symbol": "MUI",
   "name": "Blackrock Muni Intermediate Duration Fund Inc",
   "last_sale": "12.94",
   "market_cap": "$495.55M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mui",
   "FIELD9": ""
 },
 {
   "symbol": "MNE",
   "name": "Blackrock Muni New York Intermediate Duration Fund Inc",
   "last_sale": "12.57",
   "market_cap": "$52.92M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mne",
   "FIELD9": ""
 },
 {
   "symbol": "MUA",
   "name": "Blackrock MuniAssets Fund, Inc.",
   "last_sale": "13.04",
   "market_cap": "$469.54M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mua",
   "FIELD9": ""
 },
 {
   "symbol": "BPK",
   "name": "Blackrock Municipal 2018 Term Trust",
   "last_sale": "15.05",
   "market_cap": "$239.42M",
   "IPOyear": "2001",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bpk",
   "FIELD9": ""
 },
 {
   "symbol": "BKK",
   "name": "Blackrock Municipal 2020 Term Trust",
   "last_sale": "14.74",
   "market_cap": "$298.29M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bkk",
   "FIELD9": ""
 },
 {
   "symbol": "BBK",
   "name": "Blackrock Municipal Bond Trust",
   "last_sale": "13.81",
   "market_cap": "$145.32M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbk",
   "FIELD9": ""
 },
 {
   "symbol": "BBF",
   "name": "BlackRock Municipal Income Investment Trust",
   "last_sale": "13.1673",
   "market_cap": "$134.65M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bbf",
   "FIELD9": ""
 },
 {
   "symbol": "BYM",
   "name": "Blackrock Municipal Income Quality Trust",
   "last_sale": "12.71",
   "market_cap": "$335.62M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bym",
   "FIELD9": ""
 },
 {
   "symbol": "BFK",
   "name": "BlackRock Municipal Income Trust",
   "last_sale": "12.47",
   "market_cap": "$559.05M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bfk",
   "FIELD9": ""
 },
 {
   "symbol": "BLE",
   "name": "BlackRock Municipal Income Trust II",
   "last_sale": "13.12",
   "market_cap": "$308.71M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ble",
   "FIELD9": ""
 },
 {
   "symbol": "BTT",
   "name": "BlackRock Municipal Target Term Trust Inc. (The)",
   "last_sale": "20.68",
   "market_cap": "$1.46B",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/btt",
   "FIELD9": ""
 },
 {
   "symbol": "MEN",
   "name": "Blackrock MuniEnhanced Fund, Inc.",
   "last_sale": "10",
   "market_cap": "$296.81M",
   "IPOyear": "1989",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/men",
   "FIELD9": ""
 },
 {
   "symbol": "MUC",
   "name": "Blackrock MuniHoldings California Quality Fund,  Inc.",
   "last_sale": "12.605",
   "market_cap": "$516.84M",
   "IPOyear": "1998",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/muc",
   "FIELD9": ""
 },
 {
   "symbol": "MUH",
   "name": "Blackrock MuniHoldings Fund II, Inc.",
   "last_sale": "13.38",
   "market_cap": "$151.68M",
   "IPOyear": "1998",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/muh",
   "FIELD9": ""
 },
 {
   "symbol": "MHD",
   "name": "Blackrock MuniHoldings Fund, Inc.",
   "last_sale": "14.95",
   "market_cap": "$212.16M",
   "IPOyear": "1997",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mhd",
   "FIELD9": ""
 },
 {
   "symbol": "MFL",
   "name": "Blackrock MuniHoldings Investment Quality Fund",
   "last_sale": "12.31",
   "market_cap": "$466.5M",
   "IPOyear": "1997",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mfl",
   "FIELD9": ""
 },
 {
   "symbol": "MUJ",
   "name": "Blackrock MuniHoldings New Jersey Insured Fund, Inc.",
   "last_sale": "12.59",
   "market_cap": "$379.64M",
   "IPOyear": "1998",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/muj",
   "FIELD9": ""
 },
 {
   "symbol": "MHN",
   "name": "Blackrock MuniHoldings New York Quality Fund, Inc.",
   "last_sale": "11.94",
   "market_cap": "$371.72M",
   "IPOyear": "1997",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mhn",
   "FIELD9": ""
 },
 {
   "symbol": "MUE",
   "name": "Blackrock MuniHoldings Quality Fund II, Inc.",
   "last_sale": "11.84",
   "market_cap": "$266.65M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mue",
   "FIELD9": ""
 },
 {
   "symbol": "MUS",
   "name": "Blackrock MuniHoldings Quality Fund, Inc.",
   "last_sale": "11.57",
   "market_cap": "$150.62M",
   "IPOyear": "1998",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mus",
   "FIELD9": ""
 },
 {
   "symbol": "MVT",
   "name": "Blackrock MuniVest Fund II, Inc.",
   "last_sale": "13.35",
   "market_cap": "$284.43M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mvt",
   "FIELD9": ""
 },
 {
   "symbol": "MYC",
   "name": "Blackrock MuniYield California Fund, Inc.",
   "last_sale": "12.76",
   "market_cap": "$273.31M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/myc",
   "FIELD9": ""
 },
 {
   "symbol": "MCA",
   "name": "Blackrock MuniYield California Insured Fund, Inc.",
   "last_sale": "12.82",
   "market_cap": "$441.08M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mca",
   "FIELD9": ""
 },
 {
   "symbol": "MYD",
   "name": "Blackrock MuniYield Fund, Inc.",
   "last_sale": "13.31",
   "market_cap": "$624.12M",
   "IPOyear": "1991",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/myd",
   "FIELD9": ""
 },
 {
   "symbol": "MYF",
   "name": "Blackrock MuniYield Investment Fund",
   "last_sale": "14.38",
   "market_cap": "$196.98M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/myf",
   "FIELD9": ""
 },
 {
   "symbol": "MFT",
   "name": "Blackrock MuniYield Investment QualityFund",
   "last_sale": "12.51",
   "market_cap": "$106.05M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mft",
   "FIELD9": ""
 },
 {
   "symbol": "MIY",
   "name": "Blackrock MuniYield Michigan Quality Fund, Inc.",
   "last_sale": "12.415",
   "market_cap": "$367.21M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/miy",
   "FIELD9": ""
 },
 {
   "symbol": "MYJ",
   "name": "Blackrock MuniYield New Jersey Fund, Inc.",
   "last_sale": "13.0599",
   "market_cap": "$315.5M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/myj",
   "FIELD9": ""
 },
 {
   "symbol": "MYN",
   "name": "Blackrock MuniYield New York Quality Fund, Inc.",
   "last_sale": "11.46",
   "market_cap": "$453.66M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/myn",
   "FIELD9": ""
 },
 {
   "symbol": "MPA",
   "name": "Blackrock MuniYield Pennsylvania Quality Fund",
   "last_sale": "12.68",
   "market_cap": "$169.31M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mpa",
   "FIELD9": ""
 },
 {
   "symbol": "MQT",
   "name": "Blackrock MuniYield Quality Fund II, Inc.",
   "last_sale": "11.7",
   "market_cap": "$263.93M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mqt",
   "FIELD9": ""
 },
 {
   "symbol": "MYI",
   "name": "Blackrock MuniYield Quality Fund III, Inc.",
   "last_sale": "12",
   "market_cap": "$817.81M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/myi",
   "FIELD9": ""
 },
 {
   "symbol": "MQY",
   "name": "Blackrock MuniYield Quality Fund, Inc.",
   "last_sale": "13.39",
   "market_cap": "$411.24M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mqy",
   "FIELD9": ""
 },
 {
   "symbol": "BNY",
   "name": "BlackRock New York Investment Quality Municipal Trust Inc. (Th",
   "last_sale": "12.2",
   "market_cap": "$158.31M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bny",
   "FIELD9": ""
 },
 {
   "symbol": "BLH",
   "name": "Blackrock New York Municipal 2018 Term Trust",
   "last_sale": "14.9125",
   "market_cap": "$54.18M",
   "IPOyear": "2001",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/blh",
   "FIELD9": ""
 },
 {
   "symbol": "BQH",
   "name": "Blackrock New York Municipal Bond Trust",
   "last_sale": "12.84",
   "market_cap": "$35.95M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bqh",
   "FIELD9": ""
 },
 {
   "symbol": "BSE",
   "name": "Blackrock New York Municipal Income Quality Trust",
   "last_sale": "12.43",
   "market_cap": "$81.04M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bse",
   "FIELD9": ""
 },
 {
   "symbol": "BFY",
   "name": "BlackRock New York Municipal Income Trust II",
   "last_sale": "12.59",
   "market_cap": "$63.01M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bfy",
   "FIELD9": ""
 },
 {
   "symbol": "BCX",
   "name": "BlackRock Resources",
   "last_sale": "9.15",
   "market_cap": "$877.57M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bcx",
   "FIELD9": ""
 },
 {
   "symbol": "BST",
   "name": "BlackRock Science and Technology Trust",
   "last_sale": "35.18",
   "market_cap": "$787.72M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bst",
   "FIELD9": ""
 },
 {
   "symbol": "BSD",
   "name": "BlackRock Strategic Municipal Trust Inc. (The)",
   "last_sale": "12.15",
   "market_cap": "$88.79M",
   "IPOyear": "1999",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bsd",
   "FIELD9": ""
 },
 {
   "symbol": "BUI",
   "name": "BlackRock Utility, Infrastructure & Power Opportun",
   "last_sale": "20.67",
   "market_cap": "$350.43M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bui",
   "FIELD9": ""
 },
 {
   "symbol": "BHV",
   "name": "BlackRock Virginia Municipal Bond Trust",
   "last_sale": "16.9424",
   "market_cap": "$27.16M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bhv",
   "FIELD9": ""
 },
 {
   "symbol": "BLK",
   "name": "Julius Wealth Management.",
   "last_sale": "487.61",
   "market_cap": "$78.29B",
   "IPOyear": "1999",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/blk",
   "FIELD9": ""
 },
 {
   "symbol": "BGB",
   "name": "Blackstone / GSO Strategic Credit Fund",
   "last_sale": "15.88",
   "market_cap": "$709.27M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bgb",
   "FIELD9": ""
 },
 {
   "symbol": "BGX",
   "name": "Blackstone GSO Long Short Credit Income Fund",
   "last_sale": "16.27",
   "market_cap": "$206.66M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bgx",
   "FIELD9": ""
 },
 {
   "symbol": "BSL",
   "name": "Blackstone GSO Senior Floating Rate Term Fund",
   "last_sale": "18.16",
   "market_cap": "$276.72M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bsl",
   "FIELD9": ""
 },
 {
   "symbol": "BE",
   "name": "Bloom Energy Corporation",
   "last_sale": "30.95",
   "market_cap": "$3.38B",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/be",
   "FIELD9": ""
 },
 {
   "symbol": "APRN",
   "name": "Blue Apron Holdings, Inc.",
   "last_sale": "1.79",
   "market_cap": "$344.58M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/aprn",
   "FIELD9": ""
 },
 {
   "symbol": "BCRH",
   "name": "Blue Capital Reinsurance Holdings Ltd.",
   "last_sale": "10.1",
   "market_cap": "$88.55M",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/bcrh",
   "FIELD9": ""
 },
 {
   "symbol": "BXG",
   "name": "Bluegreen Vacations Corporation",
   "last_sale": "18.1",
   "market_cap": "$1.35B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/bxg",
   "FIELD9": ""
 },
 {
   "symbol": "BXC",
   "name": "BlueLinx Holdings Inc.",
   "last_sale": "34.93",
   "market_cap": "$324.45M",
   "IPOyear": "2004",
   "sector": "Capital Goods",
   "industry": "Wholesale Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/bxc",
   "FIELD9": ""
 },
 {
   "symbol": "BA",
   "name": "Boeing Company (The)",
   "last_sale": "372.23",
   "market_cap": "$213.85B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/ba",
   "FIELD9": ""
 },
 {
   "symbol": "BCC",
   "name": "Boise Cascade, L.L.C.",
   "last_sale": "38.15",
   "market_cap": "$1.48B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/bcc",
   "FIELD9": ""
 },
 {
   "symbol": "BCEI",
   "name": "Bonanza Creek Energy, Inc.",
   "last_sale": "29.99",
   "market_cap": "$616.03M",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/bcei",
   "FIELD9": ""
 },
 {
   "symbol": "BOOT",
   "name": "Boot Barn Holdings, Inc.",
   "last_sale": "27.71",
   "market_cap": "$775.76M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/boot",
   "FIELD9": ""
 },
 {
   "symbol": "BAH",
   "name": "Booz Allen Hamilton Holding Corporation",
   "last_sale": "49.57",
   "market_cap": "$7.06B",
   "IPOyear": "2010",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bah",
   "FIELD9": ""
 },
 {
   "symbol": "BWA",
   "name": "BorgWarner Inc.",
   "last_sale": "45.26",
   "market_cap": "$9.45B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/bwa",
   "FIELD9": ""
 },
 {
   "symbol": "SAM",
   "name": "Boston Beer Company, Inc. (The)",
   "last_sale": "297.7",
   "market_cap": "$3.5B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/sam",
   "FIELD9": ""
 },
 {
   "symbol": "BXP",
   "name": "Boston Properties, Inc.",
   "last_sale": "126.86",
   "market_cap": "$19.59B",
   "IPOyear": "1997",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/bxp",
   "FIELD9": ""
 },
 {
   "symbol": "BXP^B",
   "name": "Boston Properties, Inc.",
   "last_sale": "24.449",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bxp^b",
   "FIELD9": ""
 },
 {
   "symbol": "BSX",
   "name": "Boston Scientific Corporation",
   "last_sale": "37.77",
   "market_cap": "$52.23B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/bsx",
   "FIELD9": ""
 },
 {
   "symbol": "BOX",
   "name": "Box, Inc.",
   "last_sale": "23.64",
   "market_cap": "$3.35B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/box",
   "FIELD9": ""
 },
 {
   "symbol": "BYD",
   "name": "Boyd Gaming Corporation",
   "last_sale": "34.36",
   "market_cap": "$3.86B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/byd",
   "FIELD9": ""
 },
 {
   "symbol": "BPMP",
   "name": "BP Midstream Partners LP",
   "last_sale": "18.7",
   "market_cap": "$1.96B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/bpmp",
   "FIELD9": ""
 },
 {
   "symbol": "BP",
   "name": "BP p.l.c.",
   "last_sale": "44.67",
   "market_cap": "$148.65B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/bp",
   "FIELD9": ""
 },
 {
   "symbol": "BPT",
   "name": "BP Prudhoe Bay Royalty Trust",
   "last_sale": "33.1",
   "market_cap": "$708.34M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/bpt",
   "FIELD9": ""
 },
 {
   "symbol": "BRC",
   "name": "Brady Corporation",
   "last_sale": "44.15",
   "market_cap": "$2.3B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Miscellaneous manufacturing industries",
   "summary_quote": "https://www.nasdaq.com/symbol/brc",
   "FIELD9": ""
 },
 {
   "symbol": "BHR",
   "name": "Braemar Hotels & Resorts Inc.",
   "last_sale": "11.95",
   "market_cap": "$388.4M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/bhr",
   "FIELD9": ""
 },
 {
   "symbol": "BHR^B",
   "name": "Braemar Hotels & Resorts Inc.",
   "last_sale": "19.1834",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bhr^b",
   "FIELD9": ""
 },
 {
   "symbol": "BDN",
   "name": "Brandywine Realty Trust",
   "last_sale": "16.23",
   "market_cap": "$2.9B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/bdn",
   "FIELD9": ""
 },
 {
   "symbol": "BWG",
   "name": "BrandywineGLOBAL Global Income Opportunities Fund ",
   "last_sale": "10.96",
   "market_cap": "$230.05M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bwg",
   "FIELD9": ""
 },
 {
   "symbol": "LND",
   "name": "Brasilagro Cia Brasileira De Propriedades Agricolas",
   "last_sale": "3.424",
   "market_cap": "$184.22M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/lnd",
   "FIELD9": ""
 },
 {
   "symbol": "BAK",
   "name": "Braskem S.A.",
   "last_sale": "29.71",
   "market_cap": "$11.82B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/bak",
   "FIELD9": ""
 },
 {
   "symbol": "BRFS",
   "name": "BRF S.A.",
   "last_sale": "5.47",
   "market_cap": "$4.44B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Meat/Poultry/Fish",
   "summary_quote": "https://www.nasdaq.com/symbol/brfs",
   "FIELD9": ""
 },
 {
   "symbol": "BPI",
   "name": "Bridgepoint Education, Inc.",
   "last_sale": "10.07",
   "market_cap": "$271.77M",
   "IPOyear": "2009",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bpi",
   "FIELD9": ""
 },
 {
   "symbol": "BGG",
   "name": "Briggs & Stratton Corporation",
   "last_sale": "20.37",
   "market_cap": "$863.44M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/bgg",
   "FIELD9": ""
 },
 {
   "symbol": "BFAM",
   "name": "Bright Horizons Family Solutions Inc.",
   "last_sale": "116.36",
   "market_cap": "$6.75B",
   "IPOyear": "2013",
   "sector": "Miscellaneous",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bfam",
   "FIELD9": ""
 },
 {
   "symbol": "BEDU",
   "name": "Bright Scholar Education Holdings Limited",
   "last_sale": "13.01",
   "market_cap": "$1.53B",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bedu",
   "FIELD9": ""
 },
 {
   "symbol": "BSA",
   "name": "BrightSphere Investment Group plc",
   "last_sale": "22.8",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/bsa",
   "FIELD9": ""
 },
 {
   "symbol": "BSIG",
   "name": "BrightSphere Investment Group plc",
   "last_sale": "12.98",
   "market_cap": "$1.39B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/bsig",
   "FIELD9": ""
 },
 {
   "symbol": "BV",
   "name": "BrightView Holdings, Inc.",
   "last_sale": "17.19",
   "market_cap": "$1.76B",
   "IPOyear": "2018",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/bv",
   "FIELD9": ""
 },
 {
   "symbol": "EAT",
   "name": "Brinker International, Inc.",
   "last_sale": "47.98",
   "market_cap": "$1.96B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/eat",
   "FIELD9": ""
 },
 {
   "symbol": "BCO",
   "name": "Brink&#39;s Company (The)",
   "last_sale": "71.85",
   "market_cap": "$3.66B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/bco",
   "FIELD9": ""
 },
 {
   "symbol": "BMY",
   "name": "Bristol-Myers Squibb Company",
   "last_sale": "62.25",
   "market_cap": "$101.58B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/bmy",
   "FIELD9": ""
 },
 {
   "symbol": "BRS",
   "name": "Bristow Group Inc",
   "last_sale": "12.11",
   "market_cap": "$433.12M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/brs",
   "FIELD9": ""
 },
 {
   "symbol": "BTI",
   "name": "British American Tobacco p.l.c.",
   "last_sale": "47.42",
   "market_cap": "$108.77B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/bti",
   "FIELD9": ""
 },
 {
   "symbol": "BRX",
   "name": "Brixmor Property Group Inc.",
   "last_sale": "17.54",
   "market_cap": "$5.31B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/brx",
   "FIELD9": ""
 },
 {
   "symbol": "BR",
   "name": "Broadridge Financial Solutions, Inc.",
   "last_sale": "132.65",
   "market_cap": "$15.43B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/br",
   "FIELD9": ""
 },
 {
   "symbol": "BKD",
   "name": "Brookdale Senior Living Inc.",
   "last_sale": "9.7",
   "market_cap": "$1.82B",
   "IPOyear": "2005",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/bkd",
   "FIELD9": ""
 },
 {
   "symbol": "BAM",
   "name": "Brookfield Asset Management Inc",
   "last_sale": "44.24",
   "market_cap": "$43.9B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Building operators",
   "summary_quote": "https://www.nasdaq.com/symbol/bam",
   "FIELD9": ""
 },
 {
   "symbol": "BBU",
   "name": "Brookfield Business Partners L.P.",
   "last_sale": "44",
   "market_cap": "$2.91B",
   "IPOyear": "2016",
   "sector": "Basic Industries",
   "industry": "Engineering & Construction",
   "summary_quote": "https://www.nasdaq.com/symbol/bbu",
   "FIELD9": ""
 },
 {
   "symbol": "DTLA^",
   "name": "Brookfield DTLA Inc.",
   "last_sale": "23.14",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dtla^",
   "FIELD9": ""
 },
 {
   "symbol": "INF",
   "name": "Brookfield Global Listed Infrastructure Income Fund",
   "last_sale": "12.19",
   "market_cap": "$168.21M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/inf",
   "FIELD9": ""
 },
 {
   "symbol": "BIP",
   "name": "Brookfield Infrastructure Partners LP",
   "last_sale": "38.93",
   "market_cap": "$10.77B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/bip",
   "FIELD9": ""
 },
 {
   "symbol": "RA",
   "name": "Brookfield Real Assets Income Fund Inc.",
   "last_sale": "23.14",
   "market_cap": "$844.33M",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ra",
   "FIELD9": ""
 },
 {
   "symbol": "BEP",
   "name": "Brookfield Renewable Partners L.P.",
   "last_sale": "31.05",
   "market_cap": "$5.6B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/bep",
   "FIELD9": ""
 },
 {
   "symbol": "BRO",
   "name": "Brown & Brown, Inc.",
   "last_sale": "30.27",
   "market_cap": "$8.45B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/bro",
   "FIELD9": ""
 },
 {
   "symbol": "BF.A",
   "name": "Brown Forman Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bf.a",
   "FIELD9": ""
 },
 {
   "symbol": "BF.B",
   "name": "Brown Forman Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bf.b",
   "FIELD9": ""
 },
 {
   "symbol": "BRT",
   "name": "BRT Apartments Corp.",
   "last_sale": "11.98",
   "market_cap": "$187.78M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/brt",
   "FIELD9": ""
 },
 {
   "symbol": "BC",
   "name": "Brunswick Corporation",
   "last_sale": "67.64",
   "market_cap": "$5.87B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/bc",
   "FIELD9": ""
 },
 {
   "symbol": "BT",
   "name": "BT Group plc",
   "last_sale": "15.1",
   "market_cap": "$29.96B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/bt",
   "FIELD9": ""
 },
 {
   "symbol": "BPL",
   "name": "Buckeye Partners L.P.",
   "last_sale": "36.02",
   "market_cap": "$5.52B",
   "IPOyear": "1986",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/bpl",
   "FIELD9": ""
 },
 {
   "symbol": "BKE",
   "name": "Buckle, Inc. (The)",
   "last_sale": "22.7",
   "market_cap": "$1.11B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/bke",
   "FIELD9": ""
 },
 {
   "symbol": "BVN",
   "name": "Buenaventura Mining Company Inc.",
   "last_sale": "13.39",
   "market_cap": "$3.4B",
   "IPOyear": "1996",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/bvn",
   "FIELD9": ""
 },
 {
   "symbol": "BBW",
   "name": "Build-A-Bear Workshop, Inc.",
   "last_sale": "9",
   "market_cap": "$134.75M",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/bbw",
   "FIELD9": ""
 },
 {
   "symbol": "BG",
   "name": "Bunge Limited",
   "last_sale": "66.73",
   "market_cap": "$9.41B",
   "IPOyear": "2001",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/bg",
   "FIELD9": ""
 },
 {
   "symbol": "BURL",
   "name": "Burlington Stores, Inc.",
   "last_sale": "158.77",
   "market_cap": "$10.73B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/burl",
   "FIELD9": ""
 },
 {
   "symbol": "BWXT",
   "name": "BWX Technologies, Inc.",
   "last_sale": "62.69",
   "market_cap": "$6.25B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/bwxt",
   "FIELD9": ""
 },
 {
   "symbol": "BY",
   "name": "Byline Bancorp, Inc.",
   "last_sale": "23.22",
   "market_cap": "$841M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/by",
   "FIELD9": ""
 },
 {
   "symbol": "CJ",
   "name": "C&J Energy Services, Inc",
   "last_sale": "22.16",
   "market_cap": "$1.51B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/cj",
   "FIELD9": ""
 },
 {
   "symbol": "GYB",
   "name": "CABCO Series 2004-101 Trust",
   "last_sale": "22.2895",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gyb",
   "FIELD9": ""
 },
 {
   "symbol": "PFH",
   "name": "CABCO Series 2004-101 Trust",
   "last_sale": "9.7196",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pfh",
   "FIELD9": ""
 },
 {
   "symbol": "CABO",
   "name": "Cable One, Inc.",
   "last_sale": "880.06",
   "market_cap": "$5.02B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cabo",
   "FIELD9": ""
 },
 {
   "symbol": "CBT",
   "name": "Cabot Corporation",
   "last_sale": "65.69",
   "market_cap": "$4.04B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/cbt",
   "FIELD9": ""
 },
 {
   "symbol": "COG",
   "name": "Cabot Oil & Gas Corporation",
   "last_sale": "23.21",
   "market_cap": "$10.24B",
   "IPOyear": "1990",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/cog",
   "FIELD9": ""
 },
 {
   "symbol": "CACI",
   "name": "CACI International, Inc.",
   "last_sale": "186.35",
   "market_cap": "$4.6B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/caci",
   "FIELD9": ""
 },
 {
   "symbol": "WHD",
   "name": "Cactus, Inc.",
   "last_sale": "36.7",
   "market_cap": "$2.75B",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/whd",
   "FIELD9": ""
 },
 {
   "symbol": "CADE",
   "name": "Cadence Bancorporation",
   "last_sale": "27.23",
   "market_cap": "$2.28B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cade",
   "FIELD9": ""
 },
 {
   "symbol": "CAE",
   "name": "CAE Inc",
   "last_sale": "20.43",
   "market_cap": "$5.46B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cae",
   "FIELD9": ""
 },
 {
   "symbol": "CAI",
   "name": "CAI International, Inc.",
   "last_sale": "26.48",
   "market_cap": "$511.23M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cai",
   "FIELD9": ""
 },
 {
   "symbol": "CAI^A",
   "name": "CAI International, Inc.",
   "last_sale": "25.7299",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cai^a",
   "FIELD9": ""
 },
 {
   "symbol": "CAI^B",
   "name": "CAI International, Inc.",
   "last_sale": "25.63",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cai^b",
   "FIELD9": ""
 },
 {
   "symbol": "CAL",
   "name": "Caleres, Inc.",
   "last_sale": "34.97",
   "market_cap": "$1.51B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Shoe Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/cal",
   "FIELD9": ""
 },
 {
   "symbol": "CRC",
   "name": "California Resources Corporation",
   "last_sale": "39.6",
   "market_cap": "$1.91B",
   "IPOyear": "2014",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/crc",
   "FIELD9": ""
 },
 {
   "symbol": "CWT",
   "name": "California Water  Service Group Holding",
   "last_sale": "41.45",
   "market_cap": "$1.99B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/cwt",
   "FIELD9": ""
 },
 {
   "symbol": "CALX",
   "name": "Calix, Inc",
   "last_sale": "8.15",
   "market_cap": "$432.6M",
   "IPOyear": "2010",
   "sector": "Consumer Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/calx",
   "FIELD9": ""
 },
 {
   "symbol": "ELY",
   "name": "Callaway Golf Company",
   "last_sale": "22.71",
   "market_cap": "$2.14B",
   "IPOyear": "1992",
   "sector": "Consumer Non-Durables",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/ely",
   "FIELD9": ""
 },
 {
   "symbol": "CPE",
   "name": "Callon Petroleum Company",
   "last_sale": "11.75",
   "market_cap": "$2.67B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/cpe",
   "FIELD9": ""
 },
 {
   "symbol": "CPE^A",
   "name": "Callon Petroleum Company",
   "last_sale": "51.1492",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/cpe^a",
   "FIELD9": ""
 },
 {
   "symbol": "CBM",
   "name": "Cambrex Corporation",
   "last_sale": "61.2",
   "market_cap": "$2.04B",
   "IPOyear": "1987",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cbm",
   "FIELD9": ""
 },
 {
   "symbol": "CPT",
   "name": "Camden Property Trust",
   "last_sale": "94.91",
   "market_cap": "$8.81B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cpt",
   "FIELD9": ""
 },
 {
   "symbol": "CCJ",
   "name": "Cameco Corporation",
   "last_sale": "9.92",
   "market_cap": "$3.93B",
   "IPOyear": "1996",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/ccj",
   "FIELD9": ""
 },
 {
   "symbol": "CPB",
   "name": "Campbell Soup Company",
   "last_sale": "40.05",
   "market_cap": "$12.04B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/cpb",
   "FIELD9": ""
 },
 {
   "symbol": "CWH",
   "name": "Camping World Holdings, Inc.",
   "last_sale": "22.06",
   "market_cap": "$1.93B",
   "IPOyear": "2016",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/cwh",
   "FIELD9": ""
 },
 {
   "symbol": "GOOS",
   "name": "Canada Goose Holdings Inc.",
   "last_sale": "57.3",
   "market_cap": "$2.79B",
   "IPOyear": "2017",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/goos",
   "FIELD9": ""
 },
 {
   "symbol": "CM",
   "name": "Canadian Imperial Bank of Commerce",
   "last_sale": "96.24",
   "market_cap": "$42.66B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cm",
   "FIELD9": ""
 },
 {
   "symbol": "CNI",
   "name": "Canadian National Railway Company",
   "last_sale": "88.68",
   "market_cap": "$64.97B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/cni",
   "FIELD9": ""
 },
 {
   "symbol": "CNQ",
   "name": "Canadian Natural Resources Limited",
   "last_sale": "32.41",
   "market_cap": "$39.57B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/cnq",
   "FIELD9": ""
 },
 {
   "symbol": "CP",
   "name": "Canadian Pacific Railway Limited",
   "last_sale": "209.83",
   "market_cap": "$29.92B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/cp",
   "FIELD9": ""
 },
 {
   "symbol": "CANG",
   "name": "Cango Inc.",
   "last_sale": "8.723",
   "market_cap": "$1.32B",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cang",
   "FIELD9": ""
 },
 {
   "symbol": "CNNE",
   "name": "Cannae Holdings, Inc.",
   "last_sale": "21.43",
   "market_cap": "$1.54B",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/cnne",
   "FIELD9": ""
 },
 {
   "symbol": "CAJ",
   "name": "Canon, Inc.",
   "last_sale": "31.68",
   "market_cap": "$34.21B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/caj",
   "FIELD9": ""
 },
 {
   "symbol": "CGC",
   "name": "Canopy Growth Corporation",
   "last_sale": "49.78",
   "market_cap": "$11.38B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/cgc",
   "FIELD9": ""
 },
 {
   "symbol": "CMD",
   "name": "Cantel Medical Corp.",
   "last_sale": "97.3",
   "market_cap": "$4.06B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/cmd",
   "FIELD9": ""
 },
 {
   "symbol": "COF",
   "name": "Capital One Financial Corporation",
   "last_sale": "99.01",
   "market_cap": "$47.37B",
   "IPOyear": "1994",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cof",
   "FIELD9": ""
 },
 {
   "symbol": "COF.WS",
   "name": "Capital One Financial Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cof.ws",
   "FIELD9": ""
 },
 {
   "symbol": "COF^C",
   "name": "Capital One Financial Corporation",
   "last_sale": "25.76",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cof^c",
   "FIELD9": ""
 },
 {
   "symbol": "COF^D",
   "name": "Capital One Financial Corporation",
   "last_sale": "26.36",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cof^d",
   "FIELD9": ""
 },
 {
   "symbol": "COF^F",
   "name": "Capital One Financial Corporation",
   "last_sale": "25.79",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cof^f",
   "FIELD9": ""
 },
 {
   "symbol": "COF^G",
   "name": "Capital One Financial Corporation",
   "last_sale": "24.63",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cof^g",
   "FIELD9": ""
 },
 {
   "symbol": "COF^H",
   "name": "Capital One Financial Corporation",
   "last_sale": "25.6835",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cof^h",
   "FIELD9": ""
 },
 {
   "symbol": "COF^P",
   "name": "Capital One Financial Corporation",
   "last_sale": "25.2",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cof^p",
   "FIELD9": ""
 },
 {
   "symbol": "CSU",
   "name": "Capital Senior Living Corporation",
   "last_sale": "9.22",
   "market_cap": "$287.45M",
   "IPOyear": "1997",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/csu",
   "FIELD9": ""
 },
 {
   "symbol": "BXMT",
   "name": "Capital Trust, Inc.",
   "last_sale": "34.37",
   "market_cap": "$4.07B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/bxmt",
   "FIELD9": ""
 },
 {
   "symbol": "CIC",
   "name": "Capitol Investment Corp. IV",
   "last_sale": "9.9",
   "market_cap": "$118.03M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cic",
   "FIELD9": ""
 },
 {
   "symbol": "CIC.U",
   "name": "Capitol Investment Corp. IV",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cic.u",
   "FIELD9": ""
 },
 {
   "symbol": "CIC.WS",
   "name": "Capitol Investment Corp. IV",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cic.ws",
   "FIELD9": ""
 },
 {
   "symbol": "CMO",
   "name": "Capstead Mortgage Corporation",
   "last_sale": "8.1",
   "market_cap": "$749.27M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cmo",
   "FIELD9": ""
 },
 {
   "symbol": "CMO^E",
   "name": "Capstead Mortgage Corporation",
   "last_sale": "25.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cmo^e",
   "FIELD9": ""
 },
 {
   "symbol": "CRR",
   "name": "Carbo Ceramics, Inc.",
   "last_sale": "8.09",
   "market_cap": "$224.42M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/crr",
   "FIELD9": ""
 },
 {
   "symbol": "CAH",
   "name": "Cardinal Health, Inc.",
   "last_sale": "54.94",
   "market_cap": "$16.97B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Other Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/cah",
   "FIELD9": ""
 },
 {
   "symbol": "CRCM",
   "name": "Care.com, Inc.",
   "last_sale": "21.05",
   "market_cap": "$658.11M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/crcm",
   "FIELD9": ""
 },
 {
   "symbol": "CSL",
   "name": "Carlisle Companies Incorporated",
   "last_sale": "123.85",
   "market_cap": "$7.4B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/csl",
   "FIELD9": ""
 },
 {
   "symbol": "KMX",
   "name": "CarMax Inc",
   "last_sale": "78.17",
   "market_cap": "$13.8B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/kmx",
   "FIELD9": ""
 },
 {
   "symbol": "CCL",
   "name": "Carnival Corporation",
   "last_sale": "67.17",
   "market_cap": "$49.49B",
   "IPOyear": "1987",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/ccl",
   "FIELD9": ""
 },
 {
   "symbol": "CUK",
   "name": "Carnival Corporation",
   "last_sale": "66.38",
   "market_cap": "$48.63B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/cuk",
   "FIELD9": ""
 },
 {
   "symbol": "CRS",
   "name": "Carpenter Technology Corporation",
   "last_sale": "59.18",
   "market_cap": "$2.8B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/crs",
   "FIELD9": ""
 },
 {
   "symbol": "CSV",
   "name": "Carriage Services, Inc.",
   "last_sale": "22.38",
   "market_cap": "$428.66M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/csv",
   "FIELD9": ""
 },
 {
   "symbol": "CARS",
   "name": "Cars.com Inc.",
   "last_sale": "26.46",
   "market_cap": "$1.85B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cars",
   "FIELD9": ""
 },
 {
   "symbol": "CRI",
   "name": "Carter&#39;s, Inc.",
   "last_sale": "94.87",
   "market_cap": "$4.41B",
   "IPOyear": "2003",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/cri",
   "FIELD9": ""
 },
 {
   "symbol": "CVNA",
   "name": "Carvana Co.",
   "last_sale": "60.01",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/cvna",
   "FIELD9": ""
 },
 {
   "symbol": "CSLT",
   "name": "Castlight Health, inc.",
   "last_sale": "2.85",
   "market_cap": "$392.62M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cslt",
   "FIELD9": ""
 },
 {
   "symbol": "CTLT",
   "name": "Catalent, Inc.",
   "last_sale": "42.65",
   "market_cap": "$6.18B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ctlt",
   "FIELD9": ""
 },
 {
   "symbol": "CTT           ",
   "name": "CatchMark Timber Trust, Inc.",
   "last_sale": "11.8",
   "market_cap": "$579.57M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ctt",
   "FIELD9": ""
 },
 {
   "symbol": "CAT",
   "name": "Caterpillar, Inc.",
   "last_sale": "156.38",
   "market_cap": "$92.94B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/cat",
   "FIELD9": ""
 },
 {
   "symbol": "CATO",
   "name": "Cato Corporation (The)",
   "last_sale": "20.29",
   "market_cap": "$500.61M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/cato",
   "FIELD9": ""
 },
 {
   "symbol": "CBZ",
   "name": "CBIZ, Inc.",
   "last_sale": "23.95",
   "market_cap": "$1.32B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cbz",
   "FIELD9": ""
 },
 {
   "symbol": "CBL",
   "name": "CBL & Associates Properties, Inc.",
   "last_sale": "4.36",
   "market_cap": "$752.83M",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cbl",
   "FIELD9": ""
 },
 {
   "symbol": "CBL^D",
   "name": "CBL & Associates Properties, Inc.",
   "last_sale": "16.67",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cbl^d",
   "FIELD9": ""
 },
 {
   "symbol": "CBL^E",
   "name": "CBL & Associates Properties, Inc.",
   "last_sale": "14.91",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cbl^e",
   "FIELD9": ""
 },
 {
   "symbol": "CBO",
   "name": "CBO (Listing Market - NYSE - Networks A/E)",
   "last_sale": "5.15",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cbo",
   "FIELD9": ""
 },
 {
   "symbol": "IGR",
   "name": "CBRE Clarion Global Real Estate Income Fund",
   "last_sale": "7.39",
   "market_cap": "$861.6M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/igr",
   "FIELD9": ""
 },
 {
   "symbol": "CBRE",
   "name": "CBRE Group, Inc.",
   "last_sale": "45.46",
   "market_cap": "$15.45B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/cbre",
   "FIELD9": ""
 },
 {
   "symbol": "CBS",
   "name": "CBS Corporation",
   "last_sale": "56.74",
   "market_cap": "$21.34B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/cbs",
   "FIELD9": ""
 },
 {
   "symbol": "CBS.A",
   "name": "CBS Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cbs.a",
   "FIELD9": ""
 },
 {
   "symbol": "CBX",
   "name": "CBX (Listing Market NYSE Networks AE",
   "last_sale": "1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cbx",
   "FIELD9": ""
 },
 {
   "symbol": "FUN",
   "name": "Cedar Fair, L.P.",
   "last_sale": "52.45",
   "market_cap": "$2.96B",
   "IPOyear": "1987",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/fun",
   "FIELD9": ""
 },
 {
   "symbol": "CDR",
   "name": "Cedar Realty Trust, Inc.",
   "last_sale": "4.47",
   "market_cap": "$407.71M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cdr",
   "FIELD9": ""
 },
 {
   "symbol": "CDR^B",
   "name": "Cedar Realty Trust, Inc.",
   "last_sale": "24.29",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cdr^b",
   "FIELD9": ""
 },
 {
   "symbol": "CDR^C",
   "name": "Cedar Realty Trust, Inc.",
   "last_sale": "21.82",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cdr^c",
   "FIELD9": ""
 },
 {
   "symbol": "CE",
   "name": "Celanese Corporation",
   "last_sale": "116.22",
   "market_cap": "$15.69B",
   "IPOyear": "2005",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/ce",
   "FIELD9": ""
 },
 {
   "symbol": "CLS",
   "name": "Celestica, Inc.",
   "last_sale": "10.9",
   "market_cap": "$1.32B",
   "IPOyear": "1998",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/cls",
   "FIELD9": ""
 },
 {
   "symbol": "CEL",
   "name": "Cellcom Israel, Ltd.",
   "last_sale": "6.83",
   "market_cap": "$690.13M",
   "IPOyear": "2007",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/cel",
   "FIELD9": ""
 },
 {
   "symbol": "CPAC",
   "name": "Cementos Pacasmayo S.A.A.",
   "last_sale": "10.08",
   "market_cap": "$863.06M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/cpac",
   "FIELD9": ""
 },
 {
   "symbol": "CX",
   "name": "Cemex S.A.B. de C.V.",
   "last_sale": "7.06",
   "market_cap": "$10.67B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/cx",
   "FIELD9": ""
 },
 {
   "symbol": "CVE",
   "name": "Cenovus Energy Inc",
   "last_sale": "9.35",
   "market_cap": "$11.49B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/cve",
   "FIELD9": ""
 },
 {
   "symbol": "CNC",
   "name": "Centene Corporation",
   "last_sale": "142.71",
   "market_cap": "$29.29B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/cnc",
   "FIELD9": ""
 },
 {
   "symbol": "CEN",
   "name": "Center Coast Brookfield MLP & Energy Infrastructur",
   "last_sale": "9.61",
   "market_cap": "$278.79M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cen",
   "FIELD9": ""
 },
 {
   "symbol": "CNP",
   "name": "CenterPoint Energy, Inc.",
   "last_sale": "28.03",
   "market_cap": "$12.1B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/cnp",
   "FIELD9": ""
 },
 {
   "symbol": "EBR",
   "name": "Centrais Electricas Brasileiras S.A.- Eletrobras",
   "last_sale": "3.93",
   "market_cap": "$5.32B",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/ebr",
   "FIELD9": ""
 },
 {
   "symbol": "EBR.B",
   "name": "Centrais Electricas Brasileiras S.A.- Eletrobras",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ebr.b",
   "FIELD9": ""
 },
 {
   "symbol": "CEPU",
   "name": "Central Puerto S.A.",
   "last_sale": "12.1",
   "market_cap": "$1.82B",
   "IPOyear": "2018",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/cepu",
   "FIELD9": ""
 },
 {
   "symbol": "CCS",
   "name": "Century Communities, Inc.",
   "last_sale": "27.4",
   "market_cap": "$825.27M",
   "IPOyear": "2014",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/ccs",
   "FIELD9": ""
 },
 {
   "symbol": "CTL",
   "name": "CenturyLink, Inc.",
   "last_sale": "22.94",
   "market_cap": "$24.78B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ctl",
   "FIELD9": ""
 },
 {
   "symbol": "CDAY",
   "name": "Ceridian HCM Holding Inc.",
   "last_sale": "42.01",
   "market_cap": "$5.67B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/cday",
   "FIELD9": ""
 },
 {
   "symbol": "CF",
   "name": "CF Industries Holdings, Inc.",
   "last_sale": "52.81",
   "market_cap": "$12.33B",
   "IPOyear": "2005",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/cf",
   "FIELD9": ""
 },
 {
   "symbol": "CGG",
   "name": "CGG",
   "last_sale": "2.74",
   "market_cap": "$1.95B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/cgg",
   "FIELD9": ""
 },
 {
   "symbol": "GIB",
   "name": "CGI Group, Inc.",
   "last_sale": "66.2",
   "market_cap": "$16.59B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gib",
   "FIELD9": ""
 },
 {
   "symbol": "ECOM          ",
   "name": "ChannelAdvisor Corporation",
   "last_sale": "11.05",
   "market_cap": "$301.47M",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/ecom",
   "FIELD9": ""
 },
 {
   "symbol": "CHAP",
   "name": "Chaparral Energy, Inc.",
   "last_sale": "18.16",
   "market_cap": "$843.72M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/chap",
   "FIELD9": ""
 },
 {
   "symbol": "CHRA",
   "name": "Charah Solutions, Inc.",
   "last_sale": "5.96",
   "market_cap": "$173.33M",
   "IPOyear": "2018",
   "sector": "Basic Industries",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/chra",
   "FIELD9": ""
 },
 {
   "symbol": "CRL",
   "name": "Charles River Laboratories International, Inc.",
   "last_sale": "128.41",
   "market_cap": "$6.17B",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/crl",
   "FIELD9": ""
 },
 {
   "symbol": "CLDT",
   "name": "Chatham Lodging Trust (REIT)",
   "last_sale": "20.83",
   "market_cap": "$955.66M",
   "IPOyear": "2010",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cldt",
   "FIELD9": ""
 },
 {
   "symbol": "CMCM",
   "name": "Cheetah Mobile Inc.",
   "last_sale": "9.79",
   "market_cap": "$1.4B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/cmcm",
   "FIELD9": ""
 },
 {
   "symbol": "CHGG",
   "name": "Chegg, Inc.",
   "last_sale": "31.52",
   "market_cap": "$3.59B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/chgg",
   "FIELD9": ""
 },
 {
   "symbol": "CHE",
   "name": "Chemed Corp.",
   "last_sale": "313.09",
   "market_cap": "$5.04B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/che",
   "FIELD9": ""
 },
 {
   "symbol": "CC",
   "name": "Chemours Company (The)",
   "last_sale": "41.04",
   "market_cap": "$7.26B",
   "IPOyear": "2015",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/cc",
   "FIELD9": ""
 },
 {
   "symbol": "CHMI",
   "name": "Cherry Hill Mortgage Investment Corporation",
   "last_sale": "18.54",
   "market_cap": "$293.28M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/chmi",
   "FIELD9": ""
 },
 {
   "symbol": "CHMI^A",
   "name": "Cherry Hill Mortgage Investment Corporation",
   "last_sale": "25.65",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/chmi^a",
   "FIELD9": ""
 },
 {
   "symbol": "CHK",
   "name": "Chesapeake Energy Corporation",
   "last_sale": "4.44",
   "market_cap": "$4.05B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/chk",
   "FIELD9": ""
 },
 {
   "symbol": "CHK^D",
   "name": "Chesapeake Energy Corporation",
   "last_sale": "53.85",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/chk^d",
   "FIELD9": ""
 },
 {
   "symbol": "CHKR",
   "name": "Chesapeake Granite Wash Trust",
   "last_sale": "1.675",
   "market_cap": "$78.31M",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/chkr",
   "FIELD9": ""
 },
 {
   "symbol": "CHSP",
   "name": "Chesapeake Lodging Trust",
   "last_sale": "33.22",
   "market_cap": "$2.01B",
   "IPOyear": "2010",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/chsp",
   "FIELD9": ""
 },
 {
   "symbol": "CPK",
   "name": "Chesapeake Utilities Corporation",
   "last_sale": "89.05",
   "market_cap": "$1.46B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/cpk",
   "FIELD9": ""
 },
 {
   "symbol": "CVX",
   "name": "Chevron Corporation",
   "last_sale": "121.13",
   "market_cap": "$232.1B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/cvx",
   "FIELD9": ""
 },
 {
   "symbol": "CHS",
   "name": "Chico&#39;s FAS, Inc.",
   "last_sale": "8.35",
   "market_cap": "$1.05B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/chs",
   "FIELD9": ""
 },
 {
   "symbol": "CIM",
   "name": "Chimera Investment Corporation",
   "last_sale": "18.71",
   "market_cap": "$3.5B",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cim",
   "FIELD9": ""
 },
 {
   "symbol": "CIM^A",
   "name": "Chimera Investment Corporation",
   "last_sale": "25.72",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cim^a",
   "FIELD9": ""
 },
 {
   "symbol": "CIM^B",
   "name": "Chimera Investment Corporation",
   "last_sale": "25.665",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cim^b",
   "FIELD9": ""
 },
 {
   "symbol": "DL",
   "name": "China Distance Education Holdings Limited",
   "last_sale": "7.89",
   "market_cap": "$262.89M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dl",
   "FIELD9": ""
 },
 {
   "symbol": "CEA",
   "name": "China Eastern Airlines Corporation Ltd.",
   "last_sale": "33.19",
   "market_cap": "$9.6B",
   "IPOyear": "1997",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cea",
   "FIELD9": ""
 },
 {
   "symbol": "CHN",
   "name": "China Fund, Inc. (The)",
   "last_sale": "19.6783",
   "market_cap": "$309.4M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/chn",
   "FIELD9": ""
 },
 {
   "symbol": "CGA",
   "name": "China Green Agriculture, Inc.",
   "last_sale": "0.92",
   "market_cap": "$35.79M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/cga",
   "FIELD9": ""
 },
 {
   "symbol": "LFC",
   "name": "China Life Insurance Company Limited",
   "last_sale": "11.43",
   "market_cap": "$64.61B",
   "IPOyear": "2003",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/lfc",
   "FIELD9": ""
 },
 {
   "symbol": "CHL",
   "name": "China Mobile (Hong Kong) Ltd.",
   "last_sale": "48.42",
   "market_cap": "$198.28B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/chl",
   "FIELD9": ""
 },
 {
   "symbol": "BORN",
   "name": "China New Borun Corporation",
   "last_sale": "1.12",
   "market_cap": "$28.81M",
   "IPOyear": "2010",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/born",
   "FIELD9": ""
 },
 {
   "symbol": "COE",
   "name": "China Online Education Group",
   "last_sale": "9.16",
   "market_cap": "$184.86M",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/coe",
   "FIELD9": ""
 },
 {
   "symbol": "SNP",
   "name": "China Petroleum & Chemical Corporation",
   "last_sale": "97.13",
   "market_cap": "$117.6B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/snp",
   "FIELD9": ""
 },
 {
   "symbol": "XRF",
   "name": "China Rapid Finance Limited",
   "last_sale": "2.57",
   "market_cap": "$168.07M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/xrf",
   "FIELD9": ""
 },
 {
   "symbol": "ZNH",
   "name": "China Southern Airlines Company Limited",
   "last_sale": "34.23",
   "market_cap": "$7.32B",
   "IPOyear": "1997",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/znh",
   "FIELD9": ""
 },
 {
   "symbol": "CHA",
   "name": "China Telecom Corp Ltd",
   "last_sale": "48.41",
   "market_cap": "$39.18B",
   "IPOyear": "2002",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/cha",
   "FIELD9": ""
 },
 {
   "symbol": "CHU",
   "name": "China Unicom (Hong Kong) Ltd",
   "last_sale": "12.13",
   "market_cap": "$37.12B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/chu",
   "FIELD9": ""
 },
 {
   "symbol": "CYD",
   "name": "China Yuchai International Limited",
   "last_sale": "17.66",
   "market_cap": "$721.56M",
   "IPOyear": "1994",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cyd",
   "FIELD9": ""
 },
 {
   "symbol": "CMG",
   "name": "Chipotle Mexican Grill, Inc.",
   "last_sale": "467.37",
   "market_cap": "$12.99B",
   "IPOyear": "2006",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/cmg",
   "FIELD9": ""
 },
 {
   "symbol": "CHH",
   "name": "Choice Hotels International, Inc.",
   "last_sale": "83.2",
   "market_cap": "$4.71B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/chh",
   "FIELD9": ""
 },
 {
   "symbol": "CBK",
   "name": "Christopher & Banks Corporation",
   "last_sale": "0.81",
   "market_cap": "$31.12M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/cbk",
   "FIELD9": ""
 },
 {
   "symbol": "CB",
   "name": "Chubb Limited",
   "last_sale": "139.86",
   "market_cap": "$64.79B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/cb",
   "FIELD9": ""
 },
 {
   "symbol": "CHT",
   "name": "Chunghwa Telecom Co., Ltd.",
   "last_sale": "35.48",
   "market_cap": "$27.52B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/cht",
   "FIELD9": ""
 },
 {
   "symbol": "CHD",
   "name": "Church & Dwight Company, Inc.",
   "last_sale": "60.04",
   "market_cap": "$14.73B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/chd",
   "FIELD9": ""
 },
 {
   "symbol": "CCC.U",
   "name": "Churchill Capital Corp",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ccc.u",
   "FIELD9": ""
 },
 {
   "symbol": "CIEN",
   "name": "Ciena Corporation",
   "last_sale": "31.04",
   "market_cap": "$4.43B",
   "IPOyear": "1997",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/cien",
   "FIELD9": ""
 },
 {
   "symbol": "CI",
   "name": "Cigna Holding Co",
   "last_sale": "202.23",
   "market_cap": "$49.22B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/ci",
   "FIELD9": ""
 },
 {
   "symbol": "XEC",
   "name": "Cimarex Energy Co",
   "last_sale": "92.34",
   "market_cap": "$8.81B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/xec",
   "FIELD9": ""
 },
 {
   "symbol": "CBB",
   "name": "Cincinnati Bell Inc",
   "last_sale": "14.95",
   "market_cap": "$749.85M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/cbb",
   "FIELD9": ""
 },
 {
   "symbol": "CBB^B",
   "name": "Cincinnati Bell Inc",
   "last_sale": "48.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cbb^b",
   "FIELD9": ""
 },
 {
   "symbol": "CNK",
   "name": "Cinemark Holdings Inc",
   "last_sale": "38.55",
   "market_cap": "$4.5B",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "Movies/Entertainment",
   "summary_quote": "https://www.nasdaq.com/symbol/cnk",
   "FIELD9": ""
 },
 {
   "symbol": "CINR",
   "name": "Ciner Resources LP",
   "last_sale": "27.35",
   "market_cap": "$540.41M",
   "IPOyear": "2013",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/cinr",
   "FIELD9": ""
 },
 {
   "symbol": "CIR",
   "name": "CIRCOR International, Inc.",
   "last_sale": "47.5",
   "market_cap": "$942.24M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/cir",
   "FIELD9": ""
 },
 {
   "symbol": "CISN",
   "name": "Cision Ltd.",
   "last_sale": "16.35",
   "market_cap": "$2.17B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/cisn",
   "FIELD9": ""
 },
 {
   "symbol": "CIT",
   "name": "CIT Group Inc (DEL)",
   "last_sale": "53.85",
   "market_cap": "$6.09B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cit",
   "FIELD9": ""
 },
 {
   "symbol": "BLW",
   "name": "Citigroup Inc.",
   "last_sale": "14.88",
   "market_cap": "$549.71M",
   "IPOyear": "2003",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/blw",
   "FIELD9": ""
 },
 {
   "symbol": "C",
   "name": "Citigroup Inc.",
   "last_sale": "74.15",
   "market_cap": "$186.61B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/c",
   "FIELD9": ""
 },
 {
   "symbol": "C.WS.A",
   "name": "Citigroup Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/c.ws.a",
   "FIELD9": ""
 },
 {
   "symbol": "C^J",
   "name": "Citigroup Inc.",
   "last_sale": "28.16",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/c^j",
   "FIELD9": ""
 },
 {
   "symbol": "C^K",
   "name": "Citigroup Inc.",
   "last_sale": "27.81",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/c^k",
   "FIELD9": ""
 },
 {
   "symbol": "C^L",
   "name": "Citigroup Inc.",
   "last_sale": "25.65",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/c^l",
   "FIELD9": ""
 },
 {
   "symbol": "C^N",
   "name": "Citigroup Inc.",
   "last_sale": "26.98",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/c^n",
   "FIELD9": ""
 },
 {
   "symbol": "C^S",
   "name": "Citigroup Inc.",
   "last_sale": "26.1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/c^s",
   "FIELD9": ""
 },
 {
   "symbol": "CFG",
   "name": "Citizens Financial Group, Inc.",
   "last_sale": "40.98",
   "market_cap": "$19.5B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cfg",
   "FIELD9": ""
 },
 {
   "symbol": "CIA",
   "name": "Citizens, Inc.",
   "last_sale": "8.26",
   "market_cap": "$413.68M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/cia",
   "FIELD9": ""
 },
 {
   "symbol": "CIO",
   "name": "City Office REIT, Inc.",
   "last_sale": "12.43",
   "market_cap": "$449.14M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cio",
   "FIELD9": ""
 },
 {
   "symbol": "CIO^A",
   "name": "City Office REIT, Inc.",
   "last_sale": "25.0974",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cio^a",
   "FIELD9": ""
 },
 {
   "symbol": "CVEO",
   "name": "Civeo Corporation",
   "last_sale": "3.65",
   "market_cap": "$613.05M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/cveo",
   "FIELD9": ""
 },
 {
   "symbol": "CIVI",
   "name": "Civitas Solutions, Inc.",
   "last_sale": "14.65",
   "market_cap": "$530.76M",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/civi",
   "FIELD9": ""
 },
 {
   "symbol": "CLH",
   "name": "Clean Harbors, Inc.",
   "last_sale": "69.3",
   "market_cap": "$3.89B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/clh",
   "FIELD9": ""
 },
 {
   "symbol": "CCO",
   "name": "Clear Channel Outdoor Holdings, Inc.",
   "last_sale": "5.85",
   "market_cap": "$2.13B",
   "IPOyear": "2005",
   "sector": "Consumer Services",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/cco",
   "FIELD9": ""
 },
 {
   "symbol": "CBA           ",
   "name": "ClearBridge American Energy MLP Fund Inc.",
   "last_sale": "7.95",
   "market_cap": "$465.81M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cba",
   "FIELD9": ""
 },
 {
   "symbol": "CEM",
   "name": "ClearBridge Energy MLP Fund Inc.",
   "last_sale": "14.64",
   "market_cap": "$1.03B",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cem",
   "FIELD9": ""
 },
 {
   "symbol": "EMO",
   "name": "ClearBridge Energy MLP Opportunity Fund Inc.",
   "last_sale": "11.49",
   "market_cap": "$358.44M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/emo",
   "FIELD9": ""
 },
 {
   "symbol": "CTR",
   "name": "ClearBridge Energy MLP Total Return Fund Inc.",
   "last_sale": "11.42",
   "market_cap": "$438.53M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ctr",
   "FIELD9": ""
 },
 {
   "symbol": "CLW",
   "name": "Clearwater Paper Corporation",
   "last_sale": "31.75",
   "market_cap": "$522.64M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/clw",
   "FIELD9": ""
 },
 {
   "symbol": "CWEN",
   "name": "Clearway Energy, Inc.",
   "last_sale": "20",
   "market_cap": "$3.78B",
   "IPOyear": "2015",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/cwen",
   "FIELD9": ""
 },
 {
   "symbol": "CWEN.A",
   "name": "Clearway Energy, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cwen.a",
   "FIELD9": ""
 },
 {
   "symbol": "CLF",
   "name": "Cleveland-Cliffs Inc.",
   "last_sale": "12.16",
   "market_cap": "$3.62B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/clf",
   "FIELD9": ""
 },
 {
   "symbol": "CLPR",
   "name": "Clipper Realty Inc.",
   "last_sale": "13.1",
   "market_cap": "$233.35M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/clpr",
   "FIELD9": ""
 },
 {
   "symbol": "CLX",
   "name": "Clorox Company (The)",
   "last_sale": "152.47",
   "market_cap": "$19.53B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/clx",
   "FIELD9": ""
 },
 {
   "symbol": "CLD",
   "name": "Cloud Peak Energy Inc",
   "last_sale": "2.41",
   "market_cap": "$182.63M",
   "IPOyear": "2009",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/cld",
   "FIELD9": ""
 },
 {
   "symbol": "CLDR",
   "name": "Cloudera, Inc.",
   "last_sale": "17.61",
   "market_cap": "$2.66B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/cldr",
   "FIELD9": ""
 },
 {
   "symbol": "CMS",
   "name": "CMS Energy Corporation",
   "last_sale": "49.33",
   "market_cap": "$13.97B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/cms",
   "FIELD9": ""
 },
 {
   "symbol": "CMS^B",
   "name": "CMS Energy Corporation",
   "last_sale": "103",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/cms^b",
   "FIELD9": ""
 },
 {
   "symbol": "CMSA",
   "name": "CMS Energy Corporation",
   "last_sale": "24.31",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/cmsa",
   "FIELD9": ""
 },
 {
   "symbol": "CNA",
   "name": "CNA Financial Corporation",
   "last_sale": "47.62",
   "market_cap": "$12.92B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/cna",
   "FIELD9": ""
 },
 {
   "symbol": "CNHI",
   "name": "CNH Industrial N.V.",
   "last_sale": "12.61",
   "market_cap": "$17.09B",
   "IPOyear": "2013",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/cnhi",
   "FIELD9": ""
 },
 {
   "symbol": "CNO",
   "name": "CNO Financial Group, Inc.",
   "last_sale": "21.9",
   "market_cap": "$3.6B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Accident &Health Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/cno",
   "FIELD9": ""
 },
 {
   "symbol": "CEO",
   "name": "CNOOC Limited",
   "last_sale": "182.56",
   "market_cap": "$1.92B",
   "IPOyear": "2001",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/ceo",
   "FIELD9": ""
 },
 {
   "symbol": "CNXM",
   "name": "CNX Midstream Partners LP",
   "last_sale": "19.55",
   "market_cap": "$1.24B",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/cnxm",
   "FIELD9": ""
 },
 {
   "symbol": "CEIX",
   "name": "CNX Resources Corporation",
   "last_sale": "41.68",
   "market_cap": "$1.17B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/ceix",
   "FIELD9": ""
 },
 {
   "symbol": "CNX",
   "name": "CNX Resources Corporation",
   "last_sale": "14.61",
   "market_cap": "$3.11B",
   "IPOyear": "1999",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/cnx",
   "FIELD9": ""
 },
 {
   "symbol": "KOF",
   "name": "Coca Cola Femsa S.A.B. de C.V.",
   "last_sale": "60.77",
   "market_cap": "$12.77B",
   "IPOyear": "1993",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/kof",
   "FIELD9": ""
 },
 {
   "symbol": "KO",
   "name": "Coca-Cola Company (The)",
   "last_sale": "46.58",
   "market_cap": "$198.1B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/ko",
   "FIELD9": ""
 },
 {
   "symbol": "CCE",
   "name": "Coca-Cola European Partners plc",
   "last_sale": "45.86",
   "market_cap": "$22.31B",
   "IPOyear": "2016",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/cce",
   "FIELD9": ""
 },
 {
   "symbol": "CDE",
   "name": "Coeur Mining, Inc.",
   "last_sale": "5.61",
   "market_cap": "$1.05B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/cde",
   "FIELD9": ""
 },
 {
   "symbol": "FOF",
   "name": "Cohen & Steers Closed-End Opportunity Fund, Inc.",
   "last_sale": "13.1667",
   "market_cap": "$358.25M",
   "IPOyear": "2006",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fof",
   "FIELD9": ""
 },
 {
   "symbol": "INB",
   "name": "Cohen & Steers Global Income Builder, Inc.",
   "last_sale": "9.4",
   "market_cap": "$217.54M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/inb",
   "FIELD9": ""
 },
 {
   "symbol": "CNS",
   "name": "Cohen & Steers Inc",
   "last_sale": "41.9",
   "market_cap": "$1.96B",
   "IPOyear": "2004",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/cns",
   "FIELD9": ""
 },
 {
   "symbol": "UTF",
   "name": "Cohen & Steers Infrastructure Fund, Inc",
   "last_sale": "22.94",
   "market_cap": "$1.96B",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/utf",
   "FIELD9": ""
 },
 {
   "symbol": "LDP",
   "name": "Cohen & Steers Limited Duration Preferred and Income Fund, Inc",
   "last_sale": "23.99",
   "market_cap": "$691.65M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ldp",
   "FIELD9": ""
 },
 {
   "symbol": "MIE",
   "name": "Cohen & Steers MLP Income and Energy Opportunity Fund, Inc.",
   "last_sale": "10.39",
   "market_cap": "$278.38M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mie",
   "FIELD9": ""
 },
 {
   "symbol": "RQI",
   "name": "Cohen & Steers Quality Income Realty Fund Inc",
   "last_sale": "12.38",
   "market_cap": "$1.35B",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rqi",
   "FIELD9": ""
 },
 {
   "symbol": "RNP",
   "name": "Cohen & Steers Reit and Preferred Income Fund Inc",
   "last_sale": "19.75",
   "market_cap": "$939.44M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rnp",
   "FIELD9": ""
 },
 {
   "symbol": "PSF",
   "name": "Cohen & Steers Select Preferred and Income Fund, Inc.",
   "last_sale": "27.14",
   "market_cap": "$325.53M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psf",
   "FIELD9": ""
 },
 {
   "symbol": "RFI",
   "name": "Cohen & Steers Total Return Realty Fund, Inc.",
   "last_sale": "12.41",
   "market_cap": "$324.34M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rfi",
   "FIELD9": ""
 },
 {
   "symbol": "CFX",
   "name": "Colfax Corporation",
   "last_sale": "36.47",
   "market_cap": "$4.34B",
   "IPOyear": "2008",
   "sector": "Capital Goods",
   "industry": "Fluid Controls",
   "summary_quote": "https://www.nasdaq.com/symbol/cfx",
   "FIELD9": ""
 },
 {
   "symbol": "CL",
   "name": "Colgate-Palmolive Company",
   "last_sale": "69.09",
   "market_cap": "$59.95B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/cl",
   "FIELD9": ""
 },
 {
   "symbol": "CXE",
   "name": "Colonial High Income Municipal Trust",
   "last_sale": "4.98",
   "market_cap": "$156.93M",
   "IPOyear": "1989",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cxe",
   "FIELD9": ""
 },
 {
   "symbol": "CIF",
   "name": "Colonial Intermediate High Income Fund",
   "last_sale": "2.625",
   "market_cap": "$51.72M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cif",
   "FIELD9": ""
 },
 {
   "symbol": "CXH",
   "name": "Colonial Investment Grade Municipal Trust",
   "last_sale": "9.01",
   "market_cap": "$82.08M",
   "IPOyear": "1989",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cxh",
   "FIELD9": ""
 },
 {
   "symbol": "CMU",
   "name": "Colonial Municipal Income Trust",
   "last_sale": "4.54",
   "market_cap": "$128.58M",
   "IPOyear": "1987",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cmu",
   "FIELD9": ""
 },
 {
   "symbol": "CLNY",
   "name": "Colony Capital, Inc.",
   "last_sale": "6.2",
   "market_cap": "$3.04B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/clny",
   "FIELD9": ""
 },
 {
   "symbol": "CLNY^B",
   "name": "Colony Capital, Inc.",
   "last_sale": "25.4",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/clny^b",
   "FIELD9": ""
 },
 {
   "symbol": "CLNY^E",
   "name": "Colony Capital, Inc.",
   "last_sale": "25.86",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/clny^e",
   "FIELD9": ""
 },
 {
   "symbol": "CLNY^G",
   "name": "Colony Capital, Inc.",
   "last_sale": "24.1598",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/clny^g",
   "FIELD9": ""
 },
 {
   "symbol": "CLNY^H",
   "name": "Colony Capital, Inc.",
   "last_sale": "23.05",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/clny^h",
   "FIELD9": ""
 },
 {
   "symbol": "CLNY^I",
   "name": "Colony Capital, Inc.",
   "last_sale": "23.08",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/clny^i",
   "FIELD9": ""
 },
 {
   "symbol": "CLNY^J",
   "name": "Colony Capital, Inc.",
   "last_sale": "23.06",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/clny^j",
   "FIELD9": ""
 },
 {
   "symbol": "CLNC",
   "name": "Colony Credit Real Estate, Inc.",
   "last_sale": "23",
   "market_cap": "$2.94B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/clnc",
   "FIELD9": ""
 },
 {
   "symbol": "CXP",
   "name": "Columbia Property Trust, Inc.",
   "last_sale": "23.62",
   "market_cap": "$2.79B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cxp",
   "FIELD9": ""
 },
 {
   "symbol": "STK",
   "name": "Columbia Seligman Premium Technology Growth Fund, Inc",
   "last_sale": "21.56",
   "market_cap": "$331.56M",
   "IPOyear": "2009",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/stk",
   "FIELD9": ""
 },
 {
   "symbol": "CCZ",
   "name": "Comcast Corporation",
   "last_sale": "52.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ccz",
   "FIELD9": ""
 },
 {
   "symbol": "CMA",
   "name": "Comerica Incorporated",
   "last_sale": "94.63",
   "market_cap": "$16.22B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cma",
   "FIELD9": ""
 },
 {
   "symbol": "CMA.WS",
   "name": "Comerica Incorporated",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cma.ws",
   "FIELD9": ""
 },
 {
   "symbol": "FIX",
   "name": "Comfort Systems USA, Inc.",
   "last_sale": "54.45",
   "market_cap": "$2.03B",
   "IPOyear": "1997",
   "sector": "Capital Goods",
   "industry": "Engineering & Construction",
   "summary_quote": "https://www.nasdaq.com/symbol/fix",
   "FIELD9": ""
 },
 {
   "symbol": "CMC",
   "name": "Commercial Metals Company",
   "last_sale": "20.46",
   "market_cap": "$2.39B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/cmc",
   "FIELD9": ""
 },
 {
   "symbol": "CBU",
   "name": "Community Bank System, Inc.",
   "last_sale": "63.21",
   "market_cap": "$3.23B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cbu",
   "FIELD9": ""
 },
 {
   "symbol": "CYH",
   "name": "Community Health Systems, Inc.",
   "last_sale": "3.41",
   "market_cap": "$396.43M",
   "IPOyear": "2000",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/cyh",
   "FIELD9": ""
 },
 {
   "symbol": "CHCT",
   "name": "Community Healthcare Trust Incorporated",
   "last_sale": "29.96",
   "market_cap": "$545.27M",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/chct",
   "FIELD9": ""
 },
 {
   "symbol": "CIG",
   "name": "Comp En De Mn Cemig ADS",
   "last_sale": "1.81",
   "market_cap": "$2.64B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/cig",
   "FIELD9": ""
 },
 {
   "symbol": "CIG.C",
   "name": "Comp En De Mn Cemig ADS",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cig.c",
   "FIELD9": ""
 },
 {
   "symbol": "CBD",
   "name": "Companhia Brasileira de Distribuicao",
   "last_sale": "21.18",
   "market_cap": "$5.65B",
   "IPOyear": "1997",
   "sector": "Consumer Services",
   "industry": "Food Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/cbd",
   "FIELD9": ""
 },
 {
   "symbol": "SBS",
   "name": "Companhia de saneamento Basico Do Estado De Sao Paulo - Sabesp",
   "last_sale": "6.11",
   "market_cap": "$4.18B",
   "IPOyear": "2002",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/sbs",
   "FIELD9": ""
 },
 {
   "symbol": "ELP",
   "name": "Companhia Paranaense de Energia (COPEL)",
   "last_sale": "5.46",
   "market_cap": "$1.49B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/elp",
   "FIELD9": ""
 },
 {
   "symbol": "CCU",
   "name": "Compania Cervecerias Unidas, S.A.",
   "last_sale": "28.23",
   "market_cap": "$5.22B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/ccu",
   "FIELD9": ""
 },
 {
   "symbol": "CODI",
   "name": "Compass Diversified Holdings",
   "last_sale": "18.15",
   "market_cap": "$1.09B",
   "IPOyear": "2006",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/codi",
   "FIELD9": ""
 },
 {
   "symbol": "CODI^A",
   "name": "Compass Diversified Holdings",
   "last_sale": "22.7478",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/codi^a",
   "FIELD9": ""
 },
 {
   "symbol": "CODI^B",
   "name": "Compass Diversified Holdings",
   "last_sale": "23.337",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/codi^b",
   "FIELD9": ""
 },
 {
   "symbol": "CMP",
   "name": "Compass Minerals International, Inc.",
   "last_sale": "69.9",
   "market_cap": "$2.37B",
   "IPOyear": "2003",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/cmp",
   "FIELD9": ""
 },
 {
   "symbol": "CRK",
   "name": "Comstock Resources, Inc.",
   "last_sale": "8.95",
   "market_cap": "$938.41M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/crk",
   "FIELD9": ""
 },
 {
   "symbol": "CAG",
   "name": "ConAgra Brands, Inc.",
   "last_sale": "37.45",
   "market_cap": "$14.67B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/cag",
   "FIELD9": ""
 },
 {
   "symbol": "CXO",
   "name": "Concho Resources Inc.",
   "last_sale": "142.88",
   "market_cap": "$28.61B",
   "IPOyear": "2007",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/cxo",
   "FIELD9": ""
 },
 {
   "symbol": "CCM",
   "name": "Concord Medical Services Holdings Limited",
   "last_sale": "3.06",
   "market_cap": "$132.69M",
   "IPOyear": "2009",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ccm",
   "FIELD9": ""
 },
 {
   "symbol": "CNDT",
   "name": "Conduent Incorporated",
   "last_sale": "22.34",
   "market_cap": "$4.72B",
   "IPOyear": "2016",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cndt",
   "FIELD9": ""
 },
 {
   "symbol": "COP",
   "name": "ConocoPhillips",
   "last_sale": "76.28",
   "market_cap": "$88.64B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/cop",
   "FIELD9": ""
 },
 {
   "symbol": "CCR",
   "name": "CONSOL Coal Resources LP",
   "last_sale": "17.95",
   "market_cap": "$493.99M",
   "IPOyear": "2015",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/ccr",
   "FIELD9": ""
 },
 {
   "symbol": "ED",
   "name": "Consolidated Edison Inc",
   "last_sale": "77.89",
   "market_cap": "$24.23B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/ed",
   "FIELD9": ""
 },
 {
   "symbol": "STZ",
   "name": "Constellation Brands Inc",
   "last_sale": "216.94",
   "market_cap": "$41.48B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/stz",
   "FIELD9": ""
 },
 {
   "symbol": "STZ.B",
   "name": "Constellation Brands Inc",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/stz.b",
   "FIELD9": ""
 },
 {
   "symbol": "CSTM",
   "name": "Constellium N.V.",
   "last_sale": "12.45",
   "market_cap": "$1.68B",
   "IPOyear": "2013",
   "sector": "Basic Industries",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/cstm",
   "FIELD9": ""
 },
 {
   "symbol": "TCS",
   "name": "Container Store (The)",
   "last_sale": "11.19",
   "market_cap": "$546.62M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/tcs",
   "FIELD9": ""
 },
 {
   "symbol": "CBPX",
   "name": "Continental Building Products, Inc.",
   "last_sale": "37.85",
   "market_cap": "$1.4B",
   "IPOyear": "2014",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/cbpx",
   "FIELD9": ""
 },
 {
   "symbol": "CLR",
   "name": "Continental Resources, Inc.",
   "last_sale": "62.23",
   "market_cap": "$23.4B",
   "IPOyear": "2007",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/clr",
   "FIELD9": ""
 },
 {
   "symbol": "VLRS",
   "name": "Controladora Vuela Compania de Aviacion, S.A.B. de C.V.",
   "last_sale": "7.98",
   "market_cap": "$796.9M",
   "IPOyear": "2013",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/vlrs",
   "FIELD9": ""
 },
 {
   "symbol": "CVG",
   "name": "Convergys Corporation",
   "last_sale": "24.72",
   "market_cap": "$2.25B",
   "IPOyear": "1998",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cvg",
   "FIELD9": ""
 },
 {
   "symbol": "CTB",
   "name": "Cooper Tire & Rubber Company",
   "last_sale": "30.05",
   "market_cap": "$1.5B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/ctb",
   "FIELD9": ""
 },
 {
   "symbol": "CPS",
   "name": "Cooper-Standard Holdings Inc.",
   "last_sale": "122.56",
   "market_cap": "$2.18B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/cps",
   "FIELD9": ""
 },
 {
   "symbol": "CPA",
   "name": "Copa Holdings, S.A.",
   "last_sale": "78.86",
   "market_cap": "$3.33B",
   "IPOyear": "2005",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cpa",
   "FIELD9": ""
 },
 {
   "symbol": "CLB",
   "name": "Core Laboratories N.V.",
   "last_sale": "111.03",
   "market_cap": "$4.91B",
   "IPOyear": "1995",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/clb",
   "FIELD9": ""
 },
 {
   "symbol": "CXW",
   "name": "CoreCivic, Inc.",
   "last_sale": "25.09",
   "market_cap": "$2.97B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cxw",
   "FIELD9": ""
 },
 {
   "symbol": "CLGX",
   "name": "CoreLogic, Inc.",
   "last_sale": "50.41",
   "market_cap": "$4.08B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/clgx",
   "FIELD9": ""
 },
 {
   "symbol": "CORR",
   "name": "CorEnergy Infrastructure Trust, Inc.",
   "last_sale": "38.05",
   "market_cap": "$454.11M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/corr",
   "FIELD9": ""
 },
 {
   "symbol": "CORR^A",
   "name": "CorEnergy Infrastructure Trust, Inc.",
   "last_sale": "25.15",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/corr^a",
   "FIELD9": ""
 },
 {
   "symbol": "CPLG",
   "name": "CorePoint Lodging Inc.",
   "last_sale": "20.22",
   "market_cap": "$1.21B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cplg",
   "FIELD9": ""
 },
 {
   "symbol": "COR",
   "name": "CoreSite Realty Corporation",
   "last_sale": "115.87",
   "market_cap": "$3.99B",
   "IPOyear": "2010",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cor",
   "FIELD9": ""
 },
 {
   "symbol": "GLW",
   "name": "Corning Incorporated",
   "last_sale": "35.92",
   "market_cap": "$29.1B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/glw",
   "FIELD9": ""
 },
 {
   "symbol": "CAAP",
   "name": "Corporacion America Airports SA",
   "last_sale": "9.6",
   "market_cap": "$1.54B",
   "IPOyear": "2018",
   "sector": "Transportation",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/caap",
   "FIELD9": ""
 },
 {
   "symbol": "GYC",
   "name": "Corporate Asset Backed Corp CABCO",
   "last_sale": "23.6933",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gyc",
   "FIELD9": ""
 },
 {
   "symbol": "CCT",
   "name": "Corporate Capital Trust, Inc.",
   "last_sale": "15.9",
   "market_cap": "$1.97B",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cct",
   "FIELD9": ""
 },
 {
   "symbol": "OFC",
   "name": "Corporate Office Properties Trust",
   "last_sale": "30.17",
   "market_cap": "$3.12B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ofc",
   "FIELD9": ""
 },
 {
   "symbol": "CZZ",
   "name": "Cosan Limited",
   "last_sale": "7.13",
   "market_cap": "$1.74B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Specialty Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/czz",
   "FIELD9": ""
 },
 {
   "symbol": "CMRE",
   "name": "Costamare Inc.",
   "last_sale": "6.8",
   "market_cap": "$756.71M",
   "IPOyear": "2010",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/cmre",
   "FIELD9": ""
 },
 {
   "symbol": "CMRE^B",
   "name": "Costamare Inc.",
   "last_sale": "24.59",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cmre^b",
   "FIELD9": ""
 },
 {
   "symbol": "CMRE^C",
   "name": "Costamare Inc.",
   "last_sale": "25.42",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cmre^c",
   "FIELD9": ""
 },
 {
   "symbol": "CMRE^D",
   "name": "Costamare Inc.",
   "last_sale": "25.89",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cmre^d",
   "FIELD9": ""
 },
 {
   "symbol": "CMRE^E",
   "name": "Costamare Inc.",
   "last_sale": "25.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cmre^e",
   "FIELD9": ""
 },
 {
   "symbol": "COT",
   "name": "Cott Corporation",
   "last_sale": "15.18",
   "market_cap": "$2.1B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/cot",
   "FIELD9": ""
 },
 {
   "symbol": "COTY",
   "name": "Coty Inc.",
   "last_sale": "13.07",
   "market_cap": "$9.81B",
   "IPOyear": "2013",
   "sector": "Consumer Non-Durables",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/coty",
   "FIELD9": ""
 },
 {
   "symbol": "CUZ",
   "name": "Cousins Properties Incorporated",
   "last_sale": "9.12",
   "market_cap": "$3.83B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cuz",
   "FIELD9": ""
 },
 {
   "symbol": "CVA",
   "name": "Covanta Holding Corporation",
   "last_sale": "17",
   "market_cap": "$2.22B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/cva",
   "FIELD9": ""
 },
 {
   "symbol": "CVIA",
   "name": "Covia Holdings Corporation",
   "last_sale": "9.71",
   "market_cap": "$1.27B",
   "IPOyear": "2018",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/cvia",
   "FIELD9": ""
 },
 {
   "symbol": "CPF",
   "name": "CPB Inc.",
   "last_sale": "27.67",
   "market_cap": "$814.15M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cpf",
   "FIELD9": ""
 },
 {
   "symbol": "CPL",
   "name": "CPFL Energia S.A.",
   "last_sale": "11.69",
   "market_cap": "$5.95B",
   "IPOyear": "2004",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/cpl",
   "FIELD9": ""
 },
 {
   "symbol": "CR",
   "name": "Crane Co.",
   "last_sale": "98.71",
   "market_cap": "$5.88B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/cr",
   "FIELD9": ""
 },
 {
   "symbol": "CRD.A",
   "name": "Crawford & Company",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/crd.a",
   "FIELD9": ""
 },
 {
   "symbol": "CRD.B",
   "name": "Crawford & Company",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/crd.b",
   "FIELD9": ""
 },
 {
   "symbol": "BAP",
   "name": "Credicorp Ltd.",
   "last_sale": "227",
   "market_cap": "$18.11B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bap",
   "FIELD9": ""
 },
 {
   "symbol": "CS",
   "name": "Credit Suisse Group",
   "last_sale": "15.94",
   "market_cap": "$40.65B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/cs",
   "FIELD9": ""
 },
 {
   "symbol": "CPG",
   "name": "Crescent Point Energy Corporation",
   "last_sale": "6.24",
   "market_cap": "$3.43B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/cpg",
   "FIELD9": ""
 },
 {
   "symbol": "CEQP",
   "name": "Crestwood Equity Partners LP",
   "last_sale": "37.5",
   "market_cap": "$2.67B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ceqp",
   "FIELD9": ""
 },
 {
   "symbol": "CRH",
   "name": "CRH PLC",
   "last_sale": "33.02",
   "market_cap": "$27.35B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/crh",
   "FIELD9": ""
 },
 {
   "symbol": "CRT",
   "name": "Cross Timbers Royalty Trust",
   "last_sale": "14.1",
   "market_cap": "$84.6M",
   "IPOyear": "1992",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/crt",
   "FIELD9": ""
 },
 {
   "symbol": "CAPL",
   "name": "CrossAmerica Partners LP",
   "last_sale": "18.11",
   "market_cap": "$623.59M",
   "IPOyear": "2012",
   "sector": "Energy",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/capl",
   "FIELD9": ""
 },
 {
   "symbol": "CCI",
   "name": "Crown Castle International Corporation",
   "last_sale": "111.71",
   "market_cap": "$46.34B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cci",
   "FIELD9": ""
 },
 {
   "symbol": "CCI^A",
   "name": "Crown Castle International Corporation",
   "last_sale": "1091.4871",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cci^a",
   "FIELD9": ""
 },
 {
   "symbol": "CCK",
   "name": "Crown Holdings, Inc.",
   "last_sale": "48.71",
   "market_cap": "$6.58B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/cck",
   "FIELD9": ""
 },
 {
   "symbol": "CRY",
   "name": "CryoLife, Inc.",
   "last_sale": "34.6",
   "market_cap": "$1.27B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/cry",
   "FIELD9": ""
 },
 {
   "symbol": "CSS",
   "name": "CSS Industries, Inc.",
   "last_sale": "14.94",
   "market_cap": "$136.25M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Consumer: Greeting Cards",
   "summary_quote": "https://www.nasdaq.com/symbol/css",
   "FIELD9": ""
 },
 {
   "symbol": "CTS",
   "name": "CTS Corporation",
   "last_sale": "36.45",
   "market_cap": "$1.21B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/cts",
   "FIELD9": ""
 },
 {
   "symbol": "CUBE",
   "name": "CubeSmart",
   "last_sale": "29.32",
   "market_cap": "$5.45B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cube",
   "FIELD9": ""
 },
 {
   "symbol": "CUB",
   "name": "Cubic Corporation",
   "last_sale": "72.05",
   "market_cap": "$1.96B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cub",
   "FIELD9": ""
 },
 {
   "symbol": "CFR",
   "name": "Cullen/Frost Bankers, Inc.",
   "last_sale": "109.43",
   "market_cap": "$6.99B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cfr",
   "FIELD9": ""
 },
 {
   "symbol": "CFR^A",
   "name": "Cullen/Frost Bankers, Inc.",
   "last_sale": "24.8799",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cfr^a",
   "FIELD9": ""
 },
 {
   "symbol": "CULP",
   "name": "Culp, Inc.",
   "last_sale": "24.8",
   "market_cap": "$310.63M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Textiles",
   "summary_quote": "https://www.nasdaq.com/symbol/culp",
   "FIELD9": ""
 },
 {
   "symbol": "CMI",
   "name": "Cummins Inc.",
   "last_sale": "151.02",
   "market_cap": "$24.66B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cmi",
   "FIELD9": ""
 },
 {
   "symbol": "CURO",
   "name": "CURO Group Holdings Corp.",
   "last_sale": "30.99",
   "market_cap": "$1.42B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/curo",
   "FIELD9": ""
 },
 {
   "symbol": "CW",
   "name": "Curtiss-Wright Corporation",
   "last_sale": "137.33",
   "market_cap": "$6.04B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/cw",
   "FIELD9": ""
 },
 {
   "symbol": "SRF",
   "name": "Cushing Energy Income Fund (The)",
   "last_sale": "9.29",
   "market_cap": "$22.99M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/srf",
   "FIELD9": ""
 },
 {
   "symbol": "SRV",
   "name": "Cushing MLP & Infrastructure Total Return Fund",
   "last_sale": "11.935",
   "market_cap": "$80.37M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/srv",
   "FIELD9": ""
 },
 {
   "symbol": "SZC",
   "name": "Cushing Renaissance Fund (The)",
   "last_sale": "19.09",
   "market_cap": "$149M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/szc",
   "FIELD9": ""
 },
 {
   "symbol": "CWK",
   "name": "Cushman & Wakefield plc",
   "last_sale": "18",
   "market_cap": "$3.88B",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/cwk",
   "FIELD9": ""
 },
 {
   "symbol": "CUBI",
   "name": "Customers Bancorp, Inc",
   "last_sale": "24.42",
   "market_cap": "$773.38M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/cubi",
   "FIELD9": ""
 },
 {
   "symbol": "CUBI^C",
   "name": "Customers Bancorp, Inc",
   "last_sale": "25.91",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cubi^c",
   "FIELD9": ""
 },
 {
   "symbol": "CUBI^D",
   "name": "Customers Bancorp, Inc",
   "last_sale": "26.1288",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cubi^d",
   "FIELD9": ""
 },
 {
   "symbol": "CUBI^E",
   "name": "Customers Bancorp, Inc",
   "last_sale": "26.1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cubi^e",
   "FIELD9": ""
 },
 {
   "symbol": "CUBI^F",
   "name": "Customers Bancorp, Inc",
   "last_sale": "25.71",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cubi^f",
   "FIELD9": ""
 },
 {
   "symbol": "CVI",
   "name": "CVR Energy Inc.",
   "last_sale": "39.21",
   "market_cap": "$3.4B",
   "IPOyear": "2007",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/cvi",
   "FIELD9": ""
 },
 {
   "symbol": "UAN",
   "name": "CVR Partners, LP",
   "last_sale": "3.79",
   "market_cap": "$429.34M",
   "IPOyear": "2011",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/uan",
   "FIELD9": ""
 },
 {
   "symbol": "CVRR",
   "name": "CVR Refining, LP",
   "last_sale": "18.55",
   "market_cap": "$2.74B",
   "IPOyear": "2013",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/cvrr",
   "FIELD9": ""
 },
 {
   "symbol": "CVS",
   "name": "CVS Health Corporation",
   "last_sale": "79.59",
   "market_cap": "$81.03B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/cvs",
   "FIELD9": ""
 },
 {
   "symbol": "CELP",
   "name": "Cypress Energy Partners, L.P.",
   "last_sale": "7.4652",
   "market_cap": "$89.09M",
   "IPOyear": "2014",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/celp",
   "FIELD9": ""
 },
 {
   "symbol": "DHI",
   "name": "D.R. Horton, Inc.",
   "last_sale": "42.41",
   "market_cap": "$15.99B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/dhi",
   "FIELD9": ""
 },
 {
   "symbol": "DAN",
   "name": "Dana Incorporated",
   "last_sale": "20.42",
   "market_cap": "$2.95B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/dan",
   "FIELD9": ""
 },
 {
   "symbol": "DHR",
   "name": "Danaher Corporation",
   "last_sale": "108.08",
   "market_cap": "$75.63B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/dhr",
   "FIELD9": ""
 },
 {
   "symbol": "DAC",
   "name": "Danaos Corporation",
   "last_sale": "1.55",
   "market_cap": "$324.17M",
   "IPOyear": "2006",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/dac",
   "FIELD9": ""
 },
 {
   "symbol": "DQ",
   "name": "DAQO New Energy Corp.",
   "last_sale": "30.21",
   "market_cap": "$388.62M",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/dq",
   "FIELD9": ""
 },
 {
   "symbol": "DRI",
   "name": "Darden Restaurants, Inc.",
   "last_sale": "112.89",
   "market_cap": "$14.01B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/dri",
   "FIELD9": ""
 },
 {
   "symbol": "DAR",
   "name": "Darling Ingredients Inc.",
   "last_sale": "19.01",
   "market_cap": "$3.13B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/dar",
   "FIELD9": ""
 },
 {
   "symbol": "DVA",
   "name": "DaVita Inc.",
   "last_sale": "69.92",
   "market_cap": "$11.67B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/dva",
   "FIELD9": ""
 },
 {
   "symbol": "DCP",
   "name": "DCP Midstream LP",
   "last_sale": "40.35",
   "market_cap": "$5.78B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/dcp",
   "FIELD9": ""
 },
 {
   "symbol": "DCP^B",
   "name": "DCP Midstream LP",
   "last_sale": "25.17",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dcp^b",
   "FIELD9": ""
 },
 {
   "symbol": "DDR",
   "name": "DDR Corp.",
   "last_sale": "13.94",
   "market_cap": "$2.57B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ddr",
   "FIELD9": ""
 },
 {
   "symbol": "DDR^A",
   "name": "DDR Corp.",
   "last_sale": "25.38",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ddr^a",
   "FIELD9": ""
 },
 {
   "symbol": "DDR^J",
   "name": "DDR Corp.",
   "last_sale": "24.6474",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ddr^j",
   "FIELD9": ""
 },
 {
   "symbol": "DDR^K",
   "name": "DDR Corp.",
   "last_sale": "24.04",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ddr^k",
   "FIELD9": ""
 },
 {
   "symbol": "DF",
   "name": "Dean Foods Company",
   "last_sale": "7.6",
   "market_cap": "$694.45M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/df",
   "FIELD9": ""
 },
 {
   "symbol": "DECK",
   "name": "Deckers Outdoor Corporation",
   "last_sale": "111.13",
   "market_cap": "$3.34B",
   "IPOyear": "1993",
   "sector": "Consumer Non-Durables",
   "industry": "Shoe Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/deck",
   "FIELD9": ""
 },
 {
   "symbol": "DE",
   "name": "Deere & Company",
   "last_sale": "152.81",
   "market_cap": "$49.15B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/de",
   "FIELD9": ""
 },
 {
   "symbol": "DEX",
   "name": "Delaware Enhanced Global Dividend",
   "last_sale": "11.32",
   "market_cap": "$179.18M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dex",
   "FIELD9": ""
 },
 {
   "symbol": "DDF",
   "name": "Delaware Investments Dividend & Income Fund, Inc.",
   "last_sale": "12.74",
   "market_cap": "$97.95M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ddf",
   "FIELD9": ""
 },
 {
   "symbol": "DKL",
   "name": "Delek Logistics Partners, L.P.",
   "last_sale": "34.55",
   "market_cap": "$842.85M",
   "IPOyear": "2012",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/dkl",
   "FIELD9": ""
 },
 {
   "symbol": "DK",
   "name": "Delek US Holdings, Inc.",
   "last_sale": "43.94",
   "market_cap": "$3.69B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/dk",
   "FIELD9": ""
 },
 {
   "symbol": "DELL",
   "name": "Dell Technologies Inc.",
   "last_sale": "96.2",
   "market_cap": "$19.18B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/dvmt",
   "FIELD9": ""
 },
 {
   "symbol": "DLPH",
   "name": "Delphi Technologies PLC",
   "last_sale": "35.43",
   "market_cap": "$3.15B",
   "IPOyear": "2017",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/dlph",
   "FIELD9": ""
 },
 {
   "symbol": "DAL",
   "name": "Delta Air Lines, Inc.",
   "last_sale": "59.61",
   "market_cap": "$41.21B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dal",
   "FIELD9": ""
 },
 {
   "symbol": "DLX",
   "name": "Deluxe Corporation",
   "last_sale": "56.61",
   "market_cap": "$2.7B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Publishing",
   "summary_quote": "https://www.nasdaq.com/symbol/dlx",
   "FIELD9": ""
 },
 {
   "symbol": "DNR",
   "name": "Denbury Resources Inc.",
   "last_sale": "5.59",
   "market_cap": "$2.57B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/dnr",
   "FIELD9": ""
 },
 {
   "symbol": "DESP",
   "name": "Despegar.com, Corp.",
   "last_sale": "17.24",
   "market_cap": "$1.19B",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/desp",
   "FIELD9": ""
 },
 {
   "symbol": "DKT",
   "name": "Deutsch Bk Contingent Cap Tr V",
   "last_sale": "25.96",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/dkt",
   "FIELD9": ""
 },
 {
   "symbol": "DB",
   "name": "Deutsche Bank AG",
   "last_sale": "12.34",
   "market_cap": "$25.42B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/db",
   "FIELD9": ""
 },
 {
   "symbol": "DXB",
   "name": "Deutsche Bank AG",
   "last_sale": "25.42",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/dxb",
   "FIELD9": ""
 },
 {
   "symbol": "DVN",
   "name": "Devon Energy Corporation",
   "last_sale": "40.55",
   "market_cap": "$20.63B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/dvn",
   "FIELD9": ""
 },
 {
   "symbol": "DHX",
   "name": "DHI Group, Inc.",
   "last_sale": "2",
   "market_cap": "$107.45M",
   "IPOyear": "2007",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dhx",
   "FIELD9": ""
 },
 {
   "symbol": "DHT",
   "name": "DHT Holdings, Inc.",
   "last_sale": "4.6",
   "market_cap": "$660.53M",
   "IPOyear": "2005",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/dht",
   "FIELD9": ""
 },
 {
   "symbol": "DEO",
   "name": "Diageo plc",
   "last_sale": "141.25",
   "market_cap": "$86.68B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/deo",
   "FIELD9": ""
 },
 {
   "symbol": "DO",
   "name": "Diamond Offshore Drilling, Inc.",
   "last_sale": "19.34",
   "market_cap": "$2.66B",
   "IPOyear": "1995",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/do",
   "FIELD9": ""
 },
 {
   "symbol": "DRH",
   "name": "Diamondrock Hospitality Company",
   "last_sale": "11.83",
   "market_cap": "$2.46B",
   "IPOyear": "2005",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/drh",
   "FIELD9": ""
 },
 {
   "symbol": "DSX",
   "name": "Diana Shipping inc.",
   "last_sale": "3.94",
   "market_cap": "$425.25M",
   "IPOyear": "2005",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/dsx",
   "FIELD9": ""
 },
 {
   "symbol": "DSX^B",
   "name": "Diana Shipping inc.",
   "last_sale": "24.7",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dsx^b",
   "FIELD9": ""
 },
 {
   "symbol": "DSXN",
   "name": "Diana Shipping inc.",
   "last_sale": "25.28",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/dsxn",
   "FIELD9": ""
 },
 {
   "symbol": "DKS",
   "name": "Dick&#39;s Sporting Goods Inc",
   "last_sale": "37.89",
   "market_cap": "$3.83B",
   "IPOyear": "2002",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/dks",
   "FIELD9": ""
 },
 {
   "symbol": "DBD",
   "name": "Diebold Nixdorf Incorporated",
   "last_sale": "5",
   "market_cap": "$380.47M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dbd",
   "FIELD9": ""
 },
 {
   "symbol": "DLR",
   "name": "Digital Realty Trust, Inc.",
   "last_sale": "120.92",
   "market_cap": "$24.92B",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/dlr",
   "FIELD9": ""
 },
 {
   "symbol": "DLR^C",
   "name": "Digital Realty Trust, Inc.",
   "last_sale": "26.2988",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dlr^c",
   "FIELD9": ""
 },
 {
   "symbol": "DLR^G",
   "name": "Digital Realty Trust, Inc.",
   "last_sale": "24.82",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dlr^g",
   "FIELD9": ""
 },
 {
   "symbol": "DLR^H",
   "name": "Digital Realty Trust, Inc.",
   "last_sale": "25.55",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dlr^h",
   "FIELD9": ""
 },
 {
   "symbol": "DLR^I",
   "name": "Digital Realty Trust, Inc.",
   "last_sale": "25.5605",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dlr^i",
   "FIELD9": ""
 },
 {
   "symbol": "DLR^J",
   "name": "Digital Realty Trust, Inc.",
   "last_sale": "24.12",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dlr^j",
   "FIELD9": ""
 },
 {
   "symbol": "DDS",
   "name": "Dillard&#39;s, Inc.",
   "last_sale": "78.01",
   "market_cap": "$2.14B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/dds",
   "FIELD9": ""
 },
 {
   "symbol": "DDT",
   "name": "Dillard&#39;s, Inc.",
   "last_sale": "26.34",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/ddt",
   "FIELD9": ""
 },
 {
   "symbol": "DIN",
   "name": "Dine Brands Global, Inc.",
   "last_sale": "81.1",
   "market_cap": "$1.44B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/din",
   "FIELD9": ""
 },
 {
   "symbol": "DPLO",
   "name": "Diplomat Pharmacy, Inc.",
   "last_sale": "20.44",
   "market_cap": "$1.52B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dplo",
   "FIELD9": ""
 },
 {
   "symbol": "DFS",
   "name": "Discover Financial Services",
   "last_sale": "79.99",
   "market_cap": "$27.41B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dfs",
   "FIELD9": ""
 },
 {
   "symbol": "DHCP",
   "name": "Ditech Holding Corporation",
   "last_sale": "4.33",
   "market_cap": "$21.46M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dhcp",
   "FIELD9": ""
 },
 {
   "symbol": "DHCP.WS.A",
   "name": "Ditech Holding Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dhcp.ws.a",
   "FIELD9": ""
 },
 {
   "symbol": "DHCP.WS.B",
   "name": "Ditech Holding Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dhcp.ws.b",
   "FIELD9": ""
 },
 {
   "symbol": "DNI",
   "name": "Dividend and Income Fund",
   "last_sale": "12.1045",
   "market_cap": "$149.31M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dni",
   "FIELD9": ""
 },
 {
   "symbol": "DLB",
   "name": "Dolby Laboratories",
   "last_sale": "69.53",
   "market_cap": "$7.21B",
   "IPOyear": "2005",
   "sector": "Miscellaneous",
   "industry": "Multi-Sector Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/dlb",
   "FIELD9": ""
 },
 {
   "symbol": "DG",
   "name": "Dollar General Corporation",
   "last_sale": "108.26",
   "market_cap": "$28.75B",
   "IPOyear": "2009",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/dg",
   "FIELD9": ""
 },
 {
   "symbol": "DM",
   "name": "Dominion Energy Midstream Partners, LP",
   "last_sale": "17.95",
   "market_cap": "$2.27B",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/dm",
   "FIELD9": ""
 },
 {
   "symbol": "D",
   "name": "Dominion Energy, Inc.",
   "last_sale": "70.85",
   "market_cap": "$46.32B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/d",
   "FIELD9": ""
 },
 {
   "symbol": "DCUD",
   "name": "Dominion Energy, Inc.",
   "last_sale": "47.66",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/dcud",
   "FIELD9": ""
 },
 {
   "symbol": "DRUA",
   "name": "Dominion Energy, Inc.",
   "last_sale": "23.9595",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/drua",
   "FIELD9": ""
 },
 {
   "symbol": "DPZ",
   "name": "Domino&#39;s Pizza Inc",
   "last_sale": "286.22",
   "market_cap": "$11.98B",
   "IPOyear": "2004",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/dpz",
   "FIELD9": ""
 },
 {
   "symbol": "UFS",
   "name": "Domtar Corporation",
   "last_sale": "53.75",
   "market_cap": "$3.49B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/ufs",
   "FIELD9": ""
 },
 {
   "symbol": "DCI",
   "name": "Donaldson Company, Inc.",
   "last_sale": "59.18",
   "market_cap": "$7.63B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Pollution Control Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/dci",
   "FIELD9": ""
 },
 {
   "symbol": "DFIN",
   "name": "Donnelley Financial Solutions, Inc.",
   "last_sale": "20.6",
   "market_cap": "$700.4M",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dfin",
   "FIELD9": ""
 },
 {
   "symbol": "LPG",
   "name": "Dorian LPG Ltd.",
   "last_sale": "7.67",
   "market_cap": "$423.06M",
   "IPOyear": "2014",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/lpg",
   "FIELD9": ""
 },
 {
   "symbol": "DSL",
   "name": "DoubleLine Income Solutions Fund",
   "last_sale": "20.16",
   "market_cap": "$2.04B",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dsl",
   "FIELD9": ""
 },
 {
   "symbol": "DBL",
   "name": "DoubleLine Opportunistic Credit Fund",
   "last_sale": "20.72",
   "market_cap": "$308.73M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dbl",
   "FIELD9": ""
 },
 {
   "symbol": "PLOW",
   "name": "Douglas Dynamics, Inc.",
   "last_sale": "46.55",
   "market_cap": "$1.06B",
   "IPOyear": "2010",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/plow",
   "FIELD9": ""
 },
 {
   "symbol": "DEI",
   "name": "Douglas Emmett, Inc.",
   "last_sale": "38.66",
   "market_cap": "$6.57B",
   "IPOyear": "2006",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/dei",
   "FIELD9": ""
 },
 {
   "symbol": "DOV",
   "name": "Dover Corporation",
   "last_sale": "89.3",
   "market_cap": "$13.19B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/dov",
   "FIELD9": ""
 },
 {
   "symbol": "DDE",
   "name": "Dover Downs Gaming & Entertainment Inc",
   "last_sale": "2.72",
   "market_cap": "$90.53M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/dde",
   "FIELD9": ""
 },
 {
   "symbol": "DVD",
   "name": "Dover Motorsports, Inc.",
   "last_sale": "2.25",
   "market_cap": "$82.61M",
   "IPOyear": "1996",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/dvd",
   "FIELD9": ""
 },
 {
   "symbol": "DWDP",
   "name": "DowDuPont Inc.",
   "last_sale": "69.69",
   "market_cap": "$160.8B",
   "IPOyear": "2017",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/dwdp",
   "FIELD9": ""
 },
 {
   "symbol": "RDY",
   "name": "Dr. Reddy&#39;s Laboratories Ltd",
   "last_sale": "35.29",
   "market_cap": "$5.86B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/rdy",
   "FIELD9": ""
 },
 {
   "symbol": "DRD",
   "name": "DRDGOLD Limited",
   "last_sale": "2.25",
   "market_cap": "$97.07M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/drd",
   "FIELD9": ""
 },
 {
   "symbol": "DCF",
   "name": "Dreyfus Alcentra",
   "last_sale": "9.03",
   "market_cap": "$135.01M",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dcf",
   "FIELD9": ""
 },
 {
   "symbol": "DHF",
   "name": "Dreyfus High Yield Strategies Fund",
   "last_sale": "3.2",
   "market_cap": "$232.66M",
   "IPOyear": "1998",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dhf",
   "FIELD9": ""
 },
 {
   "symbol": "DMB",
   "name": "Dreyfus Municipal Bond Infrastructure Fund, Inc.",
   "last_sale": "12.204",
   "market_cap": "$224.33M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dmb",
   "FIELD9": ""
 },
 {
   "symbol": "DSM",
   "name": "Dreyfus Strategic Municipal Bond Fund, Inc.",
   "last_sale": "7.35",
   "market_cap": "$362.87M",
   "IPOyear": "1989",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dsm",
   "FIELD9": ""
 },
 {
   "symbol": "LEO",
   "name": "Dreyfus Strategic Municipals, Inc.",
   "last_sale": "7.42",
   "market_cap": "$461.49M",
   "IPOyear": "1987",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/leo",
   "FIELD9": ""
 },
 {
   "symbol": "DRQ",
   "name": "Dril-Quip, Inc.",
   "last_sale": "50.4",
   "market_cap": "$1.89B",
   "IPOyear": "1997",
   "sector": "Energy",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/drq",
   "FIELD9": ""
 },
 {
   "symbol": "DS",
   "name": "Drive Shack Inc.",
   "last_sale": "5.86",
   "market_cap": "$392.49M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ds",
   "FIELD9": ""
 },
 {
   "symbol": "DS^B",
   "name": "Drive Shack Inc.",
   "last_sale": "25.908",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ds^b",
   "FIELD9": ""
 },
 {
   "symbol": "DS^C",
   "name": "Drive Shack Inc.",
   "last_sale": "25.4",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ds^c",
   "FIELD9": ""
 },
 {
   "symbol": "DS^D",
   "name": "Drive Shack Inc.",
   "last_sale": "25.42",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ds^d",
   "FIELD9": ""
 },
 {
   "symbol": "DSW",
   "name": "DSW Inc.",
   "last_sale": "32",
   "market_cap": "$2.57B",
   "IPOyear": "2005",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/dsw",
   "FIELD9": ""
 },
 {
   "symbol": "DTE",
   "name": "DTE Energy Company",
   "last_sale": "109.07",
   "market_cap": "$19.83B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/dte",
   "FIELD9": ""
 },
 {
   "symbol": "DTJ",
   "name": "DTE Energy Company",
   "last_sale": "24.105",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/dtj",
   "FIELD9": ""
 },
 {
   "symbol": "DTQ",
   "name": "DTE Energy Company",
   "last_sale": "24.6024",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/dtq",
   "FIELD9": ""
 },
 {
   "symbol": "DTV",
   "name": "DTE Energy Company",
   "last_sale": "52.2182",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/dtv",
   "FIELD9": ""
 },
 {
   "symbol": "DTW",
   "name": "DTE Energy Company",
   "last_sale": "24",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/dtw",
   "FIELD9": ""
 },
 {
   "symbol": "DTY",
   "name": "DTE Energy Company",
   "last_sale": "25.72",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/dty",
   "FIELD9": ""
 },
 {
   "symbol": "DCO",
   "name": "Ducommun Incorporated",
   "last_sale": "39.35",
   "market_cap": "$448.65M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/dco",
   "FIELD9": ""
 },
 {
   "symbol": "DPG",
   "name": "Duff & Phelps Global Utility Income Fund Inc.",
   "last_sale": "14.42",
   "market_cap": "$546.95M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dpg",
   "FIELD9": ""
 },
 {
   "symbol": "DSE",
   "name": "Duff & Phelps Select Energy MLP Fund Inc.",
   "last_sale": "6",
   "market_cap": "$157.25M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dse",
   "FIELD9": ""
 },
 {
   "symbol": "DNP",
   "name": "Duff & Phelps Utilities Income, Inc.",
   "last_sale": "11.03",
   "market_cap": "$3.2B",
   "IPOyear": "1987",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dnp",
   "FIELD9": ""
 },
 {
   "symbol": "DTF",
   "name": "Duff & Phelps Utilities Tax-Free Income, Inc.",
   "last_sale": "12.71",
   "market_cap": "$108.3M",
   "IPOyear": "1991",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dtf",
   "FIELD9": ""
 },
 {
   "symbol": "DUC",
   "name": "Duff & Phelps Utility & Corporate Bond Trust, Inc.",
   "last_sale": "8.45",
   "market_cap": "$232.33M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/duc",
   "FIELD9": ""
 },
 {
   "symbol": "DUK",
   "name": "Duke Energy Corporation",
   "last_sale": "79.82",
   "market_cap": "$56.86B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/duk",
   "FIELD9": ""
 },
 {
   "symbol": "DUKB",
   "name": "Duke Energy Corporation",
   "last_sale": "24.75",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dukb",
   "FIELD9": ""
 },
 {
   "symbol": "DUKH",
   "name": "Duke Energy Corporation",
   "last_sale": "24.2",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/dukh",
   "FIELD9": ""
 },
 {
   "symbol": "DRE",
   "name": "Duke Realty Corporation",
   "last_sale": "28.73",
   "market_cap": "$10.26B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/dre",
   "FIELD9": ""
 },
 {
   "symbol": "DNB",
   "name": "Dun & Bradstreet Corporation (The)",
   "last_sale": "143.1",
   "market_cap": "$5.31B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dnb",
   "FIELD9": ""
 },
 {
   "symbol": "DXC",
   "name": "DXC Technology Company",
   "last_sale": "96.38",
   "market_cap": "$27.1B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dxc",
   "FIELD9": ""
 },
 {
   "symbol": "DY",
   "name": "Dycom Industries, Inc.",
   "last_sale": "83.43",
   "market_cap": "$2.61B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/dy",
   "FIELD9": ""
 },
 {
   "symbol": "DLNG",
   "name": "Dynagas LNG Partners LP",
   "last_sale": "8.64",
   "market_cap": "$306.63M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/dlng",
   "FIELD9": ""
 },
 {
   "symbol": "DLNG^A",
   "name": "Dynagas LNG Partners LP",
   "last_sale": "26.1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dlng^a",
   "FIELD9": ""
 },
 {
   "symbol": "DX",
   "name": "Dynex Capital, Inc.",
   "last_sale": "6.39",
   "market_cap": "$367.5M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/dx",
   "FIELD9": ""
 },
 {
   "symbol": "DX^A",
   "name": "Dynex Capital, Inc.",
   "last_sale": "25.87",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dx^a",
   "FIELD9": ""
 },
 {
   "symbol": "DX^B",
   "name": "Dynex Capital, Inc.",
   "last_sale": "24.7",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dx^b",
   "FIELD9": ""
 },
 {
   "symbol": "DD^A",
   "name": "E.I. du Pont de Nemours and Company",
   "last_sale": "84.11",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/dd^a",
   "FIELD9": ""
 },
 {
   "symbol": "DD^B",
   "name": "E.I. du Pont de Nemours and Company",
   "last_sale": "101",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/dd^b",
   "FIELD9": ""
 },
 {
   "symbol": "ELF",
   "name": "e.l.f. Beauty, Inc.",
   "last_sale": "13.46",
   "market_cap": "$640.45M",
   "IPOyear": "2016",
   "sector": "Consumer Non-Durables",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/elf",
   "FIELD9": ""
 },
 {
   "symbol": "EGIF",
   "name": "Eagle Growth and Income Opportunities Fund",
   "last_sale": "15.43",
   "market_cap": "$110.8M",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/egif",
   "FIELD9": ""
 },
 {
   "symbol": "EXP",
   "name": "Eagle Materials Inc",
   "last_sale": "87.25",
   "market_cap": "$4.17B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/exp",
   "FIELD9": ""
 },
 {
   "symbol": "ECC           ",
   "name": "Eagle Point Credit Company Inc.",
   "last_sale": "18",
   "market_cap": "$406.69M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ecc",
   "FIELD9": ""
 },
 {
   "symbol": "ECCA",
   "name": "Eagle Point Credit Company Inc.",
   "last_sale": "25.47",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ecca",
   "FIELD9": ""
 },
 {
   "symbol": "ECCB",
   "name": "Eagle Point Credit Company Inc.",
   "last_sale": "26.6",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eccb",
   "FIELD9": ""
 },
 {
   "symbol": "ECCX",
   "name": "Eagle Point Credit Company Inc.",
   "last_sale": "25.054",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eccx",
   "FIELD9": ""
 },
 {
   "symbol": "ECCY",
   "name": "Eagle Point Credit Company Inc.",
   "last_sale": "25.5",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eccy",
   "FIELD9": ""
 },
 {
   "symbol": "ESTE",
   "name": "Earthstone Energy, Inc.",
   "last_sale": "9.71",
   "market_cap": "$621.23M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/este",
   "FIELD9": ""
 },
 {
   "symbol": "DEA",
   "name": "Easterly Government Properties, Inc.",
   "last_sale": "19.72",
   "market_cap": "$1.19B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/dea",
   "FIELD9": ""
 },
 {
   "symbol": "EGP",
   "name": "EastGroup Properties, Inc.",
   "last_sale": "97.21",
   "market_cap": "$3.47B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/egp",
   "FIELD9": ""
 },
 {
   "symbol": "EMN",
   "name": "Eastman Chemical Company",
   "last_sale": "99.88",
   "market_cap": "$14.11B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/emn",
   "FIELD9": ""
 },
 {
   "symbol": "KODK",
   "name": "Eastman Kodak Company",
   "last_sale": "2.9",
   "market_cap": "$123.75M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/kodk",
   "FIELD9": ""
 },
 {
   "symbol": "ETN",
   "name": "Eaton Corporation, PLC",
   "last_sale": "88.5",
   "market_cap": "$38.35B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/etn",
   "FIELD9": ""
 },
 {
   "symbol": "ETV",
   "name": "Eaton Vance Corporation",
   "last_sale": "16.08",
   "market_cap": "$1.19B",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/etv",
   "FIELD9": ""
 },
 {
   "symbol": "ETW",
   "name": "Eaton Vance Corporation",
   "last_sale": "11.99",
   "market_cap": "$1.28B",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/etw",
   "FIELD9": ""
 },
 {
   "symbol": "EV",
   "name": "Eaton Vance Corporation",
   "last_sale": "54.04",
   "market_cap": "$6.4B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/ev",
   "FIELD9": ""
 },
 {
   "symbol": "EOI",
   "name": "Eaton Vance Enhance Equity Income Fund",
   "last_sale": "16.22",
   "market_cap": "$636.02M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eoi",
   "FIELD9": ""
 },
 {
   "symbol": "EOS",
   "name": "Eaton Vance Enhanced Equity Income Fund II",
   "last_sale": "17.62",
   "market_cap": "$840.7M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eos",
   "FIELD9": ""
 },
 {
   "symbol": "EFT",
   "name": "Eaton Vance Floating Rate Income Trust",
   "last_sale": "14.68",
   "market_cap": "$585.2M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eft",
   "FIELD9": ""
 },
 {
   "symbol": "EFL",
   "name": "Eaton Vance Floating-Rate 2022 Target Term Trust",
   "last_sale": "9.293",
   "market_cap": "$195.15M",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/efl",
   "FIELD9": ""
 },
 {
   "symbol": "EFF",
   "name": "Eaton vance Floating-Rate Income Plus Fund",
   "last_sale": "15.85",
   "market_cap": "$120.56M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eff",
   "FIELD9": ""
 },
 {
   "symbol": "EHT",
   "name": "Eaton Vance High Income 2021 Target Term Trust",
   "last_sale": "9.72",
   "market_cap": "$208.6M",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eht",
   "FIELD9": ""
 },
 {
   "symbol": "ETX           ",
   "name": "Eaton Vance Municipal Income 2028 Term Trust",
   "last_sale": "19.55",
   "market_cap": "$211.8M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/etx",
   "FIELD9": ""
 },
 {
   "symbol": "EOT",
   "name": "Eaton Vance Municipal Income Trust",
   "last_sale": "21.56",
   "market_cap": "$328.3M",
   "IPOyear": "2009",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eot",
   "FIELD9": ""
 },
 {
   "symbol": "EVN",
   "name": "Eaton Vance Municipal Income Trust",
   "last_sale": "11.52",
   "market_cap": "$273.97M",
   "IPOyear": "1999",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/evn",
   "FIELD9": ""
 },
 {
   "symbol": "ETJ",
   "name": "Eaton Vance Risk-Managed Diversified Equity Income Fund",
   "last_sale": "9.94",
   "market_cap": "$632.88M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/etj",
   "FIELD9": ""
 },
 {
   "symbol": "EFR",
   "name": "Eaton Vance Senior Floating-Rate Fund",
   "last_sale": "14.08",
   "market_cap": "$518.82M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/efr",
   "FIELD9": ""
 },
 {
   "symbol": "EVF",
   "name": "Eaton Vance Senior Income Trust",
   "last_sale": "6.48",
   "market_cap": "$245.38M",
   "IPOyear": "1998",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/evf",
   "FIELD9": ""
 },
 {
   "symbol": "EVG",
   "name": "Eaton Vance Short Diversified Income Fund",
   "last_sale": "12.92",
   "market_cap": "$231.02M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/evg",
   "FIELD9": ""
 },
 {
   "symbol": "EVT",
   "name": "Eaton Vance Tax Advantaged Dividend Income Fund",
   "last_sale": "24.44",
   "market_cap": "$1.78B",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/evt",
   "FIELD9": ""
 },
 {
   "symbol": "ETO",
   "name": "Eaton Vance Tax-Advantage Global Dividend Opp",
   "last_sale": "25.35",
   "market_cap": "$378.16M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eto",
   "FIELD9": ""
 },
 {
   "symbol": "EXD",
   "name": "Eaton Vance Tax-Advantaged Bond",
   "last_sale": "8.75",
   "market_cap": "$85.15M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/exd",
   "FIELD9": ""
 },
 {
   "symbol": "ETG",
   "name": "Eaton Vance Tax-Advantaged Global Dividend Income Fund",
   "last_sale": "17.95",
   "market_cap": "$1.37B",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/etg",
   "FIELD9": ""
 },
 {
   "symbol": "ETB",
   "name": "Eaton Vance Tax-Managed Buy-Write Income Fund",
   "last_sale": "16.59",
   "market_cap": "$436.48M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/etb",
   "FIELD9": ""
 },
 {
   "symbol": "ETY",
   "name": "Eaton Vance Tax-Managed Diversified Equity Income Fund",
   "last_sale": "12.79",
   "market_cap": "$1.91B",
   "IPOyear": "2006",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ety",
   "FIELD9": ""
 },
 {
   "symbol": "EXG",
   "name": "Eaton Vance Tax-Managed Global Diversified Equity Income Fund",
   "last_sale": "9.57",
   "market_cap": "$2.89B",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/exg",
   "FIELD9": ""
 },
 {
   "symbol": "ECT",
   "name": "ECA Marcellus Trust I",
   "last_sale": "1.85",
   "market_cap": "$32.57M",
   "IPOyear": "2010",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/ect",
   "FIELD9": ""
 },
 {
   "symbol": "ECR",
   "name": "Eclipse Resources Corporation",
   "last_sale": "1.31",
   "market_cap": "$396.05M",
   "IPOyear": "2014",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/ecr",
   "FIELD9": ""
 },
 {
   "symbol": "ECL",
   "name": "Ecolab Inc.",
   "last_sale": "159.4",
   "market_cap": "$46.05B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/ecl",
   "FIELD9": ""
 },
 {
   "symbol": "EC",
   "name": "Ecopetrol S.A.",
   "last_sale": "24.78",
   "market_cap": "$50.94B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/ec",
   "FIELD9": ""
 },
 {
   "symbol": "EIX",
   "name": "Edison International",
   "last_sale": "68.36",
   "market_cap": "$22.27B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/eix",
   "FIELD9": ""
 },
 {
  "symbol": "ADYEN",
  "name": "Adyen N.V.",
  "last_sale": "68.36",
  "market_cap": "$22.27B",
  "IPOyear": "n/a",
  "sector": "Public Utilities",
  "industry": "Electric Utilities: Central",
  "summary_quote": "https://www.nasdaq.com/symbol/eix",
  "FIELD9": ""
},
 {
  "symbol": "TME",
  "name": "Tencent Music",
  "last_sale": "68.36",
  "market_cap": "$22.27B",
  "IPOyear": "n/a",
  "sector": "Public Utilities",
  "industry": "Electric Utilities: Central",
  "summary_quote": "https://www.nasdaq.com/symbol/eix",
  "FIELD9": ""
},
 {
   "symbol": "EW",
   "name": "Edwards Lifesciences Corporation",
   "last_sale": "153.68",
   "market_cap": "$32.18B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/ew",
   "FIELD9": ""
 },
 {
   "symbol": "EHIC",
   "name": "eHi Car Services Limited",
   "last_sale": "11.61",
   "market_cap": "$806.26M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Rental/Leasing Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/ehic",
   "FIELD9": ""
 },
 {
   "symbol": "EP^C",
   "name": "El Paso Corporation",
   "last_sale": "46.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/ep^c",
   "FIELD9": ""
 },
 {
   "symbol": "EE",
   "name": "El Paso Electric Company",
   "last_sale": "58.95",
   "market_cap": "$2.4B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/ee",
   "FIELD9": ""
 },
 {
   "symbol": "ELAN",
   "name": "Elanco Animal Health Incorporated",
   "last_sale": "34.1",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/elan",
   "FIELD9": ""
 },
 {
   "symbol": "EGO",
   "name": "Eldorado Gold Corporation",
   "last_sale": "0.88",
   "market_cap": "$698.73M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/ego",
   "FIELD9": ""
 },
 {
   "symbol": "ELVT",
   "name": "Elevate Credit, Inc.",
   "last_sale": "8.59",
   "market_cap": "$371.01M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/elvt",
   "FIELD9": ""
 },
 {
   "symbol": "LLY",
   "name": "Eli Lilly and Company",
   "last_sale": "106.33",
   "market_cap": "$114.2B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/lly",
   "FIELD9": ""
 },
 {
   "symbol": "ELLI",
   "name": "Ellie Mae, Inc.",
   "last_sale": "93.43",
   "market_cap": "$3.24B",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/elli",
   "FIELD9": ""
 },
 {
   "symbol": "EFC",
   "name": "Ellington Financial LLC",
   "last_sale": "16.1",
   "market_cap": "$485.44M",
   "IPOyear": "2010",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/efc",
   "FIELD9": ""
 },
 {
   "symbol": "EARN",
   "name": "Ellington Residential Mortgage REIT",
   "last_sale": "11.86",
   "market_cap": "$150.51M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/earn",
   "FIELD9": ""
 },
 {
   "symbol": "AKO.A",
   "name": "Embotelladora Andina S.A.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ako.a",
   "FIELD9": ""
 },
 {
   "symbol": "AKO.B",
   "name": "Embotelladora Andina S.A.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ako.b",
   "FIELD9": ""
 },
 {
   "symbol": "ERJ",
   "name": "Embraer S.A.",
   "last_sale": "18.94",
   "market_cap": "$3.47B",
   "IPOyear": "2000",
   "sector": "Capital Goods",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/erj",
   "FIELD9": ""
 },
 {
   "symbol": "EME",
   "name": "EMCOR Group, Inc.",
   "last_sale": "75.01",
   "market_cap": "$4.36B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Engineering & Construction",
   "summary_quote": "https://www.nasdaq.com/symbol/eme",
   "FIELD9": ""
 },
 {
   "symbol": "EEX",
   "name": "Emerald Expositions Events, Inc.",
   "last_sale": "16.3",
   "market_cap": "$1.19B",
   "IPOyear": "2017",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/eex",
   "FIELD9": ""
 },
 {
   "symbol": "EMES",
   "name": "Emerge Energy Services LP",
   "last_sale": "4.62",
   "market_cap": "$143.38M",
   "IPOyear": "2013",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/emes",
   "FIELD9": ""
 },
 {
   "symbol": "EBS",
   "name": "Emergent Biosolutions, Inc.",
   "last_sale": "65.96",
   "market_cap": "$3.3B",
   "IPOyear": "2006",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/ebs",
   "FIELD9": ""
 },
 {
   "symbol": "EMR",
   "name": "Emerson Electric Company",
   "last_sale": "78.01",
   "market_cap": "$49.03B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/emr",
   "FIELD9": ""
 },
 {
   "symbol": "ESRT",
   "name": "Empire State Realty Trust, Inc.",
   "last_sale": "16.69",
   "market_cap": "$5.07B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/esrt",
   "FIELD9": ""
 },
 {
   "symbol": "EIG",
   "name": "Employers Holdings Inc",
   "last_sale": "46.8",
   "market_cap": "$1.53B",
   "IPOyear": "2007",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/eig",
   "FIELD9": ""
 },
 {
   "symbol": "EDN",
   "name": "Empresa Distribuidora Y Comercializadora Norte S.A. (Edenor)",
   "last_sale": "28.1",
   "market_cap": "$1.24B",
   "IPOyear": "2007",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/edn",
   "FIELD9": ""
 },
 {
   "symbol": "ENBL",
   "name": "Enable Midstream Partners, LP",
   "last_sale": "16.18",
   "market_cap": "$7.01B",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/enbl",
   "FIELD9": ""
 },
 {
   "symbol": "EEQ",
   "name": "Enbridge Energy Management LLC",
   "last_sale": "11.65",
   "market_cap": "$1.11B",
   "IPOyear": "2002",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/eeq",
   "FIELD9": ""
 },
 {
   "symbol": "EEP",
   "name": "Enbridge Energy, L.P.",
   "last_sale": "11.6",
   "market_cap": "$5.2B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/eep",
   "FIELD9": ""
 },
 {
   "symbol": "ENB",
   "name": "Enbridge Inc",
   "last_sale": "34.43",
   "market_cap": "$59.06B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/enb",
   "FIELD9": ""
 },
 {
   "symbol": "ENBA",
   "name": "Enbridge Inc",
   "last_sale": "25.32",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/enba",
   "FIELD9": ""
 },
 {
   "symbol": "ECA",
   "name": "Encana Corporation",
   "last_sale": "12.65",
   "market_cap": "$12.07B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/eca",
   "FIELD9": ""
 },
 {
   "symbol": "EHC",
   "name": "Encompass Health Corporation",
   "last_sale": "77",
   "market_cap": "$7.61B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/ehc",
   "FIELD9": ""
 },
 {
   "symbol": "DAVA",
   "name": "Endava plc",
   "last_sale": "28.15",
   "market_cap": "$1.49B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dava",
   "FIELD9": ""
 },
 {
   "symbol": "EXK",
   "name": "Endeavour Silver Corporation",
   "last_sale": "2.29",
   "market_cap": "$295.4M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/exk",
   "FIELD9": ""
 },
 {
   "symbol": "ENIA",
   "name": "Enel Americas S.A.",
   "last_sale": "8.05",
   "market_cap": "$9.39B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/enia",
   "FIELD9": ""
 },
 {
   "symbol": "ENIC",
   "name": "Enel Chile S.A.",
   "last_sale": "4.94",
   "market_cap": "$6.93B",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/enic",
   "FIELD9": ""
 },
 {
   "symbol": "EOCC",
   "name": "Enel Generacion Chile S.A.",
   "last_sale": "20.4",
   "market_cap": "$5.58B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/eocc",
   "FIELD9": ""
 },
 {
   "symbol": "EGN",
   "name": "Energen Corporation",
   "last_sale": "81.73",
   "market_cap": "$7.97B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/egn",
   "FIELD9": ""
 },
 {
   "symbol": "ENR",
   "name": "Energizer Holdings, Inc.",
   "last_sale": "62.38",
   "market_cap": "$3.73B",
   "IPOyear": "2015",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/enr",
   "FIELD9": ""
 },
 {
   "symbol": "EPC",
   "name": "Energizer Holdings, Inc.",
   "last_sale": "48.7",
   "market_cap": "$2.63B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/epc",
   "FIELD9": ""
 },
 {
   "symbol": "ETE",
   "name": "Energy Transfer Equity, L.P.",
   "last_sale": "17.66",
   "market_cap": "$20.45B",
   "IPOyear": "2006",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/ete",
   "FIELD9": ""
 },
 {
   "symbol": "ETP",
   "name": "Energy Transfer Partners, L.P.",
   "last_sale": "22.56",
   "market_cap": "$26.31B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/etp",
   "FIELD9": ""
 },
 {
   "symbol": "ETP^C",
   "name": "Energy Transfer Partners, L.P.",
   "last_sale": "25.23",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/etp^c",
   "FIELD9": ""
 },
 {
   "symbol": "ETP^D",
   "name": "Energy Transfer Partners, L.P.",
   "last_sale": "25.865",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/etp^d",
   "FIELD9": ""
 },
 {
   "symbol": "ERF",
   "name": "Enerplus Corporation",
   "last_sale": "11.9",
   "market_cap": "$2.92B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/erf",
   "FIELD9": ""
 },
 {
   "symbol": "ENS",
   "name": "Enersys",
   "last_sale": "85.18",
   "market_cap": "$3.59B",
   "IPOyear": "2004",
   "sector": "Consumer Non-Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ens",
   "FIELD9": ""
 },
 {
   "symbol": "EGL",
   "name": "Engility Holdings, Inc.",
   "last_sale": "35.27",
   "market_cap": "$1.3B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/egl",
   "FIELD9": ""
 },
 {
   "symbol": "E",
   "name": "ENI S.p.A.",
   "last_sale": "38.53",
   "market_cap": "$70.01B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/e",
   "FIELD9": ""
 },
 {
   "symbol": "ENLK",
   "name": "EnLink Midstream Partners, LP",
   "last_sale": "18.27",
   "market_cap": "$6.4B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/enlk",
   "FIELD9": ""
 },
 {
   "symbol": "ENLC",
   "name": "EnLink Midstream, LLC",
   "last_sale": "16.65",
   "market_cap": "$3.02B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/enlc",
   "FIELD9": ""
 },
 {
   "symbol": "EBF",
   "name": "Ennis, Inc.",
   "last_sale": "20.6",
   "market_cap": "$541.49M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ebf",
   "FIELD9": ""
 },
 {
   "symbol": "ENVA",
   "name": "Enova International, Inc.",
   "last_sale": "30.9",
   "market_cap": "$1.06B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/enva",
   "FIELD9": ""
 },
 {
   "symbol": "NPO",
   "name": "EnPro Industries",
   "last_sale": "75.51",
   "market_cap": "$1.58B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/npo",
   "FIELD9": ""
 },
 {
   "symbol": "ESV",
   "name": "ENSCO plc",
   "last_sale": "7.95",
   "market_cap": "$3.48B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/esv",
   "FIELD9": ""
 },
 {
   "symbol": "ETM",
   "name": "Entercom Communications Corp.",
   "last_sale": "7.9",
   "market_cap": "$1.13B",
   "IPOyear": "1999",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/etm",
   "FIELD9": ""
 },
 {
   "symbol": "EAB",
   "name": "Entergy Arkansas, Inc.",
   "last_sale": "24.12",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/eab",
   "FIELD9": ""
 },
 {
   "symbol": "EAE",
   "name": "Entergy Arkansas, Inc.",
   "last_sale": "23.299",
   "market_cap": "n/a",
   "IPOyear": "2013",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/eae",
   "FIELD9": ""
 },
 {
   "symbol": "EAI",
   "name": "Entergy Arkansas, Inc.",
   "last_sale": "23.58",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/eai",
   "FIELD9": ""
 },
 {
   "symbol": "ETR",
   "name": "Entergy Corporation",
   "last_sale": "82.57",
   "market_cap": "$14.93B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/etr",
   "FIELD9": ""
 },
 {
   "symbol": "ELC",
   "name": "Entergy Louisiana, Inc.",
   "last_sale": "23.5",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/elc",
   "FIELD9": ""
 },
 {
   "symbol": "ELJ",
   "name": "Entergy Louisiana, Inc.",
   "last_sale": "24.79",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/elj",
   "FIELD9": ""
 },
 {
   "symbol": "ELU",
   "name": "Entergy Louisiana, Inc.",
   "last_sale": "23.1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/elu",
   "FIELD9": ""
 },
 {
   "symbol": "EMP",
   "name": "Entergy Mississippi, Inc.",
   "last_sale": "24.0296",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/emp",
   "FIELD9": ""
 },
 {
   "symbol": "ENJ",
   "name": "Entergy New Orleans, LLC",
   "last_sale": "24.1203",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/enj",
   "FIELD9": ""
 },
 {
   "symbol": "ENO",
   "name": "Entergy New Orleans, LLC",
   "last_sale": "26.47",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/eno",
   "FIELD9": ""
 },
 {
   "symbol": "EZT",
   "name": "Entergy Texas Inc",
   "last_sale": "25.78",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/ezt",
   "FIELD9": ""
 },
 {
   "symbol": "EPD",
   "name": "Enterprise Products Partners L.P.",
   "last_sale": "29.1",
   "market_cap": "$63.32B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/epd",
   "FIELD9": ""
 },
 {
   "symbol": "EVC",
   "name": "Entravision Communications Corporation",
   "last_sale": "5.1",
   "market_cap": "$453.12M",
   "IPOyear": "2000",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/evc",
   "FIELD9": ""
 },
 {
   "symbol": "ENV",
   "name": "Envestnet, Inc",
   "last_sale": "61.4",
   "market_cap": "$2.79B",
   "IPOyear": "2010",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/env",
   "FIELD9": ""
 },
 {
   "symbol": "EVHC",
   "name": "Envision Healthcare Corporation",
   "last_sale": "45.66",
   "market_cap": "$5.54B",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/evhc",
   "FIELD9": ""
 },
 {
   "symbol": "EVA",
   "name": "Enviva Partners, LP",
   "last_sale": "31.25",
   "market_cap": "$827.46M",
   "IPOyear": "2015",
   "sector": "Basic Industries",
   "industry": "Forest Products",
   "summary_quote": "https://www.nasdaq.com/symbol/eva",
   "FIELD9": ""
 },
 {
   "symbol": "ENZ",
   "name": "Enzo Biochem, Inc.",
   "last_sale": "4.09",
   "market_cap": "$192.91M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/enz",
   "FIELD9": ""
 },
 {
   "symbol": "EOG",
   "name": "EOG Resources, Inc.",
   "last_sale": "119.46",
   "market_cap": "$69.19B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/eog",
   "FIELD9": ""
 },
 {
   "symbol": "EPE",
   "name": "EP Energy Corporation",
   "last_sale": "2.07",
   "market_cap": "$532.54M",
   "IPOyear": "2014",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/epe",
   "FIELD9": ""
 },
 {
   "symbol": "EPAM",
   "name": "EPAM Systems, Inc.",
   "last_sale": "138.12",
   "market_cap": "$7.43B",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/epam",
   "FIELD9": ""
 },
 {
   "symbol": "EPR",
   "name": "EPR Properties",
   "last_sale": "68.93",
   "market_cap": "$5.12B",
   "IPOyear": "1997",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/epr",
   "FIELD9": ""
 },
 {
   "symbol": "EPR^C",
   "name": "EPR Properties",
   "last_sale": "28.08",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/epr^c",
   "FIELD9": ""
 },
 {
   "symbol": "EPR^E",
   "name": "EPR Properties",
   "last_sale": "36.15",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/epr^e",
   "FIELD9": ""
 },
 {
   "symbol": "EPR^G",
   "name": "EPR Properties",
   "last_sale": "23.03",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/epr^g",
   "FIELD9": ""
 },
 {
   "symbol": "EQT",
   "name": "EQT Corporation",
   "last_sale": "48.24",
   "market_cap": "$12.74B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/eqt",
   "FIELD9": ""
 },
 {
   "symbol": "EQGP",
   "name": "EQT GP Holdings, LP",
   "last_sale": "21.84",
   "market_cap": "$6.61B",
   "IPOyear": "2015",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/eqgp",
   "FIELD9": ""
 },
 {
   "symbol": "EQM",
   "name": "EQT Midstream Partners, LP",
   "last_sale": "55.63",
   "market_cap": "$6.7B",
   "IPOyear": "2012",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/eqm",
   "FIELD9": ""
 },
 {
   "symbol": "EFX",
   "name": "Equifax, Inc.",
   "last_sale": "133.41",
   "market_cap": "$16.06B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/efx",
   "FIELD9": ""
 },
 {
   "symbol": "EQNR",
   "name": "Equinor ASA",
   "last_sale": "26.63",
   "market_cap": "$88.64B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/eqnr",
   "FIELD9": ""
 },
 {
   "symbol": "EQC",
   "name": "Equity Commonwealth",
   "last_sale": "32.28",
   "market_cap": "$3.92B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/eqc",
   "FIELD9": ""
 },
 {
   "symbol": "EQC^D",
   "name": "Equity Commonwealth",
   "last_sale": "25.9",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eqc^d",
   "FIELD9": ""
 },
 {
   "symbol": "ELS",
   "name": "Equity Lifestyle Properties, Inc.",
   "last_sale": "96.99",
   "market_cap": "$8.64B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/els",
   "FIELD9": ""
 },
 {
   "symbol": "EQR",
   "name": "Equity Residential",
   "last_sale": "67.69",
   "market_cap": "$24.93B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/eqr",
   "FIELD9": ""
 },
 {
   "symbol": "EQS",
   "name": "Equus Total Return, Inc.",
   "last_sale": "2",
   "market_cap": "$27.04M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eqs",
   "FIELD9": ""
 },
 {
   "symbol": "ERA",
   "name": "Era Group, Inc.",
   "last_sale": "12.64",
   "market_cap": "$274.14M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/era",
   "FIELD9": ""
 },
 {
   "symbol": "EROS",
   "name": "Eros International PLC",
   "last_sale": "12.3",
   "market_cap": "$884.96M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Movies/Entertainment",
   "summary_quote": "https://www.nasdaq.com/symbol/eros",
   "FIELD9": ""
 },
 {
   "symbol": "ESE",
   "name": "ESCO Technologies Inc.",
   "last_sale": "67.8",
   "market_cap": "$1.76B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ese",
   "FIELD9": ""
 },
 {
   "symbol": "ESNT",
   "name": "Essent Group Ltd.",
   "last_sale": "44.55",
   "market_cap": "$4.37B",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/esnt",
   "FIELD9": ""
 },
 {
   "symbol": "EPRT",
   "name": "Essential Properties Realty Trust, Inc.",
   "last_sale": "14.45",
   "market_cap": "$632.17M",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/eprt",
   "FIELD9": ""
 },
 {
   "symbol": "ESS",
   "name": "Essex Property Trust, Inc.",
   "last_sale": "247.24",
   "market_cap": "$16.33B",
   "IPOyear": "1994",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ess",
   "FIELD9": ""
 },
 {
   "symbol": "EL",
   "name": "Estee Lauder Companies, Inc. (The)",
   "last_sale": "143.54",
   "market_cap": "$52.71B",
   "IPOyear": "1995",
   "sector": "Consumer Non-Durables",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/el",
   "FIELD9": ""
 },
 {
   "symbol": "ESL",
   "name": "Esterline Technologies Corporation",
   "last_sale": "90.1",
   "market_cap": "$2.65B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/esl",
   "FIELD9": ""
 },
 {
   "symbol": "ETH",
   "name": "Ethan Allen Interiors Inc.",
   "last_sale": "21.7",
   "market_cap": "$575.69M",
   "IPOyear": "1993",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/eth",
   "FIELD9": ""
 },
 {
   "symbol": "EURN",
   "name": "Euronav NV",
   "last_sale": "8.65",
   "market_cap": "$1.89B",
   "IPOyear": "2015",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/eurn",
   "FIELD9": ""
 },
 {
   "symbol": "EEA",
   "name": "European Equity Fund, Inc. (The)",
   "last_sale": "9.51",
   "market_cap": "$75.27M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eea",
   "FIELD9": ""
 },
 {
   "symbol": "EB",
   "name": "Eventbrite, Inc.",
   "last_sale": "34.25",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eb",
   "FIELD9": ""
 },
 {
   "symbol": "EVR",
   "name": "Evercore Inc.",
   "last_sale": "102.8",
   "market_cap": "$4.21B",
   "IPOyear": "2006",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/evr",
   "FIELD9": ""
 },
 {
   "symbol": "RE",
   "name": "Everest Re Group, Ltd.",
   "last_sale": "233.13",
   "market_cap": "$9.52B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/re",
   "FIELD9": ""
 },
 {
   "symbol": "EVRG",
   "name": "Evergy, Inc.",
   "last_sale": "55.87",
   "market_cap": "$15.18B",
   "IPOyear": "2018",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/evrg",
   "FIELD9": ""
 },
 {
   "symbol": "EVRI",
   "name": "Everi Holdings Inc.",
   "last_sale": "9.33",
   "market_cap": "$648.86M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/evri",
   "FIELD9": ""
 },
 {
   "symbol": "ES",
   "name": "Eversource Energy",
   "last_sale": "62.16",
   "market_cap": "$19.7B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/es",
   "FIELD9": ""
 },
 {
   "symbol": "EVTC",
   "name": "Evertec, Inc.",
   "last_sale": "23.35",
   "market_cap": "$1.7B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/evtc",
   "FIELD9": ""
 },
 {
   "symbol": "EVH",
   "name": "Evolent Health, Inc",
   "last_sale": "27.55",
   "market_cap": "$2.17B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/evh",
   "FIELD9": ""
 },
 {
   "symbol": "AQUA",
   "name": "Evoqua Water Technologies Corp.",
   "last_sale": "17.95",
   "market_cap": "$2.04B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/aqua",
   "FIELD9": ""
 },
 {
   "symbol": "XAN",
   "name": "Exantas Capital Corp.",
   "last_sale": "11.11",
   "market_cap": "$351.71M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/xan",
   "FIELD9": ""
 },
 {
   "symbol": "XAN^C",
   "name": "Exantas Capital Corp.",
   "last_sale": "25.85",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/xan^c",
   "FIELD9": ""
 },
 {
   "symbol": "EXC",
   "name": "Exelon Corporation",
   "last_sale": "43.65",
   "market_cap": "$42.16B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/exc",
   "FIELD9": ""
 },
 {
   "symbol": "EXPR",
   "name": "Express, Inc.",
   "last_sale": "10.91",
   "market_cap": "$800.58M",
   "IPOyear": "2010",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/expr",
   "FIELD9": ""
 },
 {
   "symbol": "EXTN",
   "name": "Exterran Corporation",
   "last_sale": "25.14",
   "market_cap": "$908.19M",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/extn",
   "FIELD9": ""
 },
 {
   "symbol": "EXR",
   "name": "Extra Space Storage Inc",
   "last_sale": "87.69",
   "market_cap": "$11.09B",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/exr",
   "FIELD9": ""
 },
 {
   "symbol": "XOM",
   "name": "Exxon Mobil Corporation",
   "last_sale": "85.17",
   "market_cap": "$360.59B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/xom",
   "FIELD9": ""
 },
 {
   "symbol": "FNB",
   "name": "F.N.B. Corporation",
   "last_sale": "13.33",
   "market_cap": "$4.32B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fnb",
   "FIELD9": ""
 },
 {
   "symbol": "FNB^E",
   "name": "F.N.B. Corporation",
   "last_sale": "28.22",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fnb^e",
   "FIELD9": ""
 },
 {
   "symbol": "FN",
   "name": "Fabrinet",
   "last_sale": "45.52",
   "market_cap": "$1.66B",
   "IPOyear": "2010",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/fn",
   "FIELD9": ""
 },
 {
   "symbol": "FDS",
   "name": "FactSet Research Systems Inc.",
   "last_sale": "231.33",
   "market_cap": "$8.87B",
   "IPOyear": "1996",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/fds",
   "FIELD9": ""
 },
 {
   "symbol": "FICO",
   "name": "Fair Isaac Corporation",
   "last_sale": "228.23",
   "market_cap": "$6.65B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fico",
   "FIELD9": ""
 },
 {
   "symbol": "SFUN",
   "name": "Fang Holdings Limited",
   "last_sale": "2.65",
   "market_cap": "$1.18B",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sfun",
   "FIELD9": ""
 },
 {
   "symbol": "FPAC",
   "name": "Far Point Acquisition Corporation",
   "last_sale": "9.6",
   "market_cap": "$168.07M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fpac",
   "FIELD9": ""
 },
 {
   "symbol": "FPAC.U",
   "name": "Far Point Acquisition Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fpac.u",
   "FIELD9": ""
 },
 {
   "symbol": "FPAC.WS",
   "name": "Far Point Acquisition Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fpac.ws",
   "FIELD9": ""
 },
 {
   "symbol": "FPI",
   "name": "Farmland Partners Inc.",
   "last_sale": "6.59",
   "market_cap": "$216.6M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/fpi",
   "FIELD9": ""
 },
 {
   "symbol": "FPI^B",
   "name": "Farmland Partners Inc.",
   "last_sale": "22.55",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fpi^b",
   "FIELD9": ""
 },
 {
   "symbol": "FBK",
   "name": "FB Financial Corporation",
   "last_sale": "43.96",
   "market_cap": "$1.35B",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fbk",
   "FIELD9": ""
 },
 {
   "symbol": "FFG",
   "name": "FBL Financial Group, Inc.",
   "last_sale": "80.55",
   "market_cap": "$2B",
   "IPOyear": "1996",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/ffg",
   "FIELD9": ""
 },
 {
   "symbol": "FCB",
   "name": "FCB Financial Holdings, Inc.",
   "last_sale": "49.35",
   "market_cap": "$2.31B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fcb",
   "FIELD9": ""
 },
 {
   "symbol": "AGM",
   "name": "Federal Agricultural Mortgage Corporation",
   "last_sale": "80.32",
   "market_cap": "$856.9M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/agm",
   "FIELD9": ""
 },
 {
   "symbol": "AGM.A",
   "name": "Federal Agricultural Mortgage Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/agm.a",
   "FIELD9": ""
 },
 {
   "symbol": "AGM^A",
   "name": "Federal Agricultural Mortgage Corporation",
   "last_sale": "25.5042",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/agm^a",
   "FIELD9": ""
 },
 {
   "symbol": "AGM^B",
   "name": "Federal Agricultural Mortgage Corporation",
   "last_sale": "26.49",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/agm^b",
   "FIELD9": ""
 },
 {
   "symbol": "AGM^C",
   "name": "Federal Agricultural Mortgage Corporation",
   "last_sale": "26",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/agm^c",
   "FIELD9": ""
 },
 {
   "symbol": "FRT",
   "name": "Federal Realty Investment Trust",
   "last_sale": "127.87",
   "market_cap": "$9.4B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/frt",
   "FIELD9": ""
 },
 {
   "symbol": "FRT^C",
   "name": "Federal Realty Investment Trust",
   "last_sale": "22.235",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/frt^c",
   "FIELD9": ""
 },
 {
   "symbol": "FSS",
   "name": "Federal Signal Corporation",
   "last_sale": "26.76",
   "market_cap": "$1.61B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/fss",
   "FIELD9": ""
 },
 {
   "symbol": "FII",
   "name": "Federated Investors, Inc.",
   "last_sale": "25.17",
   "market_cap": "$2.54B",
   "IPOyear": "1998",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/fii",
   "FIELD9": ""
 },
 {
   "symbol": "FMN",
   "name": "Federated Premier Municipal Income Fund",
   "last_sale": "12.83",
   "market_cap": "$147.5M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fmn",
   "FIELD9": ""
 },
 {
   "symbol": "FDX",
   "name": "FedEx Corporation",
   "last_sale": "247.32",
   "market_cap": "$65.17B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fdx",
   "FIELD9": ""
 },
 {
   "symbol": "RACE",
   "name": "Ferrari N.V.",
   "last_sale": "137.47",
   "market_cap": "$33.7B",
   "IPOyear": "2015",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/race",
   "FIELD9": ""
 },
 {
   "symbol": "FGP",
   "name": "Ferrellgas Partners, L.P.",
   "last_sale": "2.85",
   "market_cap": "$276.89M",
   "IPOyear": "1994",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/fgp",
   "FIELD9": ""
 },
 {
   "symbol": "FOE",
   "name": "Ferro Corporation",
   "last_sale": "23.82",
   "market_cap": "$2B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Paints/Coatings",
   "summary_quote": "https://www.nasdaq.com/symbol/foe",
   "FIELD9": ""
 },
 {
   "symbol": "FG",
   "name": "FGL Holdings",
   "last_sale": "8.97",
   "market_cap": "$1.92B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/fg",
   "FIELD9": ""
 },
 {
   "symbol": "FG.WS",
   "name": "FGL Holdings",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fg.ws",
   "FIELD9": ""
 },
 {
   "symbol": "FCAU",
   "name": "Fiat Chrysler Automobiles N.V.",
   "last_sale": "18.29",
   "market_cap": "$35.84B",
   "IPOyear": "2014",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/fcau",
   "FIELD9": ""
 },
 {
   "symbol": "FBR",
   "name": "Fibria Celulose S.A.",
   "last_sale": "18.45",
   "market_cap": "$10.21B",
   "IPOyear": "1997",
   "sector": "Basic Industries",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/fbr",
   "FIELD9": ""
 },
 {
   "symbol": "FNF",
   "name": "Fidelity National Financial, Inc.",
   "last_sale": "39.64",
   "market_cap": "$10.9B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/fnf",
   "FIELD9": ""
 },
 {
   "symbol": "FIS",
   "name": "Fidelity National Information Services, Inc.",
   "last_sale": "110.58",
   "market_cap": "$36.36B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fis",
   "FIELD9": ""
 },
 {
   "symbol": "FMO",
   "name": "Fiduciary/Claymore MLP Opportunity Fund",
   "last_sale": "12.05",
   "market_cap": "$427.06M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fmo",
   "FIELD9": ""
 },
 {
   "symbol": "FAF",
   "name": "First American Corporation (The)",
   "last_sale": "52.64",
   "market_cap": "$5.88B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/faf",
   "FIELD9": ""
 },
 {
   "symbol": "FBP",
   "name": "First BanCorp.",
   "last_sale": "9.17",
   "market_cap": "$1.99B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fbp",
   "FIELD9": ""
 },
 {
   "symbol": "FCFS",
   "name": "First Cash, Inc.",
   "last_sale": "83",
   "market_cap": "$3.68B",
   "IPOyear": "1991",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/fcfs",
   "FIELD9": ""
 },
 {
   "symbol": "FCF",
   "name": "First Commonwealth Financial Corporation",
   "last_sale": "16.45",
   "market_cap": "$1.65B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fcf",
   "FIELD9": ""
 },
 {
   "symbol": "FDC",
   "name": "First Data Corporation",
   "last_sale": "25.36",
   "market_cap": "$23.68B",
   "IPOyear": "2015",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fdc",
   "FIELD9": ""
 },
 {
   "symbol": "FHN",
   "name": "First Horizon National Corporation",
   "last_sale": "18.08",
   "market_cap": "$5.88B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fhn",
   "FIELD9": ""
 },
 {
   "symbol": "FHN^A",
   "name": "First Horizon National Corporation",
   "last_sale": "25.42",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fhn^a",
   "FIELD9": ""
 },
 {
   "symbol": "FR",
   "name": "First Industrial Realty Trust, Inc.",
   "last_sale": "31.81",
   "market_cap": "$4.01B",
   "IPOyear": "1994",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/fr",
   "FIELD9": ""
 },
 {
   "symbol": "AG",
   "name": "First Majestic Silver Corp.",
   "last_sale": "5.7",
   "market_cap": "$1.1B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/ag",
   "FIELD9": ""
 },
 {
   "symbol": "FRC",
   "name": "FIRST REPUBLIC BANK",
   "last_sale": "100.98",
   "market_cap": "$16.42B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/frc",
   "FIELD9": ""
 },
 {
   "symbol": "FRC^D",
   "name": "FIRST REPUBLIC BANK",
   "last_sale": "24.8626",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/frc^d",
   "FIELD9": ""
 },
 {
   "symbol": "FRC^E",
   "name": "FIRST REPUBLIC BANK",
   "last_sale": "25.44",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/frc^e",
   "FIELD9": ""
 },
 {
   "symbol": "FRC^F",
   "name": "FIRST REPUBLIC BANK",
   "last_sale": "25.0327",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/frc^f",
   "FIELD9": ""
 },
 {
   "symbol": "FRC^G",
   "name": "FIRST REPUBLIC BANK",
   "last_sale": "24.6565",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/frc^g",
   "FIELD9": ""
 },
 {
   "symbol": "FRC^H",
   "name": "FIRST REPUBLIC BANK",
   "last_sale": "24.54",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/frc^h",
   "FIELD9": ""
 },
 {
   "symbol": "FRC^I",
   "name": "FIRST REPUBLIC BANK",
   "last_sale": "24.23",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/frc^i",
   "FIELD9": ""
 },
 {
   "symbol": "FFA",
   "name": "First Trust",
   "last_sale": "16.25",
   "market_cap": "$324.56M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ffa",
   "FIELD9": ""
 },
 {
   "symbol": "FMY",
   "name": "First Trust",
   "last_sale": "13.41",
   "market_cap": "$56.5M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fmy",
   "FIELD9": ""
 },
 {
   "symbol": "FDEU",
   "name": "First Trust Dynamic Europe Equity Income Fund",
   "last_sale": "15.82",
   "market_cap": "$272.61M",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fdeu",
   "FIELD9": ""
 },
 {
   "symbol": "FIF",
   "name": "First Trust Energy Infrastructure Fund",
   "last_sale": "16.12",
   "market_cap": "$282.91M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fif",
   "FIELD9": ""
 },
 {
   "symbol": "FSD",
   "name": "First Trust High Income Long Short Fund",
   "last_sale": "14.78",
   "market_cap": "$442.62M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fsd",
   "FIELD9": ""
 },
 {
   "symbol": "FPF",
   "name": "First Trust Intermediate Duration Preferred & Income Fund",
   "last_sale": "21.53",
   "market_cap": "$1.31B",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fpf",
   "FIELD9": ""
 },
 {
   "symbol": "FEI           ",
   "name": "First Trust MLP and Energy Income Fund",
   "last_sale": "12.48",
   "market_cap": "$584.78M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fei",
   "FIELD9": ""
 },
 {
   "symbol": "FPL",
   "name": "First Trust New Opportunities MLP & Energy Fund",
   "last_sale": "9.6489",
   "market_cap": "$245.07M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fpl",
   "FIELD9": ""
 },
 {
   "symbol": "FIV",
   "name": "First Trust Senior Floating Rate 2022 Target Term Fund",
   "last_sale": "9.32",
   "market_cap": "$333.95M",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fiv",
   "FIELD9": ""
 },
 {
   "symbol": "FCT",
   "name": "First Trust Senior Floating Rate Income Fund II",
   "last_sale": "12.63",
   "market_cap": "$337.18M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fct",
   "FIELD9": ""
 },
 {
   "symbol": "FGB",
   "name": "First Trust Specialty Finance and Financial Opportunities Fund",
   "last_sale": "6.38",
   "market_cap": "$91.55M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fgb",
   "FIELD9": ""
 },
 {
   "symbol": "FEO",
   "name": "First Trust/Aberdeen Emerging Opportunity Fund",
   "last_sale": "13.01",
   "market_cap": "$67.22M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/feo",
   "FIELD9": ""
 },
 {
   "symbol": "FAM",
   "name": "First Trust/Aberdeen Global Opportunity Income Fund",
   "last_sale": "9.58",
   "market_cap": "$124.06M",
   "IPOyear": "2006",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fam",
   "FIELD9": ""
 },
 {
   "symbol": "FE",
   "name": "FirstEnergy Corp.",
   "last_sale": "36.9",
   "market_cap": "$17.93B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/fe",
   "FIELD9": ""
 },
 {
   "symbol": "FIT",
   "name": "Fitbit, Inc.",
   "last_sale": "5.94",
   "market_cap": "$1.46B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Computer Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/fit",
   "FIELD9": ""
 },
 {
   "symbol": "FPH",
   "name": "Five Point Holdings, LLC",
   "last_sale": "9.97",
   "market_cap": "$663.28M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/fph",
   "FIELD9": ""
 },
 {
   "symbol": "FBC",
   "name": "Flagstar Bancorp, Inc.",
   "last_sale": "32.15",
   "market_cap": "$1.85B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/fbc",
   "FIELD9": ""
 },
 {
   "symbol": "DFP",
   "name": "Flaherty & Crumrine Dynamic Preferred and Income Fund Inc.",
   "last_sale": "23.7232",
   "market_cap": "$454.57M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dfp",
   "FIELD9": ""
 },
 {
   "symbol": "PFD",
   "name": "Flaherty & Crumrine Preferred Income Fund Incorporated",
   "last_sale": "13.42",
   "market_cap": "$150.29M",
   "IPOyear": "1991",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pfd",
   "FIELD9": ""
 },
 {
   "symbol": "PFO",
   "name": "Flaherty & Crumrine Preferred Income Opportunity Fund Inc",
   "last_sale": "11.51",
   "market_cap": "$144.24M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pfo",
   "FIELD9": ""
 },
 {
   "symbol": "FFC",
   "name": "Flaherty & Crumrine Preferred Securities Income Fund Inc",
   "last_sale": "18.54",
   "market_cap": "$820.44M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ffc",
   "FIELD9": ""
 },
 {
   "symbol": "FLC",
   "name": "Flaherty & Crumrine Total Return Fund Inc",
   "last_sale": "19",
   "market_cap": "$189.2M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/flc",
   "FIELD9": ""
 },
 {
   "symbol": "FLT",
   "name": "FleetCor Technologies, Inc.",
   "last_sale": "222.28",
   "market_cap": "$19.65B",
   "IPOyear": "2010",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/flt",
   "FIELD9": ""
 },
 {
   "symbol": "FND",
   "name": "Floor & Decor Holdings, Inc.",
   "last_sale": "34.04",
   "market_cap": "$3.31B",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/fnd",
   "FIELD9": ""
 },
 {
   "symbol": "FTK",
   "name": "Flotek Industries, Inc.",
   "last_sale": "2.57",
   "market_cap": "$146.38M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/ftk",
   "FIELD9": ""
 },
 {
   "symbol": "FLO",
   "name": "Flowers Foods, Inc.",
   "last_sale": "19.35",
   "market_cap": "$4.08B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/flo",
   "FIELD9": ""
 },
 {
   "symbol": "FLS",
   "name": "Flowserve Corporation",
   "last_sale": "55.44",
   "market_cap": "$7.25B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Fluid Controls",
   "summary_quote": "https://www.nasdaq.com/symbol/fls",
   "FIELD9": ""
 },
 {
   "symbol": "FLR",
   "name": "Fluor Corporation",
   "last_sale": "59.43",
   "market_cap": "$8.36B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/flr",
   "FIELD9": ""
 },
 {
   "symbol": "FLY",
   "name": "Fly Leasing Limited",
   "last_sale": "14.33",
   "market_cap": "$401M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fly",
   "FIELD9": ""
 },
 {
   "symbol": "FMC",
   "name": "FMC Corporation",
   "last_sale": "89.86",
   "market_cap": "$12.1B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/fmc",
   "FIELD9": ""
 },
 {
   "symbol": "FMX",
   "name": "Fomento Economico Mexicano S.A.B. de C.V.",
   "last_sale": "96.57",
   "market_cap": "$172.77B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/fmx",
   "FIELD9": ""
 },
 {
   "symbol": "FL",
   "name": "Foot Locker, Inc.",
   "last_sale": "48.29",
   "market_cap": "$5.55B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/fl",
   "FIELD9": ""
 },

 {
   "symbol": "FELP",
   "name": "Foresight Energy LP",
   "last_sale": "3.91",
   "market_cap": "$569.1M",
   "IPOyear": "2014",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/felp",
   "FIELD9": ""
 },
 {
   "symbol": "FCE.A",
   "name": "Forest City Realty Trust, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fce.a",
   "FIELD9": ""
 },
 {
   "symbol": "FOR",
   "name": "Forestar Group Inc",
   "last_sale": "25.15",
   "market_cap": "$1.05B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/for",
   "FIELD9": ""
 },
 {
   "symbol": "FTS",
   "name": "Fortis Inc.",
   "last_sale": "32.74",
   "market_cap": "$13.91B",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/fts",
   "FIELD9": ""
 },
 {
   "symbol": "FTV",
   "name": "Fortive Corporation",
   "last_sale": "86.98",
   "market_cap": "$30.37B",
   "IPOyear": "2016",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/ftv",
   "FIELD9": ""
 },
 {
   "symbol": "FTV^A",
   "name": "Fortive Corporation",
   "last_sale": "1090.63",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftv^a",
   "FIELD9": ""
 },
 {
   "symbol": "FTAI",
   "name": "Fortress Transportation and Infrastructure Investors LLC",
   "last_sale": "18.78",
   "market_cap": "$1.55B",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ftai",
   "FIELD9": ""
 },
 {
   "symbol": "FSM",
   "name": "Fortuna Silver Mines Inc.",
   "last_sale": "4.37",
   "market_cap": "$698.33M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/fsm",
   "FIELD9": ""
 },
 {
   "symbol": "FBHS",
   "name": "Fortune Brands Home & Security, Inc.",
   "last_sale": "55.22",
   "market_cap": "$7.86B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/fbhs",
   "FIELD9": ""
 },
 {
   "symbol": "FET",
   "name": "Forum Energy Technologies, Inc.",
   "last_sale": "11.2",
   "market_cap": "$1.22B",
   "IPOyear": "2012",
   "sector": "Energy",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/fet",
   "FIELD9": ""
 },
 {
   "symbol": "FBM",
   "name": "Foundation Building Materials, Inc.",
   "last_sale": "12.9",
   "market_cap": "$553.33M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/fbm",
   "FIELD9": ""
 },
 {
   "symbol": "FCPT",
   "name": "Four Corners Property Trust, Inc.",
   "last_sale": "25.69",
   "market_cap": "$1.62B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/fcpt",
   "FIELD9": ""
 },
 {
   "symbol": "FEDU",
   "name": "Four Seasons Education (Cayman) Inc.",
   "last_sale": "4.5",
   "market_cap": "$224.7M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fedu",
   "FIELD9": ""
 },
 {
   "symbol": "FNV",
   "name": "Franco-Nevada Corporation",
   "last_sale": "63.95",
   "market_cap": "$11.91B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/fnv",
   "FIELD9": ""
 },
 {
   "symbol": "FC",
   "name": "Franklin Covey Company",
   "last_sale": "23.7",
   "market_cap": "$329.61M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fc",
   "FIELD9": ""
 },
 {
   "symbol": "FSB",
   "name": "Franklin Financial Network, Inc.",
   "last_sale": "41.2",
   "market_cap": "$596.89M",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/fsb",
   "FIELD9": ""
 },
 {
   "symbol": "BEN",
   "name": "Franklin Resources, Inc.",
   "last_sale": "32.82",
   "market_cap": "$17.3B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/ben",
   "FIELD9": ""
 },
 {
   "symbol": "FT",
   "name": "Franklin Universal Trust",
   "last_sale": "6.73",
   "market_cap": "$169.14M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ft",
   "FIELD9": ""
 },
 {
   "symbol": "FI",
   "name": "Frank&#39;s International N.V.",
   "last_sale": "8.27",
   "market_cap": "$1.85B",
   "IPOyear": "2013",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/fi",
   "FIELD9": ""
 },
 {
   "symbol": "FCX",
   "name": "Freeport-McMoran, Inc.",
   "last_sale": "14.61",
   "market_cap": "$21.17B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/fcx",
   "FIELD9": ""
 },
 {
   "symbol": "FMS",
   "name": "Fresenius Medical Care Corporation",
   "last_sale": "51.1",
   "market_cap": "$31.29B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/fms",
   "FIELD9": ""
 },
 {
   "symbol": "FDP",
   "name": "Fresh Del Monte Produce, Inc.",
   "last_sale": "35.14",
   "market_cap": "$1.71B",
   "IPOyear": "1997",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/fdp",
   "FIELD9": ""
 },
 {
   "symbol": "RESI",
   "name": "Front Yard Residential Corporation",
   "last_sale": "10.97",
   "market_cap": "$587.57M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/resi",
   "FIELD9": ""
 },
 {
   "symbol": "FRO",
   "name": "Frontline Ltd.",
   "last_sale": "5.46",
   "market_cap": "$927.16M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/fro",
   "FIELD9": ""
 },
 {
   "symbol": "FSIC",
   "name": "FS Investment Corporation",
   "last_sale": "7.15",
   "market_cap": "$1.71B",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/fsic",
   "FIELD9": ""
 },
 {
   "symbol": "FCN",
   "name": "FTI Consulting, Inc.",
   "last_sale": "73.12",
   "market_cap": "$2.78B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/fcn",
   "FIELD9": ""
 },
 {
   "symbol": "FTSI",
   "name": "FTS International, Inc.",
   "last_sale": "11.69",
   "market_cap": "$1.28B",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ftsi",
   "FIELD9": ""
 },
 {
   "symbol": "FF",
   "name": "FutureFuel Corp.",
   "last_sale": "17.28",
   "market_cap": "$755.87M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/ff",
   "FIELD9": ""
 },
 {
   "symbol": "GCV",
   "name": "Gabelli Convertible and Income Securities Fund, Inc. (The)",
   "last_sale": "5.66",
   "market_cap": "$80.96M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gcv",
   "FIELD9": ""
 },
 {
   "symbol": "GCV^B",
   "name": "Gabelli Convertible and Income Securities Fund, Inc. (The)",
   "last_sale": "25.7995",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gcv^b",
   "FIELD9": ""
 },
 {
   "symbol": "GCV~",
   "name": "Gabelli Convertible and Income Securities Fund, Inc. (The)",
   "last_sale": "0.0928",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gcv~",
   "FIELD9": ""
 },
 {
   "symbol": "GDV",
   "name": "Gabelli Dividend",
   "last_sale": "24.23",
   "market_cap": "$2B",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gdv",
   "FIELD9": ""
 },
 {
   "symbol": "GDV^A",
   "name": "Gabelli Dividend",
   "last_sale": "25.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gdv^a",
   "FIELD9": ""
 },
 {
   "symbol": "GDV^D",
   "name": "Gabelli Dividend",
   "last_sale": "25.622",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gdv^d",
   "FIELD9": ""
 },
 {
   "symbol": "GDV^G",
   "name": "Gabelli Dividend",
   "last_sale": "24.7786",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gdv^g",
   "FIELD9": ""
 },
 {
   "symbol": "GAB",
   "name": "Gabelli Equity Trust, Inc. (The)",
   "last_sale": "6.56",
   "market_cap": "$1.65B",
   "IPOyear": "1986",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gab",
   "FIELD9": ""
 },
 {
   "symbol": "GAB^D",
   "name": "Gabelli Equity Trust, Inc. (The)",
   "last_sale": "25.42",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gab^d",
   "FIELD9": ""
 },
 {
   "symbol": "GAB^G",
   "name": "Gabelli Equity Trust, Inc. (The)",
   "last_sale": "23.7775",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gab^g",
   "FIELD9": ""
 },
 {
   "symbol": "GAB^H",
   "name": "Gabelli Equity Trust, Inc. (The)",
   "last_sale": "24.24",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gab^h",
   "FIELD9": ""
 },
 {
   "symbol": "GAB^J",
   "name": "Gabelli Equity Trust, Inc. (The)",
   "last_sale": "25.0115",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gab^j",
   "FIELD9": ""
 },
 {
   "symbol": "GGZ",
   "name": "Gabelli Global Small and Mid Cap Value Trust (The)",
   "last_sale": "12.36",
   "market_cap": "$127.48M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ggz",
   "FIELD9": ""
 },
 {
   "symbol": "GGZ^A",
   "name": "Gabelli Global Small and Mid Cap Value Trust (The)",
   "last_sale": "24.9899",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ggz^a",
   "FIELD9": ""
 },
 {
   "symbol": "GGT",
   "name": "Gabelli Multi-Media Trust Inc. (The)",
   "last_sale": "9.25",
   "market_cap": "$224.59M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ggt",
   "FIELD9": ""
 },
 {
   "symbol": "GGT^B",
   "name": "Gabelli Multi-Media Trust Inc. (The)",
   "last_sale": "25.7216",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ggt^b",
   "FIELD9": ""
 },
 {
   "symbol": "GGT^E",
   "name": "Gabelli Multi-Media Trust Inc. (The)",
   "last_sale": "23.6826",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ggt^e",
   "FIELD9": ""
 },
 {
   "symbol": "GUT",
   "name": "Gabelli Utility Trust (The)",
   "last_sale": "5.83",
   "market_cap": "$308.92M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gut",
   "FIELD9": ""
 },
 {
   "symbol": "GUT^A",
   "name": "Gabelli Utility Trust (The)",
   "last_sale": "25.4",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gut^a",
   "FIELD9": ""
 },
 {
   "symbol": "GUT^C",
   "name": "Gabelli Utility Trust (The)",
   "last_sale": "24.9605",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gut^c",
   "FIELD9": ""
 },
 {
   "symbol": "GFA",
   "name": "Gafisa SA",
   "last_sale": "5.37",
   "market_cap": "$117.67M",
   "IPOyear": "2007",
   "sector": "Basic Industries",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/gfa",
   "FIELD9": ""
 },
 {
   "symbol": "GCAP",
   "name": "GAIN Capital Holdings, Inc.",
   "last_sale": "6.54",
   "market_cap": "$291.96M",
   "IPOyear": "2010",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/gcap",
   "FIELD9": ""
 },
 {
   "symbol": "GBL",
   "name": "Gamco Investors, Inc.",
   "last_sale": "24.98",
   "market_cap": "$723.48M",
   "IPOyear": "1999",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/gbl",
   "FIELD9": ""
 },
 {
   "symbol": "GNT",
   "name": "GAMCO Natural Resources, Gold & Income Tust ",
   "last_sale": "5.79",
   "market_cap": "$121M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gnt",
   "FIELD9": ""
 },
 {
   "symbol": "GNT^A",
   "name": "GAMCO Natural Resources, Gold & Income Tust ",
   "last_sale": "23.3995",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gnt^a",
   "FIELD9": ""
 },
 {
   "symbol": "GME",
   "name": "Gamestop Corporation",
   "last_sale": "16.52",
   "market_cap": "$1.68B",
   "IPOyear": "2002",
   "sector": "Consumer Services",
   "industry": "Electronics Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/gme",
   "FIELD9": ""
 },
 {
   "symbol": "GPS",
   "name": "Gap, Inc. (The)",
   "last_sale": "27.8",
   "market_cap": "$10.69B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/gps",
   "FIELD9": ""
 },
 {
   "symbol": "GDI",
   "name": "Gardner Denver Holdings, Inc.",
   "last_sale": "29.38",
   "market_cap": "$5.85B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/gdi",
   "FIELD9": ""
 },
 {
   "symbol": "GTX$",
   "name": "Garrett Motion Inc.",
   "last_sale": "16.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gtx$",
   "FIELD9": ""
 },
 {
   "symbol": "IT",
   "name": "Gartner, Inc.",
   "last_sale": "158.45",
   "market_cap": "$14.39B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/it",
   "FIELD9": ""
 },
 {
   "symbol": "GLOG",
   "name": "GasLog LP.",
   "last_sale": "20.05",
   "market_cap": "$1.62B",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/glog",
   "FIELD9": ""
 },
 {
   "symbol": "GLOG^A",
   "name": "GasLog LP.",
   "last_sale": "26.5916",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/glog^a",
   "FIELD9": ""
 },
 {
   "symbol": "GLOP",
   "name": "GasLog Partners LP",
   "last_sale": "24.7",
   "market_cap": "$1.08B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/glop",
   "FIELD9": ""
 },
 {
   "symbol": "GLOP^A",
   "name": "GasLog Partners LP",
   "last_sale": "25.8",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/glop^a",
   "FIELD9": ""
 },
 {
   "symbol": "GLOP^B",
   "name": "GasLog Partners LP",
   "last_sale": "25.46",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/glop^b",
   "FIELD9": ""
 },
 {
   "symbol": "GTES",
   "name": "Gates Industrial Corporation plc",
   "last_sale": "20.21",
   "market_cap": "$5.86B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/gtes",
   "FIELD9": ""
 },
 {
   "symbol": "GATX",
   "name": "GATX Corporation",
   "last_sale": "85.69",
   "market_cap": "$3.23B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gatx",
   "FIELD9": ""
 },
 {
   "symbol": "GMTA",
   "name": "GATX Corporation",
   "last_sale": "25.1597",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gmta",
   "FIELD9": ""
 },
 {
   "symbol": "GZT",
   "name": "Gazit-Globe Ltd.",
   "last_sale": "9.41",
   "market_cap": "$1.82B",
   "IPOyear": "2011",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/gzt",
   "FIELD9": ""
 },
 {
   "symbol": "GCP",
   "name": "GCP Applied Technologies Inc.",
   "last_sale": "26.55",
   "market_cap": "$1.92B",
   "IPOyear": "2016",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/gcp",
   "FIELD9": ""
 },
 {
   "symbol": "GNK",
   "name": "Genco Shipping & Trading Limited ",
   "last_sale": "13.62",
   "market_cap": "$565.87M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/gnk",
   "FIELD9": ""
 },
 {
   "symbol": "GNRC",
   "name": "Generac Holdlings Inc.",
   "last_sale": "57.97",
   "market_cap": "$3.59B",
   "IPOyear": "2010",
   "sector": "Consumer Durables",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/gnrc",
   "FIELD9": ""
 },
 {
   "symbol": "GAM",
   "name": "General American Investors, Inc.",
   "last_sale": "37.26",
   "market_cap": "$959.89M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gam",
   "FIELD9": ""
 },
 {
   "symbol": "GAM^B",
   "name": "General American Investors, Inc.",
   "last_sale": "25.8751",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gam^b",
   "FIELD9": ""
 },
 {
   "symbol": "GD",
   "name": "General Dynamics Corporation",
   "last_sale": "204.66",
   "market_cap": "$60.64B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/gd",
   "FIELD9": ""
 },
 {
   "symbol": "GE",
   "name": "General Electric Company",
   "last_sale": "12.17",
   "market_cap": "$105.77B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/ge",
   "FIELD9": ""
 },
 {
   "symbol": "GIS",
   "name": "General Mills, Inc.",
   "last_sale": "44.46",
   "market_cap": "$26.51B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/gis",
   "FIELD9": ""
 },
 {
   "symbol": "GM",
   "name": "General Motors Company",
   "last_sale": "35.32",
   "market_cap": "$49.83B",
   "IPOyear": "2010",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/gm",
   "FIELD9": ""
 },
 {
   "symbol": "GM.WS.B",
   "name": "General Motors Company",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gm.ws.b",
   "FIELD9": ""
 },
 {
   "symbol": "GCO",
   "name": "Genesco Inc.",
   "last_sale": "47.05",
   "market_cap": "$950.07M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/gco",
   "FIELD9": ""
 },
 {
   "symbol": "GWR",
   "name": "Genesee & Wyoming, Inc.",
   "last_sale": "91.4",
   "market_cap": "$5.49B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/gwr",
   "FIELD9": ""
 },
 {
   "symbol": "GEL",
   "name": "Genesis Energy, L.P.",
   "last_sale": "24.21",
   "market_cap": "$2.97B",
   "IPOyear": "1996",
   "sector": "Energy",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/gel",
   "FIELD9": ""
 },
 {
   "symbol": "GEN           ",
   "name": "Genesis Healthcare, Inc.",
   "last_sale": "1.46",
   "market_cap": "$235.84M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/gen",
   "FIELD9": ""
 },
 {
   "symbol": "GNE",
   "name": "Genie Energy Ltd.",
   "last_sale": "5.5",
   "market_cap": "$145.48M",
   "IPOyear": "2011",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/gne",
   "FIELD9": ""
 },
 {
   "symbol": "GNE^A",
   "name": "Genie Energy Ltd.",
   "last_sale": "7.66",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gne^a",
   "FIELD9": ""
 },
 {
   "symbol": "G",
   "name": "Genpact Limited",
   "last_sale": "30.84",
   "market_cap": "$5.86B",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/g",
   "FIELD9": ""
 },
 {
   "symbol": "GPC",
   "name": "Genuine Parts Company",
   "last_sale": "101.14",
   "market_cap": "$14.84B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/gpc",
   "FIELD9": ""
 },
 {
   "symbol": "GNW",
   "name": "Genworth Financial Inc",
   "last_sale": "4.26",
   "market_cap": "$2.13B",
   "IPOyear": "2004",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/gnw",
   "FIELD9": ""
 },
 {
   "symbol": "GEO",
   "name": "Geo Group Inc (The)",
   "last_sale": "25.03",
   "market_cap": "$3.05B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/geo",
   "FIELD9": ""
 },
 {
   "symbol": "GPRK",
   "name": "Geopark Ltd",
   "last_sale": "19",
   "market_cap": "$1.15B",
   "IPOyear": "2014",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/gprk",
   "FIELD9": ""
 },
 {
   "symbol": "GPJA",
   "name": "Georgia Power Company",
   "last_sale": "24.11",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/gpja",
   "FIELD9": ""
 },
 {
   "symbol": "GGB",
   "name": "Gerdau S.A.",
   "last_sale": "4.21",
   "market_cap": "$7.16B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/ggb",
   "FIELD9": ""
 },
 {
   "symbol": "GTY",
   "name": "Getty Realty Corporation",
   "last_sale": "28.44",
   "market_cap": "$1.15B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/gty",
   "FIELD9": ""
 },
 {
   "symbol": "GIG",
   "name": "GigCapital, Inc.",
   "last_sale": "9.9",
   "market_cap": "$40.52M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gig",
   "FIELD9": ""
 },
 {
   "symbol": "GIG.U",
   "name": "GigCapital, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gig.u",
   "FIELD9": ""
 },
 {
   "symbol": "GIG.WS",
   "name": "GigCapital, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gig.ws",
   "FIELD9": ""
 },
 {
   "symbol": "GIG~",
   "name": "GigCapital, Inc.",
   "last_sale": "0.49",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gig~",
   "FIELD9": ""
 },
 {
   "symbol": "GIL",
   "name": "Gildan Activewear, Inc.",
   "last_sale": "30.36",
   "market_cap": "$6.31B",
   "IPOyear": "1998",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/gil",
   "FIELD9": ""
 },
 {
   "symbol": "GLT",
   "name": "Glatfelter",
   "last_sale": "19.92",
   "market_cap": "$872.08M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/glt",
   "FIELD9": ""
 },
 {
   "symbol": "GKOS",
   "name": "Glaukos Corporation",
   "last_sale": "58.84",
   "market_cap": "$2.07B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/gkos",
   "FIELD9": ""
 },
 {
   "symbol": "GSK",
   "name": "GlaxoSmithKline PLC",
   "last_sale": "40.3",
   "market_cap": "$99.95B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/gsk",
   "FIELD9": ""
 },
 {
   "symbol": "BRSS",
   "name": "Global Brass and Copper Holdings, Inc.",
   "last_sale": "36.95",
   "market_cap": "$819.32M",
   "IPOyear": "2013",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/brss",
   "FIELD9": ""
 },
 {
   "symbol": "CO",
   "name": "Global Cord Blood Corporation",
   "last_sale": "6.37",
   "market_cap": "$769.65M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/co",
   "FIELD9": ""
 },
 {
   "symbol": "GMRE",
   "name": "Global Medical REIT Inc.",
   "last_sale": "9.26",
   "market_cap": "$200.3M",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/gmre",
   "FIELD9": ""
 },
 {
   "symbol": "GMRE^A",
   "name": "Global Medical REIT Inc.",
   "last_sale": "25.2109",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gmre^a",
   "FIELD9": ""
 },
 {
   "symbol": "GNL",
   "name": "Global Net Lease, Inc.",
   "last_sale": "20.7",
   "market_cap": "$1.49B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/gnl",
   "FIELD9": ""
 },
 {
   "symbol": "GNL^A",
   "name": "Global Net Lease, Inc.",
   "last_sale": "25.1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gnl^a",
   "FIELD9": ""
 },
 {
   "symbol": "GLP",
   "name": "Global Partners LP",
   "last_sale": "18.35",
   "market_cap": "$623.82M",
   "IPOyear": "2005",
   "sector": "Energy",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/glp",
   "FIELD9": ""
 },
 {
   "symbol": "GLP^A",
   "name": "Global Partners LP",
   "last_sale": "25.4999",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/glp^a",
   "FIELD9": ""
 },
 {
   "symbol": "GPN",
   "name": "Global Payments Inc.",
   "last_sale": "127.19",
   "market_cap": "$20.12B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gpn",
   "FIELD9": ""
 },
 {
   "symbol": "GSL",
   "name": "Global Ship Lease, Inc.",
   "last_sale": "1.0095",
   "market_cap": "$55.54M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/gsl",
   "FIELD9": ""
 },
 {
   "symbol": "GSL^B",
   "name": "Global Ship Lease, Inc.",
   "last_sale": "24.3668",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gsl^b",
   "FIELD9": ""
 },
 {
   "symbol": "GLOB",
   "name": "Globant S.A.",
   "last_sale": "56.47",
   "market_cap": "$2.02B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/glob",
   "FIELD9": ""
 },
 {
   "symbol": "GMED",
   "name": "Globus Medical, Inc.",
   "last_sale": "54.1",
   "market_cap": "$5.32B",
   "IPOyear": "2012",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/gmed",
   "FIELD9": ""
 },
 {
   "symbol": "GMS",
   "name": "GMS Inc.",
   "last_sale": "25.14",
   "market_cap": "$1.03B",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/gms",
   "FIELD9": ""
 },
 {
   "symbol": "GNC",
   "name": "GNC Holdings, Inc.",
   "last_sale": "3.96",
   "market_cap": "$332.2M",
   "IPOyear": "2011",
   "sector": "Consumer Non-Durables",
   "industry": "Food Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/gnc",
   "FIELD9": ""
 },
 {
   "symbol": "GDDY",
   "name": "GoDaddy Inc.",
   "last_sale": "80.4",
   "market_cap": "$13.85B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gddy",
   "FIELD9": ""
 },
 {
   "symbol": "GOL",
   "name": "Gol Linhas Aereas Inteligentes S.A.",
   "last_sale": "5.66",
   "market_cap": "$8.86B",
   "IPOyear": "2004",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gol",
   "FIELD9": ""
 },
 {
   "symbol": "GFI",
   "name": "Gold Fields Limited",
   "last_sale": "2.44",
   "market_cap": "$2B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/gfi",
   "FIELD9": ""
 },
 {
   "symbol": "GG",
   "name": "Goldcorp Inc.",
   "last_sale": "10.6",
   "market_cap": "$9.21B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/gg",
   "FIELD9": ""
 },
 {
   "symbol": "GSBD",
   "name": "Goldman Sachs BDC, Inc.",
   "last_sale": "22.5",
   "market_cap": "$904.41M",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gsbd",
   "FIELD9": ""
 },
 {
   "symbol": "GS",
   "name": "Goldman Sachs Group, Inc. (The)",
   "last_sale": "235.34",
   "market_cap": "$88.85B",
   "IPOyear": "1999",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/gs",
   "FIELD9": ""
 },
 {
   "symbol": "GS^A",
   "name": "Goldman Sachs Group, Inc. (The)",
   "last_sale": "22.8763",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gs^a",
   "FIELD9": ""
 },
 {
   "symbol": "GS^B",
   "name": "Goldman Sachs Group, Inc. (The)",
   "last_sale": "26.57",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gs^b",
   "FIELD9": ""
 },
 {
   "symbol": "GS^C",
   "name": "Goldman Sachs Group, Inc. (The)",
   "last_sale": "23.3632",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gs^c",
   "FIELD9": ""
 },
 {
   "symbol": "GS^D",
   "name": "Goldman Sachs Group, Inc. (The)",
   "last_sale": "22.629",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gs^d",
   "FIELD9": ""
 },
 {
   "symbol": "GS^J",
   "name": "Goldman Sachs Group, Inc. (The)",
   "last_sale": "25.59",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gs^j",
   "FIELD9": ""
 },
 {
   "symbol": "GS^K",
   "name": "Goldman Sachs Group, Inc. (The)",
   "last_sale": "26.79",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gs^k",
   "FIELD9": ""
 },
 {
   "symbol": "GS^N",
   "name": "Goldman Sachs Group, Inc. (The)",
   "last_sale": "26.09",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gs^n",
   "FIELD9": ""
 },
 {
   "symbol": "GER",
   "name": "Goldman Sachs MLP Energy Renaissance Fund",
   "last_sale": "6.5",
   "market_cap": "$516.59M",
   "IPOyear": "1986",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ger",
   "FIELD9": ""
 },
 {
   "symbol": "GMZ",
   "name": "Goldman Sachs MLP Income Opportunities Fund",
   "last_sale": "9.24",
   "market_cap": "$410.52M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gmz",
   "FIELD9": ""
 },
 {
   "symbol": "GRC",
   "name": "Gorman-Rupp Company (The)",
   "last_sale": "38.15",
   "market_cap": "$996.37M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Fluid Controls",
   "summary_quote": "https://www.nasdaq.com/symbol/grc",
   "FIELD9": ""
 },
 {
   "symbol": "GPX",
   "name": "GP Strategies Corporation",
   "last_sale": "18.8",
   "market_cap": "$310.86M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gpx",
   "FIELD9": ""
 },
 {
   "symbol": "GGG",
   "name": "Graco Inc.",
   "last_sale": "46.95",
   "market_cap": "$7.85B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Fluid Controls",
   "summary_quote": "https://www.nasdaq.com/symbol/ggg",
   "FIELD9": ""
 },
 {
   "symbol": "EAF",
   "name": "GrafTech International Ltd.",
   "last_sale": "19.98",
   "market_cap": "$5.8B",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/eaf",
   "FIELD9": ""
 },
 {
   "symbol": "GHM",
   "name": "Graham Corporation",
   "last_sale": "28.1",
   "market_cap": "$276.26M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/ghm",
   "FIELD9": ""
 },
 {
   "symbol": "GHC",
   "name": "Graham Holdings Company",
   "last_sale": "582.35",
   "market_cap": "$3.11B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ghc",
   "FIELD9": ""
 },
 {
   "symbol": "GPT",
   "name": "Gramercy Property Trust",
   "last_sale": "27.42",
   "market_cap": "$4.41B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/gpt",
   "FIELD9": ""
 },
 {
   "symbol": "GPT^A",
   "name": "Gramercy Property Trust Inc.",
   "last_sale": "25.0071",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gpt^a",
   "FIELD9": ""
 },
 {
   "symbol": "GRAM",
   "name": "Grana y Montero S.A.A.",
   "last_sale": "2.69",
   "market_cap": "$355.11M",
   "IPOyear": "2018",
   "sector": "Basic Industries",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/gram",
   "FIELD9": ""
 },
 {
   "symbol": "GVA",
   "name": "Granite Construction Incorporated",
   "last_sale": "46.2",
   "market_cap": "$2.11B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/gva",
   "FIELD9": ""
 },
 {
   "symbol": "GPMT",
   "name": "Granite Point Mortgage Trust Inc.",
   "last_sale": "19.32",
   "market_cap": "$839.57M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/gpmt",
   "FIELD9": ""
 },
 {
   "symbol": "GRP.U",
   "name": "Granite Real Estate Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/grp.u",
   "FIELD9": ""
 },
 {
   "symbol": "GPK",
   "name": "Graphic Packaging Holding Company",
   "last_sale": "14.69",
   "market_cap": "$4.56B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/gpk",
   "FIELD9": ""
 },
 {
   "symbol": "GTN",
   "name": "Gray Television, Inc.",
   "last_sale": "17.65",
   "market_cap": "$1.57B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/gtn",
   "FIELD9": ""
 },
 {
   "symbol": "GTN.A",
   "name": "Gray Television, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gtn.a",
   "FIELD9": ""
 },
 {
   "symbol": "AJX",
   "name": "Great Ajax Corp.",
   "last_sale": "13.7",
   "market_cap": "$257.86M",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ajx",
   "FIELD9": ""
 },
 {
   "symbol": "AJXA",
   "name": "Great Ajax Corp.",
   "last_sale": "25.3985",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ajxa",
   "FIELD9": ""
 },
 {
   "symbol": "GWB",
   "name": "Great Western Bancorp, Inc.",
   "last_sale": "43.68",
   "market_cap": "$2.57B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/gwb",
   "FIELD9": ""
 },
 {
   "symbol": "GDOT",
   "name": "Green Dot Corporation",
   "last_sale": "87.25",
   "market_cap": "$4.59B",
   "IPOyear": "2010",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gdot",
   "FIELD9": ""
 },
 {
   "symbol": "GBX",
   "name": "Greenbrier Companies, Inc. (The)",
   "last_sale": "60.3",
   "market_cap": "$1.94B",
   "IPOyear": "1994",
   "sector": "Capital Goods",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/gbx",
   "FIELD9": ""
 },
 {
   "symbol": "GHL",
   "name": "Greenhill & Co., Inc.",
   "last_sale": "27.75",
   "market_cap": "$626.19M",
   "IPOyear": "2004",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/ghl",
   "FIELD9": ""
 },
 {
   "symbol": "GHG",
   "name": "GreenTree Hospitality Group Ltd.",
   "last_sale": "13.01",
   "market_cap": "$1.32B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/ghg",
   "FIELD9": ""
 },
 {
   "symbol": "GEF",
   "name": "Greif Bros. Corporation",
   "last_sale": "58.55",
   "market_cap": "$3.45B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gef",
   "FIELD9": ""
 },
 {
   "symbol": "GEF.B",
   "name": "Greif Bros. Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gef.b",
   "FIELD9": ""
 },
 {
   "symbol": "GFF",
   "name": "Griffon Corporation",
   "last_sale": "17.05",
   "market_cap": "$777.74M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Building Products",
   "summary_quote": "https://www.nasdaq.com/symbol/gff",
   "FIELD9": ""
 },
 {
   "symbol": "GPI",
   "name": "Group 1 Automotive, Inc.",
   "last_sale": "70.9",
   "market_cap": "$1.41B",
   "IPOyear": "1997",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/gpi",
   "FIELD9": ""
 },
 {
   "symbol": "GRUB",
   "name": "GrubHub Inc.",
   "last_sale": "135.75",
   "market_cap": "$12.28B",
   "IPOyear": "2014",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/grub",
   "FIELD9": ""
 },
 {
   "symbol": "PAC",
   "name": "Grupo Aeroportuario Del Pacifico, S.A. de C.V.",
   "last_sale": "105.12",
   "market_cap": "$5.9B",
   "IPOyear": "2006",
   "sector": "Transportation",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/pac",
   "FIELD9": ""
 },
 {
   "symbol": "ASR",
   "name": "Grupo Aeroportuario del Sureste, S.A. de C.V.",
   "last_sale": "203.89",
   "market_cap": "$6.12B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/asr",
   "FIELD9": ""
 },
 {
   "symbol": "AVAL",
   "name": "Grupo Aval Acciones y Valores S.A.",
   "last_sale": "7.52",
   "market_cap": "$8.38B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/aval",
   "FIELD9": ""
 },
 {
   "symbol": "SUPV",
   "name": "Grupo Supervielle S.A.",
   "last_sale": "9.34",
   "market_cap": "$853.16M",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/supv",
   "FIELD9": ""
 },
 {
   "symbol": "TV",
   "name": "Grupo Televisa S.A.",
   "last_sale": "18.52",
   "market_cap": "$10.79B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/tv",
   "FIELD9": ""
 },
 {
   "symbol": "GSAH",
   "name": "GS Acquisition Holdings Corp.",
   "last_sale": "9.75",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gsah",
   "FIELD9": ""
 },
 {
   "symbol": "GSAH.U",
   "name": "GS Acquisition Holdings Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gsah.u",
   "FIELD9": ""
 },
 {
   "symbol": "GSAH.WS",
   "name": "GS Acquisition Holdings Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gsah.ws",
   "FIELD9": ""
 },
 {
   "symbol": "GTT",
   "name": "GTT Communications, Inc.",
   "last_sale": "46.35",
   "market_cap": "$2.53B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/gtt",
   "FIELD9": ""
 },
 {
   "symbol": "GSH",
   "name": "Guangshen Railway Company Limited",
   "last_sale": "22.55",
   "market_cap": "$3.19B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/gsh",
   "FIELD9": ""
 },
 {
   "symbol": "GES",
   "name": "Guess?, Inc.",
   "last_sale": "22.63",
   "market_cap": "$1.83B",
   "IPOyear": "1996",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/ges",
   "FIELD9": ""
 },
 {
   "symbol": "GGM",
   "name": "Guggenheim Credit Allocation Fund",
   "last_sale": "21.9",
   "market_cap": "$161.5M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ggm",
   "FIELD9": ""
 },
 {
   "symbol": "GPM",
   "name": "Guggenheim Enhanced Equity Income Fund",
   "last_sale": "8.89",
   "market_cap": "$427.56M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gpm",
   "FIELD9": ""
 },
 {
   "symbol": "GOF",
   "name": "Guggenheim Strategic Opportunities Fund",
   "last_sale": "21.28",
   "market_cap": "$635.85M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gof",
   "FIELD9": ""
 },
 {
   "symbol": "GBAB",
   "name": "Guggenheim Taxable Municipal Managed Duration Trst",
   "last_sale": "21.4109",
   "market_cap": "$372.9M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gbab",
   "FIELD9": ""
 },
 {
   "symbol": "GWRE",
   "name": "Guidewire Software, Inc.",
   "last_sale": "98.7",
   "market_cap": "$7.92B",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/gwre",
   "FIELD9": ""
 },
 {
   "symbol": "HRB",
   "name": "H&R Block, Inc.",
   "last_sale": "26.12",
   "market_cap": "$5.37B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hrb",
   "FIELD9": ""
 },
 {
   "symbol": "FUL",
   "name": "H. B. Fuller Company",
   "last_sale": "58.31",
   "market_cap": "$2.95B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/ful",
   "FIELD9": ""
 },
 {
   "symbol": "HAE",
   "name": "Haemonetics Corporation",
   "last_sale": "111.57",
   "market_cap": "$5.77B",
   "IPOyear": "1991",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/hae",
   "FIELD9": ""
 },
 {
   "symbol": "HK",
   "name": "Halcon Resources Corporation",
   "last_sale": "4.58",
   "market_cap": "$735.8M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/hk",
   "FIELD9": ""
 },
 {
   "symbol": "HK.WS",
   "name": "Halcon Resources Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hk.ws",
   "FIELD9": ""
 },
 {
   "symbol": "HAL",
   "name": "Halliburton Company",
   "last_sale": "40.71",
   "market_cap": "$35.82B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/hal",
   "FIELD9": ""
 },
 {
   "symbol": "HBB",
   "name": "Hamilton Beach Brands Holding Company",
   "last_sale": "24.05",
   "market_cap": "$329.58M",
   "IPOyear": "2017",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/hbb",
   "FIELD9": ""
 },
 {
   "symbol": "HBI",
   "name": "Hanesbrands Inc.",
   "last_sale": "18.7",
   "market_cap": "$6.74B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/hbi",
   "FIELD9": ""
 },
 {
   "symbol": "HNGR",
   "name": "Hanger, Inc.",
   "last_sale": "21.57",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/hngr",
   "FIELD9": ""
 },
 {
   "symbol": "HASI",
   "name": "Hannon Armstrong Sustainable Infrastructure Capital, Inc.",
   "last_sale": "21.7",
   "market_cap": "$1.17B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/hasi",
   "FIELD9": ""
 },
 {
   "symbol": "HOG",
   "name": "Harley-Davidson, Inc.",
   "last_sale": "45.35",
   "market_cap": "$7.55B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Motor Vehicles",
   "summary_quote": "https://www.nasdaq.com/symbol/hog",
   "FIELD9": ""
 },
 {
   "symbol": "HMY",
   "name": "Harmony Gold Mining Company Limited",
   "last_sale": "1.87",
   "market_cap": "$935.47M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/hmy",
   "FIELD9": ""
 },
 {
   "symbol": "HRS",
   "name": "Harris Corporation",
   "last_sale": "164.28",
   "market_cap": "$19.3B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/hrs",
   "FIELD9": ""
 },
 {
   "symbol": "HSC",
   "name": "Harsco Corporation",
   "last_sale": "28.55",
   "market_cap": "$2.31B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/hsc",
   "FIELD9": ""
 },
 {
   "symbol": "HHS",
   "name": "Harte-Hanks, Inc.",
   "last_sale": "7.12",
   "market_cap": "$44.51M",
   "IPOyear": "1993",
   "sector": "Technology",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/hhs",
   "FIELD9": ""
 },
 {
   "symbol": "HGH",
   "name": "Hartford Financial Services Group, Inc. (The)",
   "last_sale": "28.45",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/hgh",
   "FIELD9": ""
 },
 {
   "symbol": "HIG",
   "name": "Hartford Financial Services Group, Inc. (The)",
   "last_sale": "50.92",
   "market_cap": "$18.25B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/hig",
   "FIELD9": ""
 },
 {
   "symbol": "HIG.WS",
   "name": "Hartford Financial Services Group, Inc. (The)",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hig.ws",
   "FIELD9": ""
 },
 {
   "symbol": "HVT",
   "name": "Haverty Furniture Companies, Inc.",
   "last_sale": "21.95",
   "market_cap": "$460.25M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/hvt",
   "FIELD9": ""
 },
 {
   "symbol": "HVT.A",
   "name": "Haverty Furniture Companies, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hvt.a",
   "FIELD9": ""
 },
 {
   "symbol": "HE",
   "name": "Hawaiian Electric Industries, Inc.",
   "last_sale": "35.3",
   "market_cap": "$3.84B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/he",
   "FIELD9": ""
 },
 {
   "symbol": "HE^U",
   "name": "Hawaiian Electric Industries, Inc.",
   "last_sale": "26.77",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/he^u",
   "FIELD9": ""
 },
 {
   "symbol": "HCHC",
   "name": "HC2 Holdings, Inc.",
   "last_sale": "5.93",
   "market_cap": "$265.12M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/hchc",
   "FIELD9": ""
 },
 {
   "symbol": "HCA",
   "name": "HCA Healthcare, Inc.",
   "last_sale": "133.37",
   "market_cap": "$46.15B",
   "IPOyear": "2011",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/hca",
   "FIELD9": ""
 },
 {
   "symbol": "HCI",
   "name": "HCI Group, Inc.",
   "last_sale": "42.85",
   "market_cap": "$397.84M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/hci",
   "FIELD9": ""
 },
 {
   "symbol": "HCP",
   "name": "HCP, Inc.",
   "last_sale": "26.39",
   "market_cap": "$12.4B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/hcp",
   "FIELD9": ""
 },
 {
   "symbol": "HDB",
   "name": "HDFC Bank Limited",
   "last_sale": "93.69",
   "market_cap": "$84.79B",
   "IPOyear": "2001",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hdb",
   "FIELD9": ""
 },
 {
   "symbol": "HR",
   "name": "Healthcare Realty Trust Incorporated",
   "last_sale": "29.52",
   "market_cap": "$3.7B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/hr",
   "FIELD9": ""
 },
 {
   "symbol": "HTA",
   "name": "Healthcare Trust of America, Inc.",
   "last_sale": "26.76",
   "market_cap": "$5.55B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/hta",
   "FIELD9": ""
 },
 {
   "symbol": "HL",
   "name": "Hecla Mining Company",
   "last_sale": "2.98",
   "market_cap": "$1.42B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/hl",
   "FIELD9": ""
 },
 {
   "symbol": "HL^B",
   "name": "Hecla Mining Company",
   "last_sale": "54.74",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/hl^b",
   "FIELD9": ""
 },
 {
   "symbol": "HEI",
   "name": "Heico Corporation",
   "last_sale": "91.21",
   "market_cap": "$12.12B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/hei",
   "FIELD9": ""
 },
 {
   "symbol": "HEI.A",
   "name": "Heico Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hei.a",
   "FIELD9": ""
 },
 {
   "symbol": "HLX",
   "name": "Helix Energy Solutions Group, Inc.",
   "last_sale": "9.74",
   "market_cap": "$1.44B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/hlx",
   "FIELD9": ""
 },
 {
   "symbol": "HP",
   "name": "Helmerich & Payne, Inc.",
   "last_sale": "67.28",
   "market_cap": "$7.33B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/hp",
   "FIELD9": ""
 },
 {
   "symbol": "HLF",
   "name": "Herbalife Nutrition Ltd.",
   "last_sale": "54.98",
   "market_cap": "$8.64B",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Other Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/hlf",
   "FIELD9": ""
 },
 {
   "symbol": "HRI",
   "name": "Herc Holdings Inc.",
   "last_sale": "51.57",
   "market_cap": "$1.47B",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hri",
   "FIELD9": ""
 },
 {
   "symbol": "HCXZ",
   "name": "Hercules Capital, Inc.",
   "last_sale": "24.65",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hcxz",
   "FIELD9": ""
 },
 {
   "symbol": "HTGC",
   "name": "Hercules Capital, Inc.",
   "last_sale": "13.29",
   "market_cap": "$1.27B",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/htgc",
   "FIELD9": ""
 },
 {
   "symbol": "HTGX",
   "name": "Hercules Capital, Inc.",
   "last_sale": "25.25",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/htgx",
   "FIELD9": ""
 },
 {
   "symbol": "HRTG",
   "name": "Heritage Insurance Holdings, Inc.",
   "last_sale": "15.69",
   "market_cap": "$416.88M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/hrtg",
   "FIELD9": ""
 },
 {
   "symbol": "HT",
   "name": "Hersha Hospitality Trust",
   "last_sale": "22.87",
   "market_cap": "$900.62M",
   "IPOyear": "1999",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ht",
   "FIELD9": ""
 },
 {
   "symbol": "HT^C",
   "name": "Hersha Hospitality Trust",
   "last_sale": "24.7579",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ht^c",
   "FIELD9": ""
 },
 {
   "symbol": "HT^D",
   "name": "Hersha Hospitality Trust",
   "last_sale": "23.701",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ht^d",
   "FIELD9": ""
 },
 {
   "symbol": "HT^E",
   "name": "Hersha Hospitality Trust",
   "last_sale": "23.57",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ht^e",
   "FIELD9": ""
 },
 {
   "symbol": "HSY",
   "name": "Hershey Company (The)",
   "last_sale": "103.9",
   "market_cap": "$21.75B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Specialty Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/hsy",
   "FIELD9": ""
 },
 {
   "symbol": "HTZ",
   "name": "Hertz Global Holdings, Inc",
   "last_sale": "18.23",
   "market_cap": "$1.53B",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Rental/Leasing Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/htz",
   "FIELD9": ""
 },
 {
   "symbol": "HES",
   "name": "Hess Corporation",
   "last_sale": "70.51",
   "market_cap": "$21.13B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/hes",
   "FIELD9": ""
 },
 {
   "symbol": "HES^A",
   "name": "Hess Corporation",
   "last_sale": "78.4275",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hes^a",
   "FIELD9": ""
 },
 {
   "symbol": "HESM",
   "name": "Hess Midstream Partners LP",
   "last_sale": "22.88",
   "market_cap": "$1.25B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/hesm",
   "FIELD9": ""
 },
 {
   "symbol": "HPE",
   "name": "Hewlett Packard Enterprise Company",
   "last_sale": "17.02",
   "market_cap": "$25.05B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Computer Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/hpe",
   "FIELD9": ""
 },
 {
   "symbol": "HXL",
   "name": "Hexcel Corporation",
   "last_sale": "68.26",
   "market_cap": "$5.97B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/hxl",
   "FIELD9": ""
 },
 {
   "symbol": "HF",
   "name": "HFF, Inc.",
   "last_sale": "44.12",
   "market_cap": "$1.73B",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/hf",
   "FIELD9": ""
 },
 {
   "symbol": "HCLP",
   "name": "Hi-Crush Partners LP",
   "last_sale": "12.55",
   "market_cap": "$1.13B",
   "IPOyear": "2012",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/hclp",
   "FIELD9": ""
 },
 {
   "symbol": "PCF",
   "name": "High Income Securities Fund",
   "last_sale": "9.39",
   "market_cap": "$121.85M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pcf",
   "FIELD9": ""
 },
 {
   "symbol": "HFRO",
   "name": "Highland Floating Rate Opportunities Fund",
   "last_sale": "15.46",
   "market_cap": "$1.11B",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hfro",
   "FIELD9": ""
 },
 {
   "symbol": "HPR",
   "name": "HighPoint Resources Corporation",
   "last_sale": "5.18",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/hpr",
   "FIELD9": ""
 },
 {
   "symbol": "HIW",
   "name": "Highwoods Properties, Inc.",
   "last_sale": "48.01",
   "market_cap": "$4.97B",
   "IPOyear": "1994",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/hiw",
   "FIELD9": ""
 },
 {
   "symbol": "HI",
   "name": "Hillenbrand Inc",
   "last_sale": "52.15",
   "market_cap": "$3.25B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Miscellaneous manufacturing industries",
   "summary_quote": "https://www.nasdaq.com/symbol/hi",
   "FIELD9": ""
 },
 {
   "symbol": "HRC",
   "name": "Hill-Rom Holdings Inc",
   "last_sale": "91.33",
   "market_cap": "$6.06B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/hrc",
   "FIELD9": ""
 },
 {
   "symbol": "HTH",
   "name": "Hilltop Holdings Inc.",
   "last_sale": "21.06",
   "market_cap": "$1.99B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/hth",
   "FIELD9": ""
 },
 {
   "symbol": "HGV",
   "name": "Hilton Grand Vacations Inc.",
   "last_sale": "33.24",
   "market_cap": "$3.22B",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/hgv",
   "FIELD9": ""
 },
 {
   "symbol": "HLT",
   "name": "Hilton Worldwide Holdings Inc.",
   "last_sale": "80.96",
   "market_cap": "$24.14B",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/hlt",
   "FIELD9": ""
 },
 {
   "symbol": "HNI",
   "name": "HNI Corporation",
   "last_sale": "44.18",
   "market_cap": "$1.93B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hni",
   "FIELD9": ""
 },
 {
   "symbol": "HMLP",
   "name": "Hoegh LNG Partners LP",
   "last_sale": "18.5",
   "market_cap": "$612.52M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/hmlp",
   "FIELD9": ""
 },
 {
   "symbol": "HMLP^A",
   "name": "Hoegh LNG Partners LP",
   "last_sale": "25.87",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hmlp^a",
   "FIELD9": ""
 },
 {
   "symbol": "HEP",
   "name": "Holly Energy Partners, L.P.",
   "last_sale": "32.55",
   "market_cap": "$3.43B",
   "IPOyear": "2004",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/hep",
   "FIELD9": ""
 },
 {
   "symbol": "HFC",
   "name": "HollyFrontier Corporation",
   "last_sale": "66.88",
   "market_cap": "$11.78B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/hfc",
   "FIELD9": ""
 },
 {
   "symbol": "HD",
   "name": "Home Depot, Inc. (The)",
   "last_sale": "212.39",
   "market_cap": "$243B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/hd",
   "FIELD9": ""
 },
 {
   "symbol": "HMC",
   "name": "Honda Motor Company, Ltd.",
   "last_sale": "30.87",
   "market_cap": "$54.34B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/hmc",
   "FIELD9": ""
 },
 {
   "symbol": "HON",
   "name": "Honeywell International Inc.",
   "last_sale": "167.34",
   "market_cap": "$124.27B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/hon",
   "FIELD9": ""
 },
 {
   "symbol": "HON$",
   "name": "Honeywell International Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hon$",
   "FIELD9": ""
 },
 {
   "symbol": "HMN",
   "name": "Horace Mann Educators Corporation",
   "last_sale": "46.6",
   "market_cap": "$1.91B",
   "IPOyear": "1991",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/hmn",
   "FIELD9": ""
 },
 {
   "symbol": "HZN",
   "name": "Horizon Global Corporation",
   "last_sale": "7.7",
   "market_cap": "$193.24M",
   "IPOyear": "2015",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/hzn",
   "FIELD9": ""
 },
 {
   "symbol": "HTFA",
   "name": "Horizon Technology Finance Corporation",
   "last_sale": "25.6",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/htfa",
   "FIELD9": ""
 },
 {
   "symbol": "HRL",
   "name": "Hormel Foods Corporation",
   "last_sale": "40.01",
   "market_cap": "$21.33B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Meat/Poultry/Fish",
   "summary_quote": "https://www.nasdaq.com/symbol/hrl",
   "FIELD9": ""
 },
 {
   "symbol": "HOS",
   "name": "Hornbeck Offshore Services",
   "last_sale": "4.67",
   "market_cap": "$175.57M",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/hos",
   "FIELD9": ""
 },
 {
   "symbol": "HST",
   "name": "Host Hotels & Resorts, Inc.",
   "last_sale": "21.12",
   "market_cap": "$15.66B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/hst",
   "FIELD9": ""
 },
 {
   "symbol": "HLI",
   "name": "Houlihan Lokey, Inc.",
   "last_sale": "46.57",
   "market_cap": "$3.07B",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/hli",
   "FIELD9": ""
 },
 {
   "symbol": "HOV",
   "name": "Hovnanian Enterprises Inc",
   "last_sale": "1.68",
   "market_cap": "$249.29M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/hov",
   "FIELD9": ""
 },
 {
   "symbol": "HHC",
   "name": "Howard Hughes Corporation (The)",
   "last_sale": "126.7",
   "market_cap": "$5.46B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/hhc",
   "FIELD9": ""
 },
 {
   "symbol": "HPQ",
   "name": "HP Inc.",
   "last_sale": "25.83",
   "market_cap": "$40.87B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/hpq",
   "FIELD9": ""
 },
 {
   "symbol": "HSBC",
   "name": "HSBC Holdings plc",
   "last_sale": "44.92",
   "market_cap": "$178.84B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/hsbc",
   "FIELD9": ""
 },
 {
   "symbol": "HSBC^A",
   "name": "HSBC Holdings plc",
   "last_sale": "25.65",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hsbc^a",
   "FIELD9": ""
 },
 {
   "symbol": "HMI",
   "name": "Huami Corporation",
   "last_sale": "10.67",
   "market_cap": "$634.16M",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/hmi",
   "FIELD9": ""
 },
 {
   "symbol": "HNP",
   "name": "Huaneng Power International, Inc.",
   "last_sale": "26.27",
   "market_cap": "$9.98B",
   "IPOyear": "1994",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/hnp",
   "FIELD9": ""
 },
 {
   "symbol": "HUBB",
   "name": "Hubbell Inc",
   "last_sale": "136.74",
   "market_cap": "$7.49B",
   "IPOyear": "2015",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/hubb",
   "FIELD9": ""
 },
 {
   "symbol": "HUBS",
   "name": "HubSpot, Inc.",
   "last_sale": "145.35",
   "market_cap": "$5.64B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/hubs",
   "FIELD9": ""
 },
 {
   "symbol": "HBM",
   "name": "Hudbay Minerals Inc.",
   "last_sale": "5.15",
   "market_cap": "$1.35B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/hbm",
   "FIELD9": ""
 },
 {
   "symbol": "HUD",
   "name": "Hudson Ltd.",
   "last_sale": "22.74",
   "market_cap": "$2.1B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/hud",
   "FIELD9": ""
 },
 {
   "symbol": "HPP",
   "name": "Hudson Pacific Properties, Inc.",
   "last_sale": "32.2",
   "market_cap": "$5.05B",
   "IPOyear": "2010",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/hpp",
   "FIELD9": ""
 },
 {
   "symbol": "HUM",
   "name": "Humana Inc.",
   "last_sale": "337.76",
   "market_cap": "$46.53B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/hum",
   "FIELD9": ""
 },
 {
   "symbol": "HCFT",
   "name": "Hunt Companies Finance Trust, Inc.",
   "last_sale": "3.67",
   "market_cap": "$86.92M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/hcft",
   "FIELD9": ""
 },
 {
   "symbol": "HCFT^A",
   "name": "Hunt Companies Finance Trust, Inc.",
   "last_sale": "25.34",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hcft^a",
   "FIELD9": ""
 },
 {
   "symbol": "HII",
   "name": "Huntington Ingalls Industries, Inc.",
   "last_sale": "255.71",
   "market_cap": "$11.08B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/hii",
   "FIELD9": ""
 },
 {
   "symbol": "HUN",
   "name": "Huntsman Corporation",
   "last_sale": "28.93",
   "market_cap": "$6.91B",
   "IPOyear": "2005",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/hun",
   "FIELD9": ""
 },
 {
   "symbol": "HUYA",
   "name": "HUYA Inc.",
   "last_sale": "25",
   "market_cap": "$5.09B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/huya",
   "FIELD9": ""
 },

 {
   "symbol": "HY",
   "name": "Hyster-Yale Materials Handling, Inc.",
   "last_sale": "66.48",
   "market_cap": "$1.1B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/hy",
   "FIELD9": ""
 },
 {
   "symbol": "IAG",
   "name": "Iamgold Corporation",
   "last_sale": "3.9",
   "market_cap": "$1.82B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/iag",
   "FIELD9": ""
 },
 {
   "symbol": "IBN",
   "name": "ICICI Bank Limited",
   "last_sale": "8.76",
   "market_cap": "$28.18B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ibn",
   "FIELD9": ""
 },
 {
   "symbol": "IDA",
   "name": "IDACORP, Inc.",
   "last_sale": "99.2",
   "market_cap": "$5B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/ida",
   "FIELD9": ""
 },
 {
   "symbol": "IEX",
   "name": "IDEX Corporation",
   "last_sale": "156.16",
   "market_cap": "$11.97B",
   "IPOyear": "1989",
   "sector": "Capital Goods",
   "industry": "Fluid Controls",
   "summary_quote": "https://www.nasdaq.com/symbol/iex",
   "FIELD9": ""
 },
 {
   "symbol": "IDT",
   "name": "IDT Corporation",
   "last_sale": "5.26",
   "market_cap": "$130.72M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/idt",
   "FIELD9": ""
 },
 {
   "symbol": "ITW",
   "name": "Illinois Tool Works Inc.",
   "last_sale": "148.44",
   "market_cap": "$49.78B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/itw",
   "FIELD9": ""
 },
 {
   "symbol": "IMAX",
   "name": "Imax Corporation",
   "last_sale": "24.9",
   "market_cap": "$1.56B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/imax",
   "FIELD9": ""
 },
 {
   "symbol": "ICD",
   "name": "Independence Contract Drilling, Inc.",
   "last_sale": "4.69",
   "market_cap": "$179.41M",
   "IPOyear": "2014",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/icd",
   "FIELD9": ""
 },
 {
   "symbol": "IHC",
   "name": "Independence Holding Company",
   "last_sale": "33.3",
   "market_cap": "$492.46M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/ihc",
   "FIELD9": ""
 },
 {
   "symbol": "IRT",
   "name": "Independence Realty Trust, Inc.",
   "last_sale": "10.36",
   "market_cap": "$908.12M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/irt",
   "FIELD9": ""
 },
 {
   "symbol": "IFN",
   "name": "India Fund, Inc. (The)",
   "last_sale": "22.75",
   "market_cap": "$623.12M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ifn",
   "FIELD9": ""
 },
 {
   "symbol": "IBA",
   "name": "Industrias Bachoco, S.A. de C.V.",
   "last_sale": "54.38",
   "market_cap": "$2.72B",
   "IPOyear": "1997",
   "sector": "Consumer Non-Durables",
   "industry": "Meat/Poultry/Fish",
   "summary_quote": "https://www.nasdaq.com/symbol/iba",
   "FIELD9": ""
 },
 {
   "symbol": "INFY",
   "name": "Infosys Limited",
   "last_sale": "9.93",
   "market_cap": "$86.76B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/infy",
   "FIELD9": ""
 },
 {
   "symbol": "HIFR",
   "name": "InfraREIT, Inc.",
   "last_sale": "21.06",
   "market_cap": "$925.84M",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/hifr",
   "FIELD9": ""
 },
 {
   "symbol": "ING",
   "name": "ING Group, N.V.",
   "last_sale": "13.67",
   "market_cap": "$53.17B",
   "IPOyear": "1997",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ing",
   "FIELD9": ""
 },
 {
   "symbol": "ISF",
   "name": "ING Group, N.V.",
   "last_sale": "25.57",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/isf",
   "FIELD9": ""
 },
 {
   "symbol": "ISG",
   "name": "ING Group, N.V.",
   "last_sale": "25.76",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/isg",
   "FIELD9": ""
 },
 {
   "symbol": "IR",
   "name": "Ingersoll-Rand plc (Ireland)",
   "last_sale": "104.03",
   "market_cap": "$25.52B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/ir",
   "FIELD9": ""
 },
 {
   "symbol": "NGVT",
   "name": "Ingevity Corporation",
   "last_sale": "104.93",
   "market_cap": "$4.41B",
   "IPOyear": "2016",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/ngvt",
   "FIELD9": ""
 },
 {
   "symbol": "INGR",
   "name": "Ingredion Incorporated",
   "last_sale": "104.15",
   "market_cap": "$7.4B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/ingr",
   "FIELD9": ""
 },
 {
   "symbol": "IIPR",
   "name": "Innovative Industrial Properties, Inc.",
   "last_sale": "47.47",
   "market_cap": "$167.36M",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/iipr",
   "FIELD9": ""
 },
 {
   "symbol": "IIPR^A",
   "name": "Innovative Industrial Properties, Inc.",
   "last_sale": "28.6",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iipr^a",
   "FIELD9": ""
 },
 {
   "symbol": "IPHI",
   "name": "Inphi Corporation",
   "last_sale": "36.65",
   "market_cap": "$1.61B",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/iphi",
   "FIELD9": ""
 },
 {
   "symbol": "INSI",
   "name": "Insight Select Income Fund",
   "last_sale": "18.57",
   "market_cap": "$198.89M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/insi",
   "FIELD9": ""
 },
 {
   "symbol": "NSP",
   "name": "Insperity, Inc.",
   "last_sale": "115",
   "market_cap": "$4.82B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nsp",
   "FIELD9": ""
 },
 {
   "symbol": "INSP",
   "name": "Inspire Medical Systems, Inc.",
   "last_sale": "44.5",
   "market_cap": "$950.25M",
   "IPOyear": "1998",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/insp",
   "FIELD9": ""
 },
 {
   "symbol": "IBP",
   "name": "Installed Building Products, Inc.",
   "last_sale": "45.1",
   "market_cap": "$1.43B",
   "IPOyear": "2014",
   "sector": "Basic Industries",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/ibp",
   "FIELD9": ""
 },
 {
   "symbol": "INST",
   "name": "Instructure, Inc.",
   "last_sale": "37.35",
   "market_cap": "$1.3B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/inst",
   "FIELD9": ""
 },
 {
   "symbol": "ITGR",
   "name": "Integer Holdings Corporation",
   "last_sale": "83.8",
   "market_cap": "$2.7B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/itgr",
   "FIELD9": ""
 },
 {
   "symbol": "I",
   "name": "Intelsat S.A.",
   "last_sale": "22.53",
   "market_cap": "$3.08B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/i",
   "FIELD9": ""
 },
 {
   "symbol": "ICE",
   "name": "Intercontinental Exchange Inc.",
   "last_sale": "77.82",
   "market_cap": "$44.62B",
   "IPOyear": "2005",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/ice",
   "FIELD9": ""
 },
 {
   "symbol": "IHG",
   "name": "Intercontinental Hotels Group",
   "last_sale": "62.58",
   "market_cap": "$11.93B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/ihg",
   "FIELD9": ""
 },
 {
   "symbol": "IBM",
   "name": "International Business Machines Corporation",
   "last_sale": "151.35",
   "market_cap": "$138.15B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/ibm",
   "FIELD9": ""
 },
 {
   "symbol": "IFF",
   "name": "International Flavors & Fragrances, Inc.",
   "last_sale": "140.46",
   "market_cap": "$12.88B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/iff",
   "FIELD9": ""
 },
 {
   "symbol": "IFFT",
   "name": "International Flavors & Fragrances, Inc.",
   "last_sale": "54.13",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ifft",
   "FIELD9": ""
 },
 {
   "symbol": "IGT",
   "name": "International Game Technology",
   "last_sale": "19.5",
   "market_cap": "$3.98B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/igt",
   "FIELD9": ""
 },
 {
   "symbol": "IP",
   "name": "International Paper Company",
   "last_sale": "54.12",
   "market_cap": "$22.13B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/ip",
   "FIELD9": ""
 },
 {
   "symbol": "INSW",
   "name": "International Seaways, Inc.",
   "last_sale": "20.15",
   "market_cap": "$587.95M",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/insw",
   "FIELD9": ""
 },
 {
   "symbol": "INSW^A",
   "name": "International Seaways, Inc.",
   "last_sale": "24.23",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/insw^a",
   "FIELD9": ""
 },
 {
   "symbol": "IPG",
   "name": "Interpublic Group of Companies, Inc. (The)",
   "last_sale": "23.18",
   "market_cap": "$8.9B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/ipg",
   "FIELD9": ""
 },
 {
   "symbol": "IPL^D",
   "name": "Interstate Power and Light Company",
   "last_sale": "24.85",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ipl^d",
   "FIELD9": ""
 },
 {
   "symbol": "INXN",
   "name": "InterXion Holding N.V.",
   "last_sale": "68.75",
   "market_cap": "$4.92B",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/inxn",
   "FIELD9": ""
 },
 {
   "symbol": "IPI",
   "name": "Intrepid Potash, Inc",
   "last_sale": "3.67",
   "market_cap": "$481.16M",
   "IPOyear": "2008",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/ipi",
   "FIELD9": ""
 },
 {
   "symbol": "XON",
   "name": "Intrexon Corporation",
   "last_sale": "14.5",
   "market_cap": "$1.99B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/xon",
   "FIELD9": ""
 },
 {
   "symbol": "IVC",
   "name": "Invacare Corporation",
   "last_sale": "14.75",
   "market_cap": "$490.23M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/ivc",
   "FIELD9": ""
 },
 {
   "symbol": "VBF",
   "name": "Invesco Bond Fund",
   "last_sale": "17.52",
   "market_cap": "$199.33M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vbf",
   "FIELD9": ""
 },
 {
   "symbol": "VCV",
   "name": "Invesco California Value Municipal Income Trust",
   "last_sale": "11.64",
   "market_cap": "$557.15M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vcv",
   "FIELD9": ""
 },
 {
   "symbol": "VTA",
   "name": "Invesco Credit Opportunities Fund",
   "last_sale": "11.5",
   "market_cap": "$852.08M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vta",
   "FIELD9": ""
 },
 {
   "symbol": "IHIT",
   "name": "Invesco High Income 2023 Target Term Fund",
   "last_sale": "9.9",
   "market_cap": "$237.49M",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ihit",
   "FIELD9": ""
 },
 {
   "symbol": "IHTA",
   "name": "Invesco High Income 2024 Target Term Fund",
   "last_sale": "9.4",
   "market_cap": "$82.51M",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ihta",
   "FIELD9": ""
 },
 {
   "symbol": "VLT",
   "name": "Invesco High Income Trust II",
   "last_sale": "13.65",
   "market_cap": "$110.82M",
   "IPOyear": "1989",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vlt",
   "FIELD9": ""
 },
 {
   "symbol": "IVR",
   "name": "INVESCO MORTGAGE CAPITAL INC",
   "last_sale": "16.32",
   "market_cap": "$1.82B",
   "IPOyear": "2009",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ivr",
   "FIELD9": ""
 },
 {
   "symbol": "IVR^B",
   "name": "INVESCO MORTGAGE CAPITAL INC",
   "last_sale": "25.5545",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ivr^b",
   "FIELD9": ""
 },
 {
   "symbol": "IVR^C",
   "name": "INVESCO MORTGAGE CAPITAL INC",
   "last_sale": "24.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ivr^c",
   "FIELD9": ""
 },
 {
   "symbol": "IVR^A",
   "name": "Invesco Mortgage Capital Inc.",
   "last_sale": "25.42",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ivr^a",
   "FIELD9": ""
 },
 {
   "symbol": "OIA",
   "name": "Invesco Municipal Income Opportunities Trust",
   "last_sale": "7.585",
   "market_cap": "$511.34M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/oia",
   "FIELD9": ""
 },
 {
   "symbol": "VMO",
   "name": "Invesco Municipal Opportunity Trust",
   "last_sale": "11.51",
   "market_cap": "$775.94M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vmo",
   "FIELD9": ""
 },
 {
   "symbol": "VKQ",
   "name": "Invesco Municipal Trust",
   "last_sale": "11.41",
   "market_cap": "$631.2M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vkq",
   "FIELD9": ""
 },
 {
   "symbol": "VPV",
   "name": "Invesco Pennsylvania Value Municipal Income Trust",
   "last_sale": "11.81",
   "market_cap": "$281.43M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vpv",
   "FIELD9": ""
 },
 {
   "symbol": "IVZ",
   "name": "Invesco Plc",
   "last_sale": "24.31",
   "market_cap": "$9.99B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/ivz",
   "FIELD9": ""
 },
 {
   "symbol": "IQI",
   "name": "Invesco Quality Municipal Income Trust",
   "last_sale": "11.67",
   "market_cap": "$617.15M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iqi",
   "FIELD9": ""
 },
 {
   "symbol": "VVR",
   "name": "Invesco Senior Income Trust",
   "last_sale": "4.33",
   "market_cap": "$779.56M",
   "IPOyear": "1998",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vvr",
   "FIELD9": ""
 },
 {
   "symbol": "VTN",
   "name": "Invesco Trust  for Investment Grade New York Municipal",
   "last_sale": "12.46",
   "market_cap": "$242.69M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vtn",
   "FIELD9": ""
 },
 {
   "symbol": "VGM",
   "name": "Invesco Trust for Investment Grade Municipals",
   "last_sale": "11.7",
   "market_cap": "$634.44M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vgm",
   "FIELD9": ""
 },
 {
   "symbol": "IIM",
   "name": "Invesco Value Municipal Income Trust",
   "last_sale": "13.86",
   "market_cap": "$652.2M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iim",
   "FIELD9": ""
 },
 {
   "symbol": "ITG",
   "name": "Investment Technology Group, Inc.",
   "last_sale": "22.13",
   "market_cap": "$730.05M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/itg",
   "FIELD9": ""
 },
 {
   "symbol": "IRET",
   "name": "Investors Real Estate Trust",
   "last_sale": "5.61",
   "market_cap": "$670.44M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/iret",
   "FIELD9": ""
 },
 {
   "symbol": "IRET^C",
   "name": "Investors Real Estate Trust",
   "last_sale": "24.7",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iret^c",
   "FIELD9": ""
 },
 {
   "symbol": "NVTA",
   "name": "Invitae Corporation",
   "last_sale": "16.72",
   "market_cap": "$1.15B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/nvta",
   "FIELD9": ""
 },
 {
   "symbol": "INVH",
   "name": "Invitation Homes Inc.",
   "last_sale": "23.94",
   "market_cap": "$12.46B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/invh",
   "FIELD9": ""
 },
 {
   "symbol": "IO",
   "name": "Ion Geophysical Corporation",
   "last_sale": "14.5",
   "market_cap": "$203.04M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/io",
   "FIELD9": ""
 },
 {
   "symbol": "IQV",
   "name": "IQVIA Holdings, Inc.",
   "last_sale": "127.58",
   "market_cap": "$25.85B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Biotechnology: Commercial Physical & Biological Resarch",
   "summary_quote": "https://www.nasdaq.com/symbol/iqv",
   "FIELD9": ""
 },
 {
   "symbol": "IRM",
   "name": "Iron Mountain Incorporated",
   "last_sale": "35.91",
   "market_cap": "$10.28B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/irm",
   "FIELD9": ""
 },
 {
   "symbol": "IRS",
   "name": "IRSA Inversiones Y Representaciones S.A.",
   "last_sale": "17.14",
   "market_cap": "$991.85M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/irs",
   "FIELD9": ""
 },
 {
   "symbol": "ICL",
   "name": "Israel Chemicals Shs",
   "last_sale": "6.22",
   "market_cap": "$7.96B",
   "IPOyear": "2014",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/icl",
   "FIELD9": ""
 },
 {
   "symbol": "STAR          ",
   "name": "iStar Inc.",
   "last_sale": "11.41",
   "market_cap": "$775.52M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/star",
   "FIELD9": ""
 },
 {
   "symbol": "STAR^D",
   "name": "iStar Inc.",
   "last_sale": "25.01",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/star^d",
   "FIELD9": ""
 },
 {
   "symbol": "STAR^G",
   "name": "iStar Inc.",
   "last_sale": "24.55",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/star^g",
   "FIELD9": ""
 },
 {
   "symbol": "STAR^I",
   "name": "iStar Inc.",
   "last_sale": "24.3078",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/star^i",
   "FIELD9": ""
 },
 {
   "symbol": "ITCB",
   "name": "Ita? CorpBanca",
   "last_sale": "15.2",
   "market_cap": "$5.19B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/itcb",
   "FIELD9": ""
 },
 {
   "symbol": "ITUB",
   "name": "Itau Unibanco Banco Holding SA",
   "last_sale": "10.87",
   "market_cap": "$70.39B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/itub",
   "FIELD9": ""
 },
 {
   "symbol": "ITT",
   "name": "ITT Inc.",
   "last_sale": "61.18",
   "market_cap": "$5.36B",
   "IPOyear": "2011",
   "sector": "Capital Goods",
   "industry": "Fluid Controls",
   "summary_quote": "https://www.nasdaq.com/symbol/itt",
   "FIELD9": ""
 },
 {
   "symbol": "IVH",
   "name": "Ivy High Income Opportunities Fund",
   "last_sale": "14.22",
   "market_cap": "$235.63M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ivh",
   "FIELD9": ""
 },
 {
   "symbol": "JPM",
   "name": "J P Morgan Chase & Co",
   "last_sale": "117.85",
   "market_cap": "$396.08B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/jpm",
   "FIELD9": ""
 },
 {
   "symbol": "JPM.WS",
   "name": "J P Morgan Chase & Co",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jpm.ws",
   "FIELD9": ""
 },
 {
   "symbol": "JPM^A",
   "name": "J P Morgan Chase & Co",
   "last_sale": "24.9898",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/jpm^a",
   "FIELD9": ""
 },
 {
   "symbol": "JPM^B",
   "name": "J P Morgan Chase & Co",
   "last_sale": "25.67",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jpm^b",
   "FIELD9": ""
 },
 {
   "symbol": "JPM^E",
   "name": "J P Morgan Chase & Co",
   "last_sale": "25.82",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jpm^e",
   "FIELD9": ""
 },
 {
   "symbol": "JPM^F",
   "name": "J P Morgan Chase & Co",
   "last_sale": "25.78",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jpm^f",
   "FIELD9": ""
 },
 {
   "symbol": "JPM^G",
   "name": "J P Morgan Chase & Co",
   "last_sale": "25.81",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jpm^g",
   "FIELD9": ""
 },
 {
   "symbol": "JPM^H",
   "name": "J P Morgan Chase & Co",
   "last_sale": "25.85",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/jpm^h",
   "FIELD9": ""
 },
 {
   "symbol": "JAX",
   "name": "J. Alexander&#39;s Holdings, Inc.",
   "last_sale": "13.2",
   "market_cap": "$193.98M",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/jax",
   "FIELD9": ""
 },
 {
   "symbol": "JILL",
   "name": "J. Jill, Inc.",
   "last_sale": "5.92",
   "market_cap": "$258.99M",
   "IPOyear": "2017",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/jill",
   "FIELD9": ""
 },
 {
   "symbol": "JCP",
   "name": "J.C. Penney Company, Inc. Holding Company",
   "last_sale": "2.02",
   "market_cap": "$636.09M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/jcp",
   "FIELD9": ""
 },
 {
   "symbol": "SJM",
   "name": "J.M. Smucker Company (The)",
   "last_sale": "110.16",
   "market_cap": "$12.53B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/sjm",
   "FIELD9": ""
 },
 {
   "symbol": "JBL",
   "name": "Jabil Inc.",
   "last_sale": "29.86",
   "market_cap": "$5.03B",
   "IPOyear": "1993",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/jbl",
   "FIELD9": ""
 },
 {
   "symbol": "JEC",
   "name": "Jacobs Engineering Group Inc.",
   "last_sale": "77.61",
   "market_cap": "$11.01B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/jec",
   "FIELD9": ""
 },
 {
   "symbol": "JAG",
   "name": "Jagged Peak Energy Inc.",
   "last_sale": "13.91",
   "market_cap": "$2.97B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/jag",
   "FIELD9": ""
 },
 {
   "symbol": "JHX",
   "name": "James Hardie Industries plc.",
   "last_sale": "15.19",
   "market_cap": "$6.71B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/jhx",
   "FIELD9": ""
 },
 {
   "symbol": "JHG",
   "name": "Janus Henderson Group plc",
   "last_sale": "27.93",
   "market_cap": "$5.47B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/jhg",
   "FIELD9": ""
 },
 {
   "symbol": "JOF",
   "name": "Japan Smaller Capitalization Fund Inc",
   "last_sale": "10.84",
   "market_cap": "$307.14M",
   "IPOyear": "1990",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jof",
   "FIELD9": ""
 },
 {
   "symbol": "JBGS",
   "name": "JBG SMITH Properties",
   "last_sale": "37.55",
   "market_cap": "$4.52B",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/jbgs",
   "FIELD9": ""
 },
 {
   "symbol": "JEF",
   "name": "Jefferies Financial Group Inc.",
   "last_sale": "23.52",
   "market_cap": "$7.84B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Meat/Poultry/Fish",
   "summary_quote": "https://www.nasdaq.com/symbol/jef",
   "FIELD9": ""
 },
 {
   "symbol": "JELD",
   "name": "JELD-WEN Holding, Inc.",
   "last_sale": "25.59",
   "market_cap": "$2.69B",
   "IPOyear": "2017",
   "sector": "Basic Industries",
   "industry": "Forest Products",
   "summary_quote": "https://www.nasdaq.com/symbol/jeld",
   "FIELD9": ""
 },
 {
   "symbol": "JCAP",
   "name": "Jernigan Capital, Inc.",
   "last_sale": "19.44",
   "market_cap": "$376.45M",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/jcap",
   "FIELD9": ""
 },
 {
   "symbol": "JCAP^B",
   "name": "Jernigan Capital, Inc.",
   "last_sale": "24.8992",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jcap^b",
   "FIELD9": ""
 },
 {
   "symbol": "JT",
   "name": "Jianpu Technology Inc.",
   "last_sale": "4.95",
   "market_cap": "$831.73M",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/jt",
   "FIELD9": ""
 },
 {
   "symbol": "JKS",
   "name": "JinkoSolar Holding Company Limited",
   "last_sale": "12.36",
   "market_cap": "$483.45M",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/jks",
   "FIELD9": ""
 },
 {
   "symbol": "JMP",
   "name": "JMP Group LLC",
   "last_sale": "5.22",
   "market_cap": "$111.98M",
   "IPOyear": "2007",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/jmp",
   "FIELD9": ""
 },
 {
   "symbol": "JMPB",
   "name": "JMP Group LLC",
   "last_sale": "25.73",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/jmpb",
   "FIELD9": ""
 },
 {
   "symbol": "JMPD",
   "name": "JMP Group LLC",
   "last_sale": "25.3699",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/jmpd",
   "FIELD9": ""
 },
 {
   "symbol": "JBT",
   "name": "John Bean Technologies Corporation",
   "last_sale": "117.45",
   "market_cap": "$3.71B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/jbt",
   "FIELD9": ""
 },
 {
   "symbol": "BTO",
   "name": "John Hancock Financial Opportunities Fund",
   "last_sale": "37.91",
   "market_cap": "$706.49M",
   "IPOyear": "1994",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bto",
   "FIELD9": ""
 },
 {
   "symbol": "HEQ",
   "name": "John Hancock Hedged Equity & Income Fund",
   "last_sale": "15.63",
   "market_cap": "$190.76M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/heq",
   "FIELD9": ""
 },
 {
   "symbol": "JHS",
   "name": "John Hancock Income Securities Trust",
   "last_sale": "13.35",
   "market_cap": "$155.48M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jhs",
   "FIELD9": ""
 },
 {
   "symbol": "JHI",
   "name": "John Hancock Investors Trust",
   "last_sale": "16.1",
   "market_cap": "$140.18M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jhi",
   "FIELD9": ""
 },
 {
   "symbol": "HPF",
   "name": "John Hancock Pfd Income Fund II",
   "last_sale": "21.489",
   "market_cap": "$457.02M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hpf",
   "FIELD9": ""
 },
 {
   "symbol": "HPI",
   "name": "John Hancock Preferred Income Fund",
   "last_sale": "22",
   "market_cap": "$572.07M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hpi",
   "FIELD9": ""
 },
 {
   "symbol": "HPS",
   "name": "John Hancock Preferred Income Fund III",
   "last_sale": "18.64",
   "market_cap": "$588.6M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hps",
   "FIELD9": ""
 },
 {
   "symbol": "PDT",
   "name": "John Hancock Premium Dividend Fund",
   "last_sale": "16.26",
   "market_cap": "$787.58M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pdt",
   "FIELD9": ""
 },
 {
   "symbol": "HTD",
   "name": "John Hancock Tax Advantaged Dividend Income Fund",
   "last_sale": "23.27",
   "market_cap": "$823.41M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/htd",
   "FIELD9": ""
 },
 {
   "symbol": "HTY",
   "name": "John Hancock Tax-Advantaged Global Shareholder Yield Fund",
   "last_sale": "7.46",
   "market_cap": "$82.35M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hty",
   "FIELD9": ""
 },
 {
   "symbol": "JW.A",
   "name": "John Wiley & Sons, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jw.a",
   "FIELD9": ""
 },
 {
   "symbol": "JW.B",
   "name": "John Wiley & Sons, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jw.b",
   "FIELD9": ""
 },
 {
   "symbol": "JNJ",
   "name": "Johnson & Johnson",
   "last_sale": "142.88",
   "market_cap": "$383.31B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/jnj",
   "FIELD9": ""
 },
 {
   "symbol": "JCI",
   "name": "Johnson Controls International plc",
   "last_sale": "36.96",
   "market_cap": "$34.19B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/jci",
   "FIELD9": ""
 },
 {
   "symbol": "JONE",
   "name": "Jones Energy, Inc.",
   "last_sale": "4.79",
   "market_cap": "$24.64M",
   "IPOyear": "2013",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/jone",
   "FIELD9": ""
 },
 {
   "symbol": "JLL",
   "name": "Jones Lang LaSalle Incorporated",
   "last_sale": "145.45",
   "market_cap": "$6.62B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/jll",
   "FIELD9": ""
 },
 {
   "symbol": "JMEI",
   "name": "Jumei International Holding Limited",
   "last_sale": "2.19",
   "market_cap": "$328.25M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/jmei",
   "FIELD9": ""
 },
 {
   "symbol": "JNPR",
   "name": "Juniper Networks, Inc.",
   "last_sale": "29.77",
   "market_cap": "$10.26B",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Computer Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/jnpr",
   "FIELD9": ""
 },
 {
   "symbol": "JP",
   "name": "Jupai Holdings Limited",
   "last_sale": "9.07",
   "market_cap": "$299.53M",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/jp",
   "FIELD9": ""
 },
 {
   "symbol": "JE",
   "name": "Just Energy Group, Inc.",
   "last_sale": "3.05",
   "market_cap": "$455.22M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil/Gas Transmission",
   "summary_quote": "https://www.nasdaq.com/symbol/je",
   "FIELD9": ""
 },
 {
   "symbol": "JE^A",
   "name": "Just Energy Group, Inc.",
   "last_sale": "21.1641",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/je^a",
   "FIELD9": ""
 },
 {
   "symbol": "LRN",
   "name": "K12 Inc",
   "last_sale": "17.56",
   "market_cap": "$694.9M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lrn",
   "FIELD9": ""
 },
 {
   "symbol": "KAI",
   "name": "Kadant Inc",
   "last_sale": "110.1",
   "market_cap": "$1.22B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/kai",
   "FIELD9": ""
 },
 {
   "symbol": "KDMN",
   "name": "Kadmon Holdings, Inc.",
   "last_sale": "3.34",
   "market_cap": "$377.76M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/kdmn",
   "FIELD9": ""
 },
 {
   "symbol": "KAMN",
   "name": "Kaman Corporation",
   "last_sale": "67.12",
   "market_cap": "$1.88B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/kamn",
   "FIELD9": ""
 },
 {
   "symbol": "KSU",
   "name": "Kansas City Southern",
   "last_sale": "117.11",
   "market_cap": "$11.96B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/ksu",
   "FIELD9": ""
 },
 {
   "symbol": "KSU^",
   "name": "Kansas City Southern",
   "last_sale": "26.3265",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/ksu^",
   "FIELD9": ""
 },
 {
   "symbol": "KS",
   "name": "KapStone Paper and Packaging Corporation",
   "last_sale": "33.93",
   "market_cap": "$3.32B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/ks",
   "FIELD9": ""
 },
 {
   "symbol": "KAR",
   "name": "KAR Auction Services, Inc",
   "last_sale": "61.42",
   "market_cap": "$8.25B",
   "IPOyear": "2009",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/kar",
   "FIELD9": ""
 },
 {
   "symbol": "KMF",
   "name": "Kayne Anderson Midstream Energy Fund, Inc",
   "last_sale": "13.09",
   "market_cap": "$288.43M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kmf",
   "FIELD9": ""
 },
 {
   "symbol": "KYN",
   "name": "Kayne Anderson MLP/Midstream Investment Company",
   "last_sale": "18.12",
   "market_cap": "$2.1B",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kyn",
   "FIELD9": ""
 },
 {
   "symbol": "KYN^F",
   "name": "Kayne Anderson MLP/Midstream Investment Company",
   "last_sale": "25.0648",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kyn^f",
   "FIELD9": ""
 },
 {
   "symbol": "KB",
   "name": "KB Financial Group Inc",
   "last_sale": "47.34",
   "market_cap": "$18.76B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/kb",
   "FIELD9": ""
 },
 {
   "symbol": "KBH",
   "name": "KB Home",
   "last_sale": "25.37",
   "market_cap": "$2.22B",
   "IPOyear": "1986",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/kbh",
   "FIELD9": ""
 },
 {
   "symbol": "KBR",
   "name": "KBR, Inc.",
   "last_sale": "21.26",
   "market_cap": "$2.99B",
   "IPOyear": "2006",
   "sector": "Basic Industries",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/kbr",
   "FIELD9": ""
 },
 {
   "symbol": "KAP",
   "name": "KCAP Financial, Inc.",
   "last_sale": "25.5548",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kap",
   "FIELD9": ""
 },
 {
   "symbol": "FRAC",
   "name": "Keane Group, Inc.",
   "last_sale": "12.56",
   "market_cap": "$1.38B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/frac",
   "FIELD9": ""
 },

 {
   "symbol": "KEM",
   "name": "Kemet Corporation",
   "last_sale": "20.35",
   "market_cap": "$1.17B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/kem",
   "FIELD9": ""
 },
 {
   "symbol": "KMPA",
   "name": "Kemper Corporation",
   "last_sale": "25.6",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/kmpa",
   "FIELD9": ""
 },
 {
   "symbol": "KMPR",
   "name": "Kemper Corporation",
   "last_sale": "80.6",
   "market_cap": "$5.22B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/kmpr",
   "FIELD9": ""
 },
 {
   "symbol": "KMT",
   "name": "Kennametal Inc.",
   "last_sale": "44.64",
   "market_cap": "$3.66B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/kmt",
   "FIELD9": ""
 },
 {
   "symbol": "KW",
   "name": "Kennedy-Wilson Holdings Inc.",
   "last_sale": "21.6",
   "market_cap": "$3.11B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/kw",
   "FIELD9": ""
 },
 {
   "symbol": "KEN",
   "name": "Kenon Holdings Ltd.",
   "last_sale": "17.615",
   "market_cap": "$948.16M",
   "IPOyear": "2015",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/ken",
   "FIELD9": ""
 },
 {
   "symbol": "KDP",
   "name": "Keurig Dr Pepper Inc.",
   "last_sale": "23.8",
   "market_cap": "$33.05B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/kdp",
   "FIELD9": ""
 },
 {
   "symbol": "KEG",
   "name": "Key Energy Services, Inc.",
   "last_sale": "13.59",
   "market_cap": "$275.12M",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/keg",
   "FIELD9": ""
 },
 {
   "symbol": "KEY",
   "name": "KeyCorp",
   "last_sale": "20.78",
   "market_cap": "$21.86B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/key",
   "FIELD9": ""
 },
 {
   "symbol": "KEY^I",
   "name": "KeyCorp",
   "last_sale": "26.71",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/key^i",
   "FIELD9": ""
 },
 {
   "symbol": "KEY^J",
   "name": "KeyCorp",
   "last_sale": "24.47",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/key^j",
   "FIELD9": ""
 },
 {
   "symbol": "KEYS",
   "name": "Keysight Technologies Inc.",
   "last_sale": "64.63",
   "market_cap": "$12.11B",
   "IPOyear": "2014",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/keys",
   "FIELD9": ""
 },
 {
   "symbol": "KRC",
   "name": "Kilroy Realty Corporation",
   "last_sale": "71.41",
   "market_cap": "$7.19B",
   "IPOyear": "1997",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/krc",
   "FIELD9": ""
 },
 {
   "symbol": "KRP",
   "name": "Kimbell Royalty Partners",
   "last_sale": "22.15",
   "market_cap": "$594.49M",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/krp",
   "FIELD9": ""
 },
 {
   "symbol": "KMB",
   "name": "Kimberly-Clark Corporation",
   "last_sale": "116.72",
   "market_cap": "$40.58B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/kmb",
   "FIELD9": ""
 },
 {
   "symbol": "KIM",
   "name": "Kimco Realty Corporation",
   "last_sale": "16.83",
   "market_cap": "$7.09B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/kim",
   "FIELD9": ""
 },
 {
   "symbol": "KIM^I",
   "name": "Kimco Realty Corporation",
   "last_sale": "25.01",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kim^i",
   "FIELD9": ""
 },
 {
   "symbol": "KIM^J",
   "name": "Kimco Realty Corporation",
   "last_sale": "24.32",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kim^j",
   "FIELD9": ""
 },
 {
   "symbol": "KIM^K",
   "name": "Kimco Realty Corporation",
   "last_sale": "24.4",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kim^k",
   "FIELD9": ""
 },
 {
   "symbol": "KIM^L",
   "name": "Kimco Realty Corporation",
   "last_sale": "22.44",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kim^l",
   "FIELD9": ""
 },
 {
   "symbol": "KIM^M",
   "name": "Kimco Realty Corporation",
   "last_sale": "22.57",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kim^m",
   "FIELD9": ""
 },
 {
   "symbol": "KMI",
   "name": "Kinder Morgan, Inc.",
   "last_sale": "18.06",
   "market_cap": "$39.86B",
   "IPOyear": "2011",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/kmi",
   "FIELD9": ""
 },
 {
   "symbol": "KMI^A",
   "name": "Kinder Morgan, Inc.",
   "last_sale": "33.97",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kmi^a",
   "FIELD9": ""
 },
 {
   "symbol": "KFS",
   "name": "Kingsway Financial Services, Inc.",
   "last_sale": "2.95",
   "market_cap": "$69.8M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/kfs",
   "FIELD9": ""
 },
 {
   "symbol": "KGC",
   "name": "Kinross Gold Corporation",
   "last_sale": "2.95",
   "market_cap": "$3.69B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/kgc",
   "FIELD9": ""
 },
 {
   "symbol": "KEX",
   "name": "Kirby Corporation",
   "last_sale": "80.45",
   "market_cap": "$4.82B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/kex",
   "FIELD9": ""
 },
 {
   "symbol": "KL",
   "name": "Kirkland Lake Gold Ltd.",
   "last_sale": "18.58",
   "market_cap": "$3.9B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/kl",
   "FIELD9": ""
 },
 {
   "symbol": "KRG",
   "name": "Kite Realty Group Trust",
   "last_sale": "16.71",
   "market_cap": "$1.4B",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/krg",
   "FIELD9": ""
 },
 {
   "symbol": "KKR",
   "name": "KKR & Co. Inc.",
   "last_sale": "28.25",
   "market_cap": "$23.42B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/kkr",
   "FIELD9": ""
 },
 {
   "symbol": "KKR^A",
   "name": "KKR & Co. Inc.",
   "last_sale": "26.64",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kkr^a",
   "FIELD9": ""
 },
 {
   "symbol": "KKR^B",
   "name": "KKR & Co. Inc.",
   "last_sale": "26.43",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kkr^b",
   "FIELD9": ""
 },
 {
   "symbol": "KIO",
   "name": "KKR Income Opportunities Fund",
   "last_sale": "16.52",
   "market_cap": "$336.02M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kio",
   "FIELD9": ""
 },
 {
   "symbol": "KREF",
   "name": "KKR Real Estate Finance Trust Inc.",
   "last_sale": "20.55",
   "market_cap": "$1.19B",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/kref",
   "FIELD9": ""
 },
 {
   "symbol": "KMG",
   "name": "KMG Chemicals, Inc.",
   "last_sale": "75.71",
   "market_cap": "$1.17B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/kmg",
   "FIELD9": ""
 },
 {
   "symbol": "KNX",
   "name": "Knight Transportation, Inc.",
   "last_sale": "35.09",
   "market_cap": "$6.25B",
   "IPOyear": "2017",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/knx",
   "FIELD9": ""
 },
 {
   "symbol": "KNL",
   "name": "Knoll, Inc.",
   "last_sale": "24.1",
   "market_cap": "$1.19B",
   "IPOyear": "2004",
   "sector": "Consumer Durables",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/knl",
   "FIELD9": ""
 },
 {
   "symbol": "KNOP",
   "name": "KNOT Offshore Partners LP",
   "last_sale": "21.65",
   "market_cap": "$707.83M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/knop",
   "FIELD9": ""
 },
 {
   "symbol": "KN",
   "name": "Knowles Corporation",
   "last_sale": "16.51",
   "market_cap": "$1.49B",
   "IPOyear": "2014",
   "sector": "Consumer Non-Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/kn",
   "FIELD9": ""
 },
 {
   "symbol": "KSS",
   "name": "Kohl&#39;s Corporation",
   "last_sale": "75.88",
   "market_cap": "$12.65B",
   "IPOyear": "1992",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/kss",
   "FIELD9": ""
 },
 {
   "symbol": "PHG",
   "name": "Koninklijke Philips N.V.",
   "last_sale": "45.85",
   "market_cap": "$42.71B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/phg",
   "FIELD9": ""
 },
 {
   "symbol": "KOP",
   "name": "Koppers Holdings Inc.",
   "last_sale": "33.05",
   "market_cap": "$699.9M",
   "IPOyear": "2006",
   "sector": "Basic Industries",
   "industry": "Forest Products",
   "summary_quote": "https://www.nasdaq.com/symbol/kop",
   "FIELD9": ""
 },
 {
   "symbol": "KEP",
   "name": "Korea Electric Power Corporation",
   "last_sale": "12.8",
   "market_cap": "$16.43B",
   "IPOyear": "1994",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/kep",
   "FIELD9": ""
 },
 {
   "symbol": "KF",
   "name": "Korea Fund, Inc. (The)",
   "last_sale": "36.37",
   "market_cap": "$203.95M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kf",
   "FIELD9": ""
 },
 {
   "symbol": "KFY",
   "name": "Korn/Ferry International",
   "last_sale": "49.15",
   "market_cap": "$2.8B",
   "IPOyear": "1999",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kfy",
   "FIELD9": ""
 },
 {
   "symbol": "KOS",
   "name": "Kosmos Energy Ltd.",
   "last_sale": "9.51",
   "market_cap": "$3.79B",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/kos",
   "FIELD9": ""
 },
 {
   "symbol": "KRA",
   "name": "Kraton Corporation",
   "last_sale": "49.74",
   "market_cap": "$1.59B",
   "IPOyear": "2009",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/kra",
   "FIELD9": ""
 },
 {
   "symbol": "KR",
   "name": "Kroger Company (The)",
   "last_sale": "29.95",
   "market_cap": "$23.86B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Food Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/kr",
   "FIELD9": ""
 },
 {
   "symbol": "KRO",
   "name": "Kronos Worldwide Inc",
   "last_sale": "17.03",
   "market_cap": "$1.97B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/kro",
   "FIELD9": ""
 },
 {
   "symbol": "KT",
   "name": "KT Corporation",
   "last_sale": "14.46",
   "market_cap": "$7.06B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/kt",
   "FIELD9": ""
 },
 {
   "symbol": "LB",
   "name": "L Brands, Inc.",
   "last_sale": "30.37",
   "market_cap": "$8.35B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/lb",
   "FIELD9": ""
 },
 {
   "symbol": "SCX",
   "name": "L.S. Starrett Company (The)",
   "last_sale": "6.2",
   "market_cap": "$43.54M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/scx",
   "FIELD9": ""
 },
 {
   "symbol": "LLL",
   "name": "L3 Technologies, Inc.",
   "last_sale": "211.46",
   "market_cap": "$16.56B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/lll",
   "FIELD9": ""
 },
 {
   "symbol": "LH",
   "name": "Laboratory Corporation of America Holdings",
   "last_sale": "172.08",
   "market_cap": "$17.53B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/lh",
   "FIELD9": ""
 },
 {
   "symbol": "LADR",
   "name": "Ladder Capital Corp",
   "last_sale": "17.08",
   "market_cap": "$1.9B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ladr",
   "FIELD9": ""
 },
 {
   "symbol": "LW",
   "name": "Lamb Weston Holdings, Inc.",
   "last_sale": "67",
   "market_cap": "$9.81B",
   "IPOyear": "2016",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/lw",
   "FIELD9": ""
 },
 {
   "symbol": "LCI",
   "name": "Lannett Co Inc",
   "last_sale": "5",
   "market_cap": "$194.51M",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/lci",
   "FIELD9": ""
 },
 {
   "symbol": "LPI",
   "name": "Laredo Petroleum, Inc.",
   "last_sale": "8.8",
   "market_cap": "$2.07B",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/lpi",
   "FIELD9": ""
 },
 {
   "symbol": "LVS",
   "name": "Las Vegas Sands Corp.",
   "last_sale": "60.95",
   "market_cap": "$48.03B",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/lvs",
   "FIELD9": ""
 },
 {
   "symbol": "LHO",
   "name": "LaSalle Hotel Properties",
   "last_sale": "34.47",
   "market_cap": "$3.81B",
   "IPOyear": "1998",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/lho",
   "FIELD9": ""
 },
 {
   "symbol": "LHO^I",
   "name": "LaSalle Hotel Properties",
   "last_sale": "24.72",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lho^i",
   "FIELD9": ""
 },
 {
   "symbol": "LHO^J",
   "name": "LaSalle Hotel Properties",
   "last_sale": "24.58",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lho^j",
   "FIELD9": ""
 },
 {
   "symbol": "LTM",
   "name": "LATAM Airlines Group S.A.",
   "last_sale": "9.81",
   "market_cap": "$5.95B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ltm",
   "FIELD9": ""
 },
 {
   "symbol": "LDF",
   "name": "Latin American Discovery Fund, Inc. (The)",
   "last_sale": "11.05",
   "market_cap": "$72.27M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ldf",
   "FIELD9": ""
 },
 {
   "symbol": "LGI",
   "name": "Lazard Global Total Return and Income Fund",
   "last_sale": "17.68",
   "market_cap": "$169.82M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lgi",
   "FIELD9": ""
 },
 {
   "symbol": "LAZ",
   "name": "Lazard Ltd.",
   "last_sale": "48.94",
   "market_cap": "$5.86B",
   "IPOyear": "2005",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/laz",
   "FIELD9": ""
 },
 {
   "symbol": "LOR",
   "name": "Lazard World Dividend & Income Fund, Inc.",
   "last_sale": "10.42",
   "market_cap": "$71.69M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lor",
   "FIELD9": ""
 },
 {
   "symbol": "LZB",
   "name": "La-Z-Boy Incorporated",
   "last_sale": "32.2",
   "market_cap": "$1.5B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/lzb",
   "FIELD9": ""
 },
 {
   "symbol": "LCII",
   "name": "LCI Industries ",
   "last_sale": "91.95",
   "market_cap": "$2.32B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/lcii",
   "FIELD9": ""
 },
 {
   "symbol": "LEAF",
   "name": "Leaf Group Ltd.",
   "last_sale": "9.75",
   "market_cap": "$244.01M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/leaf",
   "FIELD9": ""
 },
 {
   "symbol": "LEA",
   "name": "Lear Corporation",
   "last_sale": "159.35",
   "market_cap": "$10.44B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/lea",
   "FIELD9": ""
 },
 {
   "symbol": "LEE",
   "name": "Lee Enterprises, Incorporated",
   "last_sale": "2.75",
   "market_cap": "$156.97M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Newspapers/Magazines",
   "summary_quote": "https://www.nasdaq.com/symbol/lee",
   "FIELD9": ""
 },
 {
   "symbol": "LGC",
   "name": "Legacy Acquisition Corp.",
   "last_sale": "9.69",
   "market_cap": "$84.58M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lgc",
   "FIELD9": ""
 },
 {
   "symbol": "LGC.U",
   "name": "Legacy Acquisition Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lgc.u",
   "FIELD9": ""
 },
 {
   "symbol": "LGC.WS",
   "name": "Legacy Acquisition Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lgc.ws",
   "FIELD9": ""
 },
 {
   "symbol": "LM",
   "name": "Legg Mason, Inc.",
   "last_sale": "32.25",
   "market_cap": "$2.76B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/lm",
   "FIELD9": ""
 },
 {
   "symbol": "LMHA",
   "name": "Legg Mason, Inc.",
   "last_sale": "26.08",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/lmha",
   "FIELD9": ""
 },
 {
   "symbol": "LMHB",
   "name": "Legg Mason, Inc.",
   "last_sale": "24.18",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/lmhb",
   "FIELD9": ""
 },
 {
   "symbol": "LEG",
   "name": "Leggett & Platt, Incorporated",
   "last_sale": "45.65",
   "market_cap": "$5.94B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/leg",
   "FIELD9": ""
 },
 {
   "symbol": "JBK",
   "name": "Lehman ABS Corporation",
   "last_sale": "25.9719",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/jbk",
   "FIELD9": ""
 },
 {
   "symbol": "KTH",
   "name": "Lehman ABS Corporation",
   "last_sale": "31.8",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/kth",
   "FIELD9": ""
 },
 {
   "symbol": "KTN",
   "name": "Lehman ABS Corporation",
   "last_sale": "30.4988",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ktn",
   "FIELD9": ""
 },
 {
   "symbol": "KTP",
   "name": "Lehman ABS Corporation",
   "last_sale": "9.74",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ktp",
   "FIELD9": ""
 },
 {
   "symbol": "LDOS",
   "name": "Leidos Holdings, Inc.",
   "last_sale": "69.76",
   "market_cap": "$10.5B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ldos",
   "FIELD9": ""
 },
 {
   "symbol": "LEJU",
   "name": "Leju Holdings Limited",
   "last_sale": "2.18",
   "market_cap": "$295.97M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/leju",
   "FIELD9": ""
 },
 {
   "symbol": "LC",
   "name": "LendingClub Corporation",
   "last_sale": "3.57",
   "market_cap": "$1.51B",
   "IPOyear": "2014",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lc",
   "FIELD9": ""
 },
 {
   "symbol": "LEN",
   "name": "Lennar Corporation",
   "last_sale": "50.13",
   "market_cap": "$16.52B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/len",
   "FIELD9": ""
 },
 {
   "symbol": "LEN.B",
   "name": "Lennar Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/len.b",
   "FIELD9": ""
 },
 {
   "symbol": "LII",
   "name": "Lennox International, Inc.",
   "last_sale": "216.72",
   "market_cap": "$8.72B",
   "IPOyear": "1999",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/lii",
   "FIELD9": ""
 },
 {
   "symbol": "LHC",
   "name": "Leo Holdings Corp.",
   "last_sale": "9.701",
   "market_cap": "$242.53M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lhc",
   "FIELD9": ""
 },
 {
   "symbol": "LHC.U",
   "name": "Leo Holdings Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lhc.u",
   "FIELD9": ""
 },
 {
   "symbol": "LHC.WS",
   "name": "Leo Holdings Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lhc.ws",
   "FIELD9": ""
 },
 {
   "symbol": "LXP",
   "name": "Lexington Realty Trust",
   "last_sale": "8.31",
   "market_cap": "$1.99B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lxp",
   "FIELD9": ""
 },
 {
   "symbol": "LXP^C",
   "name": "Lexington Realty Trust",
   "last_sale": "49.8689",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lxp^c",
   "FIELD9": ""
 },
 {
   "symbol": "LPL",
   "name": "LG Display Co., Ltd.",
   "last_sale": "8.55",
   "market_cap": "$6.12B",
   "IPOyear": "2004",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/lpl",
   "FIELD9": ""
 },
 {
   "symbol": "USA",
   "name": "Liberty All-Star Equity Fund",
   "last_sale": "6.82",
   "market_cap": "$1.34B",
   "IPOyear": "1986",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/usa",
   "FIELD9": ""
 },
 {
   "symbol": "ASG",
   "name": "Liberty All-Star Growth Fund, Inc.",
   "last_sale": "6.3",
   "market_cap": "$172.88M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/asg",
   "FIELD9": ""
 },
 {
   "symbol": "LBRT",
   "name": "Liberty Oilfield Services Inc.",
   "last_sale": "21.67",
   "market_cap": "$2.56B",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/lbrt",
   "FIELD9": ""
 },
 {
   "symbol": "LPT",
   "name": "Liberty Property Trust",
   "last_sale": "43.16",
   "market_cap": "$6.38B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/lpt",
   "FIELD9": ""
 },
 {
   "symbol": "LSI",
   "name": "Life Storage, Inc.",
   "last_sale": "96.11",
   "market_cap": "$4.48B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/lsi",
   "FIELD9": ""
 },
 {
   "symbol": "LITB",
   "name": "LightInTheBox Holding Co., Ltd.",
   "last_sale": "1.06",
   "market_cap": "$143.75M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/litb",
   "FIELD9": ""
 },
 {
   "symbol": "LNC",
   "name": "Lincoln National Corporation",
   "last_sale": "70.32",
   "market_cap": "$15.24B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/lnc",
   "FIELD9": ""
 },
 {
   "symbol": "LNC.WS",
   "name": "Lincoln National Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lnc.ws",
   "FIELD9": ""
 },
 {
   "symbol": "LNN",
   "name": "Lindsay Corporation",
   "last_sale": "99.12",
   "market_cap": "$1.07B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/lnn",
   "FIELD9": ""
 },
 {
   "symbol": "LN",
   "name": "LINE Corporation",
   "last_sale": "43.23",
   "market_cap": "$10.38B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/ln",
   "FIELD9": ""
 },
 {
   "symbol": "LKM",
   "name": "Link Motion Inc.",
   "last_sale": "0.6402",
   "market_cap": "$62.73M",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/lkm",
   "FIELD9": ""
 },
 {
   "symbol": "LGF.A",
   "name": "Lions Gate Entertainment Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lgf.a",
   "FIELD9": ""
 },
 {
   "symbol": "LGF.B",
   "name": "Lions Gate Entertainment Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/lgf.b",
   "FIELD9": ""
 },
 {
   "symbol": "LAD",
   "name": "Lithia Motors, Inc.",
   "last_sale": "87.46",
   "market_cap": "$2.12B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/lad",
   "FIELD9": ""
 },
 {
   "symbol": "LAC",
   "name": "Lithium Americas Corp.",
   "last_sale": "4.93",
   "market_cap": "$436.75M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/lac",
   "FIELD9": ""
 },
 {
   "symbol": "LYV",
   "name": "Live Nation Entertainment, Inc.",
   "last_sale": "53.41",
   "market_cap": "$11.17B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/lyv",
   "FIELD9": ""
 },
 {
   "symbol": "LYG",
   "name": "Lloyds Banking Group Plc",
   "last_sale": "3.23",
   "market_cap": "$57.44B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/lyg",
   "FIELD9": ""
 },
 {
   "symbol": "SCD",
   "name": "LMP Capital and Income Fund Inc.",
   "last_sale": "13.87",
   "market_cap": "$249.43M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/scd",
   "FIELD9": ""
 },
 {
   "symbol": "LMT",
   "name": "Lockheed Martin Corporation",
   "last_sale": "337.66",
   "market_cap": "$96.16B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/lmt",
   "FIELD9": ""
 },

 {
   "symbol": "LOMA",
   "name": "Loma Negra Compania Industrial Argentina Sociedad Anonima",
   "last_sale": "9.98",
   "market_cap": "$1.19B",
   "IPOyear": "2017",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/loma",
   "FIELD9": ""
 },
 {
   "symbol": "LPX",
   "name": "Louisiana-Pacific Corporation",
   "last_sale": "28.25",
   "market_cap": "$4.03B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Forest Products",
   "summary_quote": "https://www.nasdaq.com/symbol/lpx",
   "FIELD9": ""
 },
 {
   "symbol": "LOW",
   "name": "Lowe&#39;s Companies, Inc.",
   "last_sale": "116.84",
   "market_cap": "$94.44B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/low",
   "FIELD9": ""
 },
 {
   "symbol": "LXU",
   "name": "Lsb Industries Inc.",
   "last_sale": "9.7",
   "market_cap": "$277.55M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/lxu",
   "FIELD9": ""
 },
 {
   "symbol": "LKSD",
   "name": "LSC Communications, Inc.",
   "last_sale": "12.37",
   "market_cap": "$412.8M",
   "IPOyear": "2016",
   "sector": "Miscellaneous",
   "industry": "Publishing",
   "summary_quote": "https://www.nasdaq.com/symbol/lksd",
   "FIELD9": ""
 },
 {
   "symbol": "LTC",
   "name": "LTC Properties, Inc.",
   "last_sale": "44.38",
   "market_cap": "$1.76B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ltc",
   "FIELD9": ""
 },
 {
   "symbol": "LUB",
   "name": "Luby&#39;s, Inc.",
   "last_sale": "1.71",
   "market_cap": "$50.45M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/lub",
   "FIELD9": ""
 },
 {
   "symbol": "LL",
   "name": "Lumber Liquidators Holdings, Inc",
   "last_sale": "17.74",
   "market_cap": "$507.16M",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/ll",
   "FIELD9": ""
 },
 {
   "symbol": "LXFR",
   "name": "Luxfer Holdings PLC",
   "last_sale": "24.26",
   "market_cap": "$643M",
   "IPOyear": "2012",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/lxfr",
   "FIELD9": ""
 },
 {
   "symbol": "LXFT",
   "name": "Luxoft Holding, Inc.",
   "last_sale": "49.65",
   "market_cap": "$1.67B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/lxft",
   "FIELD9": ""
 },
 {
   "symbol": "LDL",
   "name": "Lydall, Inc.",
   "last_sale": "42.25",
   "market_cap": "$734.29M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/ldl",
   "FIELD9": ""
 },
 {
   "symbol": "WLH",
   "name": "Lyon William Homes",
   "last_sale": "17.59",
   "market_cap": "$668.01M",
   "IPOyear": "2013",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/wlh",
   "FIELD9": ""
 },
 {
   "symbol": "LYB",
   "name": "LyondellBasell Industries NV",
   "last_sale": "105.21",
   "market_cap": "$40.96B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/lyb",
   "FIELD9": ""
 },
 {
   "symbol": "MTB",
   "name": "M&T Bank Corporation",
   "last_sale": "173",
   "market_cap": "$24.88B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mtb",
   "FIELD9": ""
 },
 {
   "symbol": "MTB.WS",
   "name": "M&T Bank Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mtb.ws",
   "FIELD9": ""
 },
 {
   "symbol": "MTB^",
   "name": "M&T Bank Corporation",
   "last_sale": "1020",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mtb^",
   "FIELD9": ""
 },
 {
   "symbol": "MTB^C",
   "name": "M&T Bank Corporation",
   "last_sale": "1014.11",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mtb^c",
   "FIELD9": ""
 },
 {
   "symbol": "MDC",
   "name": "M.D.C. Holdings, Inc.",
   "last_sale": "30.94",
   "market_cap": "$1.75B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/mdc",
   "FIELD9": ""
 },
 {
   "symbol": "MHO",
   "name": "M/I Homes, Inc.",
   "last_sale": "25.26",
   "market_cap": "$721.7M",
   "IPOyear": "1993",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/mho",
   "FIELD9": ""
 },
 {
   "symbol": "MAC",
   "name": "Macerich Company (The)",
   "last_sale": "56.93",
   "market_cap": "$8.03B",
   "IPOyear": "1994",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/mac",
   "FIELD9": ""
 },
 {
   "symbol": "CLI",
   "name": "Mack-Cali Realty Corporation",
   "last_sale": "20.48",
   "market_cap": "$1.85B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/cli",
   "FIELD9": ""
 },
 {
   "symbol": "MFD",
   "name": "Macquarie First Trust Global",
   "last_sale": "10.99",
   "market_cap": "$93.94M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mfd",
   "FIELD9": ""
 },
 {
   "symbol": "MGU",
   "name": "Macquarie Global Infrastructure Total Return Fund Inc.",
   "last_sale": "21.84",
   "market_cap": "$272.31M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mgu",
   "FIELD9": ""
 },
 {
   "symbol": "MIC",
   "name": "Macquarie Infrastructure Corporation ",
   "last_sale": "46.68",
   "market_cap": "$3.99B",
   "IPOyear": "2004",
   "sector": "Energy",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/mic",
   "FIELD9": ""
 },
 {
   "symbol": "BMA",
   "name": "Macro Bank Inc.",
   "last_sale": "48.5",
   "market_cap": "$3.25B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/bma",
   "FIELD9": ""
 },
 {
   "symbol": "M",
   "name": "Macy&#39;s Inc",
   "last_sale": "35.69",
   "market_cap": "$10.96B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/m",
   "FIELD9": ""
 },
 {
   "symbol": "MCN",
   "name": "Madison Covered Call & Equity Strategy Fund",
   "last_sale": "7.7",
   "market_cap": "$148.37M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mcn",
   "FIELD9": ""
 },
 {
   "symbol": "MSP",
   "name": "Madison Strategic Sector Premium Fund",
   "last_sale": "11.6986",
   "market_cap": "$67.83M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/msp",
   "FIELD9": ""
 },
 {
   "symbol": "MMP",
   "name": "Magellan Midstream Partners L.P.",
   "last_sale": "68.9",
   "market_cap": "$15.72B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/mmp",
   "FIELD9": ""
 },
 {
   "symbol": "MGA",
   "name": "Magna International, Inc.",
   "last_sale": "55.99",
   "market_cap": "$19.04B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/mga",
   "FIELD9": ""
 },
 {
   "symbol": "MX",
   "name": "MagnaChip Semiconductor Corporation",
   "last_sale": "9.85",
   "market_cap": "$339.78M",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/mx",
   "FIELD9": ""
 },
 {
   "symbol": "MGY",
   "name": "Magnolia Oil & Gas Corporation",
   "last_sale": "14.39",
   "market_cap": "$2.45B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/mgy",
   "FIELD9": ""
 },
 {
   "symbol": "MGY.WS",
   "name": "Magnolia Oil & Gas Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mgy.ws",
   "FIELD9": ""
 },
 {
   "symbol": "MH^A",
   "name": "Maiden Holdings, Ltd.",
   "last_sale": "20.47",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mh^a",
   "FIELD9": ""
 },
 {
   "symbol": "MH^C",
   "name": "Maiden Holdings, Ltd.",
   "last_sale": "17.75",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mh^c",
   "FIELD9": ""
 },
 {
   "symbol": "MH^D",
   "name": "Maiden Holdings, Ltd.",
   "last_sale": "16.82",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mh^d",
   "FIELD9": ""
 },
 {
   "symbol": "MHLA",
   "name": "Maiden Holdings, Ltd.",
   "last_sale": "17.4",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/mhla",
   "FIELD9": ""
 },
 {
   "symbol": "MHNC",
   "name": "Maiden Holdings, Ltd.",
   "last_sale": "20.3",
   "market_cap": "n/a",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/mhnc",
   "FIELD9": ""
 },
 {
   "symbol": "MAIN",
   "name": "Main Street Capital Corporation",
   "last_sale": "39.37",
   "market_cap": "$2.39B",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/main",
   "FIELD9": ""
 },
 {
   "symbol": "MMD",
   "name": "MainStay MacKay DefinedTerm Municipal Opportunitie",
   "last_sale": "19.3",
   "market_cap": "$531.95M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mmd",
   "FIELD9": ""
 },
 {
   "symbol": "MNK",
   "name": "Mallinckrodt plc",
   "last_sale": "29.64",
   "market_cap": "$2.47B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mnk",
   "FIELD9": ""
 },
 {
   "symbol": "MANU",
   "name": "Manchester United Ltd.",
   "last_sale": "24.1",
   "market_cap": "$3.96B",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/manu",
   "FIELD9": ""
 },
 {
   "symbol": "MTW",
   "name": "Manitowoc Company, Inc. (The)",
   "last_sale": "25.85",
   "market_cap": "$918.62M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/mtw",
   "FIELD9": ""
 },
 {
   "symbol": "MN",
   "name": "Manning & Napier, Inc.",
   "last_sale": "2.8",
   "market_cap": "$42.93M",
   "IPOyear": "2011",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/mn",
   "FIELD9": ""
 },
 {
   "symbol": "MAN",
   "name": "ManpowerGroup",
   "last_sale": "85.74",
   "market_cap": "$5.56B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/man",
   "FIELD9": ""
 },
 {
   "symbol": "MFC",
   "name": "Manulife Financial Corp",
   "last_sale": "18.54",
   "market_cap": "$36.78B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/mfc",
   "FIELD9": ""
 },
 {
   "symbol": "MRO",
   "name": "Marathon Oil Corporation",
   "last_sale": "21.86",
   "market_cap": "$18.67B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/mro",
   "FIELD9": ""
 },
 {
   "symbol": "MPC",
   "name": "Marathon Petroleum Corporation",
   "last_sale": "83.37",
   "market_cap": "$37.6B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/mpc",
   "FIELD9": ""
 },
 {
   "symbol": "MMI",
   "name": "Marcus & Millichap, Inc.",
   "last_sale": "34.58",
   "market_cap": "$1.34B",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/mmi",
   "FIELD9": ""
 },
 {
   "symbol": "MCS",
   "name": "Marcus Corporation (The)",
   "last_sale": "40.8",
   "market_cap": "$1.15B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Movies/Entertainment",
   "summary_quote": "https://www.nasdaq.com/symbol/mcs",
   "FIELD9": ""
 },
 {
   "symbol": "MPX",
   "name": "Marine Products Corporation",
   "last_sale": "21.86",
   "market_cap": "$755.22M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/mpx",
   "FIELD9": ""
 },
 {
   "symbol": "HZO",
   "name": "MarineMax, Inc.",
   "last_sale": "21.75",
   "market_cap": "$489.69M",
   "IPOyear": "1998",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/hzo",
   "FIELD9": ""
 },
 {
   "symbol": "MKL",
   "name": "Markel Corporation",
   "last_sale": "1216.15",
   "market_cap": "$16.89B",
   "IPOyear": "1986",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/mkl",
   "FIELD9": ""
 },
 {
   "symbol": "VAC",
   "name": "Marriot Vacations Worldwide Corporation",
   "last_sale": "118",
   "market_cap": "$5.56B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/vac",
   "FIELD9": ""
 },
 {
   "symbol": "MMC",
   "name": "Marsh & McLennan Companies, Inc.",
   "last_sale": "85.94",
   "market_cap": "$43.4B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/mmc",
   "FIELD9": ""
 },
 {
   "symbol": "MLM",
   "name": "Martin Marietta Materials, Inc.",
   "last_sale": "192.18",
   "market_cap": "$12.11B",
   "IPOyear": "1994",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/mlm",
   "FIELD9": ""
 },
 {
   "symbol": "MAS",
   "name": "Masco Corporation",
   "last_sale": "38.54",
   "market_cap": "$11.85B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Forest Products",
   "summary_quote": "https://www.nasdaq.com/symbol/mas",
   "FIELD9": ""
 },
 {
   "symbol": "DOOR",
   "name": "Masonite International Corporation",
   "last_sale": "66.55",
   "market_cap": "$1.84B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Forest Products",
   "summary_quote": "https://www.nasdaq.com/symbol/door",
   "FIELD9": ""
 },
 {
   "symbol": "MTZ",
   "name": "MasTec, Inc.",
   "last_sale": "45.8",
   "market_cap": "$3.68B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/mtz",
   "FIELD9": ""
 },
 {
   "symbol": "MA",
   "name": "Mastercard Incorporated",
   "last_sale": "221.9",
   "market_cap": "$246.06B",
   "IPOyear": "2006",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ma",
   "FIELD9": ""
 },
 {
   "symbol": "MTDR",
   "name": "Matador Resources Company",
   "last_sale": "32.52",
   "market_cap": "$3.78B",
   "IPOyear": "2012",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/mtdr",
   "FIELD9": ""
 },
 {
   "symbol": "MTRN",
   "name": "Materion Corporation",
   "last_sale": "59",
   "market_cap": "$1.19B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/mtrn",
   "FIELD9": ""
 },
 {
   "symbol": "MATX",
   "name": "Matson, Inc.",
   "last_sale": "38.8",
   "market_cap": "$1.66B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/matx",
   "FIELD9": ""
 },
 {
   "symbol": "MLP",
   "name": "Maui Land & Pineapple Company, Inc.",
   "last_sale": "13",
   "market_cap": "$249.52M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/mlp",
   "FIELD9": ""
 },
 {
   "symbol": "MAXR",
   "name": "Maxar Technologies Ltd.",
   "last_sale": "36.83",
   "market_cap": "$2.18B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/maxr",
   "FIELD9": ""
 },
 {
   "symbol": "MMS",
   "name": "Maximus, Inc.",
   "last_sale": "65.15",
   "market_cap": "$4.19B",
   "IPOyear": "1997",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mms",
   "FIELD9": ""
 },
 {
   "symbol": "MXL",
   "name": "MaxLinear, Inc",
   "last_sale": "20.03",
   "market_cap": "$1.37B",
   "IPOyear": "2010",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/mxl",
   "FIELD9": ""
 },
 {
   "symbol": "MBI",
   "name": "MBIA, Inc.",
   "last_sale": "11.24",
   "market_cap": "$1.02B",
   "IPOyear": "1987",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/mbi",
   "FIELD9": ""
 },
 {
   "symbol": "MKC",
   "name": "McCormick & Company, Incorporated",
   "last_sale": "130.22",
   "market_cap": "$17.09B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/mkc",
   "FIELD9": ""
 },
 {
   "symbol": "MKC.V",
   "name": "McCormick & Company, Incorporated",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/mkc.v",
   "FIELD9": ""
 },
 {
   "symbol": "MDR",
   "name": "McDermott International, Inc.",
   "last_sale": "18.5",
   "market_cap": "$3.34B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/mdr",
   "FIELD9": ""
 },
 {
   "symbol": "MCD",
   "name": "McDonald&#39;s Corporation",
   "last_sale": "165.3",
   "market_cap": "$128.24B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/mcd",
   "FIELD9": ""
 },
 {
   "symbol": "MUX",
   "name": "McEwen Mining Inc.",
   "last_sale": "1.87",
   "market_cap": "$630.69M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/mux",
   "FIELD9": ""
 },
 {
   "symbol": "MCK",
   "name": "McKesson Corporation",
   "last_sale": "134.95",
   "market_cap": "$26.96B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Other Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mck",
   "FIELD9": ""
 },
 {
   "symbol": "MDU",
   "name": "MDU Resources Group, Inc.",
   "last_sale": "26.29",
   "market_cap": "$5.15B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/mdu",
   "FIELD9": ""
 },
 {
   "symbol": "MTL",
   "name": "Mechel PAO",
   "last_sale": "3.01",
   "market_cap": "$751.78M",
   "IPOyear": "2004",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/mtl",
   "FIELD9": ""
 },
 {
   "symbol": "MTL^",
   "name": "Mechel PAO",
   "last_sale": "0.85",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mtl^",
   "FIELD9": ""
 },
 {
   "symbol": "MRT",
   "name": "MedEquities Realty Trust, Inc.",
   "last_sale": "9.99",
   "market_cap": "$318.31M",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/mrt",
   "FIELD9": ""
 },
 {
   "symbol": "MPW",
   "name": "Medical Properties Trust, Inc.",
   "last_sale": "14.69",
   "market_cap": "$5.36B",
   "IPOyear": "2005",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/mpw",
   "FIELD9": ""
 },
 {
   "symbol": "MED",
   "name": "MEDIFAST INC",
   "last_sale": "215.09",
   "market_cap": "$2.57B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/med",
   "FIELD9": ""
 },
 {
   "symbol": "MCC",
   "name": "Medley Capital Corporation",
   "last_sale": "3.98",
   "market_cap": "$216.81M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mcc",
   "FIELD9": ""
 },
 {
   "symbol": "MCV",
   "name": "Medley Capital Corporation",
   "last_sale": "25.14",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mcv",
   "FIELD9": ""
 },
 {
   "symbol": "MCX",
   "name": "Medley Capital Corporation",
   "last_sale": "25.26",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mcx",
   "FIELD9": ""
 },
 {
   "symbol": "MDLQ",
   "name": "Medley LLC",
   "last_sale": "24.95",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/mdlq",
   "FIELD9": ""
 },
 {
   "symbol": "MDLX",
   "name": "Medley LLC",
   "last_sale": "24.261",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/mdlx",
   "FIELD9": ""
 },
 {
   "symbol": "MDLY",
   "name": "Medley Management Inc.",
   "last_sale": "5.35",
   "market_cap": "$161.75M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/mdly",
   "FIELD9": ""
 },
 {
   "symbol": "MD",
   "name": "Mednax, Inc",
   "last_sale": "45.6",
   "market_cap": "$4.07B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/md",
   "FIELD9": ""
 },
 {
   "symbol": "MDT",
   "name": "Medtronic plc",
   "last_sale": "97.85",
   "market_cap": "$132.15B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/mdt",
   "FIELD9": ""
 },
 {
   "symbol": "MFAC.U",
   "name": "Megalith Financial Acquisition Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mfac.u",
   "FIELD9": ""
 },
 {
   "symbol": "MRK",
   "name": "Merck & Company, Inc.",
   "last_sale": "71.1",
   "market_cap": "$189.09B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/mrk",
   "FIELD9": ""
 },
 {
   "symbol": "MCY",
   "name": "Mercury General Corporation",
   "last_sale": "50.54",
   "market_cap": "$2.8B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/mcy",
   "FIELD9": ""
 },
 {
   "symbol": "MDP",
   "name": "Meredith Corporation",
   "last_sale": "53.55",
   "market_cap": "$2.4B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Newspapers/Magazines",
   "summary_quote": "https://www.nasdaq.com/symbol/mdp",
   "FIELD9": ""
 },
 {
   "symbol": "MTH",
   "name": "Meritage Corporation",
   "last_sale": "43.15",
   "market_cap": "$1.75B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/mth",
   "FIELD9": ""
 },
 {
   "symbol": "MTOR",
   "name": "Meritor, Inc.",
   "last_sale": "20.92",
   "market_cap": "$1.81B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/mtor",
   "FIELD9": ""
 },
 {
   "symbol": "MER^K",
   "name": "Merrill Lynch & Co., Inc.",
   "last_sale": "26.09",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mer^k",
   "FIELD9": ""
 },
 {
   "symbol": "PIY",
   "name": "Merrill Lynch Depositor, Inc.",
   "last_sale": "17.022",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/piy",
   "FIELD9": ""
 },
 {
   "symbol": "MTR",
   "name": "Mesa Royalty Trust",
   "last_sale": "14.35",
   "market_cap": "$26.74M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/mtr",
   "FIELD9": ""
 },
 {
   "symbol": "MSB",
   "name": "Mesabi Trust",
   "last_sale": "27.65",
   "market_cap": "$362.77M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/msb",
   "FIELD9": ""
 },
 {
   "symbol": "MEI",
   "name": "Methode Electronics, Inc.",
   "last_sale": "36.85",
   "market_cap": "$1.36B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/mei",
   "FIELD9": ""
 },
 {
   "symbol": "MET",
   "name": "MetLife, Inc.",
   "last_sale": "48.79",
   "market_cap": "$48.54B",
   "IPOyear": "2000",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/met",
   "FIELD9": ""
 },
 {
   "symbol": "MET^A",
   "name": "MetLife, Inc.",
   "last_sale": "25.22",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/met^a",
   "FIELD9": ""
 },
 {
   "symbol": "MET^E",
   "name": "MetLife, Inc.",
   "last_sale": "24.9674",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/met^e",
   "FIELD9": ""
 },
 {
   "symbol": "MCB",
   "name": "Metropolitan Bank Holding Corp.",
   "last_sale": "43.14",
   "market_cap": "$354.06M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mcb",
   "FIELD9": ""
 },
 {
   "symbol": "MTD",
   "name": "Mettler-Toledo International, Inc.",
   "last_sale": "611.98",
   "market_cap": "$15.43B",
   "IPOyear": "1997",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/mtd",
   "FIELD9": ""
 },
 {
   "symbol": "MXE",
   "name": "Mexico Equity and Income Fund, Inc. (The)",
   "last_sale": "12.16",
   "market_cap": "$84.91M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mxe",
   "FIELD9": ""
 },
 {
   "symbol": "MXF",
   "name": "Mexico Fund, Inc. (The)",
   "last_sale": "16.1284",
   "market_cap": "$242.01M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mxf",
   "FIELD9": ""
 },
 {
   "symbol": "MFA",
   "name": "MFA Financial, Inc.",
   "last_sale": "7.62",
   "market_cap": "$3.42B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/mfa",
   "FIELD9": ""
 },
 {
   "symbol": "MFA^B",
   "name": "MFA Financial, Inc.",
   "last_sale": "25.06",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mfa^b",
   "FIELD9": ""
 },
 {
   "symbol": "MFO",
   "name": "MFA Financial, Inc.",
   "last_sale": "25.55",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/mfo",
   "FIELD9": ""
 },
 {
   "symbol": "MFCB",
   "name": "MFC Bancorp Ltd.",
   "last_sale": "6.1025",
   "market_cap": "$76.49M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mfcb",
   "FIELD9": ""
 },
 {
   "symbol": "MCR",
   "name": "MFS Charter Income Trust",
   "last_sale": "7.77",
   "market_cap": "$372.42M",
   "IPOyear": "1989",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mcr",
   "FIELD9": ""
 },
 {
   "symbol": "MGF",
   "name": "MFS Government Markets Income Trust",
   "last_sale": "4.4",
   "market_cap": "$143.44M",
   "IPOyear": "1987",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mgf",
   "FIELD9": ""
 },
 {
   "symbol": "MIN",
   "name": "MFS Intermediate Income Trust",
   "last_sale": "3.74",
   "market_cap": "$440.26M",
   "IPOyear": "1988",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/min",
   "FIELD9": ""
 },
 {
   "symbol": "MMT",
   "name": "MFS Multimarket Income Trust",
   "last_sale": "5.62",
   "market_cap": "$381.74M",
   "IPOyear": "1987",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mmt",
   "FIELD9": ""
 },
 {
   "symbol": "MFM",
   "name": "MFS Municipal Income Trust",
   "last_sale": "6.51",
   "market_cap": "$268.13M",
   "IPOyear": "1986",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mfm",
   "FIELD9": ""
 },
 {
   "symbol": "MFV",
   "name": "MFS Special Value Trust",
   "last_sale": "5.6735",
   "market_cap": "$40.51M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mfv",
   "FIELD9": ""
 },
 {
   "symbol": "MTG",
   "name": "MGIC Investment Corporation",
   "last_sale": "13.1",
   "market_cap": "$4.74B",
   "IPOyear": "1991",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/mtg",
   "FIELD9": ""
 },
 {
   "symbol": "MGP",
   "name": "MGM Growth Properties LLC",
   "last_sale": "29.32",
   "market_cap": "$7.8B",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/mgp",
   "FIELD9": ""
 },
 {
   "symbol": "MGM",
   "name": "MGM Resorts International",
   "last_sale": "28.49",
   "market_cap": "$15.32B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/mgm",
   "FIELD9": ""
 },
 {
   "symbol": "KORS",
   "name": "Michael Kors Holdings Limited",
   "last_sale": "72.69",
   "market_cap": "$10.85B",
   "IPOyear": "2011",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/kors",
   "FIELD9": ""
 },
 {
   "symbol": "MFGP",
   "name": "Micro Focus Intl PLC",
   "last_sale": "17.87",
   "market_cap": "$7.71B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mfgp",
   "FIELD9": ""
 },
 {
   "symbol": "MAA",
   "name": "Mid-America Apartment Communities, Inc.",
   "last_sale": "103.05",
   "market_cap": "$11.73B",
   "IPOyear": "1994",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/maa",
   "FIELD9": ""
 },
 {
   "symbol": "MAA^I",
   "name": "Mid-America Apartment Communities, Inc.",
   "last_sale": "64.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/maa^i",
   "FIELD9": ""
 },
 {
   "symbol": "MSL",
   "name": "MidSouth Bancorp",
   "last_sale": "15.75",
   "market_cap": "$262.07M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/msl",
   "FIELD9": ""
 },
 {
   "symbol": "MPO",
   "name": "MIDSTATES PETROLEUM COMPANY, INC.",
   "last_sale": "9",
   "market_cap": "$227.31M",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/mpo",
   "FIELD9": ""
 },
 {
   "symbol": "MCRN",
   "name": "Milacron Holdings Corp.",
   "last_sale": "21.29",
   "market_cap": "$1.5B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/mcrn",
   "FIELD9": ""
 },
 {
   "symbol": "MLR",
   "name": "Miller Industries, Inc.",
   "last_sale": "26.45",
   "market_cap": "$301.11M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/mlr",
   "FIELD9": ""
 },
 {
   "symbol": "HIE",
   "name": "Miller/Howard High Income Equity Fund",
   "last_sale": "12.75",
   "market_cap": "$180.91M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hie",
   "FIELD9": ""
 },
 {
   "symbol": "MTX",
   "name": "Minerals Technologies Inc.",
   "last_sale": "68.9",
   "market_cap": "$2.43B",
   "IPOyear": "1992",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/mtx",
   "FIELD9": ""
 },
 {
   "symbol": "MP^D",
   "name": "Mississippi Power Company",
   "last_sale": "25.1642",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mp^d",
   "FIELD9": ""
 },
 {
   "symbol": "MG",
   "name": "Mistras Group Inc",
   "last_sale": "21.79",
   "market_cap": "$618.31M",
   "IPOyear": "2009",
   "sector": "Consumer Services",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/mg",
   "FIELD9": ""
 },
 {
   "symbol": "MUFG",
   "name": "Mitsubishi UFJ Financial Group Inc",
   "last_sale": "6.41",
   "market_cap": "$83.83B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mufg",
   "FIELD9": ""
 },
 {
   "symbol": "MIXT",
   "name": "MiX Telematics Limited",
   "last_sale": "14.88",
   "market_cap": "$336.06M",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/mixt",
   "FIELD9": ""
 },
 {
   "symbol": "MFG",
   "name": "Mizuho Financial Group, Inc.",
   "last_sale": "3.61",
   "market_cap": "$45.78B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/mfg",
   "FIELD9": ""
 },
 {
   "symbol": "MBT",
   "name": "Mobile TeleSystems OJSC",
   "last_sale": "8.48",
   "market_cap": "$7.99B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/mbt",
   "FIELD9": ""
 },
 {
   "symbol": "MODN",
   "name": "Model N, Inc.",
   "last_sale": "16",
   "market_cap": "$500.01M",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/modn",
   "FIELD9": ""
 },
 {
   "symbol": "MOD",
   "name": "Modine Manufacturing Company",
   "last_sale": "15.95",
   "market_cap": "$808.52M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/mod",
   "FIELD9": ""
 },
 {
   "symbol": "MC",
   "name": "Moelis & Company",
   "last_sale": "57.25",
   "market_cap": "$2.63B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/mc",
   "FIELD9": ""
 },
 {
   "symbol": "MHK",
   "name": "Mohawk Industries, Inc.",
   "last_sale": "186.6",
   "market_cap": "$13.92B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/mhk",
   "FIELD9": ""
 },
 {
   "symbol": "MOH",
   "name": "Molina Healthcare Inc",
   "last_sale": "152.72",
   "market_cap": "$9.43B",
   "IPOyear": "2003",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/moh",
   "FIELD9": ""
 },
 {
   "symbol": "TAP",
   "name": "Molson Coors Brewing  Company",
   "last_sale": "64.78",
   "market_cap": "$10.54B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Beverages (Production/Distribution)",
   "summary_quote": "https://www.nasdaq.com/symbol/tap",
   "FIELD9": ""
 },
 {
   "symbol": "TAP.A",
   "name": "Molson Coors Brewing  Company",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tap.a",
   "FIELD9": ""
 },
 {
   "symbol": "MNR",
   "name": "Monmouth Real Estate Investment Corporation",
   "last_sale": "16.79",
   "market_cap": "$1.35B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/mnr",
   "FIELD9": ""
 },
 {
   "symbol": "MNR^C",
   "name": "Monmouth Real Estate Investment Corporation",
   "last_sale": "23.96",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mnr^c",
   "FIELD9": ""
 },
 {
   "symbol": "MCO",
   "name": "Moody&#39;s Corporation",
   "last_sale": "174.59",
   "market_cap": "$33.5B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mco",
   "FIELD9": ""
 },
 {
   "symbol": "MOG.A",
   "name": "Moog Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mog.a",
   "FIELD9": ""
 },
 {
   "symbol": "MOG.B",
   "name": "Moog Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mog.b",
   "FIELD9": ""
 },
 {
   "symbol": "MS",
   "name": "Morgan Stanley",
   "last_sale": "49.41",
   "market_cap": "$86.21B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/ms",
   "FIELD9": ""
 },
 {
   "symbol": "MS^A",
   "name": "Morgan Stanley",
   "last_sale": "22.8",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ms^a",
   "FIELD9": ""
 },
 {
   "symbol": "MS^E",
   "name": "Morgan Stanley",
   "last_sale": "28.56",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ms^e",
   "FIELD9": ""
 },
 {
   "symbol": "MS^F",
   "name": "Morgan Stanley",
   "last_sale": "27.88",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ms^f",
   "FIELD9": ""
 },
 {
   "symbol": "MS^G",
   "name": "Morgan Stanley",
   "last_sale": "26.095",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ms^g",
   "FIELD9": ""
 },
 {
   "symbol": "MS^I",
   "name": "Morgan Stanley",
   "last_sale": "26.98",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ms^i",
   "FIELD9": ""
 },
 {
   "symbol": "MS^K",
   "name": "Morgan Stanley",
   "last_sale": "25.75",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ms^k",
   "FIELD9": ""
 },
 {
   "symbol": "APF",
   "name": "Morgan Stanley Asia-Pacific Fund, Inc.",
   "last_sale": "16.56",
   "market_cap": "$217.43M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/apf",
   "FIELD9": ""
 },
 {
   "symbol": "CAF",
   "name": "Morgan Stanley China A Share Fund Inc.",
   "last_sale": "21.44",
   "market_cap": "$469.14M",
   "IPOyear": "2006",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/caf",
   "FIELD9": ""
 },
 {
   "symbol": "MSD",
   "name": "Morgan Stanley Emerging Markets Debt Fund, Inc.",
   "last_sale": "8.76",
   "market_cap": "$182.76M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/msd",
   "FIELD9": ""
 },
 {
   "symbol": "EDD",
   "name": "Morgan Stanley Emerging Markets Domestic Debt Fund, Inc.",
   "last_sale": "6.66",
   "market_cap": "$445.05M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/edd",
   "FIELD9": ""
 },
 {
   "symbol": "MSF",
   "name": "Morgan Stanley Emerging Markets Fund, Inc.",
   "last_sale": "15.72",
   "market_cap": "$217.84M",
   "IPOyear": "1991",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/msf",
   "FIELD9": ""
 },
 {
   "symbol": "IIF",
   "name": "Morgan Stanley India Investment Fund, Inc.",
   "last_sale": "24.5",
   "market_cap": "$346.11M",
   "IPOyear": "1994",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iif",
   "FIELD9": ""
 },
 {
   "symbol": "MOSC",
   "name": "Mosaic Acquisition Corp.",
   "last_sale": "9.72",
   "market_cap": "$97.2M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/mosc",
   "FIELD9": ""
 },
 {
   "symbol": "MOSC.U",
   "name": "Mosaic Acquisition Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mosc.u",
   "FIELD9": ""
 },
 {
   "symbol": "MOSC.WS",
   "name": "Mosaic Acquisition Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mosc.ws",
   "FIELD9": ""
 },
 {
   "symbol": "MOS",
   "name": "Mosaic Company (The)",
   "last_sale": "32.33",
   "market_cap": "$12.46B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/mos",
   "FIELD9": ""
 },
 {
   "symbol": "MSI",
   "name": "Motorola Solutions, Inc.",
   "last_sale": "128.41",
   "market_cap": "$20.84B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/msi",
   "FIELD9": ""
 },
 {
   "symbol": "MOV",
   "name": "Movado Group Inc.",
   "last_sale": "40.55",
   "market_cap": "$938.73M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Consumer Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/mov",
   "FIELD9": ""
 },
 {
   "symbol": "MPLX",
   "name": "MPLX LP",
   "last_sale": "35.09",
   "market_cap": "$27.86B",
   "IPOyear": "2012",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/mplx",
   "FIELD9": ""
 },
 {
   "symbol": "MRC",
   "name": "MRC Global Inc.",
   "last_sale": "19.07",
   "market_cap": "$1.72B",
   "IPOyear": "2012",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/mrc",
   "FIELD9": ""
 },
 {
   "symbol": "HJV",
   "name": "MS Structured Asset Corp Saturns GE Cap Corp Series 2002-14",
   "last_sale": "8.95",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/hjv",
   "FIELD9": ""
 },
 {
   "symbol": "MSA",
   "name": "MSA Safety Incorporporated",
   "last_sale": "105.07",
   "market_cap": "$4.04B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/msa",
   "FIELD9": ""
 },
 {
   "symbol": "MSM",
   "name": "MSC Industrial Direct Company, Inc.",
   "last_sale": "88.62",
   "market_cap": "$5.01B",
   "IPOyear": "1995",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/msm",
   "FIELD9": ""
 },
 {
   "symbol": "MSCI",
   "name": "MSCI Inc",
   "last_sale": "176.29",
   "market_cap": "$15.66B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/msci",
   "FIELD9": ""
 },
 {
   "symbol": "MSGN",
   "name": "MSG Networks Inc.",
   "last_sale": "24.85",
   "market_cap": "$1.85B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/msgn",
   "FIELD9": ""
 },
 {
   "symbol": "MLI",
   "name": "Mueller Industries, Inc.",
   "last_sale": "28.53",
   "market_cap": "$1.64B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/mli",
   "FIELD9": ""
 },
 {
   "symbol": "MWA",
   "name": "Mueller Water Products Inc",
   "last_sale": "11.93",
   "market_cap": "$1.89B",
   "IPOyear": "2006",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/mwa",
   "FIELD9": ""
 },
 {
   "symbol": "MVF",
   "name": "MuniVest Fund, Inc.",
   "last_sale": "8.63",
   "market_cap": "$559.54M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mvf",
   "FIELD9": ""
 },
 {
   "symbol": "MZA",
   "name": "MuniYield Arizona Fund, Inc.",
   "last_sale": "13.07",
   "market_cap": "$60.57M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mza",
   "FIELD9": ""
 },
 {
   "symbol": "MUR",
   "name": "Murphy Oil Corporation",
   "last_sale": "32.16",
   "market_cap": "$5.57B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/mur",
   "FIELD9": ""
 },
 {
   "symbol": "MUSA",
   "name": "Murphy USA Inc.",
   "last_sale": "85.91",
   "market_cap": "$2.76B",
   "IPOyear": "2013",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/musa",
   "FIELD9": ""
 },
 {
   "symbol": "MVO",
   "name": "MV Oil Trust",
   "last_sale": "11.41",
   "market_cap": "$131.22M",
   "IPOyear": "2007",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/mvo",
   "FIELD9": ""
 },
 {
   "symbol": "MVC",
   "name": "MVC Capital, Inc.",
   "last_sale": "9.75",
   "market_cap": "$183.5M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mvc",
   "FIELD9": ""
 },
 {
   "symbol": "MVCD",
   "name": "MVC Capital, Inc.",
   "last_sale": "25.6789",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mvcd",
   "FIELD9": ""
 },
 {
   "symbol": "MYE",
   "name": "Myers Industries, Inc.",
   "last_sale": "25.45",
   "market_cap": "$895.94M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Plastic Products",
   "summary_quote": "https://www.nasdaq.com/symbol/mye",
   "FIELD9": ""
 },
 {
   "symbol": "MYOV",
   "name": "Myovant Sciences Ltd.",
   "last_sale": "26.78",
   "market_cap": "$1.83B",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/myov",
   "FIELD9": ""
 },
 {
   "symbol": "NBR",
   "name": "Nabors Industries Ltd.",
   "last_sale": "6.24",
   "market_cap": "$2.23B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/nbr",
   "FIELD9": ""
 },
 {
   "symbol": "NBR^A",
   "name": "Nabors Industries Ltd.",
   "last_sale": "44.14",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nbr^a",
   "FIELD9": ""
 },
 {
   "symbol": "NC",
   "name": "NACCO Industries, Inc.",
   "last_sale": "32.95",
   "market_cap": "$228.81M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/nc",
   "FIELD9": ""
 },
 {
   "symbol": "NTP",
   "name": "Nam Tai Property Inc.",
   "last_sale": "10.2",
   "market_cap": "$383.28M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/ntp",
   "FIELD9": ""
 },
 {
   "symbol": "NTEST",
   "name": "NASDAQ TEST STOCK",
   "last_sale": "22.51",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ntest",
   "FIELD9": ""
 },
 {
   "symbol": "NTEST.A",
   "name": "NASDAQ TEST STOCK",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ntest.a",
   "FIELD9": ""
 },
 {
   "symbol": "NTEST.B",
   "name": "NASDAQ TEST STOCK",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ntest.b",
   "FIELD9": ""
 },
 {
   "symbol": "NTEST.C",
   "name": "NASDAQ TEST STOCK",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ntest.c",
   "FIELD9": ""
 },
 {
   "symbol": "NBHC",
   "name": "National Bank Holdings Corporation",
   "last_sale": "37.97",
   "market_cap": "$1.17B",
   "IPOyear": "2012",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/nbhc",
   "FIELD9": ""
 },
 {
   "symbol": "NFG",
   "name": "National Fuel Gas Company",
   "last_sale": "56.24",
   "market_cap": "$4.83B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil/Gas Transmission",
   "summary_quote": "https://www.nasdaq.com/symbol/nfg",
   "FIELD9": ""
 },
 {
   "symbol": "NGG",
   "name": "National Grid Transco, PLC",
   "last_sale": "52.07",
   "market_cap": "$35.39B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/ngg",
   "FIELD9": ""
 },
 {
   "symbol": "NHI",
   "name": "National Health Investors, Inc.",
   "last_sale": "75.46",
   "market_cap": "$3.18B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/nhi",
   "FIELD9": ""
 },
 {
   "symbol": "NOV",
   "name": "National Oilwell Varco, Inc.",
   "last_sale": "43.15",
   "market_cap": "$16.51B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/nov",
   "FIELD9": ""
 },
 {
   "symbol": "NPK",
   "name": "National Presto Industries, Inc.",
   "last_sale": "124.55",
   "market_cap": "$869.17M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Ordnance And Accessories",
   "summary_quote": "https://www.nasdaq.com/symbol/npk",
   "FIELD9": ""
 },
 {
   "symbol": "NNN",
   "name": "National Retail Properties",
   "last_sale": "44.37",
   "market_cap": "$6.97B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/nnn",
   "FIELD9": ""
 },
 {
   "symbol": "NNN^E",
   "name": "National Retail Properties",
   "last_sale": "24.2578",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nnn^e",
   "FIELD9": ""
 },
 {
   "symbol": "NNN^F",
   "name": "National Retail Properties",
   "last_sale": "22.67",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nnn^f",
   "FIELD9": ""
 },
 {
   "symbol": "SID",
   "name": "National Steel Company",
   "last_sale": "2.21",
   "market_cap": "$3.05B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/sid",
   "FIELD9": ""
 },
 {
   "symbol": "NSA",
   "name": "National Storage Affiliates Trust",
   "last_sale": "26.01",
   "market_cap": "$1.47B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/nsa",
   "FIELD9": ""
 },
 {
   "symbol": "NSA^A",
   "name": "National Storage Affiliates Trust",
   "last_sale": "24.89",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nsa^a",
   "FIELD9": ""
 },
 {
   "symbol": "NGS",
   "name": "Natural Gas Services Group, Inc.",
   "last_sale": "20.95",
   "market_cap": "$274.16M",
   "IPOyear": "2002",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ngs",
   "FIELD9": ""
 },
 {
   "symbol": "NGVC",
   "name": "Natural Grocers by Vitamin Cottage, Inc.",
   "last_sale": "16.58",
   "market_cap": "$370.8M",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Food Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/ngvc",
   "FIELD9": ""
 },
 {
   "symbol": "NRP",
   "name": "Natural Resource Partners LP",
   "last_sale": "30.15",
   "market_cap": "$369.21M",
   "IPOyear": "2002",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/nrp",
   "FIELD9": ""
 },
 {
   "symbol": "NTZ",
   "name": "Natuzzi, S.p.A.",
   "last_sale": "1.4785",
   "market_cap": "$81.1M",
   "IPOyear": "1993",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/ntz",
   "FIELD9": ""
 },
 {
   "symbol": "NLS",
   "name": "Nautilus Group, Inc. (The)",
   "last_sale": "14.25",
   "market_cap": "$431.04M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Recreational Products/Toys",
   "summary_quote": "https://www.nasdaq.com/symbol/nls",
   "FIELD9": ""
 },
 {
   "symbol": "NCI",
   "name": "Navigant Consulting, Inc.",
   "last_sale": "23.35",
   "market_cap": "$1.05B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nci",
   "FIELD9": ""
 },
 {
   "symbol": "NVGS",
   "name": "Navigator Holdings Ltd.",
   "last_sale": "12.15",
   "market_cap": "$676.22M",
   "IPOyear": "2013",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/nvgs",
   "FIELD9": ""
 },
 {
   "symbol": "NNA",
   "name": "Navios Maritime Acquisition Corporation",
   "last_sale": "0.57",
   "market_cap": "$82.79M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/nna",
   "FIELD9": ""
 },
 {
   "symbol": "NM",
   "name": "Navios Maritime Holdings Inc.",
   "last_sale": "0.7616",
   "market_cap": "$94.98M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/nm",
   "FIELD9": ""
 },
 {
   "symbol": "NM^G",
   "name": "Navios Maritime Holdings Inc.",
   "last_sale": "11.22",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nm^g",
   "FIELD9": ""
 },
 {
   "symbol": "NM^H",
   "name": "Navios Maritime Holdings Inc.",
   "last_sale": "11",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nm^h",
   "FIELD9": ""
 },
 {
   "symbol": "NAP",
   "name": "Navios Maritime Midstream Partners LP",
   "last_sale": "3.01",
   "market_cap": "$63.05M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nap",
   "FIELD9": ""
 },
 {
   "symbol": "NMM",
   "name": "Navios Maritime Partners LP",
   "last_sale": "1.73",
   "market_cap": "$289.93M",
   "IPOyear": "2007",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/nmm",
   "FIELD9": ""
 },
 {
   "symbol": "NAV",
   "name": "Navistar International Corporation",
   "last_sale": "41.56",
   "market_cap": "$4.11B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/nav",
   "FIELD9": ""
 },
 {
   "symbol": "NAV^D",
   "name": "Navistar International Corporation",
   "last_sale": "24.5824",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/nav^d",
   "FIELD9": ""
 },
 {
   "symbol": "NCS",
   "name": "NCI Building Systems, Inc.",
   "last_sale": "15.8",
   "market_cap": "$1.05B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/ncs",
   "FIELD9": ""
 },
 {
   "symbol": "NCR",
   "name": "NCR Corporation",
   "last_sale": "29.17",
   "market_cap": "$3.44B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ncr",
   "FIELD9": ""
 },
 {
   "symbol": "NP",
   "name": "Neenah, Inc.",
   "last_sale": "92.1",
   "market_cap": "$1.55B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/np",
   "FIELD9": ""
 },
 {
   "symbol": "NNI",
   "name": "Nelnet, Inc.",
   "last_sale": "59.03",
   "market_cap": "$2.41B",
   "IPOyear": "2003",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nni",
   "FIELD9": ""
 },
 {
   "symbol": "NPTN",
   "name": "NeoPhotonics Corporation",
   "last_sale": "7.73",
   "market_cap": "$350.19M",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/nptn",
   "FIELD9": ""
 },
 {
   "symbol": "NETS",
   "name": "Netshoes (Cayman) Limited",
   "last_sale": "2.41",
   "market_cap": "$74.85M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/nets",
   "FIELD9": ""
 },
 {
   "symbol": "NVRO",
   "name": "Nevro Corp.",
   "last_sale": "59.23",
   "market_cap": "$1.78B",
   "IPOyear": "2014",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/nvro",
   "FIELD9": ""
 },
 {
   "symbol": "HYB",
   "name": "New America High Income Fund, Inc. (The)",
   "last_sale": "8.52",
   "market_cap": "$199.1M",
   "IPOyear": "1988",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hyb",
   "FIELD9": ""
 },
 {
   "symbol": "NFC",
   "name": "New Frontier Corporation",
   "last_sale": "9.615",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nfc",
   "FIELD9": ""
 },
 {
   "symbol": "NFC.U",
   "name": "New Frontier Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nfc.u",
   "FIELD9": ""
 },
 {
   "symbol": "NFC.WS",
   "name": "New Frontier Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nfc.ws",
   "FIELD9": ""
 },
 {
   "symbol": "GF",
   "name": "New Germany Fund, Inc. (The)",
   "last_sale": "18.68",
   "market_cap": "$295.41M",
   "IPOyear": "1990",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gf",
   "FIELD9": ""
 },
 {
   "symbol": "NWHM",
   "name": "New Home Company Inc. (The)",
   "last_sale": "8.61",
   "market_cap": "$179.57M",
   "IPOyear": "2014",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/nwhm",
   "FIELD9": ""
 },
 {
   "symbol": "IRL",
   "name": "New Ireland Fund, Inc. (The)",
   "last_sale": "10.6493",
   "market_cap": "$53.05M",
   "IPOyear": "1990",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/irl",
   "FIELD9": ""
 },
 {
   "symbol": "NEWM",
   "name": "New Media Investment Group Inc.",
   "last_sale": "15.69",
   "market_cap": "$946M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Newspapers/Magazines",
   "summary_quote": "https://www.nasdaq.com/symbol/newm",
   "FIELD9": ""
 },
 {
   "symbol": "NMFC",
   "name": "New Mountain Finance Corporation",
   "last_sale": "13.55",
   "market_cap": "$1.03B",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nmfc",
   "FIELD9": ""
 },
 {
   "symbol": "EDU",
   "name": "New Oriental Education & Technology Group, Inc.",
   "last_sale": "75.69",
   "market_cap": "$11.94B",
   "IPOyear": "2006",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/edu",
   "FIELD9": ""
 },
 {
   "symbol": "NEWR",
   "name": "New Relic, Inc.",
   "last_sale": "95.72",
   "market_cap": "$5.41B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/newr",
   "FIELD9": ""
 },
 {
   "symbol": "NRZ",
   "name": "New Residential Investment Corp.",
   "last_sale": "18.16",
   "market_cap": "$6.17B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/nrz",
   "FIELD9": ""
 },
 {
   "symbol": "SNR",
   "name": "New Senior Investment Group Inc.",
   "last_sale": "5.74",
   "market_cap": "$471.53M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/snr",
   "FIELD9": ""
 },
 {
   "symbol": "NWY",
   "name": "New York & Company, Inc.",
   "last_sale": "3.97",
   "market_cap": "$256.98M",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/nwy",
   "FIELD9": ""
 },
 {
   "symbol": "NYCB",
   "name": "New York Community Bancorp, Inc.",
   "last_sale": "11",
   "market_cap": "$5.39B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/nycb",
   "FIELD9": ""
 },
 {
   "symbol": "NYCB^A",
   "name": "New York Community Bancorp, Inc.",
   "last_sale": "26.77",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nycb^a",
   "FIELD9": ""
 },
 {
   "symbol": "NYCB^U",
   "name": "New York Community Bancorp, Inc.",
   "last_sale": "49.22",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nycb^u",
   "FIELD9": ""
 },
 {
   "symbol": "NYRT",
   "name": "New York REIT, Inc.",
   "last_sale": "17.89",
   "market_cap": "$300.4M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/nyrt",
   "FIELD9": ""
 },
 {
   "symbol": "NYT",
   "name": "New York Times Company (The)",
   "last_sale": "23.5",
   "market_cap": "$3.87B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Newspapers/Magazines",
   "summary_quote": "https://www.nasdaq.com/symbol/nyt",
   "FIELD9": ""
 },
 {
   "symbol": "NWL",
   "name": "Newell Brands Inc.",
   "last_sale": "21.84",
   "market_cap": "$10.32B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Plastic Products",
   "summary_quote": "https://www.nasdaq.com/symbol/nwl",
   "FIELD9": ""
 },
 {
   "symbol": "NFX",
   "name": "Newfield Exploration Company",
   "last_sale": "29.03",
   "market_cap": "$5.8B",
   "IPOyear": "1993",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/nfx",
   "FIELD9": ""
 },
 {
   "symbol": "NJR",
   "name": "NewJersey Resources Corporation",
   "last_sale": "46.65",
   "market_cap": "$4.12B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil/Gas Transmission",
   "summary_quote": "https://www.nasdaq.com/symbol/njr",
   "FIELD9": ""
 },
 {
   "symbol": "NEU",
   "name": "NewMarket Corporation",
   "last_sale": "409.4",
   "market_cap": "$4.69B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/neu",
   "FIELD9": ""
 },
 {
   "symbol": "NEM",
   "name": "Newmont Mining Corporation",
   "last_sale": "31.56",
   "market_cap": "$16.83B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/nem",
   "FIELD9": ""
 },
 {
   "symbol": "NR",
   "name": "Newpark Resources, Inc.",
   "last_sale": "10",
   "market_cap": "$905.57M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/nr",
   "FIELD9": ""
 },
 {
   "symbol": "NEXA",
   "name": "Nexa Resources S.A.",
   "last_sale": "12.93",
   "market_cap": "$1.72B",
   "IPOyear": "2017",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/nexa",
   "FIELD9": ""
 },
 {
   "symbol": "NXRT",
   "name": "NexPoint Residential Trust, Inc.",
   "last_sale": "32.67",
   "market_cap": "$677.82M",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/nxrt",
   "FIELD9": ""
 },
 {
   "symbol": "NHF",
   "name": "NexPoint Strategic Opportunities Fund",
   "last_sale": "22.27",
   "market_cap": "$507.6M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nhf",
   "FIELD9": ""
 },
 {
   "symbol": "NEP",
   "name": "NextEra Energy Partners, LP",
   "last_sale": "48.64",
   "market_cap": "$2.64B",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/nep",
   "FIELD9": ""
 },
 {
   "symbol": "NEE",
   "name": "NextEra Energy, Inc.",
   "last_sale": "170.76",
   "market_cap": "$80.53B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/nee",
   "FIELD9": ""
 },
 {
   "symbol": "NEE^I",
   "name": "NextEra Energy, Inc.",
   "last_sale": "24.14",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nee^i",
   "FIELD9": ""
 },
 {
   "symbol": "NEE^J",
   "name": "NextEra Energy, Inc.",
   "last_sale": "24.2",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nee^j",
   "FIELD9": ""
 },
 {
   "symbol": "NEE^K",
   "name": "NextEra Energy, Inc.",
   "last_sale": "24.4719",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nee^k",
   "FIELD9": ""
 },
 {
   "symbol": "NEE^R",
   "name": "NextEra Energy, Inc.",
   "last_sale": "58.3",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nee^r",
   "FIELD9": ""
 },
 {
   "symbol": "NGL",
   "name": "NGL ENERGY PARTNERS LP",
   "last_sale": "11.3",
   "market_cap": "$1.38B",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/ngl",
   "FIELD9": ""
 },
 {
   "symbol": "NGL^B",
   "name": "NGL ENERGY PARTNERS LP",
   "last_sale": "24.7024",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ngl^b",
   "FIELD9": ""
 },
 {
   "symbol": "NMK^B",
   "name": "Niagara Mohawk Holdings, Inc.",
   "last_sale": "94",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/nmk^b",
   "FIELD9": ""
 },
 {
   "symbol": "NMK^C",
   "name": "Niagara Mohawk Holdings, Inc.",
   "last_sale": "96.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/nmk^c",
   "FIELD9": ""
 },
 {
   "symbol": "NLSN",
   "name": "Nielsen N.V.",
   "last_sale": "27.24",
   "market_cap": "$9.68B",
   "IPOyear": "2011",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/nlsn",
   "FIELD9": ""
 },
 {
   "symbol": "NKE",
   "name": "Nike, Inc.",
   "last_sale": "85.55",
   "market_cap": "$136.93B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Shoe Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/nke",
   "FIELD9": ""
 },
 {
   "symbol": "NINE",
   "name": "Nine Energy Service, Inc.",
   "last_sale": "33.02",
   "market_cap": "$827.59M",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/nine",
   "FIELD9": ""
 },
 {
   "symbol": "NIO",
   "name": "NIO Inc.",
   "last_sale": "8.59",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/nio",
   "FIELD9": ""
 },
 {
   "symbol": "NI",
   "name": "NiSource, Inc",
   "last_sale": "25.55",
   "market_cap": "$9.28B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/ni",
   "FIELD9": ""
 },
 {
   "symbol": "NL",
   "name": "NL Industries, Inc.",
   "last_sale": "6.5",
   "market_cap": "$316.73M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/nl",
   "FIELD9": ""
 },
 {
   "symbol": "NOAH",
   "name": "Noah Holdings Ltd.",
   "last_sale": "42.28",
   "market_cap": "$2.43B",
   "IPOyear": "2010",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/noah",
   "FIELD9": ""
 },
 {
   "symbol": "NE",
   "name": "Noble Corporation",
   "last_sale": "6.84",
   "market_cap": "$1.69B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/ne",
   "FIELD9": ""
 },
 {
   "symbol": "NBL",
   "name": "Noble Energy Inc.",
   "last_sale": "30.47",
   "market_cap": "$14.72B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/nbl",
   "FIELD9": ""
 },
 {
   "symbol": "NBLX",
   "name": "Noble Midstream Partners LP",
   "last_sale": "37.02",
   "market_cap": "$1.47B",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/nblx",
   "FIELD9": ""
 },
 {
   "symbol": "NOK",
   "name": "Nokia Corporation",
   "last_sale": "5.59",
   "market_cap": "$31.3B",
   "IPOyear": "1994",
   "sector": "Technology",
   "industry": "Radio And Television Broadcasting And Communications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/nok",
   "FIELD9": ""
 },
 {
   "symbol": "NOMD",
   "name": "Nomad Foods Limited",
   "last_sale": "20.44",
   "market_cap": "$3.56B",
   "IPOyear": "2016",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/nomd",
   "FIELD9": ""
 },
 {
   "symbol": "NMR",
   "name": "Nomura Holdings Inc ADR",
   "last_sale": "4.98",
   "market_cap": "$16.92B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/nmr",
   "FIELD9": ""
 },
 {
   "symbol": "OSB",
   "name": "Norbord Inc.",
   "last_sale": "35.16",
   "market_cap": "$3.05B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Forest Products",
   "summary_quote": "https://www.nasdaq.com/symbol/osb",
   "FIELD9": ""
 },
 {
   "symbol": "NAO",
   "name": "Nordic American Offshore Ltd",
   "last_sale": "1.01",
   "market_cap": "$62.61M",
   "IPOyear": "2014",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/nao",
   "FIELD9": ""
 },
 {
   "symbol": "NAT",
   "name": "Nordic American Tankers Limited",
   "last_sale": "2.2",
   "market_cap": "$312.33M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/nat",
   "FIELD9": ""
 },
 {
   "symbol": "JWN",
   "name": "Nordstrom, Inc.",
   "last_sale": "60.34",
   "market_cap": "$10.17B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/jwn",
   "FIELD9": ""
 },
 {
   "symbol": "NSC",
   "name": "Norfolk Souther Corporation",
   "last_sale": "184.24",
   "market_cap": "$51.59B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/nsc",
   "FIELD9": ""
 },
 {
   "symbol": "NOA",
   "name": "North American Construction Group Ltd.",
   "last_sale": "9.2",
   "market_cap": "$249.25M",
   "IPOyear": "2006",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/noa",
   "FIELD9": ""
 },
 {
   "symbol": "NRT",
   "name": "North European Oil Royality Trust",
   "last_sale": "7.5899",
   "market_cap": "$69.76M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/nrt",
   "FIELD9": ""
 },
 {
   "symbol": "NOC",
   "name": "Northrop Grumman Corporation",
   "last_sale": "306.69",
   "market_cap": "$53.4B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/noc",
   "FIELD9": ""
 },
 {
   "symbol": "NRE",
   "name": "NorthStar Realty Europe Corp.",
   "last_sale": "12.73",
   "market_cap": "$634.12M",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/nre",
   "FIELD9": ""
 },
 {
   "symbol": "NWN",
   "name": "Northwest Natural Gas Company",
   "last_sale": "69.5",
   "market_cap": "$2B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil/Gas Transmission",
   "summary_quote": "https://www.nasdaq.com/symbol/nwn",
   "FIELD9": ""
 },
 {
   "symbol": "NWE",
   "name": "NorthWestern Corporation",
   "last_sale": "59.14",
   "market_cap": "$2.98B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/nwe",
   "FIELD9": ""
 },
 {
   "symbol": "NCLH",
   "name": "Norwegian Cruise Line Holdings Ltd.",
   "last_sale": "57.88",
   "market_cap": "$12.82B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/nclh",
   "FIELD9": ""
 },
 {
   "symbol": "NVS",
   "name": "Novartis AG",
   "last_sale": "85.46",
   "market_cap": "$198.42B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/nvs",
   "FIELD9": ""
 },
 {
   "symbol": "NVO",
   "name": "Novo Nordisk A/S",
   "last_sale": "47.66",
   "market_cap": "$114.86B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/nvo",
   "FIELD9": ""
 },
 {
   "symbol": "DNOW",
   "name": "NOW Inc.",
   "last_sale": "16.81",
   "market_cap": "$1.85B",
   "IPOyear": "2014",
   "sector": "Energy",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/dnow",
   "FIELD9": ""
 },
 {
   "symbol": "NRG",
   "name": "NRG Energy, Inc.",
   "last_sale": "36.16",
   "market_cap": "$10.97B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/nrg",
   "FIELD9": ""
 },
 {
   "symbol": "NUS",
   "name": "Nu Skin Enterprises, Inc.",
   "last_sale": "84.41",
   "market_cap": "$4.69B",
   "IPOyear": "1996",
   "sector": "Health Care",
   "industry": "Other Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/nus",
   "FIELD9": ""
 },
 {
   "symbol": "NUE",
   "name": "Nucor Corporation",
   "last_sale": "64.38",
   "market_cap": "$20.37B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/nue",
   "FIELD9": ""
 },
 {
   "symbol": "NS",
   "name": "Nustar Energy L.P.",
   "last_sale": "27.75",
   "market_cap": "$2.97B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/ns",
   "FIELD9": ""
 },
 {
   "symbol": "NS^A",
   "name": "Nustar Energy L.P.",
   "last_sale": "23.9599",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ns^a",
   "FIELD9": ""
 },
 {
   "symbol": "NS^B",
   "name": "Nustar Energy L.P.",
   "last_sale": "21.75",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ns^b",
   "FIELD9": ""
 },
 {
   "symbol": "NS^C",
   "name": "Nustar Energy L.P.",
   "last_sale": "24.33",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ns^c",
   "FIELD9": ""
 },
 {
   "symbol": "NSS",
   "name": "NuStar Logistics, L.P.",
   "last_sale": "25.67",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nss",
   "FIELD9": ""
 },
 {
   "symbol": "NTR",
   "name": "Nutrien Ltd.",
   "last_sale": "57.28",
   "market_cap": "$35.25B",
   "IPOyear": "2018",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/ntr",
   "FIELD9": ""
 },
 {
   "symbol": "JMLP",
   "name": "Nuveen All Cap Energy MLP Opportunities Fund",
   "last_sale": "7.81",
   "market_cap": "$105.44M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jmlp",
   "FIELD9": ""
 },
 {
   "symbol": "NVG",
   "name": "Nuveen AMT-Free Municipal Credit Income Fund",
   "last_sale": "14.61",
   "market_cap": "$2.96B",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nvg",
   "FIELD9": ""
 },
 {
   "symbol": "NUV",
   "name": "Nuveen AMT-Free Municipal Value Fund",
   "last_sale": "9.34",
   "market_cap": "$1.93B",
   "IPOyear": "1987",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nuv",
   "FIELD9": ""
 },
 {
   "symbol": "NUW",
   "name": "Nuveen AMT-Free Municipal Value Fund",
   "last_sale": "14.85",
   "market_cap": "$228.68M",
   "IPOyear": "2009",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nuw",
   "FIELD9": ""
 },
 {
   "symbol": "NEA",
   "name": "Nuveen AMT-Free Quality Municipal Income Fund",
   "last_sale": "12.69",
   "market_cap": "$3.33B",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nea",
   "FIELD9": ""
 },
 {
   "symbol": "NAZ",
   "name": "Nuveen Arizona Quality Municipal Income Fund",
   "last_sale": "11.7611",
   "market_cap": "$137.59M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/naz",
   "FIELD9": ""
 },
 {
   "symbol": "NBB",
   "name": "Nuveen Build America Bond Fund",
   "last_sale": "20.25",
   "market_cap": "$535.86M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nbb",
   "FIELD9": ""
 },
 {
   "symbol": "NBD",
   "name": "Nuveen Build America Bond Opportunity Fund",
   "last_sale": "21.94",
   "market_cap": "$158.08M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nbd",
   "FIELD9": ""
 },
 {
   "symbol": "NKX",
   "name": "Nuveen California AMT-Free Quality Municipal Income Fund",
   "last_sale": "12.86",
   "market_cap": "$614.07M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nkx",
   "FIELD9": ""
 },
 {
   "symbol": "NCB",
   "name": "Nuveen California Municipal Value Fund 2",
   "last_sale": "15.2",
   "market_cap": "$50.15M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ncb",
   "FIELD9": ""
 },
 {
   "symbol": "NCA",
   "name": "Nuveen California Municipal Value Fund, Inc.",
   "last_sale": "9.31",
   "market_cap": "$261.53M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nca",
   "FIELD9": ""
 },
 {
   "symbol": "NAC",
   "name": "Nuveen California Quality Municipal Income Fund",
   "last_sale": "13.02",
   "market_cap": "$1.89B",
   "IPOyear": "1999",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nac",
   "FIELD9": ""
 },
 {
   "symbol": "NTC",
   "name": "Nuveen Connecticut Quality Municipal Income Fund",
   "last_sale": "11.37",
   "market_cap": "$164.05M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ntc",
   "FIELD9": ""
 },
 {
   "symbol": "JCE",
   "name": "Nuveen Core Equity Alpha Fund",
   "last_sale": "15.57",
   "market_cap": "$249.46M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jce",
   "FIELD9": ""
 },
 {
   "symbol": "JCO",
   "name": "Nuveen Credit Opportunities 2022 Target Term Fund",
   "last_sale": "9.51",
   "market_cap": "$263.27M",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jco",
   "FIELD9": ""
 },
 {
   "symbol": "JQC",
   "name": "Nuveen Credit Strategies Income Fund",
   "last_sale": "7.94",
   "market_cap": "$1.08B",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jqc",
   "FIELD9": ""
 },
 {
   "symbol": "JDD",
   "name": "Nuveen Diversified Dividend and Income Fund",
   "last_sale": "10.98",
   "market_cap": "$216.82M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jdd",
   "FIELD9": ""
 },
 {
   "symbol": "DIAX",
   "name": "Nuveen Dow 30SM Dynamic Overwrite Fund",
   "last_sale": "19.64",
   "market_cap": "$708.91M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/diax",
   "FIELD9": ""
 },
 {
   "symbol": "JEMD",
   "name": "Nuveen Emerging Markets Debt 2022 Target Term Fund",
   "last_sale": "8.17",
   "market_cap": "$116.3M",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jemd",
   "FIELD9": ""
 },
 {
   "symbol": "JMF",
   "name": "Nuveen Energy MLP Total Return Fund",
   "last_sale": "10.83",
   "market_cap": "$441.72M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jmf",
   "FIELD9": ""
 },
 {
   "symbol": "NEV",
   "name": "Nuveen Enhanced Municipal Value Fund",
   "last_sale": "13.14",
   "market_cap": "$327.84M",
   "IPOyear": "2009",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nev",
   "FIELD9": ""
 },
 {
   "symbol": "JFR",
   "name": "Nuveen Floating Rate Income Fund",
   "last_sale": "10.32",
   "market_cap": "$587.4M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jfr",
   "FIELD9": ""
 },
 {
   "symbol": "JRO",
   "name": "Nuveen Floating Rate Income Opportuntiy Fund",
   "last_sale": "10.19",
   "market_cap": "$413.32M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jro",
   "FIELD9": ""
 },
 {
   "symbol": "NKG",
   "name": "Nuveen Georgia Quality Municipal Income Fund ",
   "last_sale": "10.94",
   "market_cap": "$115.41M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nkg",
   "FIELD9": ""
 },
 {
   "symbol": "JGH",
   "name": "Nuveen Global High Income Fund",
   "last_sale": "15.69",
   "market_cap": "$364.51M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jgh",
   "FIELD9": ""
 },
 {
   "symbol": "JHA",
   "name": "Nuveen High Income 2020 Target Term Fund",
   "last_sale": "9.85",
   "market_cap": "$289.05M",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jha",
   "FIELD9": ""
 },
 {
   "symbol": "JHY",
   "name": "Nuveen High Income 2020 Target Term Fund",
   "last_sale": "9.76",
   "market_cap": "$153.65M",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jhy",
   "FIELD9": ""
 },
 {
   "symbol": "JHD",
   "name": "Nuveen High Income December 2019 Target Term Fund",
   "last_sale": "9.84",
   "market_cap": "$266.31M",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jhd",
   "FIELD9": ""
 },
 {
   "symbol": "JHB",
   "name": "Nuveen High Income November 2021 Target Term Fund",
   "last_sale": "9.55",
   "market_cap": "$533.57M",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jhb",
   "FIELD9": ""
 },
 {
   "symbol": "NXC",
   "name": "Nuveen Insured California Select Tax-Free Income Portfolio",
   "last_sale": "13.82",
   "market_cap": "$87.76M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nxc",
   "FIELD9": ""
 },
 {
   "symbol": "NXN",
   "name": "Nuveen Insured New York Select Tax-Free Income Portfolio",
   "last_sale": "12.7",
   "market_cap": "$49.85M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nxn",
   "FIELD9": ""
 },
 {
   "symbol": "NID",
   "name": "Nuveen Intermediate Duration Municipal Term Fund",
   "last_sale": "12.37",
   "market_cap": "$580.27M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nid",
   "FIELD9": ""
 },
 {
   "symbol": "NMY",
   "name": "Nuveen Maryland Quality Municipal Income Fund",
   "last_sale": "11.832",
   "market_cap": "$276.21M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nmy",
   "FIELD9": ""
 },
 {
   "symbol": "NMT",
   "name": "Nuveen Massachusetts Municipal Income Fund",
   "last_sale": "11.89",
   "market_cap": "$111.16M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nmt",
   "FIELD9": ""
 },
 {
   "symbol": "NUM",
   "name": "Nuveen Michigan Quality Municipal Income Fund",
   "last_sale": "12.3672",
   "market_cap": "$255.45M",
   "IPOyear": "1991",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/num",
   "FIELD9": ""
 },
 {
   "symbol": "NMS",
   "name": "Nuveen Minnesota Quality Municipal Income Fund",
   "last_sale": "12.97",
   "market_cap": "$75.13M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nms",
   "FIELD9": ""
 },
 {
   "symbol": "NOM",
   "name": "Nuveen Missouri Quality Municipal Income Fund",
   "last_sale": "12.35",
   "market_cap": "$28.95M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nom",
   "FIELD9": ""
 },
 {
   "symbol": "JLS",
   "name": "Nuveen Mortgage Opportunity Term Fund",
   "last_sale": "23.89",
   "market_cap": "$379.57M",
   "IPOyear": "2009",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jls",
   "FIELD9": ""
 },
 {
   "symbol": "JMM",
   "name": "Nuveen Multi-Market Income Fund",
   "last_sale": "7",
   "market_cap": "$66.24M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jmm",
   "FIELD9": ""
 },
 {
   "symbol": "NHA",
   "name": "Nuveen Municipal 2021 Target Term Fund",
   "last_sale": "9.38",
   "market_cap": "$80.88M",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nha",
   "FIELD9": ""
 },
 {
   "symbol": "NZF",
   "name": "Nuveen Municipal Credit Income Fund",
   "last_sale": "14.34",
   "market_cap": "$2.04B",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nzf",
   "FIELD9": ""
 },
 {
   "symbol": "NMZ",
   "name": "Nuveen Municipal High Income Opportunity Fund",
   "last_sale": "12.48",
   "market_cap": "$799.71M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nmz",
   "FIELD9": ""
 },
 {
   "symbol": "NMI",
   "name": "Nuveen Municipal Income Fund, Inc.",
   "last_sale": "10.36",
   "market_cap": "$90.51M",
   "IPOyear": "1988",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nmi",
   "FIELD9": ""
 },
 {
   "symbol": "NJV",
   "name": "Nuveen New Jersey Municipal Value Fund",
   "last_sale": "12.75",
   "market_cap": "$19.78M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/njv",
   "FIELD9": ""
 },
 {
   "symbol": "NXJ",
   "name": "Nuveen New Jersey Quality Municipal Income Fund",
   "last_sale": "12.8",
   "market_cap": "$540.16M",
   "IPOyear": "2001",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nxj",
   "FIELD9": ""
 },
 {
   "symbol": "NRK",
   "name": "Nuveen New York AMT-Free Quality Municipal",
   "last_sale": "11.82",
   "market_cap": "$1.04B",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nrk",
   "FIELD9": ""
 },
 {
   "symbol": "NYV",
   "name": "Nuveen New York Municipal Value Fund 2",
   "last_sale": "13.4499",
   "market_cap": "$31.6M",
   "IPOyear": "2009",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nyv",
   "FIELD9": ""
 },
 {
   "symbol": "NNY",
   "name": "Nuveen New York Municipal Value Fund, Inc.",
   "last_sale": "9.15",
   "market_cap": "$139.25M",
   "IPOyear": "1988",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nny",
   "FIELD9": ""
 },
 {
   "symbol": "NAN",
   "name": "Nuveen New York Quality Municipal Income Fund",
   "last_sale": "12.27",
   "market_cap": "$381.92M",
   "IPOyear": "1999",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nan",
   "FIELD9": ""
 },
 {
   "symbol": "NNC",
   "name": "Nuveen North Carolina Quality Municipal Income Fd",
   "last_sale": "12.05",
   "market_cap": "$197.56M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nnc",
   "FIELD9": ""
 },
 {
   "symbol": "NUO",
   "name": "Nuveen Ohio Quality Municipal Income Fund",
   "last_sale": "13.46",
   "market_cap": "$248.94M",
   "IPOyear": "1991",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nuo",
   "FIELD9": ""
 },
 {
   "symbol": "NPN",
   "name": "Nuveen Pennsylvania Municipal Value Fund",
   "last_sale": "12.916",
   "market_cap": "$15.79M",
   "IPOyear": "2009",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/npn",
   "FIELD9": ""
 },
 {
   "symbol": "NQP",
   "name": "Nuveen Pennsylvania Quality Municipal Income Fund",
   "last_sale": "12.44",
   "market_cap": "$467.52M",
   "IPOyear": "1991",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nqp",
   "FIELD9": ""
 },
 {
   "symbol": "JPC",
   "name": "Nuveen Preferred & Income Opportunities Fund",
   "last_sale": "9.2",
   "market_cap": "$950.66M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jpc",
   "FIELD9": ""
 },
 {
   "symbol": "JPS",
   "name": "Nuveen Preferred & Income Securities Fund",
   "last_sale": "8.715",
   "market_cap": "$1.78B",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jps",
   "FIELD9": ""
 },
 {
   "symbol": "JPT",
   "name": "Nuveen Preferred and Income 2022 Term Fund",
   "last_sale": "22.97",
   "market_cap": "$156.92M",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jpt",
   "FIELD9": ""
 },
 {
   "symbol": "JPI",
   "name": "Nuveen Preferred and Income Term Fund",
   "last_sale": "22.86",
   "market_cap": "$520.23M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jpi",
   "FIELD9": ""
 },
 {
   "symbol": "NAD",
   "name": "Nuveen Quality Municipal Income Fund",
   "last_sale": "12.76",
   "market_cap": "$2.58B",
   "IPOyear": "1999",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nad",
   "FIELD9": ""
 },
 {
   "symbol": "JRI",
   "name": "Nuveen Real Asset Income and Growth Fund",
   "last_sale": "16.22",
   "market_cap": "$448.2M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jri",
   "FIELD9": ""
 },
 {
   "symbol": "JRS",
   "name": "Nuveen Real Estate Fund",
   "last_sale": "9.97",
   "market_cap": "$288.06M",
   "IPOyear": "2001",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jrs",
   "FIELD9": ""
 },
 {
   "symbol": "BXMX",
   "name": "Nuveen S&P 500 Buy-Write Income Fund",
   "last_sale": "14.4",
   "market_cap": "$1.49B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bxmx",
   "FIELD9": ""
 },
 {
   "symbol": "SPXX",
   "name": "Nuveen S&P 500 Dynamic Overwrite Fund",
   "last_sale": "16.905",
   "market_cap": "$276.79M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/spxx",
   "FIELD9": ""
 },
 {
   "symbol": "NIM",
   "name": "Nuveen Select Maturities Municipal Fund",
   "last_sale": "9.55",
   "market_cap": "$118.85M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nim",
   "FIELD9": ""
 },
 {
   "symbol": "NXP",
   "name": "Nuveen Select Tax Free Income Portfolio",
   "last_sale": "13.88",
   "market_cap": "$230M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nxp",
   "FIELD9": ""
 },
 {
   "symbol": "NXQ",
   "name": "Nuveen Select Tax Free Income Portfolio II",
   "last_sale": "13.27",
   "market_cap": "$235.06M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nxq",
   "FIELD9": ""
 },
 {
   "symbol": "NXR",
   "name": "Nuveen Select Tax Free Income Portfolio III",
   "last_sale": "14.2221",
   "market_cap": "$185.54M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nxr",
   "FIELD9": ""
 },
 {
   "symbol": "NSL",
   "name": "Nuveen Senior Income Fund",
   "last_sale": "6.14",
   "market_cap": "$237.14M",
   "IPOyear": "1999",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/nsl",
   "FIELD9": ""
 },
 {
   "symbol": "JSD",
   "name": "Nuveen Short Duration Credit Opportunities Fund",
   "last_sale": "16.7662",
   "market_cap": "$169.27M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jsd",
   "FIELD9": ""
 },
 {
   "symbol": "JTD",
   "name": "Nuveen Tax-Advantaged Dividend Growth Fund",
   "last_sale": "17.59",
   "market_cap": "$254.78M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jtd",
   "FIELD9": ""
 },
 {
   "symbol": "JTA",
   "name": "Nuveen Tax-Advantaged Total Return Strategy Fund",
   "last_sale": "13.681",
   "market_cap": "$189.39M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jta",
   "FIELD9": ""
 },
 {
   "symbol": "NTX",
   "name": "Nuveen Texas Quality Municipal Income Fund",
   "last_sale": "12.42",
   "market_cap": "$124.54M",
   "IPOyear": "1991",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ntx",
   "FIELD9": ""
 },
 {
   "symbol": "NPV",
   "name": "Nuveen Virginia Quality Municipal Income Fund",
   "last_sale": "11.79",
   "market_cap": "$211.43M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/npv",
   "FIELD9": ""
 },
 {
   "symbol": "NIQ",
   "name": "Nuveenn Intermediate Duration Quality Municipal Term Fund",
   "last_sale": "12.53",
   "market_cap": "$164.11M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/niq",
   "FIELD9": ""
 },
 {
   "symbol": "JMT",
   "name": "Nuven Mortgage Opportunity Term Fund 2",
   "last_sale": "23.09",
   "market_cap": "$112.48M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/jmt",
   "FIELD9": ""
 },
 {
   "symbol": "NVT",
   "name": "nVent Electric plc",
   "last_sale": "29.42",
   "market_cap": "$5.27B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/nvt",
   "FIELD9": ""
 },
 {
   "symbol": "NVR",
   "name": "NVR, Inc.",
   "last_sale": "2583.92",
   "market_cap": "$9.37B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/nvr",
   "FIELD9": ""
 },
 {
   "symbol": "OAK",
   "name": "Oaktree Capital Group, LLC",
   "last_sale": "41.75",
   "market_cap": "$6.56B",
   "IPOyear": "2012",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/oak",
   "FIELD9": ""
 },
 {
   "symbol": "OAK^A",
   "name": "Oaktree Capital Group, LLC",
   "last_sale": "25.065",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/oak^a",
   "FIELD9": ""
 },
 {
   "symbol": "OAK^B",
   "name": "Oaktree Capital Group, LLC",
   "last_sale": "24.9",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/oak^b",
   "FIELD9": ""
 },
 {
   "symbol": "OSLE",
   "name": "Oaktree Specialty Lending Corporation",
   "last_sale": "25.2136",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/osle",
   "FIELD9": ""
 },
 {
   "symbol": "OMP",
   "name": "Oasis Midstream Partners LP",
   "last_sale": "21.73",
   "market_cap": "$598.21M",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/omp",
   "FIELD9": ""
 },
 {
   "symbol": "OAS",
   "name": "Oasis Petroleum Inc.",
   "last_sale": "12.97",
   "market_cap": "$4.12B",
   "IPOyear": "2010",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/oas",
   "FIELD9": ""
 },
 {
   "symbol": "OBE",
   "name": "Obsidian Energy Ltd.",
   "last_sale": "0.9519",
   "market_cap": "$482.79M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/obe",
   "FIELD9": ""
 },
 {
   "symbol": "OXY",
   "name": "Occidental Petroleum Corporation",
   "last_sale": "79.6",
   "market_cap": "$60.87B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/oxy",
   "FIELD9": ""
 },
 {
   "symbol": "OII",
   "name": "Oceaneering International, Inc.",
   "last_sale": "27.26",
   "market_cap": "$2.69B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/oii",
   "FIELD9": ""
 },
 {
   "symbol": "OZM",
   "name": "Och-Ziff Capital Management Group LLC",
   "last_sale": "1.65",
   "market_cap": "$817.17M",
   "IPOyear": "2007",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/ozm",
   "FIELD9": ""
 },
 {
   "symbol": "OCN",
   "name": "Ocwen Financial Corporation",
   "last_sale": "3.97",
   "market_cap": "$531.63M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ocn",
   "FIELD9": ""
 },
 {
   "symbol": "OFG",
   "name": "OFG Bancorp",
   "last_sale": "16.9",
   "market_cap": "$743.32M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ofg",
   "FIELD9": ""
 },
 {
   "symbol": "OFG^A",
   "name": "OFG Bancorp",
   "last_sale": "24.92",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ofg^a",
   "FIELD9": ""
 },
 {
   "symbol": "OFG^B",
   "name": "OFG Bancorp",
   "last_sale": "24.5467",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ofg^b",
   "FIELD9": ""
 },
 {
   "symbol": "OFG^D",
   "name": "OFG Bancorp",
   "last_sale": "25.185",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ofg^d",
   "FIELD9": ""
 },
 {
   "symbol": "OGE",
   "name": "OGE Energy Corp",
   "last_sale": "36.69",
   "market_cap": "$7.33B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/oge",
   "FIELD9": ""
 },
 {
   "symbol": "OIBR.C",
   "name": "Oi S.A.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/oibr.c",
   "FIELD9": ""
 },
 {
   "symbol": "OIS",
   "name": "Oil States International, Inc.",
   "last_sale": "31.85",
   "market_cap": "$1.91B",
   "IPOyear": "2001",
   "sector": "Energy",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/ois",
   "FIELD9": ""
 },
 {
   "symbol": "ODC",
   "name": "Oil-Dri Corporation Of America",
   "last_sale": "38.16",
   "market_cap": "$279.16M",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Miscellaneous manufacturing industries",
   "summary_quote": "https://www.nasdaq.com/symbol/odc",
   "FIELD9": ""
 },
 {
   "symbol": "ORI",
   "name": "Old Republic International Corporation",
   "last_sale": "22.95",
   "market_cap": "$6.94B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/ori",
   "FIELD9": ""
 },
 {
   "symbol": "OLN",
   "name": "Olin Corporation",
   "last_sale": "27.61",
   "market_cap": "$4.61B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/oln",
   "FIELD9": ""
 },
 {
   "symbol": "OHI",
   "name": "Omega Healthcare Investors, Inc.",
   "last_sale": "32.77",
   "market_cap": "$6.57B",
   "IPOyear": "1992",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ohi",
   "FIELD9": ""
 },
 {
   "symbol": "OMC",
   "name": "Omnicom Group Inc.",
   "last_sale": "70.9",
   "market_cap": "$15.91B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/omc",
   "FIELD9": ""
 },
 {
   "symbol": "OMN",
   "name": "OMNOVA Solutions Inc.",
   "last_sale": "10.25",
   "market_cap": "$459.94M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/omn",
   "FIELD9": ""
 },
 {
   "symbol": "ONDK",
   "name": "On Deck Capital, Inc.",
   "last_sale": "7.35",
   "market_cap": "$548.69M",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ondk",
   "FIELD9": ""
 },
 {
   "symbol": "OGS",
   "name": "ONE Gas, Inc.",
   "last_sale": "81.39",
   "market_cap": "$4.27B",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Oil/Gas Transmission",
   "summary_quote": "https://www.nasdaq.com/symbol/ogs",
   "FIELD9": ""
 },
 {
   "symbol": "OLP",
   "name": "One Liberty Properties, Inc.",
   "last_sale": "28.96",
   "market_cap": "$558.58M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/olp",
   "FIELD9": ""
 },
 {
   "symbol": "OMAD",
   "name": "One Madison Corporation",
   "last_sale": "9.73",
   "market_cap": "$401.36M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/omad",
   "FIELD9": ""
 },
 {
   "symbol": "OMAD.U",
   "name": "One Madison Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/omad.u",
   "FIELD9": ""
 },
 {
   "symbol": "OMAD.WS",
   "name": "One Madison Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/omad.ws",
   "FIELD9": ""
 },
 {
   "symbol": "OMF",
   "name": "OneMain Holdings, Inc.",
   "last_sale": "35.71",
   "market_cap": "$4.85B",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/omf",
   "FIELD9": ""
 },
 {
   "symbol": "OKE",
   "name": "ONEOK, Inc.",
   "last_sale": "69.11",
   "market_cap": "$28.42B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/oke",
   "FIELD9": ""
 },
 {
   "symbol": "ONE",
   "name": "OneSmart International Education Group Limited",
   "last_sale": "8.97",
   "market_cap": "$1.46B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/one",
   "FIELD9": ""
 },
 {
   "symbol": "OOMA",
   "name": "Ooma, Inc.",
   "last_sale": "16.8",
   "market_cap": "$332.64M",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ooma",
   "FIELD9": ""
 },
 {
   "symbol": "OPY",
   "name": "Oppenheimer Holdings, Inc.",
   "last_sale": "31.65",
   "market_cap": "$419.68M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/opy",
   "FIELD9": ""
 },
 {
   "symbol": "ORCL",
   "name": "Oracle Corporation",
   "last_sale": "51.1",
   "market_cap": "$203.44B",
   "IPOyear": "1986",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/orcl",
   "FIELD9": ""
 },
 {
   "symbol": "ORAN",
   "name": "Orange",
   "last_sale": "16.12",
   "market_cap": "$42.8B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/oran",
   "FIELD9": ""
 },
 {
   "symbol": "ORC",
   "name": "Orchid Island Capital, Inc.",
   "last_sale": "7.51",
   "market_cap": "$390.78M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/orc",
   "FIELD9": ""
 },
 {
   "symbol": "OEC",
   "name": "Orion Engineered Carbons S.A",
   "last_sale": "32.75",
   "market_cap": "$1.95B",
   "IPOyear": "2014",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/oec",
   "FIELD9": ""
 },
 {
   "symbol": "ORN",
   "name": "Orion Group Holdings, Inc.",
   "last_sale": "7.78",
   "market_cap": "$224.77M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/orn",
   "FIELD9": ""
 },
 {
   "symbol": "IX",
   "name": "Orix Corp Ads",
   "last_sale": "84.46",
   "market_cap": "$21.65B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Diversified Financial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ix",
   "FIELD9": ""
 },
 {
   "symbol": "ORA",
   "name": "Ormat Technologies, Inc.",
   "last_sale": "57.82",
   "market_cap": "$2.93B",
   "IPOyear": "2004",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/ora",
   "FIELD9": ""
 },
 {
   "symbol": "OSK",
   "name": "Oshkosh Corporation",
   "last_sale": "76",
   "market_cap": "$5.56B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/osk",
   "FIELD9": ""
 },
 {
   "symbol": "OR",
   "name": "Osisko Gold Royalties Ltd",
   "last_sale": "7.59",
   "market_cap": "$1.19B",
   "IPOyear": "2016",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/or",
   "FIELD9": ""
 },
 {
   "symbol": "OUT",
   "name": "OUTFRONT Media Inc.",
   "last_sale": "19.98",
   "market_cap": "$2.78B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/out",
   "FIELD9": ""
 },
 {
   "symbol": "OSG",
   "name": "Overseas Shipholding Group, Inc.",
   "last_sale": "3.22",
   "market_cap": "$272.29M",
   "IPOyear": "2015",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/osg",
   "FIELD9": ""
 },
 {
   "symbol": "OMI",
   "name": "Owens & Minor, Inc.",
   "last_sale": "17.16",
   "market_cap": "$1.07B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/omi",
   "FIELD9": ""
 },
 {
   "symbol": "OC",
   "name": "Owens Corning Inc",
   "last_sale": "58.24",
   "market_cap": "$6.46B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/oc",
   "FIELD9": ""
 },
 {
   "symbol": "OI",
   "name": "Owens-Illinois, Inc.",
   "last_sale": "19.63",
   "market_cap": "$3.13B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/oi",
   "FIELD9": ""
 },
 {
   "symbol": "OXM",
   "name": "Oxford Industries, Inc.",
   "last_sale": "89.58",
   "market_cap": "$1.52B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/oxm",
   "FIELD9": ""
 },
 {
   "symbol": "ROYT",
   "name": "Pacific Coast Oil Trust",
   "last_sale": "2.64",
   "market_cap": "$101.86M",
   "IPOyear": "2012",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/royt",
   "FIELD9": ""
 },
 {
   "symbol": "PCG",
   "name": "Pacific Gas & Electric Co.",
   "last_sale": "46.79",
   "market_cap": "$24.2B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/pcg",
   "FIELD9": ""
 },
 {
   "symbol": "PKG",
   "name": "Packaging Corporation of America",
   "last_sale": "116.69",
   "market_cap": "$11.03B",
   "IPOyear": "2000",
   "sector": "Consumer Durables",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/pkg",
   "FIELD9": ""
 },
 {
   "symbol": "PAGS",
   "name": "PagSeguro Digital Ltd.",
   "last_sale": "28.68",
   "market_cap": "$9.04B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pags",
   "FIELD9": ""
 },
 {
   "symbol": "PANW",
   "name": "Palo Alto Networks, Inc.",
   "last_sale": "229.52",
   "market_cap": "$21.53B",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/panw",
   "FIELD9": ""
 },
 {
   "symbol": "PAM",
   "name": "Pampa Energia S.A.",
   "last_sale": "37.77",
   "market_cap": "$2.77B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/pam",
   "FIELD9": ""
 },
 {
   "symbol": "P",
   "name": "Pandora Media, Inc.",
   "last_sale": "9.09",
   "market_cap": "$2.42B",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/p",
   "FIELD9": ""
 },
 {
   "symbol": "PHX",
   "name": "Panhandle Royalty Company",
   "last_sale": "18.75",
   "market_cap": "$314.6M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/phx",
   "FIELD9": ""
 },
 {
   "symbol": "PARR",
   "name": "Par Pacific Holdings, Inc.",
   "last_sale": "20",
   "market_cap": "$917.62M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/parr",
   "FIELD9": ""
 },
 {
   "symbol": "PAR",
   "name": "PAR Technology Corporation",
   "last_sale": "21.6",
   "market_cap": "$349.61M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/par",
   "FIELD9": ""
 },
 {
   "symbol": "PGRE",
   "name": "Paramount Group, Inc.",
   "last_sale": "15.55",
   "market_cap": "$3.74B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/pgre",
   "FIELD9": ""
 },
 {
   "symbol": "PKE",
   "name": "Park Electrochemical Corporation",
   "last_sale": "19.77",
   "market_cap": "$400.23M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/pke",
   "FIELD9": ""
 },
 {
   "symbol": "PK",
   "name": "Park Hotels & Resorts Inc.",
   "last_sale": "32.89",
   "market_cap": "$6.62B",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/pk",
   "FIELD9": ""
 },
 {
   "symbol": "PKD",
   "name": "Parker Drilling Company",
   "last_sale": "3.27",
   "market_cap": "$30.47M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pkd",
   "FIELD9": ""
 },
 {
   "symbol": "PH",
   "name": "Parker-Hannifin Corporation",
   "last_sale": "190.58",
   "market_cap": "$25.23B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/ph",
   "FIELD9": ""
 },
 {
   "symbol": "PE",
   "name": "Parsley Energy, Inc.",
   "last_sale": "28.79",
   "market_cap": "$9.12B",
   "IPOyear": "2014",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pe",
   "FIELD9": ""
 },
 {
   "symbol": "PRE^F",
   "name": "PartnerRe Ltd.",
   "last_sale": "24.99",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pre^f",
   "FIELD9": ""
 },
 {
   "symbol": "PRE^G",
   "name": "PartnerRe Ltd.",
   "last_sale": "26.04",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pre^g",
   "FIELD9": ""
 },
 {
   "symbol": "PRE^H",
   "name": "PartnerRe Ltd.",
   "last_sale": "27.24",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pre^h",
   "FIELD9": ""
 },
 {
   "symbol": "PRE^I",
   "name": "PartnerRe Ltd.",
   "last_sale": "24.98",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pre^i",
   "FIELD9": ""
 },
 {
   "symbol": "PRTY",
   "name": "Party City Holdco Inc.",
   "last_sale": "14.25",
   "market_cap": "$1.37B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/prty",
   "FIELD9": ""
 },
 {
   "symbol": "PAYC",
   "name": "Paycom Software, Inc.",
   "last_sale": "153.65",
   "market_cap": "$9.01B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/payc",
   "FIELD9": ""
 },
 {
   "symbol": "PBF",
   "name": "PBF Energy Inc.",
   "last_sale": "47.83",
   "market_cap": "$5.44B",
   "IPOyear": "2012",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/pbf",
   "FIELD9": ""
 },
 {
   "symbol": "PBFX",
   "name": "PBF Logistics LP",
   "last_sale": "22.05",
   "market_cap": "$999.85M",
   "IPOyear": "2014",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/pbfx",
   "FIELD9": ""
 },
 {
   "symbol": "BTU",
   "name": "Peabody Energy Corporation",
   "last_sale": "42.01",
   "market_cap": "$5.11B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/btu",
   "FIELD9": ""
 },
 {
   "symbol": "PSO",
   "name": "Pearson, Plc",
   "last_sale": "11.47",
   "market_cap": "$8.96B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Books",
   "summary_quote": "https://www.nasdaq.com/symbol/pso",
   "FIELD9": ""
 },
 {
   "symbol": "PEB",
   "name": "Pebblebrook Hotel Trust",
   "last_sale": "36.85",
   "market_cap": "$2.54B",
   "IPOyear": "2009",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/peb",
   "FIELD9": ""
 },
 {
   "symbol": "PEB^C",
   "name": "Pebblebrook Hotel Trust",
   "last_sale": "25.2",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/peb^c",
   "FIELD9": ""
 },
 {
   "symbol": "PEB^D",
   "name": "Pebblebrook Hotel Trust",
   "last_sale": "25.3008",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/peb^d",
   "FIELD9": ""
 },
 {
   "symbol": "PBA",
   "name": "Pembina Pipeline Corp.",
   "last_sale": "33.78",
   "market_cap": "$17.09B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pba",
   "FIELD9": ""
 },
 {
   "symbol": "PEI",
   "name": "Pennsylvania Real Estate Investment Trust",
   "last_sale": "9.55",
   "market_cap": "$672.82M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/pei",
   "FIELD9": ""
 },
 {
   "symbol": "PEI^B",
   "name": "Pennsylvania Real Estate Investment Trust",
   "last_sale": "23.82",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pei^b",
   "FIELD9": ""
 },
 {
   "symbol": "PEI^C",
   "name": "Pennsylvania Real Estate Investment Trust",
   "last_sale": "23.2",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pei^c",
   "FIELD9": ""
 },
 {
   "symbol": "PEI^D",
   "name": "Pennsylvania Real Estate Investment Trust",
   "last_sale": "22.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pei^d",
   "FIELD9": ""
 },
 {
   "symbol": "PFSI",
   "name": "PennyMac Financial Services, Inc.",
   "last_sale": "21.45",
   "market_cap": "$540.17M",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pfsi",
   "FIELD9": ""
 },
 {
   "symbol": "PMT",
   "name": "PennyMac Mortgage Investment Trust",
   "last_sale": "20.27",
   "market_cap": "$1.24B",
   "IPOyear": "2009",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/pmt",
   "FIELD9": ""
 },
 {
   "symbol": "PMT^A",
   "name": "PennyMac Mortgage Investment Trust",
   "last_sale": "25.05",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pmt^a",
   "FIELD9": ""
 },
 {
   "symbol": "PMT^B",
   "name": "PennyMac Mortgage Investment Trust",
   "last_sale": "24.87",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pmt^b",
   "FIELD9": ""
 },
 {
   "symbol": "PAG",
   "name": "Penske Automotive Group, Inc.",
   "last_sale": "50.35",
   "market_cap": "$4.27B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/pag",
   "FIELD9": ""
 },
 {
   "symbol": "PNR",
   "name": "Pentair plc.",
   "last_sale": "44.88",
   "market_cap": "$7.87B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/pnr",
   "FIELD9": ""
 },
 {
   "symbol": "PEN",
   "name": "Penumbra, Inc.",
   "last_sale": "149.35",
   "market_cap": "$5.13B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/pen",
   "FIELD9": ""
 },
 {
   "symbol": "PFGC",
   "name": "Performance Food Group Company",
   "last_sale": "33.4",
   "market_cap": "$3.5B",
   "IPOyear": "2015",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/pfgc",
   "FIELD9": ""
 },
 {
   "symbol": "PKI",
   "name": "PerkinElmer, Inc.",
   "last_sale": "96.61",
   "market_cap": "$10.7B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/pki",
   "FIELD9": ""
 },
 {
   "symbol": "PBT",
   "name": "Permian Basin Royalty Trust",
   "last_sale": "8.4",
   "market_cap": "$391.51M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pbt",
   "FIELD9": ""
 },
 {
   "symbol": "PVL",
   "name": "Permianville Royalty Trust",
   "last_sale": "3.5",
   "market_cap": "$115.5M",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pvl",
   "FIELD9": ""
 },
 {
   "symbol": "PRT",
   "name": "PermRock Royalty Trust",
   "last_sale": "13.01",
   "market_cap": "$158.28M",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/prt",
   "FIELD9": ""
 },
 {
   "symbol": "PRGO",
   "name": "Perrigo Company",
   "last_sale": "73.56",
   "market_cap": "$10.07B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/prgo",
   "FIELD9": ""
 },
 {
   "symbol": "PRSP",
   "name": "Perspecta Inc.",
   "last_sale": "25.68",
   "market_cap": "$4.26B",
   "IPOyear": "1998",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/prsp",
   "FIELD9": ""
 },
 {
   "symbol": "PTR",
   "name": "PetroChina Company Limited",
   "last_sale": "77.48",
   "market_cap": "$141.8B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/ptr",
   "FIELD9": ""
 },
 {
   "symbol": "PBR",
   "name": "Petroleo Brasileiro S.A.- Petrobras",
   "last_sale": "11.5",
   "market_cap": "$75.01B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pbr",
   "FIELD9": ""
 },
 {
   "symbol": "PBR.A",
   "name": "Petroleo Brasileiro S.A.- Petrobras",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pbr.a",
   "FIELD9": ""
 },
 {
   "symbol": "PFE",
   "name": "Pfizer, Inc.",
   "last_sale": "44.06",
   "market_cap": "$258.28B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/pfe",
   "FIELD9": ""
 },
 {
   "symbol": "GHY",
   "name": "PGIM Global Short Duration High Yield Fund, Inc.",
   "last_sale": "13.79",
   "market_cap": "$564.34M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ghy",
   "FIELD9": ""
 },
 {
   "symbol": "ISD",
   "name": "PGIM Short Duration High Yield Fund, Inc.",
   "last_sale": "14.14",
   "market_cap": "$470.25M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/isd",
   "FIELD9": ""
 },
 {
   "symbol": "PGTI",
   "name": "PGT Innovations, Inc.",
   "last_sale": "21.65",
   "market_cap": "$1.25B",
   "IPOyear": "2006",
   "sector": "Capital Goods",
   "industry": "Building Products",
   "summary_quote": "https://www.nasdaq.com/symbol/pgti",
   "FIELD9": ""
 },
 {
   "symbol": "PHH",
   "name": "PHH Corp",
   "last_sale": "10.85",
   "market_cap": "$353.51M",
   "IPOyear": "2002",
   "sector": "Finance",
   "industry": "Diversified Financial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/phh",
   "FIELD9": ""
 },
 {
   "symbol": "PM",
   "name": "Philip Morris International Inc",
   "last_sale": "83.75",
   "market_cap": "$130.19B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/pm",
   "FIELD9": ""
 },
 {
   "symbol": "PSX",
   "name": "Phillips 66",
   "last_sale": "111.66",
   "market_cap": "$51.84B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/psx",
   "FIELD9": ""
 },
 {
   "symbol": "PSXP",
   "name": "Phillips 66 Partners LP",
   "last_sale": "51.61",
   "market_cap": "$6.34B",
   "IPOyear": "2013",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/psxp",
   "FIELD9": ""
 },
 {
   "symbol": "FENG",
   "name": "Phoenix New Media Limited",
   "last_sale": "4.21",
   "market_cap": "$306.23M",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/feng",
   "FIELD9": ""
 },
 {
   "symbol": "DOC",
   "name": "Physicians Realty Trust",
   "last_sale": "16.81",
   "market_cap": "$3.06B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/doc",
   "FIELD9": ""
 },
 {
   "symbol": "PDM",
   "name": "Piedmont Office Realty Trust, Inc.",
   "last_sale": "19.22",
   "market_cap": "$2.47B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Building operators",
   "summary_quote": "https://www.nasdaq.com/symbol/pdm",
   "FIELD9": ""
 },
 {
   "symbol": "PIR",
   "name": "Pier 1 Imports, Inc.",
   "last_sale": "1.45",
   "market_cap": "$124.23M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/pir",
   "FIELD9": ""
 },
 {
   "symbol": "PCQ",
   "name": "PIMCO California Municipal Income Fund",
   "last_sale": "16.06",
   "market_cap": "$301.39M",
   "IPOyear": "2001",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pcq",
   "FIELD9": ""
 },
 {
   "symbol": "PCK",
   "name": "Pimco California Municipal Income Fund II",
   "last_sale": "8.32",
   "market_cap": "$266.12M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pck",
   "FIELD9": ""
 },
 {
   "symbol": "PZC",
   "name": "PIMCO California Municipal Income Fund III",
   "last_sale": "10.1",
   "market_cap": "$225M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pzc",
   "FIELD9": ""
 },
 {
   "symbol": "PCM",
   "name": "PIMCO Commercial Mortgage Securities Trust, Inc.",
   "last_sale": "11.49",
   "market_cap": "$133.08M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pcm",
   "FIELD9": ""
 },
 {
   "symbol": "PTY",
   "name": "Pimco Corporate & Income Opportunity Fund",
   "last_sale": "17.77",
   "market_cap": "$1.48B",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pty",
   "FIELD9": ""
 },
 {
   "symbol": "PCN",
   "name": "Pimco Corporate & Income Stategy Fund",
   "last_sale": "18.4",
   "market_cap": "$724.69M",
   "IPOyear": "2001",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pcn",
   "FIELD9": ""
 },
 {
   "symbol": "PCI",
   "name": "PIMCO Dynamic Credit and Mortgage Income Fund",
   "last_sale": "24.15",
   "market_cap": "$3.31B",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pci",
   "FIELD9": ""
 },
 {
   "symbol": "PDI",
   "name": "PIMCO Dynamic Income Fund",
   "last_sale": "33.1",
   "market_cap": "$1.85B",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pdi",
   "FIELD9": ""
 },
 {
   "symbol": "PGP",
   "name": "Pimco Global Stocksplus & Income Fund",
   "last_sale": "13.92",
   "market_cap": "$150.22M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pgp",
   "FIELD9": ""
 },
 {
   "symbol": "PHK",
   "name": "Pimco High Income Fund",
   "last_sale": "8",
   "market_cap": "$1.04B",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/phk",
   "FIELD9": ""
 },
 {
   "symbol": "PKO",
   "name": "Pimco Income Opportunity Fund",
   "last_sale": "27.36",
   "market_cap": "$418.59M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pko",
   "FIELD9": ""
 },
 {
   "symbol": "PFL",
   "name": "PIMCO Income Strategy Fund",
   "last_sale": "11.99",
   "market_cap": "$306.69M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pfl",
   "FIELD9": ""
 },
 {
   "symbol": "PFN",
   "name": "PIMCO Income Strategy Fund II",
   "last_sale": "10.55",
   "market_cap": "$630.1M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pfn",
   "FIELD9": ""
 },
 {
   "symbol": "PMF",
   "name": "PIMCO Municipal Income Fund",
   "last_sale": "13.0399",
   "market_cap": "$335.41M",
   "IPOyear": "2001",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pmf",
   "FIELD9": ""
 },
 {
   "symbol": "PML",
   "name": "Pimco Municipal Income Fund II",
   "last_sale": "13.04",
   "market_cap": "$810.61M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pml",
   "FIELD9": ""
 },
 {
   "symbol": "PMX",
   "name": "PIMCO Municipal Income Fund III",
   "last_sale": "11.51",
   "market_cap": "$378.56M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pmx",
   "FIELD9": ""
 },
 {
   "symbol": "PNF",
   "name": "PIMCO New York Municipal Income Fund",
   "last_sale": "11.585",
   "market_cap": "$90.1M",
   "IPOyear": "2001",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pnf",
   "FIELD9": ""
 },
 {
   "symbol": "PNI",
   "name": "Pimco New York Municipal Income Fund II",
   "last_sale": "11.4819",
   "market_cap": "$127.96M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pni",
   "FIELD9": ""
 },
 {
   "symbol": "PYN",
   "name": "PIMCO New York Municipal Income Fund III",
   "last_sale": "9.5522",
   "market_cap": "$54.53M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pyn",
   "FIELD9": ""
 },
 {
   "symbol": "RCS",
   "name": "PIMCO Strategic Income Fund, Inc.",
   "last_sale": "9.37",
   "market_cap": "$403.5M",
   "IPOyear": "1994",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rcs",
   "FIELD9": ""
 },
 {
   "symbol": "PF",
   "name": "Pinnacle Foods, Inc.",
   "last_sale": "67.07",
   "market_cap": "$7.99B",
   "IPOyear": "2013",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/pf",
   "FIELD9": ""
 },
 {
   "symbol": "PNW",
   "name": "Pinnacle West Capital Corporation",
   "last_sale": "80.22",
   "market_cap": "$8.98B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/pnw",
   "FIELD9": ""
 },
 {
   "symbol": "PES",
   "name": "Pioneer Energy Services Corp.",
   "last_sale": "3.4",
   "market_cap": "$265.93M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pes",
   "FIELD9": ""
 },
 {
   "symbol": "PHD",
   "name": "Pioneer Floating Rate Trust",
   "last_sale": "11.03",
   "market_cap": "$272.86M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/phd",
   "FIELD9": ""
 },
 {
   "symbol": "PHT",
   "name": "Pioneer High Income Trust",
   "last_sale": "9.16",
   "market_cap": "$267.76M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pht",
   "FIELD9": ""
 },
 {
   "symbol": "MAV",
   "name": "Pioneer Municipal High Income Advantage Trust",
   "last_sale": "10.83",
   "market_cap": "$258.72M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mav",
   "FIELD9": ""
 },
 {
   "symbol": "MHI",
   "name": "Pioneer Municipal High Income Trust",
   "last_sale": "11.33",
   "market_cap": "$258M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mhi",
   "FIELD9": ""
 },
 {
   "symbol": "PXD",
   "name": "Pioneer Natural Resources Company",
   "last_sale": "172.52",
   "market_cap": "$29.4B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pxd",
   "FIELD9": ""
 },
 {
   "symbol": "PJC",
   "name": "Piper Jaffray Companies",
   "last_sale": "79.1",
   "market_cap": "$1.2B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/pjc",
   "FIELD9": ""
 },
 {
   "symbol": "PBI",
   "name": "Pitney Bowes Inc.",
   "last_sale": "7.48",
   "market_cap": "$1.41B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pbi",
   "FIELD9": ""
 },
 {
   "symbol": "PBI^B",
   "name": "Pitney Bowes Inc.",
   "last_sale": "23.43",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pbi^b",
   "FIELD9": ""
 },
 {
   "symbol": "PVTL",
   "name": "Pivotal Software, Inc.",
   "last_sale": "19.82",
   "market_cap": "$5.1B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/pvtl",
   "FIELD9": ""
 },
 {
   "symbol": "PJT",
   "name": "PJT Partners Inc.",
   "last_sale": "53.26",
   "market_cap": "$1.09B",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/pjt",
   "FIELD9": ""
 },
 {
   "symbol": "PAA",
   "name": "Plains All American Pipeline, L.P.",
   "last_sale": "24.83",
   "market_cap": "$18.02B",
   "IPOyear": "1998",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/paa",
   "FIELD9": ""
 },
 {
   "symbol": "PAGP",
   "name": "Plains Group Holdings, L.P.",
   "last_sale": "24.15",
   "market_cap": "$3.81B",
   "IPOyear": "2013",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/pagp",
   "FIELD9": ""
 },
 {
   "symbol": "PLNT",
   "name": "Planet Fitness, Inc.",
   "last_sale": "50.27",
   "market_cap": "$4.95B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/plnt",
   "FIELD9": ""
 },
 {
   "symbol": "PLT",
   "name": "Plantronics, Inc.",
   "last_sale": "58.93",
   "market_cap": "$2.34B",
   "IPOyear": "1994",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/plt",
   "FIELD9": ""
 },
 {
   "symbol": "PAH",
   "name": "Platform Specialty Products Corporation",
   "last_sale": "12.79",
   "market_cap": "$3.69B",
   "IPOyear": "2014",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/pah",
   "FIELD9": ""
 },
 {
   "symbol": "AGS",
   "name": "PlayAGS, Inc.",
   "last_sale": "29.82",
   "market_cap": "$1.05B",
   "IPOyear": "2018",
   "sector": "Consumer Durables",
   "industry": "Miscellaneous manufacturing industries",
   "summary_quote": "https://www.nasdaq.com/symbol/ags",
   "FIELD9": ""
 },
 {
   "symbol": "PHI",
   "name": "PLDT Inc.",
   "last_sale": "25.69",
   "market_cap": "$5.55B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/phi",
   "FIELD9": ""
 },
 {
   "symbol": "PNC",
   "name": "PNC Financial Services Group, Inc. (The)",
   "last_sale": "144.01",
   "market_cap": "$66.86B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pnc",
   "FIELD9": ""
 },
 {
   "symbol": "PNC.WS",
   "name": "PNC Financial Services Group, Inc. (The)",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pnc.ws",
   "FIELD9": ""
 },
 {
   "symbol": "PNC^P",
   "name": "PNC Financial Services Group, Inc. (The)",
   "last_sale": "26.98",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pnc^p",
   "FIELD9": ""
 },
 {
   "symbol": "PNC^Q",
   "name": "PNC Financial Services Group, Inc. (The)",
   "last_sale": "24.91",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pnc^q",
   "FIELD9": ""
 },
 {
   "symbol": "PNM",
   "name": "PNM Resources, Inc. (Holding Co.)",
   "last_sale": "39.4",
   "market_cap": "$3.14B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/pnm",
   "FIELD9": ""
 },
 {
   "symbol": "PII",
   "name": "Polaris Industries Inc.",
   "last_sale": "106.85",
   "market_cap": "$6.65B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/pii",
   "FIELD9": ""
 },
 {
   "symbol": "POL",
   "name": "PolyOne Corporation",
   "last_sale": "45.17",
   "market_cap": "$3.61B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/pol",
   "FIELD9": ""
 },
 {
   "symbol": "POR",
   "name": "Portland General Electric Company",
   "last_sale": "45.81",
   "market_cap": "$4.09B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/por",
   "FIELD9": ""
 },
 {
   "symbol": "PKX",
   "name": "POSCO",
   "last_sale": "67.76",
   "market_cap": "$21.68B",
   "IPOyear": "1994",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/pkx",
   "FIELD9": ""
 },
 {
   "symbol": "POST",
   "name": "Post Holdings, Inc.",
   "last_sale": "100.47",
   "market_cap": "$6.69B",
   "IPOyear": "2012",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/post",
   "FIELD9": ""
 },
 {
   "symbol": "PPDF",
   "name": "PPDAI Group Inc.",
   "last_sale": "6.6",
   "market_cap": "$1.98B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ppdf",
   "FIELD9": ""
 },
 {
   "symbol": "PPG",
   "name": "PPG Industries, Inc.",
   "last_sale": "115.98",
   "market_cap": "$28.07B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Paints/Coatings",
   "summary_quote": "https://www.nasdaq.com/symbol/ppg",
   "FIELD9": ""
 },
 {
   "symbol": "PPX",
   "name": "PPL Capital Funding, Inc.",
   "last_sale": "25.18",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/ppx",
   "FIELD9": ""
 },
 {
   "symbol": "PPL",
   "name": "PPL Corporation",
   "last_sale": "29.68",
   "market_cap": "$20.76B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/ppl",
   "FIELD9": ""
 },
 {
   "symbol": "PYS",
   "name": "PPlus Trust",
   "last_sale": "17.93",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pys",
   "FIELD9": ""
 },
 {
   "symbol": "PYT",
   "name": "PPlus Trust",
   "last_sale": "21.95",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pyt",
   "FIELD9": ""
 },
 {
   "symbol": "PQG",
   "name": "PQ Group Holdings Inc.",
   "last_sale": "17.73",
   "market_cap": "$2.4B",
   "IPOyear": "2017",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/pqg",
   "FIELD9": ""
 },
 {
   "symbol": "PX",
   "name": "Praxair, Inc.",
   "last_sale": "166.5",
   "market_cap": "$47.88B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/px",
   "FIELD9": ""
 },
 {
   "symbol": "PDS",
   "name": "Precision Drilling Corporation",
   "last_sale": "3.65",
   "market_cap": "$1.07B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/pds",
   "FIELD9": ""
 },
 {
   "symbol": "APTS",
   "name": "Preferred Apartment Communities, Inc.",
   "last_sale": "17.32",
   "market_cap": "$693.47M",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/apts",
   "FIELD9": ""
 },
 {
   "symbol": "PBH",
   "name": "Prestige Consumer Healthcare Inc.",
   "last_sale": "39.07",
   "market_cap": "$2.02B",
   "IPOyear": "2005",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/pbh",
   "FIELD9": ""
 },
 {
   "symbol": "PVG",
   "name": "Pretium Resources, Inc.",
   "last_sale": "8.11",
   "market_cap": "$1.48B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/pvg",
   "FIELD9": ""
 },
 {
   "symbol": "PRI",
   "name": "Primerica, Inc.",
   "last_sale": "122.35",
   "market_cap": "$5.28B",
   "IPOyear": "2010",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/pri",
   "FIELD9": ""
 },
 {
   "symbol": "PGZ",
   "name": "Principal Real Estate Income Fund",
   "last_sale": "17.69",
   "market_cap": "$122.06M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pgz",
   "FIELD9": ""
 },
 {
   "symbol": "PRIF^A",
   "name": "Priority Income Fund, Inc.",
   "last_sale": "25.01",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/prif^a",
   "FIELD9": ""
 },
 {
   "symbol": "PRA",
   "name": "ProAssurance Corporation",
   "last_sale": "47.9",
   "market_cap": "$2.57B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/pra",
   "FIELD9": ""
 },
 {
   "symbol": "PG",
   "name": "Procter & Gamble Company (The)",
   "last_sale": "85.82",
   "market_cap": "$213.62B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/pg",
   "FIELD9": ""
 },
 {
   "symbol": "PGR",
   "name": "Progressive Corporation (The)",
   "last_sale": "70.72",
   "market_cap": "$41.24B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/pgr",
   "FIELD9": ""
 },
 {
   "symbol": "PLD",
   "name": "Prologis, Inc.",
   "last_sale": "67.49",
   "market_cap": "$42.49B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/pld",
   "FIELD9": ""
 },
 {
   "symbol": "PUMP",
   "name": "ProPetro Holding Corp.",
   "last_sale": "17.33",
   "market_cap": "$1.45B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/pump",
   "FIELD9": ""
 },
 {
   "symbol": "PRO",
   "name": "PROS Holdings, Inc.",
   "last_sale": "36.46",
   "market_cap": "$1.19B",
   "IPOyear": "2007",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/pro",
   "FIELD9": ""
 },
 {
   "symbol": "PBB",
   "name": "Prospect Capital Corporation",
   "last_sale": "25.02",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pbb",
   "FIELD9": ""
 },
 {
   "symbol": "PBY",
   "name": "Prospect Capital Corporation",
   "last_sale": "24.9",
   "market_cap": "$1.35B",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pby",
   "FIELD9": ""
 },
 {
   "symbol": "PB",
   "name": "Prosperity Bancshares, Inc.",
   "last_sale": "73.24",
   "market_cap": "$5.11B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/pb",
   "FIELD9": ""
 },
 {
   "symbol": "PRLB",
   "name": "Proto Labs, Inc.",
   "last_sale": "161.5",
   "market_cap": "$4.36B",
   "IPOyear": "2012",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/prlb",
   "FIELD9": ""
 },
 {
   "symbol": "PFS",
   "name": "Provident Financial Services, Inc",
   "last_sale": "24.94",
   "market_cap": "$1.67B",
   "IPOyear": "2003",
   "sector": "Finance",
   "industry": "Savings Institutions",
   "summary_quote": "https://www.nasdaq.com/symbol/pfs",
   "FIELD9": ""
 },
 {
   "symbol": "PJH",
   "name": "Prudential Financial, Inc.",
   "last_sale": "25.0701",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/pjh",
   "FIELD9": ""
 },
 {
   "symbol": "PRH",
   "name": "Prudential Financial, Inc.",
   "last_sale": "25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/prh",
   "FIELD9": ""
 },
 {
   "symbol": "PRS",
   "name": "Prudential Financial, Inc.",
   "last_sale": "24.71",
   "market_cap": "$538.34M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/prs",
   "FIELD9": ""
 },
 {
   "symbol": "PRU",
   "name": "Prudential Financial, Inc.",
   "last_sale": "104.68",
   "market_cap": "$43.65B",
   "IPOyear": "2001",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/pru",
   "FIELD9": ""
 },
 {
   "symbol": "PUK",
   "name": "Prudential Public Limited Company",
   "last_sale": "47.37",
   "market_cap": "$61.39B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/puk",
   "FIELD9": ""
 },
 {
   "symbol": "PUK^",
   "name": "Prudential Public Limited Company",
   "last_sale": "25.981",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/puk^",
   "FIELD9": ""
 },
 {
   "symbol": "PUK^A",
   "name": "Prudential Public Limited Company",
   "last_sale": "25.96",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/puk^a",
   "FIELD9": ""
 },
 {
   "symbol": "PSB",
   "name": "PS Business Parks, Inc.",
   "last_sale": "129.27",
   "market_cap": "$3.53B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/psb",
   "FIELD9": ""
 },
 {
   "symbol": "PSB^U",
   "name": "PS Business Parks, Inc.",
   "last_sale": "24.67",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psb^u",
   "FIELD9": ""
 },
 {
   "symbol": "PSB^V",
   "name": "PS Business Parks, Inc.",
   "last_sale": "24.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psb^v",
   "FIELD9": ""
 },
 {
   "symbol": "PSB^W",
   "name": "PS Business Parks, Inc.",
   "last_sale": "22.81",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psb^w",
   "FIELD9": ""
 },
 {
   "symbol": "PSB^X",
   "name": "PS Business Parks, Inc.",
   "last_sale": "22.832",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psb^x",
   "FIELD9": ""
 },
 {
   "symbol": "PSB^Y",
   "name": "PS Business Parks, Inc.",
   "last_sale": "22.4495",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psb^y",
   "FIELD9": ""
 },
 {
   "symbol": "TLK",
   "name": "PT Telekomunikasi Indonesia, Tbk",
   "last_sale": "24.29",
   "market_cap": "$23.64B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tlk",
   "FIELD9": ""
 },
 {
   "symbol": "PEG",
   "name": "Public Service Enterprise Group Incorporated",
   "last_sale": "52.14",
   "market_cap": "$26.35B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/peg",
   "FIELD9": ""
 },
 {
   "symbol": "PSA",
   "name": "Public Storage",
   "last_sale": "204.23",
   "market_cap": "$35.59B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/psa",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^A",
   "name": "Public Storage",
   "last_sale": "25.33",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^a",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^B",
   "name": "Public Storage",
   "last_sale": "24.38",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^b",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^C",
   "name": "Public Storage",
   "last_sale": "24.224",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^c",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^D",
   "name": "Public Storage",
   "last_sale": "23.39",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^d",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^E",
   "name": "Public Storage",
   "last_sale": "23.16",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^e",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^F",
   "name": "Public Storage",
   "last_sale": "23.8984",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^f",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^G",
   "name": "Public Storage",
   "last_sale": "24.21",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^g",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^U",
   "name": "Public Storage",
   "last_sale": "24.9346",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^u",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^V",
   "name": "Public Storage",
   "last_sale": "24.4377",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^v",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^W",
   "name": "Public Storage",
   "last_sale": "24",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^w",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^X",
   "name": "Public Storage",
   "last_sale": "23.9692",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^x",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^Y",
   "name": "Public Storage",
   "last_sale": "25.43",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^y",
   "FIELD9": ""
 },
 {
   "symbol": "PSA^Z",
   "name": "Public Storage",
   "last_sale": "25.425",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/psa^z",
   "FIELD9": ""
 },
 {
   "symbol": "PHM",
   "name": "PulteGroup, Inc.",
   "last_sale": "26.26",
   "market_cap": "$7.46B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/phm",
   "FIELD9": ""
 },
 {
   "symbol": "PSTG",
   "name": "Pure Storage, Inc. ",
   "last_sale": "26.88",
   "market_cap": "$6.35B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/pstg",
   "FIELD9": ""
 },
 {
   "symbol": "PMM",
   "name": "Putnam Managed Municipal Income Trust",
   "last_sale": "7.03",
   "market_cap": "$368.54M",
   "IPOyear": "1989",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pmm",
   "FIELD9": ""
 },
 {
   "symbol": "PIM",
   "name": "Putnam Master Intermediate Income Trust",
   "last_sale": "4.51",
   "market_cap": "$241.52M",
   "IPOyear": "1988",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pim",
   "FIELD9": ""
 },
 {
   "symbol": "PMO",
   "name": "Putnam Municipal Opportunities Trust",
   "last_sale": "11.39",
   "market_cap": "$424.05M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pmo",
   "FIELD9": ""
 },
 {
   "symbol": "PPT",
   "name": "Putnam Premier Income Trust",
   "last_sale": "5.18",
   "market_cap": "$555.58M",
   "IPOyear": "1988",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ppt",
   "FIELD9": ""
 },
 {
   "symbol": "NEW",
   "name": "Puxin Limited",
   "last_sale": "9.1",
   "market_cap": "$706.42M",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/new",
   "FIELD9": ""
 },
 {
   "symbol": "PVH",
   "name": "PVH Corp.",
   "last_sale": "141.62",
   "market_cap": "$10.86B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/pvh",
   "FIELD9": ""
 },
 {
   "symbol": "PYX",
   "name": "Pyxus International, Inc.",
   "last_sale": "25",
   "market_cap": "$245.54M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/pyx",
   "FIELD9": ""
 },
 {
   "symbol": "PZN",
   "name": "Pzena Investment Management Inc",
   "last_sale": "9.26",
   "market_cap": "$643.11M",
   "IPOyear": "2007",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/pzn",
   "FIELD9": ""
 },
 {
   "symbol": "QTWO",
   "name": "Q2 Holdings, Inc.",
   "last_sale": "61.6",
   "market_cap": "$2.64B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/qtwo",
   "FIELD9": ""
 },
 {
   "symbol": "QEP",
   "name": "QEP Resources, Inc.",
   "last_sale": "11.09",
   "market_cap": "$2.63B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/qep",
   "FIELD9": ""
 },
 {
   "symbol": "QGEN",
   "name": "Qiagen N.V.",
   "last_sale": "37.47",
   "market_cap": "$8.51B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Biological Products (No Diagnostic Substances)",
   "summary_quote": "https://www.nasdaq.com/symbol/qgen",
   "FIELD9": ""
 },
 {
   "symbol": "QTS",
   "name": "QTS Realty Trust, Inc.",
   "last_sale": "45.04",
   "market_cap": "$2.3B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/qts",
   "FIELD9": ""
 },
 {
   "symbol": "QTS^A",
   "name": "QTS Realty Trust, Inc.",
   "last_sale": "25.745",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qts^a",
   "FIELD9": ""
 },
 {
   "symbol": "QTS^B",
   "name": "QTS Realty Trust, Inc.",
   "last_sale": "111.2",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/qts^b",
   "FIELD9": ""
 },
 {
   "symbol": "QUAD",
   "name": "Quad Graphics, Inc",
   "last_sale": "22.06",
   "market_cap": "$1.14B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Publishing",
   "summary_quote": "https://www.nasdaq.com/symbol/quad",
   "FIELD9": ""
 },
 {
   "symbol": "KWR",
   "name": "Quaker Chemical Corporation",
   "last_sale": "198.74",
   "market_cap": "$2.65B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/kwr",
   "FIELD9": ""
 },
 {
   "symbol": "NX",
   "name": "Quanex Building Products Corporation",
   "last_sale": "18.5",
   "market_cap": "$650.55M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/nx",
   "FIELD9": ""
 },
 {
   "symbol": "PWR",
   "name": "Quanta Services, Inc.",
   "last_sale": "34.48",
   "market_cap": "$5.13B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Engineering & Construction",
   "summary_quote": "https://www.nasdaq.com/symbol/pwr",
   "FIELD9": ""
 },
 {
   "symbol": "QTM",
   "name": "Quantum Corporation",
   "last_sale": "2.53",
   "market_cap": "$87.91M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/qtm",
   "FIELD9": ""
 },
 {
   "symbol": "QD",
   "name": "Qudian Inc.",
   "last_sale": "5.49",
   "market_cap": "$1.79B",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/qd",
   "FIELD9": ""
 },
 {
   "symbol": "DGX",
   "name": "Quest Diagnostics Incorporated",
   "last_sale": "107.61",
   "market_cap": "$14.71B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/dgx",
   "FIELD9": ""
 },
 {
   "symbol": "QES",
   "name": "Quintana Energy Services Inc.",
   "last_sale": "8.01",
   "market_cap": "$269.38M",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/qes",
   "FIELD9": ""
 },
 {
   "symbol": "QHC",
   "name": "Quorum Health Corporation",
   "last_sale": "4.67",
   "market_cap": "$144.26M",
   "IPOyear": "2016",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/qhc",
   "FIELD9": ""
 },
 {
   "symbol": "QUOT",
   "name": "Quotient Technology Inc.",
   "last_sale": "14.95",
   "market_cap": "$1.42B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/quot",
   "FIELD9": ""
 },
 {
   "symbol": "QVCD",
   "name": "QVC, Inc.",
   "last_sale": "23.98",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/qvcd",
   "FIELD9": ""
 },
 {
   "symbol": "CTAA",
   "name": "Qwest Corporation",
   "last_sale": "25.639",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ctaa",
   "FIELD9": ""
 },
 {
   "symbol": "CTBB",
   "name": "Qwest Corporation",
   "last_sale": "23.54",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ctbb",
   "FIELD9": ""
 },
 {
   "symbol": "CTDD",
   "name": "Qwest Corporation",
   "last_sale": "24.02",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ctdd",
   "FIELD9": ""
 },
 {
   "symbol": "CTV",
   "name": "Qwest Corporation",
   "last_sale": "25.05",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ctv",
   "FIELD9": ""
 },
 {
   "symbol": "CTY",
   "name": "Qwest Corporation",
   "last_sale": "23.15",
   "market_cap": "n/a",
   "IPOyear": "2013",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/cty",
   "FIELD9": ""
 },
 {
   "symbol": "CTZ",
   "name": "Qwest Corporation",
   "last_sale": "24.32",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ctz",
   "FIELD9": ""
 },
 {
   "symbol": "RRD",
   "name": "R.R. Donnelley & Sons Company",
   "last_sale": "5.91",
   "market_cap": "$416.06M",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Publishing",
   "summary_quote": "https://www.nasdaq.com/symbol/rrd",
   "FIELD9": ""
 },
 {
   "symbol": "RDN",
   "name": "Radian Group Inc.",
   "last_sale": "20.47",
   "market_cap": "$4.37B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/rdn",
   "FIELD9": ""
 },
 {
   "symbol": "RL",
   "name": "Ralph Lauren Corporation",
   "last_sale": "136.57",
   "market_cap": "$11.08B",
   "IPOyear": "1997",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/rl",
   "FIELD9": ""
 },
 {
   "symbol": "RPT",
   "name": "Ramco-Gershenson Properties Trust",
   "last_sale": "13.56",
   "market_cap": "$1.09B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/rpt",
   "FIELD9": ""
 },
 {
   "symbol": "RPT^D",
   "name": "Ramco-Gershenson Properties Trust",
   "last_sale": "54.1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rpt^d",
   "FIELD9": ""
 },
 {
   "symbol": "RRC",
   "name": "Range Resources Corporation",
   "last_sale": "17.49",
   "market_cap": "$4.36B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/rrc",
   "FIELD9": ""
 },
 {
   "symbol": "RNGR",
   "name": "Ranger Energy Services, Inc.",
   "last_sale": "8.52",
   "market_cap": "$134.38M",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/rngr",
   "FIELD9": ""
 },
 {
   "symbol": "RJF",
   "name": "Raymond James Financial, Inc.",
   "last_sale": "95.13",
   "market_cap": "$13.88B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/rjf",
   "FIELD9": ""
 },
 {
   "symbol": "RYAM",
   "name": "Rayonier Advanced Materials Inc.",
   "last_sale": "20.72",
   "market_cap": "$1.06B",
   "IPOyear": "2014",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/ryam",
   "FIELD9": ""
 },
 {
   "symbol": "RYAM^A",
   "name": "Rayonier Advanced Materials Inc.",
   "last_sale": "142.6924",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ryam^a",
   "FIELD9": ""
 },
 {
   "symbol": "RYN",
   "name": "Rayonier Inc.",
   "last_sale": "33.71",
   "market_cap": "$4.36B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ryn",
   "FIELD9": ""
 },
 {
   "symbol": "RTN",
   "name": "Raytheon Company",
   "last_sale": "203.46",
   "market_cap": "$58.04B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/rtn",
   "FIELD9": ""
 },
 {
   "symbol": "RMAX",
   "name": "RE/MAX Holdings, Inc.",
   "last_sale": "43.6",
   "market_cap": "$773.73M",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/rmax",
   "FIELD9": ""
 },
 {
   "symbol": "RLGY",
   "name": "Realogy Holdings Corp.",
   "last_sale": "20.59",
   "market_cap": "$2.55B",
   "IPOyear": "2012",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/rlgy",
   "FIELD9": ""
 },
 {
   "symbol": "O",
   "name": "Realty Income Corporation",
   "last_sale": "56.99",
   "market_cap": "$16.53B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/o",
   "FIELD9": ""
 },
 {
   "symbol": "RHT",
   "name": "Red Hat, Inc.",
   "last_sale": "134.62",
   "market_cap": "$23.88B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/rht",
   "FIELD9": ""
 },
 {
   "symbol": "RLH",
   "name": "Red Lion Hotels Corporation",
   "last_sale": "12.9",
   "market_cap": "$313.14M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/rlh",
   "FIELD9": ""
 },
 {
   "symbol": "RWT",
   "name": "Redwood Trust, Inc.",
   "last_sale": "16.37",
   "market_cap": "$1.36B",
   "IPOyear": "1995",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/rwt",
   "FIELD9": ""
 },
 {
   "symbol": "RBC",
   "name": "Regal Beloit Corporation",
   "last_sale": "85.75",
   "market_cap": "$3.73B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/rbc",
   "FIELD9": ""
 },
 {
   "symbol": "RWGE",
   "name": "Regalwood Global Energy Ltd.",
   "last_sale": "9.8",
   "market_cap": "$85.84M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rwge",
   "FIELD9": ""
 },
 {
   "symbol": "RWGE.U",
   "name": "Regalwood Global Energy Ltd.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rwge.u",
   "FIELD9": ""
 },
 {
   "symbol": "RWGE.WS",
   "name": "Regalwood Global Energy Ltd.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rwge.ws",
   "FIELD9": ""
 },
 {
   "symbol": "REG",
   "name": "Regency Centers Corporation",
   "last_sale": "65.37",
   "market_cap": "$11.08B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/reg",
   "FIELD9": ""
 },
 {
   "symbol": "RM",
   "name": "Regional Management Corp.",
   "last_sale": "29.12",
   "market_cap": "$343.34M",
   "IPOyear": "2012",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rm",
   "FIELD9": ""
 },
 {
   "symbol": "RF",
   "name": "Regions Financial Corporation",
   "last_sale": "19.44",
   "market_cap": "$20.87B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/rf",
   "FIELD9": ""
 },
 {
   "symbol": "RF^A",
   "name": "Regions Financial Corporation",
   "last_sale": "25.23",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rf^a",
   "FIELD9": ""
 },
 {
   "symbol": "RF^B",
   "name": "Regions Financial Corporation",
   "last_sale": "26.53",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rf^b",
   "FIELD9": ""
 },
 {
   "symbol": "RGS",
   "name": "Regis Corporation",
   "last_sale": "20.92",
   "market_cap": "$924.1M",
   "IPOyear": "1991",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rgs",
   "FIELD9": ""
 },
 {
   "symbol": "RGA",
   "name": "Reinsurance Group of America, Incorporated",
   "last_sale": "147.45",
   "market_cap": "$9.39B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/rga",
   "FIELD9": ""
 },
 {
   "symbol": "RZA",
   "name": "Reinsurance Group of America, Incorporated",
   "last_sale": "27.0235",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/rza",
   "FIELD9": ""
 },
 {
   "symbol": "RZB",
   "name": "Reinsurance Group of America, Incorporated",
   "last_sale": "25.66",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/rzb",
   "FIELD9": ""
 },
 {
   "symbol": "RS",
   "name": "Reliance Steel & Aluminum Co.",
   "last_sale": "86.29",
   "market_cap": "$6.24B",
   "IPOyear": "1994",
   "sector": "Basic Industries",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/rs",
   "FIELD9": ""
 },
 {
   "symbol": "RELX",
   "name": "RELX PLC",
   "last_sale": "20.26",
   "market_cap": "$58.89B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Publishing",
   "summary_quote": "https://www.nasdaq.com/symbol/relx",
   "FIELD9": ""
 },
 {
   "symbol": "RNR",
   "name": "RenaissanceRe Holdings Ltd.",
   "last_sale": "135.43",
   "market_cap": "$5.45B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/rnr",
   "FIELD9": ""
 },
 {
   "symbol": "RNR^C",
   "name": "RenaissanceRe Holdings Ltd.",
   "last_sale": "25.209",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rnr^c",
   "FIELD9": ""
 },
 {
   "symbol": "RNR^E",
   "name": "RenaissanceRe Holdings Ltd.",
   "last_sale": "24.08",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rnr^e",
   "FIELD9": ""
 },
 {
   "symbol": "RNR^F",
   "name": "RenaissanceRe Holdings Ltd.",
   "last_sale": "24.85",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rnr^f",
   "FIELD9": ""
 },
 {
   "symbol": "SOL",
   "name": "Renesola Ltd.",
   "last_sale": "2.1824",
   "market_cap": "$83.16M",
   "IPOyear": "2008",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/sol",
   "FIELD9": ""
 },
 {
   "symbol": "RENN",
   "name": "Renren Inc.",
   "last_sale": "1.48",
   "market_cap": "$101.82M",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/renn",
   "FIELD9": ""
 },
 {
   "symbol": "RSG",
   "name": "Republic Services, Inc.",
   "last_sale": "74.65",
   "market_cap": "$24.29B",
   "IPOyear": "1998",
   "sector": "Public Utilities",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rsg",
   "FIELD9": ""
 },
 {
   "symbol": "RMD",
   "name": "ResMed Inc.",
   "last_sale": "113.83",
   "market_cap": "$16.24B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/rmd",
   "FIELD9": ""
 },
 {
   "symbol": "REN           ",
   "name": "Resolute Energy Corporation",
   "last_sale": "35.92",
   "market_cap": "$832.14M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/ren",
   "FIELD9": ""
 },
 {
   "symbol": "RFP",
   "name": "Resolute Forest Products Inc.",
   "last_sale": "13.8",
   "market_cap": "$1.25B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/rfp",
   "FIELD9": ""
 },
 {
   "symbol": "QSR",
   "name": "Restaurant Brands International Inc.",
   "last_sale": "59",
   "market_cap": "$14.75B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/qsr",
   "FIELD9": ""
 },
 {
   "symbol": "RPAI",
   "name": "Retail Properties of America, Inc.",
   "last_sale": "12.61",
   "market_cap": "$2.77B",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/rpai",
   "FIELD9": ""
 },
 {
   "symbol": "RVI",
   "name": "Retail Value Inc.",
   "last_sale": "31.4",
   "market_cap": "$579.8M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/rvi",
   "FIELD9": ""
 },
 {
   "symbol": "REVG",
   "name": "REV Group, Inc.",
   "last_sale": "16.11",
   "market_cap": "$1.02B",
   "IPOyear": "2017",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/revg",
   "FIELD9": ""
 },
 {
   "symbol": "REV",
   "name": "Revlon, Inc.",
   "last_sale": "21.25",
   "market_cap": "$1.12B",
   "IPOyear": "1996",
   "sector": "Consumer Non-Durables",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/rev",
   "FIELD9": ""
 },
 {
   "symbol": "REX",
   "name": "REX American Resources Corporation",
   "last_sale": "74.8",
   "market_cap": "$475.11M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/rex",
   "FIELD9": ""
 },
 {
   "symbol": "REXR",
   "name": "Rexford Industrial Realty, Inc.",
   "last_sale": "32",
   "market_cap": "$2.91B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/rexr",
   "FIELD9": ""
 },
 {
   "symbol": "REXR^A",
   "name": "Rexford Industrial Realty, Inc.",
   "last_sale": "24.4",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rexr^a",
   "FIELD9": ""
 },
 {
   "symbol": "REXR^B",
   "name": "Rexford Industrial Realty, Inc.",
   "last_sale": "24.59",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rexr^b",
   "FIELD9": ""
 },
 {
   "symbol": "RXN",
   "name": "Rexnord Corporation",
   "last_sale": "31.86",
   "market_cap": "$3.33B",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/rxn",
   "FIELD9": ""
 },
 {
   "symbol": "RXN^A",
   "name": "Rexnord Corporation",
   "last_sale": "66.75",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rxn^a",
   "FIELD9": ""
 },
 {
   "symbol": "RH",
   "name": "RH",
   "last_sale": "136.49",
   "market_cap": "$3.03B",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/rh",
   "FIELD9": ""
 },
 {
   "symbol": "RNG",
   "name": "Ringcentral, Inc.",
   "last_sale": "89.8",
   "market_cap": "$7.15B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rng",
   "FIELD9": ""
 },
 {
   "symbol": "RIO",
   "name": "Rio Tinto Plc",
   "last_sale": "51.58",
   "market_cap": "$89.38B",
   "IPOyear": "2002",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/rio",
   "FIELD9": ""
 },
 {
   "symbol": "RBA",
   "name": "Ritchie Bros. Auctioneers Incorporated",
   "last_sale": "36.68",
   "market_cap": "$3.97B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rba",
   "FIELD9": ""
 },
 {
   "symbol": "RAD",
   "name": "Rite Aid Corporation",
   "last_sale": "1.25",
   "market_cap": "$1.33B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rad",
   "FIELD9": ""
 },
 {
   "symbol": "RMPL^",
   "name": "RiverNorth Marketplace Lending Corporation",
   "last_sale": "25.092",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rmpl^",
   "FIELD9": ""
 },
 {
   "symbol": "RIV",
   "name": "RiverNorth Opportunities Fund, Inc.",
   "last_sale": "18.26",
   "market_cap": "$97.27M",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/riv",
   "FIELD9": ""
 },
 {
   "symbol": "OPP",
   "name": "RiverNorth/DoubleLine Strategic Opportunity Fund, Inc.",
   "last_sale": "17.3051",
   "market_cap": "$190.59M",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/opp",
   "FIELD9": ""
 },
 {
   "symbol": "RLI",
   "name": "RLI Corp.",
   "last_sale": "78.57",
   "market_cap": "$3.48B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/rli",
   "FIELD9": ""
 },
 {
   "symbol": "RLJ",
   "name": "RLJ Lodging Trust",
   "last_sale": "22.65",
   "market_cap": "$3.97B",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/rlj",
   "FIELD9": ""
 },
 {
   "symbol": "RLJ^A",
   "name": "RLJ Lodging Trust",
   "last_sale": "26.53",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rlj^a",
   "FIELD9": ""
 },
 {
   "symbol": "RRTS",
   "name": "Roadrunner Transportation Systems, Inc",
   "last_sale": "1.08",
   "market_cap": "$41.59M",
   "IPOyear": "2010",
   "sector": "Transportation",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/rrts",
   "FIELD9": ""
 },
 {
   "symbol": "RHI",
   "name": "Robert Half International Inc.",
   "last_sale": "70.78",
   "market_cap": "$8.67B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rhi",
   "FIELD9": ""
 },
 {
   "symbol": "ROK",
   "name": "Rockwell Automation, Inc.",
   "last_sale": "196.47",
   "market_cap": "$24.2B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/rok",
   "FIELD9": ""
 },
 {
   "symbol": "COL",
   "name": "Rockwell Collins, Inc.",
   "last_sale": "141.98",
   "market_cap": "$23.34B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/col",
   "FIELD9": ""
 },
 {
   "symbol": "RCI",
   "name": "Rogers Communication, Inc.",
   "last_sale": "52.26",
   "market_cap": "$21.1B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rci",
   "FIELD9": ""
 },
 {
   "symbol": "ROG",
   "name": "Rogers Corporation",
   "last_sale": "149.14",
   "market_cap": "$2.74B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/rog",
   "FIELD9": ""
 },
 {
   "symbol": "ROL",
   "name": "Rollins, Inc.",
   "last_sale": "62.51",
   "market_cap": "$13.64B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/rol",
   "FIELD9": ""
 },
 {
   "symbol": "ROP",
   "name": "Roper Technologies, Inc.",
   "last_sale": "306.05",
   "market_cap": "$31.63B",
   "IPOyear": "1992",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/rop",
   "FIELD9": ""
 },
 {
   "symbol": "RST",
   "name": "Rosetta Stone",
   "last_sale": "18.08",
   "market_cap": "$412.38M",
   "IPOyear": "2009",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/rst",
   "FIELD9": ""
 },
 {
   "symbol": "RDC",
   "name": "Rowan Companies plc",
   "last_sale": "18.02",
   "market_cap": "$2.29B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/rdc",
   "FIELD9": ""
 },
 {
   "symbol": "RY",
   "name": "Royal Bank Of Canada",
   "last_sale": "80.59",
   "market_cap": "$116.16B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ry",
   "FIELD9": ""
 },
 {
   "symbol": "RY^T",
   "name": "Royal Bank Of Canada",
   "last_sale": "33.9899",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ry^t",
   "FIELD9": ""
 },
 {
   "symbol": "RBS",
   "name": "Royal Bank Scotland plc (The)",
   "last_sale": "6.97",
   "market_cap": "$41.99B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/rbs",
   "FIELD9": ""
 },
 {
   "symbol": "RBS^S",
   "name": "Royal Bank Scotland plc (The)",
   "last_sale": "25.41",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rbs^s",
   "FIELD9": ""
 },
 {
   "symbol": "RCL",
   "name": "Royal Caribbean Cruises Ltd.",
   "last_sale": "131.47",
   "market_cap": "$27.47B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/rcl",
   "FIELD9": ""
 },
 {
   "symbol": "RDS.A",
   "name": "Royal Dutch Shell PLC",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rds.a",
   "FIELD9": ""
 },
 {
   "symbol": "RDS.B",
   "name": "Royal Dutch Shell PLC",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rds.b",
   "FIELD9": ""
 },
 {
   "symbol": "RGT",
   "name": "Royce Global Value Trust, Inc.",
   "last_sale": "10.6797",
   "market_cap": "$111.73M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rgt",
   "FIELD9": ""
 },
 {
   "symbol": "RMT",
   "name": "Royce Micro-Cap Trust, Inc.",
   "last_sale": "10.27",
   "market_cap": "$407.83M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rmt",
   "FIELD9": ""
 },
 {
   "symbol": "RVT",
   "name": "Royce Value Trust, Inc.",
   "last_sale": "16.65",
   "market_cap": "$1.55B",
   "IPOyear": "1986",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/rvt",
   "FIELD9": ""
 },
 {
   "symbol": "RES",
   "name": "RPC, Inc.",
   "last_sale": "15.66",
   "market_cap": "$3.36B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/res",
   "FIELD9": ""
 },
 {
   "symbol": "RPM",
   "name": "RPM International Inc.",
   "last_sale": "67.66",
   "market_cap": "$9.03B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Paints/Coatings",
   "summary_quote": "https://www.nasdaq.com/symbol/rpm",
   "FIELD9": ""
 },
 {
   "symbol": "RTEC",
   "name": "Rudolph Technologies, Inc.",
   "last_sale": "24.55",
   "market_cap": "$783.16M",
   "IPOyear": "1999",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/rtec",
   "FIELD9": ""
 },
 {
   "symbol": "RYB",
   "name": "RYB Education, Inc.",
   "last_sale": "21.2",
   "market_cap": "$619.33M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ryb",
   "FIELD9": ""
 },
 {
   "symbol": "R",
   "name": "Ryder System, Inc.",
   "last_sale": "74.01",
   "market_cap": "$3.93B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Rental/Leasing Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/r",
   "FIELD9": ""
 },
 {
   "symbol": "RYI",
   "name": "Ryerson Holding Corporation",
   "last_sale": "11.35",
   "market_cap": "$423.31M",
   "IPOyear": "2014",
   "sector": "Basic Industries",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/ryi",
   "FIELD9": ""
 },
 {
   "symbol": "RHP",
   "name": "Ryman Hospitality Properties, Inc.",
   "last_sale": "87.81",
   "market_cap": "$4.51B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/rhp",
   "FIELD9": ""
 },
 {
   "symbol": "SPGI",
   "name": "S&P Global Inc.",
   "last_sale": "211.46",
   "market_cap": "$53.18B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/spgi",
   "FIELD9": ""
 },
 {
   "symbol": "SBR",
   "name": "Sabine Royalty Trust",
   "last_sale": "40.9",
   "market_cap": "$596.3M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/sbr",
   "FIELD9": ""
 },
 {
   "symbol": "SB",
   "name": "Safe Bulkers, Inc",
   "last_sale": "2.74",
   "market_cap": "$278.26M",
   "IPOyear": "2008",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/sb",
   "FIELD9": ""
 },
 {
   "symbol": "SB^C",
   "name": "Safe Bulkers, Inc",
   "last_sale": "23.47",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sb^c",
   "FIELD9": ""
 },
 {
   "symbol": "SB^D",
   "name": "Safe Bulkers, Inc",
   "last_sale": "23.2155",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sb^d",
   "FIELD9": ""
 },
 {
   "symbol": "SFE",
   "name": "Safeguard Scientifics, Inc.",
   "last_sale": "9.15",
   "market_cap": "$188.95M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance/Investors Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sfe",
   "FIELD9": ""
 },
 {
   "symbol": "SAFE",
   "name": "Safety, Income & Growth Inc.",
   "last_sale": "18.82",
   "market_cap": "$343.09M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/safe",
   "FIELD9": ""
 },
 {
   "symbol": "SAIL",
   "name": "SailPoint Technologies Holdings, Inc.",
   "last_sale": "32.94",
   "market_cap": "$2.89B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/sail",
   "FIELD9": ""
 },
 {
   "symbol": "CRM",
   "name": "Salesforce.com Inc",
   "last_sale": "155.52",
   "market_cap": "$117.68B",
   "IPOyear": "2004",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/crm",
   "FIELD9": ""
 },
 {
   "symbol": "SMM",
   "name": "Salient Midstream & MLP Fund",
   "last_sale": "10.11",
   "market_cap": "$179.17M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/smm",
   "FIELD9": ""
 },
 {
   "symbol": "SBH",
   "name": "Sally Beauty Holdings, Inc.",
   "last_sale": "18.36",
   "market_cap": "$2.21B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/sbh",
   "FIELD9": ""
 },
 {
   "symbol": "SJT",
   "name": "San Juan Basin Royalty Trust",
   "last_sale": "5",
   "market_cap": "$233.04M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/sjt",
   "FIELD9": ""
 },
 {
   "symbol": "SN",
   "name": "Sanchez Energy Corporation",
   "last_sale": "2.58",
   "market_cap": "$225.59M",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/sn",
   "FIELD9": ""
 },
 {
   "symbol": "SD",
   "name": "SandRidge Energy, Inc.",
   "last_sale": "10.98",
   "market_cap": "$388.72M",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/sd",
   "FIELD9": ""
 },
 {
   "symbol": "SDT",
   "name": "SandRidge Mississippian Trust I",
   "last_sale": "1.34",
   "market_cap": "$37.52M",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/sdt",
   "FIELD9": ""
 },
 {
   "symbol": "SDR",
   "name": "SandRidge Mississippian Trust II",
   "last_sale": "1.3",
   "market_cap": "$64.64M",
   "IPOyear": "2012",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/sdr",
   "FIELD9": ""
 },
 {
   "symbol": "PER",
   "name": "SandRidge Permian Trust",
   "last_sale": "2.55",
   "market_cap": "$133.88M",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/per",
   "FIELD9": ""
 },
 {
   "symbol": "SNY",
   "name": "Sanofi",
   "last_sale": "43.55",
   "market_cap": "$108.38B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/sny",
   "FIELD9": ""
 },
 {
   "symbol": "SC",
   "name": "Santander Consumer USA Holdings Inc.",
   "last_sale": "21.66",
   "market_cap": "$7.83B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sc",
   "FIELD9": ""
 },
 {
   "symbol": "SAP",
   "name": "SAP SE",
   "last_sale": "121.64",
   "market_cap": "$149.43B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/sap",
   "FIELD9": ""
 },
 {
   "symbol": "SAB",
   "name": "Saratoga Investment Corp",
   "last_sale": "25.6708",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sab",
   "FIELD9": ""
 },
 {
   "symbol": "SAF",
   "name": "Saratoga Investment Corp",
   "last_sale": "25.149",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/saf",
   "FIELD9": ""
 },
 {
   "symbol": "SAR",
   "name": "Saratoga Investment Corp",
   "last_sale": "23.39",
   "market_cap": "$174.35M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sar",
   "FIELD9": ""
 },
 {
   "symbol": "SSL",
   "name": "Sasol Ltd.",
   "last_sale": "37.46",
   "market_cap": "$23.58B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/ssl",
   "FIELD9": ""
 },
 {
  "symbol": "STNE",
  "name": "StoneCo",
  "last_sale": "37.46",
  "market_cap": "$23.58B",
  "IPOyear": "n/a",
  "sector": "Energy",
  "industry": "Oil & Gas Production",
  "summary_quote": "https://www.nasdaq.com/symbol/ssl",
  "FIELD9": ""
},
 {
   "symbol": "BFS",
   "name": "Saul Centers, Inc.",
   "last_sale": "53.78",
   "market_cap": "$1.21B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/bfs",
   "FIELD9": ""
 },
 {
   "symbol": "BFS^C",
   "name": "Saul Centers, Inc.",
   "last_sale": "25.2691",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bfs^c",
   "FIELD9": ""
 },
 {
   "symbol": "BFS^D",
   "name": "Saul Centers, Inc.",
   "last_sale": "23.15",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bfs^d",
   "FIELD9": ""
 },
 {
   "symbol": "SCG",
   "name": "Scana Corporation",
   "last_sale": "34.86",
   "market_cap": "$4.97B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/scg",
   "FIELD9": ""
 },
 {
   "symbol": "SLB",
   "name": "Schlumberger N.V.",
   "last_sale": "61.13",
   "market_cap": "$84.61B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/slb",
   "FIELD9": ""
 },
 {
   "symbol": "SNDR",
   "name": "Schneider National, Inc.",
   "last_sale": "25.56",
   "market_cap": "$4.52B",
   "IPOyear": "2017",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sndr",
   "FIELD9": ""
 },
 {
   "symbol": "SWM",
   "name": "Schweitzer-Mauduit International, Inc.",
   "last_sale": "41.73",
   "market_cap": "$1.28B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/swm",
   "FIELD9": ""
 },
 {
   "symbol": "SAIC",
   "name": "SCIENCE APPLICATIONS INTERNATIONAL CORPORATION",
   "last_sale": "79.43",
   "market_cap": "$3.36B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/saic",
   "FIELD9": ""
 },
 {
   "symbol": "SALT",
   "name": "Scorpio Bulkers Inc.",
   "last_sale": "6.8",
   "market_cap": "$516.53M",
   "IPOyear": "2013",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/salt",
   "FIELD9": ""
 },
 {
   "symbol": "SLTB",
   "name": "Scorpio Bulkers Inc.",
   "last_sale": "25.1703",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/sltb",
   "FIELD9": ""
 },
 {
   "symbol": "SBBC",
   "name": "Scorpio Tankers Inc.",
   "last_sale": "25.2298",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/sbbc",
   "FIELD9": ""
 },
 {
   "symbol": "SBNA",
   "name": "Scorpio Tankers Inc.",
   "last_sale": "24.6547",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/sbna",
   "FIELD9": ""
 },
 {
   "symbol": "STNG",
   "name": "Scorpio Tankers Inc.",
   "last_sale": "2.03",
   "market_cap": "$673.21M",
   "IPOyear": "2010",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/stng",
   "FIELD9": ""
 },
 {
   "symbol": "SMG",
   "name": "Scotts Miracle-Gro Company (The)",
   "last_sale": "78.84",
   "market_cap": "$4.37B",
   "IPOyear": "1992",
   "sector": "Basic Industries",
   "industry": "Agricultural Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/smg",
   "FIELD9": ""
 },
 {
   "symbol": "KMM",
   "name": "Scudder Multi-Market Income Trust",
   "last_sale": "8.98",
   "market_cap": "$201.09M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kmm",
   "FIELD9": ""
 },
 {
   "symbol": "KTF",
   "name": "Scudder Municiple Income Trust",
   "last_sale": "10.49",
   "market_cap": "$414.36M",
   "IPOyear": "1988",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ktf",
   "FIELD9": ""
 },
 {
   "symbol": "KST",
   "name": "Scudder Strategic Income Trust",
   "last_sale": "12.56",
   "market_cap": "$54.74M",
   "IPOyear": "1994",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/kst",
   "FIELD9": ""
 },
 {
   "symbol": "KSM",
   "name": "Scudder Strategic Municiple Income Trust",
   "last_sale": "10.64",
   "market_cap": "$119.21M",
   "IPOyear": "1989",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ksm",
   "FIELD9": ""
 },
 {
   "symbol": "SE",
   "name": "Sea Limited",
   "last_sale": "14.6",
   "market_cap": "$4.89B",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/se",
   "FIELD9": ""
 },
 {
   "symbol": "SA",
   "name": "Seabridge Gold, Inc.",
   "last_sale": "11.3",
   "market_cap": "$671.47M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/sa",
   "FIELD9": ""
 },
 {
   "symbol": "CKH",
   "name": "SEACOR Holdings, Inc.",
   "last_sale": "49.26",
   "market_cap": "$897.7M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/ckh",
   "FIELD9": ""
 },
 {
   "symbol": "SMHI",
   "name": "SEACOR Marine Holdings Inc.",
   "last_sale": "21.34",
   "market_cap": "$436.22M",
   "IPOyear": "2017",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/smhi",
   "FIELD9": ""
 },
 {
   "symbol": "SDRL",
   "name": "Seadrill Limited",
   "last_sale": "23.68",
   "market_cap": "$2.37B",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/sdrl",
   "FIELD9": ""
 },
 {
   "symbol": "SDLP",
   "name": "Seadrill Partners LLC",
   "last_sale": "3.72",
   "market_cap": "$341.58M",
   "IPOyear": "2012",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/sdlp",
   "FIELD9": ""
 },
 {
   "symbol": "SEE",
   "name": "Sealed Air Corporation",
   "last_sale": "41.74",
   "market_cap": "$6.63B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/see",
   "FIELD9": ""
 },
 {
   "symbol": "SSW",
   "name": "Seaspan Corporation",
   "last_sale": "8.06",
   "market_cap": "$1.11B",
   "IPOyear": "2005",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/ssw",
   "FIELD9": ""
 },
 {
   "symbol": "SSW^D",
   "name": "Seaspan Corporation",
   "last_sale": "24.94",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ssw^d",
   "FIELD9": ""
 },
 {
   "symbol": "SSW^E",
   "name": "Seaspan Corporation",
   "last_sale": "25.3",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ssw^e",
   "FIELD9": ""
 },
 {
   "symbol": "SSW^G",
   "name": "Seaspan Corporation",
   "last_sale": "25.29",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ssw^g",
   "FIELD9": ""
 },
 {
   "symbol": "SSW^H",
   "name": "Seaspan Corporation",
   "last_sale": "24.55",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ssw^h",
   "FIELD9": ""
 },
 {
   "symbol": "SSWA",
   "name": "Seaspan Corporation",
   "last_sale": "25.069",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/sswa",
   "FIELD9": ""
 },
 {
   "symbol": "SSWN",
   "name": "Seaspan Corporation",
   "last_sale": "25.44",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/sswn",
   "FIELD9": ""
 },
 {
   "symbol": "SEAS",
   "name": "SeaWorld Entertainment, Inc.",
   "last_sale": "30.1",
   "market_cap": "$2.64B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/seas",
   "FIELD9": ""
 },
 {
   "symbol": "JBN",
   "name": "Select Asset Inc.",
   "last_sale": "8.76",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/jbn",
   "FIELD9": ""
 },
 {
   "symbol": "JBR",
   "name": "Select Asset Inc.",
   "last_sale": "8.87",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/jbr",
   "FIELD9": ""
 },
 {
   "symbol": "WTTR",
   "name": "Select Energy Services, Inc.",
   "last_sale": "12.29",
   "market_cap": "$1.31B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/wttr",
   "FIELD9": ""
 },
 {
   "symbol": "SEM",
   "name": "Select Medical Holdings Corporation",
   "last_sale": "18",
   "market_cap": "$2.44B",
   "IPOyear": "2009",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/sem",
   "FIELD9": ""
 },
 {
   "symbol": "SGZA",
   "name": "Selective Insurance Group, Inc.",
   "last_sale": "25.08",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/sgza",
   "FIELD9": ""
 },
 {
   "symbol": "SEMG",
   "name": "Semgroup Corporation",
   "last_sale": "21.9",
   "market_cap": "$1.73B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/semg",
   "FIELD9": ""
 },
 {
   "symbol": "SMI",
   "name": "Semiconductor  Manufacturing International Corporation",
   "last_sale": "5.41",
   "market_cap": "$5.47B",
   "IPOyear": "2004",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/smi",
   "FIELD9": ""
 },
 {
   "symbol": "SRE",
   "name": "Sempra Energy",
   "last_sale": "115.21",
   "market_cap": "$31.51B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/sre",
   "FIELD9": ""
 },
 {
   "symbol": "SRE^A",
   "name": "Sempra Energy",
   "last_sale": "103",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/sre^a",
   "FIELD9": ""
 },
 {
   "symbol": "SRE^B",
   "name": "Sempra Energy",
   "last_sale": "103.55",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sre^b",
   "FIELD9": ""
 },
 {
   "symbol": "SEND",
   "name": "SendGrid, Inc.",
   "last_sale": "35.48",
   "market_cap": "$1.65B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/send",
   "FIELD9": ""
 },
 {
   "symbol": "ST",
   "name": "Sensata Technologies Holding plc",
   "last_sale": "51.88",
   "market_cap": "$8.8B",
   "IPOyear": "2010",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/st",
   "FIELD9": ""
 },
 {
   "symbol": "SXT",
   "name": "Sensient Technologies Corporation",
   "last_sale": "77.06",
   "market_cap": "$3.26B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/sxt",
   "FIELD9": ""
 },
 {
   "symbol": "SQNS",
   "name": "Sequans Communications S.A.",
   "last_sale": "1.43",
   "market_cap": "$135.13M",
   "IPOyear": "2011",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/sqns",
   "FIELD9": ""
 },
 {
   "symbol": "SRG",
   "name": "Seritage Growth Properties",
   "last_sale": "49.4",
   "market_cap": "$2.76B",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/srg",
   "FIELD9": ""
 },
 {
   "symbol": "SRG^A",
   "name": "Seritage Growth Properties",
   "last_sale": "25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/srg^a",
   "FIELD9": ""
 },
 {
   "symbol": "SCI",
   "name": "Service Corporation International",
   "last_sale": "43.94",
   "market_cap": "$7.92B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sci",
   "FIELD9": ""
 },
 {
   "symbol": "SERV",
   "name": "ServiceMaster Global Holdings, Inc.",
   "last_sale": "60.46",
   "market_cap": "$8.2B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/serv",
   "FIELD9": ""
 },
 {
   "symbol": "SERV$",
   "name": "ServiceMaster Global Holdings, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/serv$",
   "FIELD9": ""
 },
 {
   "symbol": "NOW",
   "name": "ServiceNow, Inc.",
   "last_sale": "189.69",
   "market_cap": "$33.75B",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/now",
   "FIELD9": ""
 },
 {
   "symbol": "SHAK",
   "name": "Shake Shack, Inc.",
   "last_sale": "58.19",
   "market_cap": "$2.15B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/shak",
   "FIELD9": ""
 },
 {
   "symbol": "SJR",
   "name": "Shaw Communications Inc.",
   "last_sale": "19.74",
   "market_cap": "$9.54B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sjr",
   "FIELD9": ""
 },
 {
   "symbol": "SHLX",
   "name": "Shell Midstream Partners, L.P.",
   "last_sale": "21.89",
   "market_cap": "$4.9B",
   "IPOyear": "2014",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/shlx",
   "FIELD9": ""
 },
 {
   "symbol": "SHW",
   "name": "Sherwin-Williams Company (The)",
   "last_sale": "469.96",
   "market_cap": "$43.89B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "RETAIL: Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/shw",
   "FIELD9": ""
 },
 {
   "symbol": "SHG",
   "name": "Shinhan Financial Group Co Ltd",
   "last_sale": "39.26",
   "market_cap": "$18.62B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/shg",
   "FIELD9": ""
 },
 {
   "symbol": "SFL",
   "name": "Ship Finance International Limited",
   "last_sale": "13.8",
   "market_cap": "$1.48B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/sfl",
   "FIELD9": ""
 },
 {
   "symbol": "SHOP",
   "name": "Shopify Inc.",
   "last_sale": "161.52",
   "market_cap": "$15.2B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/shop",
   "FIELD9": ""
 },
 {
   "symbol": "SSTK",
   "name": "Shutterstock, Inc.",
   "last_sale": "52.5",
   "market_cap": "$1.84B",
   "IPOyear": "2012",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sstk",
   "FIELD9": ""
 },
 {
   "symbol": "SBGL",
   "name": "Sibanye Gold Limited",
   "last_sale": "2.52",
   "market_cap": "$1.43B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/sbgl",
   "FIELD9": ""
 },
 {
   "symbol": "SIG",
   "name": "Signet Jewelers Limited",
   "last_sale": "66.63",
   "market_cap": "$3.46B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Consumer Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/sig",
   "FIELD9": ""
 },
 {
   "symbol": "SBOW",
   "name": "SilverBow Resorces, Inc.",
   "last_sale": "28.51",
   "market_cap": "$332.63M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/sbow",
   "FIELD9": ""
 },
 {
   "symbol": "SPG",
   "name": "Simon Property Group, Inc.",
   "last_sale": "180.48",
   "market_cap": "$55.81B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/spg",
   "FIELD9": ""
 },
 {
   "symbol": "SPG^J",
   "name": "Simon Property Group, Inc.",
   "last_sale": "70.2184",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/spg^j",
   "FIELD9": ""
 },
 {
   "symbol": "SSD",
   "name": "Simpson Manufacturing Company, Inc.",
   "last_sale": "73.57",
   "market_cap": "$3.41B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/ssd",
   "FIELD9": ""
 },
 {
   "symbol": "SHI",
   "name": "SINOPEC Shangai Petrochemical Company, Ltd.",
   "last_sale": "58.76",
   "market_cap": "$6.36B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/shi",
   "FIELD9": ""
 },
 {
   "symbol": "SITE",
   "name": "SiteOne Landscape Supply, Inc.",
   "last_sale": "81.2",
   "market_cap": "$3.29B",
   "IPOyear": "2016",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/site",
   "FIELD9": ""
 },
 {
   "symbol": "SIX",
   "name": "Six Flags Entertainment Corporation New",
   "last_sale": "68.72",
   "market_cap": "$5.78B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/six",
   "FIELD9": ""
 },
 {
   "symbol": "SJW",
   "name": "SJW Group",
   "last_sale": "58.82",
   "market_cap": "$1.21B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Water Supply",
   "summary_quote": "https://www.nasdaq.com/symbol/sjw",
   "FIELD9": ""
 },
 {
   "symbol": "SKM",
   "name": "SK Telecom Co., Ltd.",
   "last_sale": "27",
   "market_cap": "$17.18B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/skm",
   "FIELD9": ""
 },
 {
   "symbol": "SKX",
   "name": "Skechers U.S.A., Inc.",
   "last_sale": "26.98",
   "market_cap": "$4.3B",
   "IPOyear": "1999",
   "sector": "Consumer Non-Durables",
   "industry": "Shoe Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/skx",
   "FIELD9": ""
 },
 {
   "symbol": "SKY",
   "name": "Skyline Champion Corporation",
   "last_sale": "30.03",
   "market_cap": "$1.7B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/sky",
   "FIELD9": ""
 },
 {
   "symbol": "SLG",
   "name": "SL Green Realty Corp",
   "last_sale": "100.26",
   "market_cap": "$8.68B",
   "IPOyear": "1997",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/slg",
   "FIELD9": ""
 },
 {
   "symbol": "SLG^I",
   "name": "SL Green Realty Corp",
   "last_sale": "25.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/slg^i",
   "FIELD9": ""
 },
 {
   "symbol": "SM",
   "name": "SM Energy Company",
   "last_sale": "31.54",
   "market_cap": "$3.54B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/sm",
   "FIELD9": ""
 },
 {
   "symbol": "SFS",
   "name": "Smart",
   "last_sale": "6.45",
   "market_cap": "$489.68M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Food Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/sfs",
   "FIELD9": ""
 },
 {
   "symbol": "SMAR",
   "name": "Smartsheet Inc.",
   "last_sale": "31.64",
   "market_cap": "$3.25B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/smar",
   "FIELD9": ""
 },
 {
   "symbol": "SNN",
   "name": "Smith & Nephew SNATS, Inc.",
   "last_sale": "36.88",
   "market_cap": "$16.12B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/snn",
   "FIELD9": ""
 },
 {
   "symbol": "AOS",
   "name": "Smith (A.O.) Corporation",
   "last_sale": "59.72",
   "market_cap": "$10.19B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/aos",
   "FIELD9": ""
 },
 {
   "symbol": "SNAP",
   "name": "Snap Inc.",
   "last_sale": "9.14",
   "market_cap": "$11.68B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/snap",
   "FIELD9": ""
 },
 {
   "symbol": "SNA",
   "name": "Snap-On Incorporated",
   "last_sale": "188.46",
   "market_cap": "$10.63B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/sna",
   "FIELD9": ""
 },
 {
   "symbol": "IPOA",
   "name": "Social Capital Hedosophia Holdings Corp.",
   "last_sale": "9.9",
   "market_cap": "$199.07M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ipoa",
   "FIELD9": ""
 },
 {
   "symbol": "IPOA.U",
   "name": "Social Capital Hedosophia Holdings Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ipoa.u",
   "FIELD9": ""
 },
 {
   "symbol": "IPOA.WS",
   "name": "Social Capital Hedosophia Holdings Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ipoa.ws",
   "FIELD9": ""
 },
 {
   "symbol": "SQM",
   "name": "Sociedad Quimica y Minera S.A.",
   "last_sale": "48.45",
   "market_cap": "$12.75B",
   "IPOyear": "1993",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/sqm",
   "FIELD9": ""
 },
 {
   "symbol": "SOGO",
   "name": "Sogou Inc.",
   "last_sale": "7.93",
   "market_cap": "$3.15B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/sogo",
   "FIELD9": ""
 },
 {
   "symbol": "SOI",
   "name": "Solaris Oilfield Infrastructure, Inc.",
   "last_sale": "17.3",
   "market_cap": "$813.78M",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/soi",
   "FIELD9": ""
 },
 {
   "symbol": "SAH",
   "name": "Sonic Automotive, Inc.",
   "last_sale": "20.75",
   "market_cap": "$886.26M",
   "IPOyear": "1997",
   "sector": "Consumer Durables",
   "industry": "Automotive Aftermarket",
   "summary_quote": "https://www.nasdaq.com/symbol/sah",
   "FIELD9": ""
 },
 {
   "symbol": "SON",
   "name": "Sonoco Products Company",
   "last_sale": "56.73",
   "market_cap": "$5.65B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/son",
   "FIELD9": ""
 },
 {
   "symbol": "SNE",
   "name": "Sony Corp Ord",
   "last_sale": "57",
   "market_cap": "$72.29B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/sne",
   "FIELD9": ""
 },
 {
   "symbol": "BID",
   "name": "Sotheby&#39;s",
   "last_sale": "48.99",
   "market_cap": "$2.53B",
   "IPOyear": "1988",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/bid",
   "FIELD9": ""
 },
 {
   "symbol": "SOR",
   "name": "Source Capital, Inc.",
   "last_sale": "40.53",
   "market_cap": "$349.15M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sor",
   "FIELD9": ""
 },
 {
   "symbol": "SJI",
   "name": "South Jersey Industries, Inc.",
   "last_sale": "36",
   "market_cap": "$3.08B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil/Gas Transmission",
   "summary_quote": "https://www.nasdaq.com/symbol/sji",
   "FIELD9": ""
 },
 {
   "symbol": "SJIU",
   "name": "South Jersey Industries, Inc.",
   "last_sale": "57.55",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil/Gas Transmission",
   "summary_quote": "https://www.nasdaq.com/symbol/sjiu",
   "FIELD9": ""
 },
 {
   "symbol": "SXE",
   "name": "Southcross Energy Partners, L.P.",
   "last_sale": "0.6455",
   "market_cap": "$51.53M",
   "IPOyear": "2012",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/sxe",
   "FIELD9": ""
 },
 {
   "symbol": "SCE^G",
   "name": "Southern California Edison Company",
   "last_sale": "22.97",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sce^g",
   "FIELD9": ""
 },
 {
   "symbol": "SCE^H",
   "name": "Southern California Edison Company",
   "last_sale": "25.58",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sce^h",
   "FIELD9": ""
 },
 {
   "symbol": "SCE^J",
   "name": "Southern California Edison Company",
   "last_sale": "24.7186",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sce^j",
   "FIELD9": ""
 },
 {
   "symbol": "SCE^K",
   "name": "Southern California Edison Company",
   "last_sale": "24.99",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sce^k",
   "FIELD9": ""
 },
 {
   "symbol": "SCE^L",
   "name": "Southern California Edison Company",
   "last_sale": "22.19",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sce^l",
   "FIELD9": ""
 },
 {
   "symbol": "SO",
   "name": "Southern Company (The)",
   "last_sale": "44.01",
   "market_cap": "$44.63B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/so",
   "FIELD9": ""
 },
 {
   "symbol": "SOJA",
   "name": "Southern Company (The)",
   "last_sale": "25.94",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/soja",
   "FIELD9": ""
 },
 {
   "symbol": "SOJB",
   "name": "Southern Company (The)",
   "last_sale": "24.1198",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/sojb",
   "FIELD9": ""
 },
 {
   "symbol": "SOJC",
   "name": "Southern Company (The)",
   "last_sale": "23.63",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/sojc",
   "FIELD9": ""
 },
 {
   "symbol": "SCCO",
   "name": "Southern Copper Corporation",
   "last_sale": "44.26",
   "market_cap": "$34.21B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/scco",
   "FIELD9": ""
 },
 {
   "symbol": "LUV",
   "name": "Southwest Airlines Company",
   "last_sale": "63.77",
   "market_cap": "$36.54B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/luv",
   "FIELD9": ""
 },
 {
   "symbol": "SWX",
   "name": "Southwest Gas Holdings, Inc.",
   "last_sale": "79.4",
   "market_cap": "$3.9B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/swx",
   "FIELD9": ""
 },
 {
   "symbol": "SWN",
   "name": "Southwestern Energy Company",
   "last_sale": "5.75",
   "market_cap": "$3.37B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/swn",
   "FIELD9": ""
 },
 {
   "symbol": "SPAQ.U",
   "name": "Spartan Energy Acquisition Corp",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/spaq.u",
   "FIELD9": ""
 },
 {
   "symbol": "SPA",
   "name": "Sparton Corporation",
   "last_sale": "14.76",
   "market_cap": "$145.16M",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/spa",
   "FIELD9": ""
 },
 {
   "symbol": "SPE",
   "name": "Special Opportunities Fund Inc.",
   "last_sale": "15.01",
   "market_cap": "$127.71M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/spe",
   "FIELD9": ""
 },
 {
   "symbol": "SPE^B",
   "name": "Special Opportunities Fund Inc.",
   "last_sale": "25.52",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/spe^b",
   "FIELD9": ""
 },
 {
   "symbol": "SEP",
   "name": "Spectra Energy Partners, LP",
   "last_sale": "38.06",
   "market_cap": "$18.46B",
   "IPOyear": "2007",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/sep",
   "FIELD9": ""
 },
 {
   "symbol": "SPB           ",
   "name": "Spectrum Brands Holdings, Inc.",
   "last_sale": "80.78",
   "market_cap": "$4.31B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/spb",
   "FIELD9": ""
 },
 {
   "symbol": "TRK",
   "name": "Speedway Motorsports, Inc.",
   "last_sale": "17.73",
   "market_cap": "$725.14M",
   "IPOyear": "1995",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/trk",
   "FIELD9": ""
 },
 {
   "symbol": "SR",
   "name": "Spire Inc.",
   "last_sale": "74.55",
   "market_cap": "$3.78B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil/Gas Transmission",
   "summary_quote": "https://www.nasdaq.com/symbol/sr",
   "FIELD9": ""
 },
 {
   "symbol": "SPR",
   "name": "Spirit Aerosystems Holdings, Inc.",
   "last_sale": "93.5",
   "market_cap": "$9.96B",
   "IPOyear": "2006",
   "sector": "Capital Goods",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/spr",
   "FIELD9": ""
 },
 {
   "symbol": "SAVE",
   "name": "Spirit Airlines, Inc.",
   "last_sale": "48.29",
   "market_cap": "$3.3B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Air Freight/Delivery Services",
   "summary_quote": "https://www.nasdaq.com/symbol/save",
   "FIELD9": ""
 },
 {
   "symbol": "SMTA",
   "name": "Spirit MTA REIT",
   "last_sale": "10.98",
   "market_cap": "$472.15M",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/smta",
   "FIELD9": ""
 },
 {
   "symbol": "SRC",
   "name": "Spirit Realty Capital, Inc.",
   "last_sale": "8.08",
   "market_cap": "$3.46B",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Building operators",
   "summary_quote": "https://www.nasdaq.com/symbol/src",
   "FIELD9": ""
 },
 {
   "symbol": "SRC^A",
   "name": "Spirit Realty Capital, Inc.",
   "last_sale": "23.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/src^a",
   "FIELD9": ""
 },
 {
   "symbol": "SPOT",
   "name": "Spotify Technology S.A.",
   "last_sale": "175.02",
   "market_cap": "$31.46B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/spot",
   "FIELD9": ""
 },
 {
   "symbol": "SRLP",
   "name": "Sprague Resources LP",
   "last_sale": "27.85",
   "market_cap": "$632.95M",
   "IPOyear": "2013",
   "sector": "Energy",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/srlp",
   "FIELD9": ""
 },
 {
   "symbol": "S",
   "name": "Sprint Corporation",
   "last_sale": "6.39",
   "market_cap": "$26B",
   "IPOyear": "2013",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/s",
   "FIELD9": ""
 },
 {
   "symbol": "SPXC",
   "name": "SPX Corporation",
   "last_sale": "34.75",
   "market_cap": "$1.5B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/spxc",
   "FIELD9": ""
 },
 {
   "symbol": "FLOW",
   "name": "SPX FLOW, Inc.",
   "last_sale": "53.82",
   "market_cap": "$2.29B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/flow",
   "FIELD9": ""
 },
 {
   "symbol": "SQ",
   "name": "Square, Inc.",
   "last_sale": "85.3",
   "market_cap": "$35.01B",
   "IPOyear": "2015",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/sq",
   "FIELD9": ""
 },
 {
   "symbol": "JOE",
   "name": "St. Joe Company (The)",
   "last_sale": "17.15",
   "market_cap": "$1.05B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/joe",
   "FIELD9": ""
 },
 {
   "symbol": "STAG",
   "name": "Stag Industrial, Inc.",
   "last_sale": "27.94",
   "market_cap": "$2.92B",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/stag",
   "FIELD9": ""
 },
 {
   "symbol": "STAG^C",
   "name": "Stag Industrial, Inc.",
   "last_sale": "25.8",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/stag^c",
   "FIELD9": ""
 },
 {
   "symbol": "SSI",
   "name": "Stage Stores, Inc.",
   "last_sale": "2.04",
   "market_cap": "$57.62M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/ssi",
   "FIELD9": ""
 },
 {
   "symbol": "SMP",
   "name": "Standard Motor Products, Inc.",
   "last_sale": "51.9",
   "market_cap": "$1.16B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/smp",
   "FIELD9": ""
 },
 {
   "symbol": "SXI",
   "name": "Standex International Corporation",
   "last_sale": "110.9",
   "market_cap": "$1.42B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/sxi",
   "FIELD9": ""
 },
 {
   "symbol": "SWJ",
   "name": "Stanley Black & Decker, Inc.",
   "last_sale": "25.0584",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/swj",
   "FIELD9": ""
 },
 {
   "symbol": "SWK",
   "name": "Stanley Black & Decker, Inc.",
   "last_sale": "154.36",
   "market_cap": "$23.62B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/swk",
   "FIELD9": ""
 },
 {
   "symbol": "SWP",
   "name": "Stanley Black & Decker, Inc.",
   "last_sale": "114.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/swp",
   "FIELD9": ""
 },
 {
   "symbol": "STN",
   "name": "Stantec Inc",
   "last_sale": "25.7",
   "market_cap": "$2.93B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/stn",
   "FIELD9": ""
 },
 {
   "symbol": "SGU",
   "name": "Star Group, L.P.",
   "last_sale": "9.8",
   "market_cap": "$523.25M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/sgu",
   "FIELD9": ""
 },
 {
   "symbol": "SRT",
   "name": "StarTek, Inc.",
   "last_sale": "6.38",
   "market_cap": "$236.02M",
   "IPOyear": "1997",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/srt",
   "FIELD9": ""
 },
 {
   "symbol": "STWD",
   "name": "STARWOOD PROPERTY TRUST, INC.",
   "last_sale": "21.88",
   "market_cap": "$5.84B",
   "IPOyear": "2009",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/stwd",
   "FIELD9": ""
 },
 {
   "symbol": "STT",
   "name": "State Street Corporation",
   "last_sale": "88.77",
   "market_cap": "$33.65B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/stt",
   "FIELD9": ""
 },
 {
   "symbol": "STT^C",
   "name": "State Street Corporation",
   "last_sale": "24.72",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/stt^c",
   "FIELD9": ""
 },
 {
   "symbol": "STT^D",
   "name": "State Street Corporation",
   "last_sale": "26.39",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/stt^d",
   "FIELD9": ""
 },
 {
   "symbol": "STT^E",
   "name": "State Street Corporation",
   "last_sale": "25.67",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/stt^e",
   "FIELD9": ""
 },
 {
   "symbol": "STT^G",
   "name": "State Street Corporation",
   "last_sale": "25.7017",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/stt^g",
   "FIELD9": ""
 },
 {
   "symbol": "SPLP",
   "name": "Steel Partners Holdings LP",
   "last_sale": "16.9",
   "market_cap": "$442.36M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/splp",
   "FIELD9": ""
 },
 {
   "symbol": "SPLP^A",
   "name": "Steel Partners Holdings LP",
   "last_sale": "22.84",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/splp^a",
   "FIELD9": ""
 },
 {
   "symbol": "SCS",
   "name": "Steelcase Inc.",
   "last_sale": "19.05",
   "market_cap": "$2.22B",
   "IPOyear": "1998",
   "sector": "Consumer Durables",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/scs",
   "FIELD9": ""
 },
 {
   "symbol": "SCA",
   "name": "Stellus Capital Investment Corporation",
   "last_sale": "25.27",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sca",
   "FIELD9": ""
 },
 {
   "symbol": "SCM",
   "name": "Stellus Capital Investment Corporation",
   "last_sale": "13.93",
   "market_cap": "$222.24M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/scm",
   "FIELD9": ""
 },
 {
   "symbol": "SCL",
   "name": "Stepan Company",
   "last_sale": "89.52",
   "market_cap": "$2.02B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/scl",
   "FIELD9": ""
 },
 {
   "symbol": "STE",
   "name": "STERIS plc",
   "last_sale": "113.97",
   "market_cap": "$9.64B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/ste",
   "FIELD9": ""
 },
 {
   "symbol": "STL",
   "name": "Sterling Bancorp",
   "last_sale": "23.1",
   "market_cap": "$5.21B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/stl",
   "FIELD9": ""
 },
 {
   "symbol": "STL^A",
   "name": "Sterling Bancorp",
   "last_sale": "26.6112",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/stl^a",
   "FIELD9": ""
 },
 {
   "symbol": "STC",
   "name": "Stewart Information Services Corporation",
   "last_sale": "45.31",
   "market_cap": "$1.08B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Specialty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/stc",
   "FIELD9": ""
 },
 {
   "symbol": "SF",
   "name": "Stifel Financial Corporation",
   "last_sale": "54.93",
   "market_cap": "$3.91B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/sf",
   "FIELD9": ""
 },
 {
   "symbol": "SF^A",
   "name": "Stifel Financial Corporation",
   "last_sale": "25.31",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/sf^a",
   "FIELD9": ""
 },
 {
   "symbol": "SFB",
   "name": "Stifel Financial Corporation",
   "last_sale": "24.37",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/sfb",
   "FIELD9": ""
 },
 {
   "symbol": "STM",
   "name": "STMicroelectronics N.V.",
   "last_sale": "18.82",
   "market_cap": "$16.96B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/stm",
   "FIELD9": ""
 },
 {
   "symbol": "EDF",
   "name": "Stone Harbor Emerging Markets Income Fund",
   "last_sale": "13.16",
   "market_cap": "$211.34M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/edf",
   "FIELD9": ""
 },
 {
   "symbol": "EDI",
   "name": "Stone Harbor Emerging Markets Total Income Fund",
   "last_sale": "12.36",
   "market_cap": "$119.34M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/edi",
   "FIELD9": ""
 },
 {
   "symbol": "STON",
   "name": "StoneMor Partners L.P.",
   "last_sale": "4.97",
   "market_cap": "$188.65M",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ston",
   "FIELD9": ""
 },
 {
   "symbol": "SRI",
   "name": "Stoneridge, Inc.",
   "last_sale": "29.77",
   "market_cap": "$847.93M",
   "IPOyear": "1997",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/sri",
   "FIELD9": ""
 },
 {
   "symbol": "STOR",
   "name": "STORE Capital Corporation",
   "last_sale": "28",
   "market_cap": "$5.76B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/stor",
   "FIELD9": ""
 },
 {
   "symbol": "GJH",
   "name": "STRATS Trust",
   "last_sale": "9.962",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gjh",
   "FIELD9": ""
 },
 {
   "symbol": "GJO",
   "name": "STRATS Trust",
   "last_sale": "23.49",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gjo",
   "FIELD9": ""
 },
 {
   "symbol": "GJS",
   "name": "STRATS Trust",
   "last_sale": "21.67",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gjs",
   "FIELD9": ""
 },
 {
   "symbol": "SYK",
   "name": "Stryker Corporation",
   "last_sale": "174.5",
   "market_cap": "$65.26B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/syk",
   "FIELD9": ""
 },
 {
   "symbol": "RGR",
   "name": "Sturm, Ruger & Company, Inc.",
   "last_sale": "67.75",
   "market_cap": "$1.18B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Ordnance And Accessories",
   "summary_quote": "https://www.nasdaq.com/symbol/rgr",
   "FIELD9": ""
 },
 {
   "symbol": "SPH",
   "name": "Suburban Propane Partners, L.P.",
   "last_sale": "23.3",
   "market_cap": "$1.43B",
   "IPOyear": "1996",
   "sector": "Consumer Services",
   "industry": "Other Specialty Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/sph",
   "FIELD9": ""
 },
 {
   "symbol": "SMFG",
   "name": "Sumitomo Mitsui Financial Group Inc",
   "last_sale": "8.26",
   "market_cap": "$57.63B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/smfg",
   "FIELD9": ""
 },
 {
   "symbol": "INN",
   "name": "Summit Hotel Properties, Inc.",
   "last_sale": "13.35",
   "market_cap": "$1.4B",
   "IPOyear": "2011",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/inn",
   "FIELD9": ""
 },
 {
   "symbol": "INN^D",
   "name": "Summit Hotel Properties, Inc.",
   "last_sale": "24.176",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/inn^d",
   "FIELD9": ""
 },
 {
   "symbol": "INN^E",
   "name": "Summit Hotel Properties, Inc.",
   "last_sale": "23",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/inn^e",
   "FIELD9": ""
 },
 {
   "symbol": "SUM",
   "name": "Summit Materials, Inc.",
   "last_sale": "19.05",
   "market_cap": "$2.13B",
   "IPOyear": "2015",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/sum",
   "FIELD9": ""
 },
 {
   "symbol": "SMLP",
   "name": "Summit Midstream Partners, LP",
   "last_sale": "16.05",
   "market_cap": "$1.18B",
   "IPOyear": "2012",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/smlp",
   "FIELD9": ""
 },
 {
   "symbol": "SUI",
   "name": "Sun Communities, Inc.",
   "last_sale": "102.19",
   "market_cap": "$8.82B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/sui",
   "FIELD9": ""
 },
 {
   "symbol": "SLF",
   "name": "Sun Life Financial Inc.",
   "last_sale": "40.48",
   "market_cap": "$24.57B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/slf",
   "FIELD9": ""
 },
 {
   "symbol": "SXCP",
   "name": "SunCoke Energy Partners, L.P.",
   "last_sale": "15.8",
   "market_cap": "$730.39M",
   "IPOyear": "2013",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/sxcp",
   "FIELD9": ""
 },
 {
   "symbol": "SXC",
   "name": "SunCoke Energy, Inc.",
   "last_sale": "11.6",
   "market_cap": "$750.85M",
   "IPOyear": "2011",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/sxc",
   "FIELD9": ""
 },
 {
   "symbol": "SU",
   "name": "Suncor Energy  Inc.",
   "last_sale": "39.05",
   "market_cap": "$63.56B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/su",
   "FIELD9": ""
 },
 {
   "symbol": "STG",
   "name": "Sunlands Online Education Group",
   "last_sale": "6.4",
   "market_cap": "$1.11B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/stg",
   "FIELD9": ""
 },
 {
   "symbol": "SUN",
   "name": "Sunoco LP",
   "last_sale": "28.23",
   "market_cap": "$2.79B",
   "IPOyear": "2012",
   "sector": "Energy",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/sun",
   "FIELD9": ""
 },
 {
   "symbol": "SHO",
   "name": "Sunstone Hotel Investors, Inc.",
   "last_sale": "16.53",
   "market_cap": "$3.77B",
   "IPOyear": "2004",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/sho",
   "FIELD9": ""
 },
 {
   "symbol": "SHO^E",
   "name": "Sunstone Hotel Investors, Inc.",
   "last_sale": "26.3332",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sho^e",
   "FIELD9": ""
 },
 {
   "symbol": "SHO^F",
   "name": "Sunstone Hotel Investors, Inc.",
   "last_sale": "25.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sho^f",
   "FIELD9": ""
 },
 {
   "symbol": "STI",
   "name": "SunTrust Banks, Inc.",
   "last_sale": "70.86",
   "market_cap": "$32.65B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/sti",
   "FIELD9": ""
 },
 {
   "symbol": "STI.WS.A",
   "name": "SunTrust Banks, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sti.ws.a",
   "FIELD9": ""
 },
 {
   "symbol": "STI.WS.B",
   "name": "SunTrust Banks, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sti.ws.b",
   "FIELD9": ""
 },
 {
   "symbol": "STI^A",
   "name": "SunTrust Banks, Inc.",
   "last_sale": "22.98",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sti^a",
   "FIELD9": ""
 },
 {
   "symbol": "SPN",
   "name": "Superior Energy Services, Inc.",
   "last_sale": "9.52",
   "market_cap": "$1.47B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oilfield Services/Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/spn",
   "FIELD9": ""
 },
 {
   "symbol": "SUP",
   "name": "Superior Industries International, Inc.",
   "last_sale": "18.15",
   "market_cap": "$454.1M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/sup",
   "FIELD9": ""
 },
 {
   "symbol": "SVU",
   "name": "SuperValu Inc.",
   "last_sale": "32.25",
   "market_cap": "$1.25B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/svu",
   "FIELD9": ""
 },
 {
   "symbol": "SLD",
   "name": "Sutherland Asset Management Corporation",
   "last_sale": "16.9",
   "market_cap": "$541.68M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/sld",
   "FIELD9": ""
 },
 {
   "symbol": "SLDA",
   "name": "Sutherland Asset Management Corporation",
   "last_sale": "26.03",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/slda",
   "FIELD9": ""
 },
 {
   "symbol": "SLDD",
   "name": "Sutherland Asset Management Corporation",
   "last_sale": "25.6054",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/sldd",
   "FIELD9": ""
 },
 {
   "symbol": "SWZ",
   "name": "Swiss Helvetia Fund, Inc. (The)",
   "last_sale": "8.62",
   "market_cap": "$218.21M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/swz",
   "FIELD9": ""
 },
 {
   "symbol": "SWCH",
   "name": "Switch, Inc.",
   "last_sale": "11.07",
   "market_cap": "$2.8B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/swch",
   "FIELD9": ""
 },
 {
   "symbol": "SYF",
   "name": "Synchrony Financial",
   "last_sale": "33.47",
   "market_cap": "$24.79B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/syf",
   "FIELD9": ""
 },
 {
   "symbol": "SNX",
   "name": "Synnex Corporation",
   "last_sale": "93.08",
   "market_cap": "$3.69B",
   "IPOyear": "2003",
   "sector": "Technology",
   "industry": "Retail: Computer Software & Peripheral Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/snx",
   "FIELD9": ""
 },
 {
   "symbol": "SNV",
   "name": "Synovus Financial Corp.",
   "last_sale": "47.65",
   "market_cap": "$5.59B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/snv",
   "FIELD9": ""
 },
 {
   "symbol": "SNV^D",
   "name": "Synovus Financial Corp.",
   "last_sale": "25.9501",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/snv^d",
   "FIELD9": ""
 },
 {
   "symbol": "GJP",
   "name": "Synthetic Fixed-Income Securities, Inc.",
   "last_sale": "22.76",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gjp",
   "FIELD9": ""
 },
 {
   "symbol": "GJR",
   "name": "Synthetic Fixed-Income Securities, Inc.",
   "last_sale": "23.135",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gjr",
   "FIELD9": ""
 },
 {
   "symbol": "GJT",
   "name": "Synthetic Fixed-Income Securities, Inc.",
   "last_sale": "21.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gjt",
   "FIELD9": ""
 },
 {
   "symbol": "GJV",
   "name": "Synthetic Fixed-Income Securities, Inc.",
   "last_sale": "25.9513",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gjv",
   "FIELD9": ""
 },
 {
   "symbol": "SYY",
   "name": "Sysco Corporation",
   "last_sale": "72.97",
   "market_cap": "$37.93B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/syy",
   "FIELD9": ""
 },
 {
   "symbol": "SYX",
   "name": "Systemax Inc.",
   "last_sale": "34.8",
   "market_cap": "$1.29B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/syx",
   "FIELD9": ""
 },
 {
   "symbol": "DATA",
   "name": "Tableau Software, Inc.",
   "last_sale": "110.18",
   "market_cap": "$9.14B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/data",
   "FIELD9": ""
 },
 {
   "symbol": "TAHO",
   "name": "Tahoe Resources, Inc.",
   "last_sale": "2.86",
   "market_cap": "$896.07M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/taho",
   "FIELD9": ""
 },
 {
   "symbol": "TLRD",
   "name": "Tailored Brands, Inc.",
   "last_sale": "25.29",
   "market_cap": "$1.26B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/tlrd",
   "FIELD9": ""
 },
 {
   "symbol": "TWN",
   "name": "Taiwan Fund, Inc. (The)",
   "last_sale": "19.34",
   "market_cap": "$157.43M",
   "IPOyear": "1986",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/twn",
   "FIELD9": ""
 },
 {
   "symbol": "TSM",
   "name": "Taiwan Semiconductor Manufacturing Company Ltd.",
   "last_sale": "44.06",
   "market_cap": "$228.5B",
   "IPOyear": "1997",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/tsm",
   "FIELD9": ""
 },
 {
   "symbol": "TAL",
   "name": "TAL Education Group",
   "last_sale": "26.98",
   "market_cap": "$15.29B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tal",
   "FIELD9": ""
 },
 {
   "symbol": "TGE",
   "name": "Tallgrass Energy, LP",
   "last_sale": "23.24",
   "market_cap": "$6.51B",
   "IPOyear": "2015",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/tge",
   "FIELD9": ""
 },
 {
   "symbol": "TALO",
   "name": "Talos Energy, Inc.",
   "last_sale": "31.6",
   "market_cap": "$1.71B",
   "IPOyear": "2018",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/talo",
   "FIELD9": ""
 },
 {
   "symbol": "SKT",
   "name": "Tanger Factory Outlet Centers, Inc.",
   "last_sale": "23.07",
   "market_cap": "$2.17B",
   "IPOyear": "1993",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/skt",
   "FIELD9": ""
 },
 {
   "symbol": "TPR",
   "name": "Tapestry, Inc.",
   "last_sale": "50.2",
   "market_cap": "$14.46B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/tpr",
   "FIELD9": ""
 },
 {
   "symbol": "NGLS^A",
   "name": "Targa Resources Partners LP",
   "last_sale": "27.1385",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ngls^a",
   "FIELD9": ""
 },
 {
   "symbol": "TRGP",
   "name": "Targa Resources, Inc.",
   "last_sale": "55.33",
   "market_cap": "$12.48B",
   "IPOyear": "2010",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/trgp",
   "FIELD9": ""
 },
 {
   "symbol": "TGT",
   "name": "Target Corporation",
   "last_sale": "87.31",
   "market_cap": "$45.96B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/tgt",
   "FIELD9": ""
 },
 {
   "symbol": "TARO",
   "name": "Taro Pharmaceutical Industries Ltd.",
   "last_sale": "99.42",
   "market_cap": "$3.92B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/taro",
   "FIELD9": ""
 },
 {
   "symbol": "TTM",
   "name": "Tata Motors Ltd",
   "last_sale": "17.14",
   "market_cap": "$11.64B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/ttm",
   "FIELD9": ""
 },
 {
   "symbol": "TCO",
   "name": "Taubman Centers, Inc.",
   "last_sale": "60.79",
   "market_cap": "$3.71B",
   "IPOyear": "1992",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/tco",
   "FIELD9": ""
 },
 {
   "symbol": "TCO^J",
   "name": "Taubman Centers, Inc.",
   "last_sale": "25.1077",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tco^j",
   "FIELD9": ""
 },
 {
   "symbol": "TCO^K",
   "name": "Taubman Centers, Inc.",
   "last_sale": "24.9",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tco^k",
   "FIELD9": ""
 },
 {
   "symbol": "TMHC",
   "name": "Taylor Morrison Home Corporation",
   "last_sale": "19.19",
   "market_cap": "$2.15B",
   "IPOyear": "2013",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/tmhc",
   "FIELD9": ""
 },
 {
   "symbol": "TCP",
   "name": "TC PipeLines, LP",
   "last_sale": "31.75",
   "market_cap": "$2.32B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/tcp",
   "FIELD9": ""
 },
 {
   "symbol": "TCF",
   "name": "TCF Financial Corporation",
   "last_sale": "25.18",
   "market_cap": "$4.22B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/tcf",
   "FIELD9": ""
 },
 {
   "symbol": "TCF.WS",
   "name": "TCF Financial Corporation",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tcf.ws",
   "FIELD9": ""
 },
 {
   "symbol": "TCF^D",
   "name": "TCF Financial Corporation",
   "last_sale": "24.2425",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tcf^d",
   "FIELD9": ""
 },
 {
   "symbol": "TSI",
   "name": "TCW Strategic Income Fund, Inc.",
   "last_sale": "5.63",
   "market_cap": "$268.48M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tsi",
   "FIELD9": ""
 },
 {
   "symbol": "TEL",
   "name": "TE Connectivity Ltd.",
   "last_sale": "92.61",
   "market_cap": "$32.27B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Electronic Components",
   "summary_quote": "https://www.nasdaq.com/symbol/tel",
   "FIELD9": ""
 },
 {
   "symbol": "TISI",
   "name": "Team, Inc.",
   "last_sale": "22.25",
   "market_cap": "$667.98M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tisi",
   "FIELD9": ""
 },
 {
   "symbol": "FTI",
   "name": "TechnipFMC plc",
   "last_sale": "31.2",
   "market_cap": "$14.14B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/fti",
   "FIELD9": ""
 },
 {
   "symbol": "TECK",
   "name": "Teck Resources Ltd",
   "last_sale": "25.55",
   "market_cap": "$14.48B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/teck",
   "FIELD9": ""
 },
 {
   "symbol": "TK",
   "name": "Teekay Corporation",
   "last_sale": "6.45",
   "market_cap": "$647.81M",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/tk",
   "FIELD9": ""
 },
 {
   "symbol": "TGP",
   "name": "Teekay LNG Partners L.P.",
   "last_sale": "15.1",
   "market_cap": "$1.2B",
   "IPOyear": "2005",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/tgp",
   "FIELD9": ""
 },
 {
   "symbol": "TGP^A",
   "name": "Teekay LNG Partners L.P.",
   "last_sale": "25.31",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tgp^a",
   "FIELD9": ""
 },
 {
   "symbol": "TGP^B",
   "name": "Teekay LNG Partners L.P.",
   "last_sale": "24.3",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tgp^b",
   "FIELD9": ""
 },
 {
   "symbol": "TOO",
   "name": "Teekay Offshore Partners L.P.",
   "last_sale": "2.33",
   "market_cap": "$956M",
   "IPOyear": "2006",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/too",
   "FIELD9": ""
 },
 {
   "symbol": "TOO^A",
   "name": "Teekay Offshore Partners L.P.",
   "last_sale": "21.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/too^a",
   "FIELD9": ""
 },
 {
   "symbol": "TOO^B",
   "name": "Teekay Offshore Partners L.P.",
   "last_sale": "24.1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/too^b",
   "FIELD9": ""
 },
 {
   "symbol": "TOO^E",
   "name": "Teekay Offshore Partners L.P.",
   "last_sale": "24.3866",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/too^e",
   "FIELD9": ""
 },
 {
   "symbol": "TNK",
   "name": "Teekay Tankers Ltd.",
   "last_sale": "1.03",
   "market_cap": "$276.66M",
   "IPOyear": "2007",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/tnk",
   "FIELD9": ""
 },
 {
   "symbol": "GCI",
   "name": "TEGNA Inc.",
   "last_sale": "10.35",
   "market_cap": "$1.17B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Newspapers/Magazines",
   "summary_quote": "https://www.nasdaq.com/symbol/gci",
   "FIELD9": ""
 },
 {
   "symbol": "TGNA",
   "name": "TEGNA Inc.",
   "last_sale": "11.85",
   "market_cap": "$2.55B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/tgna",
   "FIELD9": ""
 },
 {
   "symbol": "TRC",
   "name": "Tejon Ranch Co",
   "last_sale": "22.45",
   "market_cap": "$582.81M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/trc",
   "FIELD9": ""
 },
 {
   "symbol": "HQH",
   "name": "Tekla Healthcare Investors",
   "last_sale": "22.78",
   "market_cap": "$952.86M",
   "IPOyear": "1987",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hqh",
   "FIELD9": ""
 },
 {
   "symbol": "THQ",
   "name": "Tekla Healthcare Opportunies Fund",
   "last_sale": "18.68",
   "market_cap": "$786.53M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/thq",
   "FIELD9": ""
 },
 {
   "symbol": "HQL",
   "name": "Tekla Life Sciences Investors",
   "last_sale": "20",
   "market_cap": "$444.25M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hql",
   "FIELD9": ""
 },
 {
   "symbol": "THW",
   "name": "Tekla World Healthcare Fund",
   "last_sale": "13.85",
   "market_cap": "$421.04M",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/thw",
   "FIELD9": ""
 },
 {
   "symbol": "TDOC",
   "name": "Teladoc Health, Inc.",
   "last_sale": "78.1",
   "market_cap": "$5.43B",
   "IPOyear": "2015",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tdoc",
   "FIELD9": ""
 },
 {
   "symbol": "TLRA",
   "name": "Telaria, Inc.",
   "last_sale": "3.9",
   "market_cap": "$205.01M",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/tlra",
   "FIELD9": ""
 },
 {
   "symbol": "TEO",
   "name": "Telecom Argentina Stet - France Telecom S.A.",
   "last_sale": "19.67",
   "market_cap": "$8.47B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/teo",
   "FIELD9": ""
 },
 {
   "symbol": "TI",
   "name": "Telecom Italia S.P.A.",
   "last_sale": "6.62",
   "market_cap": "$13.95B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/ti",
   "FIELD9": ""
 },
 {
   "symbol": "TI.A",
   "name": "Telecom Italia S.P.A.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ti.a",
   "FIELD9": ""
 },
 {
   "symbol": "TDY",
   "name": "Teledyne Technologies Incorporated",
   "last_sale": "247.4",
   "market_cap": "$8.88B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/tdy",
   "FIELD9": ""
 },
 {
   "symbol": "TFX",
   "name": "Teleflex Incorporated",
   "last_sale": "269.75",
   "market_cap": "$12.35B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical/Dental Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/tfx",
   "FIELD9": ""
 },
 {
   "symbol": "VIV",
   "name": "Telefonica Brasil S.A.",
   "last_sale": "9.63",
   "market_cap": "$16.26B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/viv",
   "FIELD9": ""
 },
 {
   "symbol": "TEF",
   "name": "Telefonica SA",
   "last_sale": "8.03",
   "market_cap": "$41.69B",
   "IPOyear": "1988",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tef",
   "FIELD9": ""
 },
 {
   "symbol": "TDA",
   "name": "Telephone and Data Systems, Inc.",
   "last_sale": "23.97",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tda",
   "FIELD9": ""
 },
 {
   "symbol": "TDE",
   "name": "Telephone and Data Systems, Inc.",
   "last_sale": "25.03",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tde",
   "FIELD9": ""
 },
 {
   "symbol": "TDI",
   "name": "Telephone and Data Systems, Inc.",
   "last_sale": "25.13",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tdi",
   "FIELD9": ""
 },
 {
   "symbol": "TDJ",
   "name": "Telephone and Data Systems, Inc.",
   "last_sale": "25.065",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tdj",
   "FIELD9": ""
 },
 {
   "symbol": "TDS",
   "name": "Telephone and Data Systems, Inc.",
   "last_sale": "30.5",
   "market_cap": "$3.41B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tds",
   "FIELD9": ""
 },
 {
   "symbol": "TU",
   "name": "TELUS Corporation",
   "last_sale": "36.77",
   "market_cap": "$21.98B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tu",
   "FIELD9": ""
 },
 {
   "symbol": "TDF",
   "name": "Templeton Dragon Fund, Inc.",
   "last_sale": "19.98",
   "market_cap": "$682.06M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tdf",
   "FIELD9": ""
 },
 {
   "symbol": "EMF",
   "name": "Templeton Emerging Markets Fund",
   "last_sale": "14.7",
   "market_cap": "$264.74M",
   "IPOyear": "1987",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/emf",
   "FIELD9": ""
 },
 {
   "symbol": "TEI",
   "name": "Templeton Emerging Markets Income Fund, Inc.",
   "last_sale": "9.95",
   "market_cap": "$477.58M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tei",
   "FIELD9": ""
 },
 {
   "symbol": "GIM",
   "name": "Templeton Global Income Fund, Inc.",
   "last_sale": "6.03",
   "market_cap": "$808.89M",
   "IPOyear": "1988",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gim",
   "FIELD9": ""
 },
 {
   "symbol": "TPX",
   "name": "Tempur Sealy International, Inc.",
   "last_sale": "53.83",
   "market_cap": "$2.93B",
   "IPOyear": "2003",
   "sector": "Consumer Durables",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/tpx",
   "FIELD9": ""
 },
 {
   "symbol": "TS",
   "name": "Tenaris S.A.",
   "last_sale": "32.7",
   "market_cap": "$19.3B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/ts",
   "FIELD9": ""
 },
 {
   "symbol": "THC",
   "name": "Tenet Healthcare Corporation",
   "last_sale": "28.1",
   "market_cap": "$2.88B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/thc",
   "FIELD9": ""
 },
 {
   "symbol": "TNC",
   "name": "Tennant Company",
   "last_sale": "74",
   "market_cap": "$1.34B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/tnc",
   "FIELD9": ""
 },
 {
   "symbol": "TEN",
   "name": "Tenneco Inc.",
   "last_sale": "45.49",
   "market_cap": "$2.34B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/ten",
   "FIELD9": ""
 },
 {
   "symbol": "TVC",
   "name": "Tennessee Valley Authority",
   "last_sale": "24.96",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/tvc",
   "FIELD9": ""
 },
 {
   "symbol": "TVE",
   "name": "Tennessee Valley Authority",
   "last_sale": "24.57",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/tve",
   "FIELD9": ""
 },
 {
   "symbol": "TDC",
   "name": "Teradata Corporation",
   "last_sale": "38.72",
   "market_cap": "$4.61B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/tdc",
   "FIELD9": ""
 },
 {
   "symbol": "TER",
   "name": "Teradyne, Inc.",
   "last_sale": "38.21",
   "market_cap": "$7.12B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/ter",
   "FIELD9": ""
 },
 {
   "symbol": "TEX",
   "name": "Terex Corporation",
   "last_sale": "41.94",
   "market_cap": "$3.09B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/tex",
   "FIELD9": ""
 },
 {
   "symbol": "TX",
   "name": "Ternium S.A.",
   "last_sale": "29.99",
   "market_cap": "$5.89B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/tx",
   "FIELD9": ""
 },
 {
   "symbol": "TRNO",
   "name": "Terreno Realty Corporation",
   "last_sale": "37.59",
   "market_cap": "$2.2B",
   "IPOyear": "2010",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/trno",
   "FIELD9": ""
 },
 {
   "symbol": "TTI",
   "name": "Tetra Technologies, Inc.",
   "last_sale": "4.39",
   "market_cap": "$551.73M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/tti",
   "FIELD9": ""
 },
 {
   "symbol": "TEVA",
   "name": "Teva Pharmaceutical Industries Limited",
   "last_sale": "24.36",
   "market_cap": "$24.81B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/teva",
   "FIELD9": ""
 },
 {
   "symbol": "TPL",
   "name": "Texas Pacific Land Trust",
   "last_sale": "840.04",
   "market_cap": "$6.54B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/tpl",
   "FIELD9": ""
 },
 {
   "symbol": "TGH",
   "name": "Textainer Group Holdings Limited",
   "last_sale": "13.65",
   "market_cap": "$780.04M",
   "IPOyear": "2007",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tgh",
   "FIELD9": ""
 },
 {
   "symbol": "TXT",
   "name": "Textron Inc.",
   "last_sale": "71.82",
   "market_cap": "$17.84B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/txt",
   "FIELD9": ""
 },
 {
   "symbol": "AES",
   "name": "The AES Corporation",
   "last_sale": "13.96",
   "market_cap": "$9.24B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/aes",
   "FIELD9": ""
 },
 {
   "symbol": "BX",
   "name": "The Blackstone Group L.P.",
   "last_sale": "39.49",
   "market_cap": "$47.52B",
   "IPOyear": "2007",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/bx",
   "FIELD9": ""
 },
 {
   "symbol": "CEE",
   "name": "The Central and Eastern Europe Fund, Inc.",
   "last_sale": "23.66",
   "market_cap": "$165.68M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/cee",
   "FIELD9": ""
 },
 {
   "symbol": "SCHW",
   "name": "The Charles Schwab Corporation",
   "last_sale": "51.84",
   "market_cap": "$70.04B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/schw",
   "FIELD9": ""
 },
 {
   "symbol": "SCHW^C",
   "name": "The Charles Schwab Corporation",
   "last_sale": "25.78",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/schw^c",
   "FIELD9": ""
 },
 {
   "symbol": "SCHW^D",
   "name": "The Charles Schwab Corporation",
   "last_sale": "25.6703",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/schw^d",
   "FIELD9": ""
 },
 {
   "symbol": "COO",
   "name": "The Cooper Companies, Inc. ",
   "last_sale": "268.93",
   "market_cap": "$13.22B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Ophthalmic Goods",
   "summary_quote": "https://www.nasdaq.com/symbol/coo",
   "FIELD9": ""
 },
 {
   "symbol": "GRX",
   "name": "The Gabelli Healthcare & Wellness Trust",
   "last_sale": "11.07",
   "market_cap": "$219.28M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/grx",
   "FIELD9": ""
 },
 {
   "symbol": "GRX^A",
   "name": "The Gabelli Healthcare & Wellness Trust",
   "last_sale": "25.2",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/grx^a",
   "FIELD9": ""
 },
 {
   "symbol": "GRX^B",
   "name": "The Gabelli Healthcare & Wellness Trust",
   "last_sale": "25.55",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/grx^b",
   "FIELD9": ""
 },
 {
   "symbol": "GDL",
   "name": "The GDL Fund",
   "last_sale": "9.14",
   "market_cap": "$166.79M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gdl",
   "FIELD9": ""
 },
 {
   "symbol": "GDL^C",
   "name": "The GDL Fund",
   "last_sale": "51.41",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gdl^c",
   "FIELD9": ""
 },
 {
   "symbol": "THG",
   "name": "The Hanover Insurance Group, Inc.",
   "last_sale": "118.21",
   "market_cap": "$5.03B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/thg",
   "FIELD9": ""
 },
 {
   "symbol": "THGA",
   "name": "The Hanover Insurance Group, Inc.",
   "last_sale": "25.18",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/thga",
   "FIELD9": ""
 },
 {
   "symbol": "MSG",
   "name": "The Madison Square Garden Company",
   "last_sale": "304.16",
   "market_cap": "$7.2B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/msg",
   "FIELD9": ""
 },
 {
   "symbol": "RUBI",
   "name": "The Rubicon Project, Inc.",
   "last_sale": "3.8",
   "market_cap": "$192.85M",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/rubi",
   "FIELD9": ""
 },
 {
   "symbol": "TRV",
   "name": "The Travelers Companies, Inc.",
   "last_sale": "134.44",
   "market_cap": "$35.99B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/trv",
   "FIELD9": ""
 },
 {
   "symbol": "VAM",
   "name": "The Vivaldi Opportunities Fund",
   "last_sale": "15",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vam",
   "FIELD9": ""
 },
 {
   "symbol": "TMO",
   "name": "Thermo Fisher Scientific Inc",
   "last_sale": "243.49",
   "market_cap": "$98.08B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/tmo",
   "FIELD9": ""
 },
 {
   "symbol": "THR",
   "name": "Thermon Group Holdings, Inc.",
   "last_sale": "26.16",
   "market_cap": "$851.79M",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/thr",
   "FIELD9": ""
 },
 {
   "symbol": "TPRE",
   "name": "Third Point Reinsurance Ltd.",
   "last_sale": "13.4",
   "market_cap": "$1.34B",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/tpre",
   "FIELD9": ""
 },
 {
   "symbol": "TSLF",
   "name": "THL Credit Senior Loan Fund",
   "last_sale": "16.71",
   "market_cap": "$123.97M",
   "IPOyear": "2013",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tslf",
   "FIELD9": ""
 },
 {
   "symbol": "TCRX",
   "name": "THL Credit, Inc.",
   "last_sale": "25.31",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tcrx",
   "FIELD9": ""
 },
 {
   "symbol": "TCRZ",
   "name": "THL Credit, Inc.",
   "last_sale": "25.4",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tcrz",
   "FIELD9": ""
 },
 {
   "symbol": "TRI",
   "name": "Thomson Reuters Corp",
   "last_sale": "45.37",
   "market_cap": "$31.87B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Publishing",
   "summary_quote": "https://www.nasdaq.com/symbol/tri",
   "FIELD9": ""
 },
 {
   "symbol": "THO",
   "name": "Thor Industries, Inc.",
   "last_sale": "89.04",
   "market_cap": "$4.69B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/tho",
   "FIELD9": ""
 },
 {
   "symbol": "TDW",
   "name": "Tidewater Inc.",
   "last_sale": "31.1",
   "market_cap": "$822.15M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/tdw",
   "FIELD9": ""
 },
 {
   "symbol": "TDW.WS.A",
   "name": "Tidewater Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tdw.ws.a",
   "FIELD9": ""
 },
 {
   "symbol": "TDW.WS.B",
   "name": "Tidewater Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tdw.ws.b",
   "FIELD9": ""
 },
 {
   "symbol": "TIER",
   "name": "TIER REIT, Inc.",
   "last_sale": "23.31",
   "market_cap": "$1.18B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/tier",
   "FIELD9": ""
 },
 {
   "symbol": "TIF",
   "name": "Tiffany & Co.",
   "last_sale": "126.62",
   "market_cap": "$15.5B",
   "IPOyear": "1987",
   "sector": "Consumer Services",
   "industry": "Consumer Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/tif",
   "FIELD9": ""
 },
 {
   "symbol": "TLYS",
   "name": "Tilly&#39;s, Inc.",
   "last_sale": "18.89",
   "market_cap": "$555.53M",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/tlys",
   "FIELD9": ""
 },
 {
   "symbol": "TSU",
   "name": "TIM Participacoes S.A.",
   "last_sale": "14.53",
   "market_cap": "$7.04B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tsu",
   "FIELD9": ""
 },
 {
   "symbol": "TKR",
   "name": "Timken Company (The)",
   "last_sale": "52.1",
   "market_cap": "$4.02B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/tkr",
   "FIELD9": ""
 },
 {
   "symbol": "TMST",
   "name": "TimkenSteel Corporation",
   "last_sale": "14.51",
   "market_cap": "$646.92M",
   "IPOyear": "2014",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/tmst",
   "FIELD9": ""
 },
 {
   "symbol": "TWI",
   "name": "Titan International, Inc.",
   "last_sale": "7.56",
   "market_cap": "$452.83M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/twi",
   "FIELD9": ""
 },
 {
   "symbol": "TJX",
   "name": "TJX Companies, Inc. (The)",
   "last_sale": "109.71",
   "market_cap": "$68.1B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/tjx",
   "FIELD9": ""
 },
 {
   "symbol": "TOL",
   "name": "Toll Brothers, Inc.",
   "last_sale": "35.85",
   "market_cap": "$5.28B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/tol",
   "FIELD9": ""
 },
 {
   "symbol": "TR",
   "name": "Tootsie Roll Industries, Inc.",
   "last_sale": "29",
   "market_cap": "$1.13B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Specialty Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/tr",
   "FIELD9": ""
 },
 {
   "symbol": "BLD",
   "name": "TopBuild Corp.",
   "last_sale": "61.83",
   "market_cap": "$2.2B",
   "IPOyear": "2015",
   "sector": "Basic Industries",
   "industry": "Engineering & Construction",
   "summary_quote": "https://www.nasdaq.com/symbol/bld",
   "FIELD9": ""
 },
 {
   "symbol": "TMK",
   "name": "Torchmark Corporation",
   "last_sale": "88.89",
   "market_cap": "$10.02B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/tmk",
   "FIELD9": ""
 },
 {
   "symbol": "TMK^C",
   "name": "Torchmark Corporation",
   "last_sale": "25.815",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tmk^c",
   "FIELD9": ""
 },
 {
   "symbol": "TTC",
   "name": "Toro Company (The)",
   "last_sale": "62.17",
   "market_cap": "$6.56B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Tools/Hardware",
   "summary_quote": "https://www.nasdaq.com/symbol/ttc",
   "FIELD9": ""
 },
 {
   "symbol": "TD",
   "name": "Toronto Dominion Bank (The)",
   "last_sale": "61.62",
   "market_cap": "$112.68B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/td",
   "FIELD9": ""
 },
 {
   "symbol": "NDP",
   "name": "Tortoise Energy Independence Fund, Inc.",
   "last_sale": "12.52",
   "market_cap": "$183.21M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ndp",
   "FIELD9": ""
 },
 {
   "symbol": "TYG",
   "name": "Tortoise Energy Infrastructure Corporation",
   "last_sale": "27.56",
   "market_cap": "$1.5B",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tyg",
   "FIELD9": ""
 },
 {
   "symbol": "NTG",
   "name": "Tortoise MLP Fund, Inc.",
   "last_sale": "16.31",
   "market_cap": "$773.14M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ntg",
   "FIELD9": ""
 },
 {
   "symbol": "TTP",
   "name": "Tortoise Pipeline & Energy Fund, Inc.",
   "last_sale": "17.52",
   "market_cap": "$175.48M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ttp",
   "FIELD9": ""
 },
 {
   "symbol": "TPZ",
   "name": "Tortoise Power and Energy Infrastructure Fund, Inc",
   "last_sale": "19.2",
   "market_cap": "$133.5M",
   "IPOyear": "2009",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tpz",
   "FIELD9": ""
 },
 {
   "symbol": "TOT",
   "name": "Total S.A.",
   "last_sale": "63.33",
   "market_cap": "$166.02B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/tot",
   "FIELD9": ""
 },
 {
   "symbol": "TSS",
   "name": "Total System Services, Inc.",
   "last_sale": "97.85",
   "market_cap": "$17.85B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tss",
   "FIELD9": ""
 },
 {
   "symbol": "TOWR",
   "name": "Tower International, Inc.",
   "last_sale": "31.9",
   "market_cap": "$657.27M",
   "IPOyear": "2010",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/towr",
   "FIELD9": ""
 },
 {
   "symbol": "TSQ",
   "name": "Townsquare Media, Inc.",
   "last_sale": "8.77",
   "market_cap": "$165.72M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/tsq",
   "FIELD9": ""
 },
 {
   "symbol": "TM",
   "name": "Toyota Motor Corp Ltd Ord",
   "last_sale": "124.72",
   "market_cap": "$181.86B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/tm",
   "FIELD9": ""
 },
 {
   "symbol": "TPGH",
   "name": "TPG Pace Holdings Corp.",
   "last_sale": "10.05",
   "market_cap": "$130.79M",
   "IPOyear": "2017",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tpgh",
   "FIELD9": ""
 },
 {
   "symbol": "TPGH.U",
   "name": "TPG Pace Holdings Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tpgh.u",
   "FIELD9": ""
 },
 {
   "symbol": "TPGH.WS",
   "name": "TPG Pace Holdings Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tpgh.ws",
   "FIELD9": ""
 },
 {
   "symbol": "TRTX",
   "name": "TPG RE Finance Trust, Inc.",
   "last_sale": "20.24",
   "market_cap": "$1.36B",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/trtx",
   "FIELD9": ""
 },
 {
   "symbol": "TSLX",
   "name": "TPG Specialty Lending, Inc.",
   "last_sale": "20.71",
   "market_cap": "$1.35B",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tslx",
   "FIELD9": ""
 },
 {
   "symbol": "TAC",
   "name": "TransAlta Corporation",
   "last_sale": "5.65",
   "market_cap": "$1.62B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/tac",
   "FIELD9": ""
 },
 {
   "symbol": "TRP",
   "name": "TransCanada Corporation",
   "last_sale": "41",
   "market_cap": "$37.2B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/trp",
   "FIELD9": ""
 },
 {
   "symbol": "TCI",
   "name": "Transcontinental Realty Investors, Inc.",
   "last_sale": "31.57",
   "market_cap": "$275.22M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/tci",
   "FIELD9": ""
 },
 {
   "symbol": "TDG",
   "name": "Transdigm Group Incorporated",
   "last_sale": "368.37",
   "market_cap": "$19.39B",
   "IPOyear": "2006",
   "sector": "Capital Goods",
   "industry": "Military/Government/Technical",
   "summary_quote": "https://www.nasdaq.com/symbol/tdg",
   "FIELD9": ""
 },
 {
   "symbol": "TLP",
   "name": "TransMontaigne Partners L.P.",
   "last_sale": "38.46",
   "market_cap": "$623.9M",
   "IPOyear": "2005",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/tlp",
   "FIELD9": ""
 },
 {
   "symbol": "RIG",
   "name": "Transocean Ltd.",
   "last_sale": "13.54",
   "market_cap": "$6.25B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/rig",
   "FIELD9": ""
 },
 {
   "symbol": "TGS",
   "name": "Transportadora De Gas Sa Ord B",
   "last_sale": "16.94",
   "market_cap": "$2.67B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/tgs",
   "FIELD9": ""
 },
 {
   "symbol": "TRU",
   "name": "TransUnion",
   "last_sale": "74.33",
   "market_cap": "$13.73B",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tru",
   "FIELD9": ""
 },
 {
   "symbol": "TVPT",
   "name": "Travelport Worldwide Limited",
   "last_sale": "16.8",
   "market_cap": "$2.12B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tvpt",
   "FIELD9": ""
 },
 {
   "symbol": "TREC",
   "name": "Trecora Resources",
   "last_sale": "14.35",
   "market_cap": "$351.38M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/trec",
   "FIELD9": ""
 },
 {
   "symbol": "TG",
   "name": "Tredegar Corporation",
   "last_sale": "23.25",
   "market_cap": "$771.72M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/tg",
   "FIELD9": ""
 },
 {
   "symbol": "THS",
   "name": "Treehouse Foods, Inc.",
   "last_sale": "52.05",
   "market_cap": "$2.93B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Packaged Foods",
   "summary_quote": "https://www.nasdaq.com/symbol/ths",
   "FIELD9": ""
 },
 {
   "symbol": "TREX",
   "name": "Trex Company, Inc.",
   "last_sale": "79.65",
   "market_cap": "$4.68B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Forest Products",
   "summary_quote": "https://www.nasdaq.com/symbol/trex",
   "FIELD9": ""
 },
 {
   "symbol": "TY",
   "name": "Tri Continental Corporation",
   "last_sale": "27.93",
   "market_cap": "$1.56B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ty",
   "FIELD9": ""
 },
 {
   "symbol": "TY^",
   "name": "Tri Continental Corporation",
   "last_sale": "50.65",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Miscellaneous",
   "summary_quote": "https://www.nasdaq.com/symbol/ty^",
   "FIELD9": ""
 },
 {
   "symbol": "TPH",
   "name": "TRI Pointe Group, Inc.",
   "last_sale": "13.26",
   "market_cap": "$2.02B",
   "IPOyear": "2013",
   "sector": "Capital Goods",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/tph",
   "FIELD9": ""
 },
 {
   "symbol": "TRCO",
   "name": "Tribune Media Company",
   "last_sale": "37.96",
   "market_cap": "$3.33B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Broadcasting",
   "summary_quote": "https://www.nasdaq.com/symbol/trco",
   "FIELD9": ""
 },
 {
   "symbol": "TNET",
   "name": "TriNet Group, Inc.",
   "last_sale": "52.7",
   "market_cap": "$3.72B",
   "IPOyear": "2014",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tnet",
   "FIELD9": ""
 },
 {
   "symbol": "TRN",
   "name": "Trinity Industries, Inc.",
   "last_sale": "37.17",
   "market_cap": "$5.49B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/trn",
   "FIELD9": ""
 },
 {
   "symbol": "TSE",
   "name": "Trinseo S.A.",
   "last_sale": "77.55",
   "market_cap": "$3.3B",
   "IPOyear": "2014",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/tse",
   "FIELD9": ""
 },
 {
   "symbol": "TPVG",
   "name": "TriplePoint Venture Growth BDC Corp.",
   "last_sale": "13.1",
   "market_cap": "$311.41M",
   "IPOyear": "2014",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tpvg",
   "FIELD9": ""
 },
 {
   "symbol": "TPVY",
   "name": "TriplePoint Venture Growth BDC Corp.",
   "last_sale": "25.25",
   "market_cap": "n/a",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tpvy",
   "FIELD9": ""
 },
 {
   "symbol": "GTS",
   "name": "Triple-S Management Corporation",
   "last_sale": "21.38",
   "market_cap": "$495.88M",
   "IPOyear": "2007",
   "sector": "Finance",
   "industry": "Accident &Health Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/gts",
   "FIELD9": ""
 },
 {
   "symbol": "TRTN",
   "name": "Triton International Limited",
   "last_sale": "37.75",
   "market_cap": "$3.05B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/trtn",
   "FIELD9": ""
 },
 {
   "symbol": "TGI",
   "name": "Triumph Group, Inc.",
   "last_sale": "23.35",
   "market_cap": "$1.16B",
   "IPOyear": "1996",
   "sector": "Capital Goods",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/tgi",
   "FIELD9": ""
 },
 {
   "symbol": "TROX",
   "name": "Tronox Limited",
   "last_sale": "13.43",
   "market_cap": "$1.65B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/trox",
   "FIELD9": ""
 },
 {
   "symbol": "TBI",
   "name": "TrueBlue, Inc.",
   "last_sale": "24.95",
   "market_cap": "$1.01B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Professional Services",
   "summary_quote": "https://www.nasdaq.com/symbol/tbi",
   "FIELD9": ""
 },
 {
   "symbol": "TNP",
   "name": "Tsakos Energy Navigation Ltd",
   "last_sale": "3.43",
   "market_cap": "$296.38M",
   "IPOyear": "2002",
   "sector": "Transportation",
   "industry": "Marine Transportation",
   "summary_quote": "https://www.nasdaq.com/symbol/tnp",
   "FIELD9": ""
 },
 {
   "symbol": "TNP^B",
   "name": "Tsakos Energy Navigation Ltd",
   "last_sale": "25.1845",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tnp^b",
   "FIELD9": ""
 },
 {
   "symbol": "TNP^C",
   "name": "Tsakos Energy Navigation Ltd",
   "last_sale": "25.25",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tnp^c",
   "FIELD9": ""
 },
 {
   "symbol": "TNP^D",
   "name": "Tsakos Energy Navigation Ltd",
   "last_sale": "24.243",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tnp^d",
   "FIELD9": ""
 },
 {
   "symbol": "TNP^E",
   "name": "Tsakos Energy Navigation Ltd",
   "last_sale": "24.735",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tnp^e",
   "FIELD9": ""
 },
 {
   "symbol": "TNP^F",
   "name": "Tsakos Energy Navigation Ltd",
   "last_sale": "24.972",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tnp^f",
   "FIELD9": ""
 },
 {
   "symbol": "TUP",
   "name": "Tupperware Brands Corporation",
   "last_sale": "34.55",
   "market_cap": "$1.73B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Plastic Products",
   "summary_quote": "https://www.nasdaq.com/symbol/tup",
   "FIELD9": ""
 },
 {
   "symbol": "TKC",
   "name": "Turkcell Iletisim Hizmetleri AS",
   "last_sale": "4.7",
   "market_cap": "$4.14B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/tkc",
   "FIELD9": ""
 },
 {
   "symbol": "TPB",
   "name": "Turning Point Brands, Inc.",
   "last_sale": "42.27",
   "market_cap": "$822.87M",
   "IPOyear": "2016",
   "sector": "Consumer Non-Durables",
   "industry": "Tobacco",
   "summary_quote": "https://www.nasdaq.com/symbol/tpb",
   "FIELD9": ""
 },
 {
   "symbol": "TRQ",
   "name": "Turquoise Hill Resources Ltd.",
   "last_sale": "2.2",
   "market_cap": "$4.43B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/trq",
   "FIELD9": ""
 },
 {
   "symbol": "TPC",
   "name": "Tutor Perini Corporation",
   "last_sale": "20.05",
   "market_cap": "$1B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "General Bldg Contractors - Nonresidential Bldgs",
   "summary_quote": "https://www.nasdaq.com/symbol/tpc",
   "FIELD9": ""
 },
 {
   "symbol": "TWLO",
   "name": "Twilio Inc.",
   "last_sale": "83.73",
   "market_cap": "$8.16B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/twlo",
   "FIELD9": ""
 },
 {
   "symbol": "TWTR",
   "name": "Twitter, Inc.",
   "last_sale": "28.5",
   "market_cap": "$21.6B",
   "IPOyear": "2013",
   "sector": "Communication Services",
   "industry": "Computer Software: Programming, Data Processing",
   "summary_quote": "https://www.nasdaq.com/symbol/twtr",
   "FIELD9": ""
 },
 {
   "symbol": "TWO",
   "name": "Two Harbors Investments Corp",
   "last_sale": "15.24",
   "market_cap": "$3.78B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/two",
   "FIELD9": ""
 },
 {
   "symbol": "TWO^A",
   "name": "Two Harbors Investments Corp",
   "last_sale": "26.62",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/two^a",
   "FIELD9": ""
 },
 {
   "symbol": "TWO^B",
   "name": "Two Harbors Investments Corp",
   "last_sale": "25.78",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/two^b",
   "FIELD9": ""
 },
 {
   "symbol": "TWO^C",
   "name": "Two Harbors Investments Corp",
   "last_sale": "24.53",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/two^c",
   "FIELD9": ""
 },
 {
   "symbol": "TWO^D",
   "name": "Two Harbors Investments Corp",
   "last_sale": "25.18",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/two^d",
   "FIELD9": ""
 },
 {
   "symbol": "TWO^E",
   "name": "Two Harbors Investments Corp",
   "last_sale": "24.6",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/two^e",
   "FIELD9": ""
 },
 {
   "symbol": "TYL",
   "name": "Tyler Technologies, Inc.",
   "last_sale": "241.35",
   "market_cap": "$9.33B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/tyl",
   "FIELD9": ""
 },
 {
   "symbol": "TSN",
   "name": "Tyson Foods, Inc.",
   "last_sale": "61.24",
   "market_cap": "$22.41B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Meat/Poultry/Fish",
   "summary_quote": "https://www.nasdaq.com/symbol/tsn",
   "FIELD9": ""
 },
 {
   "symbol": "USB",
   "name": "U.S. Bancorp",
   "last_sale": "55.14",
   "market_cap": "$89.83B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/usb",
   "FIELD9": ""
 },
 {
   "symbol": "USB^A",
   "name": "U.S. Bancorp",
   "last_sale": "920",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/usb^a",
   "FIELD9": ""
 },
 {
   "symbol": "USB^H",
   "name": "U.S. Bancorp",
   "last_sale": "22.41",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/usb^h",
   "FIELD9": ""
 },
 {
   "symbol": "USB^M",
   "name": "U.S. Bancorp",
   "last_sale": "27.47",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/usb^m",
   "FIELD9": ""
 },
 {
   "symbol": "USB^O",
   "name": "U.S. Bancorp",
   "last_sale": "25.06",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/usb^o",
   "FIELD9": ""
 },
 {
   "symbol": "USB^P",
   "name": "U.S. Bancorp",
   "last_sale": "25.09",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/usb^p",
   "FIELD9": ""
 },
 {
   "symbol": "USPH",
   "name": "U.S. Physical Therapy, Inc.",
   "last_sale": "116.9",
   "market_cap": "$1.48B",
   "IPOyear": "1992",
   "sector": "Health Care",
   "industry": "Medical/Nursing Services",
   "summary_quote": "https://www.nasdaq.com/symbol/usph",
   "FIELD9": ""
 },
 {
   "symbol": "SLCA",
   "name": "U.S. Silica Holdings, Inc.",
   "last_sale": "19.8",
   "market_cap": "$1.53B",
   "IPOyear": "2012",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/slca",
   "FIELD9": ""
 },
 {
   "symbol": "USX",
   "name": "U.S. Xpress Enterprises, Inc.",
   "last_sale": "14.09",
   "market_cap": "$680.47M",
   "IPOyear": "2018",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/usx",
   "FIELD9": ""
 },
 {
   "symbol": "UBS",
   "name": "UBS AG",
   "last_sale": "16.51",
   "market_cap": "$61.57B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/ubs",
   "FIELD9": ""
 },
 {
   "symbol": "UDR",
   "name": "UDR, Inc.",
   "last_sale": "40.8",
   "market_cap": "$10.92B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/udr",
   "FIELD9": ""
 },
 {
   "symbol": "UGI",
   "name": "UGI Corporation",
   "last_sale": "54.43",
   "market_cap": "$9.46B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/ugi",
   "FIELD9": ""
 },
 {
   "symbol": "UGP",
   "name": "Ultrapar Participacoes S.A.",
   "last_sale": "9.12",
   "market_cap": "$5.07B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Oil/Gas Transmission",
   "summary_quote": "https://www.nasdaq.com/symbol/ugp",
   "FIELD9": ""
 },
 {
   "symbol": "UMH",
   "name": "UMH Properties, Inc.",
   "last_sale": "15.64",
   "market_cap": "$579.53M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/umh",
   "FIELD9": ""
 },
 {
   "symbol": "UMH^B",
   "name": "UMH Properties, Inc.",
   "last_sale": "26.339",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/umh^b",
   "FIELD9": ""
 },
 {
   "symbol": "UMH^C",
   "name": "UMH Properties, Inc.",
   "last_sale": "24.95",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/umh^c",
   "FIELD9": ""
 },
 {
   "symbol": "UMH^D",
   "name": "UMH Properties, Inc.",
   "last_sale": "23.8447",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/umh^d",
   "FIELD9": ""
 },
 {
   "symbol": "UA",
   "name": "Under Armour, Inc.",
   "last_sale": "18.7",
   "market_cap": "$8.32B",
   "IPOyear": "2016",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/ua",
   "FIELD9": ""
 },
 {
   "symbol": "UAA",
   "name": "Under Armour, Inc.",
   "last_sale": "20.57",
   "market_cap": "$9.15B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/uaa",
   "FIELD9": ""
 },
 {
   "symbol": "UFI",
   "name": "Unifi, Inc.",
   "last_sale": "28.5",
   "market_cap": "$523.64M",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Textiles",
   "summary_quote": "https://www.nasdaq.com/symbol/ufi",
   "FIELD9": ""
 },
 {
   "symbol": "UNF",
   "name": "Unifirst Corporation",
   "last_sale": "175.95",
   "market_cap": "$3.37B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/unf",
   "FIELD9": ""
 },
 {
   "symbol": "UN",
   "name": "Unilever NV",
   "last_sale": "56.51",
   "market_cap": "$153.71B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/un",
   "FIELD9": ""
 },
 {
   "symbol": "UL",
   "name": "Unilever PLC",
   "last_sale": "55.89",
   "market_cap": "$151.41B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Package Goods/Cosmetics",
   "summary_quote": "https://www.nasdaq.com/symbol/ul",
   "FIELD9": ""
 },
 {
   "symbol": "LTN",
   "name": "Union Acquisition Corp.",
   "last_sale": "9.7",
   "market_cap": "$139.44M",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ltn",
   "FIELD9": ""
 },
 {
   "symbol": "LTN.U",
   "name": "Union Acquisition Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ltn.u",
   "FIELD9": ""
 },
 {
   "symbol": "LTN.WS",
   "name": "Union Acquisition Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ltn.ws",
   "FIELD9": ""
 },
 {
   "symbol": "LTN~",
   "name": "Union Acquisition Corp.",
   "last_sale": "0.36",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ltn~",
   "FIELD9": ""
 },
 {
   "symbol": "UNP",
   "name": "Union Pacific Corporation",
   "last_sale": "164.99",
   "market_cap": "$122.01B",
   "IPOyear": "n/a",
   "sector": "Transportation",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/unp",
   "FIELD9": ""
 },
 {
   "symbol": "UIS",
   "name": "Unisys Corporation",
   "last_sale": "20.5",
   "market_cap": "$1.05B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/uis",
   "FIELD9": ""
 },
 {
   "symbol": "UNT",
   "name": "Unit Corporation",
   "last_sale": "26.98",
   "market_cap": "$1.46B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/unt",
   "FIELD9": ""
 },
 {
   "symbol": "UMC",
   "name": "United Microelectronics Corporation",
   "last_sale": "2.5",
   "market_cap": "$6B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Semiconductors",
   "summary_quote": "https://www.nasdaq.com/symbol/umc",
   "FIELD9": ""
 },
 {
   "symbol": "UPS",
   "name": "United Parcel Service, Inc.",
   "last_sale": "118.49",
   "market_cap": "$101.94B",
   "IPOyear": "1999",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/ups",
   "FIELD9": ""
 },
 {
   "symbol": "URI",
   "name": "United Rentals, Inc.",
   "last_sale": "169.04",
   "market_cap": "$13.99B",
   "IPOyear": "1997",
   "sector": "Technology",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/uri",
   "FIELD9": ""
 },
 {
   "symbol": "USM",
   "name": "United States Cellular Corporation",
   "last_sale": "44.4",
   "market_cap": "$3.8B",
   "IPOyear": "1988",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/usm",
   "FIELD9": ""
 },
 {
   "symbol": "UZA",
   "name": "United States Cellular Corporation",
   "last_sale": "25.08",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/uza",
   "FIELD9": ""
 },
 {
   "symbol": "UZB",
   "name": "United States Cellular Corporation",
   "last_sale": "25.59",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/uzb",
   "FIELD9": ""
 },
 {
   "symbol": "UZC",
   "name": "United States Cellular Corporation",
   "last_sale": "26",
   "market_cap": "n/a",
   "IPOyear": "2015",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/uzc",
   "FIELD9": ""
 },
 {
   "symbol": "X",
   "name": "United States Steel Corporation",
   "last_sale": "29.13",
   "market_cap": "$5.16B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/x",
   "FIELD9": ""
 },
 {
   "symbol": "UTX",
   "name": "United Technologies Corporation",
   "last_sale": "142.08",
   "market_cap": "$113.68B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Aerospace",
   "summary_quote": "https://www.nasdaq.com/symbol/utx",
   "FIELD9": ""
 },
 {
   "symbol": "UNH",
   "name": "UnitedHealth Group Incorporated",
   "last_sale": "266.67",
   "market_cap": "$256.66B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/unh",
   "FIELD9": ""
 },
 {
   "symbol": "UTL",
   "name": "UNITIL Corporation",
   "last_sale": "51.26",
   "market_cap": "$762.07M",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/utl",
   "FIELD9": ""
 },
 {
   "symbol": "UNVR",
   "name": "Univar Inc.",
   "last_sale": "31",
   "market_cap": "$4.39B",
   "IPOyear": "2015",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/unvr",
   "FIELD9": ""
 },
 {
   "symbol": "UVV",
   "name": "Universal Corporation",
   "last_sale": "67.25",
   "market_cap": "$1.68B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/uvv",
   "FIELD9": ""
 },
 {
   "symbol": "UHT",
   "name": "Universal Health Realty Income Trust",
   "last_sale": "72.52",
   "market_cap": "$996.8M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/uht",
   "FIELD9": ""
 },
 {
   "symbol": "UHS",
   "name": "Universal Health Services, Inc.",
   "last_sale": "126.74",
   "market_cap": "$11.83B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Hospital/Nursing Management",
   "summary_quote": "https://www.nasdaq.com/symbol/uhs",
   "FIELD9": ""
 },
 {
   "symbol": "UVE",
   "name": "UNIVERSAL INSURANCE HOLDINGS INC",
   "last_sale": "47.7",
   "market_cap": "$1.66B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/uve",
   "FIELD9": ""
 },
 {
   "symbol": "UTI",
   "name": "Universal Technical Institute Inc",
   "last_sale": "2.65",
   "market_cap": "$66.75M",
   "IPOyear": "2003",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/uti",
   "FIELD9": ""
 },
 {
   "symbol": "UNM",
   "name": "Unum Group",
   "last_sale": "40.51",
   "market_cap": "$8.86B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Accident &Health Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/unm",
   "FIELD9": ""
 },
 {
   "symbol": "UNMA",
   "name": "Unum Group",
   "last_sale": "25.05",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Accident &Health Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/unma",
   "FIELD9": ""
 },
 {
   "symbol": "UE",
   "name": "Urban Edge Properties",
   "last_sale": "22.17",
   "market_cap": "$2.53B",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Real Estate",
   "summary_quote": "https://www.nasdaq.com/symbol/ue",
   "FIELD9": ""
 },
 {
   "symbol": "UBA",
   "name": "Urstadt Biddle Properties Inc.",
   "last_sale": "20.93",
   "market_cap": "$829.52M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/uba",
   "FIELD9": ""
 },
 {
   "symbol": "UBP",
   "name": "Urstadt Biddle Properties Inc.",
   "last_sale": "16.6",
   "market_cap": "$657.93M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ubp",
   "FIELD9": ""
 },
 {
   "symbol": "UBP^G",
   "name": "Urstadt Biddle Properties Inc.",
   "last_sale": "25.3104",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ubp^g",
   "FIELD9": ""
 },
 {
   "symbol": "UBP^H",
   "name": "Urstadt Biddle Properties Inc.",
   "last_sale": "24.72",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ubp^h",
   "FIELD9": ""
 },
 {
   "symbol": "USFD",
   "name": "US Foods Holding Corp.",
   "last_sale": "31.31",
   "market_cap": "$6.79B",
   "IPOyear": "2016",
   "sector": "Consumer Non-Durables",
   "industry": "Food Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/usfd",
   "FIELD9": ""
 },
 {
   "symbol": "USAC",
   "name": "USA Compression Partners, LP",
   "last_sale": "16.57",
   "market_cap": "$1.6B",
   "IPOyear": "2013",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/usac",
   "FIELD9": ""
 },
 {
   "symbol": "USNA",
   "name": "USANA Health Sciences, Inc.",
   "last_sale": "119.25",
   "market_cap": "$2.89B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/usna",
   "FIELD9": ""
 },
 {
   "symbol": "USDP",
   "name": "USD Partners LP",
   "last_sale": "9.8",
   "market_cap": "$256.17M",
   "IPOyear": "2014",
   "sector": "Transportation",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/usdp",
   "FIELD9": ""
 },
 {
   "symbol": "USG",
   "name": "USG Corporation",
   "last_sale": "43.35",
   "market_cap": "$6.06B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Building Materials",
   "summary_quote": "https://www.nasdaq.com/symbol/usg",
   "FIELD9": ""
 },
 {
   "symbol": "BIF",
   "name": "USLIFE Income Fund, Inc.",
   "last_sale": "11.36",
   "market_cap": "$1.2B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/bif",
   "FIELD9": ""
 },
 {
   "symbol": "VFC",
   "name": "V.F. Corporation",
   "last_sale": "92.24",
   "market_cap": "$36.57B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Apparel",
   "summary_quote": "https://www.nasdaq.com/symbol/vfc",
   "FIELD9": ""
 },
 {
   "symbol": "EGY",
   "name": "VAALCO Energy, Inc. ",
   "last_sale": "2.37",
   "market_cap": "$140.89M",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/egy",
   "FIELD9": ""
 },
 {
   "symbol": "MTN",
   "name": "Vail Resorts, Inc.",
   "last_sale": "282.24",
   "market_cap": "$11.38B",
   "IPOyear": "1997",
   "sector": "Consumer Services",
   "industry": "Services-Misc. Amusement & Recreation",
   "summary_quote": "https://www.nasdaq.com/symbol/mtn",
   "FIELD9": ""
 },
 {
  "symbol": "4502 JP",
  "name": "Takeda Pharm. (4502)",
  "last_sale": "282.24",
  "market_cap": "$11.38B",
  "IPOyear": "1997",
  "sector": "Consumer Services",
  "industry": "Services-Misc. Amusement & Recreation",
  "summary_quote": "https://www.nasdaq.com/symbol/mtn",
  "FIELD9": ""
},
 {
   "symbol": "VALE",
   "name": "VALE S.A.",
   "last_sale": "15.06",
   "market_cap": "$78.04B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/vale",
   "FIELD9": ""
 },
 {
   "symbol": "VLO",
   "name": "Valero Energy Corporation",
   "last_sale": "112.24",
   "market_cap": "$47.97B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/vlo",
   "FIELD9": ""
 },
 {
   "symbol": "VLP",
   "name": "Valero Energy Partners LP",
   "last_sale": "36.36",
   "market_cap": "$2.52B",
   "IPOyear": "2013",
   "sector": "Energy",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/vlp",
   "FIELD9": ""
 },
 {
   "symbol": "VHI",
   "name": "Valhi, Inc.",
   "last_sale": "2.85",
   "market_cap": "$966.68M",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/vhi",
   "FIELD9": ""
 },
 {
   "symbol": "VR^A",
   "name": "Validus Holdings, Ltd.",
   "last_sale": "25.23",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vr^a",
   "FIELD9": ""
 },
 {
   "symbol": "VR^B",
   "name": "Validus Holdings, Ltd.",
   "last_sale": "25.05",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vr^b",
   "FIELD9": ""
 },
 {
   "symbol": "VLY",
   "name": "Valley National Bancorp",
   "last_sale": "12.02",
   "market_cap": "$3.98B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/vly",
   "FIELD9": ""
 },
 {
   "symbol": "VLY.WS",
   "name": "Valley National Bancorp",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vly.ws",
   "FIELD9": ""
 },
 {
   "symbol": "VLY^A",
   "name": "Valley National Bancorp",
   "last_sale": "26.17",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/vly^a",
   "FIELD9": ""
 },
 {
   "symbol": "VLY^B",
   "name": "Valley National Bancorp",
   "last_sale": "25.08",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vly^b",
   "FIELD9": ""
 },
 {
   "symbol": "VMI",
   "name": "Valmont Industries, Inc.",
   "last_sale": "140.75",
   "market_cap": "$3.15B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/vmi",
   "FIELD9": ""
 },
 {
   "symbol": "VVV",
   "name": "Valvoline Inc.",
   "last_sale": "21.68",
   "market_cap": "$4.14B",
   "IPOyear": "2016",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/vvv",
   "FIELD9": ""
 },
 {
   "symbol": "VAR",
   "name": "Varian Medical Systems, Inc.",
   "last_sale": "112.48",
   "market_cap": "$10.3B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Biotechnology: Electromedical & Electrotherapeutic Apparatus",
   "summary_quote": "https://www.nasdaq.com/symbol/var",
   "FIELD9": ""
 },
 {
   "symbol": "VGR",
   "name": "Vector Group Ltd.",
   "last_sale": "14.29",
   "market_cap": "$2.01B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Farming/Seeds/Milling",
   "summary_quote": "https://www.nasdaq.com/symbol/vgr",
   "FIELD9": ""
 },
 {
   "symbol": "VVC",
   "name": "Vectren Corporation",
   "last_sale": "71.55",
   "market_cap": "$5.94B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/vvc",
   "FIELD9": ""
 },
 {
   "symbol": "VEC",
   "name": "Vectrus, Inc.",
   "last_sale": "31.52",
   "market_cap": "$354.53M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Diversified Commercial Services",
   "summary_quote": "https://www.nasdaq.com/symbol/vec",
   "FIELD9": ""
 },
 {
   "symbol": "VEDL",
   "name": "Vedanta  Limited",
   "last_sale": "12.96",
   "market_cap": "$12.04B",
   "IPOyear": "2013",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/vedl",
   "FIELD9": ""
 },
 {
   "symbol": "VEEV",
   "name": "Veeva Systems Inc.",
   "last_sale": "103.91",
   "market_cap": "$15.02B",
   "IPOyear": "2013",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/veev",
   "FIELD9": ""
 },
 {
   "symbol": "VNTR",
   "name": "Venator Materials PLC",
   "last_sale": "9.88",
   "market_cap": "$1.05B",
   "IPOyear": "2017",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/vntr",
   "FIELD9": ""
 },
 {
   "symbol": "VTRB",
   "name": "Ventas Realty, Limited Partnership // Ventas Capital Corporati",
   "last_sale": "24.6601",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/vtrb",
   "FIELD9": ""
 },
 {
   "symbol": "VTR",
   "name": "Ventas, Inc.",
   "last_sale": "56.19",
   "market_cap": "$20.03B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/vtr",
   "FIELD9": ""
 },
 {
   "symbol": "VNE",
   "name": "Veoneer, Inc.",
   "last_sale": "56.35",
   "market_cap": "$4.91B",
   "IPOyear": "2018",
   "sector": "Capital Goods",
   "industry": "Auto Parts:O.E.M.",
   "summary_quote": "https://www.nasdaq.com/symbol/vne",
   "FIELD9": ""
 },
 {
   "symbol": "VER",
   "name": "VEREIT Inc.",
   "last_sale": "7.47",
   "market_cap": "$7.23B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/ver",
   "FIELD9": ""
 },
 {
   "symbol": "VER^F",
   "name": "VEREIT Inc.",
   "last_sale": "25.04",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ver^f",
   "FIELD9": ""
 },
 {
   "symbol": "VRTV",
   "name": "Veritiv Corporation",
   "last_sale": "39.8",
   "market_cap": "$630.68M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/vrtv",
   "FIELD9": ""
 },
 {
   "symbol": "VZ",
   "name": "Verizon Communications Inc.",
   "last_sale": "54.42",
   "market_cap": "$224.86B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/vz",
   "FIELD9": ""
 },
 {
   "symbol": "VZA",
   "name": "Verizon Communications Inc.",
   "last_sale": "25.59",
   "market_cap": "n/a",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/vza",
   "FIELD9": ""
 },
 {
   "symbol": "VET",
   "name": "Vermilion Energy Inc.",
   "last_sale": "32.66",
   "market_cap": "$4.98B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/vet",
   "FIELD9": ""
 },
 {
   "symbol": "VRS",
   "name": "Verso Corporation",
   "last_sale": "28.73",
   "market_cap": "$992.72M",
   "IPOyear": "2016",
   "sector": "Basic Industries",
   "industry": "Paper",
   "summary_quote": "https://www.nasdaq.com/symbol/vrs",
   "FIELD9": ""
 },
 {
   "symbol": "VSM",
   "name": "Versum Materials, Inc.",
   "last_sale": "36.66",
   "market_cap": "$3.99B",
   "IPOyear": "2016",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/vsm",
   "FIELD9": ""
 },
 {
   "symbol": "VVI",
   "name": "Viad Corp",
   "last_sale": "59.9",
   "market_cap": "$1.22B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/vvi",
   "FIELD9": ""
 },
 {
   "symbol": "VICI",
   "name": "VICI Properties Inc.",
   "last_sale": "21.43",
   "market_cap": "$7.93B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/vici",
   "FIELD9": ""
 },
 {
   "symbol": "VNCE",
   "name": "Vince Holding Corp.",
   "last_sale": "14.51",
   "market_cap": "$168.62M",
   "IPOyear": "2013",
   "sector": "Consumer Services",
   "industry": "Clothing/Shoe/Accessory Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/vnce",
   "FIELD9": ""
 },
 {
   "symbol": "VIPS",
   "name": "Vipshop Holdings Limited",
   "last_sale": "6.55",
   "market_cap": "$4.34B",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/vips",
   "FIELD9": ""
 },
 {
   "symbol": "ZTR",
   "name": "Virtus Global Dividend & Income Fund Inc.",
   "last_sale": "11.16",
   "market_cap": "$273.35M",
   "IPOyear": "1988",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ztr",
   "FIELD9": ""
 },
 {
   "symbol": "VGI",
   "name": "Virtus Global Multi-Sector Income Fund",
   "last_sale": "13.14",
   "market_cap": "$148.54M",
   "IPOyear": "2012",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vgi",
   "FIELD9": ""
 },
 {
   "symbol": "ZF",
   "name": "Virtus Total Return Fund Inc.",
   "last_sale": "10.53",
   "market_cap": "$226.68M",
   "IPOyear": "1986",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/zf",
   "FIELD9": ""
 },
 {
   "symbol": "V",
   "name": "Visa Inc.",
   "last_sale": "150.05",
   "market_cap": "$344.02B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/v",
   "FIELD9": ""
 },
 {
   "symbol": "VSH",
   "name": "Vishay Intertechnology, Inc.",
   "last_sale": "21.5",
   "market_cap": "$3.1B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/vsh",
   "FIELD9": ""
 },
 {
   "symbol": "VPG",
   "name": "Vishay Precision Group, Inc.",
   "last_sale": "37.3",
   "market_cap": "$502.6M",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Electrical Products",
   "summary_quote": "https://www.nasdaq.com/symbol/vpg",
   "FIELD9": ""
 },
 {
   "symbol": "VSTO",
   "name": "Vista Outdoor Inc.",
   "last_sale": "17.83",
   "market_cap": "$1.03B",
   "IPOyear": "2015",
   "sector": "Capital Goods",
   "industry": "Ordnance And Accessories",
   "summary_quote": "https://www.nasdaq.com/symbol/vsto",
   "FIELD9": ""
 },
 {
   "symbol": "DYNC",
   "name": "Vistra Energy Corp.",
   "last_sale": "93.44",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/dync",
   "FIELD9": ""
 },
 {
   "symbol": "VST",
   "name": "Vistra Energy Corp.",
   "last_sale": "23.84",
   "market_cap": "$12.36B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Electric Utilities: Central",
   "summary_quote": "https://www.nasdaq.com/symbol/vst",
   "FIELD9": ""
 },
 {
   "symbol": "VST.WS.A",
   "name": "Vistra Energy Corp.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vst.ws.a",
   "FIELD9": ""
 },
 {
   "symbol": "VSI",
   "name": "Vitamin Shoppe, Inc",
   "last_sale": "11.2",
   "market_cap": "$269.39M",
   "IPOyear": "2009",
   "sector": "Consumer Non-Durables",
   "industry": "Food Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/vsi",
   "FIELD9": ""
 },
 {
   "symbol": "VSLR",
   "name": "Vivint Solar, Inc.",
   "last_sale": "5.05",
   "market_cap": "$598.93M",
   "IPOyear": "2014",
   "sector": "Capital Goods",
   "industry": "Building Products",
   "summary_quote": "https://www.nasdaq.com/symbol/vslr",
   "FIELD9": ""
 },
 {
   "symbol": "VMW",
   "name": "Vmware, Inc.",
   "last_sale": "152.09",
   "market_cap": "$62.16B",
   "IPOyear": "2007",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/vmw",
   "FIELD9": ""
 },
 {
   "symbol": "VOC",
   "name": "VOC Energy Trust",
   "last_sale": "5.29",
   "market_cap": "$89.93M",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/voc",
   "FIELD9": ""
 },
 {
   "symbol": "VCRA",
   "name": "Vocera Communications, Inc.",
   "last_sale": "35.35",
   "market_cap": "$1.07B",
   "IPOyear": "2012",
   "sector": "Consumer Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/vcra",
   "FIELD9": ""
 },
 {
   "symbol": "VG",
   "name": "Vonage Holdings Corp.",
   "last_sale": "13.59",
   "market_cap": "$3.25B",
   "IPOyear": "2006",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/vg",
   "FIELD9": ""
 },
 {
   "symbol": "VNO",
   "name": "Vornado Realty Trust",
   "last_sale": "75.05",
   "market_cap": "$14.28B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/vno",
   "FIELD9": ""
 },
 {
   "symbol": "VNO^K",
   "name": "Vornado Realty Trust",
   "last_sale": "24.67",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vno^k",
   "FIELD9": ""
 },
 {
   "symbol": "VNO^L",
   "name": "Vornado Realty Trust",
   "last_sale": "24.06",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vno^l",
   "FIELD9": ""
 },
 {
   "symbol": "VNO^M",
   "name": "Vornado Realty Trust",
   "last_sale": "22.65",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/vno^m",
   "FIELD9": ""
 },
 {
   "symbol": "VJET",
   "name": "voxeljet AG",
   "last_sale": "4.02",
   "market_cap": "$74.77M",
   "IPOyear": "2013",
   "sector": "Capital Goods",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/vjet",
   "FIELD9": ""
 },
 {
   "symbol": "IAE",
   "name": "Voya Asia Pacific High Dividend Equity Income Fund",
   "last_sale": "9.58",
   "market_cap": "$113.99M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iae",
   "FIELD9": ""
 },
 {
   "symbol": "IHD",
   "name": "Voya Emerging Markets High Income Dividend Equity Fund",
   "last_sale": "7.99",
   "market_cap": "$152.03M",
   "IPOyear": "2011",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ihd",
   "FIELD9": ""
 },
 {
   "symbol": "VOYA",
   "name": "Voya Financial, Inc.",
   "last_sale": "50.5",
   "market_cap": "$8.11B",
   "IPOyear": "2013",
   "sector": "Finance",
   "industry": "Life Insurance",
   "summary_quote": "https://www.nasdaq.com/symbol/voya",
   "FIELD9": ""
 },
 {
   "symbol": "IGA",
   "name": "Voya Global Advantage and Premium Opportunity Fund",
   "last_sale": "11.57",
   "market_cap": "$211.79M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iga",
   "FIELD9": ""
 },
 {
   "symbol": "IGD",
   "name": "Voya Global Equity Dividend and Premium Opportunity Fund",
   "last_sale": "7.41",
   "market_cap": "$719.34M",
   "IPOyear": "2005",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/igd",
   "FIELD9": ""
 },
 {
   "symbol": "IDE",
   "name": "Voya Infrastructure, Industrials and Materials Fund",
   "last_sale": "15.71",
   "market_cap": "$302.87M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ide",
   "FIELD9": ""
 },
 {
   "symbol": "IID",
   "name": "Voya International High Dividend Equity Income Fund",
   "last_sale": "6.46",
   "market_cap": "$54.4M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/iid",
   "FIELD9": ""
 },
 {
   "symbol": "IRR",
   "name": "Voya Natural Resources Equity Income Fund",
   "last_sale": "6.5",
   "market_cap": "$147.18M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/irr",
   "FIELD9": ""
 },
 {
   "symbol": "PPR",
   "name": "Voya Prime Rate Trust",
   "last_sale": "4.98",
   "market_cap": "$735.98M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ppr",
   "FIELD9": ""
 },
 {
   "symbol": "VMC",
   "name": "Vulcan Materials Company",
   "last_sale": "115.55",
   "market_cap": "$15.28B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Mining & Quarrying of Nonmetallic Minerals (No Fuels)",
   "summary_quote": "https://www.nasdaq.com/symbol/vmc",
   "FIELD9": ""
 },
 {
   "symbol": "WTI",
   "name": "W&T Offshore, Inc.",
   "last_sale": "7.72",
   "market_cap": "$1.07B",
   "IPOyear": "2005",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/wti",
   "FIELD9": ""
 },
 {
   "symbol": "WPC",
   "name": "W.P. Carey Inc.",
   "last_sale": "65.77",
   "market_cap": "$7.05B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/wpc",
   "FIELD9": ""
 },
 {
   "symbol": "WRB",
   "name": "W.R. Berkley Corporation",
   "last_sale": "78.81",
   "market_cap": "$9.6B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/wrb",
   "FIELD9": ""
 },
 {
   "symbol": "WRB^B",
   "name": "W.R. Berkley Corporation",
   "last_sale": "24.6",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wrb^b",
   "FIELD9": ""
 },
 {
   "symbol": "WRB^C",
   "name": "W.R. Berkley Corporation",
   "last_sale": "25.43",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wrb^c",
   "FIELD9": ""
 },
 {
   "symbol": "WRB^D",
   "name": "W.R. Berkley Corporation",
   "last_sale": "24.58",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wrb^d",
   "FIELD9": ""
 },
 {
   "symbol": "WRB^E",
   "name": "W.R. Berkley Corporation",
   "last_sale": "24.5",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wrb^e",
   "FIELD9": ""
 },
 {
   "symbol": "GRA",
   "name": "W.R. Grace & Co.",
   "last_sale": "73.96",
   "market_cap": "$4.97B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/gra",
   "FIELD9": ""
 },
 {
   "symbol": "GWW",
   "name": "W.W. Grainger, Inc.",
   "last_sale": "356.09",
   "market_cap": "$19.99B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Office Equipment/Supplies/Services",
   "summary_quote": "https://www.nasdaq.com/symbol/gww",
   "FIELD9": ""
 },
 {
   "symbol": "WNC",
   "name": "Wabash National Corporation",
   "last_sale": "19.4",
   "market_cap": "$1.11B",
   "IPOyear": "1991",
   "sector": "Capital Goods",
   "industry": "Construction/Ag Equipment/Trucks",
   "summary_quote": "https://www.nasdaq.com/symbol/wnc",
   "FIELD9": ""
 },
 {
   "symbol": "WBC",
   "name": "Wabco Holdings Inc.",
   "last_sale": "120.35",
   "market_cap": "$6.37B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Auto Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/wbc",
   "FIELD9": ""
 },
 {
   "symbol": "WDR",
   "name": "Waddell & Reed Financial, Inc.",
   "last_sale": "21.18",
   "market_cap": "$1.69B",
   "IPOyear": "1998",
   "sector": "Finance",
   "industry": "Investment Bankers/Brokers/Service",
   "summary_quote": "https://www.nasdaq.com/symbol/wdr",
   "FIELD9": ""
 },
 {
   "symbol": "WAGE",
   "name": "WageWorks, Inc.",
   "last_sale": "40.15",
   "market_cap": "$1.59B",
   "IPOyear": "2012",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wage",
   "FIELD9": ""
 },
 {
   "symbol": "WD",
   "name": "Walker & Dunlop, Inc.",
   "last_sale": "54.13",
   "market_cap": "$1.69B",
   "IPOyear": "2010",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wd",
   "FIELD9": ""
 },
 {
   "symbol": "WMT",
   "name": "Walmart Inc.",
   "last_sale": "95.9",
   "market_cap": "$280.87B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Department/Specialty Retail Stores",
   "summary_quote": "https://www.nasdaq.com/symbol/wmt",
   "FIELD9": ""
 },
 {
   "symbol": "DIS",
   "name": "Walt Disney Company (The)",
   "last_sale": "110.4",
   "market_cap": "$164.19B",
   "IPOyear": "n/a",
   "sector": "Communication Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/dis",
   "FIELD9": ""
 },
 {
   "symbol": "HCC",
   "name": "Warrior Met Coal, Inc.",
   "last_sale": "25.97",
   "market_cap": "$1.37B",
   "IPOyear": "2017",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/hcc",
   "FIELD9": ""
 },
 {
   "symbol": "WPG",
   "name": "Washington Prime Group Inc.",
   "last_sale": "7.4",
   "market_cap": "$1.38B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/wpg",
   "FIELD9": ""
 },
 {
   "symbol": "WPG^H",
   "name": "Washington Prime Group Inc.",
   "last_sale": "23.23",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wpg^h",
   "FIELD9": ""
 },
 {
   "symbol": "WPG^I",
   "name": "Washington Prime Group Inc.",
   "last_sale": "21.15",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wpg^i",
   "FIELD9": ""
 },
 {
   "symbol": "WRE",
   "name": "Washington Real Estate Investment Trust",
   "last_sale": "30.92",
   "market_cap": "$2.43B",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wre",
   "FIELD9": ""
 },
 {
   "symbol": "WCN",
   "name": "Waste Connections, Inc.",
   "last_sale": "80.32",
   "market_cap": "$21.16B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wcn",
   "FIELD9": ""
 },
 {
   "symbol": "WM",
   "name": "Waste Management, Inc.",
   "last_sale": "91.42",
   "market_cap": "$39.19B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Environmental Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wm",
   "FIELD9": ""
 },
 {
   "symbol": "WAT",
   "name": "Waters Corporation",
   "last_sale": "196.76",
   "market_cap": "$15.16B",
   "IPOyear": "1995",
   "sector": "Capital Goods",
   "industry": "Biotechnology: Laboratory Analytical Instruments",
   "summary_quote": "https://www.nasdaq.com/symbol/wat",
   "FIELD9": ""
 },
 {
   "symbol": "WSO",
   "name": "Watsco, Inc.",
   "last_sale": "175.94",
   "market_cap": "$6.57B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/wso",
   "FIELD9": ""
 },
 {
   "symbol": "WSO.B",
   "name": "Watsco, Inc.",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wso.b",
   "FIELD9": ""
 },
 {
   "symbol": "WTS",
   "name": "Watts Water Technologies, Inc.",
   "last_sale": "81.45",
   "market_cap": "$2.78B",
   "IPOyear": "1986",
   "sector": "Capital Goods",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/wts",
   "FIELD9": ""
 },
 {
   "symbol": "W",
   "name": "Wayfair Inc.",
   "last_sale": "133.98",
   "market_cap": "$12.01B",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Catalog/Specialty Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/w",
   "FIELD9": ""
 },
 {
   "symbol": "WFT",
   "name": "Weatherford International plc",
   "last_sale": "2.63",
   "market_cap": "$2.62B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Metal Fabrications",
   "summary_quote": "https://www.nasdaq.com/symbol/wft",
   "FIELD9": ""
 },
 {
   "symbol": "WBS",
   "name": "Webster Financial Corporation",
   "last_sale": "61.62",
   "market_cap": "$5.68B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wbs",
   "FIELD9": ""
 },
 {
   "symbol": "WBS^F",
   "name": "Webster Financial Corporation",
   "last_sale": "23.2",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wbs^f",
   "FIELD9": ""
 },
 {
   "symbol": "WEC",
   "name": "WEC Energy Group, Inc.",
   "last_sale": "67.24",
   "market_cap": "$21.22B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Power Generation",
   "summary_quote": "https://www.nasdaq.com/symbol/wec",
   "FIELD9": ""
 },
 {
   "symbol": "WTW",
   "name": "Weight Watchers International Inc",
   "last_sale": "69.76",
   "market_cap": "$4.65B",
   "IPOyear": "2001",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wtw",
   "FIELD9": ""
 },
 {
   "symbol": "WRI",
   "name": "Weingarten Realty Investors",
   "last_sale": "29.84",
   "market_cap": "$3.82B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/wri",
   "FIELD9": ""
 },
 {
   "symbol": "WMK",
   "name": "Weis Markets, Inc.",
   "last_sale": "45.08",
   "market_cap": "$1.21B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Food Chains",
   "summary_quote": "https://www.nasdaq.com/symbol/wmk",
   "FIELD9": ""
 },
 {
   "symbol": "WBT",
   "name": "Welbilt, Inc.",
   "last_sale": "22.02",
   "market_cap": "$3.09B",
   "IPOyear": "2016",
   "sector": "Technology",
   "industry": "Industrial Machinery/Components",
   "summary_quote": "https://www.nasdaq.com/symbol/wbt",
   "FIELD9": ""
 },
 {
   "symbol": "WCG",
   "name": "WellCare Health Plans, Inc.",
   "last_sale": "304.3",
   "market_cap": "$15.21B",
   "IPOyear": "2004",
   "sector": "Health Care",
   "industry": "Medical Specialities",
   "summary_quote": "https://www.nasdaq.com/symbol/wcg",
   "FIELD9": ""
 },
 {
   "symbol": "WFC",
   "name": "Wells Fargo & Company",
   "last_sale": "54.99",
   "market_cap": "$264.84B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc",
   "FIELD9": ""
 },
 {
   "symbol": "WFC.WS",
   "name": "Wells Fargo & Company",
   "last_sale": "n/a",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc.ws",
   "FIELD9": ""
 },
 {
   "symbol": "WFC^L",
   "name": "Wells Fargo & Company",
   "last_sale": "1274.98",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc^l",
   "FIELD9": ""
 },
 {
   "symbol": "WFC^N",
   "name": "Wells Fargo & Company",
   "last_sale": "24.41",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc^n",
   "FIELD9": ""
 },
 {
   "symbol": "WFC^O",
   "name": "Wells Fargo & Company",
   "last_sale": "24.32",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc^o",
   "FIELD9": ""
 },
 {
   "symbol": "WFC^P",
   "name": "Wells Fargo & Company",
   "last_sale": "24.59",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc^p",
   "FIELD9": ""
 },
 {
   "symbol": "WFC^Q",
   "name": "Wells Fargo & Company",
   "last_sale": "25.6",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc^q",
   "FIELD9": ""
 },
 {
   "symbol": "WFC^R",
   "name": "Wells Fargo & Company",
   "last_sale": "27.46",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc^r",
   "FIELD9": ""
 },
 {
   "symbol": "WFC^T",
   "name": "Wells Fargo & Company",
   "last_sale": "25.61",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc^t",
   "FIELD9": ""
 },
 {
   "symbol": "WFC^V",
   "name": "Wells Fargo & Company",
   "last_sale": "25.71",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc^v",
   "FIELD9": ""
 },
 {
   "symbol": "WFC^W",
   "name": "Wells Fargo & Company",
   "last_sale": "25.1",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc^w",
   "FIELD9": ""
 },
 {
   "symbol": "WFC^X",
   "name": "Wells Fargo & Company",
   "last_sale": "24.88",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc^x",
   "FIELD9": ""
 },
 {
   "symbol": "WFC^Y",
   "name": "Wells Fargo & Company",
   "last_sale": "24.94",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfc^y",
   "FIELD9": ""
 },
 {
   "symbol": "WFE^A",
   "name": "Wells Fargo & Company",
   "last_sale": "25.85",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wfe^a",
   "FIELD9": ""
 },
 {
   "symbol": "EOD",
   "name": "Wells Fargo Global Dividend Opportunity Fund",
   "last_sale": "5.4",
   "market_cap": "$245.34M",
   "IPOyear": "2007",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/eod",
   "FIELD9": ""
 },
 {
   "symbol": "WELL",
   "name": "Welltower Inc.",
   "last_sale": "65.5",
   "market_cap": "$24.37B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/well",
   "FIELD9": ""
 },
 {
   "symbol": "WELL^I",
   "name": "Welltower Inc.",
   "last_sale": "61.6",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/well^i",
   "FIELD9": ""
 },
 {
   "symbol": "WAIR",
   "name": "Wesco Aircraft Holdings, Inc.",
   "last_sale": "11.35",
   "market_cap": "$1.13B",
   "IPOyear": "2011",
   "sector": "Capital Goods",
   "industry": "Wholesale Distributors",
   "summary_quote": "https://www.nasdaq.com/symbol/wair",
   "FIELD9": ""
 },
 {
   "symbol": "WCC",
   "name": "WESCO International, Inc.",
   "last_sale": "62.2",
   "market_cap": "$2.93B",
   "IPOyear": "1999",
   "sector": "Consumer Non-Durables",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/wcc",
   "FIELD9": ""
 },
 {
   "symbol": "WST",
   "name": "West Pharmaceutical Services, Inc.",
   "last_sale": "121.59",
   "market_cap": "$8.94B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Specialty Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/wst",
   "FIELD9": ""
 },
 {
   "symbol": "WAL",
   "name": "Western Alliance Bancorporation",
   "last_sale": "59.37",
   "market_cap": "$6.29B",
   "IPOyear": "2005",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wal",
   "FIELD9": ""
 },
 {
   "symbol": "WALA",
   "name": "Western Alliance Bancorporation",
   "last_sale": "25.276",
   "market_cap": "n/a",
   "IPOyear": "2016",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wala",
   "FIELD9": ""
 },
 {
   "symbol": "WEA",
   "name": "Western Asset Bond Fund",
   "last_sale": "12.57",
   "market_cap": "$149.64M",
   "IPOyear": "2002",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wea",
   "FIELD9": ""
 },
 {
   "symbol": "TLI",
   "name": "Western Asset Corporate Loan Fund Inc",
   "last_sale": "10",
   "market_cap": "$99.39M",
   "IPOyear": "1998",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/tli",
   "FIELD9": ""
 },
 {
   "symbol": "EMD",
   "name": "Western Asset Emerging Markets Debt Fund Inc",
   "last_sale": "13.51",
   "market_cap": "$820.68M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/emd",
   "FIELD9": ""
 },
 {
   "symbol": "GDO",
   "name": "Western Asset Global Corporate Defined Opportunity Fund Inc.",
   "last_sale": "16.17",
   "market_cap": "$241.59M",
   "IPOyear": "2009",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gdo",
   "FIELD9": ""
 },
 {
   "symbol": "EHI",
   "name": "Western Asset Global High Income Fund Inc",
   "last_sale": "9.1",
   "market_cap": "$408.8M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/ehi",
   "FIELD9": ""
 },
 {
   "symbol": "HIX",
   "name": "Western Asset High Income Fund II Inc.",
   "last_sale": "6.34",
   "market_cap": "$546.53M",
   "IPOyear": "1998",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hix",
   "FIELD9": ""
 },
 {
   "symbol": "HIO",
   "name": "Western Asset High Income Opportunity Fund, Inc.",
   "last_sale": "4.78",
   "market_cap": "$617.73M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hio",
   "FIELD9": ""
 },
 {
   "symbol": "HYI",
   "name": "Western Asset High Yield Defined Opportunity Fund Inc.",
   "last_sale": "14.42",
   "market_cap": "$328.54M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/hyi",
   "FIELD9": ""
 },
 {
   "symbol": "SBI",
   "name": "Western Asset Intermediate Muni Fund Inc",
   "last_sale": "8.37",
   "market_cap": "$117.87M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/sbi",
   "FIELD9": ""
 },
 {
   "symbol": "IGI",
   "name": "Western Asset Investment Grade Defined Opportunity Trust Inc.",
   "last_sale": "20.28",
   "market_cap": "$219.49M",
   "IPOyear": "2009",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/igi",
   "FIELD9": ""
 },
 {
   "symbol": "PAI",
   "name": "Western Asset Investment Grade Income Fund Inc.",
   "last_sale": "13.57",
   "market_cap": "$128.68M",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/pai",
   "FIELD9": ""
 },
 {
   "symbol": "MMU",
   "name": "Western Asset Managed Municipals Fund, Inc.",
   "last_sale": "12.15",
   "market_cap": "$525.96M",
   "IPOyear": "1992",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mmu",
   "FIELD9": ""
 },
 {
   "symbol": "WMC",
   "name": "Western Asset Mortgage Capital Corporation",
   "last_sale": "10.73",
   "market_cap": "$446.54M",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/wmc",
   "FIELD9": ""
 },
 {
   "symbol": "DMO",
   "name": "Western Asset Mortgage Defined Opportunity Fund Inc",
   "last_sale": "22.59",
   "market_cap": "$236.07M",
   "IPOyear": "2010",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/dmo",
   "FIELD9": ""
 },
 {
   "symbol": "MTT",
   "name": "Western Asset Municipal Defined Opportunity Trust Inc",
   "last_sale": "20.75",
   "market_cap": "$252.54M",
   "IPOyear": "2009",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mtt",
   "FIELD9": ""
 },
 {
   "symbol": "MHF",
   "name": "Western Asset Municipal High Income Fund, Inc.",
   "last_sale": "7.1",
   "market_cap": "$153.59M",
   "IPOyear": "1988",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mhf",
   "FIELD9": ""
 },
 {
   "symbol": "MNP",
   "name": "Western Asset Municipal Partners Fund, Inc.",
   "last_sale": "13.75",
   "market_cap": "$133.64M",
   "IPOyear": "1993",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/mnp",
   "FIELD9": ""
 },
 {
   "symbol": "GFY",
   "name": "Western Asset Variable Rate Strategic Fund Inc.",
   "last_sale": "16.3268",
   "market_cap": "$76.22M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/gfy",
   "FIELD9": ""
 },
 {
   "symbol": "WIW",
   "name": "Western Asset/Claymore U.S Treasury Inflation Prot Secs Fd 2",
   "last_sale": "10.84",
   "market_cap": "$663.24M",
   "IPOyear": "2004",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wiw",
   "FIELD9": ""
 },
 {
   "symbol": "WIA",
   "name": "Western Asset/Claymore U.S. Treasury Inflation Prot Secs Fd",
   "last_sale": "11.28",
   "market_cap": "$328.84M",
   "IPOyear": "2003",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/wia",
   "FIELD9": ""
 },
 {
   "symbol": "WGP",
   "name": "Western Gas Equity Partners, LP",
   "last_sale": "32.22",
   "market_cap": "$7.05B",
   "IPOyear": "2012",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/wgp",
   "FIELD9": ""
 },
 {
   "symbol": "WES",
   "name": "Western Gas Partners, LP",
   "last_sale": "45.84",
   "market_cap": "$7.63B",
   "IPOyear": "2008",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/wes",
   "FIELD9": ""
 },
 {
   "symbol": "WU",
   "name": "Western Union Company (The)",
   "last_sale": "19.03",
   "market_cap": "$8.51B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wu",
   "FIELD9": ""
 },
 {
   "symbol": "WAB",
   "name": "Westinghouse Air Brake Technologies Corporation",
   "last_sale": "104.93",
   "market_cap": "$10.11B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Railroads",
   "summary_quote": "https://www.nasdaq.com/symbol/wab",
   "FIELD9": ""
 },
 {
   "symbol": "WLK",
   "name": "Westlake Chemical Corporation",
   "last_sale": "85.95",
   "market_cap": "$11.14B",
   "IPOyear": "2004",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/wlk",
   "FIELD9": ""
 },
 {
   "symbol": "WLKP",
   "name": "Westlake Chemical Partners LP",
   "last_sale": "25.15",
   "market_cap": "$810.77M",
   "IPOyear": "2014",
   "sector": "Basic Industries",
   "industry": "Major Chemicals",
   "summary_quote": "https://www.nasdaq.com/symbol/wlkp",
   "FIELD9": ""
 },
 {
   "symbol": "WMLP",
   "name": "Westmoreland Resource Partners, LP",
   "last_sale": "1.98",
   "market_cap": "$2.54M",
   "IPOyear": "2015",
   "sector": "Energy",
   "industry": "Coal Mining",
   "summary_quote": "https://www.nasdaq.com/symbol/wmlp",
   "FIELD9": ""
 },
 {
   "symbol": "WBK",
   "name": "Westpac Banking Corporation",
   "last_sale": "20.47",
   "market_cap": "$69.31B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wbk",
   "FIELD9": ""
 },
 {
   "symbol": "WRK",
   "name": "Westrock Company",
   "last_sale": "56.33",
   "market_cap": "$14.37B",
   "IPOyear": "2015",
   "sector": "Consumer Durables",
   "industry": "Containers/Packaging",
   "summary_quote": "https://www.nasdaq.com/symbol/wrk",
   "FIELD9": ""
 },
 {
   "symbol": "WHG",
   "name": "Westwood Holdings Group Inc",
   "last_sale": "51.66",
   "market_cap": "$466.32M",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Investment Managers",
   "summary_quote": "https://www.nasdaq.com/symbol/whg",
   "FIELD9": ""
 },
 {
   "symbol": "WEX",
   "name": "WEX Inc.",
   "last_sale": "194.37",
   "market_cap": "$8.38B",
   "IPOyear": "n/a",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wex",
   "FIELD9": ""
 },
 {
   "symbol": "WY",
   "name": "Weyerhaeuser Company",
   "last_sale": "33.01",
   "market_cap": "$25.01B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/wy",
   "FIELD9": ""
 },
 {
   "symbol": "WPM",
   "name": "Wheaton Precious Metals Corp.",
   "last_sale": "16.92",
   "market_cap": "$7.51B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/wpm",
   "FIELD9": ""
 },
 {
   "symbol": "WHR",
   "name": "Whirlpool Corporation",
   "last_sale": "123.75",
   "market_cap": "$7.99B",
   "IPOyear": "n/a",
   "sector": "Consumer Durables",
   "industry": "Consumer Electronics/Appliances",
   "summary_quote": "https://www.nasdaq.com/symbol/whr",
   "FIELD9": ""
 },
 {
   "symbol": "WTM",
   "name": "White Mountains Insurance Group, Ltd.",
   "last_sale": "948.09",
   "market_cap": "$3.02B",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Property-Casualty Insurers",
   "summary_quote": "https://www.nasdaq.com/symbol/wtm",
   "FIELD9": ""
 },
 {
   "symbol": "WSR",
   "name": "Whitestone REIT",
   "last_sale": "13.67",
   "market_cap": "$543.3M",
   "IPOyear": "2010",
   "sector": "Consumer Services",
   "industry": "Real Estate Investment Trusts",
   "summary_quote": "https://www.nasdaq.com/symbol/wsr",
   "FIELD9": ""
 },
 {
   "symbol": "WLL",
   "name": "Whiting Petroleum Corporation",
   "last_sale": "48.44",
   "market_cap": "$4.41B",
   "IPOyear": "2003",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/wll",
   "FIELD9": ""
 },
 {
   "symbol": "WOW",
   "name": "WideOpenWest, Inc.",
   "last_sale": "11.47",
   "market_cap": "$948.06M",
   "IPOyear": "2017",
   "sector": "Consumer Services",
   "industry": "Television Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wow",
   "FIELD9": ""
 },
 {
   "symbol": "WRD",
   "name": "WildHorse Resource Development Corporation",
   "last_sale": "21.7",
   "market_cap": "$2.21B",
   "IPOyear": "2016",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/wrd",
   "FIELD9": ""
 },
 {
   "symbol": "WMB",
   "name": "Williams Companies, Inc. (The)",
   "last_sale": "27.88",
   "market_cap": "$33.72B",
   "IPOyear": "n/a",
   "sector": "Public Utilities",
   "industry": "Natural Gas Distribution",
   "summary_quote": "https://www.nasdaq.com/symbol/wmb",
   "FIELD9": ""
 },
 {
   "symbol": "WSM",
   "name": "Williams-Sonoma, Inc.",
   "last_sale": "66.02",
   "market_cap": "$5.32B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Home Furnishings",
   "summary_quote": "https://www.nasdaq.com/symbol/wsm",
   "FIELD9": ""
 },
 {
   "symbol": "WGO",
   "name": "Winnebago Industries, Inc.",
   "last_sale": "36.45",
   "market_cap": "$1.15B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/wgo",
   "FIELD9": ""
 },
 {
   "symbol": "WIT",
   "name": "Wipro Limited",
   "last_sale": "5.33",
   "market_cap": "$23.99B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wit",
   "FIELD9": ""
 },
 {
   "symbol": "WNS",
   "name": "WNS (Holdings) Limited",
   "last_sale": "50.58",
   "market_cap": "$2.55B",
   "IPOyear": "2006",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wns",
   "FIELD9": ""
 },
 {
   "symbol": "WWW",
   "name": "Wolverine World Wide, Inc.",
   "last_sale": "38.92",
   "market_cap": "$3.7B",
   "IPOyear": "n/a",
   "sector": "Consumer Non-Durables",
   "industry": "Shoe Manufacturing",
   "summary_quote": "https://www.nasdaq.com/symbol/www",
   "FIELD9": ""
 },
 {
   "symbol": "WF",
   "name": "Woori Bank",
   "last_sale": "44.61",
   "market_cap": "$10.01B",
   "IPOyear": "2014",
   "sector": "Finance",
   "industry": "Commercial Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/wf",
   "FIELD9": ""
 },
 {
   "symbol": "WK",
   "name": "Workiva Inc.",
   "last_sale": "36.6",
   "market_cap": "$1.59B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/wk",
   "FIELD9": ""
 },
 {
   "symbol": "INT",
   "name": "World Fuel Services Corporation",
   "last_sale": "28.43",
   "market_cap": "$1.93B",
   "IPOyear": "n/a",
   "sector": "Energy",
   "industry": "Oil Refining/Marketing",
   "summary_quote": "https://www.nasdaq.com/symbol/int",
   "FIELD9": ""
 },
 {
   "symbol": "WWE",
   "name": "World Wrestling Entertainment, Inc.",
   "last_sale": "90.1",
   "market_cap": "$7.03B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Movies/Entertainment",
   "summary_quote": "https://www.nasdaq.com/symbol/wwe",
   "FIELD9": ""
 },
 {
   "symbol": "WP",
   "name": "Worldpay, Inc.",
   "last_sale": "98.4",
   "market_cap": "$30.7B",
   "IPOyear": "2012",
   "sector": "Miscellaneous",
   "industry": "Business Services",
   "summary_quote": "https://www.nasdaq.com/symbol/wp",
   "FIELD9": ""
 },
 {
   "symbol": "WOR",
   "name": "Worthington Industries, Inc.",
   "last_sale": "46.05",
   "market_cap": "$2.74B",
   "IPOyear": "n/a",
   "sector": "Capital Goods",
   "industry": "Steel/Iron Ore",
   "summary_quote": "https://www.nasdaq.com/symbol/wor",
   "FIELD9": ""
 },
 {
   "symbol": "WPP",
   "name": "WPP plc",
   "last_sale": "75.11",
   "market_cap": "$18.95B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Advertising",
   "summary_quote": "https://www.nasdaq.com/symbol/wpp",
   "FIELD9": ""
 },
 {
   "symbol": "WPX",
   "name": "WPX Energy, Inc.",
   "last_sale": "18.44",
   "market_cap": "$7.75B",
   "IPOyear": "2011",
   "sector": "Energy",
   "industry": "Oil & Gas Production",
   "summary_quote": "https://www.nasdaq.com/symbol/wpx",
   "FIELD9": ""
 },
 {
   "symbol": "WYND",
   "name": "Wyndham Destinations, Inc.",
   "last_sale": "43.95",
   "market_cap": "$4.37B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/wynd",
   "FIELD9": ""
 },
 {
   "symbol": "WH",
   "name": "Wyndham Hotels & Resorts, Inc.",
   "last_sale": "55.13",
   "market_cap": "$5.51B",
   "IPOyear": "2018",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/wh",
   "FIELD9": ""
 },
 {
   "symbol": "XYF",
   "name": "X Financial",
   "last_sale": "9.5",
   "market_cap": "n/a",
   "IPOyear": "2018",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/xyf",
   "FIELD9": ""
 },
 {
   "symbol": "XFLT",
   "name": "XAI Octagon Floating Rate & Alternative Income Term Trust",
   "last_sale": "9.7691",
   "market_cap": "$81.55M",
   "IPOyear": "2017",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/xflt",
   "FIELD9": ""
 },
 {
   "symbol": "XHR",
   "name": "Xenia Hotels & Resorts, Inc.",
   "last_sale": "23.73",
   "market_cap": "$2.66B",
   "IPOyear": "2015",
   "sector": "Consumer Services",
   "industry": "Hotels/Resorts",
   "summary_quote": "https://www.nasdaq.com/symbol/xhr",
   "FIELD9": ""
 },
 {
   "symbol": "XRM",
   "name": "Xerium Technologies, Inc.",
   "last_sale": "13.39",
   "market_cap": "$219.97M",
   "IPOyear": "2005",
   "sector": "Basic Industries",
   "industry": "Textiles",
   "summary_quote": "https://www.nasdaq.com/symbol/xrm",
   "FIELD9": ""
 },
 {
   "symbol": "XRX",
   "name": "Xerox Corporation",
   "last_sale": "28",
   "market_cap": "$7.14B",
   "IPOyear": "n/a",
   "sector": "Technology",
   "industry": "Computer peripheral equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/xrx",
   "FIELD9": ""
 },
 {
   "symbol": "XIN",
   "name": "Xinyuan Real Estate Co Ltd",
   "last_sale": "4.78",
   "market_cap": "$309.69M",
   "IPOyear": "2007",
   "sector": "Basic Industries",
   "industry": "Homebuilding",
   "summary_quote": "https://www.nasdaq.com/symbol/xin",
   "FIELD9": ""
 },
 {
   "symbol": "XOXO",
   "name": "XO Group, Inc.",
   "last_sale": "27.87",
   "market_cap": "$721.99M",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/xoxo",
   "FIELD9": ""
 },
 {
   "symbol": "XPO",
   "name": "XPO Logistics, Inc.",
   "last_sale": "112.85",
   "market_cap": "$14.32B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Transportation Services",
   "summary_quote": "https://www.nasdaq.com/symbol/xpo",
   "FIELD9": ""
 },
 {
   "symbol": "XYL",
   "name": "Xylem Inc.",
   "last_sale": "81.22",
   "market_cap": "$14.59B",
   "IPOyear": "2011",
   "sector": "Capital Goods",
   "industry": "Fluid Controls",
   "summary_quote": "https://www.nasdaq.com/symbol/xyl",
   "FIELD9": ""
 },
 {
   "symbol": "AUY",
   "name": "Yamana Gold Inc.",
   "last_sale": "2.49",
   "market_cap": "$2.36B",
   "IPOyear": "n/a",
   "sector": "Basic Industries",
   "industry": "Precious Metals",
   "summary_quote": "https://www.nasdaq.com/symbol/auy",
   "FIELD9": ""
 },
 {
   "symbol": "YELP",
   "name": "Yelp Inc.",
   "last_sale": "49.92",
   "market_cap": "$4.18B",
   "IPOyear": "2012",
   "sector": "Consumer Services",
   "industry": "Other Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/yelp",
   "FIELD9": ""
 },
 {
   "symbol": "YEXT",
   "name": "Yext, Inc.",
   "last_sale": "24.77",
   "market_cap": "$2.44B",
   "IPOyear": "2017",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/yext",
   "FIELD9": ""
 },
 {
   "symbol": "YRD",
   "name": "Yirendai Ltd.",
   "last_sale": "19.78",
   "market_cap": "$2.4B",
   "IPOyear": "2015",
   "sector": "Finance",
   "industry": "Finance: Consumer Services",
   "summary_quote": "https://www.nasdaq.com/symbol/yrd",
   "FIELD9": ""
 },
 {
   "symbol": "YPF",
   "name": "YPF Sociedad Anonima",
   "last_sale": "17.04",
   "market_cap": "$6.7B",
   "IPOyear": "1993",
   "sector": "Energy",
   "industry": "Integrated oil Companies",
   "summary_quote": "https://www.nasdaq.com/symbol/ypf",
   "FIELD9": ""
 },
 {
   "symbol": "YUMC",
   "name": "Yum China Holdings, Inc.",
   "last_sale": "35.26",
   "market_cap": "$13.51B",
   "IPOyear": "2016",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/yumc",
   "FIELD9": ""
 },
 {
   "symbol": "YUM",
   "name": "Yum! Brands, Inc.",
   "last_sale": "89.53",
   "market_cap": "$28.41B",
   "IPOyear": "n/a",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/yum",
   "FIELD9": ""
 },
 {
   "symbol": "ZAYO",
   "name": "Zayo Group Holdings, Inc.",
   "last_sale": "35.13",
   "market_cap": "$8.66B",
   "IPOyear": "2014",
   "sector": "Public Utilities",
   "industry": "Telecommunications Equipment",
   "summary_quote": "https://www.nasdaq.com/symbol/zayo",
   "FIELD9": ""
 },
 {
   "symbol": "ZEN",
   "name": "Zendesk, Inc.",
   "last_sale": "67.31",
   "market_cap": "$7.13B",
   "IPOyear": "2014",
   "sector": "Technology",
   "industry": "EDP Services",
   "summary_quote": "https://www.nasdaq.com/symbol/zen",
   "FIELD9": ""
 },
 {
   "symbol": "ZBH",
   "name": "Zimmer Biomet Holdings, Inc.",
   "last_sale": "131.43",
   "market_cap": "$26.74B",
   "IPOyear": "n/a",
   "sector": "Health Care",
   "industry": "Industrial Specialties",
   "summary_quote": "https://www.nasdaq.com/symbol/zbh",
   "FIELD9": ""
 },
 {
   "symbol": "ZB^A",
   "name": "Zions Bancorporation",
   "last_sale": "24.3514",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/zb^a",
   "FIELD9": ""
 },
 {
   "symbol": "ZB^G",
   "name": "Zions Bancorporation",
   "last_sale": "26.39",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/zb^g",
   "FIELD9": ""
 },
 {
   "symbol": "ZB^H",
   "name": "Zions Bancorporation",
   "last_sale": "25.18",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "n/a",
   "industry": "n/a",
   "summary_quote": "https://www.nasdaq.com/symbol/zb^h",
   "FIELD9": ""
 },
 {
   "symbol": "ZBK",
   "name": "Zions Bancorporation",
   "last_sale": "29.7051",
   "market_cap": "n/a",
   "IPOyear": "n/a",
   "sector": "Finance",
   "industry": "Major Banks",
   "summary_quote": "https://www.nasdaq.com/symbol/zbk",
   "FIELD9": ""
 },
 {
   "symbol": "ZOES",
   "name": "Zoe&#39;s Kitchen, Inc.",
   "last_sale": "12.73",
   "market_cap": "$249.56M",
   "IPOyear": "2014",
   "sector": "Consumer Services",
   "industry": "Restaurants",
   "summary_quote": "https://www.nasdaq.com/symbol/zoes",
   "FIELD9": ""
 },
 {
   "symbol": "ZTS",
   "name": "Zoetis Inc.",
   "last_sale": "89.83",
   "market_cap": "$43.28B",
   "IPOyear": "2013",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/zts",
   "FIELD9": ""
 },
 {
   "symbol": "ZTO",
   "name": "ZTO Express (Cayman) Inc.",
   "last_sale": "17.97",
   "market_cap": "$14.15B",
   "IPOyear": "2016",
   "sector": "Transportation",
   "industry": "Trucking Freight/Courier Services",
   "summary_quote": "https://www.nasdaq.com/symbol/zto",
   "FIELD9": ""
 },
 {
   "symbol": "ZUO",
   "name": "Zuora, Inc.",
   "last_sale": "23.36",
   "market_cap": "$2.52B",
   "IPOyear": "2018",
   "sector": "Technology",
   "industry": "Computer Software: Prepackaged Software",
   "summary_quote": "https://www.nasdaq.com/symbol/zuo",
   "FIELD9": ""
 },
 {
   "symbol": "ZYME",
   "name": "Zymeworks Inc.",
   "last_sale": "16.55",
   "market_cap": "$528.93M",
   "IPOyear": "2017",
   "sector": "Health Care",
   "industry": "Major Pharmaceuticals",
   "summary_quote": "https://www.nasdaq.com/symbol/zyme",
   "FIELD9": ""
 }
];

export default StockData;